import PropTypes from "prop-types"

export const ListIcon = [
  "small-phone",
  "home-work",
  "online",
  "call",
  "facebook",
  "edit-course",
  "youtube",
  "phone",
  "fax",
  "email",
  "address",
  "credit-card",
  "pen-black",
  "pen-primary",
  "upload-green",
  "apart-apart",
  "plus-plus",
  "eraser",
  "square-square",
  "red-warning",
  "black-dot",
  "warning-usb2",
  "upload-success",
  "rectangle-black",
  "dot-border",
  "edit-primary",
  "white-upload",
  "arrow-down-primary-black",
  "expire-date-sign",
  "zoom-in",
  "zoom-out",
  "arrow-down-primary",
  "arrow-up-primary",
  "arrow-up-primary-black",
  "deleteRow",
  "pin",
  "hierarchy",
  "chart",
  "settings",
  "database",
  "notes",
  "add",
  "search",
  "arrowDown",
  "arrowDownTree",
  "arrow-menu",
  "trashCan",
  "threeDots",
  "dot",
  "d-check",
  "icon-confirm",
  "bin",
  "edit",
  "send-message",
  "message",
  "handout",
  "g-chart",
  "curved-previous",
  "cheque",
  "handout-2",
  "check-list",
  "box-confirm",
  "stationery",
  "menu",
  "filter-white",
  "remove",
  "back",
  "sort",
  "restore",
  "refresh",
  "add-blue",
  "close-icon",
  "filter-remove",
  "users",
  "access-key",
  "meeting",
  "cancel",
  "undo",
  "check",
  "role-group",
  "authorization",
  "notice-success",
  "refresh-blue",
  "refresh-white",
  "notice-error",
  "icon-arrow-down",
  "faq",
  "warning",
  "menu-log-work",
  "menu-product",
  "menu-config",
  "menu-role-group",
  "menu-authori",
  "filter-black",
  "confirm",
  "history",
  "arrow-right",
  "arrow-down",
  "calendar",
  "warning_red",
  "warning_green",
  "warning_yellow",
  "confirm-lw",
  "file-text",
  "folder",
  "vbm",
  "people",
  "icon-system",
  "download",
  "download-grey",
  "eye",
  "warning-cancel",
  "sign_success",
  "download_orange",
  "eye_orange",
  "sign_in",
  "printer-white",
  "user_login",
  "lock_login",
  "defaultAvatar",
  "warningInactive",
  "updateUnit",
  "trashRed",
  "filter-main",
  "statistic",
  "searchStatistic",
  "exportStatistic",
  "editTypeConfig",
  "configTypeProfile",
  "noticePartner",
  "uploadProfile",
  "trashIcon",
  "iconPdf",
  "partner",
  "closeSigner",
  "checkEnabled",
  "checkDisabled",
  "hidePassLogin",
  "warning-usb",
  "signSuccess",
  "iconSigned",
  "iconRejectSigned",
  "copy",
  "sign",
  "warning_default",
  "process_group",
  "arrow_down_white",
  "arrow_down",
  "t_warning_default",
  "not-cks",
  "warningAmber",
  "warningCKS",
  "logoutIcon",
  "signMethod",
  "bigLogo",
  "closeTab",
  "uploadVBM",
  "writeVBM",
  "starOrange",
  "logoHome",
  "settingVBM",
  "uploadVBMIcon",
  "empty",
  "emptySign",
  "copyVBM",
  "add-primary",
  "addRowAbove",
  "addRowBelow",
  "management-skdn",
  "cloud-upload",
  "quanlysuckhoe",
  "cauhinhdichvu",
  "quanlychung",
  "warning-import",
  "csyt",
  "time-discount",
  "import",
  "plus-circle",
  "check-circle",
  "check-square",
  "checks",
  "recall",
  "cancel",
  // "export",
  "export-kq",
  "examination",
  "building",
  "send",
  "user-circle",
  "money-circle",
  "chat-mess",
  "transfer",
  "disease-history",
  "printer",
  "logo-icon",
  "icon-statistic",
  "white-down",
  "gear",
  "diem-danh",
  "check-special",
  "search-white",
  "arrow-up",
  "edit-green",
  "edit-orange",
  "file-icon",
  "voting",
  "camera",
  "video",
  "contact",
  "rating",
  "home",
  "signup",
  "signin",
  "link",
  "download-app",
  "arrow-up-orange",
  "phone-animation",
  "yellow-checked",
  "arrow-right-orange",
  "access-time",
  "author",
  "shopping",
  "back-arrow",
  "next-arrow",
  "file-sign",
  "media-solid",
  "handshake",
  "arrow-orange",
  "small-image",
  "close-tag",
  "speed-icon",
  "key-previous",
  "key-next",
  "share",
  "favorite",
  "truck",
  "shopping-cart",
  "save-orange",
  "clear-orange",
  "eye-red",
  "printer-red",
  "download-red",
  "user-setting",
  "qr-code",
  "download-white",
  "small-image-red",
  "swap-vert",
  "funnel",
  "information",
  "green-pencil",
  "dang-ky-mua-nuoc",
  "tra-cuu-su-dung-nuoc",
  "dang-ki-thay-doi",
  "tra-cuu-su-dung-nuoc",
  "hoa-don-dien-tu",
  "thanh-toan-truc-tuyen",
  "sua-chua",
  "lap-dat",
  "sang-ten",
  "cap-lai",
  "dang-ki-thay-doi",
  "check-box-buy-water",
  "shopping-icon",
  "dolar",
  "dashboard",
  "search-black",
  "re-post",
  "cancel-post",
  "add-box",
  "edit-black",
  "delete-black",
  "sort-up-down",
  "filter-white1",
  "media",
  "add-media-video",
  "cancel-video",
  "call-received",
  "order-step1",
  "order-step2",
  "order-step3",
  "order-step4",
  "order-step5",
  "face-sad",
  "face-frown",
  "face-meh",
  "face-smile",
  "face-grin-hearts",
  "refresh-icon",
  "send-mess-primary",
  "file-excel-icon",
  "seminar-time",
  "manual-step1",
  "manual-step2",
  "manual-step3",
  "manual-step4",
  "next-arrow-slide",
  "prev-arrow-slide",
  "menu-book",
  "supervisor-account",
  "sms-message",
  "check-green",
  "shopping-cart-white",
  "infor",
  "up",
  "video-youtube",
  "library-books",
  "user-green",
  "star-green",
  "search-blue",
  "playlist-add-check",
  "back-ios",
  "next-ios",
  "ship",
  "register",
  "hiring",
  "location",
  "code-request",
  "recallIcon",
  "edit-box",
  "delete-box",
  "green-accept",
  "cloud-icon",
  "yellow-print",
  "reset-pass",
  "face-book",
  "delete-outline",
  "person-register",
  "enterprise-register",
  "test-site-register",
  "delete-small",
  "date-range",
  "person",
  "status_order_1",
  "status_order_2",
  "status_order_3",
  "status_order_4",
  "status_order_5",
  "status_order_6",
  "ellipe",
  "ellipe-blue",
  "reply",
  "edit-seminar",
  "person-seminar",
  "dot-black",
  "info",
  "login-facebook",
  "login-google",
  "elect",
  "fall",
  "pen-red",
  "shopping-bag",
  "arrow-back-red",
  "react-like-fb",
  "arrow-bend-down",
  "liked",
  "more-horiz",
  "mic-orange",
  "mode-comment",
  "reply-right",
  "activity",
  "check-blu",
  "teacher-orange",
  "book-orange",
  "student-orange",
  "register-orange",
  "date-orange",
  "gitbranch-slide",
  "gear-slide",
  "users-slide",
  "laptop-slide",
  "chartbar-slide",
  "bell",
  "view",
  "linked-in",
  "usd",
  "config",
  "group-white",
  "group",
  "play-icon",
  "notice-partner-white",
  "check-box-learn",
  "process-group-green",
  "job-building",
  "save-gray",
  "job-company",
  "map-company",
  "experience-company",
  "dowload-company",
  "save-company",
  "clock-company",
  // "briefcase",
  // "user-plus",
  // "user-check",
  // "chevron-left",
  // "chevron-right",
  "briefcaseWhite",
  "searchWhite",
  "chat-2mess",
  "link-d",
  "calendar-d",
  "chat-conver-d",
  "container-d",
  "specialize",
  "share-android",
  "user-info",
  "chart-line",
  "student",
  "paper",
  "coder",
  "trophy",
  "user-ability",
  "briefcase-header",
  "note-header",
  "whatsapp-header",
  "red-mark",
  "blue-mark",
  "Star",
  "floppy-disk",
  "share_cv",
  "edit_cv",
  "eye_cv",
  "download_cv",
  "eye-slash-cv",
  "user-outline",
  "starvn",
  "service-company",
  "history-company",
  "user-company",
  "calender-company",
  "user-company-new",
  "search-company-new",
  "left-arrow-backup",
  "right-arrow-backup",
  "eye-black",
  "pne-black-arrow",
  "delete-black-row",
  "copy-black",
  "notepad",
  "arrow-back-sign",
  "delete-red-row",
  "word-update",
  "user-info",
  "fileClole",
  "fileRecovery",
  "pending",
  "idic",
  "new",
  "more",
  "word-update-green",
  "rounded",
  "headphone",
  "post-blog",
  "bell-blue",
  "refresh-black",
  "creat-new",
  "dowload-export",
  "filter-table",
  "File-black",
  "data-box",
  "add-blue-square",
  "add-blue-circle",
  "edit-blue",
  "delete-blue",
  "lock",
  "unlock",
  "pen-green",
  "company-blue",
  "history-orege",
  "delete-profile",
  "upload",
  "like-blue",
  "view-blue",
  "close-blue-outline",
  "close-blue-circle",
  "check-blue-circle",
  "Warning-hight",
  "cancel-hight",
  "red-x",
  "thumb-up",
  "solid-folder",
  "solid-warning",
  "warning-denied",
  "export",
  "import-cloud",
  "pdf",
  "jpg",
  "png",
  "filter-close",
  "reload-yellow",
  "arrow-left-circle",
  "arrow-right-circle",
  "file-upload",
  "icon-excel",
  "icon-word",
  "icon-pdf",
  "user-header",
  "block-tree",
  "cloud",
  "backup",
  "camera",
  "logo-vncert",
  "dientapthucchien",
  "sodiaphuongtochuc",
  "coquantochuc",
  "soluotthamgia",
  "hethong",
  "solohongduocphathien",
  "doitancong",
  "doiphongthu",
  "tong",
  "lohongnghiemtrongvacao",
  "lohongtrungbinh",
  "lohongmucthap",
  "diachi",
  "hotline",
  "email",
  "website",
  "mat",
  //Diễn tập thực chiến Quản lý diễn tập
  "meeting",
  "chat",
  "duyetdangky",
  "tiepnhanbaocao",
  "baocaocucATTT",
  "baocaotancong",
  "baocaodoiphongthu",
  "iconButtonMuitenphai",
  "iconButtonMeeting",
  "khaimac",
  "xem",
  "sua",
  "xoa",
  "doimatkhau",
  "lichsu",
  "danhgia",
  "arrowLeft",
  "arrowRight",
  "dt-people",
  "dt-date",
  "dt-add",
  "img-tailieu",
  "arrowsearchcc",
  "organization",
  "judges",
  "defense",
  "sword-two",
  "people-team",
  "quytrinh-tt",
  "quytrinh-pa",
  "quytrinh-pp",
  "quytrinh-ddk",
  "quytrinh-ddtg",
  "quytrinh-nq",
  "quytrinh-km",
  "quytrinh-tl",
  "quytrinh-1lhd",
  "quytrinh-thdt",
  "quytrinh-dg",
  "quytrinh-bm",
  "quytrinh-tk",
]
// case "khongxoa":
//   iconElement = <svg></svg>
//   break
export default function SvgIcon(props) {
  const { name, className, onClick, fill, style } = props
  let iconElement
  switch (name) {
    case "quytrinh-tk":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.4"
            d="M3.66992 2.5V14.47C3.66992 15.45 4.12992 16.38 4.91992 16.97L10.1299 20.87C11.2399 21.7 12.7699 21.7 13.8799 20.87L19.0899 16.97C19.8799 16.38 20.3399 15.45 20.3399 14.47V2.5H3.66992Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M22 3.25H2C1.59 3.25 1.25 2.91 1.25 2.5C1.25 2.09 1.59 1.75 2 1.75H22C22.41 1.75 22.75 2.09 22.75 2.5C22.75 2.91 22.41 3.25 22 3.25Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M16 8.75H8C7.59 8.75 7.25 8.41 7.25 8C7.25 7.59 7.59 7.25 8 7.25H16C16.41 7.25 16.75 7.59 16.75 8C16.75 8.41 16.41 8.75 16 8.75Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M16 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25H16C16.41 12.25 16.75 12.59 16.75 13C16.75 13.41 16.41 13.75 16 13.75Z"
            fill={fill || "#292D32"}
          />
        </svg>
      )

      break
    case "quytrinh-bm":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.4"
            d="M8.67 14H4C2.9 14 2 14.9 2 16V22H8.67V14Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M13.3302 10H10.6602C9.56016 10 8.66016 10.9 8.66016 12V22H15.3302V12C15.3302 10.9 14.4402 10 13.3302 10Z"
            fill={fill || "#292D32"}
          />
          <path
            opacity="0.4"
            d="M20.0001 17H15.3301V22H22.0001V19C22.0001 17.9 21.1001 17 20.0001 17Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M15.0097 4.85048C15.3197 4.54048 15.4397 4.17048 15.3397 3.85048C15.2397 3.53048 14.9297 3.30049 14.4897 3.23049L13.5297 3.07048C13.4897 3.06048 13.3997 3.00047 13.3797 2.96047L12.8497 1.90047C12.4497 1.09047 11.5397 1.09047 11.1397 1.90047L10.6097 2.96047C10.5897 3.00047 10.4997 3.06048 10.4597 3.07048L9.49968 3.23049C9.05968 3.30049 8.75969 3.53048 8.64969 3.85048C8.54969 4.17048 8.66968 4.54048 8.97968 4.85048L9.71969 5.60048C9.74969 5.63048 9.78968 5.75048 9.77968 5.79048L9.56968 6.71047C9.40968 7.39047 9.66968 7.70046 9.83968 7.83046C10.0097 7.95046 10.3797 8.11048 10.9897 7.75047L11.8897 7.22048C11.9297 7.19048 12.0597 7.19048 12.0997 7.22048L12.9997 7.75047C13.2797 7.92048 13.5097 7.97048 13.6897 7.97048C13.8997 7.97048 14.0497 7.89046 14.1397 7.83046C14.3097 7.71046 14.5697 7.40047 14.4097 6.71047L14.1997 5.79048C14.1897 5.74048 14.2197 5.63048 14.2597 5.60048L15.0097 4.85048Z"
            fill={fill || "#292D32"}
          />
        </svg>
      )

      break
    case "quytrinh-dg":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.4"
            d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 4.17 19.83 2 16.19 2Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M18.3105 8.86914C18.3105 9.27914 17.9805 9.61914 17.5605 9.61914H12.3105C11.9005 9.61914 11.5605 9.27914 11.5605 8.86914C11.5605 8.45914 11.9005 8.11914 12.3105 8.11914H17.5605C17.9805 8.11914 18.3105 8.45914 18.3105 8.86914Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M9.97055 7.90055L7.72055 10.1505C7.57055 10.3005 7.38055 10.3705 7.19055 10.3705C7.00055 10.3705 6.80055 10.3005 6.66055 10.1505L5.91055 9.40055C5.61055 9.11055 5.61055 8.63055 5.91055 8.34055C6.20055 8.05055 6.67055 8.05055 6.97055 8.34055L7.19055 8.56055L8.91055 6.84055C9.20055 6.55055 9.67055 6.55055 9.97055 6.84055C10.2605 7.13055 10.2605 7.61055 9.97055 7.90055Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M18.3105 15.8691C18.3105 16.2791 17.9805 16.6191 17.5605 16.6191H12.3105C11.9005 16.6191 11.5605 16.2791 11.5605 15.8691C11.5605 15.4591 11.9005 15.1191 12.3105 15.1191H17.5605C17.9805 15.1191 18.3105 15.4591 18.3105 15.8691Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M9.97055 14.9005L7.72055 17.1505C7.57055 17.3005 7.38055 17.3705 7.19055 17.3705C7.00055 17.3705 6.80055 17.3005 6.66055 17.1505L5.91055 16.4005C5.61055 16.1105 5.61055 15.6305 5.91055 15.3405C6.20055 15.0505 6.67055 15.0505 6.97055 15.3405L7.19055 15.5605L8.91055 13.8405C9.20055 13.5505 9.67055 13.5505 9.97055 13.8405C10.2605 14.1305 10.2605 14.6105 9.97055 14.9005Z"
            fill={fill || "#292D32"}
          />
        </svg>
      )

      break
    case "quytrinh-thdt":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.44922 22C6.03922 22 5.69922 21.66 5.69922 21.25V2.75C5.69922 2.34 6.03922 2 6.44922 2C6.85922 2 7.19922 2.34 7.19922 2.75V21.25C7.19922 21.66 6.85922 22 6.44922 22Z"
            fill={fill || "#292D32"}
          />
          <path
            opacity="0.4"
            d="M15.2001 7.16053L7.10008 3.66053C6.98008 3.60053 6.85008 3.62053 6.74008 3.69053C6.64008 3.76053 6.58008 3.87053 6.58008 4.00053V17.0005C6.58008 17.1305 6.65008 17.2505 6.76008 17.3205C6.82008 17.3605 6.89008 17.3805 6.96008 17.3805C7.02008 17.3805 7.07008 17.3705 7.13008 17.3405L15.4301 13.2405C15.4301 13.2405 15.4301 13.2405 15.4401 13.2405C17.1001 12.3805 17.9901 11.2705 17.9401 10.1005C17.8801 8.92053 16.9101 7.88053 15.2001 7.16053Z"
            fill={fill || "#292D32"}
          />
        </svg>
      )

      break
    case "quytrinh-1lhd":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.4"
            d="M20 9.83984C20.55 9.83984 21 10.2898 21 10.8398V16.9998C21 19.9998 19.5 21.9998 16 21.9998H8C4.5 21.9998 3 19.9998 3 16.9998V10.8398C3 10.2898 3.45 9.83984 4 9.83984H20Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M16.7502 3.56V2C16.7502 1.59 16.4102 1.25 16.0002 1.25C15.5902 1.25 15.2502 1.59 15.2502 2V3.5H8.75024V2C8.75024 1.59 8.41024 1.25 8.00024 1.25C7.59024 1.25 7.25024 1.59 7.25024 2V3.56C4.55024 3.81 3.24023 5.42 3.04023 7.81C3.02023 8.1 3.26023 8.34 3.54023 8.34H20.4602C20.7502 8.34 20.9902 8.09 20.9602 7.81C20.7602 5.42 19.4502 3.81 16.7502 3.56Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M15.6609 18.47L14.9209 17.73C15.3009 17.15 15.5309 16.45 15.5309 15.7C15.5309 13.66 13.8709 12 11.8309 12C9.79086 12 8.13086 13.66 8.13086 15.7C8.13086 17.74 9.79086 19.4 11.8309 19.4C12.5809 19.4 13.2809 19.17 13.8609 18.79L14.6009 19.53C14.7509 19.68 14.9409 19.75 15.1309 19.75C15.3209 19.75 15.5109 19.68 15.6609 19.53C15.9509 19.24 15.9509 18.76 15.6609 18.47Z"
            fill={fill || "#292D32"}
          />
        </svg>
      )

      break
    case "quytrinh-tl":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.4"
            d="M15.5 13.15H13.33C11.55 13.15 10.1 11.71 10.1 9.92V7.75C10.1 7.34 9.77 7 9.35 7H6.18C3.87 7 2 8.5 2 11.18V17.82C2 20.5 3.87 22 6.18 22H12.07C14.38 22 16.25 20.5 16.25 17.82V13.9C16.25 13.48 15.91 13.15 15.5 13.15Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M17.8198 2H15.8498H14.7598H11.9298C9.66977 2 7.83977 3.44 7.75977 6.01C7.81977 6.01 7.86977 6 7.92977 6H10.7598H11.8498H13.8198C16.1298 6 17.9998 7.5 17.9998 10.18V12.15V14.86V16.83C17.9998 16.89 17.9898 16.94 17.9898 16.99C20.2198 16.92 21.9998 15.44 21.9998 12.83V10.86V8.15V6.18C21.9998 3.5 20.1298 2 17.8198 2Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M11.9806 7.14975C11.6706 6.83975 11.1406 7.04975 11.1406 7.47975V10.0998C11.1406 11.1998 12.0706 12.0998 13.2106 12.0998C13.9206 12.1098 14.9106 12.1098 15.7606 12.1098C16.1906 12.1098 16.4106 11.6098 16.1106 11.3098C15.0206 10.2198 13.0806 8.26975 11.9806 7.14975Z"
            fill={fill || "#292D32"}
          />
        </svg>
      )

      break
    case "quytrinh-km":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.4"
            d="M18.3301 5.67L6.59009 17.41C6.15009 17.85 5.41008 17.79 5.05008 17.27C3.81008 15.46 3.08008 13.32 3.08008 11.12V6.73C3.08008 5.91 3.70008 4.98 4.46008 4.67L10.0301 2.39C11.2901 1.87 12.6901 1.87 13.9501 2.39L17.9901 4.03999C18.6601 4.30999 18.8301 5.17 18.3301 5.67Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M19.27 7.03963C19.92 6.48963 20.91 6.95962 20.91 7.80962V11.1196C20.91 16.0096 17.36 20.5896 12.51 21.9296C12.18 22.0196 11.82 22.0196 11.48 21.9296C10.06 21.5296 8.74 20.8596 7.61 19.9796C7.13 19.6096 7.08001 18.9096 7.50001 18.4796C9.68001 16.2496 16.06 9.74963 19.27 7.03963Z"
            fill={fill || "#292D32"}
          />
        </svg>
      )

      break
    case "quytrinh-nq":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.4"
            d="M16.2391 3.65039H7.75906C5.28906 3.65039 3.28906 5.66039 3.28906 8.12039V17.5304C3.28906 19.9904 5.29906 22.0004 7.75906 22.0004H16.2291C18.6991 22.0004 20.6991 19.9904 20.6991 17.5304V8.12039C20.7091 5.65039 18.6991 3.65039 16.2391 3.65039Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M14.3498 2H9.64977C8.60977 2 7.75977 2.84 7.75977 3.88V4.82C7.75977 5.86 8.59977 6.7 9.63977 6.7H14.3498C15.3898 6.7 16.2298 5.86 16.2298 4.82V3.88C16.2398 2.84 15.3898 2 14.3498 2Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M15 12.9492H8C7.59 12.9492 7.25 12.6092 7.25 12.1992C7.25 11.7892 7.59 11.4492 8 11.4492H15C15.41 11.4492 15.75 11.7892 15.75 12.1992C15.75 12.6092 15.41 12.9492 15 12.9492Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M12.38 16.9492H8C7.59 16.9492 7.25 16.6092 7.25 16.1992C7.25 15.7892 7.59 15.4492 8 15.4492H12.38C12.79 15.4492 13.13 15.7892 13.13 16.1992C13.13 16.6092 12.79 16.9492 12.38 16.9492Z"
            fill={fill || "#292D32"}
          />
        </svg>
      )

      break
    case "quytrinh-ddtg":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 13C17.06 13 16.19 13.33 15.5 13.88C14.58 14.61 14 15.74 14 17C14 17.75 14.21 18.46 14.58 19.06C15.27 20.22 16.54 21 18 21C19.01 21 19.93 20.63 20.63 20C20.94 19.74 21.21 19.42 21.42 19.06C21.79 18.46 22 17.75 22 17C22 14.79 20.21 13 18 13ZM20.07 16.57L17.94 18.54C17.8 18.67 17.61 18.74 17.43 18.74C17.24 18.74 17.05 18.67 16.9 18.52L15.91 17.53C15.62 17.24 15.62 16.76 15.91 16.47C16.2 16.18 16.68 16.18 16.97 16.47L17.45 16.95L19.05 15.47C19.35 15.19 19.83 15.21 20.11 15.51C20.39 15.81 20.37 16.28 20.07 16.57Z"
            fill={fill || "#292D32"}
          />
          <path
            opacity="0.4"
            d="M21.0901 21.5C21.0901 21.78 20.8701 22 20.5901 22H3.41016C3.13016 22 2.91016 21.78 2.91016 21.5C2.91016 17.36 6.99015 14 12.0002 14C13.0302 14 14.0302 14.14 14.9502 14.41C14.3602 15.11 14.0002 16.02 14.0002 17C14.0002 17.75 14.2101 18.46 14.5801 19.06C14.7801 19.4 15.0401 19.71 15.3401 19.97C16.0401 20.61 16.9702 21 18.0002 21C19.1202 21 20.1302 20.54 20.8502 19.8C21.0102 20.34 21.0901 20.91 21.0901 21.5Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
            fill={fill || "#292D32"}
          />
        </svg>
      )

      break
    case "quytrinh-ddk":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.4"
            d="M21.0901 21.5C21.0901 21.78 20.8701 22 20.5901 22H3.41016C3.13016 22 2.91016 21.78 2.91016 21.5C2.91016 17.36 6.99015 14 12.0002 14C13.0302 14 14.0302 14.14 14.9502 14.41C14.3602 15.11 14.0002 16.02 14.0002 17C14.0002 17.75 14.2101 18.46 14.5801 19.06C14.7801 19.4 15.0401 19.71 15.3401 19.97C16.0401 20.61 16.9702 21 18.0002 21C19.1202 21 20.1302 20.54 20.8502 19.8C21.0102 20.34 21.0901 20.91 21.0901 21.5Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M20.97 14.33C20.25 13.51 19.18 13 18 13C16.88 13 15.86 13.46 15.13 14.21C14.43 14.93 14 15.92 14 17C14 17.75 14.21 18.46 14.58 19.06C14.78 19.4 15.04 19.71 15.34 19.97C16.04 20.61 16.97 21 18 21C19.46 21 20.73 20.22 21.42 19.06C21.63 18.72 21.79 18.33 21.88 17.93C21.96 17.63 22 17.32 22 17C22 15.98 21.61 15.04 20.97 14.33ZM19.5 17.73H18.75V18.51C18.75 18.92 18.41 19.26 18 19.26C17.59 19.26 17.25 18.92 17.25 18.51V17.73H16.5C16.09 17.73 15.75 17.39 15.75 16.98C15.75 16.57 16.09 16.23 16.5 16.23H17.25V15.52C17.25 15.11 17.59 14.77 18 14.77C18.41 14.77 18.75 15.11 18.75 15.52V16.23H19.5C19.91 16.23 20.25 16.57 20.25 16.98C20.25 17.39 19.91 17.73 19.5 17.73Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
            fill={fill || "#292D32"}
          />
        </svg>
      )

      break
    case "quytrinh-pp":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.4"
            d="M17.5291 7.77C17.4591 7.76 17.3891 7.76 17.3191 7.77C15.7691 7.72 14.5391 6.45 14.5391 4.89C14.5391 3.3 15.8291 2 17.4291 2C19.0191 2 20.3191 3.29 20.3191 4.89C20.3091 6.45 19.0791 7.72 17.5291 7.77Z"
            fill={fill || "#292D32"}
          />
          <path
            opacity="0.4"
            d="M20.7896 14.7004C19.6696 15.4504 18.0996 15.7304 16.6496 15.5404C17.0296 14.7204 17.2296 13.8104 17.2396 12.8504C17.2396 11.8504 17.0196 10.9004 16.5996 10.0704C18.0796 9.8704 19.6496 10.1504 20.7796 10.9004C22.3596 11.9404 22.3596 13.6504 20.7896 14.7004Z"
            fill={fill || "#292D32"}
          />
          <path
            opacity="0.4"
            d="M6.44039 7.77C6.51039 7.76 6.58039 7.76 6.65039 7.77C8.20039 7.72 9.43039 6.45 9.43039 4.89C9.43039 3.3 8.14039 2 6.54039 2C4.95039 2 3.65039 3.29 3.65039 4.89C3.66039 6.45 4.89039 7.72 6.44039 7.77Z"
            fill={fill || "#292D32"}
          />
          <path
            opacity="0.4"
            d="M6.54914 12.8506C6.54914 13.8206 6.75914 14.7406 7.13914 15.5706C5.72914 15.7206 4.25914 15.4206 3.17914 14.7106C1.59914 13.6606 1.59914 11.9506 3.17914 10.9006C4.24914 10.1806 5.75914 9.89059 7.17914 10.0506C6.76914 10.8906 6.54914 11.8406 6.54914 12.8506Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M12.1208 15.87C12.0408 15.86 11.9508 15.86 11.8608 15.87C10.0208 15.81 8.55078 14.3 8.55078 12.44C8.55078 10.54 10.0808 9 11.9908 9C13.8908 9 15.4308 10.54 15.4308 12.44C15.4308 14.3 13.9708 15.81 12.1208 15.87Z"
            fill={fill || "#292D32"}
          />
          <path
            d="M8.87078 17.9406C7.36078 18.9506 7.36078 20.6106 8.87078 21.6106C10.5908 22.7606 13.4108 22.7606 15.1308 21.6106C16.6408 20.6006 16.6408 18.9406 15.1308 17.9406C13.4208 16.7906 10.6008 16.7906 8.87078 17.9406Z"
            fill={fill || "#292D32"}
          />
        </svg>
      )

      break
    case "quytrinh-pa":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.2107 6.35952C18.1707 4.25952 16.1607 2.70952 13.8307 2.19952C11.3907 1.65952 8.8907 2.23952 6.9807 3.77952C5.0607 5.30952 3.9707 7.59952 3.9707 10.0495C3.9707 12.6395 5.5207 15.3495 7.8607 16.9195V17.7495C7.8507 18.0295 7.8407 18.4595 8.1807 18.8095C8.5307 19.1695 9.0507 19.2095 9.4607 19.2095H14.5907C15.1307 19.2095 15.5407 19.0595 15.8207 18.7795C16.2007 18.3895 16.1907 17.8895 16.1807 17.6195V16.9195C19.2807 14.8295 21.2307 10.4195 19.2107 6.35952Z"
            fill={fill || "#444444"}
          />
          <path
            opacity="0.4"
            d="M15.2592 22.0004C15.1992 22.0004 15.1292 21.9904 15.0692 21.9704C13.0592 21.4004 10.9492 21.4004 8.93918 21.9704C8.56918 22.0704 8.17918 21.8604 8.07918 21.4904C7.96918 21.1204 8.18918 20.7304 8.55918 20.6304C10.8192 19.9904 13.1992 19.9904 15.4592 20.6304C15.8292 20.7404 16.0492 21.1204 15.9392 21.4904C15.8392 21.8004 15.5592 22.0004 15.2592 22.0004Z"
            fill={fill || "#444444"}
          />
        </svg>
      )

      break
    case "quytrinh-tt":
      iconElement = (
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.4"
            d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
            fill={fill || "#444444"}
          />
          <path
            d="M22 19.77V15.73C22 14.14 21.36 13.5 19.77 13.5H15.73C14.14 13.5 13.5 14.14 13.5 15.73V19.77C13.5 21.36 14.14 22 15.73 22H19.77C21.36 22 22 21.36 22 19.77Z"
            fill={fill || "#444444"}
          />
          <path
            d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
            fill={fill || "#444444"}
          />
          <path
            opacity="0.4"
            d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
            fill={fill || "#444444"}
          />
        </svg>
      )

      break
    case "people-team":
      iconElement = (
        <svg
          width="31"
          height="23"
          viewBox="0 0 41 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24.6941 3.11801C25.2361 3.97113 25.5502 4.98348 25.5502 6.0691C25.5502 9.11223 23.0833 11.5791 20.0402 11.5791C16.9971 11.5791 14.5303 9.11223 14.5303 6.0691C14.5303 3.02598 16.9971 0.559102 20.0402 0.559102C21.0724 0.559102 22.0382 0.84293 22.8639 1.33668"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19.2142 6.5998C17.5947 6.94488 16.3433 8.28301 16.126 9.94629"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M23.9543 9.94629C23.737 8.28301 22.4856 6.94488 20.8662 6.5998"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21.863 4.97473C21.863 5.9816 21.0468 6.79785 20.0399 6.79785C19.033 6.79785 18.2168 5.9816 18.2168 4.97473C18.2168 3.96777 19.033 3.1516 20.0399 3.1516C21.0468 3.1516 21.863 3.96777 21.863 4.97473Z"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.0609 22.3031C17.9201 21.7495 18.9431 21.4283 20.0412 21.4283C23.0843 21.4283 25.5512 23.8952 25.5512 26.9382C25.5512 29.9814 23.0843 32.4482 20.0412 32.4482C16.9981 32.4482 14.5312 29.9814 14.5312 26.9382C14.5312 25.9186 14.8082 24.9638 15.2909 24.1446"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19.2138 27.468C17.5945 27.8132 16.3433 29.1513 16.126 30.8145"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M23.955 30.8135C23.7377 29.1503 22.4864 27.8122 20.8672 27.467"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21.863 25.8428C21.863 26.8498 21.0468 27.666 20.0399 27.666C19.033 27.666 18.2168 26.8498 18.2168 25.8428C18.2168 24.8359 19.033 24.0197 20.0399 24.0197C21.0468 24.0197 21.863 24.8359 21.863 25.8428Z"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M39.56 26.9382C39.56 29.9814 37.0932 32.4482 34.0501 32.4482C31.007 32.4482 28.54 29.9814 28.54 26.9382C28.54 23.8952 31.007 21.4283 34.0501 21.4283C37.0932 21.4283 39.56 23.8952 39.56 26.9382Z"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M33.2233 27.4669C31.6037 27.8118 30.3521 29.15 30.1348 30.8135"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M37.9634 30.8145C37.7461 29.151 36.4945 27.8128 34.875 27.4679"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M35.8719 25.8428C35.8719 26.8498 35.0557 27.666 34.0488 27.666C33.0418 27.666 32.2256 26.8498 32.2256 25.8428C32.2256 24.8359 33.0418 24.0197 34.0488 24.0197C35.0557 24.0197 35.8719 24.8359 35.8719 25.8428Z"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.7494 26.9382C11.7494 29.9814 9.28254 32.4482 6.23949 32.4482C3.19637 32.4482 0.729492 29.9814 0.729492 26.9382C0.729492 23.8952 3.19637 21.4283 6.23949 21.4283C9.28254 21.4283 11.7494 23.8952 11.7494 26.9382Z"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.4118 27.4671C3.79266 27.8124 2.54156 29.1504 2.32422 30.8135"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.1547 30.8135C9.93719 29.1495 8.68492 27.8109 7.06445 27.4665"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.06422 25.8428C8.06422 26.8498 7.24797 27.666 6.24109 27.666C5.23422 27.666 4.41797 26.8498 4.41797 25.8428C4.41797 24.8359 5.23422 24.0197 6.24109 24.0197C7.24797 24.0197 8.06422 24.8359 8.06422 25.8428Z"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M30.9434 16.4173H33.2693C33.7008 16.4173 34.0505 16.7672 34.0505 17.1986V18.9902"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.24121 18.9902V17.1986C6.24121 16.7672 6.59098 16.4173 7.02246 16.4173H28.3886"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M20.1436 13.9959V18.9902"
            stroke="white"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )

      break
    case "sword-two":
      iconElement = (
        <svg
          fill="#fd3060"
          height="31px"
          width="31px"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 362.086 362.086"
          stroke="#fd3060"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <g>
              {" "}
              <path d="M163.343,186.845l-12.529,12.529c-2.148,2.148-2.148,5.63,0,7.778c1.074,1.074,2.481,1.611,3.889,1.611 s2.815-0.537,3.889-1.611l12.529-12.529c2.148-2.148,2.148-5.63,0-7.778C168.973,184.697,165.492,184.697,163.343,186.845z"></path>{" "}
              <path d="M265.86,84.329l-85.43,85.43c-2.148,2.148-2.148,5.63,0,7.778c1.074,1.074,2.481,1.611,3.889,1.611 s2.815-0.537,3.889-1.611l85.43-85.43c2.148-2.148,2.148-5.63,0-7.778C271.49,82.181,268.008,82.181,265.86,84.329z"></path>{" "}
              <path d="M309.145,41.044l-25.06,25.06c-2.148,2.148-2.148,5.63,0,7.778c1.074,1.074,2.481,1.611,3.889,1.611 s2.815-0.537,3.889-1.611l25.06-25.06c2.148-2.148,2.148-5.63,0-7.778C314.774,38.896,311.293,38.896,309.145,41.044z"></path>{" "}
              <path d="M143.835,131.938L83.088,71.191c-2.148-2.147-5.63-2.148-7.778,0s-2.148,5.63,0,7.778l60.747,60.747 c1.074,1.074,2.481,1.611,3.889,1.611s2.815-0.537,3.889-1.611C145.983,137.568,145.983,134.086,143.835,131.938z"></path>{" "}
              <path d="M52.942,41.044c-2.148-2.148-5.63-2.147-7.778,0c-2.148,2.148-2.148,5.63,0,7.778l14.397,14.397 c1.074,1.074,2.481,1.611,3.889,1.611s2.815-0.537,3.889-1.611c2.148-2.148,2.148-5.63,0-7.778L52.942,41.044z"></path>{" "}
              <path d="M355.752,321.072c-2.315-2.315-5.191-4.082-8.332-5.151c-1.047-3.14-2.805-5.986-5.186-8.366 c-2.379-2.379-5.215-4.139-8.339-5.193c-1.053-3.123-2.81-5.957-5.186-8.333c-2.375-2.375-5.209-4.132-8.332-5.186 c-1.053-3.123-2.81-5.956-5.186-8.332c-2.385-2.385-5.233-4.144-8.375-5.193c-1.069-3.141-2.836-6.018-5.151-8.333 c-0.259-0.259-0.529-0.507-0.801-0.752c11.314-8.075,23.978-14.413,37.636-18.615c1.394-0.429,2.561-1.394,3.244-2.683 c0.683-1.289,0.825-2.797,0.396-4.191l-8.159-26.52c-0.893-2.903-3.972-4.533-6.874-3.639 c-12.987,3.995-25.278,9.486-36.699,16.254l-44.9-47.733l102.334-95.899c1.024-0.96,1.643-2.276,1.729-3.677l4.262-69.572 c0.096-1.573-0.486-3.111-1.601-4.225c-1.115-1.115-2.66-1.697-4.226-1.601l-69.572,4.262c-1.401,0.086-2.717,0.704-3.677,1.729 l-93.891,100.192L93.898,16.696c-0.858-0.924-2.007-1.524-3.255-1.702l-76.13-10.82C12.8,3.931,11.073,4.507,9.85,5.73 s-1.799,2.95-1.556,4.663l10.82,76.13c0.177,1.248,0.778,2.397,1.702,3.255l95.842,89.056l-44.984,48.002 c-11.42-6.767-23.709-12.257-36.695-16.252c-2.901-0.893-5.981,0.736-6.874,3.639l-8.159,26.52 c-0.429,1.394-0.287,2.902,0.396,4.191c0.683,1.289,1.85,2.254,3.244,2.683c13.658,4.202,26.322,10.539,37.636,18.615 c-0.272,0.245-0.542,0.493-0.802,0.753c-2.315,2.315-4.082,5.192-5.151,8.333c-3.141,1.048-5.99,2.808-8.375,5.193 c-2.375,2.376-4.132,5.209-5.186,8.332c-3.123,1.053-5.957,2.81-8.332,5.186c-2.375,2.376-4.133,5.21-5.186,8.333 c-3.124,1.054-5.96,2.814-8.339,5.193c-2.381,2.381-4.139,5.227-5.186,8.367c-3.141,1.069-6.018,2.836-8.333,5.151 C2.309,325.097,0,330.667,0,336.362c0.01,5.689,2.318,11.255,6.334,15.271c4.016,4.015,9.582,6.324,15.29,6.334 c5.689-0.01,11.255-2.319,15.271-6.334c2.315-2.315,4.082-5.192,5.151-8.332c3.14-1.047,5.986-2.805,8.366-5.186 c2.379-2.379,4.139-5.216,5.193-8.34c3.123-1.053,5.957-2.81,8.333-5.186c2.375-2.376,4.132-5.209,5.186-8.332 c3.123-1.053,5.957-2.81,8.332-5.185c2.379-2.379,4.137-5.226,5.188-8.37c3.138-1.066,6.017-2.835,8.337-5.156 c0.259-0.259,0.507-0.529,0.752-0.802c8.075,11.314,14.413,23.978,18.615,37.636c0.728,2.365,2.904,3.884,5.255,3.884 c0.536,0,1.081-0.079,1.619-0.245l26.52-8.159c1.394-0.429,2.561-1.394,3.244-2.683c0.683-1.289,0.825-2.797,0.396-4.191 c-3.995-12.986-9.485-25.275-16.252-36.695l50.011-46.866l49.818,46.862c-6.768,11.421-12.259,23.711-16.254,36.698 c-0.429,1.394-0.287,2.902,0.396,4.191c0.683,1.289,1.85,2.254,3.244,2.683l26.52,8.159c0.539,0.166,1.083,0.245,1.619,0.245 c2.351,0,4.527-1.52,5.255-3.884c4.202-13.658,10.54-26.322,18.615-37.636c0.245,0.272,0.493,0.542,0.753,0.802 c2.321,2.321,5.199,4.089,8.337,5.156c1.051,3.144,2.809,5.991,5.188,8.37c2.375,2.375,5.209,4.132,8.332,5.185 c1.053,3.123,2.81,5.957,5.186,8.332c2.375,2.375,5.21,4.133,8.333,5.186c1.054,3.124,2.813,5.96,5.192,8.339 c2.381,2.381,5.227,4.139,8.367,5.186c1.069,3.141,2.836,6.017,5.151,8.332c4.016,4.015,9.582,6.324,15.29,6.334 c5.689-0.01,11.255-2.319,15.271-6.334c4.016-4.016,6.324-9.582,6.334-15.28C362.086,330.667,359.778,325.097,355.752,321.072z M29.729,83.047l-9.515-66.952l66.951,9.516l86.163,92.749l-49.15,52.448L29.729,83.047z M21.625,346.967 c-2.801-0.005-5.539-1.14-7.512-3.112c-1.973-1.973-3.107-4.711-3.112-7.502c0-2.79,1.134-5.524,3.112-7.502 c0.972-0.972,2.157-1.747,3.461-2.279l13.824,13.824c-0.533,1.303-1.307,2.488-2.28,3.46 C27.144,345.827,24.406,346.962,21.625,346.967z M39.189,332.63l-13.852-13.852c0.523-1.282,1.296-2.448,2.293-3.446 c1.002-1.002,2.169-1.779,3.447-2.307l13.864,13.864c-0.528,1.278-1.305,2.445-2.308,3.448 C41.636,331.334,40.47,332.107,39.189,332.63z M52.72,319.111l-13.865-13.865c0.526-1.276,1.301-2.441,2.3-3.439 c0.999-0.999,2.163-1.773,3.439-2.3l13.865,13.865c-0.526,1.276-1.301,2.441-2.3,3.439C55.161,317.81,53.996,318.585,52.72,319.111 z M66.238,305.594l-13.865-13.865c0.526-1.276,1.301-2.441,2.3-3.439c1.001-1.001,2.17-1.776,3.454-2.301l13.849,13.849 c-0.525,1.288-1.3,2.458-2.298,3.456C68.678,304.293,67.514,305.067,66.238,305.594z M83.203,289.768 c-0.975,0.975-2.159,1.75-3.458,2.282l-13.826-13.826c0.533-1.303,1.307-2.488,2.279-3.46c0.591-0.591,1.257-1.105,1.973-1.54 c5.232,4.467,10.103,9.338,14.57,14.57C84.305,288.512,83.792,289.179,83.203,289.768z M119.144,325.921 c-14.29-40.793-46.305-72.809-87.098-87.098l4.928-16.017c22.996,7.951,43.518,20.937,60.291,37.677 c0.036,0.038,0.061,0.083,0.098,0.12s0.082,0.062,0.12,0.098c16.74,16.773,29.726,37.295,37.678,60.291L119.144,325.921z M108.977,256.768l31.39-31.39c2.148-2.148,2.148-5.63,0-7.778c-2.148-2.148-5.63-2.148-7.778,0l-31.39,31.39 c-6.263-5.87-12.977-11.266-20.086-16.139L281.292,19.24l61.183-3.748l-3.748,61.184L125.117,276.853 C120.243,269.745,114.847,263.031,108.977,256.768z M189.183,231.89l48.3-45.262l43.483,46.227 c-7.106,4.872-13.817,10.266-20.078,16.134l-31.39-31.39c-2.148-2.148-5.63-2.148-7.778,0c-2.148,2.148-2.148,5.63,0,7.778 l31.39,31.39c-5.868,6.261-11.263,12.972-16.135,20.079L189.183,231.89z M242.943,325.921l-16.017-4.927 c7.951-22.996,20.938-43.518,37.678-60.291c0.038-0.036,0.083-0.061,0.12-0.098s0.062-0.082,0.098-0.12 c16.773-16.74,37.295-29.726,60.291-37.677l4.928,16.017C289.248,253.112,257.232,285.128,242.943,325.921z M278.884,289.769 c-0.589-0.59-1.103-1.256-1.538-1.974c4.467-5.232,9.338-10.103,14.57-14.57c0.716,0.435,1.382,0.948,1.973,1.539 c0.972,0.972,1.747,2.157,2.28,3.46l-13.826,13.826C281.042,291.519,279.859,290.743,278.884,289.769z M292.409,303.294 c-0.998-0.998-1.773-2.168-2.298-3.456l13.849-13.849c1.284,0.524,2.453,1.299,3.454,2.301c0.999,0.999,1.773,2.163,2.3,3.439 l-13.865,13.865C294.572,305.067,293.408,304.293,292.409,303.294z M305.927,316.811c-0.999-0.999-1.773-2.163-2.3-3.439 l13.865-13.865c1.276,0.526,2.44,1.301,3.439,2.3c0.999,0.999,1.773,2.163,2.3,3.439l-13.865,13.865 C308.09,318.585,306.926,317.81,305.927,316.811z M319.452,330.336c-1.002-1.002-1.779-2.169-2.307-3.447l13.864-13.864 c1.278,0.528,2.445,1.305,3.448,2.307c0.997,0.997,1.77,2.164,2.293,3.446l-13.852,13.852 C321.616,332.107,320.45,331.334,319.452,330.336z M347.975,343.854c-1.974,1.973-4.712,3.108-7.493,3.113 c-2.801-0.005-5.539-1.139-7.512-3.113c-0.972-0.972-1.747-2.157-2.28-3.46l13.824-13.824c1.304,0.533,2.488,1.307,3.46,2.279 c1.978,1.978,3.112,4.713,3.112,7.493C351.082,339.143,349.947,341.881,347.975,343.854z"></path>{" "}
            </g>{" "}
          </g>
        </svg>
      )

      break
    case "defense":
      iconElement = (
        <svg
          fill="#94D3F3"
          width="31px"
          height="31px"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path d="M20,4c-3.609,0-7.363-2.772-7.4-2.8a1,1,0,0,0-1.2,0C11.363,1.228,7.609,4,4,4A1,1,0,0,0,3,5c0,.6.1,14.729,8.649,17.937a1.009,1.009,0,0,0,.7,0C20.9,19.729,21,5.6,21,5A1,1,0,0,0,20,4ZM12,20.922C6.2,18.4,5.205,8.973,5.035,5.943A16.968,16.968,0,0,0,12,3.216a16.968,16.968,0,0,0,6.965,2.727C18.8,8.973,17.8,18.4,12,20.922ZM8,11a4,4,0,1,0,4-4A4,4,0,0,0,8,11Zm6,0a2,2,0,1,1-2-2A2,2,0,0,1,14,11Z"></path>
          </g>
        </svg>
      )

      break
    case "judges":
      iconElement = (
        <svg
          width="31"
          height="31"
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.90191 36.791H2.29395C1.43098 36.791 0.731445 37.4905 0.731445 38.3535C0.731445 39.2165 1.43098 39.916 2.29395 39.916H21.6689C22.5319 39.916 23.2314 39.2165 23.2314 38.3535C23.2314 37.4905 22.5319 36.791 21.6689 36.791H9.0259"
            stroke="white"
            stroke-width="1.17187"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.63086 36.791C3.76789 36.791 3.06836 36.0915 3.06836 35.2285C3.06836 34.3655 3.76789 33.666 4.63086 33.666H19.3333C20.1962 33.666 20.8958 34.3655 20.8958 35.2285C20.8958 36.0915 20.1962 36.791 19.3333 36.791"
            stroke="white"
            stroke-width="1.17187"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M25.4902 18.0223L36.2813 28.8134C37.0314 29.5635 38.2475 29.5635 38.9976 28.8134C39.7477 28.0633 39.7477 26.8472 38.9976 26.0972L28.1805 15.28"
            stroke="white"
            stroke-width="1.17187"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.1807 13.7734L23.958 3.99609"
            stroke="white"
            stroke-width="1.17187"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M29.6739 9.71379L19.8965 19.4912"
            stroke="white"
            stroke-width="1.17187"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M20.4123 21.9876C20.9614 21.4384 20.9614 20.548 20.4123 19.9989L13.673 13.2596C13.1238 12.7104 12.2335 12.7104 11.6843 13.2596C11.1352 13.8087 11.1352 14.6991 11.6843 15.2482L18.4236 21.9876C18.9728 22.5367 19.8631 22.5367 20.4123 21.9876Z"
            stroke="white"
            stroke-width="1.17187"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M26.0642 2.13125L25.4327 1.49977C24.8836 0.950626 23.9932 0.950626 23.4441 1.49977C22.8949 2.04891 22.8949 2.9393 23.4441 3.48844L30.1835 10.2277C30.7325 10.777 31.6229 10.777 32.172 10.2277C32.7212 9.67859 32.7212 8.78828 32.172 8.23914L28.1967 4.26375"
            stroke="white"
            stroke-width="1.17187"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21.9658 17.4279L22.4314 17.8935C23.2726 18.7347 24.6364 18.7347 25.4775 17.8935L28.0786 15.2924C28.9197 14.4513 28.9197 13.0875 28.0786 12.2463L27.613 11.7807L21.9658 17.4279Z"
            stroke="white"
            stroke-width="1.17187"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.65723 27.8951L8.05543 30.1943"
            stroke="white"
            stroke-width="1.17187"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19.4666 27.8951L16.0684 30.1943"
            stroke="white"
            stroke-width="1.17187"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.0625 27.6504V23.7438"
            stroke="white"
            stroke-width="1.17187"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )

      break
    case "organization":
      iconElement = (
        <svg
          width="31"
          height="31"
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1213_1051)">
            <path
              d="M38.5219 23.4311L37.0532 22.9436C37.1457 22.2327 37.1916 21.5166 37.1907 20.7998C37.1914 20.0809 37.1455 19.3627 37.0532 18.6498L38.5219 18.1686C38.8368 18.0656 39.0978 17.8419 39.2478 17.5466C39.3978 17.2513 39.4245 16.9085 39.3219 16.5936L38.1657 13.0311C38.115 12.8739 38.0336 12.7284 37.9264 12.6029C37.8191 12.4774 37.688 12.3744 37.5407 12.2998C37.3916 12.2224 37.2284 12.1759 37.0608 12.163C36.8933 12.1501 36.7249 12.1711 36.5657 12.2248L35.1157 12.6748C34.4355 11.4136 33.5952 10.2456 32.6157 9.1998L33.5219 7.9498C33.6191 7.81697 33.6891 7.66624 33.7279 7.50628C33.7667 7.34632 33.7735 7.18028 33.748 7.01768C33.7224 6.85508 33.665 6.69913 33.579 6.55878C33.493 6.41842 33.3802 6.29643 33.2469 6.1998L30.1844 4.0248C29.9166 3.83049 29.5826 3.75032 29.2557 3.80187C28.9289 3.85342 28.6358 4.03249 28.4407 4.2998L27.5282 5.5498C26.2294 4.93017 24.8553 4.48264 23.4407 4.21855V2.6748C23.4407 2.34328 23.309 2.02534 23.0746 1.79092C22.8402 1.5565 22.5222 1.4248 22.1907 1.4248H18.4407C18.1092 1.4248 17.7912 1.5565 17.5568 1.79092C17.3224 2.02534 17.1907 2.34328 17.1907 2.6748V4.21855C15.7737 4.48128 14.3974 4.92885 13.0969 5.5498L12.1907 4.2998C11.9956 4.03249 11.7025 3.85342 11.3757 3.80187C11.0488 3.75032 10.7148 3.83049 10.4469 4.0248L7.40945 6.2248C7.2762 6.32143 7.16335 6.44342 7.07737 6.58378C6.99139 6.72413 6.93398 6.88008 6.90843 7.04268C6.88288 7.20528 6.88969 7.37132 6.92848 7.53128C6.96726 7.69124 7.03726 7.84197 7.13444 7.9748L8.03445 9.2248C7.0551 10.2731 6.21485 11.4431 5.53445 12.7061L4.06569 12.2248C3.90935 12.1742 3.74455 12.1549 3.58073 12.168C3.41691 12.1811 3.25729 12.2264 3.111 12.3013C2.96471 12.3762 2.83462 12.4792 2.72819 12.6044C2.62175 12.7296 2.54104 12.8746 2.49069 13.0311L1.33444 16.5936C1.23192 16.9085 1.25858 17.2513 1.40857 17.5466C1.55857 17.8419 1.81964 18.0656 2.13444 18.1686L3.6032 18.6561C3.50236 19.3663 3.44808 20.0824 3.44069 20.7998C3.44 21.5187 3.48593 22.2369 3.57819 22.9498L2.10944 23.4311C1.79464 23.534 1.53357 23.7577 1.38357 24.053C1.23358 24.3483 1.20692 24.6911 1.30944 25.0061L2.46569 28.5686C2.51642 28.7257 2.59776 28.8712 2.70504 28.9967C2.81231 29.1222 2.94339 29.2252 3.09069 29.2998C3.23983 29.3772 3.40303 29.4237 3.57056 29.4366C3.73808 29.4495 3.90648 29.4285 4.06569 29.3748L5.51569 28.9248C6.19591 30.186 7.0362 31.354 8.01569 32.3998L7.10944 33.6498C7.01226 33.7826 6.94226 33.9334 6.90348 34.0933C6.86469 34.2533 6.85788 34.4193 6.88343 34.5819C6.90898 34.7445 6.96639 34.9005 7.05237 35.0408C7.13835 35.1812 7.2512 35.3032 7.38445 35.3998L10.4219 37.5998C10.5569 37.6987 10.7103 37.7695 10.8731 37.808C11.0359 37.8465 11.2048 37.8519 11.3698 37.8239C11.5347 37.7959 11.6924 37.7351 11.8334 37.6451C11.9744 37.5551 12.0959 37.4377 12.1907 37.2998L13.1032 36.0498C14.402 36.6694 15.7761 37.117 17.1907 37.3811V38.9248C17.1907 39.2563 17.3224 39.5743 17.5568 39.8087C17.7912 40.0431 18.1092 40.1748 18.4407 40.1748H22.1907C22.5222 40.1748 22.8402 40.0431 23.0746 39.8087C23.309 39.5743 23.4407 39.2563 23.4407 38.9248V37.3811C24.8555 37.1178 26.2297 36.6702 27.5282 36.0498L28.4344 37.2998C28.6295 37.5671 28.9226 37.7462 29.2495 37.7977C29.5764 37.8493 29.9103 37.7691 30.1782 37.5748L33.2157 35.3748C33.3489 35.2782 33.4618 35.1562 33.5478 35.0158C33.6337 34.8755 33.6912 34.7195 33.7167 34.5569C33.7423 34.3943 33.7354 34.2283 33.6967 34.0683C33.6579 33.9084 33.5879 33.7576 33.4907 33.6248L32.5907 32.3748C33.57 31.3265 34.4103 30.1565 35.0907 28.8936L36.5657 29.3748C36.722 29.4254 36.8868 29.4447 37.0507 29.4316C37.2145 29.4185 37.3741 29.3732 37.5204 29.2983C37.6667 29.2234 37.7968 29.1204 37.9032 28.9952C38.0096 28.87 38.0903 28.725 38.1407 28.5686L39.2969 25.0061C39.4006 24.6944 39.3774 24.3544 39.2324 24.0596C39.0874 23.7649 38.8322 23.5391 38.5219 23.4311ZM36.9719 28.1811L35.5032 27.7061C35.2222 27.6194 34.9197 27.6345 34.6488 27.7488C34.3778 27.8631 34.1559 28.0693 34.0219 28.3311C33.3814 29.4981 32.5961 30.5796 31.6844 31.5498C31.4895 31.7577 31.3714 32.026 31.3498 32.3101C31.3282 32.5943 31.4044 32.8773 31.5657 33.1123L32.4719 34.3623L29.4407 36.5623L28.5344 35.3123C28.3617 35.0755 28.1111 34.9069 27.8267 34.8361C27.5422 34.7652 27.2419 34.7966 26.9782 34.9248C25.7873 35.5014 24.5269 35.9216 23.2282 36.1748C22.937 36.2281 22.6741 36.3829 22.4864 36.6118C22.2987 36.8407 22.1984 37.1288 22.2032 37.4248V38.9248H18.4407V37.3811C18.4455 37.0851 18.3451 36.797 18.1574 36.5681C17.9697 36.3392 17.7069 36.1843 17.4157 36.1311C16.1067 35.879 14.8358 35.4588 13.6344 34.8811C13.3722 34.7562 13.0746 34.7266 12.7929 34.7973C12.5112 34.8681 12.2629 35.0347 12.0907 35.2686L11.1782 36.5186L8.14694 34.3623L9.05319 33.1123C9.22423 32.876 9.30724 32.5873 9.28784 32.2962C9.26843 32.0052 9.14784 31.7301 8.94695 31.5186C8.03534 30.5484 7.24995 29.4669 6.60944 28.2998C6.47549 28.038 6.25354 27.8319 5.98263 27.7176C5.71171 27.6033 5.40917 27.5881 5.12819 27.6748L3.65944 28.1561L2.49694 24.6186L3.96569 24.1373C4.24247 24.0466 4.47886 23.862 4.63406 23.6155C4.78925 23.3691 4.85349 23.0761 4.81569 22.7873C4.64902 21.4675 4.64902 20.1321 4.81569 18.8123C4.85349 18.5235 4.78925 18.2306 4.63406 17.9841C4.47886 17.7376 4.24247 17.553 3.96569 17.4623L2.49694 16.9811L3.65944 13.4186L5.12819 13.9248C5.40917 14.0115 5.71171 13.9963 5.98263 13.882C6.25354 13.7677 6.47549 13.5616 6.60944 13.2998C7.24995 12.1327 8.03534 11.0513 8.94695 10.0811C9.14972 9.87107 9.2726 9.59674 9.29429 9.30564C9.31598 9.01453 9.23511 8.72502 9.06569 8.4873L8.15944 7.2373L11.1907 5.0373L12.0969 6.2873C12.2697 6.52413 12.5203 6.6927 12.8047 6.76353C13.0892 6.83437 13.3895 6.80296 13.6532 6.6748C14.8441 6.0982 16.1045 5.67804 17.4032 5.4248C17.6944 5.37156 17.9572 5.2167 18.1449 4.98779C18.3326 4.75888 18.433 4.47079 18.4282 4.1748V2.6748H22.1782V4.21855C22.1734 4.51454 22.2737 4.80263 22.4614 5.03154C22.6491 5.26045 22.912 5.41531 23.2032 5.46855C24.5015 5.72321 25.7618 6.1433 26.9532 6.71855C27.2155 6.84338 27.513 6.87298 27.7947 6.80226C28.0764 6.73155 28.3247 6.56494 28.4969 6.33105L29.4094 5.08105L32.4407 7.2873L31.5657 8.4873C31.3947 8.72361 31.3117 9.0123 31.3311 9.30336C31.3505 9.59443 31.4711 9.86954 31.6719 10.0811C32.5879 11.0505 33.3776 12.132 34.0219 13.2998C34.1559 13.5616 34.3778 13.7677 34.6488 13.882C34.9197 13.9963 35.2222 14.0115 35.5032 13.9248L36.9719 13.4436L38.1344 17.0123L36.6657 17.4936C36.3889 17.5843 36.1525 17.7688 35.9973 18.0153C35.8421 18.2618 35.7779 18.5547 35.8157 18.8436C35.9824 20.1633 35.9824 21.4988 35.8157 22.8186C35.7779 23.1074 35.8421 23.4003 35.9973 23.6468C36.1525 23.8933 36.3889 24.0778 36.6657 24.1686L38.1344 24.6498L36.9719 28.1811Z"
              fill="white"
            />
            <path
              d="M11.9155 12.3999C13.9138 10.4204 16.5467 9.20963 19.3502 8.98096C22.1536 8.75229 24.9479 9.5204 27.2405 11.1499H25.503V12.3999H29.3155C29.4159 12.3999 29.5147 12.3757 29.6038 12.3294C29.6928 12.2831 29.7693 12.216 29.8269 12.1339C29.8846 12.0517 29.9216 11.9569 29.9348 11.8575C29.9481 11.758 29.9372 11.6568 29.903 11.5624L28.603 7.97494L27.428 8.40619L28.053 10.2124C25.6045 8.41323 22.6075 7.5193 19.5734 7.68317C16.5393 7.84704 13.6561 9.05855 11.4156 11.111C9.17504 13.1635 7.71604 15.9297 7.28748 18.9379C6.85892 21.946 7.48734 25.0097 9.06555 27.6062L10.1343 26.9812C8.7524 24.7032 8.17671 22.0268 8.49978 19.3821C8.82286 16.7374 10.0259 14.2782 11.9155 12.3999Z"
              fill="white"
            />
            <path
              d="M30.472 14.6432C31.8675 16.9789 32.4187 19.723 32.0332 22.4164C31.6477 25.1098 30.349 27.5892 28.3543 29.4397C26.3596 31.2902 23.7899 32.3996 21.0752 32.5822C18.3605 32.7649 15.6653 32.0098 13.4407 30.4432H15.172V29.1932H11.3595C11.2584 29.1928 11.1587 29.217 11.069 29.2637C10.9793 29.3103 10.9023 29.3781 10.8445 29.461C10.7867 29.544 10.75 29.6397 10.7373 29.74C10.7247 29.8403 10.7366 29.9422 10.772 30.0369L12.072 33.6182L13.247 33.1932L12.5845 31.3744C15.0326 33.1645 18.0251 34.0515 21.0533 33.8847C24.0815 33.7179 26.9585 32.5075 29.1952 30.4593C31.4319 28.4112 32.8903 25.6516 33.3224 22.6498C33.7546 19.6479 33.1338 16.5891 31.5657 13.9932L30.472 14.6432Z"
              fill="white"
            />
            <path
              d="M11.5654 22.0498V25.1748C11.5654 25.3405 11.6313 25.4995 11.7485 25.6167C11.8657 25.7339 12.0247 25.7998 12.1904 25.7998H16.5654C16.5654 25.9655 16.6313 26.1245 16.7485 26.2417C16.8657 26.3589 17.0247 26.4248 17.1904 26.4248H23.4404C23.6062 26.4248 23.7652 26.3589 23.8824 26.2417C23.9996 26.1245 24.0654 25.9655 24.0654 25.7998H28.4404C28.6062 25.7998 28.7652 25.7339 28.8824 25.6167C28.9996 25.4995 29.0654 25.3405 29.0654 25.1748V22.0498C29.0633 21.5195 28.8927 21.0035 28.5781 20.5766C28.2635 20.1497 27.8213 19.8338 27.3154 19.6748C27.6672 19.3904 27.9223 19.004 28.0454 18.5687C28.1685 18.1334 28.1536 17.6707 28.0028 17.2442C27.852 16.8177 27.5727 16.4485 27.2034 16.1873C26.834 15.9262 26.3928 15.7859 25.9404 15.7859C25.4881 15.7859 25.0468 15.9262 24.6775 16.1873C24.3081 16.4485 24.0288 16.8177 23.878 17.2442C23.7273 17.6707 23.7124 18.1334 23.8355 18.5687C23.9586 19.004 24.2136 19.3904 24.5654 19.6748C24.1736 19.7949 23.8173 20.0095 23.5279 20.2998C23.114 19.6916 22.4987 19.2489 21.7904 19.0498C22.2162 18.7386 22.5327 18.3008 22.6947 17.7989C22.8566 17.297 22.8557 16.7568 22.692 16.2555C22.5284 15.7541 22.2104 15.3174 21.7835 15.0077C21.3566 14.698 20.8428 14.5312 20.3154 14.5312C19.7881 14.5312 19.2742 14.698 18.8474 15.0077C18.4205 15.3174 18.1025 15.7541 17.9388 16.2555C17.7752 16.7568 17.7743 17.297 17.9362 17.7989C18.0981 18.3008 18.4146 18.7386 18.8404 19.0498C18.1322 19.2489 17.5169 19.6916 17.1029 20.2998C16.8136 20.0095 16.4573 19.7949 16.0654 19.6748C16.4173 19.3904 16.6723 19.004 16.7954 18.5687C16.9185 18.1334 16.9036 17.6707 16.7528 17.2442C16.602 16.8177 16.3227 16.4485 15.9534 16.1873C15.584 15.9262 15.1428 15.7859 14.6904 15.7859C14.2381 15.7859 13.7968 15.9262 13.4275 16.1873C13.0581 16.4485 12.7788 16.8177 12.628 17.2442C12.4773 17.6707 12.4624 18.1334 12.5855 18.5687C12.7086 19.004 12.9636 19.3904 13.3154 19.6748C12.8095 19.8338 12.3674 20.1497 12.0528 20.5766C11.7382 21.0035 11.5675 21.5195 11.5654 22.0498ZM25.9404 17.0498C26.1258 17.0498 26.3071 17.1047 26.4613 17.2078C26.6154 17.3108 26.7356 17.4572 26.8066 17.6285C26.8775 17.7998 26.8961 17.9883 26.8599 18.1702C26.8237 18.352 26.7345 18.5191 26.6033 18.6502C26.4722 18.7813 26.3052 18.8706 26.1233 18.9067C25.9415 18.9429 25.753 18.9244 25.5817 18.8534C25.4104 18.7824 25.2639 18.6623 25.1609 18.5081C25.0579 18.3539 25.0029 18.1727 25.0029 17.9873C25.0029 17.7386 25.1017 17.5002 25.2775 17.3243C25.4533 17.1485 25.6918 17.0498 25.9404 17.0498ZM24.0654 22.0498C24.0654 21.7182 24.1971 21.4003 24.4315 21.1659C24.666 20.9315 24.9839 20.7998 25.3154 20.7998H26.5654C26.897 20.7998 27.2149 20.9315 27.4493 21.1659C27.6837 21.4003 27.8154 21.7182 27.8154 22.0498V24.5498H24.0654V22.0498ZM20.3154 15.7998C20.5627 15.7998 20.8043 15.8731 21.0099 16.0104C21.2155 16.1478 21.3757 16.343 21.4703 16.5714C21.5649 16.7998 21.5896 17.0511 21.5414 17.2936C21.4932 17.5361 21.3741 17.7588 21.1993 17.9336C21.0245 18.1085 20.8018 18.2275 20.5593 18.2757C20.3168 18.324 20.0655 18.2992 19.8371 18.2046C19.6087 18.11 19.4134 17.9498 19.2761 17.7442C19.1387 17.5387 19.0654 17.297 19.0654 17.0498C19.0654 16.7182 19.1971 16.4003 19.4315 16.1659C19.666 15.9315 19.9839 15.7998 20.3154 15.7998ZM17.8154 22.0498C17.8154 21.5525 18.013 21.0756 18.3646 20.7239C18.7162 20.3723 19.1931 20.1748 19.6904 20.1748H20.9404C21.4377 20.1748 21.9146 20.3723 22.2663 20.7239C22.6179 21.0756 22.8154 21.5525 22.8154 22.0498V25.1748H17.8154V22.0498ZM14.6904 17.0498C14.8758 17.0498 15.0571 17.1047 15.2113 17.2078C15.3654 17.3108 15.4856 17.4572 15.5566 17.6285C15.6275 17.7998 15.6461 17.9883 15.6099 18.1702C15.5737 18.352 15.4845 18.5191 15.3533 18.6502C15.2222 18.7813 15.0552 18.8706 14.8733 18.9067C14.6915 18.9429 14.503 18.9244 14.3317 18.8534C14.1604 18.7824 14.0139 18.6623 13.9109 18.5081C13.8079 18.3539 13.7529 18.1727 13.7529 17.9873C13.7529 17.7386 13.8517 17.5002 14.0275 17.3243C14.2033 17.1485 14.4418 17.0498 14.6904 17.0498ZM12.8154 22.0498C12.8154 21.7182 12.9471 21.4003 13.1815 21.1659C13.416 20.9315 13.7339 20.7998 14.0654 20.7998H15.3154C15.647 20.7998 15.9649 20.9315 16.1993 21.1659C16.4337 21.4003 16.5654 21.7182 16.5654 22.0498V24.5498H12.8154V22.0498Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1213_1051">
              <rect
                width="40"
                height="40"
                fill="white"
                transform="translate(0.31543 0.799805)"
              />
            </clipPath>
          </defs>
        </svg>
      )

      break
    case "arrowsearchcc":
      iconElement = (
        <svg
          width="26"
          height="25"
          viewBox="0 0 41 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.3992 4.9334L12.3492 9.9334C2.23255 13.3167 2.23255 18.8334 12.3492 22.2001L16.8159 23.6834L18.2992 28.1501C21.6659 38.2667 27.1992 38.2667 30.5659 28.1501L35.5826 13.1167C37.8159 6.36674 34.1492 2.6834 27.3992 4.9334ZM27.9326 13.9001L21.5992 20.2667C21.3492 20.5167 21.0326 20.6334 20.7159 20.6334C20.3992 20.6334 20.0826 20.5167 19.8326 20.2667C19.3492 19.7834 19.3492 18.9834 19.8326 18.5001L26.1659 12.1334C26.6492 11.6501 27.4492 11.6501 27.9326 12.1334C28.4159 12.6167 28.4159 13.4167 27.9326 13.9001Z"
            fill="white"
          />
        </svg>
      )

      break
    case "img-tailieu":
      iconElement = (
        <svg
          width="320"
          height="207"
          viewBox="0 0 320 207"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 16C0 7.16345 7.16344 0 16 0H304C312.837 0 320 7.16344 320 16V207H0V16Z"
            fill="#DBEDF3"
          />
          <path
            d="M116 37H163H186.5H194.5L201 44L210 53.625V70.25V103.5V170H116V37Z"
            fill="white"
          />
          <path
            d="M217.309 59.0661L184.184 25.9411C182.942 24.6989 181.256 24 179.5 24H119.875C108.914 24 100 32.9139 100 43.875V163.125C100 174.086 108.914 183 119.875 183H199.375C210.336 183 219.25 174.086 219.25 163.125V63.75C219.25 61.9944 218.551 60.3083 217.309 59.0661ZM186.125 156.5H133.125C129.468 156.5 126.5 153.532 126.5 149.875C126.5 146.218 129.468 143.25 133.125 143.25H186.125C189.782 143.25 192.75 146.218 192.75 149.875C192.75 153.532 189.782 156.5 186.125 156.5ZM186.125 126.688H133.125C129.468 126.688 126.5 123.719 126.5 120.062C126.5 116.406 129.468 113.438 133.125 113.438H186.125C189.782 113.438 192.75 116.406 192.75 120.062C192.75 123.719 189.782 126.688 186.125 126.688ZM186.125 96.875H133.125C129.468 96.875 126.5 93.907 126.5 90.25C126.5 86.593 129.468 83.625 133.125 83.625H186.125C189.782 83.625 192.75 86.593 192.75 90.25C192.75 93.907 189.782 96.875 186.125 96.875ZM204.874 63.75H182.014C180.626 63.75 179.5 62.6237 179.5 61.2358V38.3763C179.5 37.3759 180.709 36.8757 181.418 37.5813L205.669 61.8321C206.378 62.5409 205.874 63.75 204.874 63.75Z"
            fill="url(#paint0_linear_1022_1705)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1022_1705"
              x1="89.5524"
              y1="46.1043"
              x2="217.021"
              y2="173.573"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#00D2FF" />
              <stop offset="1" stop-color="#3A7BD5" />
            </linearGradient>
          </defs>
        </svg>
      )

      break
    // Icon button
    case "dt-add":
      iconElement = (
        <svg
          width="80"
          height="80"
          viewBox="0 0 102 102"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_836_1969)">
            <path
              d="M49.8264 12.707C50.9127 12.707 51.7934 11.8264 51.7934 10.74V1.96699C51.7934 0.880664 50.9127 0 49.8264 0C48.74 0 47.8594 0.880664 47.8594 1.96699V10.74C47.8596 11.8264 48.7402 12.707 49.8264 12.707Z"
              fill="#01CBFD"
            />
            <path
              d="M97.9064 67.5745L94.4316 64.1095C93.1955 62.8749 91.548 62.1949 89.7926 62.1949C88.6701 62.1949 87.5926 62.4741 86.6377 62.9974L80.0896 56.4571L80.4086 56.1386C83.065 53.4769 83.0641 49.1517 80.4084 46.4989C79.4594 45.5482 78.2752 44.9142 76.9844 44.6474C77.1621 44.0339 77.2557 43.3913 77.2557 42.7337C77.2557 40.9066 76.5459 39.1933 75.2611 37.9138C74.3119 36.963 73.1279 36.329 71.8371 36.0622C72.0148 35.4488 72.1084 34.8064 72.1084 34.1486C72.1084 32.3212 71.3986 30.6081 70.1117 29.3267C69.1398 28.356 67.9451 27.7415 66.6906 27.48C67.3617 25.1661 66.7883 22.5628 64.968 20.7394C63.4527 19.2306 61.3967 18.5822 59.4152 18.7923L46.4397 16.3363C44.4607 15.9609 41.9895 15.7126 40.4295 17.1355C40.3311 17.2253 40.2307 17.3286 40.1318 17.4437C37.7131 16.562 34.892 17.087 32.9551 19.0218C31.6701 20.3052 30.9623 22.0177 30.9623 23.8439C30.9623 24.5017 31.0555 25.1441 31.233 25.7577C29.9436 26.0243 28.7609 26.6575 27.815 27.6052C26.5275 28.8874 25.8176 30.598 25.8162 32.422C25.8156 33.0814 25.9092 33.7259 26.0877 34.3411C24.7977 34.6072 23.6143 35.2392 22.6654 36.1868C21.3779 37.473 20.6689 39.1864 20.6689 41.0116C20.6689 42.4097 21.0863 43.7415 21.8598 44.8665C20.8832 45.1976 19.9887 45.7486 19.2396 46.4968C16.5814 49.1517 16.5805 53.4771 19.2414 56.1427L19.5592 56.4591L13.0104 62.996C10.5766 61.8501 7.57793 62.2794 5.56953 64.2853L2.09258 67.7525C0.855859 68.9876 0.175 70.6353 0.174805 72.3917C0.174805 74.1484 0.855859 75.7962 2.09258 77.0316L6.43184 81.3655C7.20039 82.1333 8.4459 82.1325 9.21348 81.364C9.98125 80.5954 9.98047 79.3499 9.21191 78.5823L4.87266 74.2484C4.38008 73.7564 4.10879 73.097 4.10879 72.3919C4.10879 71.687 4.38008 71.0279 4.87148 70.537L8.34863 67.0697C9.21738 66.2019 10.5471 66.0726 11.5568 66.6763C11.6279 66.7831 11.7102 66.8847 11.8043 66.979C11.9729 67.148 12.1652 67.2775 12.3695 67.3722L32.3096 87.2829C32.4043 87.4894 32.5344 87.6837 32.7041 87.8536C32.8693 88.0191 33.0578 88.147 33.2578 88.2411C33.6795 88.7179 33.9125 89.3269 33.9125 89.9765C33.9125 90.6816 33.6412 91.3408 33.1486 91.8327L29.675 95.3023C28.6486 96.3241 26.9791 96.324 25.9559 95.3054L21.6166 90.9657C20.8484 90.1976 19.6031 90.1976 18.835 90.9657C18.0668 91.7339 18.0668 92.9792 18.835 93.7474L23.1773 98.0902C24.4555 99.363 26.134 99.9991 27.8133 99.9991C29.493 99.9991 31.1734 99.362 32.4531 98.088L35.9289 94.6163C37.1656 93.381 37.8467 91.7333 37.8467 89.9765C37.8467 88.7228 37.498 87.5255 36.8498 86.4931L44.2201 79.1318C44.2279 79.1238 44.2357 79.1157 44.2437 79.1077C45.0877 78.2353 47.4379 78.3986 49.7107 78.5564C51.3256 78.6687 53.126 78.7935 54.885 78.5907L62.9561 86.6523C62.4332 87.6056 62.1541 88.6818 62.1541 89.8025C62.1541 91.5573 62.8352 93.204 64.0719 94.4394L67.5479 97.9111C68.7838 99.1456 70.4313 99.8257 72.1867 99.8257C73.942 99.8257 75.5895 99.1458 76.8256 97.9111L97.9078 76.8544C99.1445 75.6193 99.8256 73.9716 99.8256 72.215C99.8254 70.4585 99.1443 68.8109 97.9064 67.5745ZM45.7072 20.2015L54.2398 21.8165L49.1326 26.9218C48.3426 26.5421 47.2598 25.8339 46.0719 24.6976C44.4459 23.1421 43.2828 21.3462 43.177 20.2261C43.1768 20.2255 43.1768 20.2249 43.1768 20.2243C43.1768 20.2241 43.1766 20.2239 43.1766 20.2238C43.1689 20.1433 43.167 20.079 43.168 20.03C43.4252 19.9675 44.1084 19.8982 45.7072 20.2015ZM35.735 21.8052C36.7314 20.8097 38.2795 20.6948 39.4055 21.4573C40.0436 24.1327 42.3258 26.5575 43.3525 27.54C44.1135 28.2681 46.5551 30.4511 49.0195 31.0511C49.3529 31.529 49.5344 32.0988 49.5344 32.6999C49.5344 33.4743 49.2365 34.1984 48.6938 34.7406C48.1525 35.2827 47.4273 35.5812 46.6516 35.5812C45.8756 35.5812 45.1504 35.2827 44.6066 34.738L44.6064 34.7378L44.6055 34.7368L35.7348 25.8822C35.1939 25.3421 34.8961 24.6181 34.8961 23.8439C34.8963 23.0695 35.1941 22.3454 35.735 21.8052ZM30.5951 30.3886C31.1363 29.8466 31.8607 29.548 32.6354 29.548C33.4109 29.548 34.1377 29.8472 34.6824 30.3913L41.8254 37.52C42.9502 38.6466 42.9502 40.4798 41.8293 41.6025C41.2852 42.1445 40.5574 42.4429 39.7803 42.4429C39.0031 42.4429 38.2754 42.1445 37.7336 41.6048L37.7334 41.6046L32.3145 36.1868C32.3061 36.1784 32.2969 36.1706 32.2883 36.162L30.593 34.4675C30.049 33.9241 29.7496 33.1988 29.7502 32.4249C29.751 31.6536 30.0494 30.932 30.5951 30.3886ZM25.4455 38.9702C25.9871 38.4294 26.7131 38.1316 27.49 38.1316C28.2605 38.1316 28.9803 38.4251 29.5195 38.9566L34.9551 44.3896C35.4971 44.9294 35.7957 45.6527 35.7957 46.4261C35.7957 47.1993 35.4971 47.9226 34.9529 48.4646C34.4115 49.0052 33.6863 49.3031 32.9107 49.3031C32.134 49.3031 31.4064 49.0044 30.8643 48.4646L28.8937 46.4964C28.8934 46.4958 28.8928 46.4954 28.8924 46.495L25.4457 43.0525C24.9023 42.5097 24.6031 41.7847 24.6031 41.0113C24.6031 40.238 24.9023 39.5128 25.4455 38.9702ZM22.0197 49.28C22.5637 48.7366 23.2906 48.4374 24.0666 48.4374C24.8424 48.4374 25.5691 48.7364 26.1129 49.2794L28.0861 51.2503C28.6283 51.7902 28.9268 52.5134 28.9268 53.2868C28.9268 54.0603 28.6281 54.7833 28.082 55.3275C27.5408 55.8695 26.8156 56.1681 26.0398 56.1681C25.2639 56.1681 24.5387 55.8697 23.9936 55.3236L23.7465 55.0775C23.7432 55.0741 23.7406 55.0706 23.7375 55.0675C23.7338 55.064 23.7299 55.0609 23.7262 55.0573L22.0217 53.3595C20.8969 52.2323 20.8959 50.4025 22.0197 49.28ZM62.1045 71.6351C61.3367 70.8663 60.0912 70.8657 59.3228 71.6333L57.5728 73.3812C55.91 75.0441 52.8969 74.8347 49.983 74.6325C46.8188 74.4126 43.5467 74.1857 41.4293 76.3595L34.1842 83.5958L16.0664 65.5046L22.4781 59.1044C23.5379 59.754 24.7607 60.1023 26.0402 60.1023C27.8682 60.1023 29.5822 59.3937 30.8625 58.1111C32.1514 56.8275 32.8613 55.1144 32.8613 53.287C32.8613 53.27 32.8602 53.2532 32.8602 53.2363C32.8771 53.2365 32.8941 53.2374 32.9111 53.2374C34.7365 53.2374 36.4492 52.531 37.7313 51.2505C39.0201 49.9669 39.7301 48.2536 39.7301 46.4265C39.7301 46.4095 39.7289 46.3927 39.7289 46.3757C39.7461 46.3757 39.7633 46.3769 39.7807 46.3769C41.6055 46.3769 43.3191 45.6712 44.6098 44.3859C45.9496 43.0439 46.6123 41.2771 46.5996 39.514C46.6172 39.5142 46.6348 39.5152 46.6523 39.5152C48.4803 39.515 50.1941 38.8066 51.4764 37.522C52.7613 36.2386 53.4691 34.5261 53.4691 32.6999C53.4691 31.4228 53.1219 30.2019 52.4744 29.1443L58.0941 23.5269C58.5129 23.1099 59.0293 22.8482 59.5705 22.7402C59.6291 22.7339 59.6869 22.7245 59.7441 22.7132C60.6125 22.5935 61.5244 22.8614 62.1885 23.5228C63.3133 24.6495 63.3133 26.4827 62.1926 27.6054L60.481 29.3099C60.4754 29.3156 60.4693 29.3206 60.4637 29.3263L58.4924 31.2943C57.7236 32.0618 57.7229 33.3073 58.4906 34.0759C59.2586 34.8447 60.5039 34.8452 61.2723 34.0777L62.9906 32.3616C62.991 32.3613 62.9914 32.3609 62.9918 32.3605L63.2516 32.1017C64.3795 30.9841 66.2068 30.9864 67.3336 32.1116C67.8758 32.6515 68.1744 33.3747 68.1744 34.1482C68.1744 34.9214 67.8758 35.6447 67.3293 36.1888L65.608 37.9136C65.6078 37.9138 65.6076 37.914 65.6074 37.9144L63.6363 39.8775C62.8666 40.6441 62.8641 41.8896 63.6307 42.6591C64.3973 43.4288 65.6426 43.4312 66.4123 42.6648L68.3924 40.6927C68.9336 40.1505 69.6588 39.8521 70.4346 39.8521C71.2105 39.8521 71.9359 40.1505 72.481 40.6966C73.0232 41.2366 73.3217 41.9599 73.3217 42.7333C73.3217 43.5066 73.0232 44.2298 72.4779 44.7728L69.0463 48.2058C68.2783 48.9741 68.2785 50.2195 69.0467 50.9874C69.4309 51.3714 69.934 51.5632 70.4373 51.5632C70.9408 51.5632 71.4443 51.371 71.8283 50.9868L73.5102 49.3044C73.5197 49.2952 73.5301 49.2872 73.5396 49.2777C74.0809 48.7355 74.8061 48.437 75.5818 48.437C76.3578 48.437 77.083 48.7355 77.6262 49.2796C78.7498 50.4021 78.7488 52.2322 77.6262 53.3568L75.9162 55.0648C75.9156 55.0654 75.9148 55.0659 75.9143 55.0665C75.9137 55.0671 75.9131 55.0679 75.9125 55.0685L73.1984 57.7792C72.4299 58.547 72.4291 59.7925 73.1967 60.5611C73.5809 60.9456 74.0848 61.138 74.5885 61.138C75.0914 61.138 75.5945 60.9462 75.9785 60.5628L77.3061 59.2368L83.6687 65.5921L65.5525 83.6862L59.0615 77.203C59.5141 76.912 59.9471 76.5698 60.3535 76.1634L62.1025 74.4165C62.8715 73.6491 62.8723 72.4036 62.1045 71.6351ZM95.1275 74.071L74.0453 95.1277C73.5521 95.6202 72.892 95.8915 72.1865 95.8915C71.481 95.8915 70.8209 95.6202 70.3275 95.1275L66.8516 91.6558C66.359 91.164 66.0877 90.5058 66.0877 89.8025C66.0877 89.0993 66.359 88.4411 66.8516 87.9491L87.9338 66.8925C88.4271 66.3997 89.0871 66.1284 89.7928 66.1284C90.4982 66.1284 91.1584 66.3997 91.6529 66.8937L95.1277 70.3587C95.6203 70.8507 95.8916 71.5097 95.8916 72.2148C95.8914 72.92 95.6201 73.5792 95.1275 74.071Z"
              fill="#01CBFD"
            />
            <path
              d="M23.707 11.0489C24.091 11.4321 24.5937 11.6235 25.0964 11.6235C25.6003 11.6235 26.1044 11.4309 26.4886 11.0459C27.256 10.277 27.2548 9.03167 26.4859 8.26428L19.3183 1.11096C18.5496 0.34358 17.3041 0.344556 16.5367 1.1137C15.7693 1.88264 15.7705 3.12795 16.5394 3.89534L23.707 11.0489Z"
              fill="#01CBFD"
            />
            <path
              d="M74.5548 11.6234C75.0578 11.6234 75.5609 11.4316 75.9449 11.0482L83.107 3.89468C83.8755 3.1271 83.8763 1.88159 83.1085 1.11304C82.341 0.344483 81.0957 0.343701 80.3269 1.11147L73.1648 8.26499C72.3962 9.03257 72.3955 10.2781 73.1632 11.0466C73.5474 11.4312 74.0511 11.6234 74.5548 11.6234Z"
              fill="#01CBFD"
            />
            <path
              d="M12.2694 84.6105C11.5078 85.3851 11.5184 86.6306 12.2932 87.3921L12.2989 87.3976C12.6811 87.7734 13.1774 87.9605 13.6735 87.9605C14.1826 87.9605 14.6918 87.7634 15.0776 87.371C15.8391 86.5964 15.8256 85.3482 15.051 84.5867C14.2766 83.8251 13.0313 83.8359 12.2694 84.6105Z"
              fill="#01CBFD"
            />
            <path
              d="M66.9153 68.8026C67.2146 68.8026 67.5181 68.7344 67.803 68.5909C68.773 68.1016 69.1626 66.9188 68.6735 65.9489C68.1843 64.9789 67.0013 64.5891 66.0316 65.0784L66.0206 65.0838C65.0507 65.5731 64.6665 66.7532 65.1556 67.7231C65.5009 68.4082 66.1954 68.8026 66.9153 68.8026Z"
              fill="#01CBFD"
            />
          </g>
          <g clip-path="url(#clip1_836_1969)">
            <path
              d="M51.8264 14.707C52.9127 14.707 53.7934 13.8264 53.7934 12.74V3.96699C53.7934 2.88066 52.9127 2 51.8264 2C50.74 2 49.8594 2.88066 49.8594 3.96699V12.74C49.8596 13.8264 50.7402 14.707 51.8264 14.707Z"
              fill="#F5463B"
            />
            <path
              d="M99.9064 69.5745L96.4316 66.1095C95.1955 64.8749 93.548 64.1949 91.7926 64.1949C90.6701 64.1949 89.5926 64.4741 88.6377 64.9974L82.0896 58.4571L82.4086 58.1386C85.065 55.4769 85.0641 51.1517 82.4084 48.4989C81.4594 47.5482 80.2752 46.9142 78.9844 46.6474C79.1621 46.0339 79.2557 45.3913 79.2557 44.7337C79.2557 42.9066 78.5459 41.1933 77.2611 39.9138C76.3119 38.963 75.1279 38.329 73.8371 38.0622C74.0148 37.4488 74.1084 36.8064 74.1084 36.1486C74.1084 34.3212 73.3986 32.6081 72.1117 31.3267C71.1398 30.356 69.9451 29.7415 68.6906 29.48C69.3617 27.1661 68.7883 24.5628 66.968 22.7394C65.4527 21.2306 63.3967 20.5822 61.4152 20.7923L48.4397 18.3363C46.4607 17.9609 43.9895 17.7126 42.4295 19.1355C42.3311 19.2253 42.2307 19.3286 42.1318 19.4437C39.7131 18.562 36.892 19.087 34.9551 21.0218C33.6701 22.3052 32.9623 24.0177 32.9623 25.8439C32.9623 26.5017 33.0555 27.1441 33.233 27.7577C31.9436 28.0243 30.7609 28.6575 29.815 29.6052C28.5275 30.8874 27.8176 32.598 27.8162 34.422C27.8156 35.0814 27.9092 35.7259 28.0877 36.3411C26.7977 36.6072 25.6143 37.2392 24.6654 38.1868C23.3779 39.473 22.6689 41.1864 22.6689 43.0116C22.6689 44.4097 23.0863 45.7415 23.8598 46.8665C22.8832 47.1976 21.9887 47.7486 21.2396 48.4968C18.5814 51.1517 18.5805 55.4771 21.2414 58.1427L21.5592 58.4591L15.0104 64.996C12.5766 63.8501 9.57793 64.2794 7.56953 66.2853L4.09258 69.7525C2.85586 70.9876 2.175 72.6353 2.1748 74.3917C2.1748 76.1484 2.85586 77.7962 4.09258 79.0316L8.43184 83.3655C9.20039 84.1333 10.4459 84.1325 11.2135 83.364C11.9812 82.5954 11.9805 81.3499 11.2119 80.5823L6.87266 76.2484C6.38008 75.7564 6.10879 75.097 6.10879 74.3919C6.10879 73.687 6.38008 73.0279 6.87148 72.537L10.3486 69.0697C11.2174 68.2019 12.5471 68.0726 13.5568 68.6763C13.6279 68.7831 13.7102 68.8847 13.8043 68.979C13.9729 69.148 14.1652 69.2775 14.3695 69.3722L34.3096 89.2829C34.4043 89.4894 34.5344 89.6837 34.7041 89.8536C34.8693 90.0191 35.0578 90.147 35.2578 90.2411C35.6795 90.7179 35.9125 91.3269 35.9125 91.9765C35.9125 92.6816 35.6412 93.3408 35.1486 93.8327L31.675 97.3023C30.6486 98.3241 28.9791 98.324 27.9559 97.3054L23.6166 92.9657C22.8484 92.1976 21.6031 92.1976 20.835 92.9657C20.0668 93.7339 20.0668 94.9792 20.835 95.7474L25.1773 100.09C26.4555 101.363 28.134 101.999 29.8133 101.999C31.493 101.999 33.1734 101.362 34.4531 100.088L37.9289 96.6163C39.1656 95.381 39.8467 93.7333 39.8467 91.9765C39.8467 90.7228 39.498 89.5255 38.8498 88.4931L46.2201 81.1318C46.2279 81.1238 46.2357 81.1157 46.2437 81.1077C47.0877 80.2353 49.4379 80.3986 51.7107 80.5564C53.3256 80.6687 55.126 80.7935 56.885 80.5907L64.9561 88.6523C64.4332 89.6056 64.1541 90.6818 64.1541 91.8025C64.1541 93.5573 64.8352 95.204 66.0719 96.4394L69.5479 99.9111C70.7838 101.146 72.4313 101.826 74.1867 101.826C75.942 101.826 77.5895 101.146 78.8256 99.9111L99.9078 78.8544C101.145 77.6193 101.826 75.9716 101.826 74.215C101.825 72.4585 101.144 70.8109 99.9064 69.5745ZM47.7072 22.2015L56.2398 23.8165L51.1326 28.9218C50.3426 28.5421 49.2598 27.8339 48.0719 26.6976C46.4459 25.1421 45.2828 23.3462 45.177 22.2261C45.1768 22.2255 45.1768 22.2249 45.1768 22.2243C45.1768 22.2241 45.1766 22.2239 45.1766 22.2238C45.1689 22.1433 45.167 22.079 45.168 22.03C45.4252 21.9675 46.1084 21.8982 47.7072 22.2015ZM37.735 23.8052C38.7314 22.8097 40.2795 22.6948 41.4055 23.4573C42.0436 26.1327 44.3258 28.5575 45.3525 29.54C46.1135 30.2681 48.5551 32.4511 51.0195 33.0511C51.3529 33.529 51.5344 34.0988 51.5344 34.6999C51.5344 35.4743 51.2365 36.1984 50.6938 36.7406C50.1525 37.2827 49.4273 37.5812 48.6516 37.5812C47.8756 37.5812 47.1504 37.2827 46.6066 36.738L46.6064 36.7378L46.6055 36.7368L37.7348 27.8822C37.1939 27.3421 36.8961 26.6181 36.8961 25.8439C36.8963 25.0695 37.1941 24.3454 37.735 23.8052ZM32.5951 32.3886C33.1363 31.8466 33.8607 31.548 34.6354 31.548C35.4109 31.548 36.1377 31.8472 36.6824 32.3913L43.8254 39.52C44.9502 40.6466 44.9502 42.4798 43.8293 43.6025C43.2852 44.1445 42.5574 44.4429 41.7803 44.4429C41.0031 44.4429 40.2754 44.1445 39.7336 43.6048L39.7334 43.6046L34.3145 38.1868C34.3061 38.1784 34.2969 38.1706 34.2883 38.162L32.593 36.4675C32.049 35.9241 31.7496 35.1988 31.7502 34.4249C31.751 33.6536 32.0494 32.932 32.5951 32.3886ZM27.4455 40.9702C27.9871 40.4294 28.7131 40.1316 29.49 40.1316C30.2605 40.1316 30.9803 40.4251 31.5195 40.9566L36.9551 46.3896C37.4971 46.9294 37.7957 47.6527 37.7957 48.4261C37.7957 49.1993 37.4971 49.9226 36.9529 50.4646C36.4115 51.0052 35.6863 51.3031 34.9107 51.3031C34.134 51.3031 33.4064 51.0044 32.8643 50.4646L30.8937 48.4964C30.8934 48.4958 30.8928 48.4954 30.8924 48.495L27.4457 45.0525C26.9023 44.5097 26.6031 43.7847 26.6031 43.0113C26.6031 42.238 26.9023 41.5128 27.4455 40.9702ZM24.0197 51.28C24.5637 50.7366 25.2906 50.4374 26.0666 50.4374C26.8424 50.4374 27.5691 50.7364 28.1129 51.2794L30.0861 53.2503C30.6283 53.7902 30.9268 54.5134 30.9268 55.2868C30.9268 56.0603 30.6281 56.7833 30.082 57.3275C29.5408 57.8695 28.8156 58.1681 28.0398 58.1681C27.2639 58.1681 26.5387 57.8697 25.9936 57.3236L25.7465 57.0775C25.7432 57.0741 25.7406 57.0706 25.7375 57.0675C25.7338 57.064 25.7299 57.0609 25.7262 57.0573L24.0217 55.3595C22.8969 54.2323 22.8959 52.4025 24.0197 51.28ZM64.1045 73.6351C63.3367 72.8663 62.0912 72.8657 61.3228 73.6333L59.5728 75.3812C57.91 77.0441 54.8969 76.8347 51.983 76.6325C48.8188 76.4126 45.5467 76.1857 43.4293 78.3595L36.1842 85.5958L18.0664 67.5046L24.4781 61.1044C25.5379 61.754 26.7607 62.1023 28.0402 62.1023C29.8682 62.1023 31.5822 61.3937 32.8625 60.1111C34.1514 58.8275 34.8613 57.1144 34.8613 55.287C34.8613 55.27 34.8602 55.2532 34.8602 55.2363C34.8771 55.2365 34.8941 55.2374 34.9111 55.2374C36.7365 55.2374 38.4492 54.531 39.7313 53.2505C41.0201 51.9669 41.7301 50.2536 41.7301 48.4265C41.7301 48.4095 41.7289 48.3927 41.7289 48.3757C41.7461 48.3757 41.7633 48.3769 41.7807 48.3769C43.6055 48.3769 45.3191 47.6712 46.6098 46.3859C47.9496 45.0439 48.6123 43.2771 48.5996 41.514C48.6172 41.5142 48.6348 41.5152 48.6523 41.5152C50.4803 41.515 52.1941 40.8066 53.4764 39.522C54.7613 38.2386 55.4691 36.5261 55.4691 34.6999C55.4691 33.4228 55.1219 32.2019 54.4744 31.1443L60.0941 25.5269C60.5129 25.1099 61.0293 24.8482 61.5705 24.7402C61.6291 24.7339 61.6869 24.7245 61.7441 24.7132C62.6125 24.5935 63.5244 24.8614 64.1885 25.5228C65.3133 26.6495 65.3133 28.4827 64.1926 29.6054L62.481 31.3099C62.4754 31.3156 62.4693 31.3206 62.4637 31.3263L60.4924 33.2943C59.7236 34.0618 59.7229 35.3073 60.4906 36.0759C61.2586 36.8447 62.5039 36.8452 63.2723 36.0777L64.9906 34.3616C64.991 34.3613 64.9914 34.3609 64.9918 34.3605L65.2516 34.1017C66.3795 32.9841 68.2068 32.9864 69.3336 34.1116C69.8758 34.6515 70.1744 35.3747 70.1744 36.1482C70.1744 36.9214 69.8758 37.6447 69.3293 38.1888L67.608 39.9136C67.6078 39.9138 67.6076 39.914 67.6074 39.9144L65.6363 41.8775C64.8666 42.6441 64.8641 43.8896 65.6307 44.6591C66.3973 45.4288 67.6426 45.4312 68.4123 44.6648L70.3924 42.6927C70.9336 42.1505 71.6588 41.8521 72.4346 41.8521C73.2105 41.8521 73.9359 42.1505 74.481 42.6966C75.0232 43.2366 75.3217 43.9599 75.3217 44.7333C75.3217 45.5066 75.0232 46.2298 74.4779 46.7728L71.0463 50.2058C70.2783 50.9741 70.2785 52.2195 71.0467 52.9874C71.4309 53.3714 71.934 53.5632 72.4373 53.5632C72.9408 53.5632 73.4443 53.371 73.8283 52.9868L75.5102 51.3044C75.5197 51.2952 75.5301 51.2872 75.5396 51.2777C76.0809 50.7355 76.8061 50.437 77.5818 50.437C78.3578 50.437 79.083 50.7355 79.6262 51.2796C80.7498 52.4021 80.7488 54.2322 79.6262 55.3568L77.9162 57.0648C77.9156 57.0654 77.9148 57.0659 77.9143 57.0665C77.9137 57.0671 77.9131 57.0679 77.9125 57.0685L75.1984 59.7792C74.4299 60.547 74.4291 61.7925 75.1967 62.5611C75.5809 62.9456 76.0848 63.138 76.5885 63.138C77.0914 63.138 77.5945 62.9462 77.9785 62.5628L79.3061 61.2368L85.6687 67.5921L67.5525 85.6862L61.0615 79.203C61.5141 78.912 61.9471 78.5698 62.3535 78.1634L64.1025 76.4165C64.8715 75.6491 64.8723 74.4036 64.1045 73.6351ZM97.1275 76.071L76.0453 97.1277C75.5521 97.6202 74.892 97.8915 74.1865 97.8915C73.481 97.8915 72.8209 97.6202 72.3275 97.1275L68.8516 93.6558C68.359 93.164 68.0877 92.5058 68.0877 91.8025C68.0877 91.0993 68.359 90.4411 68.8516 89.9491L89.9338 68.8925C90.4271 68.3997 91.0871 68.1284 91.7928 68.1284C92.4982 68.1284 93.1584 68.3997 93.6529 68.8937L97.1277 72.3587C97.6203 72.8507 97.8916 73.5097 97.8916 74.2148C97.8914 74.92 97.6201 75.5792 97.1275 76.071Z"
              fill="#F5463B"
            />
            <path
              d="M25.707 13.0489C26.091 13.4321 26.5937 13.6235 27.0964 13.6235C27.6003 13.6235 28.1044 13.4309 28.4886 13.0459C29.256 12.277 29.2548 11.0317 28.4859 10.2643L21.3183 3.11096C20.5496 2.34358 19.3041 2.34456 18.5367 3.1137C17.7693 3.88264 17.7705 5.12795 18.5394 5.89534L25.707 13.0489Z"
              fill="#F5463B"
            />
            <path
              d="M76.5548 13.6234C77.0578 13.6234 77.5609 13.4316 77.9449 13.0482L85.107 5.89468C85.8755 5.1271 85.8763 3.88159 85.1085 3.11304C84.341 2.34448 83.0957 2.3437 82.3269 3.11147L75.1648 10.265C74.3962 11.0326 74.3955 12.2781 75.1632 13.0466C75.5474 13.4312 76.0511 13.6234 76.5548 13.6234Z"
              fill="#F5463B"
            />
            <path
              d="M14.2694 86.6105C13.5078 87.3851 13.5184 88.6306 14.2932 89.3921L14.2989 89.3976C14.6811 89.7734 15.1774 89.9605 15.6735 89.9605C16.1826 89.9605 16.6918 89.7634 17.0776 89.371C17.8391 88.5964 17.8256 87.3482 17.051 86.5867C16.2766 85.8251 15.0313 85.8359 14.2694 86.6105Z"
              fill="#F5463B"
            />
            <path
              d="M68.9153 70.8026C69.2146 70.8026 69.5181 70.7344 69.803 70.5909C70.773 70.1016 71.1626 68.9188 70.6735 67.9489C70.1843 66.9789 69.0013 66.5891 68.0316 67.0784L68.0206 67.0838C67.0507 67.5731 66.6665 68.7532 67.1556 69.7231C67.5009 70.4082 68.1954 70.8026 68.9153 70.8026Z"
              fill="#F5463B"
            />
          </g>
          <defs>
            <clipPath id="clip0_836_1969">
              <rect width="100" height="100" fill="white" />
            </clipPath>
            <clipPath id="clip1_836_1969">
              <rect
                width="100"
                height="100"
                fill="white"
                transform="translate(2 2)"
              />
            </clipPath>
          </defs>
        </svg>
      )

      break
    case "dt-date":
      iconElement = (
        <svg
          width="80"
          height="80"
          viewBox="0 0 102 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M75.3656 50.5117C71.2715 50.5117 67.4039 51.8465 64.1811 54.3717C63.5451 54.8699 63.4336 55.7893 63.9318 56.4248C64.4299 57.0605 65.3496 57.1723 65.9852 56.674C68.6883 54.5561 71.932 53.4365 75.3656 53.4365C83.7621 53.4365 90.5932 60.2676 90.5932 68.6641C90.5932 77.0605 83.7621 83.8916 75.3656 83.8916C66.9691 83.8916 60.1381 77.0605 60.1381 68.6641C60.1381 65.7928 60.9447 62.9934 62.4709 60.5682C62.9012 59.8848 62.6955 58.9818 62.0121 58.5516C61.3285 58.1213 60.4254 58.327 59.9953 59.0104C58.1752 61.9027 57.2129 65.241 57.2129 68.6641C57.2129 78.6734 65.3561 86.8168 75.3656 86.8168C85.3752 86.8168 93.5184 78.6736 93.5184 68.6641C93.5184 58.6551 85.3752 50.5117 75.3656 50.5117Z"
            fill="#01CBFD"
          />
          <path
            d="M86.8356 69.3838H76.8273V59.3756C76.8273 58.568 76.1725 57.9131 75.3648 57.9131C74.5572 57.9131 73.9023 58.568 73.9023 59.3756V70.8465C73.9023 71.6541 74.5572 72.309 75.3648 72.309H86.8356C87.6432 72.309 88.2981 71.6541 88.2981 70.8465C88.2981 70.0389 87.6432 69.3838 86.8356 69.3838Z"
            fill="#01CBFD"
          />
          <path
            d="M89.3631 48.407V23.0377C89.3631 19.2256 86.2615 16.124 82.4492 16.124H79.3103V12.5246C79.3103 9.31348 76.698 6.70117 73.4869 6.70117C70.2758 6.70117 67.6635 9.31348 67.6635 12.5246V16.1238H60.107V12.5246C60.107 9.31348 57.4947 6.70117 54.2836 6.70117C51.0725 6.70117 48.4602 9.31348 48.4602 12.5246V16.1238H40.9037V12.5246C40.9037 9.31348 38.2914 6.70117 35.0803 6.70117C31.8691 6.70117 29.2568 9.31348 29.2568 12.5246V16.1238H21.7004V12.5246C21.7004 9.31348 19.0881 6.70117 15.877 6.70117C12.6658 6.70117 10.0529 9.31348 10.0529 12.5246V16.1238H6.91367C3.10156 16.1238 0 19.2252 0 23.0377V23.7592C0 24.5668 0.654883 25.2217 1.4625 25.2217C2.27012 25.2217 2.925 24.5668 2.925 23.7592V23.0377C2.925 20.8385 4.71445 19.049 6.91367 19.049H10.0525C10.0525 19.049 10.0525 22.648 10.0525 22.6482C10.0525 25.8594 12.6648 28.4717 15.876 28.4717C19.0871 28.4717 21.6994 25.8594 21.6994 22.648V19.049H29.2559C29.2559 19.049 29.2559 22.648 29.2559 22.6482C29.2559 25.8594 31.8682 28.4717 35.0793 28.4717C38.2904 28.4717 40.9027 25.8594 40.9027 22.648V19.049H48.4592C48.4592 19.049 48.4592 22.648 48.4592 22.6482C48.4592 25.8594 51.0715 28.4717 54.2826 28.4717C57.4938 28.4717 60.1061 25.8594 60.1061 22.648V19.049H67.6625C67.6625 19.049 67.6625 22.648 67.6625 22.6482C67.6625 25.8594 70.2748 28.4717 73.4859 28.4717C76.6971 28.4717 79.3094 25.8594 79.3094 22.648V19.049H82.4482C84.6477 19.049 86.4371 20.8385 86.4371 23.0377V33.36H2.925V29.6092C2.925 28.8016 2.27012 28.1467 1.4625 28.1467C0.654883 28.1467 0 28.8014 0 29.6092V80.0822C0 83.8945 3.10156 86.9961 6.91367 86.9961H58.9244C63.2881 90.9141 69.0525 93.3016 75.365 93.3016C80.6359 93.3016 85.6643 91.659 89.9068 88.5516C90.5586 88.0742 90.6998 87.159 90.2225 86.5074C89.7451 85.8557 88.8297 85.7147 88.1783 86.1918C84.4406 88.9295 80.01 90.3764 75.3648 90.3764C63.3939 90.3764 53.6551 80.6373 53.6551 68.6666C53.6551 56.6959 63.3941 46.9568 75.3648 46.9568C77.5309 46.9568 79.6881 47.2809 81.7586 47.918C81.7996 47.9305 81.84 47.9436 81.8811 47.9564C90.6779 50.7305 97.0748 58.965 97.0748 68.6666C97.0748 73.6719 95.3301 78.5562 92.1623 82.4203C91.6502 83.0449 91.7412 83.9666 92.3658 84.4785C92.9906 84.9906 93.9121 84.8994 94.424 84.275C98.0197 79.8896 100 74.3465 100 68.6666C100 60.2789 95.785 52.8578 89.3631 48.407ZM18.7744 22.648C18.7744 24.2463 17.4742 25.5465 15.876 25.5465C14.2777 25.5465 12.9775 24.2465 12.9775 22.648V12.5246C12.9775 10.9264 14.2775 9.62617 15.876 9.62617C17.4742 9.62617 18.7744 10.9262 18.7744 12.5246V22.648ZM37.9779 22.648C37.9779 24.2463 36.6777 25.5465 35.0795 25.5465C33.4813 25.5465 32.1811 24.2465 32.1811 22.648V12.5246C32.1811 10.9264 33.4813 9.62617 35.0795 9.62617C36.6777 9.62617 37.9779 10.9262 37.9779 12.5246V22.648ZM57.1816 22.648C57.1816 24.2463 55.8814 25.5465 54.2832 25.5465C52.685 25.5465 51.3848 24.2465 51.3848 22.648V12.5246C51.3848 10.9264 52.685 9.62617 54.2832 9.62617C55.8814 9.62617 57.1816 10.9262 57.1816 12.5246V22.648ZM76.3852 22.648C76.3852 24.2463 75.085 25.5465 73.4867 25.5465C71.8885 25.5465 70.5883 24.2465 70.5883 22.648V12.5246C70.5883 10.9264 71.8885 9.62617 73.4867 9.62617C75.085 9.62617 76.3852 10.9262 76.3852 12.5246V22.648ZM37.5002 36.285H51.8627V50.2635H37.5002V36.285ZM17.2875 84.0709H6.91367C4.71445 84.0709 2.925 82.2814 2.925 80.082V70.0922H17.2873L17.2875 84.0709ZM17.2875 67.1672H2.925V53.1887H17.2873L17.2875 67.1672ZM17.2875 50.2635H2.925V36.285H17.2873L17.2875 50.2635ZM20.2125 53.1887H34.5748V67.1672H20.2125V53.1887ZM34.5752 84.0709H20.2129V70.0924H34.5752V84.0709ZM34.5752 50.2635H20.2129V36.285H34.5752V50.2635ZM37.5 53.1887H51.8625V61.2785C51.2715 63.1551 50.9002 65.1283 50.7771 67.1674H37.5V53.1887ZM56.1338 84.0709H37.5002V70.0924H50.7713C51.0611 75.2549 52.9221 80.0867 56.1338 84.0709ZM54.7879 55.1387V53.1887H56.2156C55.709 53.8143 55.2324 54.465 54.7879 55.1387ZM69.1502 44.8266C65.3316 45.8227 61.8719 47.715 59.0078 50.2635H54.7879V36.285H69.1502V44.8266ZM86.4379 46.6557C85.0605 45.9617 83.6238 45.4035 82.1467 44.9812C82.1152 44.9723 82.0836 44.9633 82.0523 44.9543C79.8799 44.3406 77.6228 44.0314 75.3654 44.0314C74.2498 44.0316 73.152 44.1074 72.0754 44.2518V36.2846H86.4379V46.6557Z"
            fill="#01CBFD"
          />
          <path
            d="M77.1527 52C73.0586 52 69.191 53.3348 65.9682 55.86C65.3322 56.3582 65.2207 57.2775 65.7189 57.9131C66.217 58.5488 67.1367 58.6605 67.7723 58.1623C70.4754 56.0443 73.7191 54.9248 77.1527 54.9248C85.5492 54.9248 92.3803 61.7559 92.3803 70.1523C92.3803 78.5488 85.5492 85.3799 77.1527 85.3799C68.7562 85.3799 61.9252 78.5488 61.9252 70.1523C61.9252 67.2811 62.7318 64.4816 64.258 62.0564C64.6883 61.373 64.4826 60.4701 63.7992 60.0398C63.1156 59.6096 62.2125 59.8152 61.7824 60.4986C59.9623 63.391 59 66.7293 59 70.1523C59 80.1617 67.1432 88.3051 77.1527 88.3051C87.1623 88.3051 95.3055 80.1619 95.3055 70.1523C95.3055 60.1434 87.1623 52 77.1527 52Z"
            fill="#F5463B"
          />
          <path
            d="M88.6227 70.8721H78.6145V60.8639C78.6145 60.0563 77.9596 59.4014 77.152 59.4014C76.3443 59.4014 75.6895 60.0563 75.6895 60.8639V72.3348C75.6895 73.1424 76.3443 73.7973 77.152 73.7973H88.6227C89.4303 73.7973 90.0852 73.1424 90.0852 72.3348C90.0852 71.5272 89.4303 70.8721 88.6227 70.8721Z"
            fill="#F5463B"
          />
          <path
            d="M91.3631 49.7059V24.3365C91.3631 20.5244 88.2615 17.4229 84.4492 17.4229H81.3103V13.8234C81.3103 10.6123 78.698 8 75.4869 8C72.2758 8 69.6635 10.6123 69.6635 13.8234V17.4227H62.107V13.8234C62.107 10.6123 59.4947 8 56.2836 8C53.0725 8 50.4602 10.6123 50.4602 13.8234V17.4227H42.9037V13.8234C42.9037 10.6123 40.2914 8 37.0803 8C33.8691 8 31.2568 10.6123 31.2568 13.8234V17.4227H23.7004V13.8234C23.7004 10.6123 21.0881 8 17.877 8C14.6658 8 12.0529 10.6123 12.0529 13.8234V17.4227H8.91367C5.10156 17.4227 2 20.524 2 24.3365V25.058C2 25.8656 2.65488 26.5205 3.4625 26.5205C4.27012 26.5205 4.925 25.8656 4.925 25.058V24.3365C4.925 22.1373 6.71445 20.3479 8.91367 20.3479H12.0525C12.0525 20.3479 12.0525 23.9469 12.0525 23.9471C12.0525 27.1582 14.6648 29.7705 17.876 29.7705C21.0871 29.7705 23.6994 27.1582 23.6994 23.9469V20.3479H31.2559C31.2559 20.3479 31.2559 23.9469 31.2559 23.9471C31.2559 27.1582 33.8682 29.7705 37.0793 29.7705C40.2904 29.7705 42.9027 27.1582 42.9027 23.9469V20.3479H50.4592C50.4592 20.3479 50.4592 23.9469 50.4592 23.9471C50.4592 27.1582 53.0715 29.7705 56.2826 29.7705C59.4938 29.7705 62.1061 27.1582 62.1061 23.9469V20.3479H69.6625C69.6625 20.3479 69.6625 23.9469 69.6625 23.9471C69.6625 27.1582 72.2748 29.7705 75.4859 29.7705C78.6971 29.7705 81.3094 27.1582 81.3094 23.9469V20.3479H84.4482C86.6477 20.3479 88.4371 22.1373 88.4371 24.3365V34.6588H4.925V30.908C4.925 30.1004 4.27012 29.4455 3.4625 29.4455C2.65488 29.4455 2 30.1002 2 30.908V81.3811C2 85.1934 5.10156 88.2949 8.91367 88.2949H60.9244C65.2881 92.2129 71.0525 94.6004 77.365 94.6004C82.6359 94.6004 87.6643 92.9578 91.9068 89.8504C92.5586 89.373 92.6998 88.4578 92.2225 87.8063C91.7451 87.1545 90.8297 87.0135 90.1783 87.4906C86.4406 90.2283 82.01 91.6752 77.3648 91.6752C65.3939 91.6752 55.6551 81.9361 55.6551 69.9654C55.6551 57.9947 65.3941 48.2557 77.3648 48.2557C79.5309 48.2557 81.6881 48.5797 83.7586 49.2168C83.7996 49.2293 83.84 49.2424 83.8811 49.2553C92.6779 52.0293 99.0748 60.2639 99.0748 69.9654C99.0748 74.9707 97.3301 79.8551 94.1623 83.7191C93.6502 84.3437 93.7412 85.2654 94.3658 85.7773C94.9906 86.2895 95.9121 86.1982 96.424 85.5738C100.02 81.1885 102 75.6453 102 69.9654C102 61.5777 97.785 54.1566 91.3631 49.7059ZM20.7744 23.9469C20.7744 25.5451 19.4742 26.8453 17.876 26.8453C16.2777 26.8453 14.9775 25.5453 14.9775 23.9469V13.8234C14.9775 12.2252 16.2775 10.925 17.876 10.925C19.4742 10.925 20.7744 12.225 20.7744 13.8234V23.9469ZM39.9779 23.9469C39.9779 25.5451 38.6777 26.8453 37.0795 26.8453C35.4813 26.8453 34.1811 25.5453 34.1811 23.9469V13.8234C34.1811 12.2252 35.4813 10.925 37.0795 10.925C38.6777 10.925 39.9779 12.225 39.9779 13.8234V23.9469ZM59.1816 23.9469C59.1816 25.5451 57.8814 26.8453 56.2832 26.8453C54.685 26.8453 53.3848 25.5453 53.3848 23.9469V13.8234C53.3848 12.2252 54.685 10.925 56.2832 10.925C57.8814 10.925 59.1816 12.225 59.1816 13.8234V23.9469ZM78.3852 23.9469C78.3852 25.5451 77.085 26.8453 75.4867 26.8453C73.8885 26.8453 72.5883 25.5453 72.5883 23.9469V13.8234C72.5883 12.2252 73.8885 10.925 75.4867 10.925C77.085 10.925 78.3852 12.225 78.3852 13.8234V23.9469ZM39.5002 37.5838H53.8627V51.5623H39.5002V37.5838ZM19.2875 85.3697H8.91367C6.71445 85.3697 4.925 83.5803 4.925 81.3809V71.391H19.2873L19.2875 85.3697ZM19.2875 68.466H4.925V54.4875H19.2873L19.2875 68.466ZM19.2875 51.5623H4.925V37.5838H19.2873L19.2875 51.5623ZM22.2125 54.4875H36.5748V68.466H22.2125V54.4875ZM36.5752 85.3697H22.2129V71.3912H36.5752V85.3697ZM36.5752 51.5623H22.2129V37.5838H36.5752V51.5623ZM39.5 54.4875H53.8625V62.5773C53.2715 64.4539 52.9002 66.4272 52.7771 68.4662H39.5V54.4875ZM58.1338 85.3697H39.5002V71.3912H52.7713C53.0611 76.5537 54.9221 81.3855 58.1338 85.3697ZM56.7879 56.4375V54.4875H58.2156C57.709 55.1131 57.2324 55.7639 56.7879 56.4375ZM71.1502 46.1254C67.3316 47.1215 63.8719 49.0139 61.0078 51.5623H56.7879V37.5838H71.1502V46.1254ZM88.4379 47.9545C87.0605 47.2605 85.6238 46.7023 84.1467 46.2801C84.1152 46.2711 84.0836 46.2621 84.0523 46.2531C81.8799 45.6395 79.6228 45.3303 77.3654 45.3303C76.2498 45.3305 75.152 45.4062 74.0754 45.5506V37.5834H88.4379V47.9545Z"
            fill="#F5463B"
          />
        </svg>
      )

      break
    case "dt-people":
      iconElement = (
        <svg
          width="80"
          height="80"
          viewBox="0 0 102 102"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_836_1872)">
            <path
              d="M66.6106 41.7595C68.2768 40.1102 69.311 37.8239 69.311 35.2999C69.311 30.2865 65.2315 26.208 60.2172 26.208C56.3533 26.208 52.9287 28.6574 51.65 32.2467C51.114 32.1479 50.5626 32.0936 49.9984 32.0936C49.4341 32.0936 48.8829 32.1479 48.3468 32.2467C47.0681 28.6572 43.6433 26.208 39.7796 26.208C34.7653 26.208 30.6858 30.2865 30.6858 35.2999C30.6858 37.8239 31.7201 40.1102 33.3864 41.7595C29.3895 44.0362 26.8164 48.3476 26.8164 53.0365C26.8164 53.8457 27.4723 54.5013 28.2813 54.5013C29.0902 54.5013 29.7461 53.8457 29.7461 53.0365C29.7461 48.8952 32.3389 45.1347 36.2034 43.6599C37.3018 44.1315 38.5106 44.3937 39.7798 44.3937C40.3387 44.3937 40.8923 44.3398 41.4341 44.2398C41.8972 45.5349 42.6452 46.695 43.6034 47.6443C39.5702 49.9279 37.0356 54.2074 37.0356 58.9227C37.0356 59.7318 37.6915 60.3875 38.5005 60.3875C39.3094 60.3875 39.9653 59.7318 39.9653 58.9227C39.9653 54.881 42.3708 51.2519 46.0935 49.6773C46.1931 49.6351 46.2851 49.5826 46.3698 49.5226C47.4822 50.0087 48.7089 50.2802 49.9984 50.2802C51.2679 50.2802 52.4769 50.0179 53.5754 49.546C57.4381 51.0208 60.0314 54.7853 60.0314 58.9227C60.0314 59.7318 60.6873 60.3875 61.4963 60.3875C62.3053 60.3875 62.9612 59.7318 62.9612 58.9227C62.9612 54.2381 60.3875 49.9232 56.3918 47.6456C57.3508 46.6962 58.0994 45.5355 58.5627 44.2398C59.1047 44.3398 59.658 44.3937 60.217 44.3937C61.4861 44.3937 62.6949 44.1315 63.7932 43.6599C67.6577 45.1347 70.2504 48.8949 70.2504 53.0365C70.2504 53.8457 70.9063 54.5013 71.7153 54.5013C72.5243 54.5013 73.1802 53.8457 73.1802 53.0365C73.1805 48.3474 70.6075 44.0362 66.6106 41.7595ZM40.9054 41.187C40.9054 41.2446 40.9087 41.3013 40.9097 41.3585C40.5407 41.4272 40.1628 41.464 39.7798 41.464C36.3809 41.464 33.6157 38.6989 33.6157 35.2999C33.6157 31.9022 36.3809 29.1377 39.7798 29.1377C42.402 29.1377 44.7249 30.8016 45.5894 33.2379C42.7983 34.7922 40.9054 37.7721 40.9054 41.187ZM43.8351 41.187C43.8351 37.7885 46.5999 35.0235 49.9986 35.0235C53.3972 35.0235 56.1621 37.7884 56.1621 41.187C56.1621 44.5857 53.3972 47.3505 49.9986 47.3505C46.5999 47.3505 43.8351 44.5855 43.8351 41.187ZM59.0873 41.3585C59.0883 41.3013 59.0916 41.2444 59.0916 41.187C59.0916 37.7721 57.1986 34.7924 54.4076 33.2381C55.272 30.8018 57.5949 29.1379 60.2172 29.1379C63.616 29.1379 66.3813 31.9022 66.3813 35.3001C66.3813 38.6989 63.616 41.4642 60.2172 41.4642C59.8342 41.464 59.4562 41.4272 59.0873 41.3585Z"
              fill="#01CBFD"
            />
            <path
              d="M87.9349 63.3084V36.6819C91.5862 35.9928 94.3573 32.7811 94.3573 28.9324C94.3573 24.5828 90.8189 21.0443 86.4692 21.0443C84.0788 21.0443 81.9348 22.1146 80.4871 23.7994L57.4427 10.4936C57.7292 9.6774 57.887 8.80083 57.887 7.88774C57.887 3.5385 54.3485 0 49.9991 0C45.6496 0 42.111 3.5385 42.111 7.88794C42.111 8.80103 42.2686 9.6774 42.5553 10.4938L19.5108 23.7994C18.0632 22.1146 15.9192 21.0443 13.5288 21.0443C9.17912 21.0443 5.64062 24.5828 5.64062 28.9324C5.64062 32.7811 8.41174 35.9926 12.0631 36.6819V63.3084C8.41174 63.9974 5.64062 67.2092 5.64062 71.0578C5.64062 75.4075 9.17912 78.946 13.5288 78.946C15.9155 78.946 18.0563 77.879 19.504 76.1989L42.5551 89.507C42.2686 90.323 42.111 91.1994 42.111 92.1121C42.111 96.4617 45.6495 100 49.9991 100C54.3487 100 57.8872 96.4617 57.8872 92.1121C57.8872 91.1994 57.7296 90.323 57.4431 89.507L80.4942 76.1989C81.9418 77.8792 84.0827 78.946 86.4694 78.946C90.819 78.946 94.3575 75.4075 94.3575 71.0578C94.3574 67.209 91.586 63.9974 87.9349 63.3084ZM86.4692 23.974C89.2032 23.974 91.4276 26.1984 91.4276 28.9324C91.4276 31.6664 89.2032 33.8908 86.4692 33.8908C83.7352 33.8908 81.5108 31.6664 81.5108 28.9324C81.5108 26.1984 83.7352 23.974 86.4692 23.974ZM49.9991 2.9297C52.7331 2.9297 54.9575 5.15394 54.9575 7.88794C54.9575 10.6194 52.7372 12.8421 50.0067 12.8462C50.0042 12.8462 50.0016 12.8458 49.9991 12.8458C49.9965 12.8458 49.994 12.8462 49.9915 12.8462C47.261 12.8421 45.0407 10.6194 45.0407 7.88794C45.0407 5.15394 47.2649 2.9297 49.9991 2.9297ZM8.57033 28.9324C8.57033 26.1984 10.7948 23.974 13.5288 23.974C16.2628 23.974 18.4872 26.1984 18.4872 28.9324C18.4872 31.6664 16.2628 33.8908 13.5288 33.8908C10.7948 33.8908 8.57033 31.6664 8.57033 28.9324ZM13.5288 76.0161C10.7948 76.0161 8.57033 73.7916 8.57033 71.0576C8.57033 68.3236 10.7948 66.0992 13.5288 66.0992C16.2628 66.0992 18.4872 68.3236 18.4872 71.0576C18.4872 73.7916 16.2628 76.0161 13.5288 76.0161ZM49.9991 97.0703C47.2651 97.0703 45.0407 94.8459 45.0407 92.1119C45.0407 89.3779 47.2651 87.1534 49.9991 87.1534C52.7331 87.1534 54.9575 89.3779 54.9575 92.1119C54.9575 94.8459 52.7331 97.0703 49.9991 97.0703ZM55.9747 86.9716C54.8307 85.6435 53.2536 84.6999 51.4637 84.3624V78.719C51.4637 77.9098 50.8079 77.2542 49.9989 77.2542C49.1899 77.2542 48.534 77.9098 48.534 78.719V84.3624C46.7444 84.7001 45.1672 85.6435 44.0231 86.9716L20.9724 73.6637C21.2591 72.8473 21.4167 71.9709 21.4167 71.0578C21.4167 70.144 21.2587 69.2666 20.9716 68.4496L25.8603 65.6264C26.5609 65.2217 26.8007 64.3258 26.3962 63.6252C25.9917 62.9246 25.0958 62.6849 24.395 63.0892L19.502 65.915C18.3581 64.5881 16.7815 63.6455 14.9926 63.3082V36.6821C16.7821 36.3447 18.3591 35.4016 19.503 34.074L24.4026 36.9035C24.6333 37.0367 24.8853 37.1 25.1339 37.1C25.64 37.1 26.1323 36.8373 26.4036 36.3676C26.8083 35.667 26.5683 34.7709 25.8677 34.3664L20.9718 31.5391C21.2585 30.7224 21.4163 29.8457 21.4163 28.9324C21.4163 28.023 21.2599 27.15 20.9753 26.3365L44.0231 13.0288C45.167 14.3565 46.744 15.2999 48.5335 15.6374V21.2814C48.5335 22.0906 49.1893 22.7462 49.9983 22.7462C50.8073 22.7462 51.4632 22.0906 51.4632 21.2814V15.6374C53.2526 15.2999 54.8296 14.3565 55.9735 13.0288L79.0213 26.3365C78.7369 27.15 78.5803 28.023 78.5803 28.9324C78.5803 29.8457 78.7381 30.7224 79.0248 31.5391L74.1289 34.3664C73.4283 34.7709 73.1883 35.667 73.593 36.3676C73.8643 36.8373 74.3566 37.1 74.8627 37.1C75.1111 37.1 75.3633 37.0367 75.594 36.9035L80.4936 34.074C81.6377 35.4016 83.2147 36.3447 85.004 36.6821V63.3082C83.2151 63.6455 81.6387 64.5881 80.4946 65.915L75.6016 63.0892C74.901 62.6853 74.0051 62.9246 73.6004 63.6252C73.1957 64.3258 73.4357 65.2217 74.1363 65.6264L79.025 68.4496C78.7379 69.2666 78.5799 70.144 78.5799 71.0578C78.5799 71.9709 78.7375 72.8475 79.0243 73.6637L55.9747 86.9716ZM86.4692 76.0161C83.7352 76.0161 81.5108 73.7916 81.5108 71.0576C81.5108 68.3236 83.7352 66.0992 86.4692 66.0992C89.2032 66.0992 91.4276 68.3236 91.4276 71.0576C91.4276 73.7916 89.2032 76.0161 86.4692 76.0161Z"
              fill="#01CBFD"
            />
            <path
              d="M62.2685 65.1357H57.9092C57.1002 65.1357 56.4443 65.7914 56.4443 66.6006C56.4443 67.4098 57.1002 68.0654 57.9092 68.0654H62.2685C63.0775 68.0654 63.7334 67.4098 63.7334 66.6006C63.7334 65.7914 63.0775 65.1357 62.2685 65.1357Z"
              fill="#01CBFD"
            />
            <path
              d="M62.268 70.8721H37.7295C36.9205 70.8721 36.2646 71.5277 36.2646 72.3369C36.2646 73.1461 36.9205 73.8018 37.7295 73.8018H62.2682C63.0771 73.8018 63.733 73.1461 63.733 72.3369C63.733 71.5277 63.077 70.8721 62.268 70.8721Z"
              fill="#01CBFD"
            />
            <path
              d="M37.7295 68.0654H37.7498C38.5588 68.0654 39.2146 67.4098 39.2146 66.6006C39.2146 65.7914 38.5588 65.1357 37.7498 65.1357H37.7295C36.9205 65.1357 36.2646 65.7914 36.2646 66.6006C36.2646 67.4098 36.9205 68.0654 37.7295 68.0654Z"
              fill="#01CBFD"
            />
            <path
              d="M42.824 68.0654C43.633 68.0654 44.2889 67.4098 44.2889 66.6006C44.2889 65.7914 43.633 65.1357 42.824 65.1357H42.8037C41.9947 65.1357 41.3389 65.7914 41.3389 66.6006C41.3389 67.4098 41.9947 68.0654 42.8037 68.0654H42.824Z"
              fill="#01CBFD"
            />
            <path
              d="M47.8982 68.0654C48.7072 68.0654 49.3631 67.4098 49.3631 66.6006C49.3631 65.7914 48.7072 65.1357 47.8982 65.1357H47.8779C47.0689 65.1357 46.4131 65.7914 46.4131 66.6006C46.4131 67.4098 47.0689 68.0654 47.8779 68.0654H47.8982Z"
              fill="#01CBFD"
            />
          </g>
          <g clip-path="url(#clip1_836_1872)">
            <path
              d="M68.6106 43.7595C70.2768 42.1102 71.311 39.8239 71.311 37.2999C71.311 32.2865 67.2315 28.208 62.2172 28.208C58.3533 28.208 54.9287 30.6574 53.65 34.2467C53.114 34.1479 52.5626 34.0936 51.9984 34.0936C51.4341 34.0936 50.8829 34.1479 50.3468 34.2467C49.0681 30.6572 45.6433 28.208 41.7796 28.208C36.7653 28.208 32.6858 32.2865 32.6858 37.2999C32.6858 39.8239 33.7201 42.1102 35.3864 43.7595C31.3895 46.0362 28.8164 50.3476 28.8164 55.0365C28.8164 55.8457 29.4723 56.5013 30.2813 56.5013C31.0902 56.5013 31.7461 55.8457 31.7461 55.0365C31.7461 50.8952 34.3389 47.1347 38.2034 45.6599C39.3018 46.1315 40.5106 46.3937 41.7798 46.3937C42.3387 46.3937 42.8923 46.3398 43.4341 46.2398C43.8972 47.5349 44.6452 48.695 45.6034 49.6443C41.5702 51.9279 39.0356 56.2074 39.0356 60.9227C39.0356 61.7318 39.6915 62.3875 40.5005 62.3875C41.3094 62.3875 41.9653 61.7318 41.9653 60.9227C41.9653 56.881 44.3708 53.2519 48.0935 51.6773C48.1931 51.6351 48.2851 51.5826 48.3698 51.5226C49.4822 52.0087 50.7089 52.2802 51.9984 52.2802C53.2679 52.2802 54.4769 52.0179 55.5754 51.546C59.4381 53.0208 62.0314 56.7853 62.0314 60.9227C62.0314 61.7318 62.6873 62.3875 63.4963 62.3875C64.3053 62.3875 64.9612 61.7318 64.9612 60.9227C64.9612 56.2381 62.3875 51.9232 58.3918 49.6456C59.3508 48.6962 60.0994 47.5355 60.5627 46.2398C61.1047 46.3398 61.658 46.3937 62.217 46.3937C63.4861 46.3937 64.6949 46.1315 65.7932 45.6599C69.6577 47.1347 72.2504 50.8949 72.2504 55.0365C72.2504 55.8457 72.9063 56.5013 73.7153 56.5013C74.5243 56.5013 75.1802 55.8457 75.1802 55.0365C75.1805 50.3474 72.6075 46.0362 68.6106 43.7595ZM42.9054 43.187C42.9054 43.2446 42.9087 43.3013 42.9097 43.3585C42.5407 43.4272 42.1628 43.464 41.7798 43.464C38.3809 43.464 35.6157 40.6989 35.6157 37.2999C35.6157 33.9022 38.3809 31.1377 41.7798 31.1377C44.402 31.1377 46.7249 32.8016 47.5894 35.2379C44.7983 36.7922 42.9054 39.7721 42.9054 43.187ZM45.8351 43.187C45.8351 39.7885 48.5999 37.0235 51.9986 37.0235C55.3972 37.0235 58.1621 39.7884 58.1621 43.187C58.1621 46.5857 55.3972 49.3505 51.9986 49.3505C48.5999 49.3505 45.8351 46.5855 45.8351 43.187ZM61.0873 43.3585C61.0883 43.3013 61.0916 43.2444 61.0916 43.187C61.0916 39.7721 59.1986 36.7924 56.4076 35.2381C57.272 32.8018 59.5949 31.1379 62.2172 31.1379C65.616 31.1379 68.3813 33.9022 68.3813 37.3001C68.3813 40.6989 65.616 43.4642 62.2172 43.4642C61.8342 43.464 61.4562 43.4272 61.0873 43.3585Z"
              fill="#F5463B"
            />
            <path
              d="M89.9349 65.3084V38.6819C93.5862 37.9928 96.3573 34.7811 96.3573 30.9324C96.3573 26.5828 92.8189 23.0443 88.4692 23.0443C86.0788 23.0443 83.9348 24.1146 82.4871 25.7994L59.4427 12.4936C59.7292 11.6774 59.887 10.8008 59.887 9.88774C59.887 5.5385 56.3485 2 51.9991 2C47.6496 2 44.111 5.5385 44.111 9.88794C44.111 10.801 44.2686 11.6774 44.5553 12.4938L21.5108 25.7994C20.0632 24.1146 17.9192 23.0443 15.5288 23.0443C11.1791 23.0443 7.64062 26.5828 7.64062 30.9324C7.64062 34.7811 10.4117 37.9926 14.0631 38.6819V65.3084C10.4117 65.9974 7.64062 69.2092 7.64062 73.0578C7.64062 77.4075 11.1791 80.946 15.5288 80.946C17.9155 80.946 20.0563 79.879 21.504 78.1989L44.5551 91.507C44.2686 92.323 44.111 93.1994 44.111 94.1121C44.111 98.4617 47.6495 102 51.9991 102C56.3487 102 59.8872 98.4617 59.8872 94.1121C59.8872 93.1994 59.7296 92.323 59.4431 91.507L82.4942 78.1989C83.9418 79.8792 86.0827 80.946 88.4694 80.946C92.819 80.946 96.3575 77.4075 96.3575 73.0578C96.3574 69.209 93.586 65.9974 89.9349 65.3084ZM88.4692 25.974C91.2032 25.974 93.4276 28.1984 93.4276 30.9324C93.4276 33.6664 91.2032 35.8908 88.4692 35.8908C85.7352 35.8908 83.5108 33.6664 83.5108 30.9324C83.5108 28.1984 85.7352 25.974 88.4692 25.974ZM51.9991 4.9297C54.7331 4.9297 56.9575 7.15394 56.9575 9.88794C56.9575 12.6194 54.7372 14.8421 52.0067 14.8462C52.0042 14.8462 52.0016 14.8458 51.9991 14.8458C51.9965 14.8458 51.994 14.8462 51.9915 14.8462C49.261 14.8421 47.0407 12.6194 47.0407 9.88794C47.0407 7.15394 49.2649 4.9297 51.9991 4.9297ZM10.5703 30.9324C10.5703 28.1984 12.7948 25.974 15.5288 25.974C18.2628 25.974 20.4872 28.1984 20.4872 30.9324C20.4872 33.6664 18.2628 35.8908 15.5288 35.8908C12.7948 35.8908 10.5703 33.6664 10.5703 30.9324ZM15.5288 78.0161C12.7948 78.0161 10.5703 75.7916 10.5703 73.0576C10.5703 70.3236 12.7948 68.0992 15.5288 68.0992C18.2628 68.0992 20.4872 70.3236 20.4872 73.0576C20.4872 75.7916 18.2628 78.0161 15.5288 78.0161ZM51.9991 99.0703C49.2651 99.0703 47.0407 96.8459 47.0407 94.1119C47.0407 91.3779 49.2651 89.1534 51.9991 89.1534C54.7331 89.1534 56.9575 91.3779 56.9575 94.1119C56.9575 96.8459 54.7331 99.0703 51.9991 99.0703ZM57.9747 88.9716C56.8307 87.6435 55.2536 86.6999 53.4637 86.3624V80.719C53.4637 79.9098 52.8079 79.2542 51.9989 79.2542C51.1899 79.2542 50.534 79.9098 50.534 80.719V86.3624C48.7444 86.7001 47.1672 87.6435 46.0231 88.9716L22.9724 75.6637C23.2591 74.8473 23.4167 73.9709 23.4167 73.0578C23.4167 72.144 23.2587 71.2666 22.9716 70.4496L27.8603 67.6264C28.5609 67.2217 28.8007 66.3258 28.3962 65.6252C27.9917 64.9246 27.0958 64.6849 26.395 65.0892L21.502 67.915C20.3581 66.5881 18.7815 65.6455 16.9926 65.3082V38.6821C18.7821 38.3447 20.3591 37.4016 21.503 36.074L26.4026 38.9035C26.6333 39.0367 26.8853 39.1 27.1339 39.1C27.64 39.1 28.1323 38.8373 28.4036 38.3676C28.8083 37.667 28.5683 36.7709 27.8677 36.3664L22.9718 33.5391C23.2585 32.7224 23.4163 31.8457 23.4163 30.9324C23.4163 30.023 23.2599 29.15 22.9753 28.3365L46.0231 15.0288C47.167 16.3565 48.744 17.2999 50.5335 17.6374V23.2814C50.5335 24.0906 51.1893 24.7462 51.9983 24.7462C52.8073 24.7462 53.4632 24.0906 53.4632 23.2814V17.6374C55.2526 17.2999 56.8296 16.3565 57.9735 15.0288L81.0213 28.3365C80.7369 29.15 80.5803 30.023 80.5803 30.9324C80.5803 31.8457 80.7381 32.7224 81.0248 33.5391L76.1289 36.3664C75.4283 36.7709 75.1883 37.667 75.593 38.3676C75.8643 38.8373 76.3566 39.1 76.8627 39.1C77.1111 39.1 77.3633 39.0367 77.594 38.9035L82.4936 36.074C83.6377 37.4016 85.2147 38.3447 87.004 38.6821V65.3082C85.2151 65.6455 83.6387 66.5881 82.4946 67.915L77.6016 65.0892C76.901 64.6853 76.0051 64.9246 75.6004 65.6252C75.1957 66.3258 75.4357 67.2217 76.1363 67.6264L81.025 70.4496C80.7379 71.2666 80.5799 72.144 80.5799 73.0578C80.5799 73.9709 80.7375 74.8475 81.0243 75.6637L57.9747 88.9716ZM88.4692 78.0161C85.7352 78.0161 83.5108 75.7916 83.5108 73.0576C83.5108 70.3236 85.7352 68.0992 88.4692 68.0992C91.2032 68.0992 93.4276 70.3236 93.4276 73.0576C93.4276 75.7916 91.2032 78.0161 88.4692 78.0161Z"
              fill="#F5463B"
            />
            <path
              d="M64.2685 67.1357H59.9092C59.1002 67.1357 58.4443 67.7914 58.4443 68.6006C58.4443 69.4098 59.1002 70.0654 59.9092 70.0654H64.2685C65.0775 70.0654 65.7334 69.4098 65.7334 68.6006C65.7334 67.7914 65.0775 67.1357 64.2685 67.1357Z"
              fill="#F5463B"
            />
            <path
              d="M64.268 72.8721H39.7295C38.9205 72.8721 38.2646 73.5277 38.2646 74.3369C38.2646 75.1461 38.9205 75.8018 39.7295 75.8018H64.2682C65.0771 75.8018 65.733 75.1461 65.733 74.3369C65.733 73.5277 65.077 72.8721 64.268 72.8721Z"
              fill="#F5463B"
            />
            <path
              d="M39.7295 70.0654H39.7498C40.5588 70.0654 41.2146 69.4098 41.2146 68.6006C41.2146 67.7914 40.5588 67.1357 39.7498 67.1357H39.7295C38.9205 67.1357 38.2646 67.7914 38.2646 68.6006C38.2646 69.4098 38.9205 70.0654 39.7295 70.0654Z"
              fill="#F5463B"
            />
            <path
              d="M44.824 70.0654C45.633 70.0654 46.2889 69.4098 46.2889 68.6006C46.2889 67.7914 45.633 67.1357 44.824 67.1357H44.8037C43.9947 67.1357 43.3389 67.7914 43.3389 68.6006C43.3389 69.4098 43.9947 70.0654 44.8037 70.0654H44.824Z"
              fill="#F5463B"
            />
            <path
              d="M49.8982 70.0654C50.7072 70.0654 51.3631 69.4098 51.3631 68.6006C51.3631 67.7914 50.7072 67.1357 49.8982 67.1357H49.8779C49.0689 67.1357 48.4131 67.7914 48.4131 68.6006C48.4131 69.4098 49.0689 70.0654 49.8779 70.0654H49.8982Z"
              fill="#F5463B"
            />
          </g>
          <defs>
            <clipPath id="clip0_836_1872">
              <rect width="100" height="100" fill="white" />
            </clipPath>
            <clipPath id="clip1_836_1872">
              <rect
                width="100"
                height="100"
                fill="white"
                transform="translate(2 2)"
              />
            </clipPath>
          </defs>
        </svg>
      )

      break
    case "arrowRight":
      iconElement = (
        <svg
          width="35"
          height="13"
          viewBox="0 0 35 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.8281 4.27083L27.7461 6.5L21.8281 8.72917V4.27083ZM4.25 4.27083L10.168 6.5L4.25 8.72917V4.27083ZM17.9219 0.25V12.75L34.5234 6.5L17.9219 0.25ZM0.34375 0.25V12.75L16.9453 6.5L0.34375 0.25Z"
            fill="#00549A"
          />
        </svg>
      )

      break
    case "arrowLeft":
      iconElement = (
        <svg
          width="19"
          height="13"
          viewBox="0 0 19 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.03385 8.72917L3.8776 6.5L7.03385 4.27083L7.03385 8.72917ZM16.4089 8.72917L13.2526 6.5L16.4089 4.27083V8.72917ZM9.11719 12.75L9.11719 0.25L0.26302 6.5L9.11719 12.75ZM18.4922 12.75V0.25L9.63802 6.5L18.4922 12.75Z"
            fill="#00549A"
          />
        </svg>
      )

      break
    case "iconButtonMuitenphai":
      iconElement = (
        <svg
          class="icon"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="20" cy="20" r="20" fill="white" />
          <path
            d="M30.707 20.7064C30.7996 20.6133 30.873 20.5029 30.923 20.3814C30.9738 20.2605 31 20.1306 31 19.9994C31 19.8682 30.9738 19.7384 30.923 19.6174C30.873 19.496 30.7996 19.3855 30.707 19.2924L22.707 11.2924C22.5184 11.1103 22.2658 11.0095 22.0036 11.0118C21.7414 11.014 21.4906 11.1192 21.3052 11.3046C21.1198 11.49 21.0146 11.7408 21.0123 12.003C21.01 12.2652 21.1108 12.5178 21.293 12.7064L27.586 18.9994H10C9.73478 18.9994 9.48043 19.1048 9.29289 19.2923C9.10536 19.4799 9 19.7342 9 19.9994C9 20.2646 9.10536 20.519 9.29289 20.7065C9.48043 20.8941 9.73478 20.9994 10 20.9994H27.586L21.293 27.2924C21.1108 27.481 21.01 27.7336 21.0123 27.9958C21.0146 28.258 21.1198 28.5088 21.3052 28.6942C21.4906 28.8797 21.7414 28.9848 22.0036 28.9871C22.2658 28.9894 22.5184 28.8886 22.707 28.7064L30.707 20.7064Z"
            fill="url(#paint0_linear_1647_35520)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1647_35520"
              x1="20"
              y1="11.0117"
              x2="20"
              y2="28.9871"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#174297" />
              <stop offset="1" stop-color="#EA1119" />
            </linearGradient>
          </defs>
        </svg>
      )

      break
    case "iconButtonMeeting":
      iconElement = (
        <svg
          class="icon"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1647_35541)">
            <path
              d="M18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0ZM22.5972 23.1252C22.5972 23.298 22.5285 23.4638 22.4063 23.586C22.2841 23.7082 22.1184 23.7769 21.9456 23.7769H10.9086C10.0543 23.7769 9.23501 23.4375 8.63093 22.8334C8.02685 22.2293 7.68748 21.41 7.68748 20.5557V12.8748C7.68748 12.702 7.75613 12.5362 7.87834 12.414C8.00055 12.2918 8.1663 12.2231 8.33913 12.2231H19.3761C20.2304 12.2231 21.0497 12.5625 21.6537 13.1666C22.2578 13.7706 22.5972 14.5899 22.5972 15.4442V23.1252ZM28.3125 23.3527C28.3125 23.4071 28.2976 23.4605 28.2693 23.5069C28.241 23.5534 28.2004 23.5912 28.1521 23.6162C28.1038 23.6412 28.0495 23.6524 27.9952 23.6486C27.9409 23.6448 27.8887 23.6262 27.8443 23.5947L23.1576 20.2736V15.7263L27.8443 12.4052C27.8887 12.3738 27.9409 12.3552 27.9952 12.3514C28.0495 12.3476 28.1038 12.3588 28.1521 12.3838C28.2004 12.4088 28.2409 12.4466 28.2692 12.4931C28.2975 12.5395 28.3125 12.5929 28.3125 12.6473V23.3527Z"
              fill="#A825F9"
            />
          </g>
          <defs>
            <clipPath id="clip0_1647_35541">
              <rect width="36" height="36" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )

      break

    //Diễn tập thực chiến Quản lý diễn tập

    case "xem":
      iconElement = (
        <svg
          width="47"
          height="46"
          viewBox="0 0 47 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_1499_52785)">
            <circle cx="23.0938" cy="21" r="18" fill="#EDF6FC" />
          </g>
          <path
            d="M23.0938 15.375C16.8438 15.375 14.3438 21.0006 14.3438 21.0006C14.3438 21.0006 16.8438 26.625 23.0938 26.625C29.3438 26.625 31.8438 21.0006 31.8438 21.0006C31.8438 21.0006 29.3438 15.375 23.0938 15.375Z"
            stroke="#0D99FF"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M23.0938 24.125C24.8196 24.125 26.2188 22.7259 26.2188 21C26.2188 19.2741 24.8196 17.875 23.0938 17.875C21.3679 17.875 19.9688 19.2741 19.9688 21C19.9688 22.7259 21.3679 24.125 23.0938 24.125Z"
            stroke="#0D99FF"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <defs>
            <filter
              id="filter0_d_1499_52785"
              x="0.09375"
              y="0"
              width="46"
              height="46"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="2.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.731597 0 0 0 0 0.782009 0 0 0 0 0.816667 0 0 0 0.5 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1499_52785"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_1499_52785"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      )

      break

    case "sua":
      iconElement = (
        <svg
          width="45"
          height="44"
          viewBox="0 0 45 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_1499_52788)">
            <circle cx="22.0938" cy="20" r="18" fill="#DDFEF0" />
          </g>
          <path
            d="M23.8104 17.5167L24.5771 18.2833L17.0271 25.8333H16.2604V25.0667L23.8104 17.5167ZM26.8104 12.5C26.6021 12.5 26.3854 12.5833 26.2271 12.7417L24.7021 14.2667L27.8271 17.3917L29.3521 15.8667C29.6771 15.5417 29.6771 15.0167 29.3521 14.6917L27.4021 12.7417C27.2354 12.575 27.0271 12.5 26.8104 12.5ZM23.8104 15.1583L14.5938 24.375V27.5H17.7188L26.9354 18.2833L23.8104 15.1583Z"
            fill="#00C590"
          />
          <defs>
            <filter
              id="filter0_d_1499_52788"
              x="0.09375"
              y="0"
              width="44"
              height="44"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.743854 0 0 0 0 0.801151 0 0 0 0 0.804167 0 0 0 0.5 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1499_52788"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_1499_52788"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      )

      break

    case "xoa":
      iconElement = (
        <svg
          width="45"
          height="44"
          viewBox="0 0 45 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_1499_52791)">
            <circle cx="22.0938" cy="20" r="18" fill="#FFE9EC" />
          </g>
          <path
            d="M17.0911 25.8333C17.0911 26.75 17.8411 27.5 18.7578 27.5H25.4245C26.3411 27.5 27.0911 26.75 27.0911 25.8333V17.5C27.0911 16.5833 26.3411 15.8333 25.4245 15.8333H18.7578C17.8411 15.8333 17.0911 16.5833 17.0911 17.5V25.8333ZM19.5911 17.5H24.5911C25.0495 17.5 25.4245 17.875 25.4245 18.3333V25C25.4245 25.4583 25.0495 25.8333 24.5911 25.8333H19.5911C19.1328 25.8333 18.7578 25.4583 18.7578 25V18.3333C18.7578 17.875 19.1328 17.5 19.5911 17.5ZM25.0078 13.3333L24.4161 12.7417C24.2661 12.5917 24.0495 12.5 23.8328 12.5H20.3495C20.1328 12.5 19.9161 12.5917 19.7661 12.7417L19.1745 13.3333H17.0911C16.6328 13.3333 16.2578 13.7083 16.2578 14.1667C16.2578 14.625 16.6328 15 17.0911 15H27.0911C27.5495 15 27.9245 14.625 27.9245 14.1667C27.9245 13.7083 27.5495 13.3333 27.0911 13.3333H25.0078Z"
            fill="#ED1117"
          />
          <defs>
            <filter
              id="filter0_d_1499_52791"
              x="0.09375"
              y="0"
              width="44"
              height="44"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.811765 0 0 0 0 0.756863 0 0 0 0 0.768627 0 0 0 0.5 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1499_52791"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_1499_52791"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      )

      break

    case "doimatkhau":
      iconElement = (
        <svg
          width="47"
          height="46"
          viewBox="0 0 47 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_1499_52794)">
            <circle cx="23.0938" cy="21" r="18" fill="#EDF6FC" />
          </g>
          <path
            d="M29.3438 17.875H16.8438C16.4986 17.875 16.2188 18.1548 16.2188 18.5V27.25C16.2188 27.5952 16.4986 27.875 16.8438 27.875H29.3438C29.6889 27.875 29.9688 27.5952 29.9688 27.25V18.5C29.9688 18.1548 29.6889 17.875 29.3438 17.875Z"
            stroke="#0D99FF"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M20.2812 17.875V15.0625C20.2812 14.3166 20.5776 13.6012 21.105 13.0738C21.6325 12.5463 22.3478 12.25 23.0938 12.25C23.8397 12.25 24.555 12.5463 25.0825 13.0738C25.6099 13.6012 25.9062 14.3166 25.9062 15.0625V17.875"
            stroke="#0D99FF"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <defs>
            <filter
              id="filter0_d_1499_52794"
              x="0.09375"
              y="0"
              width="46"
              height="46"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="2.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.731597 0 0 0 0 0.782009 0 0 0 0 0.816667 0 0 0 0.5 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1499_52794"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_1499_52794"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      )

      break

    case "lichsu":
      iconElement = (
        <svg
          width="45"
          height="44"
          viewBox="0 0 45 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_1499_52823)">
            <circle cx="22.0938" cy="20" r="18" fill="#FFFDE5" />
          </g>
          <path
            d="M22.0828 11.668C17.4828 11.668 13.7578 15.4013 13.7578 20.0013C13.7578 24.6013 17.4828 28.3346 22.0828 28.3346C26.6911 28.3346 30.4245 24.6013 30.4245 20.0013C30.4245 15.4013 26.6911 11.668 22.0828 11.668ZM22.0911 26.668C18.4078 26.668 15.4245 23.6846 15.4245 20.0013C15.4245 16.318 18.4078 13.3346 22.0911 13.3346C25.7745 13.3346 28.7578 16.318 28.7578 20.0013C28.7578 23.6846 25.7745 26.668 22.0911 26.668ZM21.9078 15.8346H21.8578C21.5245 15.8346 21.2578 16.1013 21.2578 16.4346V20.368C21.2578 20.6596 21.4078 20.9346 21.6661 21.0846L25.1245 23.1596C25.4078 23.3263 25.7745 23.243 25.9411 22.9596C26.1161 22.6763 26.0245 22.3013 25.7328 22.1346L22.5078 20.218V16.4346C22.5078 16.1013 22.2411 15.8346 21.9078 15.8346Z"
            fill="#FFD600"
          />
          <defs>
            <filter
              id="filter0_d_1499_52823"
              x="0.09375"
              y="0"
              width="44"
              height="44"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.816667 0 0 0 0 0.809578 0 0 0 0 0.731597 0 0 0 0.5 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1499_52823"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_1499_52823"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      )

      break

    case "danhgia":
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.09375"
            y="0.738281"
            width="35"
            height="35"
            rx="17.5"
            fill="#BCF0FF"
            fill-opacity="0.2"
          />
          <path
            d="M13.6875 9.25391V10.0352H12.125C11.7855 10.0352 11.4449 10.1988 11.2613 10.4258H9V23.3164L13.2969 27.6133H22.2812V10.4258H20.0199C19.8363 10.1988 19.4957 10.0352 19.1562 10.0352H17.5938V9.25391H17.1512C16.8172 8.86602 16.6355 8.8625 16.6164 8.48008C16.6164 8.47773 16.6172 8.475 16.6172 8.47266C16.6172 7.93437 16.1793 7.49609 15.6406 7.49609C15.1578 7.49609 14.7586 7.84922 14.6805 8.30977C14.6719 8.36328 14.6641 8.4168 14.6641 8.47266C14.6641 8.475 14.6648 8.47773 14.6648 8.48008C14.6457 8.8625 14.4641 8.86602 14.1301 9.25391H13.6875ZM12.9062 26.6703L9.94297 23.707H12.9062V26.6703ZM20.1719 10.8164H21.8906V27.2227H13.2969V23.3164H9.39062V10.8164H11.0945C11.0129 11.1539 10.9531 11.5977 10.9531 11.5977H20.3281L20.1719 10.8164ZM15.0555 8.4668C15.0555 8.44414 15.0594 8.42227 15.0621 8.40039C15.0648 8.38203 15.0656 8.36367 15.0699 8.3457C15.1285 8.08359 15.3613 7.88672 15.6406 7.88672C15.9582 7.88672 16.2156 8.14023 16.225 8.45547L16.2242 8.45859L16.2254 8.48359C16.2191 8.80156 15.9598 9.05859 15.6406 9.05859C15.3203 9.05859 15.0594 8.79961 15.0555 8.48008V8.4668ZM14.0781 9.64453H14.309L14.4262 9.50898C14.5168 9.40352 14.5961 9.32969 14.6652 9.26484C14.7336 9.20117 14.8023 9.13672 14.8633 9.05742C15.0418 9.29375 15.3223 9.44922 15.6406 9.44922C15.9586 9.44922 16.2395 9.29414 16.4176 9.05781C16.4781 9.13633 16.5477 9.20078 16.616 9.26484C16.6855 9.33008 16.7645 9.40352 16.8551 9.50898L16.9723 9.64453H17.2031V10.4258H19.1562C19.4441 10.4258 19.6984 10.6023 19.7559 10.7289L19.8516 11.207H11.4113C11.4426 11.0363 11.4809 10.8598 11.5187 10.7445C11.5613 10.618 11.8246 10.4258 12.125 10.4258H14.0781V9.64453Z"
            fill="#37474F"
          />
          <path
            d="M22.6719 9.25391H17.9844V9.64453H22.6719C22.8875 9.64453 23.0625 9.81992 23.0625 10.0352V28.0039C23.0625 28.2191 22.8875 28.3945 22.6719 28.3945H8.60938C8.39375 28.3945 8.21875 28.2191 8.21875 28.0039V10.0352C8.21875 9.81992 8.39375 9.64453 8.60938 9.64453H13.2969V9.25391H8.60938C8.17969 9.25391 7.82812 9.60547 7.82812 10.0352V28.0039C7.82812 28.4336 8.17969 28.7852 8.60938 28.7852H22.6719C23.1016 28.7852 23.4531 28.4336 23.4531 28.0039V10.0352C23.4531 9.60547 23.1016 9.25391 22.6719 9.25391Z"
            fill="#37474F"
          />
          <path
            d="M26.5742 18.7039V10.4273H26.9648V17.068L27.3555 17.4586V10.4273C27.3555 9.99609 27.0234 9.53555 26.6145 9.39883L26.2812 9.37891V18.7039H26.5742Z"
            fill="#37474F"
          />
          <path
            d="M26.5781 16.6758H24.2344V17.0664H26.5781V16.6758Z"
            fill="#37474F"
          />
          <path
            d="M24.625 9.35078L26.1875 9.7V10.4258V17.8477V24.8789H24.625V9.35078ZM24.2344 8.86328V25.2422V25.2695H26.5781V17.8477V10.4258V9.38672L24.2344 8.86328Z"
            fill="#37474F"
          />
          <path
            d="M26.166 25.2695L25.4062 27.55L24.6465 25.2695H26.166ZM26.5781 24.8789H24.2344V25.2695L25.4062 28.7852L26.5781 25.2695V24.8789Z"
            fill="#37474F"
          />
          <path
            d="M18.5703 15.8945C17.6012 15.8945 16.8125 15.1059 16.8125 14.1367C16.8125 13.1676 17.6012 12.3789 18.5703 12.3789C19.5395 12.3789 20.3281 13.1676 20.3281 14.1367C20.3281 15.1059 19.5395 15.8945 18.5703 15.8945ZM18.5703 12.7695C17.8164 12.7695 17.2031 13.3828 17.2031 14.1367C17.2031 14.8906 17.8164 15.5039 18.5703 15.5039C19.3242 15.5039 19.9375 14.8906 19.9375 14.1367C19.9375 13.3828 19.3242 12.7695 18.5703 12.7695Z"
            fill="#37474F"
          />
          <path
            d="M18.7656 13.1602H18.375V15.1133H18.7656V13.1602Z"
            fill="#37474F"
          />
          <path
            d="M19.5469 13.9414H17.5938V14.332H19.5469V13.9414Z"
            fill="#37474F"
          />
          <path
            d="M20.7188 17.8477H14.0781V18.2383H20.7188V17.8477Z"
            fill="#37474F"
          />
          <path
            d="M20.7188 16.6758H14.0781V17.0664H20.7188V16.6758Z"
            fill="#37474F"
          />
          <path
            d="M12.9062 20.7684V22.5352H10.5625V20.1914H12.0113L12.2348 19.8008H10.1719V22.9258H13.2969V20.0859L12.9062 20.7684Z"
            fill="#37474F"
          />
          <path
            d="M11.7457 22.1246L10.7891 20.6895L11.1141 20.473L11.7199 21.3816L13.1258 18.9219L13.4648 19.1156L11.7457 22.1246Z"
            fill="#37474F"
          />
          <path
            d="M12.9062 16.0809V17.8477H10.5625V15.5039H12.0113L12.2348 15.1133H10.1719V18.2383H13.2969V15.3984L12.9062 16.0809Z"
            fill="#37474F"
          />
          <path
            d="M11.7457 17.4371L10.7891 16.002L11.1141 15.7855L11.7199 16.6941L13.1258 14.2344L13.4648 14.4281L11.7457 17.4371Z"
            fill="#37474F"
          />
          <path
            d="M20.7188 22.5352H14.0781V22.9258H20.7188V22.5352Z"
            fill="#37474F"
          />
          <path
            d="M20.7188 21.3633H14.0781V21.7539H20.7188V21.3633Z"
            fill="#37474F"
          />
        </svg>
      )

      break

    case "khaimac":
      iconElement = (
        <svg
          width="39"
          height="36"
          viewBox="0 0 39 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <rect width="38.0952" height="36" rx="18" fill="url(#pattern0)" />
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image0_1647_35528"
                transform="scale(0.005 0.00529101)"
              />
            </pattern>
            <image
              id="image0_1647_35528"
              width="200"
              height="189"
              xlinkHref="data:image/png;base64,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"
            />
          </defs>
        </svg>
      )

      break

    case "meeting":
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1499_52797)">
            <path
              d="M18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0ZM22.5972 23.1252C22.5972 23.298 22.5285 23.4638 22.4063 23.586C22.2841 23.7082 22.1184 23.7769 21.9456 23.7769H10.9086C10.0543 23.7769 9.23501 23.4375 8.63093 22.8334C8.02685 22.2293 7.68748 21.41 7.68748 20.5557V12.8748C7.68748 12.702 7.75613 12.5362 7.87834 12.414C8.00055 12.2918 8.1663 12.2231 8.33913 12.2231H19.3761C20.2304 12.2231 21.0497 12.5625 21.6537 13.1666C22.2578 13.7706 22.5972 14.5899 22.5972 15.4442V23.1252ZM28.3125 23.3527C28.3125 23.4071 28.2976 23.4605 28.2693 23.5069C28.241 23.5534 28.2004 23.5912 28.1521 23.6162C28.1038 23.6412 28.0495 23.6524 27.9952 23.6486C27.9409 23.6448 27.8887 23.6262 27.8443 23.5947L23.1576 20.2736V15.7263L27.8443 12.4052C27.8887 12.3738 27.9409 12.3552 27.9952 12.3514C28.0495 12.3476 28.1038 12.3588 28.1521 12.3838C28.2004 12.4088 28.2409 12.4466 28.2692 12.4931C28.2975 12.5395 28.3125 12.5929 28.3125 12.6473V23.3527Z"
              fill="#A825F9"
            />
          </g>
          <defs>
            <clipPath id="clip0_1499_52797">
              <rect width="36" height="36" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )

      break
    case "chat":
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1499_52799)">
            <path
              d="M16.9063 14.8711L11.3281 20.8124L16.3852 17.9999L19.0977 20.75L24.6758 14.8125L19.5782 17.6601L16.9063 14.8711Z"
              fill="#0E8CF1"
            />
            <path
              d="M18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0ZM18 27.1406C16.9783 27.1417 15.9614 27.0005 14.9787 26.7212L11.4982 28.636V24.9896C9.17332 23.2277 7.68762 20.5413 7.68762 17.5312C7.68748 12.2241 12.3047 7.92183 18 7.92183C23.6953 7.92183 28.3125 12.2241 28.3125 17.5312C28.3125 22.8383 23.6953 27.1406 18 27.1406Z"
              fill="#0E8CF1"
            />
          </g>
          <defs>
            <clipPath id="clip0_1499_52799">
              <rect width="36" height="36" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )

      break
    case "duyetdangky":
      iconElement = (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_1499_52802)">
            <circle cx="22" cy="20" r="18" fill="#BCF0FF" />
          </g>
          <path
            d="M28.875 15.625L20.125 24.3746L15.75 20"
            stroke="#2260BD"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <defs>
            <filter
              id="filter0_d_1499_52802"
              x="0"
              y="0"
              width="44"
              height="44"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.743854 0 0 0 0 0.801151 0 0 0 0 0.804167 0 0 0 0.5 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1499_52802"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_1499_52802"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      )

      break
    case "tiepnhanbaocao":
      iconElement = (
        <svg
          width="34"
          height="36"
          viewBox="0 0 34 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1499_52808)">
            <mask
              id="mask0_1499_52808"
              mask-type="luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="27"
              height="31"
            >
              <path d="M26.6839 0H0.71875V30.8571H26.6839V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_1499_52808)">
              <path
                d="M26.5762 15.8125C26.5762 18.5933 26.5847 21.3741 26.5706 24.155C26.5747 24.8676 26.5311 25.5799 26.44 26.2866C26.2513 27.6297 25.5496 28.6747 24.4183 29.4288C23.5915 29.9953 22.634 30.3441 21.6351 30.4424C17.857 30.8187 14.0518 30.842 10.2693 30.512C8.77202 30.3816 7.25908 30.3771 5.80185 29.9631C5.04257 29.7637 4.3011 29.5025 3.58501 29.1819C2.20886 28.5311 1.37735 27.4236 1.05414 25.928C0.857531 25.0952 0.752928 24.2436 0.742188 23.3885C0.765622 18.611 0.781956 13.8334 0.791181 9.05579C0.806861 7.62954 0.917136 6.20595 1.12127 4.79418C1.20242 4.15828 1.36713 3.5357 1.61117 2.94254C2.27795 1.37114 3.45958 0.420939 5.21125 0.31922C7.14063 0.207013 9.07173 0.106196 11.0036 0.0631422C12.7926 0.0227718 14.5843 0.0365281 16.3736 0.0794598C17.732 0.112146 19.0885 0.225815 20.4456 0.308264C20.8044 0.332105 21.1486 0.460058 21.4351 0.676422C23.1646 1.94861 24.7451 3.41058 26.1463 5.03464C26.5469 5.49349 26.6577 6.01354 26.6485 6.61471C26.5986 9.68018 26.5794 12.7462 26.5493 15.812L26.5762 15.8125ZM14.6918 29.2705C16.4838 29.2054 18.4844 29.1364 20.4849 29.0575C20.9137 29.0408 21.3424 29.0054 21.7664 28.9462C22.4084 28.8551 23.0071 28.5715 23.4833 28.1333C24.2025 27.4902 24.6836 26.7101 24.7692 25.7457C24.851 24.8252 24.8759 23.8988 24.9024 22.9744C24.9513 21.2669 24.9863 19.5594 25.0206 17.8519C25.0362 17.0693 25.1079 16.2793 25.03 15.5051C24.8362 13.5849 24.9099 11.6631 24.9033 9.74233C24.9009 9.03066 24.8911 8.31887 24.8693 7.60794C24.8587 7.25705 24.5438 6.98413 24.1468 6.97072C23.2179 6.93913 22.288 6.93153 21.3598 6.88627C20.9327 6.86033 20.5081 6.80364 20.0893 6.71654C19.7144 6.64337 19.3223 6.18106 19.28 5.80419C19.2446 5.52209 19.2241 5.23837 19.2187 4.95413C19.2136 4.10038 19.2244 3.24662 19.2234 2.39287C19.2119 2.25245 19.1547 2.11958 19.0604 2.01457C18.9659 1.90958 18.8398 1.83828 18.7009 1.81138C18.4875 1.79211 18.2739 1.76764 18.0601 1.76398C15.4146 1.71848 12.7691 1.66649 10.1236 1.63856C9.05178 1.62734 7.97925 1.67098 6.90708 1.69049C6.11836 1.70985 5.33942 1.8692 4.60696 2.1612C3.58465 2.55918 3.00422 3.32111 2.90882 4.41684C2.88724 4.77209 2.89074 5.12843 2.91934 5.4832C3.04905 7.83188 3.0019 10.1803 2.95535 12.5303C2.88346 16.161 2.8428 19.7925 2.81341 23.4237C2.80018 24.2779 2.84891 25.1319 2.95915 25.9792C3.01423 26.4428 3.18751 26.8846 3.46258 27.2626C3.73764 27.6408 4.10529 27.9422 4.53053 28.1386C4.98013 28.3546 5.45318 28.5183 5.94037 28.6265C6.98343 28.8775 8.04876 29.0257 9.12099 29.069C10.9085 29.1196 12.6947 29.1964 14.6918 29.2705ZM22.1187 5.46831C22.4615 5.45038 22.7433 5.4543 23.016 5.41185C23.1168 5.39612 23.2132 5.28152 23.2854 5.19126C23.2959 5.15948 23.2988 5.12563 23.2937 5.09253C23.2884 5.05942 23.2754 5.02792 23.2557 5.00081C22.7503 4.3396 22.1317 3.77219 21.4285 3.32463C21.3736 3.31625 21.3173 3.31968 21.2639 3.33452C21.2103 3.34937 21.1604 3.3753 21.1177 3.41074C21.0919 3.95959 21.0789 4.51033 21.0998 5.05917C21.1158 5.1254 21.1478 5.1867 21.193 5.23796C21.2379 5.28921 21.2948 5.32891 21.3587 5.35348C21.6088 5.40989 21.863 5.44814 22.1187 5.46807V5.46831Z"
                fill="#248C4E"
                fill-opacity="0.7"
              />
              <path
                d="M13.5565 10.6055C15.631 10.634 17.7055 10.6588 19.78 10.694C20.2806 10.6972 20.7808 10.7266 21.2782 10.7823C21.5571 10.8364 21.829 10.9217 22.0884 11.0368C22.3031 11.1158 22.5507 11.504 22.5434 11.7171C22.5362 11.9255 22.2495 12.3068 22.0594 12.3813C21.3819 12.6464 20.6716 12.699 19.9551 12.7095C18.5243 12.7304 17.0929 12.7838 15.663 12.7583C13.8044 12.7248 11.9469 12.63 10.0891 12.5561C8.94549 12.5106 7.80205 12.4612 6.65971 12.3996C6.29818 12.3963 5.94902 12.2681 5.67193 12.0368C5.58651 11.9725 5.5173 11.8894 5.46983 11.7938C5.42234 11.6982 5.3979 11.5929 5.39845 11.4863C5.4107 11.2411 5.63422 10.8695 5.85161 10.83C6.19744 10.7516 6.54946 10.7035 6.90369 10.6861C9.12149 10.6732 11.3394 10.6795 13.5572 10.6795L13.5565 10.6055Z"
                fill="#248C4E"
                fill-opacity="0.7"
              />
              <path
                d="M14.2239 15.9652C12.2513 15.9138 10.3203 15.8748 8.39032 15.8073C7.74821 15.7821 7.10824 15.7182 6.47392 15.6157C6.19873 15.5516 5.93855 15.4351 5.70759 15.2729C5.65446 15.2301 5.61124 15.1764 5.58085 15.1154C5.55047 15.0545 5.53363 14.9877 5.53148 14.9197C5.52935 14.8517 5.54198 14.7841 5.56851 14.7212C5.59504 14.6586 5.63481 14.6022 5.68518 14.5562C5.85239 14.4267 6.04822 14.339 6.2564 14.3001C6.75101 14.2284 7.24975 14.1879 7.74951 14.1792C10.6821 14.1515 13.6155 14.0912 16.5471 14.1389C18.2596 14.1667 19.9693 14.3727 21.6796 14.5071C21.8198 14.5346 21.9556 14.5801 22.0838 14.6425C22.274 14.7111 22.5336 15.1624 22.4461 15.3433C22.3587 15.5241 22.2347 15.7336 22.0687 15.8183C21.4807 16.1179 20.8261 16.1277 20.1825 16.1254C18.1812 16.1175 16.1755 16.2687 14.2239 15.9652Z"
                fill="#248C4E"
                fill-opacity="0.7"
              />
              <path
                d="M13.8396 17.8619C15.9162 17.8901 17.993 17.9147 20.0695 17.9493C20.4986 17.9519 20.9274 17.9813 21.353 18.0372C21.5557 18.066 21.7476 18.1931 21.9363 18.2909C22.1395 18.3962 22.3446 18.8388 22.2451 19.0256C22.1493 19.2049 22.0091 19.4093 21.836 19.4879C21.5749 19.5991 21.2941 19.6582 21.01 19.6612C19.2203 19.706 17.4301 19.7598 15.6402 19.7553C13.8503 19.7506 12.0584 19.7171 10.271 19.6279C8.98622 19.5638 7.70609 19.3954 6.42632 19.2522C6.21435 19.2256 6.01487 19.1378 5.85278 18.9991C5.7127 18.8482 5.61203 18.6653 5.55969 18.4665C5.51536 18.3339 5.77672 17.9939 5.90813 17.9772C6.32869 17.9066 6.75307 17.8608 7.17907 17.8402C9.39909 17.8267 11.6192 17.834 13.8394 17.834L13.8396 17.8619Z"
                fill="#248C4E"
                fill-opacity="0.7"
              />
              <path
                d="M11.5518 23.2518C10.0609 23.198 8.56971 23.1491 7.07916 23.0872C6.57812 23.0861 6.08862 22.9374 5.67252 22.6593C5.55651 22.579 5.46328 22.4702 5.40186 22.3434C5.34045 22.2166 5.31296 22.0761 5.32199 21.9357C5.3269 21.6877 5.58949 21.3842 5.81582 21.2956C6.42956 21.0549 7.06853 21.0692 7.70834 21.0967C9.55371 21.1755 11.4005 21.2337 13.2436 21.3507C14.3756 21.4226 15.5022 21.5842 16.6302 21.7137C16.7686 21.7432 16.904 21.7848 17.0352 21.8378C17.1617 21.8757 17.4202 22.2121 17.3659 22.3391C17.2881 22.522 17.1944 22.7483 17.0381 22.8371C16.7919 22.9728 16.5186 23.0524 16.2378 23.0701C15.1747 23.1386 14.1096 23.1799 13.0448 23.2164C12.548 23.2339 12.05 23.2196 11.5527 23.2196L11.5518 23.2518Z"
                fill="#248C4E"
                fill-opacity="0.7"
              />
              <path
                d="M8.68598 8.55103C7.99191 8.5075 7.20401 8.48191 6.42335 8.39763C6.0706 8.34535 5.72727 8.24265 5.40397 8.09271C5.30577 8.04983 5.22171 7.98021 5.16144 7.8919C5.10121 7.80358 5.06719 7.70013 5.06336 7.59341C5.04608 7.35521 5.29362 6.9865 5.50794 6.9332C5.57555 6.90983 5.64466 6.89107 5.71482 6.87711C7.42496 6.69722 9.13684 6.61791 10.8514 6.81195C10.993 6.8306 11.1305 6.87278 11.2581 6.93666C11.3872 6.99546 11.4999 7.08455 11.5868 7.19631C11.6737 7.30807 11.732 7.43914 11.7567 7.57828C11.7985 7.78954 11.5422 8.1834 11.3202 8.25731C11.1237 8.33966 10.9182 8.39876 10.7078 8.43359C10.0661 8.48701 9.42243 8.51066 8.68598 8.55103Z"
                fill="#248C4E"
                fill-opacity="0.7"
              />
            </g>
          </g>
          <g clip-path="url(#clip1_1499_52808)">
            <path
              d="M21.7171 30.7513H21.7042C21.5894 30.7497 21.476 30.7251 21.3709 30.6788C21.2657 30.6326 21.171 30.5657 21.0922 30.4821L17.0928 26.2298C17.0155 26.1479 16.9552 26.0515 16.9152 25.9463C16.8753 25.841 16.8564 25.7289 16.8598 25.6164C16.8665 25.3891 16.9633 25.1738 17.1288 25.0178C17.2943 24.8619 17.5149 24.7781 17.7422 24.7848C17.8548 24.7882 17.9656 24.8137 18.0682 24.8598C18.1709 24.906 18.2635 24.9719 18.3408 25.0538L21.7342 28.6598L29.1056 21.2516C29.1845 21.1695 29.2789 21.104 29.3833 21.0588C29.4877 21.0136 29.6001 20.9896 29.7139 20.9883C29.8277 20.987 29.9406 21.0084 30.0461 21.0512C30.1515 21.094 30.2474 21.1574 30.3281 21.2376C30.4088 21.3179 30.4727 21.4134 30.5161 21.5186C30.5595 21.6238 30.5815 21.7366 30.5808 21.8503C30.5802 21.9641 30.5569 22.0767 30.5123 22.1814C30.4677 22.2861 30.4027 22.3808 30.3211 22.4601L22.3239 30.4984C22.2446 30.5787 22.1501 30.6424 22.0459 30.6858C21.9417 30.7292 21.8299 30.7515 21.7171 30.7513Z"
              fill="#2260BD"
            />
            <path
              d="M25.1467 30.7513H25.1339C25.019 30.7497 24.9057 30.7251 24.8006 30.6788C24.6954 30.6326 24.6007 30.5657 24.5219 30.4821L20.5225 26.2298C20.4452 26.1479 20.3849 26.0515 20.3449 25.9463C20.305 25.841 20.2861 25.7289 20.2894 25.6164C20.2962 25.3891 20.393 25.1738 20.5585 25.0178C20.7239 24.8619 20.9446 24.7781 21.1719 24.7848C21.2845 24.7882 21.3952 24.8137 21.4979 24.8598C21.6006 24.906 21.6932 24.9719 21.7705 25.0538L25.1639 28.6598L32.5353 21.2516C32.6142 21.1695 32.7086 21.104 32.813 21.0588C32.9174 21.0136 33.0298 20.9896 33.1436 20.9883C33.2574 20.987 33.3703 21.0084 33.4758 21.0512C33.5812 21.094 33.6771 21.1574 33.7578 21.2376C33.8385 21.3179 33.9024 21.4134 33.9458 21.5186C33.9892 21.6238 34.0112 21.7366 34.0105 21.8503C34.0099 21.9641 33.9866 22.0767 33.942 22.1814C33.8974 22.2861 33.8323 22.3808 33.7507 22.4601L25.7536 30.4984C25.6743 30.5787 25.5798 30.6424 25.4756 30.6858C25.3714 30.7292 25.2596 30.7515 25.1467 30.7513Z"
              fill="#2260BD"
            />
          </g>
          <defs>
            <clipPath id="clip0_1499_52808">
              <rect
                width="26.1533"
                height="30.8571"
                fill="white"
                transform="translate(0.570312)"
              />
            </clipPath>
            <clipPath id="clip1_1499_52808">
              <rect
                width="20.5714"
                height="20.5714"
                fill="white"
                transform="translate(13.4297 15.4297)"
              />
            </clipPath>
          </defs>
        </svg>
      )

      break
    case "baocaocucATTT":
      iconElement = (
        <svg
          width="42"
          height="36"
          viewBox="0 0 42 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1499_52826)">
            <mask
              id="mask0_1499_52826"
              mask-type="luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="30"
              height="34"
            >
              <path d="M29.4119 0H0.164062V33.3734H29.4119V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_1499_52826)">
              <path
                d="M29.2954 17.1027C29.2954 20.1103 29.305 23.1178 29.2891 26.1255C29.2937 26.8961 29.2446 27.6665 29.142 28.4309C28.9294 29.8834 28.1391 31.0136 26.8647 31.8293C25.9334 32.442 24.8548 32.8193 23.7296 32.9255C19.4739 33.3325 15.1876 33.3577 10.9269 33.0008C9.24032 32.8598 7.5361 32.8549 5.89464 32.4072C5.03938 32.1915 4.20416 31.909 3.39754 31.5623C1.84741 30.8584 0.91078 29.6606 0.5467 28.043C0.325239 27.1423 0.207411 26.2213 0.195312 25.2964C0.22171 20.1294 0.240108 14.9622 0.2505 9.79497C0.268163 8.25241 0.392379 6.71274 0.622316 5.18584C0.713726 4.49809 0.899261 3.82474 1.17416 3.18321C1.92523 1.48367 3.25626 0.455986 5.22938 0.345972C7.40269 0.224615 9.57792 0.115576 11.754 0.069012C13.7692 0.0253497 15.7874 0.0402277 17.8029 0.0866603C19.333 0.122012 20.8611 0.24495 22.3898 0.334122C22.7939 0.359907 23.1816 0.498295 23.5044 0.732301C25.4525 2.10822 27.2328 3.68941 28.8111 5.44591C29.2624 5.94218 29.3872 6.50464 29.3768 7.15483C29.3206 10.4703 29.299 13.7863 29.2651 17.1022L29.2954 17.1027ZM15.9086 31.6581C17.9271 31.5877 20.1805 31.513 22.434 31.4278C22.9171 31.4097 23.3999 31.3714 23.8776 31.3073C24.6007 31.2088 25.2751 30.9021 25.8115 30.4282C26.6216 29.7326 27.1635 28.8889 27.2599 27.8458C27.3521 26.8503 27.3801 25.8483 27.41 24.8485C27.4651 23.0018 27.5045 21.1551 27.5431 19.3084C27.5607 18.4619 27.6414 17.6075 27.5537 16.7702C27.3354 14.6933 27.4185 12.6149 27.4111 10.5375C27.4083 9.76778 27.3973 8.99796 27.3727 8.22905C27.3608 7.84955 27.006 7.55438 26.5588 7.53987C25.5125 7.5057 24.4651 7.49748 23.4196 7.44854C22.9385 7.42047 22.4601 7.35916 21.9883 7.26496C21.5662 7.18582 21.1245 6.68581 21.0767 6.27821C21.0369 5.97311 21.0138 5.66626 21.0078 5.35883C21.002 4.43547 21.0141 3.51208 21.013 2.58872C21 2.43685 20.9356 2.29314 20.8294 2.17957C20.723 2.06602 20.5809 1.9889 20.4244 1.95982C20.1841 1.93897 19.9435 1.9125 19.7026 1.90854C16.7227 1.85934 13.7427 1.8031 10.7628 1.7729C9.55545 1.76076 8.34733 1.80796 7.1396 1.82906C6.25117 1.85 5.37376 2.02234 4.54869 2.33816C3.39713 2.76859 2.74332 3.59265 2.63586 4.77773C2.61156 5.16195 2.6155 5.54735 2.64771 5.93104C2.79382 8.47125 2.74071 11.0112 2.68828 13.5529C2.6073 17.4796 2.56149 21.4072 2.52839 25.3345C2.51349 26.2583 2.56838 27.182 2.69256 28.0984C2.75459 28.5998 2.94979 29.0776 3.25963 29.4864C3.56946 29.8954 3.9836 30.2214 4.4626 30.4339C4.96903 30.6675 5.5019 30.8445 6.05067 30.9616C7.22561 31.233 8.42562 31.3934 9.6334 31.4402C11.6469 31.4949 13.659 31.5779 15.9086 31.6581ZM24.2743 5.91495C24.6605 5.89556 24.978 5.89979 25.2851 5.85388C25.3987 5.83687 25.5072 5.71292 25.5886 5.6153C25.6004 5.58093 25.6036 5.54432 25.5979 5.50853C25.592 5.47271 25.5773 5.43864 25.5551 5.40932C24.9858 4.69419 24.289 4.08051 23.4969 3.59645C23.435 3.5874 23.3717 3.5911 23.3115 3.60716C23.2511 3.62321 23.1949 3.65126 23.1468 3.68959C23.1178 4.28319 23.1031 4.87885 23.1267 5.47245C23.1447 5.54408 23.1807 5.61037 23.2316 5.66581C23.2822 5.72124 23.3462 5.76418 23.4183 5.79075C23.7 5.85176 23.9863 5.89313 24.2743 5.91468V5.91495Z"
                fill="#248C4E"
              />
              <path
                d="M14.6269 11.4727C16.9637 11.5035 19.3005 11.5304 21.6372 11.5684C22.2012 11.5718 22.7645 11.6037 23.3249 11.6639C23.639 11.7224 23.9453 11.8147 24.2375 11.9391C24.4793 12.0246 24.7583 12.4445 24.75 12.6749C24.7419 12.9003 24.4189 13.3127 24.2049 13.3933C23.4417 13.6801 22.6416 13.7369 21.8345 13.7483C20.2228 13.7708 18.6104 13.8286 16.9997 13.801C14.9062 13.7648 12.8139 13.6623 10.7211 13.5823C9.433 13.5331 8.14499 13.4797 6.85823 13.4131C6.45099 13.4095 6.05769 13.2709 5.74557 13.0207C5.64934 12.9512 5.57139 12.8612 5.51792 12.7579C5.46443 12.6545 5.4369 12.5406 5.43751 12.4253C5.45131 12.1601 5.70309 11.7582 5.94797 11.7155C6.33752 11.6307 6.73404 11.5787 7.13306 11.5599C9.63124 11.5459 12.1296 11.5528 14.6278 11.5528L14.6269 11.4727Z"
                fill="#248C4E"
              />
              <path
                d="M15.3775 17.2679C13.1556 17.2124 10.9804 17.1701 8.80647 17.0972C8.08318 17.0699 7.3623 17.0008 6.64779 16.89C6.3378 16.8206 6.04473 16.6946 5.78457 16.5192C5.72472 16.4729 5.67604 16.4148 5.64181 16.3489C5.60758 16.2829 5.58861 16.2108 5.5862 16.1371C5.5838 16.0637 5.59802 15.9905 5.62791 15.9225C5.65779 15.8547 5.70259 15.7938 5.75933 15.7441C5.94768 15.604 6.16827 15.5091 6.40276 15.467C6.95991 15.3895 7.5217 15.3457 8.08464 15.3363C11.388 15.3064 14.6923 15.2411 17.9945 15.2927C19.9235 15.3227 21.8493 15.5455 23.7759 15.6909C23.9338 15.7207 24.0868 15.7699 24.2311 15.8373C24.4454 15.9116 24.7379 16.3997 24.6393 16.5953C24.5408 16.7909 24.4011 17.0174 24.2142 17.1091C23.5518 17.433 22.8145 17.4437 22.0894 17.4412C19.8352 17.4326 17.5759 17.5962 15.3775 17.2679Z"
                fill="#248C4E"
              />
              <path
                d="M14.9496 19.3214C17.2887 19.3519 19.628 19.3785 21.967 19.4159C22.4504 19.4187 22.9334 19.4506 23.4128 19.511C23.6411 19.5421 23.8573 19.6796 24.0699 19.7853C24.2988 19.8992 24.5298 20.3779 24.4177 20.58C24.3098 20.7739 24.1519 20.9949 23.9569 21.08C23.6627 21.2003 23.3465 21.2642 23.0265 21.2674C21.0105 21.3158 18.9939 21.374 16.9777 21.3692C14.9616 21.3641 12.9432 21.3279 10.9298 21.2314C9.48256 21.162 8.04058 20.9799 6.59902 20.825C6.36025 20.7963 6.13555 20.7013 5.95296 20.5513C5.79517 20.3881 5.68178 20.1903 5.62282 19.9753C5.57289 19.8319 5.8673 19.4641 6.01531 19.4461C6.48904 19.3697 6.96708 19.3202 7.44693 19.2979C9.94762 19.2833 12.4485 19.2912 14.9493 19.2912L14.9496 19.3214Z"
                fill="#248C4E"
              />
              <path
                d="M12.3709 25.1475C10.6915 25.0893 9.01176 25.0364 7.33277 24.9694C6.76839 24.9682 6.21701 24.8075 5.7483 24.5067C5.61762 24.4198 5.5126 24.3022 5.44342 24.165C5.37425 24.0279 5.34328 23.8759 5.35345 23.7241C5.35899 23.4558 5.65477 23.1276 5.90971 23.0318C6.60104 22.7715 7.32079 22.7869 8.0415 22.8167C10.1202 22.9019 12.2005 22.9648 14.2765 23.0914C15.5517 23.1691 16.8207 23.3439 18.0913 23.4839C18.2472 23.5159 18.3998 23.5608 18.5475 23.6182C18.69 23.6591 18.9811 24.023 18.92 24.1603C18.8324 24.3581 18.7269 24.603 18.5508 24.699C18.2734 24.8457 17.9656 24.9318 17.6493 24.9509C16.4517 25.025 15.252 25.0698 14.0526 25.1092C13.493 25.1282 12.9321 25.1127 12.3718 25.1127L12.3709 25.1475Z"
                fill="#248C4E"
              />
              <path
                d="M9.14409 9.24892C8.36226 9.20183 7.47476 9.17415 6.59539 9.08301C6.19805 9.02645 5.81132 8.91539 5.44714 8.75322C5.33653 8.70684 5.24183 8.63155 5.17395 8.53603C5.10611 8.44051 5.06779 8.32862 5.06346 8.2132C5.04401 7.95558 5.32284 7.5568 5.56426 7.49915C5.64041 7.47388 5.71825 7.45359 5.79729 7.43849C7.72364 7.24393 9.65194 7.15815 11.5833 7.36802C11.7428 7.38819 11.8976 7.43381 12.0414 7.5029C12.1868 7.56649 12.3138 7.66285 12.4116 7.78372C12.5095 7.9046 12.5752 8.04636 12.6031 8.19684C12.6501 8.42533 12.3614 8.8513 12.1114 8.93124C11.89 9.02031 11.6585 9.08423 11.4216 9.12189C10.6986 9.17967 9.97364 9.20525 9.14409 9.24892Z"
                fill="#248C4E"
              />
            </g>
          </g>
          <path
            d="M16.37 32.3203H14.7223L17.233 25.0476H19.2145L21.7216 32.3203H20.0739L18.2521 26.7095H18.1953L16.37 32.3203ZM16.267 29.4616H20.1591V30.6619H16.267V29.4616ZM21.4313 26.3153V25.0476H27.4043V26.3153H25.1777V32.3203H23.6578V26.3153H21.4313ZM28.111 26.3153V25.0476H34.084V26.3153H31.8574V32.3203H30.3375V26.3153H28.111ZM34.7907 26.3153V25.0476H40.7637V26.3153H38.5371V32.3203H37.0172V26.3153H34.7907Z"
            fill="black"
          />
          <defs>
            <clipPath id="clip0_1499_52826">
              <rect width="29.4598" height="33.3734" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )

      break
    case "baocaotancong":
      iconElement = (
        <svg
          width="35"
          height="36"
          viewBox="0 0 35 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1499_52839)">
            <mask
              id="mask0_1499_52839"
              mask-type="luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="27"
              height="31"
            >
              <path d="M26.1738 0H0.8125V30.1395H26.1738V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_1499_52839)">
              <path
                d="M26.0692 15.4457C26.0692 18.1618 26.0774 20.878 26.0637 23.5942C26.0677 24.2902 26.0251 24.9859 25.9361 25.6762C25.7518 26.988 25.0665 28.0087 23.9614 28.7453C23.1539 29.2986 22.2187 29.6394 21.243 29.7353C17.5527 30.1029 13.836 30.1256 10.1415 29.8033C8.67903 29.6759 7.20127 29.6715 5.77793 29.2672C5.03631 29.0724 4.31208 28.8173 3.61264 28.5042C2.2685 27.8685 1.45633 26.7868 1.14063 25.3259C0.948599 24.5125 0.846428 23.6807 0.835938 22.8455C0.858827 18.1791 0.874781 13.5126 0.883791 8.8461C0.899107 7.45301 1.00682 6.06253 1.2062 4.6836C1.28546 4.06248 1.44634 3.45438 1.68471 2.87502C2.33598 1.34016 3.49014 0.412059 5.20107 0.312705C7.08558 0.203107 8.97177 0.104635 10.8587 0.0625822C12.6061 0.0231507 14.3562 0.036587 16.1038 0.0785203C17.4306 0.110447 18.7556 0.221472 20.0811 0.302003C20.4316 0.32529 20.7677 0.450268 21.0476 0.661599C22.7369 1.9042 24.2806 3.33217 25.6492 4.91846C26.0405 5.36664 26.1487 5.8746 26.1397 6.46179C26.091 9.45597 26.0723 12.4507 26.0429 15.4452L26.0692 15.4457ZM14.4612 28.5907C16.2115 28.5271 18.1655 28.4597 20.1196 28.3827C20.5384 28.3663 20.957 28.3318 21.3713 28.2739C21.9983 28.185 22.5831 27.908 23.0482 27.48C23.7506 26.8518 24.2206 26.0899 24.3042 25.1478C24.3841 24.2488 24.4084 23.3439 24.4343 22.441C24.4821 20.7732 24.5163 19.1054 24.5497 17.4377C24.565 16.6732 24.635 15.9016 24.5589 15.1454C24.3696 13.2698 24.4416 11.3928 24.4352 9.51667C24.4328 8.82155 24.4233 8.12632 24.4019 7.43192C24.3916 7.08919 24.084 6.82262 23.6962 6.80952C22.7889 6.77866 21.8807 6.77124 20.9741 6.72704C20.5569 6.70169 20.1422 6.64632 19.7331 6.56125C19.367 6.48978 18.984 6.03822 18.9426 5.67011C18.908 5.39458 18.8881 5.11746 18.8828 4.83982C18.8778 4.00593 18.8883 3.17202 18.8873 2.33813C18.8761 2.20098 18.8202 2.0712 18.7281 1.96863C18.6359 1.86608 18.5127 1.79644 18.377 1.77017C18.1686 1.75135 17.96 1.72744 17.7511 1.72386C15.1671 1.67943 12.5831 1.62864 9.99916 1.60136C8.95229 1.5904 7.9047 1.63303 6.85746 1.65209C6.08708 1.67099 5.32626 1.82663 4.61083 2.11185C3.6123 2.50057 3.04536 3.24478 2.95218 4.31503C2.93111 4.66202 2.93452 5.01008 2.96246 5.35659C3.08915 7.65065 3.0431 9.94451 2.99763 12.2399C2.92741 15.7861 2.8877 19.3331 2.85899 22.8798C2.84607 23.7142 2.89367 24.5484 3.00135 25.3759C3.05514 25.8287 3.2244 26.2602 3.49306 26.6295C3.76173 26.9989 4.12083 27.2933 4.53618 27.4851C4.97532 27.6961 5.43737 27.856 5.91323 27.9617C6.93204 28.2068 7.97259 28.3516 9.01988 28.3939C10.7659 28.4433 12.5105 28.5183 14.4612 28.5907ZM21.7153 5.34205C22.0501 5.32454 22.3254 5.32836 22.5917 5.2869C22.6902 5.27154 22.7843 5.1596 22.8549 5.07144C22.8652 5.0404 22.8679 5.00734 22.863 4.97501C22.8578 4.94267 22.8452 4.9119 22.8259 4.88542C22.3322 4.23959 21.728 3.68537 21.0412 3.24822C20.9875 3.24004 20.9326 3.24338 20.8804 3.25788C20.828 3.27238 20.7793 3.29771 20.7376 3.33233C20.7124 3.86841 20.6997 4.40635 20.7201 4.94243C20.7358 5.00712 20.767 5.06699 20.8111 5.11705C20.855 5.16711 20.9105 5.20589 20.973 5.22989C21.2173 5.28499 21.4655 5.32235 21.7153 5.34181V5.34205Z"
                fill="#ED1117"
              />
              <path
                d="M13.3511 10.3594C15.3774 10.3873 17.4037 10.4115 19.4299 10.4458C19.9189 10.4489 20.4074 10.4777 20.8933 10.5321C21.1657 10.5849 21.4312 10.6683 21.6847 10.7806C21.8943 10.8578 22.1362 11.237 22.129 11.4451C22.122 11.6487 21.842 12.0211 21.6564 12.0939C20.9946 12.3529 20.3008 12.4042 19.601 12.4145C18.2034 12.4348 16.8053 12.487 15.4086 12.4621C13.5933 12.4294 11.779 12.3368 9.96436 12.2646C8.84738 12.2202 7.73053 12.1719 6.61476 12.1118C6.26163 12.1086 5.92059 11.9833 5.64994 11.7574C5.56651 11.6946 5.49891 11.6134 5.45255 11.5201C5.40616 11.4267 5.38229 11.3238 5.38282 11.2197C5.39479 10.9802 5.61311 10.6173 5.82545 10.5787C6.16323 10.5021 6.50706 10.4551 6.85306 10.4381C9.01929 10.4255 11.1857 10.4317 13.3519 10.4317L13.3511 10.3594Z"
                fill="#ED1117"
              />
              <path
                d="M14.0061 15.5942C12.0794 15.544 10.1933 15.5059 8.3082 15.44C7.68103 15.4153 7.05594 15.3529 6.43637 15.2529C6.16758 15.1902 5.91345 15.0764 5.68787 14.918C5.63597 14.8762 5.59375 14.8237 5.56407 14.7642C5.53439 14.7046 5.51794 14.6395 5.51585 14.573C5.51377 14.5066 5.5261 14.4405 5.55202 14.3792C5.57793 14.3179 5.61678 14.2629 5.66598 14.218C5.8293 14.0915 6.02058 14.0058 6.22391 13.9678C6.70702 13.8978 7.19416 13.8582 7.68229 13.8497C10.5467 13.8227 13.4119 13.7637 16.2753 13.8103C17.948 13.8375 19.6179 14.0387 21.2884 14.17C21.4254 14.1969 21.558 14.2413 21.6832 14.3022C21.869 14.3693 22.1226 14.8101 22.0371 14.9867C21.9517 15.1634 21.8306 15.3679 21.6685 15.4507C21.0942 15.7433 20.4548 15.7529 19.8261 15.7507C17.8714 15.743 15.9124 15.8907 14.0061 15.5942Z"
                fill="#ED1117"
              />
              <path
                d="M13.6313 17.4472C15.6596 17.4747 17.6881 17.4988 19.7163 17.5325C20.1355 17.5351 20.5543 17.5638 20.97 17.6184C21.1679 17.6465 21.3554 17.7706 21.5397 17.8662C21.7382 17.969 21.9385 18.4013 21.8413 18.5838C21.7478 18.759 21.6108 18.9585 21.4418 19.0354C21.1867 19.144 20.9125 19.2017 20.635 19.2046C18.8869 19.2484 17.1383 19.3009 15.39 19.2965C13.6417 19.2919 11.8916 19.2592 10.1457 19.1721C8.8908 19.1094 7.64043 18.9449 6.39043 18.8051C6.18338 18.7792 5.98854 18.6933 5.83022 18.5579C5.6934 18.4105 5.59507 18.2319 5.54395 18.0377C5.50065 17.9082 5.75594 17.5761 5.88429 17.5598C6.29507 17.4908 6.70958 17.4461 7.12567 17.426C9.29406 17.4127 11.4626 17.4199 13.6311 17.4199L13.6313 17.4472Z"
                fill="#ED1117"
              />
              <path
                d="M11.3991 22.7131C9.94282 22.6605 8.48633 22.6127 7.03044 22.5523C6.54106 22.5512 6.06294 22.406 5.65652 22.1344C5.5432 22.0559 5.45214 21.9497 5.39215 21.8258C5.33217 21.7019 5.30532 21.5647 5.31414 21.4276C5.31894 21.1853 5.57542 20.8889 5.79648 20.8023C6.39595 20.5673 7.02006 20.5813 7.64499 20.6081C9.44745 20.6851 11.2513 20.7419 13.0515 20.8562C14.1572 20.9264 15.2576 21.0843 16.3593 21.2107C16.4945 21.2396 16.6268 21.2802 16.755 21.332C16.8785 21.3689 17.131 21.6975 17.0779 21.8216C17.002 22.0002 16.9105 22.2213 16.7578 22.308C16.5173 22.4405 16.2504 22.5183 15.9761 22.5356C14.9377 22.6024 13.8974 22.6429 12.8573 22.6785C12.3721 22.6956 11.8857 22.6817 11.3999 22.6817L11.3991 22.7131Z"
                fill="#ED1117"
              />
              <path
                d="M8.60172 8.35172C7.92378 8.30919 7.15421 8.2842 6.3917 8.20188C6.04715 8.15081 5.71181 8.05051 5.39603 7.90406C5.30011 7.86217 5.218 7.79417 5.15914 7.70791C5.10031 7.62164 5.06708 7.5206 5.06334 7.41636C5.04646 7.1837 5.28824 6.82357 5.49758 6.77151C5.56362 6.74868 5.63112 6.73036 5.69965 6.71672C7.37002 6.54101 9.04209 6.46355 10.7168 6.65308C10.8551 6.67129 10.9894 6.7125 11.114 6.77489C11.2401 6.83232 11.3502 6.91934 11.4351 7.0285C11.5199 7.13767 11.5769 7.26569 11.6011 7.40159C11.6419 7.60793 11.3915 7.99264 11.1747 8.06482C10.9828 8.14526 10.782 8.20299 10.5766 8.237C9.94971 8.28918 9.32104 8.31228 8.60172 8.35172Z"
                fill="#ED1117"
              />
            </g>
          </g>
          <path
            d="M30.8107 27.6285H32.4851C32.7071 27.6285 32.9201 27.5403 33.0771 27.3833C33.2341 27.2263 33.3223 27.0134 33.3223 26.7913C33.3223 26.5693 33.2341 26.3563 33.0771 26.1993C32.9201 26.0423 32.7071 25.9541 32.4851 25.9541H30.8107V25.1169C30.8033 24.7312 30.7441 24.3483 30.6349 23.9783C31.4218 23.6766 32.0994 23.1444 32.5789 22.4513C33.0584 21.7582 33.3175 20.9364 33.3223 20.0937C33.3223 19.8716 33.2341 19.6587 33.0771 19.5017C32.9201 19.3447 32.7071 19.2564 32.4851 19.2564C32.2631 19.2564 32.0501 19.3447 31.8931 19.5017C31.7361 19.6587 31.6479 19.8716 31.6479 20.0937C31.6472 20.6335 31.4725 21.1588 31.1498 21.5916C30.8271 22.0244 30.3735 22.3417 29.8563 22.4964C29.4434 21.9673 28.9093 21.5452 28.2991 21.2658C28.3077 21.1543 28.3077 21.0423 28.2991 20.9309C28.2991 20.0427 27.9462 19.1909 27.3182 18.5629C26.6902 17.9349 25.8384 17.582 24.9502 17.582C24.0621 17.582 23.2103 17.9349 22.5822 18.5629C21.9542 19.1909 21.6014 20.0427 21.6014 20.9309C21.5927 21.0423 21.5927 21.1543 21.6014 21.2658C20.979 21.5406 20.433 21.963 20.0107 22.4964C19.4997 22.3358 19.0535 22.0159 18.7372 21.5836C18.4209 21.1514 18.2511 20.6293 18.2525 20.0937C18.2525 19.8716 18.1643 19.6587 18.0073 19.5017C17.8503 19.3447 17.6374 19.2564 17.4153 19.2564C17.1933 19.2564 16.9803 19.3447 16.8233 19.5017C16.6663 19.6587 16.5781 19.8716 16.5781 20.0937C16.583 20.9364 16.8421 21.7582 17.3216 22.4513C17.8011 23.1444 18.4786 23.6766 19.2656 23.9783C19.1563 24.3483 19.0972 24.7312 19.0898 25.1169V25.9541H17.4153C17.1933 25.9541 16.9803 26.0423 16.8233 26.1993C16.6663 26.3563 16.5781 26.5693 16.5781 26.7913C16.5781 27.0134 16.6663 27.2263 16.8233 27.3833C16.9803 27.5403 17.1933 27.6285 17.4153 27.6285H19.0898V28.4658C19.0905 28.8538 19.1297 29.2408 19.207 29.6211C18.4336 29.931 17.7703 30.4647 17.302 31.1537C16.8337 31.8428 16.5817 32.6559 16.5781 33.489C16.5781 33.7111 16.6663 33.924 16.8233 34.081C16.9803 34.238 17.1933 34.3262 17.4153 34.3262C17.6374 34.3262 17.8503 34.238 18.0073 34.081C18.1643 33.924 18.2525 33.7111 18.2525 33.489C18.2548 33.0007 18.3993 32.5237 18.6685 32.1163C18.9376 31.7089 19.3197 31.3887 19.7679 31.1951C20.2658 32.1379 21.0115 32.9271 21.9247 33.4776C22.8379 34.0281 23.8839 34.319 24.9502 34.319C26.0165 34.319 27.0626 34.0281 27.9758 33.4776C28.8889 32.9271 29.6347 32.1379 30.1325 31.1951C30.5808 31.3887 30.9628 31.7089 31.232 32.1163C31.5011 32.5237 31.6456 33.0007 31.6479 33.489C31.6479 33.7111 31.7361 33.924 31.8931 34.081C32.0501 34.238 32.2631 34.3262 32.4851 34.3262C32.7071 34.3262 32.9201 34.238 33.0771 34.081C33.2341 33.924 33.3223 33.7111 33.3223 33.489C33.3188 32.6559 33.0667 31.8428 32.5984 31.1537C32.1301 30.4647 31.4668 29.931 30.6935 29.6211C30.7707 29.2408 30.81 28.8538 30.8107 28.4658V27.6285ZM24.113 32.5681C23.1675 32.3751 22.3177 31.8613 21.7075 31.1138C21.0972 30.3662 20.764 29.4308 20.7642 28.4658V25.1169C20.7642 24.4508 21.0288 23.8119 21.4998 23.3409C21.9708 22.8699 22.6097 22.6053 23.2758 22.6053H24.113V32.5681ZM23.2758 20.9309C23.2758 20.4868 23.4522 20.0609 23.7662 19.7469C24.0802 19.4329 24.5061 19.2564 24.9502 19.2564C25.3943 19.2564 25.8202 19.4329 26.1342 19.7469C26.4482 20.0609 26.6246 20.4868 26.6246 20.9309H23.2758ZM29.1363 28.4658C29.1365 29.4308 28.8032 30.3662 28.193 31.1138C27.5827 31.8613 26.7329 32.3751 25.7874 32.5681V22.6053H26.6246C27.2908 22.6053 27.9296 22.8699 28.4006 23.3409C28.8716 23.8119 29.1363 24.4508 29.1363 25.1169V28.4658Z"
            fill="black"
          />
          <defs>
            <clipPath id="clip0_1499_52839">
              <rect
                width="25.5451"
                height="30.1395"
                fill="white"
                transform="translate(0.671875)"
              />
            </clipPath>
          </defs>
        </svg>
      )

      break
    case "baocaodoiphongthu":
      iconElement = (
        <svg
          width="31"
          height="36"
          viewBox="0 0 31 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1499_52853)">
            <mask
              id="mask0_1499_52853"
              mask-type="luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="28"
              height="33"
            >
              <path d="M27.5134 0H0.25V32.4H27.5134V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_1499_52853)">
              <path
                d="M27.3992 16.6051C27.3992 19.525 27.4081 22.4448 27.3932 25.3647C27.3976 26.1129 27.3517 26.8609 27.2561 27.6029C27.058 29.0131 26.3213 30.1103 25.1333 30.9022C24.2653 31.497 23.2599 31.8633 22.211 31.9664C18.244 32.3615 14.2485 32.386 10.2769 32.0395C8.70476 31.9026 7.11617 31.8979 5.58608 31.4632C4.78884 31.2538 4.0103 30.9796 3.2584 30.643C1.81344 29.9596 0.940362 28.7968 0.600984 27.2263C0.394548 26.3519 0.284715 25.4578 0.273438 24.5599C0.298044 19.5435 0.315194 14.527 0.32488 9.51054C0.341345 8.01297 0.457134 6.5182 0.67147 5.03584C0.756678 4.36814 0.929624 3.71444 1.18587 3.09162C1.88598 1.44165 3.1267 0.44394 4.96596 0.337134C6.99181 0.219317 9.01945 0.113459 11.0479 0.0682524C12.9264 0.0258636 14.8077 0.0403076 16.6864 0.0853859C18.1127 0.119707 19.5371 0.239059 20.962 0.32563C21.3388 0.350663 21.7001 0.485014 22.001 0.712196C23.817 2.04799 25.4765 3.58306 26.9477 5.28832C27.3683 5.77012 27.4847 6.31617 27.475 6.9474C27.4227 10.1661 27.4025 13.3855 27.3709 16.6046L27.3992 16.6051ZM14.9206 30.736C16.8022 30.6677 18.9027 30.5952 21.0033 30.5124C21.4536 30.4948 21.9036 30.4577 22.3489 30.3954C23.023 30.2998 23.6516 30.0021 24.1517 29.542C24.9067 28.8667 25.4119 28.0476 25.5018 27.0349C25.5877 26.0684 25.6138 25.0956 25.6417 24.125C25.693 22.3322 25.7298 20.5393 25.7657 18.7465C25.7821 17.9247 25.8574 17.0952 25.7756 16.2823C25.5721 14.266 25.6496 12.2483 25.6426 10.2314C25.6401 9.48414 25.6298 8.73677 25.6069 7.99029C25.5958 7.62186 25.2651 7.33529 24.8483 7.32121C23.8729 7.28804 22.8965 7.28006 21.922 7.23254C21.4735 7.2053 21.0276 7.14577 20.5879 7.05432C20.1943 6.97749 19.7826 6.49206 19.7381 6.09635C19.7009 5.80015 19.6795 5.50224 19.6738 5.20379C19.6684 4.30736 19.6797 3.4109 19.6787 2.51447C19.6666 2.36703 19.6065 2.22751 19.5075 2.11725C19.4084 2.00701 19.2759 1.93214 19.1301 1.90391C18.9061 1.88367 18.6818 1.85797 18.4572 1.85413C15.6795 1.80636 12.9017 1.75177 10.1239 1.72244C8.99851 1.71066 7.87235 1.75648 6.74657 1.77697C5.91842 1.79729 5.10054 1.96461 4.33145 2.27121C3.25802 2.68909 2.64857 3.48912 2.5484 4.63963C2.52574 5.01265 2.52942 5.38681 2.55945 5.75931C2.69565 8.22542 2.64614 10.6913 2.59726 13.1588C2.52177 16.971 2.47908 20.7841 2.44822 24.5968C2.43433 25.4937 2.4855 26.3905 2.60125 27.2801C2.65908 27.7669 2.84103 28.2307 3.12984 28.6276C3.41866 29.0247 3.80469 29.3412 4.2512 29.5475C4.72327 29.7743 5.21998 29.9462 5.73153 30.0598C6.82674 30.3233 7.94533 30.479 9.07118 30.5244C10.9481 30.5776 12.8236 30.6582 14.9206 30.736ZM22.7187 5.74368C23.0787 5.72485 23.3746 5.72896 23.6609 5.68439C23.7668 5.66788 23.868 5.54754 23.9438 5.45277C23.9549 5.41941 23.9578 5.38386 23.9525 5.34911C23.947 5.31434 23.9334 5.28127 23.9126 5.2528C23.382 4.55853 22.7324 3.96275 21.9941 3.49281C21.9364 3.48402 21.8773 3.48762 21.8212 3.5032C21.7649 3.51879 21.7126 3.54601 21.6677 3.58323C21.6407 4.15952 21.627 4.7378 21.649 5.31409C21.6657 5.38363 21.6993 5.44799 21.7467 5.50181C21.794 5.55562 21.8536 5.59731 21.9208 5.62311C22.1834 5.68234 22.4503 5.7225 22.7187 5.74343V5.74368Z"
                fill="#0E8CF1"
              />
              <path
                d="M13.7222 11.1367C15.9004 11.1667 18.0787 11.1928 20.2569 11.2296C20.7826 11.233 21.3077 11.2639 21.83 11.3224C22.1228 11.3792 22.4083 11.4688 22.6807 11.5896C22.9061 11.6725 23.1661 12.0802 23.1584 12.3039C23.1509 12.5228 22.8498 12.9231 22.6503 13.0013C21.9389 13.2797 21.1931 13.3349 20.4408 13.3459C18.9384 13.3679 17.4354 13.4239 15.934 13.3972C13.9825 13.362 12.0322 13.2625 10.0814 13.1849C8.88066 13.1371 7.68004 13.0852 6.48059 13.0205C6.10098 13.0171 5.73436 12.8825 5.44341 12.6396C5.35372 12.5721 5.28106 12.4848 5.23121 12.3845C5.18135 12.2841 5.15569 12.1735 5.15626 12.0616C5.16912 11.8041 5.40382 11.414 5.63208 11.3724C5.9952 11.2902 6.36482 11.2396 6.73677 11.2214C9.06546 11.2078 11.3943 11.2145 13.723 11.2145L13.7222 11.1367Z"
                fill="#0E8CF1"
              />
              <path
                d="M14.4241 16.7644C12.3529 16.7105 10.3254 16.6695 8.2989 16.5987C7.62468 16.5722 6.95272 16.5051 6.28668 16.3975C5.99773 16.3301 5.72454 16.2078 5.48203 16.0375C5.42624 15.9926 5.38086 15.9362 5.34896 15.8722C5.31705 15.8082 5.29937 15.7381 5.29712 15.6666C5.29488 15.5953 5.30814 15.5242 5.336 15.4583C5.36385 15.3925 5.40562 15.3333 5.4585 15.285C5.63408 15.149 5.8397 15.0569 6.05828 15.0161C6.57763 14.9408 7.1013 14.8983 7.62604 14.8892C10.7053 14.8601 13.7853 14.7967 16.8635 14.8468C18.6616 14.876 20.4568 15.0923 22.2526 15.2334C22.3998 15.2624 22.5425 15.3101 22.677 15.3756C22.8767 15.4476 23.1494 15.9215 23.0575 16.1114C22.9656 16.3013 22.8355 16.5212 22.6612 16.6102C22.0438 16.9247 21.3565 16.9351 20.6807 16.9327C18.5793 16.9244 16.4734 17.0832 14.4241 16.7644Z"
                fill="#0E8CF1"
              />
              <path
                d="M14.0273 18.758C16.2077 18.7875 18.3883 18.8134 20.5686 18.8497C21.0193 18.8525 21.4695 18.8833 21.9164 18.942C22.1292 18.9722 22.3307 19.1057 22.5288 19.2084C22.7422 19.3189 22.9575 19.7837 22.853 19.9798C22.7525 20.1681 22.6053 20.3827 22.4235 20.4653C22.1493 20.582 21.8546 20.644 21.5562 20.6472C19.677 20.6942 17.7973 20.7507 15.9179 20.746C14.0385 20.7411 12.1571 20.7059 10.2803 20.6122C8.93124 20.5449 7.58709 20.3681 6.24334 20.2177C6.02077 20.1899 5.81132 20.0976 5.64112 19.952C5.49403 19.7935 5.38834 19.6015 5.33338 19.3928C5.28683 19.2536 5.56126 18.8965 5.69924 18.879C6.14083 18.8048 6.58643 18.7568 7.03372 18.7352C9.36475 18.7209 11.6959 18.7286 14.0271 18.7286L14.0273 18.758Z"
                fill="#0E8CF1"
              />
              <path
                d="M11.629 24.4189C10.0635 24.3624 8.4978 24.311 6.93272 24.246C6.40664 24.2449 5.89266 24.0888 5.45576 23.7968C5.33394 23.7124 5.23605 23.5982 5.17157 23.4651C5.10708 23.3319 5.07822 23.1843 5.0877 23.037C5.09286 22.7766 5.36857 22.4579 5.60622 22.3649C6.25064 22.1122 6.92156 22.1272 7.59337 22.156C9.53101 22.2388 11.4702 22.2999 13.4054 22.4227C14.594 22.4982 15.7769 22.6679 16.9613 22.8038C17.1066 22.8349 17.2488 22.8785 17.3866 22.9342C17.5194 22.9739 17.7908 23.3272 17.7338 23.4605C17.6521 23.6526 17.5538 23.8902 17.3897 23.9835C17.1311 24.1259 16.8441 24.2095 16.5493 24.2281C15.433 24.3 14.3147 24.3434 13.1966 24.3818C12.675 24.4001 12.1521 24.3851 11.6299 24.3851L11.629 24.4189Z"
                fill="#0E8CF1"
              />
              <path
                d="M8.61716 8.97956C7.88838 8.93385 7.06109 8.90698 6.24139 8.81849C5.871 8.76359 5.51051 8.65576 5.17104 8.49832C5.06794 8.4533 4.97967 8.3802 4.91639 8.28747C4.85315 8.19473 4.81743 8.08611 4.8134 7.97406C4.79526 7.72394 5.05517 7.3368 5.28022 7.28083C5.3512 7.2563 5.42376 7.2366 5.49743 7.22194C7.29308 7.03305 9.09055 6.94978 10.8908 7.15353C11.0395 7.1731 11.1839 7.2174 11.3179 7.28447C11.4534 7.34621 11.5718 7.43975 11.663 7.5571C11.7542 7.67446 11.8154 7.81208 11.8415 7.95817C11.8853 8.17999 11.6162 8.59355 11.3831 8.67115C11.1768 8.75762 10.961 8.81968 10.7401 8.85625C10.0662 8.91233 9.39043 8.93717 8.61716 8.97956Z"
                fill="#0E8CF1"
              />
            </g>
          </g>
          <path
            d="M15.716 18.1484L17.0685 18.6588C17.4205 18.7923 17.7756 18.8712 18.1235 18.8955C18.2905 18.9071 18.4533 18.9061 18.6126 18.8945L16.4904 19.0513C16.3311 19.0629 16.1682 19.0639 16.0013 19.0523C15.6533 19.028 15.2982 18.9491 14.9462 18.8156L13.5938 18.3052L15.716 18.1484Z"
            fill="url(#paint0_linear_1499_52853)"
          />
          <path
            d="M23.4816 14.4023L24.1953 15.86C24.7223 16.9358 26.2023 19.4566 28.5587 19.621C28.7211 19.6321 28.8859 19.6316 29.0518 19.6195L26.9296 19.7763C26.7637 19.7884 26.5988 19.7889 26.4364 19.7778C24.08 19.6134 22.6001 17.0926 22.073 16.0168L21.3594 14.5591L23.4816 14.4023Z"
            fill="url(#paint1_linear_1499_52853)"
          />
          <path
            d="M21.3024 16.543C20.1391 18.5216 18.2505 20.2817 15.9714 20.1229C15.5582 20.0941 15.1318 20.002 14.6953 19.8371L15.2532 24.1833C15.7984 28.4355 17.8008 32.2632 20.7763 34.7416C23.8824 32.6871 26.0982 29.1527 26.8867 24.9936L27.6934 20.7425C27.2484 20.8462 26.819 20.8785 26.4057 20.8497C24.1257 20.6909 22.3468 18.6748 21.3024 16.543Z"
            fill="url(#paint2_radial_1499_52853)"
          />
          <path
            d="M16.0008 19.0544C18.3567 19.2182 19.9762 16.9134 20.5629 15.915L21.3585 14.5625L22.0722 16.0202C22.5992 17.096 24.0792 19.6168 26.4356 19.7812C26.7836 19.8055 27.1417 19.7751 27.5003 19.6922L28.877 19.372L27.7608 25.2568C26.9191 29.6925 24.5364 33.4935 21.2235 35.6845L20.739 36.0052L20.2741 35.6183C17.1014 32.975 14.9477 28.858 14.3656 24.3236L13.5938 18.3073L14.9462 18.8177C15.2977 18.9507 15.6528 19.0301 16.0008 19.0544ZM15.2517 24.185C15.7969 28.4372 17.7993 32.2649 20.7749 34.7433C23.8809 32.6888 26.0967 29.1544 26.8852 24.9953L27.692 20.7442C27.2469 20.8479 26.8175 20.8802 26.4042 20.8514C24.1247 20.6926 22.3458 18.6771 21.3014 16.5447C20.1381 18.5233 18.2495 20.2834 15.9704 20.1246C15.5572 20.0958 15.1308 20.0037 14.6943 19.8388L15.2517 24.185Z"
            fill="url(#paint3_linear_1499_52853)"
          />
          <path
            d="M21.2189 35.6803C24.5323 33.4887 26.9145 29.6877 27.7562 25.2525L28.8724 19.3677L30.9947 19.2109L29.8784 25.0957C29.0368 29.5315 26.6541 33.3324 23.3412 35.5235L22.8566 35.8441L20.7344 36.0009L21.2189 35.6803Z"
            fill="url(#paint4_linear_1499_52853)"
          />
          <mask
            id="mask1_1499_52853"
            mask-type="luminance"
            maskUnits="userSpaceOnUse"
            x="19"
            y="26"
            width="3"
            height="2"
          >
            <path
              d="M21.1681 26.9273L20.0391 27.5833C20.0133 27.5985 19.9774 27.5964 19.938 27.5732C19.8596 27.5282 19.7964 27.4179 19.7969 27.3279L20.9258 26.6719C20.9253 26.7619 20.989 26.8717 21.0669 26.9172C21.1069 26.9399 21.1423 26.942 21.1681 26.9273Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_1499_52853)">
            <path
              d="M20.9501 26.7791C20.949 26.7766 20.948 26.7745 20.947 26.7725C20.946 26.7705 20.945 26.768 20.9445 26.7654C20.9435 26.7629 20.9425 26.7609 20.942 26.7584C20.941 26.7558 20.9405 26.7533 20.9394 26.7513C20.9384 26.7488 20.9379 26.7462 20.9369 26.7437C20.9359 26.7412 20.9354 26.7386 20.9349 26.7361C20.9339 26.7336 20.9334 26.7311 20.9329 26.7285C20.9324 26.726 20.9319 26.7235 20.9313 26.7209C20.9308 26.7184 20.9303 26.7159 20.9298 26.7133C20.9293 26.7108 20.9288 26.7088 20.9288 26.7063C20.9283 26.7037 20.9278 26.7012 20.9278 26.6992C20.9273 26.6967 20.9273 26.6946 20.9268 26.6921C20.9268 26.6901 20.9263 26.6876 20.9263 26.685C20.9263 26.683 20.9263 26.6805 20.9258 26.6785C20.9258 26.6764 20.9258 26.6744 20.9258 26.6719L19.7969 27.3279C19.7969 27.3299 19.7969 27.3324 19.7974 27.3345C19.7974 27.3365 19.7974 27.339 19.7974 27.3415C19.7979 27.3436 19.7979 27.3461 19.7979 27.3481C19.7984 27.3506 19.7984 27.3527 19.7984 27.3552C19.7989 27.3577 19.7989 27.3597 19.7994 27.3623C19.7999 27.3648 19.8004 27.3673 19.8009 27.3693C19.8014 27.3719 19.8019 27.3744 19.8024 27.3769C19.8029 27.3795 19.8035 27.382 19.8045 27.3845C19.805 27.3871 19.8055 27.3896 19.8065 27.3921C19.8075 27.3946 19.808 27.3972 19.8085 27.3997C19.8095 27.4022 19.81 27.4048 19.811 27.4073C19.812 27.4093 19.8126 27.4123 19.8136 27.4149C19.8146 27.4169 19.8151 27.4194 19.8161 27.422C19.8171 27.424 19.8181 27.4265 19.8186 27.4285C19.8196 27.4311 19.8206 27.4331 19.8217 27.4356C19.8227 27.4381 19.8237 27.4402 19.8247 27.4427L20.9536 26.7867C20.9521 26.7831 20.9511 26.7811 20.9501 26.7791Z"
              fill="#103247"
            />
            <path
              d="M21.1604 26.9323C21.1568 26.9333 21.1538 26.9344 21.1502 26.9349C21.1477 26.9354 21.1452 26.9359 21.1422 26.9359C21.1396 26.9359 21.1371 26.9364 21.1346 26.9364C21.1325 26.9364 21.13 26.9359 21.128 26.9359C21.126 26.9359 21.1234 26.9354 21.1214 26.9354C21.1194 26.9349 21.1174 26.9349 21.1153 26.9344C21.1133 26.9339 21.1118 26.9334 21.1093 26.9328C21.1073 26.9323 21.1052 26.9318 21.1032 26.9313C21.1012 26.9303 21.0992 26.9298 21.0976 26.9293C21.0956 26.9283 21.0941 26.9278 21.0921 26.9273C21.0901 26.9268 21.0885 26.9258 21.0865 26.9248C21.0845 26.9237 21.083 26.9227 21.081 26.9217C21.0789 26.9207 21.0769 26.9197 21.0749 26.9187C21.0734 26.9177 21.0719 26.9172 21.0703 26.9162C21.0698 26.9156 21.0693 26.9156 21.0688 26.9151C21.0668 26.9141 21.0648 26.9126 21.0627 26.9116C21.0607 26.9106 21.0587 26.9091 21.0567 26.9076C21.0547 26.906 21.0526 26.9045 21.0506 26.903C21.0486 26.9015 21.0466 26.9 21.0445 26.8985C21.0425 26.8969 21.0405 26.8949 21.0385 26.8934C21.0364 26.8914 21.0339 26.8899 21.0324 26.8878C21.0304 26.8858 21.0284 26.8843 21.0263 26.8823C21.0243 26.8802 21.0223 26.8787 21.0203 26.8762C21.0182 26.8742 21.0162 26.8722 21.0147 26.8701C21.0127 26.8681 21.0112 26.8661 21.0091 26.8641C21.0071 26.862 21.0056 26.86 21.0036 26.858C21.0015 26.856 21 26.8534 20.998 26.8514C20.996 26.8489 20.9935 26.8459 20.9919 26.8433C20.9889 26.8388 20.9859 26.8347 20.9828 26.8307C20.9788 26.8251 20.9757 26.8195 20.9722 26.814C20.9702 26.8099 20.9672 26.8054 20.9651 26.8013C20.9636 26.7983 20.9621 26.7953 20.9606 26.7927C20.9591 26.7902 20.958 26.7877 20.957 26.7852L19.8281 27.4412C19.8291 27.4437 19.8302 27.4462 19.8317 27.4487C19.8332 27.4518 19.8347 27.4543 19.8362 27.4573C19.8387 27.4619 19.8408 27.4659 19.8433 27.47C19.8468 27.4755 19.8499 27.4811 19.8539 27.4867C19.857 27.4912 19.86 27.4953 19.863 27.4993C19.8651 27.5019 19.8671 27.5049 19.8696 27.5074C19.8711 27.5099 19.8731 27.512 19.8752 27.514C19.8767 27.516 19.8787 27.518 19.8807 27.5206C19.8828 27.5226 19.8843 27.5246 19.8863 27.5266C19.8883 27.5287 19.8903 27.5307 19.8924 27.5327C19.8944 27.5347 19.8964 27.5368 19.8984 27.5388C19.9005 27.5408 19.9025 27.5428 19.9045 27.5448C19.9065 27.5469 19.9085 27.5484 19.9106 27.5504C19.9126 27.5519 19.9151 27.5539 19.9171 27.5555C19.9192 27.557 19.9212 27.559 19.9232 27.5605C19.9252 27.562 19.9273 27.5636 19.9293 27.5651C19.9313 27.5666 19.9333 27.5676 19.9354 27.5691C19.9374 27.5701 19.9394 27.5717 19.9414 27.5727C19.9419 27.5727 19.9424 27.5732 19.9429 27.5732C19.9445 27.5742 19.946 27.5752 19.9475 27.5757C19.9495 27.5767 19.9515 27.5777 19.9536 27.5787C19.9556 27.5797 19.9576 27.5808 19.9591 27.5813C19.9612 27.5823 19.9627 27.5828 19.9647 27.5838C19.9667 27.5843 19.9682 27.5853 19.9703 27.5858C19.9723 27.5863 19.9738 27.5873 19.9758 27.5878C19.9778 27.5883 19.9799 27.5888 19.9819 27.5894C19.9839 27.5899 19.9859 27.5904 19.988 27.5904C19.99 27.5909 19.992 27.5914 19.994 27.5914C19.9966 27.5919 19.9986 27.5919 20.0006 27.5919C20.0026 27.5919 20.0052 27.5919 20.0072 27.5919C20.0097 27.5919 20.0122 27.5919 20.0143 27.5914C20.0173 27.5909 20.0198 27.5904 20.0224 27.5904C20.0254 27.5899 20.0289 27.5888 20.0325 27.5878C20.0365 27.5863 20.0406 27.5848 20.0441 27.5823L21.173 26.9263C21.168 26.9293 21.1644 26.9313 21.1604 26.9323Z"
              fill="#103247"
            />
          </g>
          <path
            d="M19.4529 23.4518C19.4473 23.4487 19.4423 23.4462 19.4372 23.4437C19.4317 23.4412 19.4266 23.4386 19.4215 23.4361C19.4165 23.4341 19.4114 23.4315 19.4064 23.4295C19.4013 23.4275 19.3963 23.4255 19.3912 23.424C19.3902 23.4234 19.3892 23.4229 19.3882 23.4229C19.3877 23.4229 19.3872 23.4224 19.3866 23.4224C19.3831 23.4209 19.3791 23.4199 19.3755 23.4184C19.3705 23.4169 19.3649 23.4154 19.3598 23.4143C19.3548 23.4128 19.3492 23.4118 19.3442 23.4108C19.3386 23.4098 19.3325 23.4088 19.3275 23.4083C19.3234 23.4078 19.3199 23.4073 19.3158 23.4073C19.3153 23.4073 19.3148 23.4073 19.3143 23.4073C19.3128 23.4073 19.3118 23.4068 19.3103 23.4068C19.3042 23.4063 19.2981 23.4062 19.2921 23.4062C19.2855 23.4062 19.2784 23.4068 19.2718 23.4073C19.2642 23.4078 19.2572 23.4093 19.2496 23.4108C19.2491 23.4108 19.2491 23.4108 19.2491 23.4108C19.2486 23.4108 19.2486 23.4108 19.2481 23.4113C19.2395 23.4133 19.2309 23.4154 19.2228 23.4184C19.2121 23.4224 19.2015 23.427 19.1914 23.4331L18.0625 24.0896C18.0797 24.0794 18.0989 24.0724 18.1191 24.0683C18.1191 24.0683 18.1197 24.0678 18.1202 24.0678C18.1404 24.0638 18.1621 24.0628 18.1849 24.0643C18.1854 24.0643 18.1859 24.0643 18.1864 24.0643C18.2092 24.0663 18.233 24.0714 18.2577 24.08C18.2577 24.08 18.2582 24.08 18.2587 24.0805C18.2835 24.0891 18.3093 24.1007 18.3361 24.1159L19.465 23.4599C19.461 23.4563 19.4575 23.4538 19.4529 23.4518Z"
            fill="url(#paint5_linear_1499_52853)"
          />
          <path
            d="M19.7989 26.5349L20.9283 25.8789L20.9258 26.6659L19.7969 27.3219L19.7989 26.5349Z"
            fill="#103247"
          />
          <mask
            id="mask2_1499_52853"
            mask-type="luminance"
            maskUnits="userSpaceOnUse"
            x="19"
            y="25"
            width="2"
            height="2"
          >
            <path
              d="M19.7302 25.9333L20.8591 25.2773C20.8039 25.3092 20.77 25.3775 20.7695 25.4736C20.769 25.6081 20.8353 25.7624 20.9319 25.8772L19.803 26.5332C19.7064 26.4184 19.6401 26.2646 19.6406 26.1301C19.6411 26.033 19.675 25.9652 19.7302 25.9333Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_1499_52853)">
            <path
              d="M20.7711 25.4574C20.7716 25.4523 20.7716 25.4478 20.7721 25.4432C20.7726 25.4382 20.7731 25.4331 20.7736 25.4286C20.7741 25.4235 20.7751 25.4185 20.7761 25.4139C20.7771 25.4088 20.7781 25.4038 20.7791 25.3992C20.7802 25.3942 20.7817 25.3886 20.7832 25.3836C20.7847 25.378 20.7867 25.3729 20.7888 25.3674C20.7913 25.3613 20.7933 25.3557 20.7963 25.3497C20.7999 25.3426 20.8034 25.3355 20.808 25.3289C20.8221 25.3067 20.8398 25.2895 20.8611 25.2773L19.7312 25.9328C19.7104 25.945 19.6922 25.9622 19.6781 25.9844C19.674 25.991 19.67 25.9981 19.6664 26.0052C19.6634 26.0107 19.6614 26.0168 19.6588 26.0229C19.6568 26.0279 19.6553 26.0335 19.6533 26.0391C19.6518 26.0441 19.6502 26.0492 19.6492 26.0547C19.6482 26.0598 19.6472 26.0649 19.6462 26.0699C19.6452 26.0745 19.6447 26.0795 19.6437 26.0846C19.6432 26.0896 19.6426 26.0942 19.6421 26.0992C19.6416 26.1043 19.6416 26.1089 19.6411 26.1139C19.6411 26.119 19.6406 26.1235 19.6406 26.1286C19.6406 26.1291 19.6406 26.1291 19.6406 26.1296C19.6406 26.1341 19.6406 26.1387 19.6411 26.1432C19.6411 26.1483 19.6416 26.1529 19.6416 26.1579C19.6421 26.163 19.6421 26.1675 19.6432 26.1726C19.6437 26.1776 19.6442 26.1822 19.6447 26.1872C19.6452 26.1923 19.6462 26.1974 19.6467 26.2024C19.6472 26.2075 19.6482 26.2125 19.6492 26.2176C19.6502 26.2227 19.6512 26.2282 19.6523 26.2333C19.6533 26.2383 19.6548 26.2439 19.6558 26.249C19.6573 26.2545 19.6583 26.2596 19.6604 26.2651C19.6619 26.2707 19.6634 26.2758 19.6649 26.2813C19.6664 26.2864 19.6679 26.2919 19.67 26.2975C19.6715 26.3026 19.6735 26.3076 19.6755 26.3127C19.677 26.3172 19.6791 26.3228 19.6811 26.3274C19.6831 26.3324 19.6851 26.337 19.6872 26.342C19.6892 26.3466 19.6912 26.3516 19.6932 26.3567L20.8221 25.7007C20.8201 25.6956 20.8181 25.6911 20.8161 25.686C20.814 25.681 20.812 25.6764 20.81 25.6714C20.808 25.6668 20.806 25.6612 20.8044 25.6567C20.8024 25.6516 20.8009 25.6466 20.7989 25.6415C20.7968 25.6365 20.7953 25.6309 20.7938 25.6258C20.7923 25.6203 20.7908 25.6152 20.7893 25.6096C20.7877 25.6041 20.7862 25.599 20.7847 25.5935C20.7837 25.5884 20.7822 25.5828 20.7812 25.5778C20.7802 25.5727 20.7791 25.5672 20.7781 25.5621C20.7771 25.557 20.7761 25.552 20.7756 25.5469C20.7751 25.5419 20.7741 25.5368 20.7736 25.5318C20.7731 25.5267 20.7726 25.5216 20.7721 25.5166C20.7716 25.512 20.7711 25.507 20.7706 25.5019C20.77 25.4969 20.77 25.4923 20.77 25.4872C20.7695 25.4827 20.7695 25.4781 20.7695 25.4736C20.7695 25.4731 20.7695 25.4731 20.7695 25.4731C20.7711 25.467 20.7711 25.4625 20.7711 25.4574Z"
              fill="#103247"
            />
            <path
              d="M20.9198 25.8575C20.9153 25.852 20.9112 25.8464 20.9067 25.8408C20.9001 25.8322 20.894 25.8231 20.8879 25.814C20.8788 25.8009 20.8708 25.7877 20.8627 25.7741C20.8576 25.765 20.8525 25.7564 20.8475 25.7473C20.8445 25.7412 20.8414 25.7351 20.8384 25.7296C20.8359 25.7245 20.8333 25.7189 20.8308 25.7139C20.8288 25.7088 20.8262 25.7038 20.8242 25.6992L19.6953 26.3552C19.6973 26.3603 19.6999 26.3648 19.7019 26.3699C19.7044 26.3749 19.7069 26.3805 19.7095 26.3856C19.7125 26.3916 19.7155 26.3977 19.7186 26.4033C19.7236 26.4124 19.7282 26.421 19.7338 26.4301C19.7418 26.4437 19.7499 26.4569 19.759 26.47C19.7651 26.4791 19.7717 26.4882 19.7778 26.4968C19.7818 26.5024 19.7864 26.508 19.7904 26.5135C19.7944 26.5186 19.798 26.5231 19.802 26.5282L20.9309 25.8722C20.9274 25.8676 20.9239 25.8626 20.9198 25.8575Z"
              fill="#103247"
            />
            <path
              d="M19.8047 26.531L20.9336 25.875C20.9346 25.876 20.9356 25.877 20.9366 25.878L19.8077 26.534C19.8067 26.533 19.8057 26.532 19.8047 26.531Z"
              fill="#3C3738"
            />
          </g>
          <mask
            id="mask3_1499_52853"
            mask-type="luminance"
            maskUnits="userSpaceOnUse"
            x="20"
            y="26"
            width="2"
            height="1"
          >
            <path
              d="M21.299 26.0195L20.1701 26.6755C20.1479 26.6887 20.1221 26.6953 20.0938 26.6963L21.2227 26.0403C21.2515 26.0398 21.2768 26.0327 21.299 26.0195Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask3_1499_52853)">
            <path
              d="M20.0938 26.6961L21.2227 26.0401C21.2267 26.0401 21.2302 26.0396 21.2343 26.0391L20.1054 26.6956C20.1018 26.6956 20.0978 26.6956 20.0938 26.6961Z"
              fill="#0D0A0B"
            />
            <path
              d="M20.1016 26.6981L21.2305 26.0416C21.2365 26.0411 21.2421 26.0406 21.2482 26.0391L20.1193 26.6951C20.1137 26.6966 20.1076 26.6971 20.1016 26.6981Z"
              fill="#0D090A"
            />
            <path
              d="M20.125 26.6933L21.2539 26.0373C21.2615 26.0358 21.2686 26.0338 21.2757 26.0312L20.1468 26.6873C20.1397 26.6898 20.1326 26.6918 20.125 26.6933Z"
              fill="#0C0909"
            />
            <path
              d="M20.1484 26.6872L21.2773 26.0312C21.2864 26.0281 21.2945 26.0241 21.3026 26.0195L20.1737 26.6755C20.1656 26.6801 20.157 26.6841 20.1484 26.6872Z"
              fill="#0B0709"
            />
          </g>
          <path
            d="M21.9375 29.1912L23.0664 28.5352C23.0664 28.5357 23.0664 28.5357 23.0664 28.5362L21.9375 29.1922C21.9375 29.1922 21.9375 29.1917 21.9375 29.1912Z"
            fill="#130E10"
          />
          <path
            d="M23.0688 28.5352L21.9399 29.1912C21.9399 29.221 21.9369 29.2483 21.9323 29.2736C21.9323 29.2746 21.9318 29.2756 21.9318 29.2761C21.9267 29.3014 21.9192 29.3237 21.9101 29.3439C21.9096 29.3444 21.9096 29.3444 21.9096 29.3449C21.9015 29.3621 21.8913 29.3763 21.8807 29.3899C21.8772 29.3945 21.8736 29.399 21.8701 29.4031C21.8575 29.4167 21.8438 29.4289 21.8281 29.438L22.957 28.7815C22.9722 28.7724 22.9864 28.7602 22.999 28.7471C23.0031 28.743 23.0061 28.7385 23.0096 28.7339C23.0142 28.7279 23.0192 28.7228 23.0233 28.7167C23.0289 28.7086 23.0334 28.7 23.038 28.6904C23.038 28.6899 23.038 28.6894 23.0385 28.6894C23.0385 28.6889 23.0385 28.6889 23.039 28.6884C23.042 28.6818 23.0445 28.6758 23.0471 28.6687C23.0496 28.6621 23.0521 28.6555 23.0541 28.6485C23.0562 28.6419 23.0577 28.6358 23.0592 28.6287C23.0597 28.6262 23.0602 28.6232 23.0607 28.6206C23.0607 28.6196 23.0612 28.6191 23.0612 28.6186C23.0617 28.6161 23.0622 28.613 23.0627 28.6105C23.0638 28.6044 23.0648 28.5984 23.0653 28.5923C23.0663 28.5862 23.0668 28.5802 23.0673 28.5736C23.0678 28.5675 23.0683 28.5615 23.0688 28.5559C23.0693 28.5498 23.0693 28.5438 23.0693 28.5372C23.0688 28.5357 23.0688 28.5357 23.0688 28.5352Z"
            fill="url(#paint6_linear_1499_52853)"
          />
          <path
            d="M21.9446 26.6404L23.0735 25.9844L23.0664 28.5366L21.9375 29.1926L21.9446 26.6404Z"
            fill="url(#paint7_linear_1499_52853)"
          />
          <path
            d="M18.3359 24.113L19.4654 23.457L22.6877 25.3178L21.5588 25.9738L18.3359 24.113Z"
            fill="url(#paint8_linear_1499_52853)"
          />
          <path
            d="M21.5612 25.9725C21.7726 26.0944 21.9445 26.3923 21.944 26.6355L21.937 29.1877C21.9365 29.4315 21.7635 29.5301 21.5516 29.4077L18.3287 27.547C18.1168 27.4246 17.9448 27.1272 17.9453 26.8829L17.9524 24.3307C17.9529 24.0874 18.1259 23.9888 18.3383 24.1112L21.5612 25.9725ZM20.0868 26.6967C20.1844 26.6942 20.2512 26.6168 20.2517 26.4818C20.2522 26.2881 20.1156 26.0514 19.9467 25.9537C19.7778 25.8561 19.6417 25.935 19.6407 26.1293C19.6402 26.2638 19.7065 26.4181 19.8031 26.5324L19.8005 27.3199C19.8 27.4099 19.8633 27.5197 19.9416 27.5652C20.0205 27.6107 20.0838 27.5738 20.0843 27.4843L20.0868 26.6967Z"
            fill="url(#paint9_linear_1499_52853)"
          />
          <path
            d="M21.5625 25.9729L22.6914 25.3164C22.6924 25.3174 22.6939 25.3179 22.695 25.3189L21.566 25.9749C21.565 25.9744 21.564 25.9739 21.5625 25.9729Z"
            fill="#171213"
          />
          <path
            d="M21.5625 25.9763L22.6914 25.3203C22.697 25.3233 22.702 25.3269 22.7076 25.3299L21.5787 25.9859C21.5736 25.9824 21.5681 25.9794 21.5625 25.9763Z"
            fill="#181213"
          />
          <path
            d="M21.5859 25.988L22.7149 25.332C22.7204 25.3356 22.7255 25.3391 22.731 25.3427L21.6021 25.9992C21.5966 25.9956 21.591 25.9916 21.5859 25.988Z"
            fill="#181314"
          />
          <path
            d="M23.0738 25.9623C23.0738 25.9562 23.0733 25.9502 23.0728 25.9441C23.0723 25.938 23.0718 25.9314 23.0713 25.9254C23.0708 25.9193 23.0697 25.9127 23.0692 25.9067C23.0682 25.9001 23.0672 25.894 23.0662 25.8874C23.0662 25.8869 23.0662 25.8869 23.0657 25.8864V25.8859C23.0647 25.8798 23.0637 25.8738 23.0627 25.8677C23.0611 25.8611 23.0601 25.8546 23.0586 25.8475C23.0571 25.8409 23.0556 25.8343 23.0541 25.8272C23.0525 25.8202 23.0505 25.8136 23.049 25.807C23.0475 25.8015 23.046 25.7964 23.0439 25.7908C23.0439 25.7903 23.0439 25.7903 23.0434 25.7898C23.0429 25.7888 23.0424 25.7878 23.0424 25.7873C23.0404 25.7807 23.0384 25.7741 23.0358 25.7671C23.0338 25.7605 23.0313 25.7539 23.0293 25.7473C23.0267 25.7413 23.0247 25.7347 23.0222 25.7286C23.0197 25.7226 23.0171 25.716 23.0146 25.7099C23.0126 25.7048 23.0106 25.7003 23.0085 25.6952C23.0085 25.6947 23.0085 25.6947 23.008 25.6942C23.0075 25.6932 23.007 25.6927 23.0065 25.6912C23.004 25.6851 23.0009 25.6785 22.9984 25.6725C22.9949 25.6659 22.9918 25.6588 22.9883 25.6522C22.9848 25.6447 22.9807 25.6366 22.9767 25.629C22.9721 25.6209 22.9676 25.6128 22.963 25.6047C22.962 25.6032 22.9615 25.6017 22.961 25.6002C22.96 25.5986 22.959 25.5971 22.958 25.5951C22.9489 25.5794 22.9392 25.5642 22.9291 25.5496C22.9215 25.5379 22.9135 25.5268 22.9054 25.5157C22.9054 25.5157 22.9054 25.5152 22.9049 25.5152C22.9049 25.5147 22.9049 25.5147 22.9043 25.5147C22.8988 25.5071 22.8932 25.4995 22.8877 25.4924C22.8826 25.4858 22.8775 25.4803 22.873 25.4742C22.8679 25.4681 22.8634 25.4626 22.8583 25.4565C22.8533 25.4509 22.8487 25.4454 22.8437 25.4403C22.8426 25.4393 22.8416 25.4383 22.8411 25.4373C22.8406 25.4368 22.8401 25.4363 22.8396 25.4363C22.8356 25.4322 22.832 25.4282 22.828 25.4236C22.8229 25.4186 22.8174 25.413 22.8118 25.408C22.8062 25.4029 22.8007 25.3973 22.7951 25.3923C22.7895 25.3872 22.784 25.3822 22.7779 25.3776C22.7749 25.3751 22.7723 25.3731 22.7693 25.3705C22.7683 25.37 22.7678 25.3695 22.7673 25.369C22.7653 25.3675 22.7627 25.3655 22.7607 25.3634C22.7551 25.3594 22.7496 25.3548 22.744 25.3508C22.7384 25.3468 22.7329 25.3427 22.7273 25.3392L22.7258 25.3402C22.7142 25.3326 22.703 25.3235 22.6914 25.3164L21.5625 25.9729C21.5888 25.9881 21.6141 26.0058 21.6389 26.0255C21.6394 26.026 21.6399 26.0265 21.6409 26.027C21.6652 26.0468 21.6889 26.069 21.7112 26.0928C21.7117 26.0933 21.7117 26.0933 21.7122 26.0938C21.735 26.1181 21.7567 26.1439 21.777 26.1717C21.777 26.1717 21.777 26.1722 21.7775 26.1722C21.7977 26.1995 21.8159 26.2278 21.8331 26.2572C21.8341 26.2587 21.8346 26.2597 21.8356 26.2612C21.8523 26.29 21.8675 26.3199 21.8806 26.3507C21.8811 26.3512 21.8811 26.3512 21.8811 26.3517C21.8948 26.3831 21.9064 26.4145 21.916 26.4458C21.916 26.4463 21.9165 26.4468 21.9165 26.4473C21.9262 26.4787 21.9332 26.5106 21.9383 26.5419C21.9383 26.5419 21.9383 26.5419 21.9383 26.5424C21.9434 26.5738 21.9459 26.6051 21.9459 26.6355L23.0748 25.9795C23.0738 25.9739 23.0738 25.9679 23.0738 25.9623Z"
            fill="url(#paint10_linear_1499_52853)"
          />
          <path
            d="M19.3019 22.9829L19.6894 22.7578L19.6843 24.043L19.2969 24.2681L19.3019 22.9829Z"
            fill="url(#paint11_linear_1499_52853)"
          />
          <mask
            id="mask4_1499_52853"
            mask-type="luminance"
            maskUnits="userSpaceOnUse"
            x="19"
            y="22"
            width="1"
            height="1"
          >
            <path
              d="M19.5811 22.3662L19.9686 22.1406C19.7941 22.2423 19.6853 22.4583 19.6843 22.7643L19.2969 22.9893C19.2984 22.6833 19.4066 22.4679 19.5811 22.3662Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask4_1499_52853)">
            <path
              d="M19.5811 22.3657C19.5144 22.4046 19.4572 22.4598 19.4122 22.5306C19.399 22.5513 19.3864 22.5736 19.3753 22.5973C19.3667 22.6151 19.3591 22.6338 19.352 22.6525C19.3459 22.6692 19.3404 22.6859 19.3353 22.7036C19.3308 22.7197 19.3262 22.7364 19.3222 22.7531C19.3186 22.7683 19.3156 22.7845 19.3126 22.8007C19.31 22.8158 19.3075 22.831 19.306 22.8472C19.304 22.8624 19.3024 22.8781 19.3009 22.8937C19.2994 22.9089 19.2989 22.9241 19.2979 22.9398C19.2974 22.9549 19.2969 22.9706 19.2969 22.9868L19.6843 22.7612C19.6843 22.7455 19.6848 22.7299 19.6853 22.7142C19.6858 22.699 19.6868 22.6833 19.6878 22.6687C19.6894 22.653 19.6909 22.6373 19.6929 22.6221C19.6949 22.6065 19.6969 22.5908 19.6995 22.5761C19.7025 22.5599 19.7055 22.5437 19.7091 22.5286C19.7131 22.5119 19.7172 22.4952 19.7222 22.479C19.7273 22.4613 19.7329 22.4446 19.7394 22.4279C19.7465 22.4087 19.7541 22.3905 19.7627 22.3728C19.7738 22.3495 19.786 22.3268 19.7996 22.306C19.8446 22.2352 19.9018 22.1796 19.9686 22.1406L19.5811 22.3657Z"
              fill="url(#paint12_linear_1499_52853)"
            />
            <path
              d="M19.2969 22.9873L19.6843 22.7617C19.6843 22.7627 19.6843 22.7637 19.6843 22.7648L19.2969 22.9898C19.2969 22.9888 19.2969 22.9878 19.2969 22.9873Z"
              fill="#130E10"
            />
          </g>
          <path
            d="M21.8171 24.4404L22.2045 24.2148L22.1999 25.5005L21.8125 25.7256L21.8171 24.4404Z"
            fill="url(#paint13_linear_1499_52853)"
          />
          <path
            d="M19.1875 21.6734L19.5749 21.4483C19.6144 21.4255 19.6559 21.4058 19.6999 21.3906L19.3124 21.6157C19.2684 21.6309 19.227 21.6501 19.1875 21.6734Z"
            fill="#0B0709"
          />
          <path
            d="M19.3125 21.6143L19.6999 21.3892C19.7348 21.3771 19.7707 21.367 19.8077 21.3594L19.4202 21.5844C19.3828 21.592 19.3474 21.6016 19.3125 21.6143Z"
            fill="#0C0909"
          />
          <path
            d="M19.4219 21.5854L19.8093 21.3603C19.8381 21.3547 19.868 21.3502 19.8983 21.3477L19.5109 21.5727C19.48 21.5753 19.4507 21.5798 19.4219 21.5854Z"
            fill="#0D090A"
          />
          <path
            d="M19.5078 21.5729L19.8952 21.3478C19.9215 21.3453 19.9478 21.3443 19.9752 21.3438L19.5877 21.5688C19.5609 21.5693 19.5341 21.5708 19.5078 21.5729Z"
            fill="#0D0A0B"
          />
          <path
            d="M19.5859 21.5688L19.9734 21.3438C19.9971 21.3438 20.0214 21.3443 20.0457 21.3458L19.6583 21.5714C19.634 21.5693 19.6097 21.5688 19.5859 21.5688Z"
            fill="#0E0B0B"
          />
          <path
            d="M21.5469 23.2837L21.9343 23.0586C21.9449 23.0829 21.9555 23.1077 21.9657 23.1319L21.5782 23.3575C21.5681 23.3327 21.558 23.3079 21.5469 23.2837Z"
            fill="#1F191A"
          />
          <path
            d="M21.5781 23.3584L21.9656 23.1328C21.9757 23.1576 21.9858 23.1829 21.9954 23.2077L21.608 23.4332C21.5989 23.408 21.5887 23.3832 21.5781 23.3584Z"
            fill="#1E1819"
          />
          <path
            d="M21.6094 23.4326L21.9968 23.207C22.0064 23.2323 22.016 23.2571 22.0251 23.2824L21.6377 23.5075C21.6286 23.4827 21.619 23.4574 21.6094 23.4326Z"
            fill="#1E1819"
          />
          <path
            d="M21.6406 23.5102L22.0281 23.2852C22.0377 23.3115 22.0468 23.3378 22.0554 23.3636L21.6679 23.5886C21.6593 23.5623 21.6502 23.536 21.6406 23.5102Z"
            fill="#1D1718"
          />
          <path
            d="M21.6641 23.5844L22.0515 23.3594C22.0606 23.3857 22.0687 23.4125 22.0773 23.4388L21.6899 23.6639C21.6818 23.6376 21.6732 23.6108 21.6641 23.5844Z"
            fill="#1B1717"
          />
          <path
            d="M21.6875 23.6665L22.0749 23.4414C22.083 23.4687 22.0911 23.4955 22.0987 23.5228L21.7113 23.7479C21.7037 23.7206 21.6956 23.6938 21.6875 23.6665Z"
            fill="#1C1617"
          />
          <path
            d="M21.7109 23.7485L22.0984 23.5234C22.106 23.5507 22.113 23.5776 22.1196 23.6049L21.7322 23.8299C21.7256 23.8031 21.718 23.7758 21.7109 23.7485Z"
            fill="#1B1416"
          />
          <path
            d="M21.7578 23.9087L22.1452 23.6836C22.1513 23.7104 22.1564 23.7372 22.1614 23.7635L21.774 23.9886C21.7689 23.9623 21.7639 23.9355 21.7578 23.9087Z"
            fill="#181314"
          />
          <path
            d="M21.7656 23.9907L22.1531 23.7656C22.1581 23.7919 22.1622 23.8177 22.1667 23.8435L21.7793 24.0686C21.7752 24.0428 21.7707 24.017 21.7656 23.9907Z"
            fill="#181213"
          />
          <path
            d="M21.7812 24.0688L22.1687 23.8438C22.1727 23.8695 22.1768 23.8953 22.1798 23.9206L21.7924 24.1457C21.7888 24.1204 21.7853 24.0946 21.7812 24.0688Z"
            fill="#171213"
          />
          <path
            d="M21.7969 24.1469L22.1843 23.9219C22.1873 23.9472 22.1904 23.9719 22.1924 23.9972L21.805 24.2228C21.8029 24.197 21.8004 24.1722 21.7969 24.1469Z"
            fill="#161112"
          />
          <path
            d="M21.8047 24.2178L22.1921 23.9922C22.1946 24.017 22.1967 24.0423 22.1982 24.067L21.8108 24.2921C21.8092 24.2678 21.8072 24.2426 21.8047 24.2178Z"
            fill="#161111"
          />
          <path
            d="M21.8047 24.2915L22.1921 24.0664C22.1936 24.0912 22.1946 24.116 22.1957 24.1408L21.8082 24.3658C21.8072 24.341 21.8062 24.3168 21.8047 24.2915Z"
            fill="#141011"
          />
          <path
            d="M21.8125 24.3657L22.1999 24.1406C22.2009 24.1639 22.2009 24.1867 22.2009 24.2099L21.8135 24.435C21.8135 24.4117 21.813 24.3885 21.8125 24.3657Z"
            fill="#130E10"
          />
          <path
            d="M20.2826 21.7808C21.1308 22.2709 21.8186 23.4626 21.8161 24.4372L21.8116 25.7229L21.2466 25.3967L21.2512 24.111C21.2527 23.4944 20.8177 22.7403 20.2811 22.4308C19.7439 22.1207 19.3059 22.3706 19.3039 22.9871L19.2993 24.2728L18.7344 23.9466L18.7389 22.6614C18.7415 21.6857 19.4334 21.2907 20.2826 21.7808Z"
            fill="url(#paint14_linear_1499_52853)"
          />
          <path
            d="M21.0812 22.5012C21.0827 22.5032 21.0847 22.5058 21.0862 22.5083C21.111 22.5401 21.1353 22.573 21.159 22.6059C21.1742 22.6271 21.1894 22.6494 21.2046 22.6711C21.2197 22.6929 21.2344 22.7141 21.2491 22.7359C21.283 22.7875 21.3163 22.8401 21.3477 22.8937C21.3654 22.9235 21.3821 22.9534 21.3988 22.9837C21.4069 22.9984 21.4155 23.0125 21.4236 23.0277C21.4463 23.0697 21.4681 23.1122 21.4888 23.1547C21.4913 23.1597 21.4939 23.1648 21.4964 23.1698C21.6977 23.5861 21.8176 24.0317 21.8166 24.4389L22.204 24.2138C22.205 23.8436 22.1059 23.443 21.9364 23.0611L21.938 23.0601C21.9268 23.0353 21.9157 23.01 21.9041 22.9857C21.8914 22.9584 21.8783 22.9311 21.8646 22.9043C21.8494 22.8735 21.8333 22.8426 21.8171 22.8118C21.7928 22.7657 21.7675 22.7207 21.7407 22.6762C21.725 22.6499 21.7078 22.6246 21.6921 22.5988C21.6911 22.5973 21.6906 22.5963 21.6896 22.5953C21.6684 22.5609 21.6476 22.5265 21.6254 22.4931C21.594 22.4461 21.5611 22.3995 21.5278 22.3545C21.5055 22.3242 21.4827 22.2943 21.4595 22.265C21.4403 22.2402 21.42 22.2159 21.4003 22.1917C21.3806 22.1679 21.3609 22.1446 21.3406 22.1219C21.3209 22.0996 21.3007 22.0774 21.2804 22.0556C21.2597 22.0333 21.239 22.0111 21.2177 21.9899C21.1965 21.9681 21.1747 21.9469 21.153 21.9256C21.1307 21.9044 21.108 21.8831 21.0852 21.8629C21.0624 21.8427 21.0402 21.8224 21.0169 21.8032C20.9942 21.784 20.9714 21.7658 20.9486 21.7476C20.9264 21.7299 20.9041 21.7127 20.8814 21.6965C20.8591 21.6803 20.8369 21.6641 20.8146 21.649C20.7929 21.6343 20.7711 21.6201 20.7494 21.606C20.7276 21.5923 20.7064 21.5792 20.6846 21.5665C20.6796 21.5635 20.6745 21.5604 20.6694 21.5574C20.6533 21.5483 20.6366 21.5392 20.6209 21.5301C20.5996 21.519 20.5789 21.5078 20.5582 21.4977C20.5445 21.4911 20.5309 21.4846 20.5172 21.4785C20.5142 21.477 20.5111 21.4755 20.5076 21.474C20.5041 21.4724 20.5 21.4704 20.496 21.4684C20.4752 21.4593 20.455 21.4507 20.4348 21.4421C20.4135 21.434 20.3933 21.4264 20.3726 21.4188C20.369 21.4173 20.3655 21.4168 20.3614 21.4153C20.3584 21.4143 20.3548 21.4133 20.3518 21.4117C20.3382 21.4072 20.3245 21.4026 20.3108 21.3986C20.2896 21.392 20.2684 21.3865 20.2471 21.3814C20.2365 21.3789 20.2264 21.3768 20.2163 21.3748C20.2117 21.3738 20.2072 21.3728 20.2031 21.3718C20.197 21.3708 20.1905 21.3688 20.1844 21.3672C20.1616 21.3632 20.1394 21.3591 20.1171 21.3566C20.103 21.3546 20.0893 21.3536 20.0757 21.3521C20.0711 21.3516 20.0666 21.351 20.062 21.3505C20.0575 21.3505 20.0534 21.3495 20.0489 21.349L20.0468 21.35C19.8698 21.3379 19.7095 21.3723 19.5749 21.4507L19.1875 21.6758C19.3261 21.5953 19.491 21.5604 19.6741 21.5756C19.6786 21.5761 19.6832 21.5766 19.6877 21.5771C19.7297 21.5812 19.7722 21.5878 19.8157 21.5969C19.8202 21.5979 19.8243 21.5989 19.8288 21.5999C19.8733 21.6095 19.9184 21.6221 19.9644 21.6378C19.9679 21.6388 19.971 21.6399 19.974 21.6409C20.022 21.6576 20.0706 21.6768 20.1202 21.6995C20.1232 21.7011 20.1267 21.7026 20.1298 21.7041C20.1798 21.7274 20.2309 21.7537 20.2825 21.783C20.3341 21.8128 20.3857 21.8457 20.4363 21.8806C20.4393 21.8826 20.4423 21.8852 20.4459 21.8872C20.4929 21.9201 20.5395 21.9555 20.585 21.9924C20.59 21.9964 20.5951 22.0005 20.6002 22.005C20.6447 22.0414 20.6882 22.0794 20.7312 22.1193C20.7362 22.1239 20.7413 22.1284 20.7463 22.133C20.7898 22.174 20.8323 22.2169 20.8743 22.261C20.8773 22.2645 20.8809 22.268 20.8839 22.2716C20.9168 22.3065 20.9491 22.3429 20.9805 22.3798C20.983 22.3834 20.9861 22.3864 20.9891 22.3899C21.0205 22.4253 21.0508 22.4628 21.0812 22.5012Z"
            fill="url(#paint15_linear_1499_52853)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1499_52853"
              x1="18.6124"
              y1="18.6047"
              x2="13.5938"
              y2="18.6047"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.0425" stop-color="#0072A0" />
              <stop offset="0.1772" stop-color="#1D82A9" />
              <stop offset="0.4697" stop-color="#66ACBE" />
              <stop offset="0.8946" stop-color="#D9EEE1" />
              <stop offset="1" stop-color="#F7FFEA" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_1499_52853"
              x1="29.0518"
              y1="17.0944"
              x2="21.3596"
              y2="17.0944"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.0425" stop-color="#0072A0" />
              <stop offset="0.1772" stop-color="#1D82A9" />
              <stop offset="0.4697" stop-color="#66ACBE" />
              <stop offset="0.8946" stop-color="#D9EEE1" />
              <stop offset="1" stop-color="#F7FFEA" />
            </linearGradient>
            <radialGradient
              id="paint2_radial_1499_52853"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(20.4113 22.7348) rotate(180) scale(17.715 17.715)"
            >
              <stop offset="0.655228" stop-color="#0E8CF1" />
              <stop offset="0.895891" stop-color="#00050F" />
              <stop offset="1" />
            </radialGradient>
            <linearGradient
              id="paint3_linear_1499_52853"
              x1="28.8766"
              y1="25.2837"
              x2="13.5933"
              y2="25.2837"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.0425" stop-color="#A5D8EB" />
              <stop offset="0.4079" stop-color="#C1E6EB" />
              <stop offset="1" stop-color="#F7FFEA" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_1499_52853"
              x1="22.6253"
              y1="35.6469"
              x2="30.3217"
              y2="21.3689"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.0425" stop-color="#0072A0" />
              <stop offset="0.1772" stop-color="#1D82A9" />
              <stop offset="0.4697" stop-color="#66ACBE" />
              <stop offset="0.8946" stop-color="#D9EEE1" />
              <stop offset="1" stop-color="#F7FFEA" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_1499_52853"
              x1="18.0625"
              y1="23.7602"
              x2="19.4653"
              y2="23.7602"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#001A4F" />
              <stop offset="0.3451" stop-color="#001237" />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_1499_52853"
              x1="21.8274"
              y1="28.9866"
              x2="23.0689"
              y2="28.9866"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#001A4F" />
              <stop offset="0.3451" stop-color="#001237" />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_1499_52853"
              x1="21.9373"
              y1="27.5885"
              x2="23.0737"
              y2="27.5885"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#001A4F" />
              <stop offset="0.3451" stop-color="#001237" />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_1499_52853"
              x1="18.3361"
              y1="24.7156"
              x2="22.6879"
              y2="24.7156"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#001A4F" />
              <stop offset="0.3451" stop-color="#001237" />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_1499_52853"
              x1="19.9448"
              y1="24.0592"
              x2="19.9448"
              y2="29.4604"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.0425" stop-color="#A5D8EB" />
              <stop offset="0.4079" stop-color="#C1E6EB" />
              <stop offset="1" stop-color="#F7FFEA" />
            </linearGradient>
            <linearGradient
              id="paint10_linear_1499_52853"
              x1="21.5621"
              y1="25.976"
              x2="23.074"
              y2="25.976"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#001A4F" />
              <stop offset="0.3451" stop-color="#001237" />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="paint11_linear_1499_52853"
              x1="19.2971"
              y1="23.5129"
              x2="19.6892"
              y2="23.5129"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#001A4F" />
              <stop offset="0.3451" stop-color="#001237" />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="paint12_linear_1499_52853"
              x1="19.2973"
              y1="22.5635"
              x2="19.9687"
              y2="22.5635"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#001A4F" />
              <stop offset="0.3451" stop-color="#001237" />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="paint13_linear_1499_52853"
              x1="22.0083"
              y1="27.0608"
              x2="22.0083"
              y2="25.9914"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#001A4F" />
              <stop offset="0.3451" stop-color="#001237" />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="paint14_linear_1499_52853"
              x1="20.275"
              y1="21.5704"
              x2="20.275"
              y2="25.7229"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.0425" stop-color="#A5D8EB" />
              <stop offset="0.4079" stop-color="#C1E6EB" />
              <stop offset="1" stop-color="#F7FFEA" />
            </linearGradient>
            <linearGradient
              id="paint15_linear_1499_52853"
              x1="19.1885"
              y1="22.8931"
              x2="22.2038"
              y2="22.8931"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#001A4F" />
              <stop offset="0.3451" stop-color="#001237" />
              <stop offset="1" />
            </linearGradient>
            <clipPath id="clip0_1499_52853">
              <rect
                width="27.461"
                height="32.4"
                fill="white"
                transform="translate(0.09375)"
              />
            </clipPath>
          </defs>
        </svg>
      )

      break
    // End

    case "mat":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1137_1008)">
            <path
              d="M0.833336 9.99967C0.833336 9.99967 4.16667 3.33301 10 3.33301C15.8333 3.33301 19.1667 9.99967 19.1667 9.99967C19.1667 9.99967 15.8333 16.6663 10 16.6663C4.16667 16.6663 0.833336 9.99967 0.833336 9.99967Z"
              stroke="#0E8CF1"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
              stroke="#0E8CF1"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1137_1008">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break

    case "diachi":
      iconElement = (
        <svg
          width="19"
          height="24"
          viewBox="0 0 19 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.49652 0.27832C4.75958 0.27832 0.904299 4.13514 0.904297 8.87207C0.904294 17.207 9.01282 23.5434 9.01282 23.5434C9.29767 23.7703 9.70147 23.7703 9.98633 23.5434C9.98633 23.5434 18.0964 17.207 18.0964 8.87207C18.0964 4.13514 14.2335 0.27832 9.49652 0.27832ZM9.49652 4.96735C11.6446 4.96735 13.4073 6.72397 13.4073 8.87207C13.4074 11.0202 11.6446 12.7814 9.49652 12.7814C7.3484 12.7814 5.59178 11.0202 5.5918 8.87207C5.5918 6.72397 7.34842 4.96735 9.49652 4.96735Z"
            fill="white"
          />
        </svg>
      )

      break
    case "hotline":
      iconElement = (
        <svg
          width="25"
          height="26"
          viewBox="0 0 25 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.92372 17.6489L6.22157 15.3774C6.84559 15.1074 7.57753 15.2895 8.00136 15.8159L10.1542 18.4438C13.5355 16.7837 16.2821 14.0342 17.9423 10.6558L15.3148 8.50536C14.7899 8.0766 14.6112 7.34862 14.8766 6.7246L17.1476 1.42675C17.4452 0.747549 18.1779 0.375967 18.8952 0.542471L23.8171 1.67772C24.5129 1.83642 24.9997 2.44921 24.9997 3.16503C24.9997 15.4844 14.9802 25.5039 2.66083 25.5039C1.94452 25.5039 1.33368 25.0172 1.17401 24.3213L0.0387591 19.3994C-0.125645 18.6841 0.244911 17.9419 0.92372 17.6489Z"
            fill="white"
          />
        </svg>
      )

      break
    case "email":
      iconElement = (
        <svg
          width="23"
          height="17"
          viewBox="0 0 23 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.4445 2.93572V2.41354C22.4445 1.42289 21.6339 0.612305 20.6432 0.612305L20.6427 0.61279L20.6417 0.613583L20.6432 0.612305H2.26124L2.26834 0.618081L2.26124 0.61279C1.27059 0.61279 0.459961 1.42337 0.459961 2.41407V14.7189C0.459961 15.7095 1.27054 16.5201 2.26124 16.5201H2.90247H19.9473C21.8369 16.4981 22.4045 16.0301 22.4474 14.7203L22.4445 2.93572ZM19.3012 1.05322L11.4231 6.85622L3.5962 1.05322H19.3012ZM3.34792 5.56217L10.6455 10.5888L10.6528 10.5939L3.34374 15.6762L3.34792 5.56217ZM3.53655 16.0791L11.0388 10.8625L11.1704 10.9541C11.2461 11.0067 11.3342 11.0331 11.4223 11.0331C11.5097 11.0331 11.8091 10.8611 11.8091 10.8611L19.3134 16.0791H3.53655ZM19.5016 15.6731L12.197 10.5939L16.2708 7.78783L19.5016 5.56244V15.6731Z"
            fill="white"
          />
        </svg>
      )

      break
    case "website":
      iconElement = (
        <svg
          width="25"
          height="26"
          viewBox="0 0 25 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.5 1.57422C6.19375 1.57422 1.07422 6.69375 1.07422 13C1.07422 19.3062 6.19375 24.4258 12.5 24.4258C18.8062 24.4258 23.9258 19.3062 23.9258 13C23.9258 6.69375 18.8062 1.57422 12.5 1.57422ZM12.5 2.55078C18.2672 2.55078 22.9492 7.23281 22.9492 13C22.9492 18.7672 18.2672 23.4492 12.5 23.4492C6.73281 23.4492 2.05078 18.7672 2.05078 13C2.05078 7.23281 6.73281 2.55078 12.5 2.55078Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.5 1.57422C11.1504 1.57422 9.8795 2.41523 8.86778 3.89883C7.46719 5.95273 6.54297 9.26367 6.54297 13C6.54297 16.7363 7.46719 20.0473 8.86778 22.1012C9.8795 23.5848 11.1504 24.4258 12.5 24.4258C13.8496 24.4258 15.1205 23.5848 16.1322 22.1012C17.5328 20.0473 18.457 16.7363 18.457 13C18.457 9.26367 17.5328 5.95273 16.1322 3.89883C15.1205 2.41523 13.8496 1.57422 12.5 1.57422ZM12.5 2.55078C13.5652 2.55078 14.527 3.27813 15.3254 4.44922C16.6402 6.37734 17.4805 9.49258 17.4805 13C17.4805 16.5074 16.6402 19.6227 15.3254 21.5508C14.527 22.7219 13.5652 23.4492 12.5 23.4492C11.4348 23.4492 10.473 22.7219 9.67461 21.5508C8.35976 19.6227 7.51953 16.5074 7.51953 13C7.51953 9.49258 8.35976 6.37734 9.67461 4.44922C10.473 3.27813 11.4348 2.55078 12.5 2.55078Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.54597 19.3906C3.36824 19.5645 3.34988 19.8445 3.50339 20.0406C5.59558 22.7098 8.8491 24.4258 12.5003 24.4258C16.1514 24.4258 19.405 22.7098 21.4972 20.0406C21.6507 19.8445 21.6323 19.5645 21.4546 19.3906C19.3714 17.3496 16.1358 16.0273 12.5003 16.0273C8.86472 16.0273 5.62918 17.3496 3.54597 19.3906ZM4.55535 19.7844C6.48153 18.0766 9.32957 17.0039 12.5003 17.0039C15.671 17.0039 18.519 18.0766 20.4452 19.7844C18.528 22.0266 15.6788 23.4492 12.5003 23.4492C9.32176 23.4492 6.47254 22.0266 4.55535 19.7844Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.50339 5.95937C3.34988 6.15547 3.36824 6.43555 3.54597 6.60938C5.62918 8.65039 8.86472 9.97266 12.5003 9.97266C16.1358 9.97266 19.3714 8.65039 21.4546 6.60938C21.6323 6.43555 21.6507 6.15547 21.4972 5.95937C19.405 3.29023 16.1514 1.57422 12.5003 1.57422C8.8491 1.57422 5.59558 3.29023 3.50339 5.95937ZM4.55535 6.21563C6.47254 3.97344 9.32176 2.55078 12.5003 2.55078C15.6788 2.55078 18.528 3.97344 20.4452 6.21563C18.519 7.92344 15.671 8.99609 12.5003 8.99609C9.32957 8.99609 6.48153 7.92344 4.55535 6.21563Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.5625 13.4883H23.4375C23.707 13.4883 23.9258 13.2695 23.9258 13C23.9258 12.7305 23.707 12.5117 23.4375 12.5117H1.5625C1.29297 12.5117 1.07422 12.7305 1.07422 13C1.07422 13.2695 1.29297 13.4883 1.5625 13.4883Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.9883 23.9375L12.9883 2.0625C12.9883 1.79297 12.7695 1.57422 12.5 1.57422C12.2305 1.57422 12.0117 1.79297 12.0117 2.0625L12.0117 23.9375C12.0117 24.207 12.2305 24.4258 12.5 24.4258C12.7695 24.4258 12.9883 24.207 12.9883 23.9375Z"
            fill="white"
          />
        </svg>
      )

      break

    case "tong":
      iconElement = (
        <svg
          width="45"
          height="45"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            d="M26.474 49.4323C38.8428 49.4323 48.8698 39.4053 48.8698 27.0365C48.8698 14.6676 38.8428 4.64062 26.474 4.64062C14.1051 4.64062 4.07812 14.6676 4.07812 27.0365C4.07812 39.4053 14.1051 49.4323 26.474 49.4323Z"
            fill="url(#paint0_radial_881_14657)"
          />
          <rect
            x="24.166"
            y="0.5"
            width="8.33333"
            height="17.5"
            fill="url(#pattern0)"
          />
          <rect
            y="13.8359"
            width="17.0833"
            height="11.6667"
            fill="url(#pattern1)"
          />
          <rect
            x="3.33398"
            y="33.4141"
            width="15.4167"
            height="15"
            fill="url(#pattern2)"
          />
          <rect
            x="28.75"
            y="34.25"
            width="14.1667"
            height="16.25"
            fill="url(#pattern3)"
          />
          <rect
            x="34.584"
            y="16.75"
            width="17.5"
            height="10.8333"
            fill="url(#pattern4)"
          />
          <rect
            x="13.334"
            y="2.57812"
            width="12.0833"
            height="17.0833"
            fill="url(#pattern5)"
          />
          <rect y="25.0781" width="17.5" height="8.75" fill="url(#pattern6)" />
          <rect
            x="17.084"
            y="35.4922"
            width="10"
            height="17.5"
            fill="url(#pattern7)"
          />
          <rect
            x="34.584"
            y="27.1641"
            width="17.5"
            height="11.25"
            fill="url(#pattern8)"
          />
          <rect
            x="29.584"
            y="4.66406"
            width="13.75"
            height="16.25"
            fill="url(#pattern9)"
          />
          <rect
            x="25.834"
            y="13"
            width="5.41667"
            height="10.4167"
            fill="url(#pattern10)"
          />
          <rect
            x="13.75"
            y="19.6641"
            width="10"
            height="7.5"
            fill="url(#pattern11)"
          />
          <rect
            x="15.416"
            y="28.8359"
            width="9.58333"
            height="8.75"
            fill="url(#pattern12)"
          />
          <rect
            x="27.5"
            y="30.5"
            width="7.91667"
            height="9.58334"
            fill="url(#pattern13)"
          />
          <rect
            x="30"
            y="22.1641"
            width="10.4167"
            height="6.25"
            fill="url(#pattern14)"
          />
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image0_881_14657"
                transform="scale(0.05 0.0238095)"
              />
            </pattern>
            <pattern
              id="pattern1"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image1_881_14657"
                transform="scale(0.0243902 0.0357143)"
              />
            </pattern>
            <pattern
              id="pattern2"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image2_881_14657"
                transform="scale(0.027027 0.0277778)"
              />
            </pattern>
            <pattern
              id="pattern3"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image3_881_14657"
                transform="scale(0.0294118 0.025641)"
              />
            </pattern>
            <pattern
              id="pattern4"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image4_881_14657"
                transform="scale(0.0238095 0.0384615)"
              />
            </pattern>
            <pattern
              id="pattern5"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image5_881_14657"
                transform="scale(0.0344828 0.0243902)"
              />
            </pattern>
            <pattern
              id="pattern6"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image6_881_14657"
                transform="scale(0.0238095 0.047619)"
              />
            </pattern>
            <pattern
              id="pattern7"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image7_881_14657"
                transform="scale(0.0416667 0.0238095)"
              />
            </pattern>
            <pattern
              id="pattern8"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image8_881_14657"
                transform="scale(0.0238095 0.037037)"
              />
            </pattern>
            <pattern
              id="pattern9"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image9_881_14657"
                transform="scale(0.030303 0.025641)"
              />
            </pattern>
            <pattern
              id="pattern10"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image10_881_14657"
                transform="scale(0.0769231 0.04)"
              />
            </pattern>
            <pattern
              id="pattern11"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image11_881_14657"
                transform="scale(0.0416667 0.0555556)"
              />
            </pattern>
            <pattern
              id="pattern12"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image12_881_14657"
                transform="scale(0.0434783 0.047619)"
              />
            </pattern>
            <pattern
              id="pattern13"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image13_881_14657"
                transform="scale(0.0526316 0.0434783)"
              />
            </pattern>
            <pattern
              id="pattern14"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image14_881_14657"
                transform="scale(0.04 0.0666667)"
              />
            </pattern>
            <radialGradient
              id="paint0_radial_881_14657"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(26.473 27.0364) rotate(158.093) scale(22.3956 22.3956)"
            >
              <stop stop-color="#8B939F" />
              <stop offset="0.3601" stop-color="#8B939F" />
              <stop offset="0.5179" stop-color="#8B939F" />
              <stop offset="0.6362" stop-color="#8B939F" />
              <stop offset="0.7349" stop-color="#000E28" />
              <stop offset="0.8203" stop-color="#00173F" />
              <stop offset="0.885" stop-color="#001F56" />
              <stop offset="1" stop-color="#005FCF" />
            </radialGradient>
            <image
              id="image0_881_14657"
              width="20"
              height="42"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAqCAYAAACz+XvQAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABAdJREFUeNqkV7uOHEUUPTXd09PLjtn1Y+2VvcgYrQPAEpJFZiISUiJCfoCUHBEQIMFPkCCR8APOIEcWQhi0AViL2Md4dnYe3T39Kk7VrZ6Ht2dnZimppvpVp++55z56gHXHNz9ofPWdXnRbrQySpMDzv4GdTSDtc6cHDArgrTeBLz5VqwMaMDOOu8DTn4DXeRz/CwS3gb2HBLwP3ODFzz9RywErsGEM/Pwr8Nsz4PwXoIyA6+8Ab7wH3NoBPnwszxPUXwpmxgEtOj4DXh4A2QjQfMHpCRD9QUvpAs1HldjWWFmM/uDitbIE7u/OGbEcMKfjDw65mSsqo0NZbuyJZWrqueWAo7Gz8GT++oLAWQ44iOYRtHtBo3lFQEPZTAuWumAjWHhHjh/srgl4TlVHVLWIRU1rqZK14V3BwsNTWphzPxUteg5oS+61gvlnGYeNlej2uwL46ghI3ffWsDAaC6ABy87dRQcQMt3u3uIarEnZilEKVSs0rWqSsiHX4PQaE7rLAf86lnU8qnzgVHbBbIrCSqLM5nGUyFr0nSDXROWwfcU4NDk87pjEdVMJXTNub18B0BQA40Mbg6VQ9ZjLrRZ3qzn/LQc8Yrj0jp0o5XxNNkG90VrTwipkUGUIQyRkhdm6C1xjHdwI1gCsgtpQtZQL5z839+/V1vuLgF9/P1X46ESo5kdcWRj8HRHExqC6kCVm+LVBnHMOGS4JZ9qp1JkRR0t+K7UCYEFqKYH+fOEKQjxfVU0JM/RNluTZCoDjGYCzf2ZKlgM0dM2LdjdrXT8P+NmXGi/pr9eYBec9d7d8xUKet5oSn9FwCeDIdbZSC6BpmaoKG1/WcIP3WYXioY0itMLLKDtq3a4A6nKmDiqx1qprfE3QMVUusksAhwPZF9PxZ2zuOneUUylbJuVSWt1mPykoXD+5hPIHH2kcvZBQyH2hpDOZE/8VErlpJO5JKOD2zQWAutrE2T2Vxp71nJWQry1znNNCn/c6ZOBxu99cANhzAZyZlFOy2ZapYiavvGk7TT1xxdMfVT2gCVJDwSjcJ6UkEit11ZO1szaT2aOl3qI2eudehmgksWVAilw2T0RRrhW7a0k0zapaUdJkSDEooUoI2kaZCr0yJUwhHV01lU0301diChKrSzIlyzqcrksGMVJ2JY1txuDUJeU4gPZSNIO2ZZBlDQZ5WQ+oy+e0zictn9b6PA8ZsIfTglfuWYFshhQdeO0tnjcx6NV8tKvGE/6+PymehmphC+ojCaWZTPGYa01/39XB65ybGPYf1v0LeJvzd84n7pxf5DiZfBTBvnCbsdizMgbBI1sPg2AHo+HH6/ytYImGacSmarzrlDL5tk9fhgRt0z3f4n+Oqm3s1t38T4ABAITeyz5Tk9DnAAAAAElFTkSuQmCC"
            />
            <image
              id="image1_881_14657"
              width="41"
              height="28"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAcCAYAAAD815boAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABTdJREFUeNrMl7tvHFUUxs/szOx6/SROYhvsGEIMQUIoINJR0VAiKhp6+AOgoEGIgo4uiCL/AIgGBUEJpokEgaAgbBTHduI4fmTttb3e1+xjHvzunFnLiReTx9rOla7uzOydO9/9zne+c9eS+9sX30bSrn30riVH1Kx7wNUaIhEY066InZInBay1A3B1XWR6XmSlINLdLfLOGyKVmkhPl4hjHylYZ+dqYZY+JbIJk54nsromks2KnH9JpB/QI4OAz9wri0MCasUfMwCv/CSyHYrcuEKoTxDy44yA7DvJVtIiE+Mi5ya4RgZDT/GmdWisKpNuj8gWYV5eRJMA9VfoMGkPidQZMwCdaYrM8/sIz14YEznWJzJ6XKXQSrYDAqsg1ysA5YPRNk/4TlDmus4IqABNBnXtNuFuNlQKg8dExgD82hkFarR7QGA13LlNkas3RP78XbPbW2IMYDOvYAV2BRAWPQWDbr/IwLMa8j7AvoIMRpHIMDLoSndcBsrkMElxalikeg5dlmAWLTbJbA+G/EICFNAR1wHPhdDniwDincoGnXd6B2D1rMhpnrks259VZoNAJfTxe9bjMdlqP/4GI+hvDia3CXnOhJvwVrkPYDsCXOQz0XQ2YJ/UMfs0KzH2wqaDJJ7h/q3zvMO8rKvv+PQCkalVRS5+bj2aT7aaHyhLuS2R2QTsFot7sNiEseZ2IgPmiWeyDgnAogV7GVhMAXLwOWV+hPtxtH6KLmw2BGiNd+oAzd9l86z98yXr4SrO7hYSolmy3FShJYw+R1hXb/Nt2KzxgZAx2EjA1lU5xrrMkt1jGuIe9OoCOsNGhtnIKHruYl4DkFWS1Ut6GQJKbP7mdWt/M7+/pfDDs3wsCFVjJpNz9CUye8VWVjxHQxluqxSCu5pkJaRhk0Qh+k0Zppm/uSxyG6vrIbGG0KsTqu4bteR7zBk/E0m5WJRmfV1KxYm9TP7fAcPIYAXmChXVbMVTX/Vh2jPMwmYzlzhBS7dpdQOjV5cxxaYcw7itjPba8RTx68poox7QK/R18ZuT9Cm0fGF/PfwX4CLhWgDQHOyUWHxxVq2rghzCTU2mKHGBGLSjzJprU8UkUrDGwtKtnjJaLQGqBMhl/PgvEu9r7n95OFtop9tbgJ1Z1ERbnFEtNrkOYDosqhyisgIzYA2rFvQ5vcq+kZVJsm7Xh7kyGr+O7v9h7Q1AXsLCLj+ad7VjuOQpu5PYWBlZNCoKos6zsJRYV5Swm0qUZgBz7WbNpoqm9olrE+qGAfmDhMF37TX5uIALAJpHBnOwu3wHCeQ1QXwwBBVNpp0qtpOlUGlV0Oo6wH6FzWtM4twoHQK5G2wYqATqsLpByG8C8hZg13CE8po6gI+eQ09ZjoEaCxPQCxZhkZFiBH7NrLizhY6BNHU62qVVk72nsaxXnxd5ESsbwti7CKvt6kEllVZ9ioMObNBboI840EbsTObbm3kn26cXo7ieV5NeIXGKBWV3YQG9esZukEHVnAWM0TLB+huAMwnQC7v1kDoQkJ+9z5ngQys26JjZQJMmAydDnKBODGgZMb87mTL+2aqz7CCa3lNXDvTc/+UnVlyrm0ndjmMHWJs+QPXJEmpzFrWsPFk+R1zLyYEgfLCy2Kn2zVcqqTffjuITkCROZP6NZtJlTXlH8yeI/uC3yw9euzvdJr9XsC+/HsX12pRAc5QLwzuwO0W0p1QWbY4Rh/5Pf/qqRRUJARdRSr34mZFDEGA9e1k8GpCmLS/YsrbiwlyeUmj8MS9PfHPTH+z3878CDABe3IgtXQZ+BAAAAABJRU5ErkJggg=="
            />
            <image
              id="image2_881_14657"
              width="37"
              height="36"
              xlinkHref="data:image/png;base64,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"
            />
            <image
              id="image3_881_14657"
              width="34"
              height="39"
              xlinkHref="data:image/png;base64,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"
            />
            <image
              id="image4_881_14657"
              width="42"
              height="26"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAaCAYAAADBuc72AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABOVJREFUeNrMmMtvG1UUxr95eDx+ZeK4edZKaRsCagtUKFlViAVS/4QKCSGxZMmiiy75A0DiD+iCNWKPxA6hbhCIDVAJIrUpaZuH48SJ40c8D74z5yZOKyclapPU0vWduRnP/c33nXPunVg4689X3yUDx2/fsg6eWq8V3BGw1msDGUbAH4uAQ6RyUVshtw9rnSmgwK1uAmsN4OEy0AuBxjbH2c/PApUh4ML5FNY9dUCBa3UJSLh/V4F19o0msLMDNNeA3S2q2gF+fQLcvAmsPDlh658H3GpRtRXgwVPAdXhOsLU6sE3YmPBdKhr3+CAcS9hXysClt4Fbn6c/d0/c3j3APWsFrrZEGMJ1OJaEChZtmWOqDY8Ks/fGgJ9/Aj748CVBv7ybwGfA2zab0x+PYuARbVwkSJ0AyzUCr9NWQofb2hJeE9bkYgPHc/jaHKqZq1LlPFCaAtrdY4J++kUCh0D5kjaxTD6Jib32LrBUU3uXCbb6mNdQpXZN1Ypod2yaKIqeqifNGVGD/XE+dAYoMokuX+R5ltDZF4Bem0uQpWI+nyzgjULeWEBd3ijixCHBNqnY0gaTgv0jWlxj6zRN3PEYVDuqK1jMJMEB9Zwp/bs/yY4oASEd9oUC8P5bjNEJYKgwIOuD8u/IeG+wFdlcJJQqk+lX3FZTDzaZqR1O1uCkfz7kEOG7bcbVhqoWtUzM9bSlyoWqmE1bLT64yzqZKelvy1UVYP4KxeV8FwkYFJ5BU1DXvUGVPkMUbcJN+nbK5PIp8IYN1juHNqwQYIOA7TCNHbQFin1MdUM5XlWVUuUiY2sF+tAjaqtA+qyRObbhAHj3shb4UR7n/YGrk7sPleA+v2cQxzXsdsWK4TTuEtrV4QU76zppVyztqhJhV+EkGSTu0ht1zAx8KGfUxN2oggZV7YvDwJvTwHUChnSmUtKSdcQSqqBReI+OzrH9whtVabuoFaOxY8PzFUISxfE0TmUyqXlx21gbGWt5X2dcb5ubMlCj+juX7RyVrbLkXJ1WsCGGgGXh/2xKDsSoVaeC1yhKHbGVgRUX0e3Z2I2M4vzqNVU1SYykZQJXbOak9pCJPfbj75nr2PKMtXdmgImyWb/9F6o36NMHDXs1OJkF9GKHECOMxybjbojNVpjYlBRTksBYcwIddwjgnaN6VCuiwpMTCnqJqlY5HvABfO9YYIeDAj8wmWZhkSaJmwg7nCE+kFmW6amGxUltKpOtaOHOUq0CIXMEmqeaZcbctFhuP2vtMeEOAxV1HpOFqWkxxaMNMzi8b7FUM1HPZqJkCeNX9AFGqWCV6l1lcgQltVtWq5eEOwIUXFISRnosFaCqltsxwewUUlqurHA5wozR+iuMP0m4MSpY4pjvq8q3P36lG57nQe9xllkTgA3aRunsItysncJ5tDbHnwxT5CmuJoHUPU/h4lgB73xyIjuyQUvo34Q6z00GpbIC1tOnyLuTLC9uaqlAlgjoOX17BfKbOye6CR8E+huVZObHF5DNiq3XkXHTjQHyWQ3XPSSpt99+fSpvCYNAO4SMuKxK1j6Aa1e5DhdNCdNNgyT/j9+f6vvWYbsnidU57oA+YsmSXVIHHjcqPYIu/HUmb672IeMzsC2JvR0ur6uEDdFpbWHxn7N5vT5C0QUup/dhJy7ssInm1o2z/j/FfwIMAB354T7Q7s71AAAAAElFTkSuQmCC"
            />
            <image
              id="image5_881_14657"
              width="29"
              height="41"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAApCAYAAADJeCK0AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABThJREFUeNq8V0tvG1UU/mY8duI475CmcUIalAZBqaqKwhIk9kjsECvEP2BBhcSq24rHH0BiwQ5YsQIJCVUguisB1FBR4rZEeZCHPXH8GI89j8t35o47efHwQxxpPJ5778w33znnO/eMgaP24RcKm4+A0ASKDpAdAp69oOeuv26gT2YcA1z7HbBC4NbXQP55YOsAuHYZuHoxuaMP4Gb0+8HnCnsEKBWBb74EWk3g+6+AzXWu4BI/OO6NHs16/JC1TeDBH0DZBqp7gJrkIKe+W6G7eb661C/vxkzFWj6wXwcOXcDl4ZF1gy9i87jzG8frfWObgE6MEYRuxSAjPSBvQbfu6blGA3i0c9zNfQEVe+YKMPQkkJ6JgWnOEbbbpb6wTUAvUxrz08DYLMnOtH3OeJaBZlGztat0fauPTK0UdUl2s+fIMp2wVQQJBHBDs602+uzep+eBqVFgPA9knogHGeeQDFtlzXaLrD2/R9CjYs9mgEmCTlMuKSaUJWx5Vsxmv5awdZo9xdU8NfLUeWB0mHEleHqcK4Y1W0XJeGR8sA/89KAnN5unStso6+0cE2qKsbUIaOY027BC0EO9pkDGYdg1W/PMmmry7wSZDuRi4CwHA+3m6hYLBavW6nrXujXPHL20ACzNMbaz2sXGCAdTsXxirf5KF2/bXbE9Dtpmm+Lw3BQ1S7A0XZvKajfD00eFbOuM747dFdvTTNvAIp1lSmhs+sgk2QYHyeUvBSZWrWO25j/OLlIy56nXIWa0RXAjq6uU+yfjSrYOM3qDulWqDzFts5VMvihsZ06wtZPLlfu8jjP5/c9U70zFlphMeYIO8pwSV2e0bhvb3HspHYexXSnoahUGPbq3zTbHRHpukRKaPX5bIOWQ2exSvz+zSu3INV1/42PVO9M223keWdZkczxhK8WizgrlVHQmlw90fK9/pLoHbbOVHUhsaCQujcxspHVsDemhyHDlLrAuhYM6rlf6wFTslSu6Qg1Sv2YmvpVgzkPqdlOzFVDpsTx64a13VPegUmN9FoRBsp2jfIJm1K/ByOgONqROFedDvkD5UK93OFbjS7z2puoO9N03jChO0pa+uAwsLMZsc3FLw721JeyYvUVm9D0mlb2vQauHPbi35carKYkxadyEQJjMB8xih0A+120Q2Lb1PU0eL7ysTve9/8UarDzNhj5yvCXLncdNabZBoOuxV9I7kRwlznl1ncleq0umN9824MctyiQBF6Q0TsQbwYCuUip+eJNuPaB0avWkWFxYVp0zjVpRJkdARk1WIMFJm1HyJu9NgFZJtzmODPMlm+k46fgzk69id3ukM8l8ctOItjORRpoPGZZOMdQ6NVLxt5in1ypfx1zc67dCbgw+vxr8znXaZivm1jQTaeQsHoaVfABKuyoSO6R+yuUyGhRyGDC7VBHDo7c6c69YjRKQ2ArjNEFSJ7I4ohgIsAvFSU85PMvEQ77IDjVcg2W92vm35rWXFFxHZ3SFjCv870tv3PR1nyqPNOpIpdfo/kLUhUD9CMmEILhP1lWrY1BhKWXOowsNAmQMn2R3mTA5KJOZFG5E2RO0dqJ5z1/l9V2kLIkxKwdKnYO69bjUVQkWijvpSr9BVrt8KrPMKOiUVasEucM/t3Ws/TM+/zuxc3mXom8wM4tkV+UGXqPbviU42wxjjYC345XiVre7inTSoqQISiRUQavBmhfa1GKZL3CP/7cfs/vbz/9urOny4agSvEK3fcoEYXmC/W9gvblXbGDwPcqnQFC2hvgB/4uZ5qVub/1LgAEABJNp5W/GguAAAAAASUVORK5CYII="
            />
            <image
              id="image6_881_14657"
              width="42"
              height="21"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAVCAYAAAAw73wjAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABDlJREFUeNrMlsty1EYUhk9LGmk0MwzYGEwIVMxtxQYegAfgBXgJNix4AnapynNkkazzCKzYUFBkkVQwmAJsg8cz4xmNLq1u/tOnxQyOuQVMUFWrJfXlfP2f06cV0vd4Je1bZOoET1somj9F3wXY2fOGyqKmYjYlrR9RVT6hMFonXS2j9cX/C3rtuqXRgKiGYOCjMlfUiqGfTkkpdLBruN1run870Jt3LBUZ0XCHKJsQ7Q2JYnh3pqU9jALSucXTEbI2w7ui2gzJmkMG/flXC4MEdxLtvmbFGiBy3w0AqoKceoynQkVVHQIOL8Gy62/NVbzc/bqgv/xm33lnEFvLc416BmBdQdE9ohEUzfGcYcgQyuYTga+wgaqqIkXHQc5s6cddv9/wp15skFXZGUPJEdFgl2gCkM2XgIXrNcoUMTnblf7FiFcFLowrswATdN0iyRzFbelg0M+Fy0sY0lKXqLdgPICtAO689whtcF8FJQ3Uy6FcFCI2N1liUbtm92JcnZH435VEVkunQP9Avi2CfghSY9JpLmOGUGcIRUYo27u8S2E8kw3C8eZ2LMoYCmqMMaV8qxi0jXrsQTk0Cilzd/AL58/As512mwsWoncgG7cxFMv/dBs1vm0hjbyCoWkmYNav3o3CbbAucCrwNUr2zPeZzKFK5YGqA9TgsRYriXgQAO22V3hFQBkyA9hfz0UtBuJg5+B3G8II2HhzDsjFKWMk5vZf9SsOvvcdOygtmUO1/OL8gsmEvE6q2QtBz81vGZrWIwd294Eot/4YgT8SOPKA/FxsL0zmSz1oAtXXyqvSeK296FKfmpYEjNUN0W5QB+irjMQxl0BpCpGqat1FQwoPH5EYHcLgGUzwx++S84x3qdmZpxf3oVhw0aI6PoOwAMqDqoSaRE2tnqjfXpGNE+H0CRkMz6GVXBorHxpYdGB6pMupM1PrJbdonF6RU6SEYqsdoo2NBVc28Rb7Zyww7HrllMA4lTp844QtJerOQ6R7lFMO6ouYFyB9tLU40cO1Hd5QlaQsDkvOpVUs7wGMVTj7rXoJx2acUyM6fRYdwfsQx2qMietYlAyPieEGjBZ2dLIqkHEqfTgldfoC2ANMvydDVvFP0cF8bbSPAbKciJIFMsZ0JB7ko5RPrnbb2+XcBh5dYkK6jHl41S8iSjFxBFXSn9AJ6nYQuyUmSX/4N2D/BNRB34SNJ9Ls2lFd+BGJBOAnscCkJTmzOZXYpRW8OMWpNANwCdv8A5LP5scqn1ocOnES+vO/L3Yl9NTb9HT/b6Qj/P5tYHd3UoFjZfha7othLl204f/BpbE1KNtJ5lAHXaaW7MF51pU9KXsQYzKWzZtnvgD8nz/VQdNIHuXEfeUS/gtheHAOE/mNswoVUoDEAGlFAh8GHz6tbt9Qh/GPo774bD8ksPeDfirsNwL7vN+2/6ryIVxvBBgA+ygQnJvB0CkAAAAASUVORK5CYII="
            />
            <image
              id="image7_881_14657"
              width="24"
              height="42"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAqCAYAAACpxZteAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABN1JREFUeNq0V01z21QUvU96kmXHn4nrJI1J02lJNx0WbPkTrNjwC1ix6QwMG/4Aw5b/wI4/ABvYwQyLsoEydVu3JMEO8adkW9LjXL3nkYtTW0oHzbzY1ij33Hvuuec9Ef3Pl9j6RMH7lJTysH6kOCaKQhd3f8CqYg23/bvcCuA4DylWFVLxfYA8pijCTTVHbgf4PMOPn7Dwnc5uVkG5+of51k3+TiYjUtE5kYUf8WMTogewjnmOgf7E4krnMgNAE1lLmgU1itSALNmlWKAitcyxgj8jEvYVCdVN7qv45+wVHN9T5E9jkjKi6WxCU58onHEQZB3iAZsp65LtgE77CcWgUCLvOB7TYt7ZXMGD91TSWOYjVhY5qk5iEZIKkFhYxv0xcrRJiCZWj5xCmywRQAg9sgCM1DYDSEd/ugWEmhIFAatIrhQOQAvVeXEil4LnIpU5KbeNqns087/YDFBvckC0CoEnC5RtJcUk8ZXQ38m2yHZRnawnonSli6pFUvl4mEGmNh7xdoj8K8SDMASCqoVpH2iQRXCP1QBjwIEYJFn4fHXR2D4HJQQOESxANgp0RaA85sYqnb0F6gTuFwCwAwCB51zvtRDWRoDbd4luHSFR/NNCabrS0hBQJj2mMpRaAoCN7zuVjACffKkSFoqoYhwazldUzYE5++IuUQ1s1LEqWA6q+u0Xsd0qSsjEcXlysSLNtQTY/DwFcGq6uibEUCnq+zwHmSrgkr0S0QA98LGm8LXZ3yY4goqSbrqNjHf3QBPA9ttE338nspmdEBogtLQ8mW/FQ8cZFvRvF0mc3IGCGvr52TSHm3IFvq9laplmUqz7wMFtUOJB+gf77FdaWUkCeeya5f7ikpKhYROLAzNoAHdAiw2K7h0jGU8DfP3ZmrdZG20ixj/1MWDDC8wCN3duzA1xXNB3BAk3UAUPFnvPNdf1AF99q734RR9VQKJe9T/GawBOwb/rajpZcbl2tDBKqQlGK/mYeZgMiO4e6uZy9p9/LPIBTOD5T16axvFeDPsncC1byBhyfPg+Pgt6ejdcb+7BDB0eIvN/nkFNL/mGNrrlgjOTNMEffSSyAzD/ETJ+Bf5HA2NscUoPB2+AmvatTMeW6ytg3sc+mf0V9AyMPAFQgO6raGq19BYAE+j9+bkOPuuZ6eU991CbWRnB9xtb6VkHWMpziJHvY8AmfBoJ9MRZXsp/cl6yb1jBAtn2jSzDcbq5CLNF1sH9/Xba4MwAy+yZ9x6mdzow9gC7FqDFgn27oKXVzHU2Xa/Ahxw7f2G4YM8LPnoG6fR6ZT1nJ/s5AZbZ83VxpV002TxGOrANq3DhOcWqpoYHLEOD1ytga5iYjGd902BjDRLZl6CeB8eZ+V8H8OGWXexaQ6zIADH/wpwU6pVcwdcB2ODO+vrsmVxBeoKt38YEA+BOKyfAKv9JFUv+LzW+3NPTy/TsVd+ygqfmHcKHipQ5A/H2yJt7DT1o1XO/QllrSrjsGmsw/CcGt9ynvRsArBoc69+6xp5qh3p6q8X0XgaJvg7AViDx8/QUPoPpLTp6p+LN5eggfebGb5nc7F/xOhZCOR28AfXP9cmh+q4+AHz4Qe7s11+hHn2jaA6Ds0HX099hDaCmBVm+00qzzxH8ze9oXE0H1Zwg+0v40W71RsH5+leAAQCy5pcUK2ycXgAAAABJRU5ErkJggg=="
            />
            <image
              id="image8_881_14657"
              width="42"
              height="27"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAbCAYAAAAK5R1TAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABPhJREFUeNrMls1vG1UUxc+bGXvGdmLHsXHixClJG9KmCVnQQGkBCQSlYodUAWKDkOiaLgCxYMkGJDZI7FkgNvwJ/BMsECsqWlBLExqcxElqx54Pzp07SZwSt6Xky9LTvPHMvPd755177wN6/Wz7Io7Rz/T4/wWCzsNJzSKVnsR645WjBrV6P7FNDJlKT6My0sHouH/cQIfhOPMwZkY1Nx4sy1BhGzPnIsydj44L6BTCyEOEHKKoRlABi7CFl0rTGJcjXH4rOmrQgDK2EKLKiKKHrT7YKQdeRp+GwY69r1yN8P5H0VEEUxHGeg/GnkUYPkfALKzUONyMg75+oFwC8gUg7QJZ3ldGADcLeEn78po5LEXPcrsdhD5Joiz7VTYLPkXbaAELK8DtOrApynYz8bnrAZ9/G+GL7w9EYWcPhRnd1ljcjUIXQduiujQEt3yzA6ytA032+waAdoojcIizU7tH+eoHhf34bXMQW59ju8r2EtspNu6teVIXY7NL8Q3BbL5mZ7Vv+KjMNRVpidP8ZGIUGKQ17PvWvw/AZleSB+bpyTcZMBPsc/ZIIsjeeVVg7Ti+YKU1sLxhXUtxTBdTo2+nuL5p3jv2v2d8TGizbQFjvcrZn2Gif52Wq9Gb41SNfm2LITUZbNs6aaKoVUjuOVRmVPslQo5yAZO85xB4amRv6P8Abroq0TU46Vkm95d5M0wuLwYNEsBo69pJ+n7yeVptIKpa/TtDZk9ozh3l5vTnFNrj/fgQP3EeTLUHvEkOIFfoq3NMOxd4V0PKLaM/P4CVpooZRzgV8X0JMN53kk8lyBoJdHoniRj27UG1glcVEagyQYfKDEK6qUpXuVzcpKRq+5GATdxs58P4EJJ2J9nOIJ3uQ9pz4omsjALcI9QmgzmUVJRn9P9FaAL6Tb0KbLi6Yw+T0eHtkvpaWv+4lGTNv0WO4bmqdIUZpJB9IKwTJ8E4TiwmSpR5RQwp2+Z1JXPZ3oAvrhO4zlcLNbJR2c1mUs+YXNs5hQuWOOqGAvtBkjEIukq/WxynfQ+4w6nzFQrQUnXHKmqNU9XdfpZUR1g1i+9/HW8rmlJ1luO6vlUqBdKlOlJC5ZohTIcwa3y/zvfrnLTFyTpsHs8x9d8JScWat7QQBH8nvk6pZQTY50JsycPcgZU/6WfaZJGFpMBsssI87RJ4gl4u5B56Hu1KWjyACGCOgVKqiNrapBJZXKfPIRao3m+ccJXXexvq4/pNBQy5oPaSQofLSfZIKbDNjGE8VVnSnEPAPlolm1Xo08weT088Iuj9vw8+jZDhIIMVrUoCHZuIk61S3esEvn4baKzRJg2FFj/LDrUW1MvBcpLy/MTPUuFKmu6kmLglHfNF1p6Ls3GK+/8lTmq7QG6XfSrXJkAjgb55B1jitga+tvW7aoHWIq+yEDk4tBJgBpfFhYfcFY9qnnkeeI2wQ0Xs/2lnq87H3g/0MCPXn2mFW1R2mQcbn0HVWEyA+R86icqB9gVafDv3LHD+EgOthgM7lu0C7oYWtX/6FfiDoE0GY4MK+5uaNTbvarYQRcv07MmTwBvv0rf5AwTtBb1ljRZVvUHPNgn4yw2FXqZVipIxmCkGiTZDf1afAL75zBwOaC+Vu5UW6GmW3e9+VC8P0K8X5oATI3HSP1zQXrDd0FIApOjIGSPPPPrJO+bx0tNhAO/jOXb/oR8C/o8AAwBbEJinc66yIQAAAABJRU5ErkJggg=="
            />
            <image
              id="image9_881_14657"
              width="33"
              height="39"
              xlinkHref="data:image/png;base64,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"
            />
            <image
              id="image10_881_14657"
              width="13"
              height="25"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAZCAYAAADqrKTxAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAhdJREFUeNqUlD9P20AYxh/bcdMEI0iB0lKWDpEYGZD6ATqw0JW5qtRvwIfI0IUPwdK5UpnaiQGpAwsSqapCaNIWQnDcGtuJ/xzP+USahJyinvLqfL773fu8fxwDuvHuvUD9HHCbQOIDay+A2ltDbplaQI6oDzTrwO8W58vB+4IWOPoOfPgIeF8A+wnQeQSsV6H3NDxED8hS4M3W4FI99I2xBD/Uc2kVOD4bbOkhzx9dF20172wbkyGZALdNWREXD/grASsLUzy1PUqjpTSTgEPAKWmgu8y5lBZ3mYQEMBxmj9IsM5em9ySTIJgxxJRWARYqI9uToV+MJwn4QA8y7JXFKVBCD9c/GU+HkhhL5TlQfTYFOmFtsozyMrVt0uZnBvGMQrU9gSRWPRax1yBj4rnXr6jS0ngKfGUnbNCMMNg+pWVg/5B8MgL9a1jvOr8YqSyolGYpiY6lLrsHbW4LfD3iAWbJa6okSBHlMrDIjmidToB8T626geqCvLu41fvDUtFLOjsB6oVAeMP24Zyy7wTNpBeDyQhcvm+MQY+fxnCveIAB9X0F5DHRbEIe9+ziGBTc+DTqd5x8zju7UFAgMygvDIMxSGQHjGEG/l+Z2grXrGQyy3cPkYQCPpy8wEPD4qEGovATMhEg7cmqfqbGLgyrC1N00I8Eri6WhiFjrInmZMVoL+WnCJvpjvsbfN7Ff457/1i3AgwAXRfaoSCdNYwAAAAASUVORK5CYII="
            />
            <image
              id="image11_881_14657"
              width="24"
              height="18"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAASCAYAAABB7B6eAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAl9JREFUeNqslN1vS3EYxz+npy9e9s4MY1mYG1cjxAWJO3+CiP/BnYi/QVwQi5vd2AURbojYFq4kQ8yGpZPKzFKjjW2lW9eu2p72+B5na9cyaadP8uS8P9/f9+V3DNbX1Xt28fziWYM6lFE2PDgDXR3QvJ16AXmKwx/ehqGn7t37z2Ap9SerTTFwBiSSMNAH8z8hHYbGXmjthD274MyxEqNNsPG6PEzI7oD8tCC14OUXkGyCub0wo3snjsORgyU2NQAZxY8mpP/YB4h+EosvkJsDOy3wNgiITUs3nBTQ0R7we6tmZJTpbOVhXCuemIJIUEACLeScB2C2wpb90Cag0wLqPQCJuNvXLhvVAaxVRkNfic3LUck1K/miApJPSEpzJ+w7JTkz0CNmhyRtbgV+LKjnYWTY2DimlZXWkCGBhCbliYByUQdd7Vtl1A5bG2B3C7T7tRCFZDEm7yIWsW++coCNNpxTSX34ZAyC42KkxnZlcz43mxUVgfg1r0VtZLWwlEV6JUwq2fdvkyqBEpLi1iOIf4UVMcp/182sG0YjoEDo2KFQLMWmyVuPyWQGq4vbeiBL/rxWAN5JtvCoG2tLRpNffcG0MM0RefRAF9dr2zhX7toUNGhBXsS1+tBH9XtISXdLIbAdf2zFkOfqfufoqQng0jnjdyyzGTe+7drhh7ukfaM82OZ4ImM80o+36tmNTa6mzl+w+TzlpiaZ0G/GAV6epmDdxM6H9MZw6We3mbpzw8DKuueObGZ2kYDvDaansDa8ftXZbdHQFMEf6P/77/p/KxL2KpaDFAqTlY9+CTAABqT6E5yN0LkAAAAASUVORK5CYII="
            />
            <image
              id="image12_881_14657"
              width="23"
              height="21"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAVCAYAAACt4nWrAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAApZJREFUeNq0lM1LVFEYxn9n5jrfY4lhaZHZokQKUQsqJKhF9rEIClq4aeG/UOCudVC0bxUtKgoiWlQuSihyo5CU9kX2/YGmo6PONKN35vbcbjakWDpTBw537p1zfvd5n+e9B/7j8Je0Oxq/Cc5e8vky3T37d/Ca2lkMa8GEyOXe4OSH9XSidHjjDodgyIfjBEmlwti5Uf2u0T/vNSeLhx9qd8FCJCA5DemZDLnsOsgHVMWAVnwoDt7R6RCOwKePmmMw/hXsjN5kZ4Uqx5haZXBt+fBT5x15DGPj0PsUpnS1Nclp+qL4VY7xTYjYqoATbgW+JYFPX3J+XHuew91eyGRgZsSFSl4cAivBikSIRbYTUmWBYNvSlJ+56uAT5EaPtHyW8kGB3dzyAlZCuAJWCR6X5cFQANveKHuCzGRfWX8FJ6bg+gMFl4KRR3JBXhupLRM0vho2V+l+VtWkIaW1k+rG6ck97nZrUag7huXp5TvqXgX4TapzstJfLbVroK4OmtYLmBRM0w3EhU+MVcxhrEXB958ouH61m8DpQW+pJWhlAzRv0dwAWXk/iqf6YZeZj7IWQG2lf6Ubhh5LyZCsVbuZcq1U+TXNcPwgxIJ6Ls/96vMLZ81irprfwEn5evE2JPQdpF4IoDJ9MZ0hUru1BQ7vEvBng9k2dLabP0VmfoEH3kJ3H3zp97rBaJ+lwFZskgVNsK+lsOvEMbOUDvZs6XsJt7qk9p1Cc8FhiNRDtRQf2Am1VcsGe3C3I+51u6kIrPDKdExEFFaD1LZtk7/hosAePKajoVwvSL+WYgUVVYvVN3r+Wv6iwR48KmX7j3rnRUpfWVwBHmn1PC8BXOiWk+cc+tV2bbsXrigSXIDP7/USoXPjuwADALDA4fxsaW4fAAAAAElFTkSuQmCC"
            />
            <image
              id="image13_881_14657"
              width="19"
              height="23"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAXCAYAAADpwXTaAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAo5JREFUeNqclEtIVFEYx3/3zuOONjPOjOajtEJFspQmhYhCSiqQiFoULSIIWrQJahOt2rSPFq1btHHTrk0Q1SYwJFpMLnoYGipk5SN8lenM3P7nDpbFOA8/7rkznPud//19/+/cA4XjOE7FdUoMa4P5Do1j+AMdhCqOEnSCzE7tLCbmzzN3WOMIPucETrBN/2sJR/0SK4vMiBzU+KzpKxpJIrEw8bhfvxAIQGrQKoXslBZ/x7J347pXIRvXXIwV3W2lxGqgMlyUzMayquXNGcKRBzihc9iBJmHEvKcZFxYyucygAxevuYXJXHdGJrcqeRcJ480CLM2heQGuwuIPpYVga4PoIkXITCzO93omG28SCYFV6YkWZn9KVM+HZb5fZDUSvH3fLSxmYnzE8rxpa4d4vRZHwSfrVqZFKtrxuVyeU0FxMRMDTyyvvKS2WXS7FlZrUqX+moGXryCtZvrV1TsP3eJiJup3QIPKSe6T6aZcEWYklpZ3/c9K8Gx99N+zSNRB915oFmHINHcbLI/ArLbg2/FcXh46O+8r7t60iMivC33Q2SvBWk0u65LYc5WbyeYVtDdkvnUpt9tbRBUTnU+lr07CZAoeDfzNWydoFzThxnmLrhb5KLKQxEjr+qat8h6GPlFamf9H34Fcd33yMjsPc8Pw+p2EM//QWSWJmeTUKDx9AVOD2sjazNFu2LMfzvaUSWYi2axyRRcQnasTYEndHRuDN6NlihnvTJw+JMFOlaumpL/C9BB8mMCjLovMRNUW6FFplU3mGFF3JZh6/Mes0sXW6JLqbpMO4EiXStY37JPExJdNkK0JXj6pw6BR365OkgaN9kavsxabCdPd+SV9Wh+hVfuvps570W8BBgCEOqblSGsoIQAAAABJRU5ErkJggg=="
            />
            <image
              id="image14_881_14657"
              width="25"
              height="15"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAPCAYAAAARZmTlAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAi1JREFUeNqslE1vElEYhZ9hKN8tA9JSqQXRYrQaE6Mrv2L8BybGxK1x6dKfUX9BN679G6Y7Y1zophJNtKWWYrAUGcoA46EDEiqN0cxN7tyPuXPOec/7zjXwq629cifWzx8Zo6nhO/jxJrKgb+Culg0bPn+D8hZcPAMLqf+IZJpquwObAi1vw7YIGuotrQMBePoEzpY4OZLHz1zCYchf8NZzqfG7Zhs23kO1DpWvcNgUmYC7Nb3sKapDiOr8zh6kskOSeGIdI/CQ9LxFMi3A9BiwXtU6A+/KnhVb6vvaszX2ZI8rgn5Lo4iRKHMBIouQK8EHnbseOyK5heNAKFyTrxb9vpTp4x0p7IUE+An2fgpUQAdfZLBs6H0XqM7QVY8IeB6CcWFIfXoZFrV+cFt75u/Eb+DI15nQPQ72u9SbQUIJcCoeRqehxwD4h8a2F52ZG4Qv4VI8q3lY89NZuLYCRY2mOeF8cFgZN2h3KnSE2jdXsG2vWtzu0IYBz5yikNJYHixVjquIl5bg5mURpLxEn/CfjBL/hr5zVzkr6mu8Pqi9qFQJYOYUZC5xZOX9O1CQ75bUG8YfgNPaiOStlL8W+FVtSb5sNGOyIakukqJsOCf+1dK4yv4CPI3E88cMVxVEhljSIqq8FApKpCorlx9X3D+AHycZWXaFWHyV9KwSaimKkGddS9X18oXhzyUXia6TmPtIJuuwfN716+6c/OPb9iZxM0BtV+bv+nZB/xJgAJa5smLgA18GAAAAAElFTkSuQmCC"
            />
          </defs>
        </svg>
      )

      break

    case "lohongnghiemtrongvacao":
      iconElement = (
        <svg
          width="45"
          height="45"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            d="M26.474 49.4323C38.8428 49.4323 48.8698 39.4053 48.8698 27.0365C48.8698 14.6676 38.8428 4.64062 26.474 4.64062C14.1051 4.64062 4.07812 14.6676 4.07812 27.0365C4.07812 39.4053 14.1051 49.4323 26.474 49.4323Z"
            fill="url(#paint0_radial_881_19003)"
          />
          <rect
            x="24.166"
            y="0.5"
            width="8.33333"
            height="17.5"
            fill="url(#pattern0)"
          />
          <rect
            y="13.8359"
            width="17.0833"
            height="11.6667"
            fill="url(#pattern1)"
          />
          <rect
            x="3.33398"
            y="33.4141"
            width="15.4167"
            height="15"
            fill="url(#pattern2)"
          />
          <rect
            x="28.75"
            y="34.25"
            width="14.1667"
            height="16.25"
            fill="url(#pattern3)"
          />
          <rect
            x="34.584"
            y="16.75"
            width="17.5"
            height="10.8333"
            fill="url(#pattern4)"
          />
          <rect
            x="13.334"
            y="2.57812"
            width="12.0833"
            height="17.0833"
            fill="url(#pattern5)"
          />
          <rect y="25.0781" width="17.5" height="8.75" fill="url(#pattern6)" />
          <rect
            x="17.084"
            y="35.4922"
            width="10"
            height="17.5"
            fill="url(#pattern7)"
          />
          <rect
            x="34.584"
            y="27.1641"
            width="17.5"
            height="11.25"
            fill="url(#pattern8)"
          />
          <rect
            x="29.584"
            y="4.66406"
            width="13.75"
            height="16.25"
            fill="url(#pattern9)"
          />
          <rect
            x="25.834"
            y="13"
            width="5.41667"
            height="10.4167"
            fill="url(#pattern10)"
          />
          <rect
            x="13.75"
            y="19.6641"
            width="10"
            height="7.5"
            fill="url(#pattern11)"
          />
          <rect
            x="15.416"
            y="28.8359"
            width="9.58333"
            height="8.75"
            fill="url(#pattern12)"
          />
          <rect
            x="27.5"
            y="30.5"
            width="7.91667"
            height="9.58334"
            fill="url(#pattern13)"
          />
          <rect
            x="30"
            y="22.1641"
            width="10.4167"
            height="6.25"
            fill="url(#pattern14)"
          />
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image0_881_19003"
                transform="scale(0.05 0.0238095)"
              />
            </pattern>
            <pattern
              id="pattern1"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image1_881_19003"
                transform="scale(0.0243902 0.0357143)"
              />
            </pattern>
            <pattern
              id="pattern2"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image2_881_19003"
                transform="scale(0.027027 0.0277778)"
              />
            </pattern>
            <pattern
              id="pattern3"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image3_881_19003"
                transform="scale(0.0294118 0.025641)"
              />
            </pattern>
            <pattern
              id="pattern4"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image4_881_19003"
                transform="scale(0.0238095 0.0384615)"
              />
            </pattern>
            <pattern
              id="pattern5"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image5_881_19003"
                transform="scale(0.0344828 0.0243902)"
              />
            </pattern>
            <pattern
              id="pattern6"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image6_881_19003"
                transform="scale(0.0238095 0.047619)"
              />
            </pattern>
            <pattern
              id="pattern7"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image7_881_19003"
                transform="scale(0.0416667 0.0238095)"
              />
            </pattern>
            <pattern
              id="pattern8"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image8_881_19003"
                transform="scale(0.0238095 0.037037)"
              />
            </pattern>
            <pattern
              id="pattern9"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image9_881_19003"
                transform="scale(0.030303 0.025641)"
              />
            </pattern>
            <pattern
              id="pattern10"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image10_881_19003"
                transform="scale(0.0769231 0.04)"
              />
            </pattern>
            <pattern
              id="pattern11"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image11_881_19003"
                transform="scale(0.0416667 0.0555556)"
              />
            </pattern>
            <pattern
              id="pattern12"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image12_881_19003"
                transform="scale(0.0434783 0.047619)"
              />
            </pattern>
            <pattern
              id="pattern13"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image13_881_19003"
                transform="scale(0.0526316 0.0434783)"
              />
            </pattern>
            <pattern
              id="pattern14"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image14_881_19003"
                transform="scale(0.04 0.0666667)"
              />
            </pattern>
            <radialGradient
              id="paint0_radial_881_19003"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(26.473 27.0364) rotate(158.093) scale(22.3956 22.3956)"
            >
              <stop stop-color="#ED1117" />
              <stop offset="0.3601" stop-color="#ED1117" />
              <stop offset="0.5179" stop-color="#ED1117" />
              <stop offset="0.6362" stop-color="#ED1117" />
              <stop offset="0.7349" stop-color="#000E28" />
              <stop offset="0.8203" stop-color="#00173F" />
              <stop offset="0.885" stop-color="#001F56" />
              <stop offset="1" stop-color="#005FCF" />
            </radialGradient>
            <image
              id="image0_881_19003"
              width="20"
              height="42"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAqCAYAAACz+XvQAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABAdJREFUeNqkV7uOHEUUPTXd09PLjtn1Y+2VvcgYrQPAEpJFZiISUiJCfoCUHBEQIMFPkCCR8APOIEcWQhi0AViL2Md4dnYe3T39Kk7VrZ6Ht2dnZimppvpVp++55z56gHXHNz9ofPWdXnRbrQySpMDzv4GdTSDtc6cHDArgrTeBLz5VqwMaMDOOu8DTn4DXeRz/CwS3gb2HBLwP3ODFzz9RywErsGEM/Pwr8Nsz4PwXoIyA6+8Ab7wH3NoBPnwszxPUXwpmxgEtOj4DXh4A2QjQfMHpCRD9QUvpAs1HldjWWFmM/uDitbIE7u/OGbEcMKfjDw65mSsqo0NZbuyJZWrqueWAo7Gz8GT++oLAWQ44iOYRtHtBo3lFQEPZTAuWumAjWHhHjh/srgl4TlVHVLWIRU1rqZK14V3BwsNTWphzPxUteg5oS+61gvlnGYeNlej2uwL46ghI3ffWsDAaC6ABy87dRQcQMt3u3uIarEnZilEKVSs0rWqSsiHX4PQaE7rLAf86lnU8qnzgVHbBbIrCSqLM5nGUyFr0nSDXROWwfcU4NDk87pjEdVMJXTNub18B0BQA40Mbg6VQ9ZjLrRZ3qzn/LQc8Yrj0jp0o5XxNNkG90VrTwipkUGUIQyRkhdm6C1xjHdwI1gCsgtpQtZQL5z839+/V1vuLgF9/P1X46ESo5kdcWRj8HRHExqC6kCVm+LVBnHMOGS4JZ9qp1JkRR0t+K7UCYEFqKYH+fOEKQjxfVU0JM/RNluTZCoDjGYCzf2ZKlgM0dM2LdjdrXT8P+NmXGi/pr9eYBec9d7d8xUKet5oSn9FwCeDIdbZSC6BpmaoKG1/WcIP3WYXioY0itMLLKDtq3a4A6nKmDiqx1qprfE3QMVUusksAhwPZF9PxZ2zuOneUUylbJuVSWt1mPykoXD+5hPIHH2kcvZBQyH2hpDOZE/8VErlpJO5JKOD2zQWAutrE2T2Vxp71nJWQry1znNNCn/c6ZOBxu99cANhzAZyZlFOy2ZapYiavvGk7TT1xxdMfVT2gCVJDwSjcJ6UkEit11ZO1szaT2aOl3qI2eudehmgksWVAilw2T0RRrhW7a0k0zapaUdJkSDEooUoI2kaZCr0yJUwhHV01lU0301diChKrSzIlyzqcrksGMVJ2JY1txuDUJeU4gPZSNIO2ZZBlDQZ5WQ+oy+e0zictn9b6PA8ZsIfTglfuWYFshhQdeO0tnjcx6NV8tKvGE/6+PymehmphC+ojCaWZTPGYa01/39XB65ybGPYf1v0LeJvzd84n7pxf5DiZfBTBvnCbsdizMgbBI1sPg2AHo+HH6/ytYImGacSmarzrlDL5tk9fhgRt0z3f4n+Oqm3s1t38T4ABAITeyz5Tk9DnAAAAAElFTkSuQmCC"
            />
            <image
              id="image1_881_19003"
              width="41"
              height="28"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAcCAYAAAD815boAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABTdJREFUeNrMl7tvHFUUxs/szOx6/SROYhvsGEIMQUIoINJR0VAiKhp6+AOgoEGIgo4uiCL/AIgGBUEJpokEgaAgbBTHduI4fmTttb3e1+xjHvzunFnLiReTx9rOla7uzOydO9/9zne+c9eS+9sX30bSrn30riVH1Kx7wNUaIhEY066InZInBay1A3B1XWR6XmSlINLdLfLOGyKVmkhPl4hjHylYZ+dqYZY+JbIJk54nsromks2KnH9JpB/QI4OAz9wri0MCasUfMwCv/CSyHYrcuEKoTxDy44yA7DvJVtIiE+Mi5ya4RgZDT/GmdWisKpNuj8gWYV5eRJMA9VfoMGkPidQZMwCdaYrM8/sIz14YEznWJzJ6XKXQSrYDAqsg1ysA5YPRNk/4TlDmus4IqABNBnXtNuFuNlQKg8dExgD82hkFarR7QGA13LlNkas3RP78XbPbW2IMYDOvYAV2BRAWPQWDbr/IwLMa8j7AvoIMRpHIMDLoSndcBsrkMElxalikeg5dlmAWLTbJbA+G/EICFNAR1wHPhdDniwDincoGnXd6B2D1rMhpnrks259VZoNAJfTxe9bjMdlqP/4GI+hvDia3CXnOhJvwVrkPYDsCXOQz0XQ2YJ/UMfs0KzH2wqaDJJ7h/q3zvMO8rKvv+PQCkalVRS5+bj2aT7aaHyhLuS2R2QTsFot7sNiEseZ2IgPmiWeyDgnAogV7GVhMAXLwOWV+hPtxtH6KLmw2BGiNd+oAzd9l86z98yXr4SrO7hYSolmy3FShJYw+R1hXb/Nt2KzxgZAx2EjA1lU5xrrMkt1jGuIe9OoCOsNGhtnIKHruYl4DkFWS1Ut6GQJKbP7mdWt/M7+/pfDDs3wsCFVjJpNz9CUye8VWVjxHQxluqxSCu5pkJaRhk0Qh+k0Zppm/uSxyG6vrIbGG0KsTqu4bteR7zBk/E0m5WJRmfV1KxYm9TP7fAcPIYAXmChXVbMVTX/Vh2jPMwmYzlzhBS7dpdQOjV5cxxaYcw7itjPba8RTx68poox7QK/R18ZuT9Cm0fGF/PfwX4CLhWgDQHOyUWHxxVq2rghzCTU2mKHGBGLSjzJprU8UkUrDGwtKtnjJaLQGqBMhl/PgvEu9r7n95OFtop9tbgJ1Z1ERbnFEtNrkOYDosqhyisgIzYA2rFvQ5vcq+kZVJsm7Xh7kyGr+O7v9h7Q1AXsLCLj+ad7VjuOQpu5PYWBlZNCoKos6zsJRYV5Swm0qUZgBz7WbNpoqm9olrE+qGAfmDhMF37TX5uIALAJpHBnOwu3wHCeQ1QXwwBBVNpp0qtpOlUGlV0Oo6wH6FzWtM4twoHQK5G2wYqATqsLpByG8C8hZg13CE8po6gI+eQ09ZjoEaCxPQCxZhkZFiBH7NrLizhY6BNHU62qVVk72nsaxXnxd5ESsbwti7CKvt6kEllVZ9ioMObNBboI840EbsTObbm3kn26cXo7ieV5NeIXGKBWV3YQG9esZukEHVnAWM0TLB+huAMwnQC7v1kDoQkJ+9z5ngQys26JjZQJMmAydDnKBODGgZMb87mTL+2aqz7CCa3lNXDvTc/+UnVlyrm0ndjmMHWJs+QPXJEmpzFrWsPFk+R1zLyYEgfLCy2Kn2zVcqqTffjuITkCROZP6NZtJlTXlH8yeI/uC3yw9euzvdJr9XsC+/HsX12pRAc5QLwzuwO0W0p1QWbY4Rh/5Pf/qqRRUJARdRSr34mZFDEGA9e1k8GpCmLS/YsrbiwlyeUmj8MS9PfHPTH+z3878CDABe3IgtXQZ+BAAAAABJRU5ErkJggg=="
            />
            <image
              id="image2_881_19003"
              width="37"
              height="36"
              xlinkHref="data:image/png;base64,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"
            />
            <image
              id="image3_881_19003"
              width="34"
              height="39"
              xlinkHref="data:image/png;base64,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"
            />
            <image
              id="image4_881_19003"
              width="42"
              height="26"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAaCAYAAADBuc72AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABOVJREFUeNrMmMtvG1UUxr95eDx+ZeK4edZKaRsCagtUKFlViAVS/4QKCSGxZMmiiy75A0DiD+iCNWKPxA6hbhCIDVAJIrUpaZuH48SJ40c8D74z5yZOKyclapPU0vWduRnP/c33nXPunVg4689X3yUDx2/fsg6eWq8V3BGw1msDGUbAH4uAQ6RyUVshtw9rnSmgwK1uAmsN4OEy0AuBxjbH2c/PApUh4ML5FNY9dUCBa3UJSLh/V4F19o0msLMDNNeA3S2q2gF+fQLcvAmsPDlh658H3GpRtRXgwVPAdXhOsLU6sE3YmPBdKhr3+CAcS9hXysClt4Fbn6c/d0/c3j3APWsFrrZEGMJ1OJaEChZtmWOqDY8Ks/fGgJ9/Aj748CVBv7ybwGfA2zab0x+PYuARbVwkSJ0AyzUCr9NWQofb2hJeE9bkYgPHc/jaHKqZq1LlPFCaAtrdY4J++kUCh0D5kjaxTD6Jib32LrBUU3uXCbb6mNdQpXZN1Ypod2yaKIqeqifNGVGD/XE+dAYoMokuX+R5ltDZF4Bem0uQpWI+nyzgjULeWEBd3ijixCHBNqnY0gaTgv0jWlxj6zRN3PEYVDuqK1jMJMEB9Zwp/bs/yY4oASEd9oUC8P5bjNEJYKgwIOuD8u/IeG+wFdlcJJQqk+lX3FZTDzaZqR1O1uCkfz7kEOG7bcbVhqoWtUzM9bSlyoWqmE1bLT64yzqZKelvy1UVYP4KxeV8FwkYFJ5BU1DXvUGVPkMUbcJN+nbK5PIp8IYN1juHNqwQYIOA7TCNHbQFin1MdUM5XlWVUuUiY2sF+tAjaqtA+qyRObbhAHj3shb4UR7n/YGrk7sPleA+v2cQxzXsdsWK4TTuEtrV4QU76zppVyztqhJhV+EkGSTu0ht1zAx8KGfUxN2oggZV7YvDwJvTwHUChnSmUtKSdcQSqqBReI+OzrH9whtVabuoFaOxY8PzFUISxfE0TmUyqXlx21gbGWt5X2dcb5ubMlCj+juX7RyVrbLkXJ1WsCGGgGXh/2xKDsSoVaeC1yhKHbGVgRUX0e3Z2I2M4vzqNVU1SYykZQJXbOak9pCJPfbj75nr2PKMtXdmgImyWb/9F6o36NMHDXs1OJkF9GKHECOMxybjbojNVpjYlBRTksBYcwIddwjgnaN6VCuiwpMTCnqJqlY5HvABfO9YYIeDAj8wmWZhkSaJmwg7nCE+kFmW6amGxUltKpOtaOHOUq0CIXMEmqeaZcbctFhuP2vtMeEOAxV1HpOFqWkxxaMNMzi8b7FUM1HPZqJkCeNX9AFGqWCV6l1lcgQltVtWq5eEOwIUXFISRnosFaCqltsxwewUUlqurHA5wozR+iuMP0m4MSpY4pjvq8q3P36lG57nQe9xllkTgA3aRunsItysncJ5tDbHnwxT5CmuJoHUPU/h4lgB73xyIjuyQUvo34Q6z00GpbIC1tOnyLuTLC9uaqlAlgjoOX17BfKbOye6CR8E+huVZObHF5DNiq3XkXHTjQHyWQ3XPSSpt99+fSpvCYNAO4SMuKxK1j6Aa1e5DhdNCdNNgyT/j9+f6vvWYbsnidU57oA+YsmSXVIHHjcqPYIu/HUmb672IeMzsC2JvR0ur6uEDdFpbWHxn7N5vT5C0QUup/dhJy7ssInm1o2z/j/FfwIMAB354T7Q7s71AAAAAElFTkSuQmCC"
            />
            <image
              id="image5_881_19003"
              width="29"
              height="41"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAApCAYAAADJeCK0AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABThJREFUeNq8V0tvG1UU/mY8duI475CmcUIalAZBqaqKwhIk9kjsECvEP2BBhcSq24rHH0BiwQ5YsQIJCVUguisB1FBR4rZEeZCHPXH8GI89j8t35o47efHwQxxpPJ5778w33znnO/eMgaP24RcKm4+A0ASKDpAdAp69oOeuv26gT2YcA1z7HbBC4NbXQP55YOsAuHYZuHoxuaMP4Gb0+8HnCnsEKBWBb74EWk3g+6+AzXWu4BI/OO6NHs16/JC1TeDBH0DZBqp7gJrkIKe+W6G7eb661C/vxkzFWj6wXwcOXcDl4ZF1gy9i87jzG8frfWObgE6MEYRuxSAjPSBvQbfu6blGA3i0c9zNfQEVe+YKMPQkkJ6JgWnOEbbbpb6wTUAvUxrz08DYLMnOtH3OeJaBZlGztat0fauPTK0UdUl2s+fIMp2wVQQJBHBDs602+uzep+eBqVFgPA9knogHGeeQDFtlzXaLrD2/R9CjYs9mgEmCTlMuKSaUJWx5Vsxmv5awdZo9xdU8NfLUeWB0mHEleHqcK4Y1W0XJeGR8sA/89KAnN5unStso6+0cE2qKsbUIaOY027BC0EO9pkDGYdg1W/PMmmry7wSZDuRi4CwHA+3m6hYLBavW6nrXujXPHL20ACzNMbaz2sXGCAdTsXxirf5KF2/bXbE9Dtpmm+Lw3BQ1S7A0XZvKajfD00eFbOuM747dFdvTTNvAIp1lSmhs+sgk2QYHyeUvBSZWrWO25j/OLlIy56nXIWa0RXAjq6uU+yfjSrYOM3qDulWqDzFts5VMvihsZ06wtZPLlfu8jjP5/c9U70zFlphMeYIO8pwSV2e0bhvb3HspHYexXSnoahUGPbq3zTbHRHpukRKaPX5bIOWQ2exSvz+zSu3INV1/42PVO9M223keWdZkczxhK8WizgrlVHQmlw90fK9/pLoHbbOVHUhsaCQujcxspHVsDemhyHDlLrAuhYM6rlf6wFTslSu6Qg1Sv2YmvpVgzkPqdlOzFVDpsTx64a13VPegUmN9FoRBsp2jfIJm1K/ByOgONqROFedDvkD5UK93OFbjS7z2puoO9N03jChO0pa+uAwsLMZsc3FLw721JeyYvUVm9D0mlb2vQauHPbi35carKYkxadyEQJjMB8xih0A+120Q2Lb1PU0eL7ysTve9/8UarDzNhj5yvCXLncdNabZBoOuxV9I7kRwlznl1ncleq0umN9824MctyiQBF6Q0TsQbwYCuUip+eJNuPaB0avWkWFxYVp0zjVpRJkdARk1WIMFJm1HyJu9NgFZJtzmODPMlm+k46fgzk69id3ukM8l8ctOItjORRpoPGZZOMdQ6NVLxt5in1ypfx1zc67dCbgw+vxr8znXaZivm1jQTaeQsHoaVfABKuyoSO6R+yuUyGhRyGDC7VBHDo7c6c69YjRKQ2ArjNEFSJ7I4ohgIsAvFSU85PMvEQ77IDjVcg2W92vm35rWXFFxHZ3SFjCv870tv3PR1nyqPNOpIpdfo/kLUhUD9CMmEILhP1lWrY1BhKWXOowsNAmQMn2R3mTA5KJOZFG5E2RO0dqJ5z1/l9V2kLIkxKwdKnYO69bjUVQkWijvpSr9BVrt8KrPMKOiUVasEucM/t3Ws/TM+/zuxc3mXom8wM4tkV+UGXqPbviU42wxjjYC345XiVre7inTSoqQISiRUQavBmhfa1GKZL3CP/7cfs/vbz/9urOny4agSvEK3fcoEYXmC/W9gvblXbGDwPcqnQFC2hvgB/4uZ5qVub/1LgAEABJNp5W/GguAAAAAASUVORK5CYII="
            />
            <image
              id="image6_881_19003"
              width="42"
              height="21"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAVCAYAAAAw73wjAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABDlJREFUeNrMlsty1EYUhk9LGmk0MwzYGEwIVMxtxQYegAfgBXgJNix4AnapynNkkazzCKzYUFBkkVQwmAJsg8cz4xmNLq1u/tOnxQyOuQVMUFWrJfXlfP2f06cV0vd4Je1bZOoET1somj9F3wXY2fOGyqKmYjYlrR9RVT6hMFonXS2j9cX/C3rtuqXRgKiGYOCjMlfUiqGfTkkpdLBruN1run870Jt3LBUZ0XCHKJsQ7Q2JYnh3pqU9jALSucXTEbI2w7ui2gzJmkMG/flXC4MEdxLtvmbFGiBy3w0AqoKceoynQkVVHQIOL8Gy62/NVbzc/bqgv/xm33lnEFvLc416BmBdQdE9ohEUzfGcYcgQyuYTga+wgaqqIkXHQc5s6cddv9/wp15skFXZGUPJEdFgl2gCkM2XgIXrNcoUMTnblf7FiFcFLowrswATdN0iyRzFbelg0M+Fy0sY0lKXqLdgPICtAO689whtcF8FJQ3Uy6FcFCI2N1liUbtm92JcnZH435VEVkunQP9Avi2CfghSY9JpLmOGUGcIRUYo27u8S2E8kw3C8eZ2LMoYCmqMMaV8qxi0jXrsQTk0Cilzd/AL58/As512mwsWoncgG7cxFMv/dBs1vm0hjbyCoWkmYNav3o3CbbAucCrwNUr2zPeZzKFK5YGqA9TgsRYriXgQAO22V3hFQBkyA9hfz0UtBuJg5+B3G8II2HhzDsjFKWMk5vZf9SsOvvcdOygtmUO1/OL8gsmEvE6q2QtBz81vGZrWIwd294Eot/4YgT8SOPKA/FxsL0zmSz1oAtXXyqvSeK296FKfmpYEjNUN0W5QB+irjMQxl0BpCpGqat1FQwoPH5EYHcLgGUzwx++S84x3qdmZpxf3oVhw0aI6PoOwAMqDqoSaRE2tnqjfXpGNE+H0CRkMz6GVXBorHxpYdGB6pMupM1PrJbdonF6RU6SEYqsdoo2NBVc28Rb7Zyww7HrllMA4lTp844QtJerOQ6R7lFMO6ouYFyB9tLU40cO1Hd5QlaQsDkvOpVUs7wGMVTj7rXoJx2acUyM6fRYdwfsQx2qMietYlAyPieEGjBZ2dLIqkHEqfTgldfoC2ANMvydDVvFP0cF8bbSPAbKciJIFMsZ0JB7ko5RPrnbb2+XcBh5dYkK6jHl41S8iSjFxBFXSn9AJ6nYQuyUmSX/4N2D/BNRB34SNJ9Ls2lFd+BGJBOAnscCkJTmzOZXYpRW8OMWpNANwCdv8A5LP5scqn1ocOnES+vO/L3Yl9NTb9HT/b6Qj/P5tYHd3UoFjZfha7othLl204f/BpbE1KNtJ5lAHXaaW7MF51pU9KXsQYzKWzZtnvgD8nz/VQdNIHuXEfeUS/gtheHAOE/mNswoVUoDEAGlFAh8GHz6tbt9Qh/GPo774bD8ksPeDfirsNwL7vN+2/6ryIVxvBBgA+ygQnJvB0CkAAAAASUVORK5CYII="
            />
            <image
              id="image7_881_19003"
              width="24"
              height="42"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAqCAYAAACpxZteAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABN1JREFUeNq0V01z21QUvU96kmXHn4nrJI1J02lJNx0WbPkTrNjwC1ix6QwMG/4Aw5b/wI4/ABvYwQyLsoEydVu3JMEO8adkW9LjXL3nkYtTW0oHzbzY1ij33Hvuuec9Ef3Pl9j6RMH7lJTysH6kOCaKQhd3f8CqYg23/bvcCuA4DylWFVLxfYA8pijCTTVHbgf4PMOPn7Dwnc5uVkG5+of51k3+TiYjUtE5kYUf8WMTogewjnmOgf7E4krnMgNAE1lLmgU1itSALNmlWKAitcyxgj8jEvYVCdVN7qv45+wVHN9T5E9jkjKi6WxCU58onHEQZB3iAZsp65LtgE77CcWgUCLvOB7TYt7ZXMGD91TSWOYjVhY5qk5iEZIKkFhYxv0xcrRJiCZWj5xCmywRQAg9sgCM1DYDSEd/ugWEmhIFAatIrhQOQAvVeXEil4LnIpU5KbeNqns087/YDFBvckC0CoEnC5RtJcUk8ZXQ38m2yHZRnawnonSli6pFUvl4mEGmNh7xdoj8K8SDMASCqoVpH2iQRXCP1QBjwIEYJFn4fHXR2D4HJQQOESxANgp0RaA85sYqnb0F6gTuFwCwAwCB51zvtRDWRoDbd4luHSFR/NNCabrS0hBQJj2mMpRaAoCN7zuVjACffKkSFoqoYhwazldUzYE5++IuUQ1s1LEqWA6q+u0Xsd0qSsjEcXlysSLNtQTY/DwFcGq6uibEUCnq+zwHmSrgkr0S0QA98LGm8LXZ3yY4goqSbrqNjHf3QBPA9ttE338nspmdEBogtLQ8mW/FQ8cZFvRvF0mc3IGCGvr52TSHm3IFvq9laplmUqz7wMFtUOJB+gf77FdaWUkCeeya5f7ikpKhYROLAzNoAHdAiw2K7h0jGU8DfP3ZmrdZG20ixj/1MWDDC8wCN3duzA1xXNB3BAk3UAUPFnvPNdf1AF99q734RR9VQKJe9T/GawBOwb/rajpZcbl2tDBKqQlGK/mYeZgMiO4e6uZy9p9/LPIBTOD5T16axvFeDPsncC1byBhyfPg+Pgt6ejdcb+7BDB0eIvN/nkFNL/mGNrrlgjOTNMEffSSyAzD/ETJ+Bf5HA2NscUoPB2+AmvatTMeW6ytg3sc+mf0V9AyMPAFQgO6raGq19BYAE+j9+bkOPuuZ6eU991CbWRnB9xtb6VkHWMpziJHvY8AmfBoJ9MRZXsp/cl6yb1jBAtn2jSzDcbq5CLNF1sH9/Xba4MwAy+yZ9x6mdzow9gC7FqDFgn27oKXVzHU2Xa/Ahxw7f2G4YM8LPnoG6fR6ZT1nJ/s5AZbZ83VxpV002TxGOrANq3DhOcWqpoYHLEOD1ytga5iYjGd902BjDRLZl6CeB8eZ+V8H8OGWXexaQ6zIADH/wpwU6pVcwdcB2ODO+vrsmVxBeoKt38YEA+BOKyfAKv9JFUv+LzW+3NPTy/TsVd+ygqfmHcKHipQ5A/H2yJt7DT1o1XO/QllrSrjsGmsw/CcGt9ynvRsArBoc69+6xp5qh3p6q8X0XgaJvg7AViDx8/QUPoPpLTp6p+LN5eggfebGb5nc7F/xOhZCOR28AfXP9cmh+q4+AHz4Qe7s11+hHn2jaA6Ds0HX099hDaCmBVm+00qzzxH8ze9oXE0H1Zwg+0v40W71RsH5+leAAQCy5pcUK2ycXgAAAABJRU5ErkJggg=="
            />
            <image
              id="image8_881_19003"
              width="42"
              height="27"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAbCAYAAAAK5R1TAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABPhJREFUeNrMls1vG1UUxc+bGXvGdmLHsXHixClJG9KmCVnQQGkBCQSlYodUAWKDkOiaLgCxYMkGJDZI7FkgNvwJ/BMsECsqWlBLExqcxElqx54Pzp07SZwSt6Xky9LTvPHMvPd755177wN6/Wz7Io7Rz/T4/wWCzsNJzSKVnsR645WjBrV6P7FNDJlKT6My0sHouH/cQIfhOPMwZkY1Nx4sy1BhGzPnIsydj44L6BTCyEOEHKKoRlABi7CFl0rTGJcjXH4rOmrQgDK2EKLKiKKHrT7YKQdeRp+GwY69r1yN8P5H0VEEUxHGeg/GnkUYPkfALKzUONyMg75+oFwC8gUg7QJZ3ldGADcLeEn78po5LEXPcrsdhD5Joiz7VTYLPkXbaAELK8DtOrApynYz8bnrAZ9/G+GL7w9EYWcPhRnd1ljcjUIXQduiujQEt3yzA6ytA032+waAdoojcIizU7tH+eoHhf34bXMQW59ju8r2EtspNu6teVIXY7NL8Q3BbL5mZ7Vv+KjMNRVpidP8ZGIUGKQ17PvWvw/AZleSB+bpyTcZMBPsc/ZIIsjeeVVg7Ti+YKU1sLxhXUtxTBdTo2+nuL5p3jv2v2d8TGizbQFjvcrZn2Gif52Wq9Gb41SNfm2LITUZbNs6aaKoVUjuOVRmVPslQo5yAZO85xB4amRv6P8Abroq0TU46Vkm95d5M0wuLwYNEsBo69pJ+n7yeVptIKpa/TtDZk9ozh3l5vTnFNrj/fgQP3EeTLUHvEkOIFfoq3NMOxd4V0PKLaM/P4CVpooZRzgV8X0JMN53kk8lyBoJdHoniRj27UG1glcVEagyQYfKDEK6qUpXuVzcpKRq+5GATdxs58P4EJJ2J9nOIJ3uQ9pz4omsjALcI9QmgzmUVJRn9P9FaAL6Tb0KbLi6Yw+T0eHtkvpaWv+4lGTNv0WO4bmqdIUZpJB9IKwTJ8E4TiwmSpR5RQwp2+Z1JXPZ3oAvrhO4zlcLNbJR2c1mUs+YXNs5hQuWOOqGAvtBkjEIukq/WxynfQ+4w6nzFQrQUnXHKmqNU9XdfpZUR1g1i+9/HW8rmlJ1luO6vlUqBdKlOlJC5ZohTIcwa3y/zvfrnLTFyTpsHs8x9d8JScWat7QQBH8nvk6pZQTY50JsycPcgZU/6WfaZJGFpMBsssI87RJ4gl4u5B56Hu1KWjyACGCOgVKqiNrapBJZXKfPIRao3m+ccJXXexvq4/pNBQy5oPaSQofLSfZIKbDNjGE8VVnSnEPAPlolm1Xo08weT088Iuj9vw8+jZDhIIMVrUoCHZuIk61S3esEvn4baKzRJg2FFj/LDrUW1MvBcpLy/MTPUuFKmu6kmLglHfNF1p6Ls3GK+/8lTmq7QG6XfSrXJkAjgb55B1jitga+tvW7aoHWIq+yEDk4tBJgBpfFhYfcFY9qnnkeeI2wQ0Xs/2lnq87H3g/0MCPXn2mFW1R2mQcbn0HVWEyA+R86icqB9gVafDv3LHD+EgOthgM7lu0C7oYWtX/6FfiDoE0GY4MK+5uaNTbvarYQRcv07MmTwBvv0rf5AwTtBb1ljRZVvUHPNgn4yw2FXqZVipIxmCkGiTZDf1afAL75zBwOaC+Vu5UW6GmW3e9+VC8P0K8X5oATI3HSP1zQXrDd0FIApOjIGSPPPPrJO+bx0tNhAO/jOXb/oR8C/o8AAwBbEJinc66yIQAAAABJRU5ErkJggg=="
            />
            <image
              id="image9_881_19003"
              width="33"
              height="39"
              xlinkHref="data:image/png;base64,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"
            />
            <image
              id="image10_881_19003"
              width="13"
              height="25"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAZCAYAAADqrKTxAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAhdJREFUeNqUlD9P20AYxh/bcdMEI0iB0lKWDpEYGZD6ATqw0JW5qtRvwIfI0IUPwdK5UpnaiQGpAwsSqapCaNIWQnDcGtuJ/xzP+USahJyinvLqfL773fu8fxwDuvHuvUD9HHCbQOIDay+A2ltDbplaQI6oDzTrwO8W58vB+4IWOPoOfPgIeF8A+wnQeQSsV6H3NDxED8hS4M3W4FI99I2xBD/Uc2kVOD4bbOkhzx9dF20172wbkyGZALdNWREXD/grASsLUzy1PUqjpTSTgEPAKWmgu8y5lBZ3mYQEMBxmj9IsM5em9ySTIJgxxJRWARYqI9uToV+MJwn4QA8y7JXFKVBCD9c/GU+HkhhL5TlQfTYFOmFtsozyMrVt0uZnBvGMQrU9gSRWPRax1yBj4rnXr6jS0ngKfGUnbNCMMNg+pWVg/5B8MgL9a1jvOr8YqSyolGYpiY6lLrsHbW4LfD3iAWbJa6okSBHlMrDIjmidToB8T626geqCvLu41fvDUtFLOjsB6oVAeMP24Zyy7wTNpBeDyQhcvm+MQY+fxnCveIAB9X0F5DHRbEIe9+ziGBTc+DTqd5x8zju7UFAgMygvDIMxSGQHjGEG/l+Z2grXrGQyy3cPkYQCPpy8wEPD4qEGovATMhEg7cmqfqbGLgyrC1N00I8Eri6WhiFjrInmZMVoL+WnCJvpjvsbfN7Ff457/1i3AgwAXRfaoSCdNYwAAAAASUVORK5CYII="
            />
            <image
              id="image11_881_19003"
              width="24"
              height="18"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAASCAYAAABB7B6eAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAl9JREFUeNqslN1vS3EYxz+npy9e9s4MY1mYG1cjxAWJO3+CiP/BnYi/QVwQi5vd2AURbojYFq4kQ8yGpZPKzFKjjW2lW9eu2p72+B5na9cyaadP8uS8P9/f9+V3DNbX1Xt28fziWYM6lFE2PDgDXR3QvJ16AXmKwx/ehqGn7t37z2Ap9SerTTFwBiSSMNAH8z8hHYbGXmjthD274MyxEqNNsPG6PEzI7oD8tCC14OUXkGyCub0wo3snjsORgyU2NQAZxY8mpP/YB4h+EosvkJsDOy3wNgiITUs3nBTQ0R7we6tmZJTpbOVhXCuemIJIUEACLeScB2C2wpb90Cag0wLqPQCJuNvXLhvVAaxVRkNfic3LUck1K/miApJPSEpzJ+w7JTkz0CNmhyRtbgV+LKjnYWTY2DimlZXWkCGBhCbliYByUQdd7Vtl1A5bG2B3C7T7tRCFZDEm7yIWsW++coCNNpxTSX34ZAyC42KkxnZlcz43mxUVgfg1r0VtZLWwlEV6JUwq2fdvkyqBEpLi1iOIf4UVMcp/182sG0YjoEDo2KFQLMWmyVuPyWQGq4vbeiBL/rxWAN5JtvCoG2tLRpNffcG0MM0RefRAF9dr2zhX7toUNGhBXsS1+tBH9XtISXdLIbAdf2zFkOfqfufoqQng0jnjdyyzGTe+7drhh7ukfaM82OZ4ImM80o+36tmNTa6mzl+w+TzlpiaZ0G/GAV6epmDdxM6H9MZw6We3mbpzw8DKuueObGZ2kYDvDaansDa8ftXZbdHQFMEf6P/77/p/KxL2KpaDFAqTlY9+CTAABqT6E5yN0LkAAAAASUVORK5CYII="
            />
            <image
              id="image12_881_19003"
              width="23"
              height="21"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAVCAYAAACt4nWrAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAApZJREFUeNq0lM1LVFEYxn9n5jrfY4lhaZHZokQKUQsqJKhF9rEIClq4aeG/UOCudVC0bxUtKgoiWlQuSihyo5CU9kX2/YGmo6PONKN35vbcbjakWDpTBw537p1zfvd5n+e9B/7j8Je0Oxq/Cc5e8vky3T37d/Ca2lkMa8GEyOXe4OSH9XSidHjjDodgyIfjBEmlwti5Uf2u0T/vNSeLhx9qd8FCJCA5DemZDLnsOsgHVMWAVnwoDt7R6RCOwKePmmMw/hXsjN5kZ4Uqx5haZXBt+fBT5x15DGPj0PsUpnS1Nclp+qL4VY7xTYjYqoATbgW+JYFPX3J+XHuew91eyGRgZsSFSl4cAivBikSIRbYTUmWBYNvSlJ+56uAT5EaPtHyW8kGB3dzyAlZCuAJWCR6X5cFQANveKHuCzGRfWX8FJ6bg+gMFl4KRR3JBXhupLRM0vho2V+l+VtWkIaW1k+rG6ck97nZrUag7huXp5TvqXgX4TapzstJfLbVroK4OmtYLmBRM0w3EhU+MVcxhrEXB958ouH61m8DpQW+pJWhlAzRv0dwAWXk/iqf6YZeZj7IWQG2lf6Ubhh5LyZCsVbuZcq1U+TXNcPwgxIJ6Ls/96vMLZ81irprfwEn5evE2JPQdpF4IoDJ9MZ0hUru1BQ7vEvBng9k2dLabP0VmfoEH3kJ3H3zp97rBaJ+lwFZskgVNsK+lsOvEMbOUDvZs6XsJt7qk9p1Cc8FhiNRDtRQf2Am1VcsGe3C3I+51u6kIrPDKdExEFFaD1LZtk7/hosAePKajoVwvSL+WYgUVVYvVN3r+Wv6iwR48KmX7j3rnRUpfWVwBHmn1PC8BXOiWk+cc+tV2bbsXrigSXIDP7/USoXPjuwADALDA4fxsaW4fAAAAAElFTkSuQmCC"
            />
            <image
              id="image13_881_19003"
              width="19"
              height="23"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAXCAYAAADpwXTaAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAo5JREFUeNqclEtIVFEYx3/3zuOONjPOjOajtEJFspQmhYhCSiqQiFoULSIIWrQJahOt2rSPFq1btHHTrk0Q1SYwJFpMLnoYGipk5SN8lenM3P7nDpbFOA8/7rkznPud//19/+/cA4XjOE7FdUoMa4P5Do1j+AMdhCqOEnSCzE7tLCbmzzN3WOMIPucETrBN/2sJR/0SK4vMiBzU+KzpKxpJIrEw8bhfvxAIQGrQKoXslBZ/x7J347pXIRvXXIwV3W2lxGqgMlyUzMayquXNGcKRBzihc9iBJmHEvKcZFxYyucygAxevuYXJXHdGJrcqeRcJ480CLM2heQGuwuIPpYVga4PoIkXITCzO93omG28SCYFV6YkWZn9KVM+HZb5fZDUSvH3fLSxmYnzE8rxpa4d4vRZHwSfrVqZFKtrxuVyeU0FxMRMDTyyvvKS2WXS7FlZrUqX+moGXryCtZvrV1TsP3eJiJup3QIPKSe6T6aZcEWYklpZ3/c9K8Gx99N+zSNRB915oFmHINHcbLI/ArLbg2/FcXh46O+8r7t60iMivC33Q2SvBWk0u65LYc5WbyeYVtDdkvnUpt9tbRBUTnU+lr07CZAoeDfzNWydoFzThxnmLrhb5KLKQxEjr+qat8h6GPlFamf9H34Fcd33yMjsPc8Pw+p2EM//QWSWJmeTUKDx9AVOD2sjazNFu2LMfzvaUSWYi2axyRRcQnasTYEndHRuDN6NlihnvTJw+JMFOlaumpL/C9BB8mMCjLovMRNUW6FFplU3mGFF3JZh6/Mes0sXW6JLqbpMO4EiXStY37JPExJdNkK0JXj6pw6BR365OkgaN9kavsxabCdPd+SV9Wh+hVfuvps570W8BBgCEOqblSGsoIQAAAABJRU5ErkJggg=="
            />
            <image
              id="image14_881_19003"
              width="25"
              height="15"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAPCAYAAAARZmTlAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAi1JREFUeNqslE1vElEYhZ9hKN8tA9JSqQXRYrQaE6Mrv2L8BybGxK1x6dKfUX9BN679G6Y7Y1zophJNtKWWYrAUGcoA46EDEiqN0cxN7tyPuXPOec/7zjXwq629cifWzx8Zo6nhO/jxJrKgb+Culg0bPn+D8hZcPAMLqf+IZJpquwObAi1vw7YIGuotrQMBePoEzpY4OZLHz1zCYchf8NZzqfG7Zhs23kO1DpWvcNgUmYC7Nb3sKapDiOr8zh6kskOSeGIdI/CQ9LxFMi3A9BiwXtU6A+/KnhVb6vvaszX2ZI8rgn5Lo4iRKHMBIouQK8EHnbseOyK5heNAKFyTrxb9vpTp4x0p7IUE+An2fgpUQAdfZLBs6H0XqM7QVY8IeB6CcWFIfXoZFrV+cFt75u/Eb+DI15nQPQ72u9SbQUIJcCoeRqehxwD4h8a2F52ZG4Qv4VI8q3lY89NZuLYCRY2mOeF8cFgZN2h3KnSE2jdXsG2vWtzu0IYBz5yikNJYHixVjquIl5bg5mURpLxEn/CfjBL/hr5zVzkr6mu8Pqi9qFQJYOYUZC5xZOX9O1CQ75bUG8YfgNPaiOStlL8W+FVtSb5sNGOyIakukqJsOCf+1dK4yv4CPI3E88cMVxVEhljSIqq8FApKpCorlx9X3D+AHycZWXaFWHyV9KwSaimKkGddS9X18oXhzyUXia6TmPtIJuuwfN716+6c/OPb9iZxM0BtV+bv+nZB/xJgAJa5smLgA18GAAAAAElFTkSuQmCC"
            />
          </defs>
        </svg>
      )

      break

    case "lohongtrungbinh":
      iconElement = (
        <svg
          width="45"
          height="45"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            d="M26.474 49.4323C38.8428 49.4323 48.8698 39.4053 48.8698 27.0365C48.8698 14.6676 38.8428 4.64062 26.474 4.64062C14.1051 4.64062 4.07812 14.6676 4.07812 27.0365C4.07812 39.4053 14.1051 49.4323 26.474 49.4323Z"
            fill="url(#paint0_radial_881_15811)"
          />
          <rect
            x="24.166"
            y="0.5"
            width="8.33333"
            height="17.5"
            fill="url(#pattern0)"
          />
          <rect
            y="13.8359"
            width="17.0833"
            height="11.6667"
            fill="url(#pattern1)"
          />
          <rect
            x="3.33398"
            y="33.4141"
            width="15.4167"
            height="15"
            fill="url(#pattern2)"
          />
          <rect
            x="28.75"
            y="34.25"
            width="14.1667"
            height="16.25"
            fill="url(#pattern3)"
          />
          <rect
            x="34.584"
            y="16.75"
            width="17.5"
            height="10.8333"
            fill="url(#pattern4)"
          />
          <rect
            x="13.334"
            y="2.57812"
            width="12.0833"
            height="17.0833"
            fill="url(#pattern5)"
          />
          <rect y="25.0781" width="17.5" height="8.75" fill="url(#pattern6)" />
          <rect
            x="17.084"
            y="35.4922"
            width="10"
            height="17.5"
            fill="url(#pattern7)"
          />
          <rect
            x="34.584"
            y="27.1641"
            width="17.5"
            height="11.25"
            fill="url(#pattern8)"
          />
          <rect
            x="29.584"
            y="4.66406"
            width="13.75"
            height="16.25"
            fill="url(#pattern9)"
          />
          <rect
            x="25.834"
            y="13"
            width="5.41667"
            height="10.4167"
            fill="url(#pattern10)"
          />
          <rect
            x="13.75"
            y="19.6641"
            width="10"
            height="7.5"
            fill="url(#pattern11)"
          />
          <rect
            x="15.416"
            y="28.8359"
            width="9.58333"
            height="8.75"
            fill="url(#pattern12)"
          />
          <rect
            x="27.5"
            y="30.5"
            width="7.91667"
            height="9.58334"
            fill="url(#pattern13)"
          />
          <rect
            x="30"
            y="22.1641"
            width="10.4167"
            height="6.25"
            fill="url(#pattern14)"
          />
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image0_881_15811"
                transform="scale(0.05 0.0238095)"
              />
            </pattern>
            <pattern
              id="pattern1"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image1_881_15811"
                transform="scale(0.0243902 0.0357143)"
              />
            </pattern>
            <pattern
              id="pattern2"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image2_881_15811"
                transform="scale(0.027027 0.0277778)"
              />
            </pattern>
            <pattern
              id="pattern3"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image3_881_15811"
                transform="scale(0.0294118 0.025641)"
              />
            </pattern>
            <pattern
              id="pattern4"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image4_881_15811"
                transform="scale(0.0238095 0.0384615)"
              />
            </pattern>
            <pattern
              id="pattern5"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image5_881_15811"
                transform="scale(0.0344828 0.0243902)"
              />
            </pattern>
            <pattern
              id="pattern6"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image6_881_15811"
                transform="scale(0.0238095 0.047619)"
              />
            </pattern>
            <pattern
              id="pattern7"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image7_881_15811"
                transform="scale(0.0416667 0.0238095)"
              />
            </pattern>
            <pattern
              id="pattern8"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image8_881_15811"
                transform="scale(0.0238095 0.037037)"
              />
            </pattern>
            <pattern
              id="pattern9"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image9_881_15811"
                transform="scale(0.030303 0.025641)"
              />
            </pattern>
            <pattern
              id="pattern10"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image10_881_15811"
                transform="scale(0.0769231 0.04)"
              />
            </pattern>
            <pattern
              id="pattern11"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image11_881_15811"
                transform="scale(0.0416667 0.0555556)"
              />
            </pattern>
            <pattern
              id="pattern12"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image12_881_15811"
                transform="scale(0.0434783 0.047619)"
              />
            </pattern>
            <pattern
              id="pattern13"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image13_881_15811"
                transform="scale(0.0526316 0.0434783)"
              />
            </pattern>
            <pattern
              id="pattern14"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image14_881_15811"
                transform="scale(0.04 0.0666667)"
              />
            </pattern>
            <radialGradient
              id="paint0_radial_881_15811"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(26.473 27.0364) rotate(158.093) scale(22.3956 22.3956)"
            >
              <stop stop-color="#FBA421" />
              <stop offset="0.3601" stop-color="#FBA421" />
              <stop offset="0.5179" stop-color="#FBA421" />
              <stop offset="0.6362" stop-color="#FBA421" />
              <stop offset="0.7349" stop-color="#000E28" />
              <stop offset="0.8203" stop-color="#00173F" />
              <stop offset="0.885" stop-color="#001F56" />
              <stop offset="1" stop-color="#005FCF" />
            </radialGradient>
            <image
              id="image0_881_15811"
              width="20"
              height="42"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAqCAYAAACz+XvQAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABAdJREFUeNqkV7uOHEUUPTXd09PLjtn1Y+2VvcgYrQPAEpJFZiISUiJCfoCUHBEQIMFPkCCR8APOIEcWQhi0AViL2Md4dnYe3T39Kk7VrZ6Ht2dnZimppvpVp++55z56gHXHNz9ofPWdXnRbrQySpMDzv4GdTSDtc6cHDArgrTeBLz5VqwMaMDOOu8DTn4DXeRz/CwS3gb2HBLwP3ODFzz9RywErsGEM/Pwr8Nsz4PwXoIyA6+8Ab7wH3NoBPnwszxPUXwpmxgEtOj4DXh4A2QjQfMHpCRD9QUvpAs1HldjWWFmM/uDitbIE7u/OGbEcMKfjDw65mSsqo0NZbuyJZWrqueWAo7Gz8GT++oLAWQ44iOYRtHtBo3lFQEPZTAuWumAjWHhHjh/srgl4TlVHVLWIRU1rqZK14V3BwsNTWphzPxUteg5oS+61gvlnGYeNlej2uwL46ghI3ffWsDAaC6ABy87dRQcQMt3u3uIarEnZilEKVSs0rWqSsiHX4PQaE7rLAf86lnU8qnzgVHbBbIrCSqLM5nGUyFr0nSDXROWwfcU4NDk87pjEdVMJXTNub18B0BQA40Mbg6VQ9ZjLrRZ3qzn/LQc8Yrj0jp0o5XxNNkG90VrTwipkUGUIQyRkhdm6C1xjHdwI1gCsgtpQtZQL5z839+/V1vuLgF9/P1X46ESo5kdcWRj8HRHExqC6kCVm+LVBnHMOGS4JZ9qp1JkRR0t+K7UCYEFqKYH+fOEKQjxfVU0JM/RNluTZCoDjGYCzf2ZKlgM0dM2LdjdrXT8P+NmXGi/pr9eYBec9d7d8xUKet5oSn9FwCeDIdbZSC6BpmaoKG1/WcIP3WYXioY0itMLLKDtq3a4A6nKmDiqx1qprfE3QMVUusksAhwPZF9PxZ2zuOneUUylbJuVSWt1mPykoXD+5hPIHH2kcvZBQyH2hpDOZE/8VErlpJO5JKOD2zQWAutrE2T2Vxp71nJWQry1znNNCn/c6ZOBxu99cANhzAZyZlFOy2ZapYiavvGk7TT1xxdMfVT2gCVJDwSjcJ6UkEit11ZO1szaT2aOl3qI2eudehmgksWVAilw2T0RRrhW7a0k0zapaUdJkSDEooUoI2kaZCr0yJUwhHV01lU0301diChKrSzIlyzqcrksGMVJ2JY1txuDUJeU4gPZSNIO2ZZBlDQZ5WQ+oy+e0zictn9b6PA8ZsIfTglfuWYFshhQdeO0tnjcx6NV8tKvGE/6+PymehmphC+ojCaWZTPGYa01/39XB65ybGPYf1v0LeJvzd84n7pxf5DiZfBTBvnCbsdizMgbBI1sPg2AHo+HH6/ytYImGacSmarzrlDL5tk9fhgRt0z3f4n+Oqm3s1t38T4ABAITeyz5Tk9DnAAAAAElFTkSuQmCC"
            />
            <image
              id="image1_881_15811"
              width="41"
              height="28"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAcCAYAAAD815boAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABTdJREFUeNrMl7tvHFUUxs/szOx6/SROYhvsGEIMQUIoINJR0VAiKhp6+AOgoEGIgo4uiCL/AIgGBUEJpokEgaAgbBTHduI4fmTttb3e1+xjHvzunFnLiReTx9rOla7uzOydO9/9zne+c9eS+9sX30bSrn30riVH1Kx7wNUaIhEY066InZInBay1A3B1XWR6XmSlINLdLfLOGyKVmkhPl4hjHylYZ+dqYZY+JbIJk54nsromks2KnH9JpB/QI4OAz9wri0MCasUfMwCv/CSyHYrcuEKoTxDy44yA7DvJVtIiE+Mi5ya4RgZDT/GmdWisKpNuj8gWYV5eRJMA9VfoMGkPidQZMwCdaYrM8/sIz14YEznWJzJ6XKXQSrYDAqsg1ysA5YPRNk/4TlDmus4IqABNBnXtNuFuNlQKg8dExgD82hkFarR7QGA13LlNkas3RP78XbPbW2IMYDOvYAV2BRAWPQWDbr/IwLMa8j7AvoIMRpHIMDLoSndcBsrkMElxalikeg5dlmAWLTbJbA+G/EICFNAR1wHPhdDniwDincoGnXd6B2D1rMhpnrks259VZoNAJfTxe9bjMdlqP/4GI+hvDia3CXnOhJvwVrkPYDsCXOQz0XQ2YJ/UMfs0KzH2wqaDJJ7h/q3zvMO8rKvv+PQCkalVRS5+bj2aT7aaHyhLuS2R2QTsFot7sNiEseZ2IgPmiWeyDgnAogV7GVhMAXLwOWV+hPtxtH6KLmw2BGiNd+oAzd9l86z98yXr4SrO7hYSolmy3FShJYw+R1hXb/Nt2KzxgZAx2EjA1lU5xrrMkt1jGuIe9OoCOsNGhtnIKHruYl4DkFWS1Ut6GQJKbP7mdWt/M7+/pfDDs3wsCFVjJpNz9CUye8VWVjxHQxluqxSCu5pkJaRhk0Qh+k0Zppm/uSxyG6vrIbGG0KsTqu4bteR7zBk/E0m5WJRmfV1KxYm9TP7fAcPIYAXmChXVbMVTX/Vh2jPMwmYzlzhBS7dpdQOjV5cxxaYcw7itjPba8RTx68poox7QK/R18ZuT9Cm0fGF/PfwX4CLhWgDQHOyUWHxxVq2rghzCTU2mKHGBGLSjzJprU8UkUrDGwtKtnjJaLQGqBMhl/PgvEu9r7n95OFtop9tbgJ1Z1ERbnFEtNrkOYDosqhyisgIzYA2rFvQ5vcq+kZVJsm7Xh7kyGr+O7v9h7Q1AXsLCLj+ad7VjuOQpu5PYWBlZNCoKos6zsJRYV5Swm0qUZgBz7WbNpoqm9olrE+qGAfmDhMF37TX5uIALAJpHBnOwu3wHCeQ1QXwwBBVNpp0qtpOlUGlV0Oo6wH6FzWtM4twoHQK5G2wYqATqsLpByG8C8hZg13CE8po6gI+eQ09ZjoEaCxPQCxZhkZFiBH7NrLizhY6BNHU62qVVk72nsaxXnxd5ESsbwti7CKvt6kEllVZ9ioMObNBboI840EbsTObbm3kn26cXo7ieV5NeIXGKBWV3YQG9esZukEHVnAWM0TLB+huAMwnQC7v1kDoQkJ+9z5ngQys26JjZQJMmAydDnKBODGgZMb87mTL+2aqz7CCa3lNXDvTc/+UnVlyrm0ndjmMHWJs+QPXJEmpzFrWsPFk+R1zLyYEgfLCy2Kn2zVcqqTffjuITkCROZP6NZtJlTXlH8yeI/uC3yw9euzvdJr9XsC+/HsX12pRAc5QLwzuwO0W0p1QWbY4Rh/5Pf/qqRRUJARdRSr34mZFDEGA9e1k8GpCmLS/YsrbiwlyeUmj8MS9PfHPTH+z3878CDABe3IgtXQZ+BAAAAABJRU5ErkJggg=="
            />
            <image
              id="image2_881_15811"
              width="37"
              height="36"
              xlinkHref="data:image/png;base64,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"
            />
            <image
              id="image3_881_15811"
              width="34"
              height="39"
              xlinkHref="data:image/png;base64,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"
            />
            <image
              id="image4_881_15811"
              width="42"
              height="26"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAaCAYAAADBuc72AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABOVJREFUeNrMmMtvG1UUxr95eDx+ZeK4edZKaRsCagtUKFlViAVS/4QKCSGxZMmiiy75A0DiD+iCNWKPxA6hbhCIDVAJIrUpaZuH48SJ40c8D74z5yZOKyclapPU0vWduRnP/c33nXPunVg4689X3yUDx2/fsg6eWq8V3BGw1msDGUbAH4uAQ6RyUVshtw9rnSmgwK1uAmsN4OEy0AuBxjbH2c/PApUh4ML5FNY9dUCBa3UJSLh/V4F19o0msLMDNNeA3S2q2gF+fQLcvAmsPDlh658H3GpRtRXgwVPAdXhOsLU6sE3YmPBdKhr3+CAcS9hXysClt4Fbn6c/d0/c3j3APWsFrrZEGMJ1OJaEChZtmWOqDY8Ks/fGgJ9/Aj748CVBv7ybwGfA2zab0x+PYuARbVwkSJ0AyzUCr9NWQofb2hJeE9bkYgPHc/jaHKqZq1LlPFCaAtrdY4J++kUCh0D5kjaxTD6Jib32LrBUU3uXCbb6mNdQpXZN1Ypod2yaKIqeqifNGVGD/XE+dAYoMokuX+R5ltDZF4Bem0uQpWI+nyzgjULeWEBd3ijixCHBNqnY0gaTgv0jWlxj6zRN3PEYVDuqK1jMJMEB9Zwp/bs/yY4oASEd9oUC8P5bjNEJYKgwIOuD8u/IeG+wFdlcJJQqk+lX3FZTDzaZqR1O1uCkfz7kEOG7bcbVhqoWtUzM9bSlyoWqmE1bLT64yzqZKelvy1UVYP4KxeV8FwkYFJ5BU1DXvUGVPkMUbcJN+nbK5PIp8IYN1juHNqwQYIOA7TCNHbQFin1MdUM5XlWVUuUiY2sF+tAjaqtA+qyRObbhAHj3shb4UR7n/YGrk7sPleA+v2cQxzXsdsWK4TTuEtrV4QU76zppVyztqhJhV+EkGSTu0ht1zAx8KGfUxN2oggZV7YvDwJvTwHUChnSmUtKSdcQSqqBReI+OzrH9whtVabuoFaOxY8PzFUISxfE0TmUyqXlx21gbGWt5X2dcb5ubMlCj+juX7RyVrbLkXJ1WsCGGgGXh/2xKDsSoVaeC1yhKHbGVgRUX0e3Z2I2M4vzqNVU1SYykZQJXbOak9pCJPfbj75nr2PKMtXdmgImyWb/9F6o36NMHDXs1OJkF9GKHECOMxybjbojNVpjYlBRTksBYcwIddwjgnaN6VCuiwpMTCnqJqlY5HvABfO9YYIeDAj8wmWZhkSaJmwg7nCE+kFmW6amGxUltKpOtaOHOUq0CIXMEmqeaZcbctFhuP2vtMeEOAxV1HpOFqWkxxaMNMzi8b7FUM1HPZqJkCeNX9AFGqWCV6l1lcgQltVtWq5eEOwIUXFISRnosFaCqltsxwewUUlqurHA5wozR+iuMP0m4MSpY4pjvq8q3P36lG57nQe9xllkTgA3aRunsItysncJ5tDbHnwxT5CmuJoHUPU/h4lgB73xyIjuyQUvo34Q6z00GpbIC1tOnyLuTLC9uaqlAlgjoOX17BfKbOye6CR8E+huVZObHF5DNiq3XkXHTjQHyWQ3XPSSpt99+fSpvCYNAO4SMuKxK1j6Aa1e5DhdNCdNNgyT/j9+f6vvWYbsnidU57oA+YsmSXVIHHjcqPYIu/HUmb672IeMzsC2JvR0ur6uEDdFpbWHxn7N5vT5C0QUup/dhJy7ssInm1o2z/j/FfwIMAB354T7Q7s71AAAAAElFTkSuQmCC"
            />
            <image
              id="image5_881_15811"
              width="29"
              height="41"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAApCAYAAADJeCK0AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABThJREFUeNq8V0tvG1UU/mY8duI475CmcUIalAZBqaqKwhIk9kjsECvEP2BBhcSq24rHH0BiwQ5YsQIJCVUguisB1FBR4rZEeZCHPXH8GI89j8t35o47efHwQxxpPJ5778w33znnO/eMgaP24RcKm4+A0ASKDpAdAp69oOeuv26gT2YcA1z7HbBC4NbXQP55YOsAuHYZuHoxuaMP4Gb0+8HnCnsEKBWBb74EWk3g+6+AzXWu4BI/OO6NHs16/JC1TeDBH0DZBqp7gJrkIKe+W6G7eb661C/vxkzFWj6wXwcOXcDl4ZF1gy9i87jzG8frfWObgE6MEYRuxSAjPSBvQbfu6blGA3i0c9zNfQEVe+YKMPQkkJ6JgWnOEbbbpb6wTUAvUxrz08DYLMnOtH3OeJaBZlGztat0fauPTK0UdUl2s+fIMp2wVQQJBHBDs602+uzep+eBqVFgPA9knogHGeeQDFtlzXaLrD2/R9CjYs9mgEmCTlMuKSaUJWx5Vsxmv5awdZo9xdU8NfLUeWB0mHEleHqcK4Y1W0XJeGR8sA/89KAnN5unStso6+0cE2qKsbUIaOY027BC0EO9pkDGYdg1W/PMmmry7wSZDuRi4CwHA+3m6hYLBavW6nrXujXPHL20ACzNMbaz2sXGCAdTsXxirf5KF2/bXbE9Dtpmm+Lw3BQ1S7A0XZvKajfD00eFbOuM747dFdvTTNvAIp1lSmhs+sgk2QYHyeUvBSZWrWO25j/OLlIy56nXIWa0RXAjq6uU+yfjSrYOM3qDulWqDzFts5VMvihsZ06wtZPLlfu8jjP5/c9U70zFlphMeYIO8pwSV2e0bhvb3HspHYexXSnoahUGPbq3zTbHRHpukRKaPX5bIOWQ2exSvz+zSu3INV1/42PVO9M223keWdZkczxhK8WizgrlVHQmlw90fK9/pLoHbbOVHUhsaCQujcxspHVsDemhyHDlLrAuhYM6rlf6wFTslSu6Qg1Sv2YmvpVgzkPqdlOzFVDpsTx64a13VPegUmN9FoRBsp2jfIJm1K/ByOgONqROFedDvkD5UK93OFbjS7z2puoO9N03jChO0pa+uAwsLMZsc3FLw721JeyYvUVm9D0mlb2vQauHPbi35carKYkxadyEQJjMB8xih0A+120Q2Lb1PU0eL7ysTve9/8UarDzNhj5yvCXLncdNabZBoOuxV9I7kRwlznl1ncleq0umN9824MctyiQBF6Q0TsQbwYCuUip+eJNuPaB0avWkWFxYVp0zjVpRJkdARk1WIMFJm1HyJu9NgFZJtzmODPMlm+k46fgzk69id3ukM8l8ctOItjORRpoPGZZOMdQ6NVLxt5in1ypfx1zc67dCbgw+vxr8znXaZivm1jQTaeQsHoaVfABKuyoSO6R+yuUyGhRyGDC7VBHDo7c6c69YjRKQ2ArjNEFSJ7I4ohgIsAvFSU85PMvEQ77IDjVcg2W92vm35rWXFFxHZ3SFjCv870tv3PR1nyqPNOpIpdfo/kLUhUD9CMmEILhP1lWrY1BhKWXOowsNAmQMn2R3mTA5KJOZFG5E2RO0dqJ5z1/l9V2kLIkxKwdKnYO69bjUVQkWijvpSr9BVrt8KrPMKOiUVasEucM/t3Ws/TM+/zuxc3mXom8wM4tkV+UGXqPbviU42wxjjYC345XiVre7inTSoqQISiRUQavBmhfa1GKZL3CP/7cfs/vbz/9urOny4agSvEK3fcoEYXmC/W9gvblXbGDwPcqnQFC2hvgB/4uZ5qVub/1LgAEABJNp5W/GguAAAAAASUVORK5CYII="
            />
            <image
              id="image6_881_15811"
              width="42"
              height="21"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAVCAYAAAAw73wjAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABDlJREFUeNrMlsty1EYUhk9LGmk0MwzYGEwIVMxtxQYegAfgBXgJNix4AnapynNkkazzCKzYUFBkkVQwmAJsg8cz4xmNLq1u/tOnxQyOuQVMUFWrJfXlfP2f06cV0vd4Je1bZOoET1somj9F3wXY2fOGyqKmYjYlrR9RVT6hMFonXS2j9cX/C3rtuqXRgKiGYOCjMlfUiqGfTkkpdLBruN1run870Jt3LBUZ0XCHKJsQ7Q2JYnh3pqU9jALSucXTEbI2w7ui2gzJmkMG/flXC4MEdxLtvmbFGiBy3w0AqoKceoynQkVVHQIOL8Gy62/NVbzc/bqgv/xm33lnEFvLc416BmBdQdE9ohEUzfGcYcgQyuYTga+wgaqqIkXHQc5s6cddv9/wp15skFXZGUPJEdFgl2gCkM2XgIXrNcoUMTnblf7FiFcFLowrswATdN0iyRzFbelg0M+Fy0sY0lKXqLdgPICtAO689whtcF8FJQ3Uy6FcFCI2N1liUbtm92JcnZH435VEVkunQP9Avi2CfghSY9JpLmOGUGcIRUYo27u8S2E8kw3C8eZ2LMoYCmqMMaV8qxi0jXrsQTk0Cilzd/AL58/As512mwsWoncgG7cxFMv/dBs1vm0hjbyCoWkmYNav3o3CbbAucCrwNUr2zPeZzKFK5YGqA9TgsRYriXgQAO22V3hFQBkyA9hfz0UtBuJg5+B3G8II2HhzDsjFKWMk5vZf9SsOvvcdOygtmUO1/OL8gsmEvE6q2QtBz81vGZrWIwd294Eot/4YgT8SOPKA/FxsL0zmSz1oAtXXyqvSeK296FKfmpYEjNUN0W5QB+irjMQxl0BpCpGqat1FQwoPH5EYHcLgGUzwx++S84x3qdmZpxf3oVhw0aI6PoOwAMqDqoSaRE2tnqjfXpGNE+H0CRkMz6GVXBorHxpYdGB6pMupM1PrJbdonF6RU6SEYqsdoo2NBVc28Rb7Zyww7HrllMA4lTp844QtJerOQ6R7lFMO6ouYFyB9tLU40cO1Hd5QlaQsDkvOpVUs7wGMVTj7rXoJx2acUyM6fRYdwfsQx2qMietYlAyPieEGjBZ2dLIqkHEqfTgldfoC2ANMvydDVvFP0cF8bbSPAbKciJIFMsZ0JB7ko5RPrnbb2+XcBh5dYkK6jHl41S8iSjFxBFXSn9AJ6nYQuyUmSX/4N2D/BNRB34SNJ9Ls2lFd+BGJBOAnscCkJTmzOZXYpRW8OMWpNANwCdv8A5LP5scqn1ocOnES+vO/L3Yl9NTb9HT/b6Qj/P5tYHd3UoFjZfha7othLl204f/BpbE1KNtJ5lAHXaaW7MF51pU9KXsQYzKWzZtnvgD8nz/VQdNIHuXEfeUS/gtheHAOE/mNswoVUoDEAGlFAh8GHz6tbt9Qh/GPo774bD8ksPeDfirsNwL7vN+2/6ryIVxvBBgA+ygQnJvB0CkAAAAASUVORK5CYII="
            />
            <image
              id="image7_881_15811"
              width="24"
              height="42"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAqCAYAAACpxZteAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABN1JREFUeNq0V01z21QUvU96kmXHn4nrJI1J02lJNx0WbPkTrNjwC1ix6QwMG/4Aw5b/wI4/ABvYwQyLsoEydVu3JMEO8adkW9LjXL3nkYtTW0oHzbzY1ij33Hvuuec9Ef3Pl9j6RMH7lJTysH6kOCaKQhd3f8CqYg23/bvcCuA4DylWFVLxfYA8pijCTTVHbgf4PMOPn7Dwnc5uVkG5+of51k3+TiYjUtE5kYUf8WMTogewjnmOgf7E4krnMgNAE1lLmgU1itSALNmlWKAitcyxgj8jEvYVCdVN7qv45+wVHN9T5E9jkjKi6WxCU58onHEQZB3iAZsp65LtgE77CcWgUCLvOB7TYt7ZXMGD91TSWOYjVhY5qk5iEZIKkFhYxv0xcrRJiCZWj5xCmywRQAg9sgCM1DYDSEd/ugWEmhIFAatIrhQOQAvVeXEil4LnIpU5KbeNqns087/YDFBvckC0CoEnC5RtJcUk8ZXQ38m2yHZRnawnonSli6pFUvl4mEGmNh7xdoj8K8SDMASCqoVpH2iQRXCP1QBjwIEYJFn4fHXR2D4HJQQOESxANgp0RaA85sYqnb0F6gTuFwCwAwCB51zvtRDWRoDbd4luHSFR/NNCabrS0hBQJj2mMpRaAoCN7zuVjACffKkSFoqoYhwazldUzYE5++IuUQ1s1LEqWA6q+u0Xsd0qSsjEcXlysSLNtQTY/DwFcGq6uibEUCnq+zwHmSrgkr0S0QA98LGm8LXZ3yY4goqSbrqNjHf3QBPA9ttE338nspmdEBogtLQ8mW/FQ8cZFvRvF0mc3IGCGvr52TSHm3IFvq9laplmUqz7wMFtUOJB+gf77FdaWUkCeeya5f7ikpKhYROLAzNoAHdAiw2K7h0jGU8DfP3ZmrdZG20ixj/1MWDDC8wCN3duzA1xXNB3BAk3UAUPFnvPNdf1AF99q734RR9VQKJe9T/GawBOwb/rajpZcbl2tDBKqQlGK/mYeZgMiO4e6uZy9p9/LPIBTOD5T16axvFeDPsncC1byBhyfPg+Pgt6ejdcb+7BDB0eIvN/nkFNL/mGNrrlgjOTNMEffSSyAzD/ETJ+Bf5HA2NscUoPB2+AmvatTMeW6ytg3sc+mf0V9AyMPAFQgO6raGq19BYAE+j9+bkOPuuZ6eU991CbWRnB9xtb6VkHWMpziJHvY8AmfBoJ9MRZXsp/cl6yb1jBAtn2jSzDcbq5CLNF1sH9/Xba4MwAy+yZ9x6mdzow9gC7FqDFgn27oKXVzHU2Xa/Ahxw7f2G4YM8LPnoG6fR6ZT1nJ/s5AZbZ83VxpV002TxGOrANq3DhOcWqpoYHLEOD1ytga5iYjGd902BjDRLZl6CeB8eZ+V8H8OGWXexaQ6zIADH/wpwU6pVcwdcB2ODO+vrsmVxBeoKt38YEA+BOKyfAKv9JFUv+LzW+3NPTy/TsVd+ygqfmHcKHipQ5A/H2yJt7DT1o1XO/QllrSrjsGmsw/CcGt9ynvRsArBoc69+6xp5qh3p6q8X0XgaJvg7AViDx8/QUPoPpLTp6p+LN5eggfebGb5nc7F/xOhZCOR28AfXP9cmh+q4+AHz4Qe7s11+hHn2jaA6Ds0HX099hDaCmBVm+00qzzxH8ze9oXE0H1Zwg+0v40W71RsH5+leAAQCy5pcUK2ycXgAAAABJRU5ErkJggg=="
            />
            <image
              id="image8_881_15811"
              width="42"
              height="27"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAbCAYAAAAK5R1TAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABPhJREFUeNrMls1vG1UUxc+bGXvGdmLHsXHixClJG9KmCVnQQGkBCQSlYodUAWKDkOiaLgCxYMkGJDZI7FkgNvwJ/BMsECsqWlBLExqcxElqx54Pzp07SZwSt6Xky9LTvPHMvPd755177wN6/Wz7Io7Rz/T4/wWCzsNJzSKVnsR645WjBrV6P7FNDJlKT6My0sHouH/cQIfhOPMwZkY1Nx4sy1BhGzPnIsydj44L6BTCyEOEHKKoRlABi7CFl0rTGJcjXH4rOmrQgDK2EKLKiKKHrT7YKQdeRp+GwY69r1yN8P5H0VEEUxHGeg/GnkUYPkfALKzUONyMg75+oFwC8gUg7QJZ3ldGADcLeEn78po5LEXPcrsdhD5Joiz7VTYLPkXbaAELK8DtOrApynYz8bnrAZ9/G+GL7w9EYWcPhRnd1ljcjUIXQduiujQEt3yzA6ytA032+waAdoojcIizU7tH+eoHhf34bXMQW59ju8r2EtspNu6teVIXY7NL8Q3BbL5mZ7Vv+KjMNRVpidP8ZGIUGKQ17PvWvw/AZleSB+bpyTcZMBPsc/ZIIsjeeVVg7Ti+YKU1sLxhXUtxTBdTo2+nuL5p3jv2v2d8TGizbQFjvcrZn2Gif52Wq9Gb41SNfm2LITUZbNs6aaKoVUjuOVRmVPslQo5yAZO85xB4amRv6P8Abroq0TU46Vkm95d5M0wuLwYNEsBo69pJ+n7yeVptIKpa/TtDZk9ozh3l5vTnFNrj/fgQP3EeTLUHvEkOIFfoq3NMOxd4V0PKLaM/P4CVpooZRzgV8X0JMN53kk8lyBoJdHoniRj27UG1glcVEagyQYfKDEK6qUpXuVzcpKRq+5GATdxs58P4EJJ2J9nOIJ3uQ9pz4omsjALcI9QmgzmUVJRn9P9FaAL6Tb0KbLi6Yw+T0eHtkvpaWv+4lGTNv0WO4bmqdIUZpJB9IKwTJ8E4TiwmSpR5RQwp2+Z1JXPZ3oAvrhO4zlcLNbJR2c1mUs+YXNs5hQuWOOqGAvtBkjEIukq/WxynfQ+4w6nzFQrQUnXHKmqNU9XdfpZUR1g1i+9/HW8rmlJ1luO6vlUqBdKlOlJC5ZohTIcwa3y/zvfrnLTFyTpsHs8x9d8JScWat7QQBH8nvk6pZQTY50JsycPcgZU/6WfaZJGFpMBsssI87RJ4gl4u5B56Hu1KWjyACGCOgVKqiNrapBJZXKfPIRao3m+ccJXXexvq4/pNBQy5oPaSQofLSfZIKbDNjGE8VVnSnEPAPlolm1Xo08weT088Iuj9vw8+jZDhIIMVrUoCHZuIk61S3esEvn4baKzRJg2FFj/LDrUW1MvBcpLy/MTPUuFKmu6kmLglHfNF1p6Ls3GK+/8lTmq7QG6XfSrXJkAjgb55B1jitga+tvW7aoHWIq+yEDk4tBJgBpfFhYfcFY9qnnkeeI2wQ0Xs/2lnq87H3g/0MCPXn2mFW1R2mQcbn0HVWEyA+R86icqB9gVafDv3LHD+EgOthgM7lu0C7oYWtX/6FfiDoE0GY4MK+5uaNTbvarYQRcv07MmTwBvv0rf5AwTtBb1ljRZVvUHPNgn4yw2FXqZVipIxmCkGiTZDf1afAL75zBwOaC+Vu5UW6GmW3e9+VC8P0K8X5oATI3HSP1zQXrDd0FIApOjIGSPPPPrJO+bx0tNhAO/jOXb/oR8C/o8AAwBbEJinc66yIQAAAABJRU5ErkJggg=="
            />
            <image
              id="image9_881_15811"
              width="33"
              height="39"
              xlinkHref="data:image/png;base64,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"
            />
            <image
              id="image10_881_15811"
              width="13"
              height="25"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAZCAYAAADqrKTxAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAhdJREFUeNqUlD9P20AYxh/bcdMEI0iB0lKWDpEYGZD6ATqw0JW5qtRvwIfI0IUPwdK5UpnaiQGpAwsSqapCaNIWQnDcGtuJ/xzP+USahJyinvLqfL773fu8fxwDuvHuvUD9HHCbQOIDay+A2ltDbplaQI6oDzTrwO8W58vB+4IWOPoOfPgIeF8A+wnQeQSsV6H3NDxED8hS4M3W4FI99I2xBD/Uc2kVOD4bbOkhzx9dF20172wbkyGZALdNWREXD/grASsLUzy1PUqjpTSTgEPAKWmgu8y5lBZ3mYQEMBxmj9IsM5em9ySTIJgxxJRWARYqI9uToV+MJwn4QA8y7JXFKVBCD9c/GU+HkhhL5TlQfTYFOmFtsozyMrVt0uZnBvGMQrU9gSRWPRax1yBj4rnXr6jS0ngKfGUnbNCMMNg+pWVg/5B8MgL9a1jvOr8YqSyolGYpiY6lLrsHbW4LfD3iAWbJa6okSBHlMrDIjmidToB8T626geqCvLu41fvDUtFLOjsB6oVAeMP24Zyy7wTNpBeDyQhcvm+MQY+fxnCveIAB9X0F5DHRbEIe9+ziGBTc+DTqd5x8zju7UFAgMygvDIMxSGQHjGEG/l+Z2grXrGQyy3cPkYQCPpy8wEPD4qEGovATMhEg7cmqfqbGLgyrC1N00I8Eri6WhiFjrInmZMVoL+WnCJvpjvsbfN7Ff457/1i3AgwAXRfaoSCdNYwAAAAASUVORK5CYII="
            />
            <image
              id="image11_881_15811"
              width="24"
              height="18"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAASCAYAAABB7B6eAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAl9JREFUeNqslN1vS3EYxz+npy9e9s4MY1mYG1cjxAWJO3+CiP/BnYi/QVwQi5vd2AURbojYFq4kQ8yGpZPKzFKjjW2lW9eu2p72+B5na9cyaadP8uS8P9/f9+V3DNbX1Xt28fziWYM6lFE2PDgDXR3QvJ16AXmKwx/ehqGn7t37z2Ap9SerTTFwBiSSMNAH8z8hHYbGXmjthD274MyxEqNNsPG6PEzI7oD8tCC14OUXkGyCub0wo3snjsORgyU2NQAZxY8mpP/YB4h+EosvkJsDOy3wNgiITUs3nBTQ0R7we6tmZJTpbOVhXCuemIJIUEACLeScB2C2wpb90Cag0wLqPQCJuNvXLhvVAaxVRkNfic3LUck1K/miApJPSEpzJ+w7JTkz0CNmhyRtbgV+LKjnYWTY2DimlZXWkCGBhCbliYByUQdd7Vtl1A5bG2B3C7T7tRCFZDEm7yIWsW++coCNNpxTSX34ZAyC42KkxnZlcz43mxUVgfg1r0VtZLWwlEV6JUwq2fdvkyqBEpLi1iOIf4UVMcp/182sG0YjoEDo2KFQLMWmyVuPyWQGq4vbeiBL/rxWAN5JtvCoG2tLRpNffcG0MM0RefRAF9dr2zhX7toUNGhBXsS1+tBH9XtISXdLIbAdf2zFkOfqfufoqQng0jnjdyyzGTe+7drhh7ukfaM82OZ4ImM80o+36tmNTa6mzl+w+TzlpiaZ0G/GAV6epmDdxM6H9MZw6We3mbpzw8DKuueObGZ2kYDvDaansDa8ftXZbdHQFMEf6P/77/p/KxL2KpaDFAqTlY9+CTAABqT6E5yN0LkAAAAASUVORK5CYII="
            />
            <image
              id="image12_881_15811"
              width="23"
              height="21"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAVCAYAAACt4nWrAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAApZJREFUeNq0lM1LVFEYxn9n5jrfY4lhaZHZokQKUQsqJKhF9rEIClq4aeG/UOCudVC0bxUtKgoiWlQuSihyo5CU9kX2/YGmo6PONKN35vbcbjakWDpTBw537p1zfvd5n+e9B/7j8Je0Oxq/Cc5e8vky3T37d/Ca2lkMa8GEyOXe4OSH9XSidHjjDodgyIfjBEmlwti5Uf2u0T/vNSeLhx9qd8FCJCA5DemZDLnsOsgHVMWAVnwoDt7R6RCOwKePmmMw/hXsjN5kZ4Uqx5haZXBt+fBT5x15DGPj0PsUpnS1Nclp+qL4VY7xTYjYqoATbgW+JYFPX3J+XHuew91eyGRgZsSFSl4cAivBikSIRbYTUmWBYNvSlJ+56uAT5EaPtHyW8kGB3dzyAlZCuAJWCR6X5cFQANveKHuCzGRfWX8FJ6bg+gMFl4KRR3JBXhupLRM0vho2V+l+VtWkIaW1k+rG6ck97nZrUag7huXp5TvqXgX4TapzstJfLbVroK4OmtYLmBRM0w3EhU+MVcxhrEXB958ouH61m8DpQW+pJWhlAzRv0dwAWXk/iqf6YZeZj7IWQG2lf6Ubhh5LyZCsVbuZcq1U+TXNcPwgxIJ6Ls/96vMLZ81irprfwEn5evE2JPQdpF4IoDJ9MZ0hUru1BQ7vEvBng9k2dLabP0VmfoEH3kJ3H3zp97rBaJ+lwFZskgVNsK+lsOvEMbOUDvZs6XsJt7qk9p1Cc8FhiNRDtRQf2Am1VcsGe3C3I+51u6kIrPDKdExEFFaD1LZtk7/hosAePKajoVwvSL+WYgUVVYvVN3r+Wv6iwR48KmX7j3rnRUpfWVwBHmn1PC8BXOiWk+cc+tV2bbsXrigSXIDP7/USoXPjuwADALDA4fxsaW4fAAAAAElFTkSuQmCC"
            />
            <image
              id="image13_881_15811"
              width="19"
              height="23"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAXCAYAAADpwXTaAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAo5JREFUeNqclEtIVFEYx3/3zuOONjPOjOajtEJFspQmhYhCSiqQiFoULSIIWrQJahOt2rSPFq1btHHTrk0Q1SYwJFpMLnoYGipk5SN8lenM3P7nDpbFOA8/7rkznPud//19/+/cA4XjOE7FdUoMa4P5Do1j+AMdhCqOEnSCzE7tLCbmzzN3WOMIPucETrBN/2sJR/0SK4vMiBzU+KzpKxpJIrEw8bhfvxAIQGrQKoXslBZ/x7J347pXIRvXXIwV3W2lxGqgMlyUzMayquXNGcKRBzihc9iBJmHEvKcZFxYyucygAxevuYXJXHdGJrcqeRcJ480CLM2heQGuwuIPpYVga4PoIkXITCzO93omG28SCYFV6YkWZn9KVM+HZb5fZDUSvH3fLSxmYnzE8rxpa4d4vRZHwSfrVqZFKtrxuVyeU0FxMRMDTyyvvKS2WXS7FlZrUqX+moGXryCtZvrV1TsP3eJiJup3QIPKSe6T6aZcEWYklpZ3/c9K8Gx99N+zSNRB915oFmHINHcbLI/ArLbg2/FcXh46O+8r7t60iMivC33Q2SvBWk0u65LYc5WbyeYVtDdkvnUpt9tbRBUTnU+lr07CZAoeDfzNWydoFzThxnmLrhb5KLKQxEjr+qat8h6GPlFamf9H34Fcd33yMjsPc8Pw+p2EM//QWSWJmeTUKDx9AVOD2sjazNFu2LMfzvaUSWYi2axyRRcQnasTYEndHRuDN6NlihnvTJw+JMFOlaumpL/C9BB8mMCjLovMRNUW6FFplU3mGFF3JZh6/Mes0sXW6JLqbpMO4EiXStY37JPExJdNkK0JXj6pw6BR365OkgaN9kavsxabCdPd+SV9Wh+hVfuvps570W8BBgCEOqblSGsoIQAAAABJRU5ErkJggg=="
            />
            <image
              id="image14_881_15811"
              width="25"
              height="15"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAPCAYAAAARZmTlAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAi1JREFUeNqslE1vElEYhZ9hKN8tA9JSqQXRYrQaE6Mrv2L8BybGxK1x6dKfUX9BN679G6Y7Y1zophJNtKWWYrAUGcoA46EDEiqN0cxN7tyPuXPOec/7zjXwq629cifWzx8Zo6nhO/jxJrKgb+Culg0bPn+D8hZcPAMLqf+IZJpquwObAi1vw7YIGuotrQMBePoEzpY4OZLHz1zCYchf8NZzqfG7Zhs23kO1DpWvcNgUmYC7Nb3sKapDiOr8zh6kskOSeGIdI/CQ9LxFMi3A9BiwXtU6A+/KnhVb6vvaszX2ZI8rgn5Lo4iRKHMBIouQK8EHnbseOyK5heNAKFyTrxb9vpTp4x0p7IUE+An2fgpUQAdfZLBs6H0XqM7QVY8IeB6CcWFIfXoZFrV+cFt75u/Eb+DI15nQPQ72u9SbQUIJcCoeRqehxwD4h8a2F52ZG4Qv4VI8q3lY89NZuLYCRY2mOeF8cFgZN2h3KnSE2jdXsG2vWtzu0IYBz5yikNJYHixVjquIl5bg5mURpLxEn/CfjBL/hr5zVzkr6mu8Pqi9qFQJYOYUZC5xZOX9O1CQ75bUG8YfgNPaiOStlL8W+FVtSb5sNGOyIakukqJsOCf+1dK4yv4CPI3E88cMVxVEhljSIqq8FApKpCorlx9X3D+AHycZWXaFWHyV9KwSaimKkGddS9X18oXhzyUXia6TmPtIJuuwfN716+6c/OPb9iZxM0BtV+bv+nZB/xJgAJa5smLgA18GAAAAAElFTkSuQmCC"
            />
          </defs>
        </svg>
      )

      break

    case "lohongmucthap":
      iconElement = (
        <svg
          width="45"
          height="45"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            d="M26.474 49.4323C38.8428 49.4323 48.8698 39.4053 48.8698 27.0365C48.8698 14.6676 38.8428 4.64062 26.474 4.64062C14.1051 4.64062 4.07812 14.6676 4.07812 27.0365C4.07812 39.4053 14.1051 49.4323 26.474 49.4323Z"
            fill="url(#paint0_radial_881_15320)"
          />
          <rect
            x="24.166"
            y="0.5"
            width="8.33333"
            height="17.5"
            fill="url(#pattern0)"
          />
          <rect
            y="13.8359"
            width="17.0833"
            height="11.6667"
            fill="url(#pattern1)"
          />
          <rect
            x="3.33398"
            y="33.4141"
            width="15.4167"
            height="15"
            fill="url(#pattern2)"
          />
          <rect
            x="28.75"
            y="34.25"
            width="14.1667"
            height="16.25"
            fill="url(#pattern3)"
          />
          <rect
            x="34.584"
            y="16.75"
            width="17.5"
            height="10.8333"
            fill="url(#pattern4)"
          />
          <rect
            x="13.334"
            y="2.57812"
            width="12.0833"
            height="17.0833"
            fill="url(#pattern5)"
          />
          <rect y="25.0781" width="17.5" height="8.75" fill="url(#pattern6)" />
          <rect
            x="17.084"
            y="35.4922"
            width="10"
            height="17.5"
            fill="url(#pattern7)"
          />
          <rect
            x="34.584"
            y="27.1641"
            width="17.5"
            height="11.25"
            fill="url(#pattern8)"
          />
          <rect
            x="29.584"
            y="4.66406"
            width="13.75"
            height="16.25"
            fill="url(#pattern9)"
          />
          <rect
            x="25.834"
            y="13"
            width="5.41667"
            height="10.4167"
            fill="url(#pattern10)"
          />
          <rect
            x="13.75"
            y="19.6641"
            width="10"
            height="7.5"
            fill="url(#pattern11)"
          />
          <rect
            x="15.416"
            y="28.8359"
            width="9.58333"
            height="8.75"
            fill="url(#pattern12)"
          />
          <rect
            x="27.5"
            y="30.5"
            width="7.91667"
            height="9.58334"
            fill="url(#pattern13)"
          />
          <rect
            x="30"
            y="22.1641"
            width="10.4167"
            height="6.25"
            fill="url(#pattern14)"
          />
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image0_881_15320"
                transform="scale(0.05 0.0238095)"
              />
            </pattern>
            <pattern
              id="pattern1"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image1_881_15320"
                transform="scale(0.0243902 0.0357143)"
              />
            </pattern>
            <pattern
              id="pattern2"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image2_881_15320"
                transform="scale(0.027027 0.0277778)"
              />
            </pattern>
            <pattern
              id="pattern3"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image3_881_15320"
                transform="scale(0.0294118 0.025641)"
              />
            </pattern>
            <pattern
              id="pattern4"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image4_881_15320"
                transform="scale(0.0238095 0.0384615)"
              />
            </pattern>
            <pattern
              id="pattern5"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image5_881_15320"
                transform="scale(0.0344828 0.0243902)"
              />
            </pattern>
            <pattern
              id="pattern6"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image6_881_15320"
                transform="scale(0.0238095 0.047619)"
              />
            </pattern>
            <pattern
              id="pattern7"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image7_881_15320"
                transform="scale(0.0416667 0.0238095)"
              />
            </pattern>
            <pattern
              id="pattern8"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image8_881_15320"
                transform="scale(0.0238095 0.037037)"
              />
            </pattern>
            <pattern
              id="pattern9"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image9_881_15320"
                transform="scale(0.030303 0.025641)"
              />
            </pattern>
            <pattern
              id="pattern10"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image10_881_15320"
                transform="scale(0.0769231 0.04)"
              />
            </pattern>
            <pattern
              id="pattern11"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image11_881_15320"
                transform="scale(0.0416667 0.0555556)"
              />
            </pattern>
            <pattern
              id="pattern12"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image12_881_15320"
                transform="scale(0.0434783 0.047619)"
              />
            </pattern>
            <pattern
              id="pattern13"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image13_881_15320"
                transform="scale(0.0526316 0.0434783)"
              />
            </pattern>
            <pattern
              id="pattern14"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image14_881_15320"
                transform="scale(0.04 0.0666667)"
              />
            </pattern>
            <radialGradient
              id="paint0_radial_881_15320"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(26.473 27.0364) rotate(158.093) scale(22.3956 22.3956)"
            >
              <stop />
              <stop offset="0.3601" stop-color="#000102" />
              <stop offset="0.5179" stop-color="#000309" />
              <stop offset="0.6362" stop-color="#000816" />
              <stop offset="0.7349" stop-color="#000E28" />
              <stop offset="0.8203" stop-color="#00173F" />
              <stop offset="0.885" stop-color="#001F56" />
              <stop offset="1" stop-color="#005FCF" />
            </radialGradient>
            <image
              id="image0_881_15320"
              width="20"
              height="42"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAqCAYAAACz+XvQAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABAdJREFUeNqkV7uOHEUUPTXd09PLjtn1Y+2VvcgYrQPAEpJFZiISUiJCfoCUHBEQIMFPkCCR8APOIEcWQhi0AViL2Md4dnYe3T39Kk7VrZ6Ht2dnZimppvpVp++55z56gHXHNz9ofPWdXnRbrQySpMDzv4GdTSDtc6cHDArgrTeBLz5VqwMaMDOOu8DTn4DXeRz/CwS3gb2HBLwP3ODFzz9RywErsGEM/Pwr8Nsz4PwXoIyA6+8Ab7wH3NoBPnwszxPUXwpmxgEtOj4DXh4A2QjQfMHpCRD9QUvpAs1HldjWWFmM/uDitbIE7u/OGbEcMKfjDw65mSsqo0NZbuyJZWrqueWAo7Gz8GT++oLAWQ44iOYRtHtBo3lFQEPZTAuWumAjWHhHjh/srgl4TlVHVLWIRU1rqZK14V3BwsNTWphzPxUteg5oS+61gvlnGYeNlej2uwL46ghI3ffWsDAaC6ABy87dRQcQMt3u3uIarEnZilEKVSs0rWqSsiHX4PQaE7rLAf86lnU8qnzgVHbBbIrCSqLM5nGUyFr0nSDXROWwfcU4NDk87pjEdVMJXTNub18B0BQA40Mbg6VQ9ZjLrRZ3qzn/LQc8Yrj0jp0o5XxNNkG90VrTwipkUGUIQyRkhdm6C1xjHdwI1gCsgtpQtZQL5z839+/V1vuLgF9/P1X46ESo5kdcWRj8HRHExqC6kCVm+LVBnHMOGS4JZ9qp1JkRR0t+K7UCYEFqKYH+fOEKQjxfVU0JM/RNluTZCoDjGYCzf2ZKlgM0dM2LdjdrXT8P+NmXGi/pr9eYBec9d7d8xUKet5oSn9FwCeDIdbZSC6BpmaoKG1/WcIP3WYXioY0itMLLKDtq3a4A6nKmDiqx1qprfE3QMVUusksAhwPZF9PxZ2zuOneUUylbJuVSWt1mPykoXD+5hPIHH2kcvZBQyH2hpDOZE/8VErlpJO5JKOD2zQWAutrE2T2Vxp71nJWQry1znNNCn/c6ZOBxu99cANhzAZyZlFOy2ZapYiavvGk7TT1xxdMfVT2gCVJDwSjcJ6UkEit11ZO1szaT2aOl3qI2eudehmgksWVAilw2T0RRrhW7a0k0zapaUdJkSDEooUoI2kaZCr0yJUwhHV01lU0301diChKrSzIlyzqcrksGMVJ2JY1txuDUJeU4gPZSNIO2ZZBlDQZ5WQ+oy+e0zictn9b6PA8ZsIfTglfuWYFshhQdeO0tnjcx6NV8tKvGE/6+PymehmphC+ojCaWZTPGYa01/39XB65ybGPYf1v0LeJvzd84n7pxf5DiZfBTBvnCbsdizMgbBI1sPg2AHo+HH6/ytYImGacSmarzrlDL5tk9fhgRt0z3f4n+Oqm3s1t38T4ABAITeyz5Tk9DnAAAAAElFTkSuQmCC"
            />
            <image
              id="image1_881_15320"
              width="41"
              height="28"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAcCAYAAAD815boAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABTdJREFUeNrMl7tvHFUUxs/szOx6/SROYhvsGEIMQUIoINJR0VAiKhp6+AOgoEGIgo4uiCL/AIgGBUEJpokEgaAgbBTHduI4fmTttb3e1+xjHvzunFnLiReTx9rOla7uzOydO9/9zne+c9eS+9sX30bSrn30riVH1Kx7wNUaIhEY066InZInBay1A3B1XWR6XmSlINLdLfLOGyKVmkhPl4hjHylYZ+dqYZY+JbIJk54nsromks2KnH9JpB/QI4OAz9wri0MCasUfMwCv/CSyHYrcuEKoTxDy44yA7DvJVtIiE+Mi5ya4RgZDT/GmdWisKpNuj8gWYV5eRJMA9VfoMGkPidQZMwCdaYrM8/sIz14YEznWJzJ6XKXQSrYDAqsg1ysA5YPRNk/4TlDmus4IqABNBnXtNuFuNlQKg8dExgD82hkFarR7QGA13LlNkas3RP78XbPbW2IMYDOvYAV2BRAWPQWDbr/IwLMa8j7AvoIMRpHIMDLoSndcBsrkMElxalikeg5dlmAWLTbJbA+G/EICFNAR1wHPhdDniwDincoGnXd6B2D1rMhpnrks259VZoNAJfTxe9bjMdlqP/4GI+hvDia3CXnOhJvwVrkPYDsCXOQz0XQ2YJ/UMfs0KzH2wqaDJJ7h/q3zvMO8rKvv+PQCkalVRS5+bj2aT7aaHyhLuS2R2QTsFot7sNiEseZ2IgPmiWeyDgnAogV7GVhMAXLwOWV+hPtxtH6KLmw2BGiNd+oAzd9l86z98yXr4SrO7hYSolmy3FShJYw+R1hXb/Nt2KzxgZAx2EjA1lU5xrrMkt1jGuIe9OoCOsNGhtnIKHruYl4DkFWS1Ut6GQJKbP7mdWt/M7+/pfDDs3wsCFVjJpNz9CUye8VWVjxHQxluqxSCu5pkJaRhk0Qh+k0Zppm/uSxyG6vrIbGG0KsTqu4bteR7zBk/E0m5WJRmfV1KxYm9TP7fAcPIYAXmChXVbMVTX/Vh2jPMwmYzlzhBS7dpdQOjV5cxxaYcw7itjPba8RTx68poox7QK/R18ZuT9Cm0fGF/PfwX4CLhWgDQHOyUWHxxVq2rghzCTU2mKHGBGLSjzJprU8UkUrDGwtKtnjJaLQGqBMhl/PgvEu9r7n95OFtop9tbgJ1Z1ERbnFEtNrkOYDosqhyisgIzYA2rFvQ5vcq+kZVJsm7Xh7kyGr+O7v9h7Q1AXsLCLj+ad7VjuOQpu5PYWBlZNCoKos6zsJRYV5Swm0qUZgBz7WbNpoqm9olrE+qGAfmDhMF37TX5uIALAJpHBnOwu3wHCeQ1QXwwBBVNpp0qtpOlUGlV0Oo6wH6FzWtM4twoHQK5G2wYqATqsLpByG8C8hZg13CE8po6gI+eQ09ZjoEaCxPQCxZhkZFiBH7NrLizhY6BNHU62qVVk72nsaxXnxd5ESsbwti7CKvt6kEllVZ9ioMObNBboI840EbsTObbm3kn26cXo7ieV5NeIXGKBWV3YQG9esZukEHVnAWM0TLB+huAMwnQC7v1kDoQkJ+9z5ngQys26JjZQJMmAydDnKBODGgZMb87mTL+2aqz7CCa3lNXDvTc/+UnVlyrm0ndjmMHWJs+QPXJEmpzFrWsPFk+R1zLyYEgfLCy2Kn2zVcqqTffjuITkCROZP6NZtJlTXlH8yeI/uC3yw9euzvdJr9XsC+/HsX12pRAc5QLwzuwO0W0p1QWbY4Rh/5Pf/qqRRUJARdRSr34mZFDEGA9e1k8GpCmLS/YsrbiwlyeUmj8MS9PfHPTH+z3878CDABe3IgtXQZ+BAAAAABJRU5ErkJggg=="
            />
            <image
              id="image2_881_15320"
              width="37"
              height="36"
              xlinkHref="data:image/png;base64,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"
            />
            <image
              id="image3_881_15320"
              width="34"
              height="39"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAnCAYAAABqippxAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABY5JREFUeNrEmM1vVFUYxp/7Md/TaWk7LS3TSSnaECkNEjAixIWydOEGNHHhX+BOExITE+PGhS7UhQs3bnRhjDtjjAsNBjdGYgSlEaQgtBSKLQU6ZTpz7/V35tyxkPA1nSkecnIHmHvPr8/7vB+30nqW4wypw8tdxz37lUge/j9BRlBiv/zEXrnuhHL5bzoJ4j+0Co67R4nEAJ8HgJlUMtWr5ZuPTJFkA0JuWq43qUjPEBbjj16u/Rou1x6FIiPsMvtZ1BgDIuRPSZ7fL79xWx5lfI1tj3R2ytkoEFTQnjhFgAh3ykn2AdCPOnklMr5SCfRKS6n0hoWm10I4E1xflKLHuPaxhxQ4eVUjX0EoQmMhMjlp38Goc4q47n6FkakRFsLxxhXWhwFBBQ4OgxTK+PIACOH3UmwPmIyU62pbERtb13ueh040tvlpPX9cNSDCaEBRkJUC81Wf8PB/HJzgn4qINFgkPISob5ArYF9+4rSpSDShKNqN+cpK+yXVzcHukOphSiGGDCvmO3ZH7DrJsrgidfO9/qJ9RL7QAY+E4QdKZ8qYcRSYfqVS7ExK6VwMmrDiRQAEyxamdktaqkq3QusTh0e99k7Uvlk9r4cQmd1FzHvU3eUrjdx+xvrBSazdZWBCwJYoaCdnLKgxbyYvHfkwag9kafFJHpZEGQ9VpDQ+yOWt5B6fE3jCAUj1GIZw3bxi/CVdQ51sl70nm+tA+l6eyTUywUidBaKnW9q0iV200jdAiFaEP4IbJsOkKhBnL0srQWx/vvfuZ1H7dWT6T6fxsBxKbCJzNxetKhmAkpQYrxB7ZhWY63iEPfu3dPwsYkU2RJ7foV5z8udmWkuFHmlsxEJ10WZSxRjGJBFGrc4CMy9NnZS+PxErx+3vfRF1pukd+9ZphChD3LeUpL07bUnPoIpPyFwARdZEqzEUhy8sSX9cWHtGCzD3775ff+6oQEgSeKOAZ3Y8DgxXH2Nmx+LmDExwFY+QPbPT0umL0o2VDRiMPn3faWSRAdpGiMa3EaayDYtnWlDKFrqA8FRQ48Rx6ehvalToFlR5uAnt47cd5QnHZjyyezvXzZgZr2RKMUzVFjzHs1DTqPL7+ZZC1FpvMGkZUEeWqbBfHSUcpO4CB1Y4OCA0Dp7yDSSAZZr2rnFpcuva/a8fdjozPB95xWl0216y5tBzttSblRmyfokAq1PkKmTSBdL5DIBzixs2xduV5eADuyl6pbhFmDGG0EQoVp+3MDMUumOk9fXKA0PUOkhTXpqySn3WLz2YOM3o4mFoxRkToM4i4VqiAn/3i2xHvzfM+hRpwgxQSw5M2D7TDUwKGJdBP6TahgDUrknzl+w9U/evL+sPTRNmEJinnrC1ptGlk9YvBmR1DmMTor/O0I8Amrp4T5j1gzRhfHyxlQltF2mdI1RJwuOaDkxmmYGqBlCVPY9pp4GpVO8K0x5Ic3XnbJoOYdwCO4lv3N44iy7b9J5FlQp/Pz1z570xTPsgzRAZmBeeplMD0FWyNcVU3ahqtzHv+fO2Bcz+08H0vWtKc/A+Y16qcNZU3aL1S7Bgu/Qy10vUmXOotFTZAJDbU3oYn4yPUvRG1mCMInU8soIa1/DJqXP4ZW4tpVsu8Q9aTfPNIP1PFLLTpxgnGZpWL9pBykx4CYydBXJozGbbzq0t/TagtbUFVfZut8O1mfYDM81dscrUjHn5+cNR+4IWK9pZj9ze1EYIyR5geks2RP6A9YsDjMexqRu26rb4+5HWlzlsYtR+/pG9YKYFFAgI1XDK+qg8+F/jdDsOcLsqptjtYpB6+SA9CS/wtqJ9h3hFpc7UCVsfXfyNl5zOm/VuxjXrOi9kP/xK1hCKDJ6Z3GFP/uhNZ2Oy5n5ANVJ1jmwqmJc1lHrr1TvO/leAAQAG4qXJ4lwKegAAAABJRU5ErkJggg=="
            />
            <image
              id="image4_881_15320"
              width="42"
              height="26"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAaCAYAAADBuc72AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABOVJREFUeNrMmMtvG1UUxr95eDx+ZeK4edZKaRsCagtUKFlViAVS/4QKCSGxZMmiiy75A0DiD+iCNWKPxA6hbhCIDVAJIrUpaZuH48SJ40c8D74z5yZOKyclapPU0vWduRnP/c33nXPunVg4689X3yUDx2/fsg6eWq8V3BGw1msDGUbAH4uAQ6RyUVshtw9rnSmgwK1uAmsN4OEy0AuBxjbH2c/PApUh4ML5FNY9dUCBa3UJSLh/V4F19o0msLMDNNeA3S2q2gF+fQLcvAmsPDlh658H3GpRtRXgwVPAdXhOsLU6sE3YmPBdKhr3+CAcS9hXysClt4Fbn6c/d0/c3j3APWsFrrZEGMJ1OJaEChZtmWOqDY8Ks/fGgJ9/Aj748CVBv7ybwGfA2zab0x+PYuARbVwkSJ0AyzUCr9NWQofb2hJeE9bkYgPHc/jaHKqZq1LlPFCaAtrdY4J++kUCh0D5kjaxTD6Jib32LrBUU3uXCbb6mNdQpXZN1Ypod2yaKIqeqifNGVGD/XE+dAYoMokuX+R5ltDZF4Bem0uQpWI+nyzgjULeWEBd3ijixCHBNqnY0gaTgv0jWlxj6zRN3PEYVDuqK1jMJMEB9Zwp/bs/yY4oASEd9oUC8P5bjNEJYKgwIOuD8u/IeG+wFdlcJJQqk+lX3FZTDzaZqR1O1uCkfz7kEOG7bcbVhqoWtUzM9bSlyoWqmE1bLT64yzqZKelvy1UVYP4KxeV8FwkYFJ5BU1DXvUGVPkMUbcJN+nbK5PIp8IYN1juHNqwQYIOA7TCNHbQFin1MdUM5XlWVUuUiY2sF+tAjaqtA+qyRObbhAHj3shb4UR7n/YGrk7sPleA+v2cQxzXsdsWK4TTuEtrV4QU76zppVyztqhJhV+EkGSTu0ht1zAx8KGfUxN2oggZV7YvDwJvTwHUChnSmUtKSdcQSqqBReI+OzrH9whtVabuoFaOxY8PzFUISxfE0TmUyqXlx21gbGWt5X2dcb5ubMlCj+juX7RyVrbLkXJ1WsCGGgGXh/2xKDsSoVaeC1yhKHbGVgRUX0e3Z2I2M4vzqNVU1SYykZQJXbOak9pCJPfbj75nr2PKMtXdmgImyWb/9F6o36NMHDXs1OJkF9GKHECOMxybjbojNVpjYlBRTksBYcwIddwjgnaN6VCuiwpMTCnqJqlY5HvABfO9YYIeDAj8wmWZhkSaJmwg7nCE+kFmW6amGxUltKpOtaOHOUq0CIXMEmqeaZcbctFhuP2vtMeEOAxV1HpOFqWkxxaMNMzi8b7FUM1HPZqJkCeNX9AFGqWCV6l1lcgQltVtWq5eEOwIUXFISRnosFaCqltsxwewUUlqurHA5wozR+iuMP0m4MSpY4pjvq8q3P36lG57nQe9xllkTgA3aRunsItysncJ5tDbHnwxT5CmuJoHUPU/h4lgB73xyIjuyQUvo34Q6z00GpbIC1tOnyLuTLC9uaqlAlgjoOX17BfKbOye6CR8E+huVZObHF5DNiq3XkXHTjQHyWQ3XPSSpt99+fSpvCYNAO4SMuKxK1j6Aa1e5DhdNCdNNgyT/j9+f6vvWYbsnidU57oA+YsmSXVIHHjcqPYIu/HUmb672IeMzsC2JvR0ur6uEDdFpbWHxn7N5vT5C0QUup/dhJy7ssInm1o2z/j/FfwIMAB354T7Q7s71AAAAAElFTkSuQmCC"
            />
            <image
              id="image5_881_15320"
              width="29"
              height="41"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAApCAYAAADJeCK0AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABThJREFUeNq8V0tvG1UU/mY8duI475CmcUIalAZBqaqKwhIk9kjsECvEP2BBhcSq24rHH0BiwQ5YsQIJCVUguisB1FBR4rZEeZCHPXH8GI89j8t35o47efHwQxxpPJ5778w33znnO/eMgaP24RcKm4+A0ASKDpAdAp69oOeuv26gT2YcA1z7HbBC4NbXQP55YOsAuHYZuHoxuaMP4Gb0+8HnCnsEKBWBb74EWk3g+6+AzXWu4BI/OO6NHs16/JC1TeDBH0DZBqp7gJrkIKe+W6G7eb661C/vxkzFWj6wXwcOXcDl4ZF1gy9i87jzG8frfWObgE6MEYRuxSAjPSBvQbfu6blGA3i0c9zNfQEVe+YKMPQkkJ6JgWnOEbbbpb6wTUAvUxrz08DYLMnOtH3OeJaBZlGztat0fauPTK0UdUl2s+fIMp2wVQQJBHBDs602+uzep+eBqVFgPA9knogHGeeQDFtlzXaLrD2/R9CjYs9mgEmCTlMuKSaUJWx5Vsxmv5awdZo9xdU8NfLUeWB0mHEleHqcK4Y1W0XJeGR8sA/89KAnN5unStso6+0cE2qKsbUIaOY027BC0EO9pkDGYdg1W/PMmmry7wSZDuRi4CwHA+3m6hYLBavW6nrXujXPHL20ACzNMbaz2sXGCAdTsXxirf5KF2/bXbE9Dtpmm+Lw3BQ1S7A0XZvKajfD00eFbOuM747dFdvTTNvAIp1lSmhs+sgk2QYHyeUvBSZWrWO25j/OLlIy56nXIWa0RXAjq6uU+yfjSrYOM3qDulWqDzFts5VMvihsZ06wtZPLlfu8jjP5/c9U70zFlphMeYIO8pwSV2e0bhvb3HspHYexXSnoahUGPbq3zTbHRHpukRKaPX5bIOWQ2exSvz+zSu3INV1/42PVO9M223keWdZkczxhK8WizgrlVHQmlw90fK9/pLoHbbOVHUhsaCQujcxspHVsDemhyHDlLrAuhYM6rlf6wFTslSu6Qg1Sv2YmvpVgzkPqdlOzFVDpsTx64a13VPegUmN9FoRBsp2jfIJm1K/ByOgONqROFedDvkD5UK93OFbjS7z2puoO9N03jChO0pa+uAwsLMZsc3FLw721JeyYvUVm9D0mlb2vQauHPbi35carKYkxadyEQJjMB8xih0A+120Q2Lb1PU0eL7ysTve9/8UarDzNhj5yvCXLncdNabZBoOuxV9I7kRwlznl1ncleq0umN9824MctyiQBF6Q0TsQbwYCuUip+eJNuPaB0avWkWFxYVp0zjVpRJkdARk1WIMFJm1HyJu9NgFZJtzmODPMlm+k46fgzk69id3ukM8l8ctOItjORRpoPGZZOMdQ6NVLxt5in1ypfx1zc67dCbgw+vxr8znXaZivm1jQTaeQsHoaVfABKuyoSO6R+yuUyGhRyGDC7VBHDo7c6c69YjRKQ2ArjNEFSJ7I4ohgIsAvFSU85PMvEQ77IDjVcg2W92vm35rWXFFxHZ3SFjCv870tv3PR1nyqPNOpIpdfo/kLUhUD9CMmEILhP1lWrY1BhKWXOowsNAmQMn2R3mTA5KJOZFG5E2RO0dqJ5z1/l9V2kLIkxKwdKnYO69bjUVQkWijvpSr9BVrt8KrPMKOiUVasEucM/t3Ws/TM+/zuxc3mXom8wM4tkV+UGXqPbviU42wxjjYC345XiVre7inTSoqQISiRUQavBmhfa1GKZL3CP/7cfs/vbz/9urOny4agSvEK3fcoEYXmC/W9gvblXbGDwPcqnQFC2hvgB/4uZ5qVub/1LgAEABJNp5W/GguAAAAAASUVORK5CYII="
            />
            <image
              id="image6_881_15320"
              width="42"
              height="21"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAVCAYAAAAw73wjAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABDlJREFUeNrMlsty1EYUhk9LGmk0MwzYGEwIVMxtxQYegAfgBXgJNix4AnapynNkkazzCKzYUFBkkVQwmAJsg8cz4xmNLq1u/tOnxQyOuQVMUFWrJfXlfP2f06cV0vd4Je1bZOoET1somj9F3wXY2fOGyqKmYjYlrR9RVT6hMFonXS2j9cX/C3rtuqXRgKiGYOCjMlfUiqGfTkkpdLBruN1run870Jt3LBUZ0XCHKJsQ7Q2JYnh3pqU9jALSucXTEbI2w7ui2gzJmkMG/flXC4MEdxLtvmbFGiBy3w0AqoKceoynQkVVHQIOL8Gy62/NVbzc/bqgv/xm33lnEFvLc416BmBdQdE9ohEUzfGcYcgQyuYTga+wgaqqIkXHQc5s6cddv9/wp15skFXZGUPJEdFgl2gCkM2XgIXrNcoUMTnblf7FiFcFLowrswATdN0iyRzFbelg0M+Fy0sY0lKXqLdgPICtAO689whtcF8FJQ3Uy6FcFCI2N1liUbtm92JcnZH435VEVkunQP9Avi2CfghSY9JpLmOGUGcIRUYo27u8S2E8kw3C8eZ2LMoYCmqMMaV8qxi0jXrsQTk0Cilzd/AL58/As512mwsWoncgG7cxFMv/dBs1vm0hjbyCoWkmYNav3o3CbbAucCrwNUr2zPeZzKFK5YGqA9TgsRYriXgQAO22V3hFQBkyA9hfz0UtBuJg5+B3G8II2HhzDsjFKWMk5vZf9SsOvvcdOygtmUO1/OL8gsmEvE6q2QtBz81vGZrWIwd294Eot/4YgT8SOPKA/FxsL0zmSz1oAtXXyqvSeK296FKfmpYEjNUN0W5QB+irjMQxl0BpCpGqat1FQwoPH5EYHcLgGUzwx++S84x3qdmZpxf3oVhw0aI6PoOwAMqDqoSaRE2tnqjfXpGNE+H0CRkMz6GVXBorHxpYdGB6pMupM1PrJbdonF6RU6SEYqsdoo2NBVc28Rb7Zyww7HrllMA4lTp844QtJerOQ6R7lFMO6ouYFyB9tLU40cO1Hd5QlaQsDkvOpVUs7wGMVTj7rXoJx2acUyM6fRYdwfsQx2qMietYlAyPieEGjBZ2dLIqkHEqfTgldfoC2ANMvydDVvFP0cF8bbSPAbKciJIFMsZ0JB7ko5RPrnbb2+XcBh5dYkK6jHl41S8iSjFxBFXSn9AJ6nYQuyUmSX/4N2D/BNRB34SNJ9Ls2lFd+BGJBOAnscCkJTmzOZXYpRW8OMWpNANwCdv8A5LP5scqn1ocOnES+vO/L3Yl9NTb9HT/b6Qj/P5tYHd3UoFjZfha7othLl204f/BpbE1KNtJ5lAHXaaW7MF51pU9KXsQYzKWzZtnvgD8nz/VQdNIHuXEfeUS/gtheHAOE/mNswoVUoDEAGlFAh8GHz6tbt9Qh/GPo774bD8ksPeDfirsNwL7vN+2/6ryIVxvBBgA+ygQnJvB0CkAAAAASUVORK5CYII="
            />
            <image
              id="image7_881_15320"
              width="24"
              height="42"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAqCAYAAACpxZteAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABN1JREFUeNq0V01z21QUvU96kmXHn4nrJI1J02lJNx0WbPkTrNjwC1ix6QwMG/4Aw5b/wI4/ABvYwQyLsoEydVu3JMEO8adkW9LjXL3nkYtTW0oHzbzY1ij33Hvuuec9Ef3Pl9j6RMH7lJTysH6kOCaKQhd3f8CqYg23/bvcCuA4DylWFVLxfYA8pijCTTVHbgf4PMOPn7Dwnc5uVkG5+of51k3+TiYjUtE5kYUf8WMTogewjnmOgf7E4krnMgNAE1lLmgU1itSALNmlWKAitcyxgj8jEvYVCdVN7qv45+wVHN9T5E9jkjKi6WxCU58onHEQZB3iAZsp65LtgE77CcWgUCLvOB7TYt7ZXMGD91TSWOYjVhY5qk5iEZIKkFhYxv0xcrRJiCZWj5xCmywRQAg9sgCM1DYDSEd/ugWEmhIFAatIrhQOQAvVeXEil4LnIpU5KbeNqns087/YDFBvckC0CoEnC5RtJcUk8ZXQ38m2yHZRnawnonSli6pFUvl4mEGmNh7xdoj8K8SDMASCqoVpH2iQRXCP1QBjwIEYJFn4fHXR2D4HJQQOESxANgp0RaA85sYqnb0F6gTuFwCwAwCB51zvtRDWRoDbd4luHSFR/NNCabrS0hBQJj2mMpRaAoCN7zuVjACffKkSFoqoYhwazldUzYE5++IuUQ1s1LEqWA6q+u0Xsd0qSsjEcXlysSLNtQTY/DwFcGq6uibEUCnq+zwHmSrgkr0S0QA98LGm8LXZ3yY4goqSbrqNjHf3QBPA9ttE338nspmdEBogtLQ8mW/FQ8cZFvRvF0mc3IGCGvr52TSHm3IFvq9laplmUqz7wMFtUOJB+gf77FdaWUkCeeya5f7ikpKhYROLAzNoAHdAiw2K7h0jGU8DfP3ZmrdZG20ixj/1MWDDC8wCN3duzA1xXNB3BAk3UAUPFnvPNdf1AF99q734RR9VQKJe9T/GawBOwb/rajpZcbl2tDBKqQlGK/mYeZgMiO4e6uZy9p9/LPIBTOD5T16axvFeDPsncC1byBhyfPg+Pgt6ejdcb+7BDB0eIvN/nkFNL/mGNrrlgjOTNMEffSSyAzD/ETJ+Bf5HA2NscUoPB2+AmvatTMeW6ytg3sc+mf0V9AyMPAFQgO6raGq19BYAE+j9+bkOPuuZ6eU991CbWRnB9xtb6VkHWMpziJHvY8AmfBoJ9MRZXsp/cl6yb1jBAtn2jSzDcbq5CLNF1sH9/Xba4MwAy+yZ9x6mdzow9gC7FqDFgn27oKXVzHU2Xa/Ahxw7f2G4YM8LPnoG6fR6ZT1nJ/s5AZbZ83VxpV002TxGOrANq3DhOcWqpoYHLEOD1ytga5iYjGd902BjDRLZl6CeB8eZ+V8H8OGWXexaQ6zIADH/wpwU6pVcwdcB2ODO+vrsmVxBeoKt38YEA+BOKyfAKv9JFUv+LzW+3NPTy/TsVd+ygqfmHcKHipQ5A/H2yJt7DT1o1XO/QllrSrjsGmsw/CcGt9ynvRsArBoc69+6xp5qh3p6q8X0XgaJvg7AViDx8/QUPoPpLTp6p+LN5eggfebGb5nc7F/xOhZCOR28AfXP9cmh+q4+AHz4Qe7s11+hHn2jaA6Ds0HX099hDaCmBVm+00qzzxH8ze9oXE0H1Zwg+0v40W71RsH5+leAAQCy5pcUK2ycXgAAAABJRU5ErkJggg=="
            />
            <image
              id="image8_881_15320"
              width="42"
              height="27"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAbCAYAAAAK5R1TAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABPhJREFUeNrMls1vG1UUxc+bGXvGdmLHsXHixClJG9KmCVnQQGkBCQSlYodUAWKDkOiaLgCxYMkGJDZI7FkgNvwJ/BMsECsqWlBLExqcxElqx54Pzp07SZwSt6Xky9LTvPHMvPd755177wN6/Wz7Io7Rz/T4/wWCzsNJzSKVnsR645WjBrV6P7FNDJlKT6My0sHouH/cQIfhOPMwZkY1Nx4sy1BhGzPnIsydj44L6BTCyEOEHKKoRlABi7CFl0rTGJcjXH4rOmrQgDK2EKLKiKKHrT7YKQdeRp+GwY69r1yN8P5H0VEEUxHGeg/GnkUYPkfALKzUONyMg75+oFwC8gUg7QJZ3ldGADcLeEn78po5LEXPcrsdhD5Joiz7VTYLPkXbaAELK8DtOrApynYz8bnrAZ9/G+GL7w9EYWcPhRnd1ljcjUIXQduiujQEt3yzA6ytA032+waAdoojcIizU7tH+eoHhf34bXMQW59ju8r2EtspNu6teVIXY7NL8Q3BbL5mZ7Vv+KjMNRVpidP8ZGIUGKQ17PvWvw/AZleSB+bpyTcZMBPsc/ZIIsjeeVVg7Ti+YKU1sLxhXUtxTBdTo2+nuL5p3jv2v2d8TGizbQFjvcrZn2Gif52Wq9Gb41SNfm2LITUZbNs6aaKoVUjuOVRmVPslQo5yAZO85xB4amRv6P8Abroq0TU46Vkm95d5M0wuLwYNEsBo69pJ+n7yeVptIKpa/TtDZk9ozh3l5vTnFNrj/fgQP3EeTLUHvEkOIFfoq3NMOxd4V0PKLaM/P4CVpooZRzgV8X0JMN53kk8lyBoJdHoniRj27UG1glcVEagyQYfKDEK6qUpXuVzcpKRq+5GATdxs58P4EJJ2J9nOIJ3uQ9pz4omsjALcI9QmgzmUVJRn9P9FaAL6Tb0KbLi6Yw+T0eHtkvpaWv+4lGTNv0WO4bmqdIUZpJB9IKwTJ8E4TiwmSpR5RQwp2+Z1JXPZ3oAvrhO4zlcLNbJR2c1mUs+YXNs5hQuWOOqGAvtBkjEIukq/WxynfQ+4w6nzFQrQUnXHKmqNU9XdfpZUR1g1i+9/HW8rmlJ1luO6vlUqBdKlOlJC5ZohTIcwa3y/zvfrnLTFyTpsHs8x9d8JScWat7QQBH8nvk6pZQTY50JsycPcgZU/6WfaZJGFpMBsssI87RJ4gl4u5B56Hu1KWjyACGCOgVKqiNrapBJZXKfPIRao3m+ccJXXexvq4/pNBQy5oPaSQofLSfZIKbDNjGE8VVnSnEPAPlolm1Xo08weT088Iuj9vw8+jZDhIIMVrUoCHZuIk61S3esEvn4baKzRJg2FFj/LDrUW1MvBcpLy/MTPUuFKmu6kmLglHfNF1p6Ls3GK+/8lTmq7QG6XfSrXJkAjgb55B1jitga+tvW7aoHWIq+yEDk4tBJgBpfFhYfcFY9qnnkeeI2wQ0Xs/2lnq87H3g/0MCPXn2mFW1R2mQcbn0HVWEyA+R86icqB9gVafDv3LHD+EgOthgM7lu0C7oYWtX/6FfiDoE0GY4MK+5uaNTbvarYQRcv07MmTwBvv0rf5AwTtBb1ljRZVvUHPNgn4yw2FXqZVipIxmCkGiTZDf1afAL75zBwOaC+Vu5UW6GmW3e9+VC8P0K8X5oATI3HSP1zQXrDd0FIApOjIGSPPPPrJO+bx0tNhAO/jOXb/oR8C/o8AAwBbEJinc66yIQAAAABJRU5ErkJggg=="
            />
            <image
              id="image9_881_15320"
              width="33"
              height="39"
              xlinkHref="data:image/png;base64,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"
            />
            <image
              id="image10_881_15320"
              width="13"
              height="25"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAZCAYAAADqrKTxAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAhdJREFUeNqUlD9P20AYxh/bcdMEI0iB0lKWDpEYGZD6ATqw0JW5qtRvwIfI0IUPwdK5UpnaiQGpAwsSqapCaNIWQnDcGtuJ/xzP+USahJyinvLqfL773fu8fxwDuvHuvUD9HHCbQOIDay+A2ltDbplaQI6oDzTrwO8W58vB+4IWOPoOfPgIeF8A+wnQeQSsV6H3NDxED8hS4M3W4FI99I2xBD/Uc2kVOD4bbOkhzx9dF20172wbkyGZALdNWREXD/grASsLUzy1PUqjpTSTgEPAKWmgu8y5lBZ3mYQEMBxmj9IsM5em9ySTIJgxxJRWARYqI9uToV+MJwn4QA8y7JXFKVBCD9c/GU+HkhhL5TlQfTYFOmFtsozyMrVt0uZnBvGMQrU9gSRWPRax1yBj4rnXr6jS0ngKfGUnbNCMMNg+pWVg/5B8MgL9a1jvOr8YqSyolGYpiY6lLrsHbW4LfD3iAWbJa6okSBHlMrDIjmidToB8T626geqCvLu41fvDUtFLOjsB6oVAeMP24Zyy7wTNpBeDyQhcvm+MQY+fxnCveIAB9X0F5DHRbEIe9+ziGBTc+DTqd5x8zju7UFAgMygvDIMxSGQHjGEG/l+Z2grXrGQyy3cPkYQCPpy8wEPD4qEGovATMhEg7cmqfqbGLgyrC1N00I8Eri6WhiFjrInmZMVoL+WnCJvpjvsbfN7Ff457/1i3AgwAXRfaoSCdNYwAAAAASUVORK5CYII="
            />
            <image
              id="image11_881_15320"
              width="24"
              height="18"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAASCAYAAABB7B6eAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAl9JREFUeNqslN1vS3EYxz+npy9e9s4MY1mYG1cjxAWJO3+CiP/BnYi/QVwQi5vd2AURbojYFq4kQ8yGpZPKzFKjjW2lW9eu2p72+B5na9cyaadP8uS8P9/f9+V3DNbX1Xt28fziWYM6lFE2PDgDXR3QvJ16AXmKwx/ehqGn7t37z2Ap9SerTTFwBiSSMNAH8z8hHYbGXmjthD274MyxEqNNsPG6PEzI7oD8tCC14OUXkGyCub0wo3snjsORgyU2NQAZxY8mpP/YB4h+EosvkJsDOy3wNgiITUs3nBTQ0R7we6tmZJTpbOVhXCuemIJIUEACLeScB2C2wpb90Cag0wLqPQCJuNvXLhvVAaxVRkNfic3LUck1K/miApJPSEpzJ+w7JTkz0CNmhyRtbgV+LKjnYWTY2DimlZXWkCGBhCbliYByUQdd7Vtl1A5bG2B3C7T7tRCFZDEm7yIWsW++coCNNpxTSX34ZAyC42KkxnZlcz43mxUVgfg1r0VtZLWwlEV6JUwq2fdvkyqBEpLi1iOIf4UVMcp/182sG0YjoEDo2KFQLMWmyVuPyWQGq4vbeiBL/rxWAN5JtvCoG2tLRpNffcG0MM0RefRAF9dr2zhX7toUNGhBXsS1+tBH9XtISXdLIbAdf2zFkOfqfufoqQng0jnjdyyzGTe+7drhh7ukfaM82OZ4ImM80o+36tmNTa6mzl+w+TzlpiaZ0G/GAV6epmDdxM6H9MZw6We3mbpzw8DKuueObGZ2kYDvDaansDa8ftXZbdHQFMEf6P/77/p/KxL2KpaDFAqTlY9+CTAABqT6E5yN0LkAAAAASUVORK5CYII="
            />
            <image
              id="image12_881_15320"
              width="23"
              height="21"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAVCAYAAACt4nWrAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAApZJREFUeNq0lM1LVFEYxn9n5jrfY4lhaZHZokQKUQsqJKhF9rEIClq4aeG/UOCudVC0bxUtKgoiWlQuSihyo5CU9kX2/YGmo6PONKN35vbcbjakWDpTBw537p1zfvd5n+e9B/7j8Je0Oxq/Cc5e8vky3T37d/Ca2lkMa8GEyOXe4OSH9XSidHjjDodgyIfjBEmlwti5Uf2u0T/vNSeLhx9qd8FCJCA5DemZDLnsOsgHVMWAVnwoDt7R6RCOwKePmmMw/hXsjN5kZ4Uqx5haZXBt+fBT5x15DGPj0PsUpnS1Nclp+qL4VY7xTYjYqoATbgW+JYFPX3J+XHuew91eyGRgZsSFSl4cAivBikSIRbYTUmWBYNvSlJ+56uAT5EaPtHyW8kGB3dzyAlZCuAJWCR6X5cFQANveKHuCzGRfWX8FJ6bg+gMFl4KRR3JBXhupLRM0vho2V+l+VtWkIaW1k+rG6ck97nZrUag7huXp5TvqXgX4TapzstJfLbVroK4OmtYLmBRM0w3EhU+MVcxhrEXB958ouH61m8DpQW+pJWhlAzRv0dwAWXk/iqf6YZeZj7IWQG2lf6Ubhh5LyZCsVbuZcq1U+TXNcPwgxIJ6Ls/96vMLZ81irprfwEn5evE2JPQdpF4IoDJ9MZ0hUru1BQ7vEvBng9k2dLabP0VmfoEH3kJ3H3zp97rBaJ+lwFZskgVNsK+lsOvEMbOUDvZs6XsJt7qk9p1Cc8FhiNRDtRQf2Am1VcsGe3C3I+51u6kIrPDKdExEFFaD1LZtk7/hosAePKajoVwvSL+WYgUVVYvVN3r+Wv6iwR48KmX7j3rnRUpfWVwBHmn1PC8BXOiWk+cc+tV2bbsXrigSXIDP7/USoXPjuwADALDA4fxsaW4fAAAAAElFTkSuQmCC"
            />
            <image
              id="image13_881_15320"
              width="19"
              height="23"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAXCAYAAADpwXTaAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAo5JREFUeNqclEtIVFEYx3/3zuOONjPOjOajtEJFspQmhYhCSiqQiFoULSIIWrQJahOt2rSPFq1btHHTrk0Q1SYwJFpMLnoYGipk5SN8lenM3P7nDpbFOA8/7rkznPud//19/+/cA4XjOE7FdUoMa4P5Do1j+AMdhCqOEnSCzE7tLCbmzzN3WOMIPucETrBN/2sJR/0SK4vMiBzU+KzpKxpJIrEw8bhfvxAIQGrQKoXslBZ/x7J347pXIRvXXIwV3W2lxGqgMlyUzMayquXNGcKRBzihc9iBJmHEvKcZFxYyucygAxevuYXJXHdGJrcqeRcJ480CLM2heQGuwuIPpYVga4PoIkXITCzO93omG28SCYFV6YkWZn9KVM+HZb5fZDUSvH3fLSxmYnzE8rxpa4d4vRZHwSfrVqZFKtrxuVyeU0FxMRMDTyyvvKS2WXS7FlZrUqX+moGXryCtZvrV1TsP3eJiJup3QIPKSe6T6aZcEWYklpZ3/c9K8Gx99N+zSNRB915oFmHINHcbLI/ArLbg2/FcXh46O+8r7t60iMivC33Q2SvBWk0u65LYc5WbyeYVtDdkvnUpt9tbRBUTnU+lr07CZAoeDfzNWydoFzThxnmLrhb5KLKQxEjr+qat8h6GPlFamf9H34Fcd33yMjsPc8Pw+p2EM//QWSWJmeTUKDx9AVOD2sjazNFu2LMfzvaUSWYi2axyRRcQnasTYEndHRuDN6NlihnvTJw+JMFOlaumpL/C9BB8mMCjLovMRNUW6FFplU3mGFF3JZh6/Mes0sXW6JLqbpMO4EiXStY37JPExJdNkK0JXj6pw6BR365OkgaN9kavsxabCdPd+SV9Wh+hVfuvps570W8BBgCEOqblSGsoIQAAAABJRU5ErkJggg=="
            />
            <image
              id="image14_881_15320"
              width="25"
              height="15"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAPCAYAAAARZmTlAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAi1JREFUeNqslE1vElEYhZ9hKN8tA9JSqQXRYrQaE6Mrv2L8BybGxK1x6dKfUX9BN679G6Y7Y1zophJNtKWWYrAUGcoA46EDEiqN0cxN7tyPuXPOec/7zjXwq629cifWzx8Zo6nhO/jxJrKgb+Culg0bPn+D8hZcPAMLqf+IZJpquwObAi1vw7YIGuotrQMBePoEzpY4OZLHz1zCYchf8NZzqfG7Zhs23kO1DpWvcNgUmYC7Nb3sKapDiOr8zh6kskOSeGIdI/CQ9LxFMi3A9BiwXtU6A+/KnhVb6vvaszX2ZI8rgn5Lo4iRKHMBIouQK8EHnbseOyK5heNAKFyTrxb9vpTp4x0p7IUE+An2fgpUQAdfZLBs6H0XqM7QVY8IeB6CcWFIfXoZFrV+cFt75u/Eb+DI15nQPQ72u9SbQUIJcCoeRqehxwD4h8a2F52ZG4Qv4VI8q3lY89NZuLYCRY2mOeF8cFgZN2h3KnSE2jdXsG2vWtzu0IYBz5yikNJYHixVjquIl5bg5mURpLxEn/CfjBL/hr5zVzkr6mu8Pqi9qFQJYOYUZC5xZOX9O1CQ75bUG8YfgNPaiOStlL8W+FVtSb5sNGOyIakukqJsOCf+1dK4yv4CPI3E88cMVxVEhljSIqq8FApKpCorlx9X3D+AHycZWXaFWHyV9KwSaimKkGddS9X18oXhzyUXia6TmPtIJuuwfN716+6c/OPb9iZxM0BtV+bv+nZB/xJgAJa5smLgA18GAAAAAElFTkSuQmCC"
            />
          </defs>
        </svg>
      )

      break

    case "dientapthucchien":
      iconElement = (
        <svg
          width="45"
          height="45"
          viewBox="0 0 68 68"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M62.4375 13.2188H44.9375C44.9375 14.4273 43.9586 15.4062 42.75 15.4062H39.4688L41.6562 32.9062H46.0312V37.2812H48.2188V41.6562H19.7812V37.2812H21.9688V32.9062H26.3438L28.5312 15.4062H25.25C24.0414 15.4062 23.0625 14.4273 23.0625 13.2188H5.5625C4.95875 13.2188 4.46875 13.7088 4.46875 14.3125V51.5H63.5312V14.3125C63.5312 13.7088 63.0412 13.2188 62.4375 13.2188Z"
            fill="#00F4CB"
          />
          <path
            d="M35.6493 28.6672C35.7182 29.2196 36.1896 29.6254 36.7332 29.6254C36.778 29.6254 36.824 29.6232 36.8699 29.6166C37.4693 29.5422 37.8948 28.9954 37.8193 28.396L36.7255 19.646C36.6501 19.0466 36.1054 18.619 35.5049 18.6966C34.9055 18.771 34.4801 19.3179 34.5555 19.9172L35.6493 28.6672Z"
            fill="black"
            fill-opacity="0.63"
          />
          <path
            d="M62.4375 8.84375H58.0625C57.4577 8.84375 56.9688 9.33375 56.9688 9.9375C56.9688 10.5412 57.4577 11.0312 58.0625 11.0312H62.4375C64.2466 11.0312 65.7188 12.5034 65.7188 14.3125V50.4062H2.28125V14.3125C2.28125 12.5034 3.75344 11.0312 5.5625 11.0312H9.9375C10.5423 11.0312 11.0312 10.5412 11.0312 9.9375C11.0312 9.33375 10.5423 8.84375 9.9375 8.84375H5.5625C2.54703 8.84375 0.09375 11.297 0.09375 14.3125V55.875C0.09375 58.8905 2.54703 61.3438 5.5625 61.3438H18.6875V65.7188H14.3125C13.7077 65.7188 13.2188 66.2088 13.2188 66.8125C13.2188 67.4162 13.7077 67.9062 14.3125 67.9062H53.6875C54.2923 67.9062 54.7812 67.4162 54.7812 66.8125C54.7812 66.2088 54.2923 65.7188 53.6875 65.7188H49.3125V61.3438H62.4375C65.453 61.3438 67.9062 58.8905 67.9062 55.875V14.3125C67.9062 11.297 65.453 8.84375 62.4375 8.84375ZM47.125 65.7188H20.875V61.3438H47.125V65.7188ZM62.4375 59.1562H5.5625C3.75344 59.1562 2.28125 57.6841 2.28125 55.875V52.5938H65.7188V55.875C65.7188 57.6841 64.2466 59.1562 62.4375 59.1562Z"
            fill="black"
            fill-opacity="0.63"
          />
          <path
            d="M18.6875 11.0312H21.9688V13.2188C21.9688 15.0278 23.4409 16.5 25.25 16.5H27.292L25.378 31.8125H21.9688C21.3639 31.8125 20.875 32.3025 20.875 32.9062V36.1875H19.7812C19.1764 36.1875 18.6875 36.6775 18.6875 37.2812V41.6562C18.6875 42.26 19.1764 42.75 19.7812 42.75H48.2188C48.8236 42.75 49.3125 42.26 49.3125 41.6562V37.2812C49.3125 36.6775 48.8236 36.1875 48.2188 36.1875H47.125V32.9062C47.125 32.3025 46.6361 31.8125 46.0312 31.8125H42.622L40.708 16.5H42.75C44.5591 16.5 46.0312 15.0278 46.0312 13.2188V11.0312H49.3125C49.9173 11.0312 50.4062 10.5412 50.4062 9.9375C50.4062 9.33375 49.9173 8.84375 49.3125 8.84375H46.0312V4.46875C46.0312 3.865 45.5423 3.375 44.9375 3.375H40.5625C39.9577 3.375 39.4688 3.865 39.4688 4.46875V9.9375H37.2812V4.46875C37.2812 3.865 36.7923 3.375 36.1875 3.375H31.8125C31.2077 3.375 30.7188 3.865 30.7188 4.46875V9.9375H28.5312V4.46875C28.5312 3.865 28.0423 3.375 27.4375 3.375H23.0625C22.4577 3.375 21.9688 3.865 21.9688 4.46875V8.84375H18.6875C18.0827 8.84375 17.5938 9.33375 17.5938 9.9375C17.5938 10.5412 18.0827 11.0312 18.6875 11.0312ZM47.125 40.5625H20.875V38.375H47.125V40.5625ZM44.9375 36.1875H23.0625V34H44.9375V36.1875ZM40.417 31.8125H27.583L29.497 16.5H38.5041L40.417 31.8125ZM24.1562 5.5625H26.3438V11.0312C26.3438 11.635 26.8327 12.125 27.4375 12.125H31.8125C32.4173 12.125 32.9062 11.635 32.9062 11.0312V5.5625H35.0938V11.0312C35.0938 11.635 35.5827 12.125 36.1875 12.125H40.5625C41.1673 12.125 41.6562 11.635 41.6562 11.0312V5.5625H43.8438V13.2188C43.8438 13.8214 43.3538 14.3125 42.75 14.3125H25.25C24.6463 14.3125 24.1562 13.8214 24.1562 13.2188V5.5625Z"
            fill="black"
            fill-opacity="0.63"
          />
          <path
            d="M53.6875 2.28125C54.2916 2.28125 54.7812 1.79156 54.7812 1.1875C54.7812 0.583439 54.2916 0.09375 53.6875 0.09375C53.0834 0.09375 52.5938 0.583439 52.5938 1.1875C52.5938 1.79156 53.0834 2.28125 53.6875 2.28125Z"
            fill="black"
            fill-opacity="0.63"
          />
          <path
            d="M58.0625 24.1562C58.6666 24.1562 59.1562 23.6666 59.1562 23.0625C59.1562 22.4584 58.6666 21.9688 58.0625 21.9688C57.4584 21.9688 56.9688 22.4584 56.9688 23.0625C56.9688 23.6666 57.4584 24.1562 58.0625 24.1562Z"
            fill="black"
            fill-opacity="0.63"
          />
          <path
            d="M43.8438 18.6875C43.8438 19.2913 44.3327 19.7812 44.9375 19.7812H53.6875C54.2923 19.7812 54.7812 19.2913 54.7812 18.6875V5.5625C54.7812 4.95875 54.2923 4.46875 53.6875 4.46875C53.0827 4.46875 52.5938 4.95875 52.5938 5.5625V17.5938H44.9375C44.3327 17.5938 43.8438 18.0837 43.8438 18.6875Z"
            fill="black"
            fill-opacity="0.63"
          />
          <path
            d="M53.6875 41.6562C54.2916 41.6562 54.7812 41.1666 54.7812 40.5625C54.7812 39.9584 54.2916 39.4688 53.6875 39.4688C53.0834 39.4688 52.5938 39.9584 52.5938 40.5625C52.5938 41.1666 53.0834 41.6562 53.6875 41.6562Z"
            fill="black"
            fill-opacity="0.63"
          />
          <path
            d="M54.7812 27.4375C54.7812 26.8338 54.2923 26.3438 53.6875 26.3438H44.9375C44.3327 26.3438 43.8438 26.8338 43.8438 27.4375C43.8438 28.0412 44.3327 28.5312 44.9375 28.5312H52.5938V36.1875C52.5938 36.7913 53.0827 37.2812 53.6875 37.2812C54.2923 37.2812 54.7812 36.7913 54.7812 36.1875V27.4375Z"
            fill="black"
            fill-opacity="0.63"
          />
          <path
            d="M53.6875 21.9688H44.9375C44.3327 21.9688 43.8438 22.4588 43.8438 23.0625C43.8438 23.6662 44.3327 24.1562 44.9375 24.1562H53.6875C54.2923 24.1562 54.7812 23.6662 54.7812 23.0625C54.7812 22.4588 54.2923 21.9688 53.6875 21.9688Z"
            fill="black"
            fill-opacity="0.63"
          />
          <path
            d="M14.3125 2.28125C14.9166 2.28125 15.4062 1.79156 15.4062 1.1875C15.4062 0.583439 14.9166 0.09375 14.3125 0.09375C13.7084 0.09375 13.2188 0.583439 13.2188 1.1875C13.2188 1.79156 13.7084 2.28125 14.3125 2.28125Z"
            fill="black"
            fill-opacity="0.63"
          />
          <path
            d="M9.9375 24.1562C10.5416 24.1562 11.0312 23.6666 11.0312 23.0625C11.0312 22.4584 10.5416 21.9688 9.9375 21.9688C9.33344 21.9688 8.84375 22.4584 8.84375 23.0625C8.84375 23.6666 9.33344 24.1562 9.9375 24.1562Z"
            fill="black"
            fill-opacity="0.63"
          />
          <path
            d="M14.3125 19.7812H23.0625C23.6673 19.7812 24.1562 19.2913 24.1562 18.6875C24.1562 18.0837 23.6673 17.5938 23.0625 17.5938H15.4062V5.5625C15.4062 4.95875 14.9173 4.46875 14.3125 4.46875C13.7077 4.46875 13.2188 4.95875 13.2188 5.5625V18.6875C13.2188 19.2913 13.7077 19.7812 14.3125 19.7812Z"
            fill="black"
            fill-opacity="0.63"
          />
          <path
            d="M14.3125 41.6562C14.9166 41.6562 15.4062 41.1666 15.4062 40.5625C15.4062 39.9584 14.9166 39.4688 14.3125 39.4688C13.7084 39.4688 13.2188 39.9584 13.2188 40.5625C13.2188 41.1666 13.7084 41.6562 14.3125 41.6562Z"
            fill="black"
            fill-opacity="0.63"
          />
          <path
            d="M14.3125 37.2812C14.9173 37.2812 15.4062 36.7913 15.4062 36.1875V28.5312H23.0625C23.6673 28.5312 24.1562 28.0412 24.1562 27.4375C24.1562 26.8338 23.6673 26.3438 23.0625 26.3438H14.3125C13.7077 26.3438 13.2188 26.8338 13.2188 27.4375V36.1875C13.2188 36.7913 13.7077 37.2812 14.3125 37.2812Z"
            fill="black"
            fill-opacity="0.63"
          />
          <path
            d="M14.3125 24.1562H23.0625C23.6673 24.1562 24.1562 23.6662 24.1562 23.0625C24.1562 22.4588 23.6673 21.9688 23.0625 21.9688H14.3125C13.7077 21.9688 13.2188 22.4588 13.2188 23.0625C13.2188 23.6662 13.7077 24.1562 14.3125 24.1562Z"
            fill="black"
            fill-opacity="0.63"
          />
          <path
            d="M42.75 54.7812H25.25C24.6452 54.7812 24.1562 55.2713 24.1562 55.875C24.1562 56.4787 24.6452 56.9688 25.25 56.9688H42.75C43.3548 56.9688 43.8438 56.4787 43.8438 55.875C43.8438 55.2713 43.3548 54.7812 42.75 54.7812Z"
            fill="black"
            fill-opacity="0.63"
          />
        </svg>
      )

      break

    case "sodiaphuongtochuc":
      iconElement = (
        <svg
          width="45"
          height="45"
          viewBox="0 0 70 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M34.9918 2.17969C21.7284 2.17969 10.9336 12.9788 10.9336 26.2422C10.9336 49.5801 33.6374 67.3219 33.6374 67.3219C34.435 67.9571 35.5657 67.9571 36.3633 67.3219C36.3633 67.3219 59.0715 49.5801 59.0714 26.2422C59.0714 12.9788 48.2552 2.17969 34.9918 2.17969ZM34.9918 15.309C41.0065 15.309 45.9421 20.2275 45.9421 26.2422C45.9422 32.257 41.0065 37.1882 34.9918 37.1882C28.9771 37.1882 24.0586 32.257 24.0586 26.2422C24.0586 20.2275 28.9771 15.309 34.9918 15.309Z"
            fill="#0E8CF1"
          />
        </svg>
      )

      break

    case "coquantochuc":
      iconElement = (
        <svg
          width="45"
          height="45"
          viewBox="0 0 60 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.22566 15.7619H15.2033V10.4573C15.2033 9.50733 15.973 8.7376 16.923 8.7376H19.3132V2.29782C19.3132 1.34786 20.0829 0.578125 21.0329 0.578125H38.9674C39.9173 0.578125 40.6879 1.34786 40.6879 2.29782V8.7376H43.0773C44.0272 8.7376 44.7978 9.50733 44.7978 10.4573V15.7619H50.7746C51.7245 15.7619 52.4943 16.5325 52.4943 17.4824V65.9787H57.3499C59.6128 65.9787 59.6128 69.419 57.3499 69.419C39.117 69.419 20.8832 69.419 2.65029 69.419C0.387402 69.419 0.387402 65.9787 2.65029 65.9787H7.50596V17.4824C7.50596 16.5325 8.27652 15.7619 9.22566 15.7619ZM31.6429 65.9787V62.3947H28.3573V65.9787H31.6429ZM24.9171 65.9787V60.675C24.9171 59.725 25.6876 58.9544 26.6376 58.9544H33.3626C34.3126 58.9544 35.0831 59.725 35.0831 60.675V65.9787H49.054V19.2021C36.3514 19.2021 23.6488 19.2021 10.9462 19.2021V65.9787H24.9171ZM15.5778 47.7458H20.9585C21.9084 47.7458 22.6782 48.5155 22.6782 49.4655V54.8462C22.6782 55.7953 21.9084 56.5659 20.9585 56.5659H15.5778C14.6278 56.5659 13.8581 55.7953 13.8581 54.8462V49.4655C13.8581 48.5155 14.6278 47.7458 15.5778 47.7458ZM19.2379 51.1852H17.2983V53.1257H19.2379V51.1852ZM39.0426 47.7458H44.4224C45.3724 47.7458 46.143 48.5155 46.143 49.4655V54.8462C46.143 55.7953 45.3724 56.5659 44.4224 56.5659H39.0426C38.0926 56.5659 37.3221 55.7953 37.3221 54.8462V49.4655C37.3221 48.5155 38.0926 47.7458 39.0426 47.7458ZM42.7027 51.1852H40.7623V53.1257H42.7027V51.1852ZM27.3098 47.7458H32.6905C33.6404 47.7458 34.4102 48.5155 34.4102 49.4655V54.8462C34.4102 55.7953 33.6404 56.5659 32.6905 56.5659H27.3098C26.3598 56.5659 25.5901 55.7953 25.5901 54.8462V49.4655C25.5901 48.5155 26.3598 47.7458 27.3098 47.7458ZM30.9699 51.1852H29.0303V53.1257H30.9699V51.1852ZM15.5778 35.5649H20.9585C21.9084 35.5649 22.6782 36.3354 22.6782 37.2846V42.6653C22.6782 43.6152 21.9084 44.385 20.9585 44.385H15.5778C14.6278 44.385 13.8581 43.6152 13.8581 42.6653V37.2846C13.8581 36.3354 14.6278 35.5649 15.5778 35.5649ZM19.2379 39.0051H17.2983V40.9456H19.2379V39.0051ZM39.0426 35.5649H44.4224C45.3724 35.5649 46.143 36.3354 46.143 37.2846V42.6653C46.143 43.6152 45.3724 44.385 44.4224 44.385H39.0426C38.0926 44.385 37.3221 43.6152 37.3221 42.6653V37.2846C37.3221 36.3354 38.0926 35.5649 39.0426 35.5649ZM42.7027 39.0051H40.7623V40.9456H42.7027V39.0051ZM27.3098 35.5649H32.6905C33.6404 35.5649 34.4102 36.3354 34.4102 37.2846V42.6653C34.4102 43.6152 33.6404 44.385 32.6905 44.385H27.3098C26.3598 44.385 25.5901 43.6152 25.5901 42.6653V37.2846C25.5901 36.3354 26.3598 35.5649 27.3098 35.5649ZM30.9699 39.0051H29.0303V40.9456H30.9699V39.0051ZM15.5778 23.384H20.9585C21.9084 23.384 22.6782 24.1545 22.6782 25.1045V30.4843C22.6782 31.4343 21.9084 32.2049 20.9585 32.2049H15.5778C14.6278 32.2049 13.8581 31.4343 13.8581 30.4843V25.1045C13.8581 24.1545 14.6278 23.384 15.5778 23.384ZM19.2379 26.8242H17.2983V28.7646H19.2379V26.8242ZM39.0426 23.384H44.4224C45.3724 23.384 46.143 24.1545 46.143 25.1045V30.4843C46.143 31.4343 45.3724 32.2049 44.4224 32.2049H39.0426C38.0926 32.2049 37.3221 31.4343 37.3221 30.4843V25.1045C37.3221 24.1545 38.0926 23.384 39.0426 23.384ZM42.7027 26.8242H40.7623V28.7646H42.7027V26.8242ZM27.3098 23.384H32.6905C33.6404 23.384 34.4102 24.1545 34.4102 25.1045V30.4843C34.4102 31.4343 33.6404 32.2049 32.6905 32.2049H27.3098C26.3598 32.2049 25.5901 31.4343 25.5901 30.4843V25.1045C25.5901 24.1545 26.3598 23.384 27.3098 23.384ZM30.9699 26.8242H29.0303V28.7646H30.9699V26.8242ZM22.7534 15.7619H37.2477V4.01835H22.7534V15.7619ZM18.6427 15.7619H19.3132V12.1778H18.6427V15.7619ZM40.6879 15.7619H41.3576V12.1778H40.6879V15.7619Z"
            fill="#0E8CF1"
          />
        </svg>
      )

      break

    case "soluotthamgia":
      iconElement = (
        <svg
          width="45"
          height="45"
          viewBox="0 0 70 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.25 26.25C26.25 21.2917 30.0417 17.5 35 17.5C39.9583 17.5 43.75 21.2917 43.75 26.25C43.75 31.2083 39.9583 35 35 35C30.0417 35 26.25 31.2083 26.25 26.25ZM35 40.8333C21.5833 40.8333 17.5 50.4583 17.5 50.4583V55.4167H52.5V50.4583C52.5 50.4583 48.4167 40.8333 35 40.8333Z"
            fill="#0E8CF1"
          />
          <path
            d="M53.9596 32.0833C57.9867 32.0833 61.2513 28.8187 61.2513 24.7917C61.2513 20.7646 57.9867 17.5 53.9596 17.5C49.9326 17.5 46.668 20.7646 46.668 24.7917C46.668 28.8187 49.9326 32.0833 53.9596 32.0833Z"
            fill="#0E8CF1"
          />
          <path
            d="M53.9596 37.9141C50.4596 37.9141 47.8346 38.7891 45.793 40.2474C52.5013 43.4557 55.1263 48.9974 55.1263 49.5807V49.8724H67.0846V46.0807C67.0846 45.7891 63.8763 37.9141 53.9596 37.9141Z"
            fill="#0E8CF1"
          />
          <path
            d="M53.9596 32.0833C57.9867 32.0833 61.2513 28.8187 61.2513 24.7917C61.2513 20.7646 57.9867 17.5 53.9596 17.5C49.9326 17.5 46.668 20.7646 46.668 24.7917C46.668 28.8187 49.9326 32.0833 53.9596 32.0833Z"
            fill="#0E8CF1"
          />
          <path
            d="M53.9596 37.9141C50.4596 37.9141 47.8346 38.7891 45.793 40.2474C52.5013 43.4557 55.1263 48.9974 55.1263 49.5807V49.8724H67.0846V46.0807C67.0846 45.7891 63.8763 37.9141 53.9596 37.9141Z"
            fill="#0E8CF1"
          />
          <path
            d="M16.0417 32.0833C20.0687 32.0833 23.3333 28.8187 23.3333 24.7917C23.3333 20.7646 20.0687 17.5 16.0417 17.5C12.0146 17.5 8.75 20.7646 8.75 24.7917C8.75 28.8187 12.0146 32.0833 16.0417 32.0833Z"
            fill="#0E8CF1"
          />
          <path
            d="M16.043 37.9141C19.543 37.9141 22.168 38.7891 24.2096 40.2474C17.5013 43.4557 14.8763 48.9974 14.8763 49.5807V49.8724H2.91797V46.0807C2.91797 45.7891 6.1263 37.9141 16.043 37.9141Z"
            fill="#0E8CF1"
          />
        </svg>
      )

      break

    case "hethong":
      iconElement = (
        <svg
          width="45"
          height="45"
          viewBox="0 0 70 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_860_13752)">
            <path
              d="M54.8996 33.2766H36.1475V24.3125H33.8524V33.2766H15.1006C14.4669 33.2766 13.9531 33.7903 13.9531 34.4241V44.5358H16.2482V35.5717H53.7522V44.5358H56.0473V34.4241C56.0472 33.7903 55.5334 33.2766 54.8996 33.2766Z"
              fill="#FFD24D"
            />
            <path
              d="M39.7245 18.0469H30.2734V25.8408H39.7245V18.0469Z"
              fill="#8B7E7F"
            />
            <path
              d="M43.0122 26.9903H26.9912C26.3575 26.9903 25.8438 26.4766 25.8438 25.8428C25.8438 25.2088 26.3575 24.6953 26.9912 24.6953H43.0123C43.6463 24.6953 44.1598 25.209 44.1598 25.8428C44.1598 26.4766 43.646 26.9903 43.0122 26.9903Z"
              fill="#C2B8B9"
            />
            <path
              d="M49.5308 16.6417C49.5308 18.2649 48.215 19.5807 46.5917 19.5807H23.4078C21.7845 19.5807 20.4688 18.2649 20.4688 16.6417V2.93904C20.4688 1.31578 21.7845 0 23.4078 0H46.5917C48.215 0 49.5308 1.31578 49.5308 2.93904V16.6417Z"
              fill="#0E8CF1"
            />
            <path
              d="M59.623 61.0547H50.1719V68.8486H59.623V61.0547Z"
              fill="#8B7E7F"
            />
            <path
              d="M62.9108 69.9981H46.8897C46.256 69.9981 45.7422 69.4844 45.7422 68.8506C45.7422 68.2166 46.256 67.7031 46.8897 67.7031H62.9106C63.5446 67.7031 64.0581 68.2168 64.0581 68.8506C64.0583 69.4844 63.5445 69.9981 62.9108 69.9981Z"
              fill="#C2B8B9"
            />
            <path
              d="M69.4294 59.6494C69.4294 61.2726 68.1134 62.5884 66.4903 62.5884H43.3062C41.683 62.5884 40.3672 61.2726 40.3672 59.6494V45.9469C40.3672 44.3236 41.683 43.0078 43.3062 43.0078H66.4902C68.1134 43.0078 69.4292 44.3237 69.4292 45.9469L69.4294 59.6494Z"
              fill="#0E8CF1"
            />
            <path
              d="M19.8261 61.0547H10.375V68.8486H19.8261V61.0547Z"
              fill="#8B7E7F"
            />
            <path
              d="M23.11 69.9981H7.08889C6.4552 69.9981 5.94141 69.4844 5.94141 68.8506C5.94141 68.2166 6.4552 67.7031 7.08889 67.7031H23.11C23.744 67.7031 24.2575 68.2168 24.2575 68.8506C24.2575 69.4844 23.7438 69.9981 23.11 69.9981Z"
              fill="#C2B8B9"
            />
            <path
              d="M29.6323 59.6494C29.6323 61.2726 28.3166 62.5884 26.6933 62.5884H3.50936C1.88609 62.5884 0.570312 61.2726 0.570312 59.6494V45.9469C0.570312 44.3236 1.88609 43.0078 3.50936 43.0078H26.6933C28.3166 43.0078 29.6323 44.3237 29.6323 45.9469V59.6494Z"
              fill="#0E8CF1"
            />
          </g>
          <defs>
            <clipPath id="clip0_860_13752">
              <rect width="70" height="70" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )

      break

    case "solohongduocphathien":
      iconElement = (
        <svg
          width="45"
          height="45"
          viewBox="0 0 70 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            d="M35.2986 65.2378C51.7904 65.2378 65.1597 51.8686 65.1597 35.3767C65.1597 18.8849 51.7904 5.51562 35.2986 5.51562C18.8068 5.51562 5.4375 18.8849 5.4375 35.3767C5.4375 51.8686 18.8068 65.2378 35.2986 65.2378Z"
            fill="url(#paint0_radial_860_19777)"
          />
          <rect
            x="32.2227"
            width="11.1111"
            height="23.3333"
            fill="url(#pattern0)"
          />
          <rect
            y="17.7812"
            width="22.7778"
            height="15.5556"
            fill="url(#pattern1)"
          />
          <rect
            x="4.44531"
            y="43.8906"
            width="20.5556"
            height="20"
            fill="url(#pattern2)"
          />
          <rect
            x="38.332"
            y="45"
            width="18.8889"
            height="21.6667"
            fill="url(#pattern3)"
          />
          <rect
            x="46.1094"
            y="21.6641"
            width="23.3333"
            height="14.4444"
            fill="url(#pattern4)"
          />
          <rect
            x="17.7773"
            y="2.77344"
            width="16.1111"
            height="22.7778"
            fill="url(#pattern5)"
          />
          <rect
            y="32.7734"
            width="23.3333"
            height="11.6667"
            fill="url(#pattern6)"
          />
          <rect
            x="22.7773"
            y="46.6641"
            width="13.3333"
            height="23.3333"
            fill="url(#pattern7)"
          />
          <rect
            x="46.1094"
            y="35.5547"
            width="23.3333"
            height="15"
            fill="url(#pattern8)"
          />
          <rect
            x="39.4453"
            y="5.55469"
            width="18.3333"
            height="21.6667"
            fill="url(#pattern9)"
          />
          <rect
            x="34.4453"
            y="16.6719"
            width="7.22222"
            height="13.8889"
            fill="url(#pattern10)"
          />
          <rect
            x="18.3359"
            y="25.5625"
            width="13.3333"
            height="10"
            fill="url(#pattern11)"
          />
          <rect
            x="20.5586"
            y="37.7812"
            width="12.7778"
            height="11.6667"
            fill="url(#pattern12)"
          />
          <rect
            x="36.668"
            y="40.0078"
            width="10.5556"
            height="12.7778"
            fill="url(#pattern13)"
          />
          <rect
            x="40.0039"
            y="28.8906"
            width="13.8889"
            height="8.33333"
            fill="url(#pattern14)"
          />
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image0_860_19777"
                transform="scale(0.05 0.0238095)"
              />
            </pattern>
            <pattern
              id="pattern1"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image1_860_19777"
                transform="scale(0.0243902 0.0357143)"
              />
            </pattern>
            <pattern
              id="pattern2"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image2_860_19777"
                transform="scale(0.027027 0.0277778)"
              />
            </pattern>
            <pattern
              id="pattern3"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image3_860_19777"
                transform="scale(0.0294118 0.025641)"
              />
            </pattern>
            <pattern
              id="pattern4"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image4_860_19777"
                transform="scale(0.0238095 0.0384615)"
              />
            </pattern>
            <pattern
              id="pattern5"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image5_860_19777"
                transform="scale(0.0344828 0.0243902)"
              />
            </pattern>
            <pattern
              id="pattern6"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image6_860_19777"
                transform="scale(0.0238095 0.047619)"
              />
            </pattern>
            <pattern
              id="pattern7"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image7_860_19777"
                transform="scale(0.0416667 0.0238095)"
              />
            </pattern>
            <pattern
              id="pattern8"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image8_860_19777"
                transform="scale(0.0238095 0.037037)"
              />
            </pattern>
            <pattern
              id="pattern9"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image9_860_19777"
                transform="scale(0.030303 0.025641)"
              />
            </pattern>
            <pattern
              id="pattern10"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image10_860_19777"
                transform="scale(0.0769231 0.04)"
              />
            </pattern>
            <pattern
              id="pattern11"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image11_860_19777"
                transform="scale(0.0416667 0.0555556)"
              />
            </pattern>
            <pattern
              id="pattern12"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image12_860_19777"
                transform="scale(0.0434783 0.047619)"
              />
            </pattern>
            <pattern
              id="pattern13"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image13_860_19777"
                transform="scale(0.0526316 0.0434783)"
              />
            </pattern>
            <pattern
              id="pattern14"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image14_860_19777"
                transform="scale(0.04 0.0666667)"
              />
            </pattern>
            <radialGradient
              id="paint0_radial_860_19777"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(35.2974 35.3766) rotate(158.093) scale(29.8609)"
            >
              <stop />
              <stop offset="0.3601" stop-color="#000102" />
              <stop offset="0.5179" stop-color="#000309" />
              <stop offset="0.6362" stop-color="#000816" />
              <stop offset="0.7349" stop-color="#000E28" />
              <stop offset="0.8203" stop-color="#00173F" />
              <stop offset="0.885" stop-color="#001F56" />
              <stop offset="1" stop-color="#005FCF" />
            </radialGradient>
            <image
              id="image0_860_19777"
              width="20"
              height="42"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAqCAYAAACz+XvQAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABAdJREFUeNqkV7uOHEUUPTXd09PLjtn1Y+2VvcgYrQPAEpJFZiISUiJCfoCUHBEQIMFPkCCR8APOIEcWQhi0AViL2Md4dnYe3T39Kk7VrZ6Ht2dnZimppvpVp++55z56gHXHNz9ofPWdXnRbrQySpMDzv4GdTSDtc6cHDArgrTeBLz5VqwMaMDOOu8DTn4DXeRz/CwS3gb2HBLwP3ODFzz9RywErsGEM/Pwr8Nsz4PwXoIyA6+8Ab7wH3NoBPnwszxPUXwpmxgEtOj4DXh4A2QjQfMHpCRD9QUvpAs1HldjWWFmM/uDitbIE7u/OGbEcMKfjDw65mSsqo0NZbuyJZWrqueWAo7Gz8GT++oLAWQ44iOYRtHtBo3lFQEPZTAuWumAjWHhHjh/srgl4TlVHVLWIRU1rqZK14V3BwsNTWphzPxUteg5oS+61gvlnGYeNlej2uwL46ghI3ffWsDAaC6ABy87dRQcQMt3u3uIarEnZilEKVSs0rWqSsiHX4PQaE7rLAf86lnU8qnzgVHbBbIrCSqLM5nGUyFr0nSDXROWwfcU4NDk87pjEdVMJXTNub18B0BQA40Mbg6VQ9ZjLrRZ3qzn/LQc8Yrj0jp0o5XxNNkG90VrTwipkUGUIQyRkhdm6C1xjHdwI1gCsgtpQtZQL5z839+/V1vuLgF9/P1X46ESo5kdcWRj8HRHExqC6kCVm+LVBnHMOGS4JZ9qp1JkRR0t+K7UCYEFqKYH+fOEKQjxfVU0JM/RNluTZCoDjGYCzf2ZKlgM0dM2LdjdrXT8P+NmXGi/pr9eYBec9d7d8xUKet5oSn9FwCeDIdbZSC6BpmaoKG1/WcIP3WYXioY0itMLLKDtq3a4A6nKmDiqx1qprfE3QMVUusksAhwPZF9PxZ2zuOneUUylbJuVSWt1mPykoXD+5hPIHH2kcvZBQyH2hpDOZE/8VErlpJO5JKOD2zQWAutrE2T2Vxp71nJWQry1znNNCn/c6ZOBxu99cANhzAZyZlFOy2ZapYiavvGk7TT1xxdMfVT2gCVJDwSjcJ6UkEit11ZO1szaT2aOl3qI2eudehmgksWVAilw2T0RRrhW7a0k0zapaUdJkSDEooUoI2kaZCr0yJUwhHV01lU0301diChKrSzIlyzqcrksGMVJ2JY1txuDUJeU4gPZSNIO2ZZBlDQZ5WQ+oy+e0zictn9b6PA8ZsIfTglfuWYFshhQdeO0tnjcx6NV8tKvGE/6+PymehmphC+ojCaWZTPGYa01/39XB65ybGPYf1v0LeJvzd84n7pxf5DiZfBTBvnCbsdizMgbBI1sPg2AHo+HH6/ytYImGacSmarzrlDL5tk9fhgRt0z3f4n+Oqm3s1t38T4ABAITeyz5Tk9DnAAAAAElFTkSuQmCC"
            />
            <image
              id="image1_860_19777"
              width="41"
              height="28"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAcCAYAAAD815boAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABTdJREFUeNrMl7tvHFUUxs/szOx6/SROYhvsGEIMQUIoINJR0VAiKhp6+AOgoEGIgo4uiCL/AIgGBUEJpokEgaAgbBTHduI4fmTttb3e1+xjHvzunFnLiReTx9rOla7uzOydO9/9zne+c9eS+9sX30bSrn30riVH1Kx7wNUaIhEY066InZInBay1A3B1XWR6XmSlINLdLfLOGyKVmkhPl4hjHylYZ+dqYZY+JbIJk54nsromks2KnH9JpB/QI4OAz9wri0MCasUfMwCv/CSyHYrcuEKoTxDy44yA7DvJVtIiE+Mi5ya4RgZDT/GmdWisKpNuj8gWYV5eRJMA9VfoMGkPidQZMwCdaYrM8/sIz14YEznWJzJ6XKXQSrYDAqsg1ysA5YPRNk/4TlDmus4IqABNBnXtNuFuNlQKg8dExgD82hkFarR7QGA13LlNkas3RP78XbPbW2IMYDOvYAV2BRAWPQWDbr/IwLMa8j7AvoIMRpHIMDLoSndcBsrkMElxalikeg5dlmAWLTbJbA+G/EICFNAR1wHPhdDniwDincoGnXd6B2D1rMhpnrks259VZoNAJfTxe9bjMdlqP/4GI+hvDia3CXnOhJvwVrkPYDsCXOQz0XQ2YJ/UMfs0KzH2wqaDJJ7h/q3zvMO8rKvv+PQCkalVRS5+bj2aT7aaHyhLuS2R2QTsFot7sNiEseZ2IgPmiWeyDgnAogV7GVhMAXLwOWV+hPtxtH6KLmw2BGiNd+oAzd9l86z98yXr4SrO7hYSolmy3FShJYw+R1hXb/Nt2KzxgZAx2EjA1lU5xrrMkt1jGuIe9OoCOsNGhtnIKHruYl4DkFWS1Ut6GQJKbP7mdWt/M7+/pfDDs3wsCFVjJpNz9CUye8VWVjxHQxluqxSCu5pkJaRhk0Qh+k0Zppm/uSxyG6vrIbGG0KsTqu4bteR7zBk/E0m5WJRmfV1KxYm9TP7fAcPIYAXmChXVbMVTX/Vh2jPMwmYzlzhBS7dpdQOjV5cxxaYcw7itjPba8RTx68poox7QK/R18ZuT9Cm0fGF/PfwX4CLhWgDQHOyUWHxxVq2rghzCTU2mKHGBGLSjzJprU8UkUrDGwtKtnjJaLQGqBMhl/PgvEu9r7n95OFtop9tbgJ1Z1ERbnFEtNrkOYDosqhyisgIzYA2rFvQ5vcq+kZVJsm7Xh7kyGr+O7v9h7Q1AXsLCLj+ad7VjuOQpu5PYWBlZNCoKos6zsJRYV5Swm0qUZgBz7WbNpoqm9olrE+qGAfmDhMF37TX5uIALAJpHBnOwu3wHCeQ1QXwwBBVNpp0qtpOlUGlV0Oo6wH6FzWtM4twoHQK5G2wYqATqsLpByG8C8hZg13CE8po6gI+eQ09ZjoEaCxPQCxZhkZFiBH7NrLizhY6BNHU62qVVk72nsaxXnxd5ESsbwti7CKvt6kEllVZ9ioMObNBboI840EbsTObbm3kn26cXo7ieV5NeIXGKBWV3YQG9esZukEHVnAWM0TLB+huAMwnQC7v1kDoQkJ+9z5ngQys26JjZQJMmAydDnKBODGgZMb87mTL+2aqz7CCa3lNXDvTc/+UnVlyrm0ndjmMHWJs+QPXJEmpzFrWsPFk+R1zLyYEgfLCy2Kn2zVcqqTffjuITkCROZP6NZtJlTXlH8yeI/uC3yw9euzvdJr9XsC+/HsX12pRAc5QLwzuwO0W0p1QWbY4Rh/5Pf/qqRRUJARdRSr34mZFDEGA9e1k8GpCmLS/YsrbiwlyeUmj8MS9PfHPTH+z3878CDABe3IgtXQZ+BAAAAABJRU5ErkJggg=="
            />
            <image
              id="image2_860_19777"
              width="37"
              height="36"
              xlinkHref="data:image/png;base64,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"
            />
            <image
              id="image3_860_19777"
              width="34"
              height="39"
              xlinkHref="data:image/png;base64,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"
            />
            <image
              id="image4_860_19777"
              width="42"
              height="26"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAaCAYAAADBuc72AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABOVJREFUeNrMmMtvG1UUxr95eDx+ZeK4edZKaRsCagtUKFlViAVS/4QKCSGxZMmiiy75A0DiD+iCNWKPxA6hbhCIDVAJIrUpaZuH48SJ40c8D74z5yZOKyclapPU0vWduRnP/c33nXPunVg4689X3yUDx2/fsg6eWq8V3BGw1msDGUbAH4uAQ6RyUVshtw9rnSmgwK1uAmsN4OEy0AuBxjbH2c/PApUh4ML5FNY9dUCBa3UJSLh/V4F19o0msLMDNNeA3S2q2gF+fQLcvAmsPDlh658H3GpRtRXgwVPAdXhOsLU6sE3YmPBdKhr3+CAcS9hXysClt4Fbn6c/d0/c3j3APWsFrrZEGMJ1OJaEChZtmWOqDY8Ks/fGgJ9/Aj748CVBv7ybwGfA2zab0x+PYuARbVwkSJ0AyzUCr9NWQofb2hJeE9bkYgPHc/jaHKqZq1LlPFCaAtrdY4J++kUCh0D5kjaxTD6Jib32LrBUU3uXCbb6mNdQpXZN1Ypod2yaKIqeqifNGVGD/XE+dAYoMokuX+R5ltDZF4Bem0uQpWI+nyzgjULeWEBd3ijixCHBNqnY0gaTgv0jWlxj6zRN3PEYVDuqK1jMJMEB9Zwp/bs/yY4oASEd9oUC8P5bjNEJYKgwIOuD8u/IeG+wFdlcJJQqk+lX3FZTDzaZqR1O1uCkfz7kEOG7bcbVhqoWtUzM9bSlyoWqmE1bLT64yzqZKelvy1UVYP4KxeV8FwkYFJ5BU1DXvUGVPkMUbcJN+nbK5PIp8IYN1juHNqwQYIOA7TCNHbQFin1MdUM5XlWVUuUiY2sF+tAjaqtA+qyRObbhAHj3shb4UR7n/YGrk7sPleA+v2cQxzXsdsWK4TTuEtrV4QU76zppVyztqhJhV+EkGSTu0ht1zAx8KGfUxN2oggZV7YvDwJvTwHUChnSmUtKSdcQSqqBReI+OzrH9whtVabuoFaOxY8PzFUISxfE0TmUyqXlx21gbGWt5X2dcb5ubMlCj+juX7RyVrbLkXJ1WsCGGgGXh/2xKDsSoVaeC1yhKHbGVgRUX0e3Z2I2M4vzqNVU1SYykZQJXbOak9pCJPfbj75nr2PKMtXdmgImyWb/9F6o36NMHDXs1OJkF9GKHECOMxybjbojNVpjYlBRTksBYcwIddwjgnaN6VCuiwpMTCnqJqlY5HvABfO9YYIeDAj8wmWZhkSaJmwg7nCE+kFmW6amGxUltKpOtaOHOUq0CIXMEmqeaZcbctFhuP2vtMeEOAxV1HpOFqWkxxaMNMzi8b7FUM1HPZqJkCeNX9AFGqWCV6l1lcgQltVtWq5eEOwIUXFISRnosFaCqltsxwewUUlqurHA5wozR+iuMP0m4MSpY4pjvq8q3P36lG57nQe9xllkTgA3aRunsItysncJ5tDbHnwxT5CmuJoHUPU/h4lgB73xyIjuyQUvo34Q6z00GpbIC1tOnyLuTLC9uaqlAlgjoOX17BfKbOye6CR8E+huVZObHF5DNiq3XkXHTjQHyWQ3XPSSpt99+fSpvCYNAO4SMuKxK1j6Aa1e5DhdNCdNNgyT/j9+f6vvWYbsnidU57oA+YsmSXVIHHjcqPYIu/HUmb672IeMzsC2JvR0ur6uEDdFpbWHxn7N5vT5C0QUup/dhJy7ssInm1o2z/j/FfwIMAB354T7Q7s71AAAAAElFTkSuQmCC"
            />
            <image
              id="image5_860_19777"
              width="29"
              height="41"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAApCAYAAADJeCK0AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABThJREFUeNq8V0tvG1UU/mY8duI475CmcUIalAZBqaqKwhIk9kjsECvEP2BBhcSq24rHH0BiwQ5YsQIJCVUguisB1FBR4rZEeZCHPXH8GI89j8t35o47efHwQxxpPJ5778w33znnO/eMgaP24RcKm4+A0ASKDpAdAp69oOeuv26gT2YcA1z7HbBC4NbXQP55YOsAuHYZuHoxuaMP4Gb0+8HnCnsEKBWBb74EWk3g+6+AzXWu4BI/OO6NHs16/JC1TeDBH0DZBqp7gJrkIKe+W6G7eb661C/vxkzFWj6wXwcOXcDl4ZF1gy9i87jzG8frfWObgE6MEYRuxSAjPSBvQbfu6blGA3i0c9zNfQEVe+YKMPQkkJ6JgWnOEbbbpb6wTUAvUxrz08DYLMnOtH3OeJaBZlGztat0fauPTK0UdUl2s+fIMp2wVQQJBHBDs602+uzep+eBqVFgPA9knogHGeeQDFtlzXaLrD2/R9CjYs9mgEmCTlMuKSaUJWx5Vsxmv5awdZo9xdU8NfLUeWB0mHEleHqcK4Y1W0XJeGR8sA/89KAnN5unStso6+0cE2qKsbUIaOY027BC0EO9pkDGYdg1W/PMmmry7wSZDuRi4CwHA+3m6hYLBavW6nrXujXPHL20ACzNMbaz2sXGCAdTsXxirf5KF2/bXbE9Dtpmm+Lw3BQ1S7A0XZvKajfD00eFbOuM747dFdvTTNvAIp1lSmhs+sgk2QYHyeUvBSZWrWO25j/OLlIy56nXIWa0RXAjq6uU+yfjSrYOM3qDulWqDzFts5VMvihsZ06wtZPLlfu8jjP5/c9U70zFlphMeYIO8pwSV2e0bhvb3HspHYexXSnoahUGPbq3zTbHRHpukRKaPX5bIOWQ2exSvz+zSu3INV1/42PVO9M223keWdZkczxhK8WizgrlVHQmlw90fK9/pLoHbbOVHUhsaCQujcxspHVsDemhyHDlLrAuhYM6rlf6wFTslSu6Qg1Sv2YmvpVgzkPqdlOzFVDpsTx64a13VPegUmN9FoRBsp2jfIJm1K/ByOgONqROFedDvkD5UK93OFbjS7z2puoO9N03jChO0pa+uAwsLMZsc3FLw721JeyYvUVm9D0mlb2vQauHPbi35carKYkxadyEQJjMB8xih0A+120Q2Lb1PU0eL7ysTve9/8UarDzNhj5yvCXLncdNabZBoOuxV9I7kRwlznl1ncleq0umN9824MctyiQBF6Q0TsQbwYCuUip+eJNuPaB0avWkWFxYVp0zjVpRJkdARk1WIMFJm1HyJu9NgFZJtzmODPMlm+k46fgzk69id3ukM8l8ctOItjORRpoPGZZOMdQ6NVLxt5in1ypfx1zc67dCbgw+vxr8znXaZivm1jQTaeQsHoaVfABKuyoSO6R+yuUyGhRyGDC7VBHDo7c6c69YjRKQ2ArjNEFSJ7I4ohgIsAvFSU85PMvEQ77IDjVcg2W92vm35rWXFFxHZ3SFjCv870tv3PR1nyqPNOpIpdfo/kLUhUD9CMmEILhP1lWrY1BhKWXOowsNAmQMn2R3mTA5KJOZFG5E2RO0dqJ5z1/l9V2kLIkxKwdKnYO69bjUVQkWijvpSr9BVrt8KrPMKOiUVasEucM/t3Ws/TM+/zuxc3mXom8wM4tkV+UGXqPbviU42wxjjYC345XiVre7inTSoqQISiRUQavBmhfa1GKZL3CP/7cfs/vbz/9urOny4agSvEK3fcoEYXmC/W9gvblXbGDwPcqnQFC2hvgB/4uZ5qVub/1LgAEABJNp5W/GguAAAAAASUVORK5CYII="
            />
            <image
              id="image6_860_19777"
              width="42"
              height="21"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAVCAYAAAAw73wjAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABDlJREFUeNrMlsty1EYUhk9LGmk0MwzYGEwIVMxtxQYegAfgBXgJNix4AnapynNkkazzCKzYUFBkkVQwmAJsg8cz4xmNLq1u/tOnxQyOuQVMUFWrJfXlfP2f06cV0vd4Je1bZOoET1somj9F3wXY2fOGyqKmYjYlrR9RVT6hMFonXS2j9cX/C3rtuqXRgKiGYOCjMlfUiqGfTkkpdLBruN1run870Jt3LBUZ0XCHKJsQ7Q2JYnh3pqU9jALSucXTEbI2w7ui2gzJmkMG/flXC4MEdxLtvmbFGiBy3w0AqoKceoynQkVVHQIOL8Gy62/NVbzc/bqgv/xm33lnEFvLc416BmBdQdE9ohEUzfGcYcgQyuYTga+wgaqqIkXHQc5s6cddv9/wp15skFXZGUPJEdFgl2gCkM2XgIXrNcoUMTnblf7FiFcFLowrswATdN0iyRzFbelg0M+Fy0sY0lKXqLdgPICtAO689whtcF8FJQ3Uy6FcFCI2N1liUbtm92JcnZH435VEVkunQP9Avi2CfghSY9JpLmOGUGcIRUYo27u8S2E8kw3C8eZ2LMoYCmqMMaV8qxi0jXrsQTk0Cilzd/AL58/As512mwsWoncgG7cxFMv/dBs1vm0hjbyCoWkmYNav3o3CbbAucCrwNUr2zPeZzKFK5YGqA9TgsRYriXgQAO22V3hFQBkyA9hfz0UtBuJg5+B3G8II2HhzDsjFKWMk5vZf9SsOvvcdOygtmUO1/OL8gsmEvE6q2QtBz81vGZrWIwd294Eot/4YgT8SOPKA/FxsL0zmSz1oAtXXyqvSeK296FKfmpYEjNUN0W5QB+irjMQxl0BpCpGqat1FQwoPH5EYHcLgGUzwx++S84x3qdmZpxf3oVhw0aI6PoOwAMqDqoSaRE2tnqjfXpGNE+H0CRkMz6GVXBorHxpYdGB6pMupM1PrJbdonF6RU6SEYqsdoo2NBVc28Rb7Zyww7HrllMA4lTp844QtJerOQ6R7lFMO6ouYFyB9tLU40cO1Hd5QlaQsDkvOpVUs7wGMVTj7rXoJx2acUyM6fRYdwfsQx2qMietYlAyPieEGjBZ2dLIqkHEqfTgldfoC2ANMvydDVvFP0cF8bbSPAbKciJIFMsZ0JB7ko5RPrnbb2+XcBh5dYkK6jHl41S8iSjFxBFXSn9AJ6nYQuyUmSX/4N2D/BNRB34SNJ9Ls2lFd+BGJBOAnscCkJTmzOZXYpRW8OMWpNANwCdv8A5LP5scqn1ocOnES+vO/L3Yl9NTb9HT/b6Qj/P5tYHd3UoFjZfha7othLl204f/BpbE1KNtJ5lAHXaaW7MF51pU9KXsQYzKWzZtnvgD8nz/VQdNIHuXEfeUS/gtheHAOE/mNswoVUoDEAGlFAh8GHz6tbt9Qh/GPo774bD8ksPeDfirsNwL7vN+2/6ryIVxvBBgA+ygQnJvB0CkAAAAASUVORK5CYII="
            />
            <image
              id="image7_860_19777"
              width="24"
              height="42"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAqCAYAAACpxZteAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABN1JREFUeNq0V01z21QUvU96kmXHn4nrJI1J02lJNx0WbPkTrNjwC1ix6QwMG/4Aw5b/wI4/ABvYwQyLsoEydVu3JMEO8adkW9LjXL3nkYtTW0oHzbzY1ij33Hvuuec9Ef3Pl9j6RMH7lJTysH6kOCaKQhd3f8CqYg23/bvcCuA4DylWFVLxfYA8pijCTTVHbgf4PMOPn7Dwnc5uVkG5+of51k3+TiYjUtE5kYUf8WMTogewjnmOgf7E4krnMgNAE1lLmgU1itSALNmlWKAitcyxgj8jEvYVCdVN7qv45+wVHN9T5E9jkjKi6WxCU58onHEQZB3iAZsp65LtgE77CcWgUCLvOB7TYt7ZXMGD91TSWOYjVhY5qk5iEZIKkFhYxv0xcrRJiCZWj5xCmywRQAg9sgCM1DYDSEd/ugWEmhIFAatIrhQOQAvVeXEil4LnIpU5KbeNqns087/YDFBvckC0CoEnC5RtJcUk8ZXQ38m2yHZRnawnonSli6pFUvl4mEGmNh7xdoj8K8SDMASCqoVpH2iQRXCP1QBjwIEYJFn4fHXR2D4HJQQOESxANgp0RaA85sYqnb0F6gTuFwCwAwCB51zvtRDWRoDbd4luHSFR/NNCabrS0hBQJj2mMpRaAoCN7zuVjACffKkSFoqoYhwazldUzYE5++IuUQ1s1LEqWA6q+u0Xsd0qSsjEcXlysSLNtQTY/DwFcGq6uibEUCnq+zwHmSrgkr0S0QA98LGm8LXZ3yY4goqSbrqNjHf3QBPA9ttE338nspmdEBogtLQ8mW/FQ8cZFvRvF0mc3IGCGvr52TSHm3IFvq9laplmUqz7wMFtUOJB+gf77FdaWUkCeeya5f7ikpKhYROLAzNoAHdAiw2K7h0jGU8DfP3ZmrdZG20ixj/1MWDDC8wCN3duzA1xXNB3BAk3UAUPFnvPNdf1AF99q734RR9VQKJe9T/GawBOwb/rajpZcbl2tDBKqQlGK/mYeZgMiO4e6uZy9p9/LPIBTOD5T16axvFeDPsncC1byBhyfPg+Pgt6ejdcb+7BDB0eIvN/nkFNL/mGNrrlgjOTNMEffSSyAzD/ETJ+Bf5HA2NscUoPB2+AmvatTMeW6ytg3sc+mf0V9AyMPAFQgO6raGq19BYAE+j9+bkOPuuZ6eU991CbWRnB9xtb6VkHWMpziJHvY8AmfBoJ9MRZXsp/cl6yb1jBAtn2jSzDcbq5CLNF1sH9/Xba4MwAy+yZ9x6mdzow9gC7FqDFgn27oKXVzHU2Xa/Ahxw7f2G4YM8LPnoG6fR6ZT1nJ/s5AZbZ83VxpV002TxGOrANq3DhOcWqpoYHLEOD1ytga5iYjGd902BjDRLZl6CeB8eZ+V8H8OGWXexaQ6zIADH/wpwU6pVcwdcB2ODO+vrsmVxBeoKt38YEA+BOKyfAKv9JFUv+LzW+3NPTy/TsVd+ygqfmHcKHipQ5A/H2yJt7DT1o1XO/QllrSrjsGmsw/CcGt9ynvRsArBoc69+6xp5qh3p6q8X0XgaJvg7AViDx8/QUPoPpLTp6p+LN5eggfebGb5nc7F/xOhZCOR28AfXP9cmh+q4+AHz4Qe7s11+hHn2jaA6Ds0HX099hDaCmBVm+00qzzxH8ze9oXE0H1Zwg+0v40W71RsH5+leAAQCy5pcUK2ycXgAAAABJRU5ErkJggg=="
            />
            <image
              id="image8_860_19777"
              width="42"
              height="27"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAbCAYAAAAK5R1TAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABPhJREFUeNrMls1vG1UUxc+bGXvGdmLHsXHixClJG9KmCVnQQGkBCQSlYodUAWKDkOiaLgCxYMkGJDZI7FkgNvwJ/BMsECsqWlBLExqcxElqx54Pzp07SZwSt6Xky9LTvPHMvPd755177wN6/Wz7Io7Rz/T4/wWCzsNJzSKVnsR645WjBrV6P7FNDJlKT6My0sHouH/cQIfhOPMwZkY1Nx4sy1BhGzPnIsydj44L6BTCyEOEHKKoRlABi7CFl0rTGJcjXH4rOmrQgDK2EKLKiKKHrT7YKQdeRp+GwY69r1yN8P5H0VEEUxHGeg/GnkUYPkfALKzUONyMg75+oFwC8gUg7QJZ3ldGADcLeEn78po5LEXPcrsdhD5Joiz7VTYLPkXbaAELK8DtOrApynYz8bnrAZ9/G+GL7w9EYWcPhRnd1ljcjUIXQduiujQEt3yzA6ytA032+waAdoojcIizU7tH+eoHhf34bXMQW59ju8r2EtspNu6teVIXY7NL8Q3BbL5mZ7Vv+KjMNRVpidP8ZGIUGKQ17PvWvw/AZleSB+bpyTcZMBPsc/ZIIsjeeVVg7Ti+YKU1sLxhXUtxTBdTo2+nuL5p3jv2v2d8TGizbQFjvcrZn2Gif52Wq9Gb41SNfm2LITUZbNs6aaKoVUjuOVRmVPslQo5yAZO85xB4amRv6P8Abroq0TU46Vkm95d5M0wuLwYNEsBo69pJ+n7yeVptIKpa/TtDZk9ozh3l5vTnFNrj/fgQP3EeTLUHvEkOIFfoq3NMOxd4V0PKLaM/P4CVpooZRzgV8X0JMN53kk8lyBoJdHoniRj27UG1glcVEagyQYfKDEK6qUpXuVzcpKRq+5GATdxs58P4EJJ2J9nOIJ3uQ9pz4omsjALcI9QmgzmUVJRn9P9FaAL6Tb0KbLi6Yw+T0eHtkvpaWv+4lGTNv0WO4bmqdIUZpJB9IKwTJ8E4TiwmSpR5RQwp2+Z1JXPZ3oAvrhO4zlcLNbJR2c1mUs+YXNs5hQuWOOqGAvtBkjEIukq/WxynfQ+4w6nzFQrQUnXHKmqNU9XdfpZUR1g1i+9/HW8rmlJ1luO6vlUqBdKlOlJC5ZohTIcwa3y/zvfrnLTFyTpsHs8x9d8JScWat7QQBH8nvk6pZQTY50JsycPcgZU/6WfaZJGFpMBsssI87RJ4gl4u5B56Hu1KWjyACGCOgVKqiNrapBJZXKfPIRao3m+ccJXXexvq4/pNBQy5oPaSQofLSfZIKbDNjGE8VVnSnEPAPlolm1Xo08weT088Iuj9vw8+jZDhIIMVrUoCHZuIk61S3esEvn4baKzRJg2FFj/LDrUW1MvBcpLy/MTPUuFKmu6kmLglHfNF1p6Ls3GK+/8lTmq7QG6XfSrXJkAjgb55B1jitga+tvW7aoHWIq+yEDk4tBJgBpfFhYfcFY9qnnkeeI2wQ0Xs/2lnq87H3g/0MCPXn2mFW1R2mQcbn0HVWEyA+R86icqB9gVafDv3LHD+EgOthgM7lu0C7oYWtX/6FfiDoE0GY4MK+5uaNTbvarYQRcv07MmTwBvv0rf5AwTtBb1ljRZVvUHPNgn4yw2FXqZVipIxmCkGiTZDf1afAL75zBwOaC+Vu5UW6GmW3e9+VC8P0K8X5oATI3HSP1zQXrDd0FIApOjIGSPPPPrJO+bx0tNhAO/jOXb/oR8C/o8AAwBbEJinc66yIQAAAABJRU5ErkJggg=="
            />
            <image
              id="image9_860_19777"
              width="33"
              height="39"
              xlinkHref="data:image/png;base64,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"
            />
            <image
              id="image10_860_19777"
              width="13"
              height="25"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAZCAYAAADqrKTxAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAhdJREFUeNqUlD9P20AYxh/bcdMEI0iB0lKWDpEYGZD6ATqw0JW5qtRvwIfI0IUPwdK5UpnaiQGpAwsSqapCaNIWQnDcGtuJ/xzP+USahJyinvLqfL773fu8fxwDuvHuvUD9HHCbQOIDay+A2ltDbplaQI6oDzTrwO8W58vB+4IWOPoOfPgIeF8A+wnQeQSsV6H3NDxED8hS4M3W4FI99I2xBD/Uc2kVOD4bbOkhzx9dF20172wbkyGZALdNWREXD/grASsLUzy1PUqjpTSTgEPAKWmgu8y5lBZ3mYQEMBxmj9IsM5em9ySTIJgxxJRWARYqI9uToV+MJwn4QA8y7JXFKVBCD9c/GU+HkhhL5TlQfTYFOmFtsozyMrVt0uZnBvGMQrU9gSRWPRax1yBj4rnXr6jS0ngKfGUnbNCMMNg+pWVg/5B8MgL9a1jvOr8YqSyolGYpiY6lLrsHbW4LfD3iAWbJa6okSBHlMrDIjmidToB8T626geqCvLu41fvDUtFLOjsB6oVAeMP24Zyy7wTNpBeDyQhcvm+MQY+fxnCveIAB9X0F5DHRbEIe9+ziGBTc+DTqd5x8zju7UFAgMygvDIMxSGQHjGEG/l+Z2grXrGQyy3cPkYQCPpy8wEPD4qEGovATMhEg7cmqfqbGLgyrC1N00I8Eri6WhiFjrInmZMVoL+WnCJvpjvsbfN7Ff457/1i3AgwAXRfaoSCdNYwAAAAASUVORK5CYII="
            />
            <image
              id="image11_860_19777"
              width="24"
              height="18"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAASCAYAAABB7B6eAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAl9JREFUeNqslN1vS3EYxz+npy9e9s4MY1mYG1cjxAWJO3+CiP/BnYi/QVwQi5vd2AURbojYFq4kQ8yGpZPKzFKjjW2lW9eu2p72+B5na9cyaadP8uS8P9/f9+V3DNbX1Xt28fziWYM6lFE2PDgDXR3QvJ16AXmKwx/ehqGn7t37z2Ap9SerTTFwBiSSMNAH8z8hHYbGXmjthD274MyxEqNNsPG6PEzI7oD8tCC14OUXkGyCub0wo3snjsORgyU2NQAZxY8mpP/YB4h+EosvkJsDOy3wNgiITUs3nBTQ0R7we6tmZJTpbOVhXCuemIJIUEACLeScB2C2wpb90Cag0wLqPQCJuNvXLhvVAaxVRkNfic3LUck1K/miApJPSEpzJ+w7JTkz0CNmhyRtbgV+LKjnYWTY2DimlZXWkCGBhCbliYByUQdd7Vtl1A5bG2B3C7T7tRCFZDEm7yIWsW++coCNNpxTSX34ZAyC42KkxnZlcz43mxUVgfg1r0VtZLWwlEV6JUwq2fdvkyqBEpLi1iOIf4UVMcp/182sG0YjoEDo2KFQLMWmyVuPyWQGq4vbeiBL/rxWAN5JtvCoG2tLRpNffcG0MM0RefRAF9dr2zhX7toUNGhBXsS1+tBH9XtISXdLIbAdf2zFkOfqfufoqQng0jnjdyyzGTe+7drhh7ukfaM82OZ4ImM80o+36tmNTa6mzl+w+TzlpiaZ0G/GAV6epmDdxM6H9MZw6We3mbpzw8DKuueObGZ2kYDvDaansDa8ftXZbdHQFMEf6P/77/p/KxL2KpaDFAqTlY9+CTAABqT6E5yN0LkAAAAASUVORK5CYII="
            />
            <image
              id="image12_860_19777"
              width="23"
              height="21"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAVCAYAAACt4nWrAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAApZJREFUeNq0lM1LVFEYxn9n5jrfY4lhaZHZokQKUQsqJKhF9rEIClq4aeG/UOCudVC0bxUtKgoiWlQuSihyo5CU9kX2/YGmo6PONKN35vbcbjakWDpTBw537p1zfvd5n+e9B/7j8Je0Oxq/Cc5e8vky3T37d/Ca2lkMa8GEyOXe4OSH9XSidHjjDodgyIfjBEmlwti5Uf2u0T/vNSeLhx9qd8FCJCA5DemZDLnsOsgHVMWAVnwoDt7R6RCOwKePmmMw/hXsjN5kZ4Uqx5haZXBt+fBT5x15DGPj0PsUpnS1Nclp+qL4VY7xTYjYqoATbgW+JYFPX3J+XHuew91eyGRgZsSFSl4cAivBikSIRbYTUmWBYNvSlJ+56uAT5EaPtHyW8kGB3dzyAlZCuAJWCR6X5cFQANveKHuCzGRfWX8FJ6bg+gMFl4KRR3JBXhupLRM0vho2V+l+VtWkIaW1k+rG6ck97nZrUag7huXp5TvqXgX4TapzstJfLbVroK4OmtYLmBRM0w3EhU+MVcxhrEXB958ouH61m8DpQW+pJWhlAzRv0dwAWXk/iqf6YZeZj7IWQG2lf6Ubhh5LyZCsVbuZcq1U+TXNcPwgxIJ6Ls/96vMLZ81irprfwEn5evE2JPQdpF4IoDJ9MZ0hUru1BQ7vEvBng9k2dLabP0VmfoEH3kJ3H3zp97rBaJ+lwFZskgVNsK+lsOvEMbOUDvZs6XsJt7qk9p1Cc8FhiNRDtRQf2Am1VcsGe3C3I+51u6kIrPDKdExEFFaD1LZtk7/hosAePKajoVwvSL+WYgUVVYvVN3r+Wv6iwR48KmX7j3rnRUpfWVwBHmn1PC8BXOiWk+cc+tV2bbsXrigSXIDP7/USoXPjuwADALDA4fxsaW4fAAAAAElFTkSuQmCC"
            />
            <image
              id="image13_860_19777"
              width="19"
              height="23"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAXCAYAAADpwXTaAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAo5JREFUeNqclEtIVFEYx3/3zuOONjPOjOajtEJFspQmhYhCSiqQiFoULSIIWrQJahOt2rSPFq1btHHTrk0Q1SYwJFpMLnoYGipk5SN8lenM3P7nDpbFOA8/7rkznPud//19/+/cA4XjOE7FdUoMa4P5Do1j+AMdhCqOEnSCzE7tLCbmzzN3WOMIPucETrBN/2sJR/0SK4vMiBzU+KzpKxpJIrEw8bhfvxAIQGrQKoXslBZ/x7J347pXIRvXXIwV3W2lxGqgMlyUzMayquXNGcKRBzihc9iBJmHEvKcZFxYyucygAxevuYXJXHdGJrcqeRcJ480CLM2heQGuwuIPpYVga4PoIkXITCzO93omG28SCYFV6YkWZn9KVM+HZb5fZDUSvH3fLSxmYnzE8rxpa4d4vRZHwSfrVqZFKtrxuVyeU0FxMRMDTyyvvKS2WXS7FlZrUqX+moGXryCtZvrV1TsP3eJiJup3QIPKSe6T6aZcEWYklpZ3/c9K8Gx99N+zSNRB915oFmHINHcbLI/ArLbg2/FcXh46O+8r7t60iMivC33Q2SvBWk0u65LYc5WbyeYVtDdkvnUpt9tbRBUTnU+lr07CZAoeDfzNWydoFzThxnmLrhb5KLKQxEjr+qat8h6GPlFamf9H34Fcd33yMjsPc8Pw+p2EM//QWSWJmeTUKDx9AVOD2sjazNFu2LMfzvaUSWYi2axyRRcQnasTYEndHRuDN6NlihnvTJw+JMFOlaumpL/C9BB8mMCjLovMRNUW6FFplU3mGFF3JZh6/Mes0sXW6JLqbpMO4EiXStY37JPExJdNkK0JXj6pw6BR365OkgaN9kavsxabCdPd+SV9Wh+hVfuvps570W8BBgCEOqblSGsoIQAAAABJRU5ErkJggg=="
            />
            <image
              id="image14_860_19777"
              width="25"
              height="15"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAPCAYAAAARZmTlAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAi1JREFUeNqslE1vElEYhZ9hKN8tA9JSqQXRYrQaE6Mrv2L8BybGxK1x6dKfUX9BN679G6Y7Y1zophJNtKWWYrAUGcoA46EDEiqN0cxN7tyPuXPOec/7zjXwq629cifWzx8Zo6nhO/jxJrKgb+Culg0bPn+D8hZcPAMLqf+IZJpquwObAi1vw7YIGuotrQMBePoEzpY4OZLHz1zCYchf8NZzqfG7Zhs23kO1DpWvcNgUmYC7Nb3sKapDiOr8zh6kskOSeGIdI/CQ9LxFMi3A9BiwXtU6A+/KnhVb6vvaszX2ZI8rgn5Lo4iRKHMBIouQK8EHnbseOyK5heNAKFyTrxb9vpTp4x0p7IUE+An2fgpUQAdfZLBs6H0XqM7QVY8IeB6CcWFIfXoZFrV+cFt75u/Eb+DI15nQPQ72u9SbQUIJcCoeRqehxwD4h8a2F52ZG4Qv4VI8q3lY89NZuLYCRY2mOeF8cFgZN2h3KnSE2jdXsG2vWtzu0IYBz5yikNJYHixVjquIl5bg5mURpLxEn/CfjBL/hr5zVzkr6mu8Pqi9qFQJYOYUZC5xZOX9O1CQ75bUG8YfgNPaiOStlL8W+FVtSb5sNGOyIakukqJsOCf+1dK4yv4CPI3E88cMVxVEhljSIqq8FApKpCorlx9X3D+AHycZWXaFWHyV9KwSaimKkGddS9X18oXhzyUXia6TmPtIJuuwfN716+6c/OPb9iZxM0BtV+bv+nZB/xJgAJa5smLgA18GAAAAAElFTkSuQmCC"
            />
          </defs>
        </svg>
      )

      break

    case "doitancong":
      iconElement = (
        <svg
          width="45"
          height="45"
          viewBox="0 0 77 74"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M43.6289 50.4849L43.8517 50.617C48.7615 53.4721 55.0494 51.8052 57.9045 46.9036C60.7596 41.9938 59.0928 35.7059 54.1912 32.8508L53.9684 32.7188L43.6289 50.4849Z"
            fill="#ED1117"
          />
          <path
            d="M47.6326 72.0022C43.2344 71.8454 39.356 68.3054 38.1595 64.064C36.963 59.8226 38.1926 55.1355 40.7671 51.5625"
            fill="#ED1117"
          />
          <path
            d="M47.6326 72.0022C43.2344 71.8454 39.356 68.3054 38.1595 64.064C36.963 59.8226 38.1926 55.1355 40.7671 51.5625"
            stroke="#ED1117"
            stroke-width="2.7435"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M18.8086 63.1494C22.8272 62.2829 26.425 59.6012 28.3972 55.9869C30.3694 52.3726 30.6829 47.9 29.2306 44.0547"
            fill="#ED1117"
          />
          <path
            d="M18.8086 63.1494C22.8272 62.2829 26.425 59.6012 28.3972 55.9869C30.3694 52.3726 30.6829 47.9 29.2306 44.0547"
            stroke="#ED1117"
            stroke-width="2.7435"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M2 39.4358C5.00366 41.4905 8.23015 43.4297 11.8362 43.9413C16.3169 44.5767 21.0782 42.7778 24.0076 39.3203"
            fill="#ED1117"
          />
          <path
            d="M2 39.4358C5.00366 41.4905 8.23015 43.4297 11.8362 43.9413C16.3169 44.5767 21.0782 42.7778 24.0076 39.3203"
            stroke="#ED1117"
            stroke-width="2.7435"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M74.6385 25.5654C72.3198 21.8191 67.3357 20.1935 63.053 21.258C58.7786 22.3225 55.3046 25.7057 53.4727 29.7078"
            fill="#ED1117"
          />
          <path
            d="M74.6385 25.5654C72.3198 21.8191 67.3357 20.1935 63.053 21.258C58.7786 22.3225 55.3046 25.7057 53.4727 29.7078"
            stroke="#ED1117"
            stroke-width="2.7435"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M52.6913 4.89062C53.9291 8.81848 53.368 13.2662 51.206 16.765C49.0441 20.2637 45.306 22.7476 41.2461 23.3912"
            fill="#ED1117"
          />
          <path
            d="M52.6913 4.89062C53.9291 8.81848 53.368 13.2662 51.206 16.765C49.0441 20.2637 45.306 22.7476 41.2461 23.3912"
            stroke="#ED1117"
            stroke-width="2.7435"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M23.7773 2C27.0533 3.5926 30.3293 5.44103 32.5655 8.32091C35.3381 11.9022 36.1221 16.9275 34.5707 21.1854"
            fill="#ED1117"
          />
          <path
            d="M23.7773 2C27.0533 3.5926 30.3293 5.44103 32.5655 8.32091C35.3381 11.9022 36.1221 16.9275 34.5707 21.1854"
            stroke="#ED1117"
            stroke-width="2.7435"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M65.6777 41.8203C64.4399 43.3634 61.1392 42.8765 59.4311 42.827C57.7642 42.7775 56.1964 42.3567 54.5625 42.1587"
            fill="#ED1117"
          />
          <path
            d="M65.6777 41.8203C64.4399 43.3634 61.1392 42.8765 59.4311 42.827C57.7642 42.7775 56.1964 42.3567 54.5625 42.1587"
            stroke="#ED1117"
            stroke-width="2.7435"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M56.8011 57.0935C57.5272 55.2534 55.4725 52.6293 54.5813 51.1687C53.7149 49.7494 52.5762 48.5942 51.5859 47.2656"
            fill="#ED1117"
          />
          <path
            d="M56.8011 57.0935C57.5272 55.2534 55.4725 52.6293 54.5813 51.1687C53.7149 49.7494 52.5762 48.5942 51.5859 47.2656"
            stroke="#ED1117"
            stroke-width="2.7435"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M49.72 40.8107L57.2704 27.8305L42.1118 19.0176C34.7265 14.7267 25.3689 16.9465 20.6406 23.8945L49.72 40.8107Z"
            fill="#ED1117"
          />
          <path
            d="M48.556 42.799L19.4684 25.8828C15.7634 33.4332 18.4617 42.667 25.8471 46.9579L41.0056 55.7709L48.556 42.799Z"
            fill="#ED1117"
          />
        </svg>
      )

      break

    case "doiphongthu":
      iconElement = <svg></svg>
      break

    case "icon-delete-blue":
      iconElement = (
        <svg
          width="80"
          height="100"
          viewBox="0 0 80 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 9C0 7.89543 0.895431 7 2 7H40V17H2C0.895431 17 0 16.1046 0 15V9Z"
            fill="#3523FF"
          />
          <path
            d="M40 7H78C79.1046 7 80 7.89543 80 9V15C80 16.1046 79.1046 17 78 17H40V7Z"
            fill="#57A3FF"
          />
          <path
            d="M52.001 7C52.2799 7.14273 50.5929 0.00193134 48.5068 0.00227761C46.4207 0.00262387 40.001 0 40.001 0V6.99789L52.001 7Z"
            fill="#2387FF"
          />
          <path
            d="M28.0303 7C27.7514 7.14273 29.4383 0.00193134 31.5245 0.00227761C33.6106 0.00262387 40.0303 0 40.0303 0V6.99789L28.0303 7Z"
            fill="#1300F0"
          />
          <path
            d="M39.9987 17V99.9976C40.0007 99.9984 40.0007 99.9992 39.9987 100V99.9976C39.8066 99.924 21.9298 100 15.4996 100C9 100 5 17 5 17H39.9987Z"
            fill="#9EC4FF"
          />
          <path
            d="M40.0013 17V99.9976C39.9993 99.9984 39.9993 99.9992 40.0013 100V99.9976C40.1934 99.924 58.0702 100 64.5004 100C71 100 75 17 75 17H40.0013Z"
            fill="#DEEBFF"
          />
          <line
            x1="20.6903"
            y1="31.7253"
            x2="26.2303"
            y2="84.435"
            stroke="#0747A6"
            stroke-width="4"
            stroke-linecap="round"
          />
          <line
            x1="2"
            y1="-2"
            x2="55"
            y2="-2"
            transform="matrix(-0.104528 0.994522 0.994522 0.104528 60.957 30)"
            stroke="#0747A6"
            stroke-width="4"
            stroke-linecap="round"
          />
          <line
            x1="2"
            y1="-2"
            x2="55"
            y2="-2"
            transform="matrix(0 -1 -1 0 38 87)"
            stroke="#0747A6"
            stroke-width="4"
            stroke-linecap="round"
          />
        </svg>
      )
      break
    case "logo-vncert":
      iconElement = (
        <svg
          width="160"
          height="27"
          viewBox="0 0 224 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.7109 13.1199C37.7109 13.4699 37.7109 13.8099 37.7109 14.1599C37.7109 17.7999 37.7109 21.4499 37.7109 25.0899C37.7109 25.8899 37.7009 25.9099 36.8909 25.9099C35.0309 25.9199 33.1709 25.9199 31.3209 25.9099C30.4709 25.9099 30.4609 25.8999 30.4609 25.0099C30.4609 17.5399 30.4609 10.0699 30.4609 2.60987C30.4609 1.77987 30.4709 1.76987 31.2709 1.76987C33.1309 1.75987 34.9909 1.78987 36.8409 1.74987C37.4509 1.73987 37.8109 1.93987 38.1509 2.43987C40.7709 6.22987 43.4309 9.98987 46.0709 13.7699C46.2909 14.0899 46.5209 14.3999 46.7909 14.7599C47.0709 14.4399 46.9609 14.1099 46.9609 13.8199C46.9709 10.0999 46.9609 6.38987 46.9709 2.66987C46.9709 1.77987 46.9809 1.76987 47.8309 1.75987C49.7209 1.74987 51.6209 1.74987 53.5109 1.75987C54.2409 1.75987 54.2609 1.77987 54.2609 2.54987C54.2609 10.0899 54.2609 17.6299 54.2609 25.1699C54.2609 25.8899 54.2409 25.9099 53.4709 25.9099C51.5809 25.9199 49.6809 25.8799 47.7909 25.9299C47.1709 25.9399 46.8309 25.7099 46.4909 25.2199C43.8609 21.4399 41.2009 17.6699 38.5509 13.9099C38.3509 13.6199 38.1309 13.3399 37.9209 13.0499C37.8609 13.0699 37.7809 13.0999 37.7109 13.1199Z"
            fill="#0808CA"
            stroke="white"
            stroke-miterlimit="10"
          />
          <path
            d="M128.411 15.2397C128.521 15.3397 128.581 15.4397 128.671 15.4697C130.241 15.9797 131.241 17.1697 132.021 18.4897C133.411 20.8497 134.641 23.2997 135.951 25.7297C135.701 25.9797 135.441 25.9097 135.221 25.9097C132.861 25.9197 130.501 25.8897 128.151 25.9297C127.541 25.9397 127.201 25.7497 126.901 25.1997C125.721 22.9997 124.491 20.8297 123.261 18.6497C123.001 18.1797 122.711 17.7297 122.401 17.2997C121.781 16.4397 120.891 16.1697 119.871 16.1497C119.411 16.1397 119.241 16.3097 119.251 16.7697C119.271 18.0197 119.261 19.2697 119.261 20.5197C119.261 22.0597 119.271 23.5897 119.261 25.1297C119.261 25.8997 119.251 25.9197 118.521 25.9197C116.451 25.9297 114.381 25.9297 112.301 25.9197C111.551 25.9197 111.531 25.8997 111.531 25.1497C111.531 17.6097 111.531 10.0797 111.531 2.53973C111.531 1.78973 111.551 1.76973 112.311 1.76973C117.131 1.80973 121.951 1.65973 126.771 1.85973C127.661 1.89973 128.541 2.02972 129.411 2.25972C132.071 2.96972 133.791 5.05973 133.981 7.80973C134.231 11.3097 132.471 13.8897 129.131 14.9797C128.901 15.0497 128.671 15.1397 128.411 15.2397ZM119.261 9.09972C119.261 9.73972 119.271 10.3897 119.261 11.0297C119.251 11.3897 119.401 11.5497 119.761 11.5397C121.291 11.5197 122.831 11.6397 124.351 11.2697C125.591 10.9697 126.331 10.0897 126.281 8.92973C126.231 7.75973 125.531 7.01973 124.271 6.79973C122.781 6.53973 121.281 6.68973 119.781 6.65973C119.421 6.64973 119.271 6.80972 119.271 7.16972C119.261 7.80972 119.261 8.44972 119.261 9.09972Z"
            fill="#0808CA"
            stroke="white"
            stroke-miterlimit="10"
          />
          <path
            d="M86.3599 13.7898C86.3599 10.0698 86.3599 6.34977 86.3599 2.63977C86.3599 1.76977 86.3699 1.75977 87.2399 1.75977C93.5299 1.75977 99.8199 1.75977 106.12 1.75977C106.97 1.75977 106.97 1.77977 106.98 2.66977C106.99 3.77977 106.99 4.88977 106.98 5.98977C106.98 6.94977 106.97 6.94977 105.96 6.94977C102.53 6.94977 99.0999 6.94977 95.6599 6.94977C95.4499 6.94977 95.2299 6.94977 95.0199 6.94977C94.0199 6.94977 94.0899 6.88977 94.0899 7.87977C94.0899 8.58977 94.1299 9.30977 94.0799 10.0198C94.0399 10.6098 94.2899 10.7298 94.8199 10.7298C98.1099 10.7098 101.4 10.7198 104.69 10.7198C104.94 10.7198 105.19 10.7398 105.44 10.7198C105.93 10.6798 106.05 10.9198 106.04 11.3598C106.02 12.5398 106.04 13.7198 106.03 14.8998C106.02 15.6898 106.01 15.6998 105.17 15.7098C101.92 15.7198 98.6599 15.7098 95.4099 15.7098C94.0899 15.7098 94.0899 15.7098 94.0899 16.9998C94.0899 17.8198 94.0899 18.6398 94.0899 19.4698C94.0899 20.5098 94.0199 20.4198 95.0999 20.4198C98.2799 20.4198 101.46 20.4198 104.64 20.4198C105.35 20.4198 106.07 20.4298 106.78 20.4198C107.18 20.4098 107.36 20.5598 107.35 20.9798C107.33 22.4498 107.33 23.9098 107.35 25.3798C107.35 25.8198 107.14 25.9398 106.76 25.9198C106.55 25.9098 106.33 25.9198 106.12 25.9198C99.9399 25.9198 93.7499 25.9198 87.5699 25.9198C87.4299 25.9198 87.2799 25.9198 87.1399 25.9198C86.3799 25.8998 86.3699 25.8998 86.3599 25.1698C86.3499 23.4898 86.3599 21.8098 86.3599 20.1298C86.3599 18.0098 86.3599 15.8998 86.3599 13.7898Z"
            fill="#0808CA"
            stroke="white"
            stroke-miterlimit="10"
          />
          <path
            d="M189.48 16.0298C191.57 16.6398 193.58 17.2398 195.61 17.7998C196.13 17.9398 196.15 18.1798 196.03 18.6498C194.95 22.7898 191.85 25.5498 187.6 26.1398C185.31 26.4598 183.04 26.3898 180.78 25.9498C176.53 25.1198 173.91 22.4498 172.63 18.4498C171.62 15.2698 171.69 12.0198 172.68 8.83984C173.82 5.16984 176.38 2.86984 180.06 1.89984C183.01 1.11984 186.01 1.11984 188.97 1.86984C192.64 2.79984 194.72 5.33984 195.94 8.86984C193.79 9.33984 191.74 9.76984 189.69 10.2298C189.23 10.3298 189.08 10.1198 188.91 9.74984C187.96 7.67984 186.49 6.82984 184.21 6.98984C182.26 7.11984 180.68 8.37984 180.13 10.3898C179.45 12.8598 179.53 15.3498 180.23 17.7998C180.67 19.3398 181.75 20.2798 183.33 20.5698C186.21 21.1098 188.08 19.9698 188.96 17.5498C189.13 17.0898 189.28 16.6198 189.48 16.0298Z"
            fill="#FE0303"
            stroke="white"
            stroke-miterlimit="10"
          />
          <path
            d="M216.491 16.0297C218.711 16.6797 220.891 17.3197 223.121 17.9697C223.111 18.6997 222.831 19.3197 222.581 19.9297C221.121 23.4997 218.491 25.6097 214.651 26.1397C212.331 26.4597 210.021 26.3997 207.721 25.9397C203.551 25.1197 200.981 22.4897 199.681 18.5997C198.661 15.5497 198.711 12.3997 199.561 9.29968C200.581 5.55968 203.001 3.09968 206.731 2.01968C210.031 1.06968 213.371 1.05968 216.661 2.08968C219.981 3.12968 221.811 5.61968 222.941 8.78968C222.381 9.10968 221.801 9.12968 221.261 9.25968C219.801 9.58968 218.331 9.89968 216.871 10.2197C216.461 10.3097 216.181 10.3097 215.951 9.80968C214.951 7.62968 213.421 6.78968 211.071 7.00968C209.121 7.19968 207.591 8.53968 207.081 10.6597C206.511 13.0297 206.571 15.4197 207.241 17.7597C207.671 19.2897 208.721 20.2597 210.311 20.5697C213.181 21.1297 215.121 20.0197 216.011 17.5097C216.151 17.0397 216.311 16.5697 216.491 16.0297Z"
            fill="#FE0303"
            stroke="white"
            stroke-miterlimit="10"
          />
          <path
            d="M71.1517 1.36963C72.8017 1.36963 74.4217 1.52963 76.0117 2.03963C79.2017 3.05963 81.0717 5.35963 82.2517 8.35963C82.4117 8.76963 82.2917 8.91963 81.8717 9.00963C79.9817 9.39963 78.1017 9.80963 76.2217 10.2396C75.7317 10.3496 75.5517 10.1496 75.3617 9.71963C74.4917 7.75963 73.0317 6.89963 70.8417 6.98963C68.8917 7.06963 67.2517 8.21963 66.6817 10.1396C65.9017 12.7696 65.9517 15.4396 66.7817 18.0496C67.2117 19.4096 68.2217 20.2596 69.6217 20.5496C72.7717 21.1996 74.6617 19.9496 75.5917 17.1296C75.9517 16.0296 75.9617 16.0296 77.0717 16.3596C78.6417 16.8196 80.2217 17.2796 81.7917 17.7396C82.6717 17.9996 82.6717 18.0096 82.3817 18.9196C80.9917 23.3496 77.9717 25.7996 73.3517 26.2396C71.0617 26.4596 68.7817 26.3796 66.5417 25.7996C62.7517 24.8296 60.3717 22.2996 59.1617 18.6996C58.1017 15.5396 58.1317 12.2896 59.0617 9.09963C60.2917 4.86963 63.2717 2.53963 67.5017 1.65963C68.7217 1.41963 69.9317 1.36963 71.1517 1.36963Z"
            fill="#0808CA"
            stroke="white"
            stroke-miterlimit="10"
          />
          <path
            d="M1.08075 1.76C3.59075 1.76 6.05075 1.77 8.51075 1.75C9.06075 1.75 9.12075 2.11 9.25075 2.49C10.1508 5.31 11.0708 8.13 11.9808 10.95C12.7608 13.36 13.5408 15.77 14.3208 18.18C14.3907 18.38 14.4108 18.6 14.6908 18.78C14.9308 18.04 15.1708 17.32 15.4008 16.6C16.8908 11.94 18.3708 7.28 19.8507 2.63C20.1208 1.77 20.1307 1.77 21.0207 1.77C23.2707 1.77 25.5107 1.77 27.7108 1.77C27.9408 2.1 27.7408 2.32 27.6508 2.53C24.7808 10.07 21.8908 17.6 19.0308 25.14C18.8008 25.73 18.5207 25.95 17.8807 25.94C15.6307 25.9 13.3808 25.91 11.1208 25.94C10.5908 25.95 10.2908 25.83 10.0808 25.3C7.09075 17.58 4.09075 9.86 1.09075 2.14C1.06075 2.07 1.08075 1.99 1.08075 1.76Z"
            fill="#0808CA"
            stroke="white"
            stroke-miterlimit="10"
          />
          <path
            d="M144.37 25.9097C144.17 25.4597 144.25 25.0597 144.25 24.6797C144.24 19.5997 144.25 14.5297 144.25 9.4497C144.25 9.2397 144.25 9.0197 144.25 8.8097C144.24 7.7397 144.24 7.7397 143.21 7.72969C141.32 7.72969 139.42 7.72969 137.53 7.72969C137.18 7.72969 136.82 7.7897 136.4 7.6097C136.4 5.8397 136.41 4.05969 136.4 2.27969C136.4 1.91969 136.54 1.74969 136.9 1.75969C137.11 1.76969 137.33 1.75969 137.54 1.75969C144.58 1.75969 151.62 1.75969 158.66 1.75969C158.77 1.75969 158.87 1.75969 158.98 1.75969C159.76 1.77969 159.77 1.77969 159.77 2.50969C159.78 4.21969 159.77 5.92969 159.77 7.61969C159.27 7.80969 158.84 7.72969 158.42 7.72969C156.56 7.7397 154.7 7.7297 152.84 7.7397C151.98 7.7397 151.97 7.7497 151.97 8.6297C151.96 11.1297 151.97 13.6297 151.97 16.1397C151.97 19.1397 151.97 22.1397 151.97 25.1497C151.97 25.8997 151.95 25.9197 151.19 25.9197C148.91 25.9197 146.63 25.9097 144.37 25.9097Z"
            fill="#0808CA"
            stroke="white"
            stroke-miterlimit="10"
          />
          <path
            d="M160.711 26.3199C161.221 24.2299 161.691 22.2999 162.171 20.3599C163.661 14.3799 165.151 8.39986 166.641 2.40986C166.681 2.23986 166.761 2.06986 166.781 1.89986C166.821 1.50986 167.011 1.35986 167.411 1.35986C168.371 1.37986 169.331 1.36986 170.281 1.36986C170.511 1.73986 170.301 2.03986 170.231 2.31986C168.311 10.0299 166.391 17.7399 164.441 25.4499C164.171 26.4999 164.271 26.2999 163.311 26.3199C162.501 26.3299 161.681 26.3199 160.711 26.3199Z"
            fill="#FE0303"
            stroke="white"
            stroke-miterlimit="10"
          />
        </svg>
      )
      break
    case "camera":
      iconElement = (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12.5"
            cy="12.5"
            r="12"
            fill="#757779"
            fill-opacity="0.75"
            stroke="white"
          />
          <path
            d="M12.0833 15.7105C12.908 15.7105 13.609 15.422 14.1865 14.8449C14.7635 14.2675 15.0521 13.5664 15.0521 12.7418C15.0521 11.9171 14.7635 11.216 14.1865 10.6386C13.609 10.0615 12.908 9.773 12.0833 9.773C11.2587 9.773 10.5576 10.0615 9.98011 10.6386C9.40307 11.216 9.11456 11.9171 9.11456 12.7418C9.11456 13.5664 9.40307 14.2675 9.98011 14.8449C10.5576 15.422 11.2587 15.7105 12.0833 15.7105ZM6.80553 18.0195C6.44268 18.0195 6.13217 17.8904 5.874 17.6323C5.61539 17.3737 5.48608 17.0629 5.48608 16.7001V8.78342C5.48608 8.42057 5.61539 8.11006 5.874 7.85189C6.13217 7.59328 6.44268 7.46398 6.80553 7.46398H8.88365L10.1041 6.14453H14.0625L15.283 7.46398H17.3611C17.7239 7.46398 18.0347 7.59328 18.2933 7.85189C18.5514 8.11006 18.6805 8.42057 18.6805 8.78342V16.7001C18.6805 17.0629 18.5514 17.3737 18.2933 17.6323C18.0347 17.8904 17.7239 18.0195 17.3611 18.0195H6.80553Z"
            fill="white"
          />
        </svg>
      )
      break
    case "backup":
      iconElement = (
        <svg
          width="19"
          height="20"
          viewBox="0 0 19 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.0885 16.6303C13.8014 17.8126 12.1979 18.5946 10.4738 18.8808C8.74966 19.167 6.9795 18.945 5.37944 18.242C3.77938 17.5389 2.41865 16.3851 1.46337 14.9216C0.508092 13.458 -0.000391364 11.748 2.26006e-07 10.0003H1.5C1.49989 11.5109 1.95597 12.9864 2.80851 14.2335C3.66106 15.4806 4.87032 16.4412 6.27796 16.9894C7.6856 17.5377 9.226 17.6481 10.6975 17.3062C12.1689 16.9643 13.5028 16.186 14.5245 15.0733H12.345C12.1461 15.0733 11.9553 14.9943 11.8147 14.8536C11.674 14.713 11.595 14.5222 11.595 14.3233C11.595 14.1244 11.674 13.9336 11.8147 13.793C11.9553 13.6523 12.1461 13.5733 12.345 13.5733H15.8385C16.0374 13.5733 16.2282 13.6523 16.3688 13.793C16.5095 13.9336 16.5885 14.1244 16.5885 14.3233V17.8138C16.5885 18.0127 16.5095 18.2035 16.3688 18.3441C16.2282 18.4848 16.0374 18.5638 15.8385 18.5638C15.6396 18.5638 15.4488 18.4848 15.3082 18.3441C15.1675 18.2035 15.0885 18.0127 15.0885 17.8138V16.6288V16.6303ZM3.4755 4.9288H5.655C5.85391 4.9288 6.04468 5.00782 6.18533 5.14847C6.32598 5.28912 6.405 5.47989 6.405 5.6788C6.405 5.87771 6.32598 6.06848 6.18533 6.20913C6.04468 6.34978 5.85391 6.4288 5.655 6.4288H2.16C1.96109 6.4288 1.77032 6.34978 1.62967 6.20913C1.48902 6.06848 1.41 5.87771 1.41 5.6788V2.1853C1.41 1.98639 1.48902 1.79562 1.62967 1.65497C1.77032 1.51432 1.96109 1.4353 2.16 1.4353C2.35891 1.4353 2.54968 1.51432 2.69033 1.65497C2.83098 1.79562 2.91 1.98639 2.91 2.1853V3.3703C4.19693 2.1865 5.80084 1.40324 7.52571 1.11622C9.25059 0.829198 11.0217 1.05086 12.6227 1.75411C14.2236 2.45737 15.585 3.61175 16.5405 5.0762C17.496 6.54064 18.0042 8.25171 18.003 10.0003H16.503C16.5031 8.48945 16.047 7.01379 15.1942 5.76659C14.3415 4.51939 13.132 3.5588 11.7241 3.01065C10.3162 2.46251 8.77553 2.35235 7.30396 2.69461C5.83239 3.03688 4.4985 3.81561 3.477 4.9288H3.4755Z"
            fill="#01638D"
          />
        </svg>
      )
      break
    case "cloud":
      iconElement = (
        <svg
          width="24"
          height="16"
          viewBox="0 0 24 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.35 6.04C19.0141 4.33772 18.0976 2.80486 16.7571 1.70325C15.4165 0.601633 13.7351 -0.000392242 12 1.91737e-07C9.11 1.91737e-07 6.6 1.64 5.35 4.04C3.88023 4.19883 2.52101 4.89521 1.53349 5.99532C0.545971 7.09543 -0.000171702 8.52168 4.04928e-08 10C4.04928e-08 13.31 2.69 16 6 16H19C21.76 16 24 13.76 24 11C24 8.36 21.95 6.22 19.35 6.04ZM19 14H6C3.79 14 2 12.21 2 10C2 7.79 3.79 6 6 6H6.71C7.37 3.69 9.48 2 12 2C15.04 2 17.5 4.46 17.5 7.5V8H19C20.66 8 22 9.34 22 11C22 12.66 20.66 14 19 14Z"
            fill="#01638D"
          />
        </svg>
      )
      break
    case "block-tree":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.66667 8H4.4C4.29391 8 4.19217 8.04214 4.11716 8.11716C4.04214 8.19217 4 8.29391 4 8.4V12.9333C4 13.0394 4.04214 13.1412 4.11716 13.2162C4.19217 13.2912 4.29391 13.3333 4.4 13.3333H11.6C11.7061 13.3333 11.8078 13.2912 11.8828 13.2162C11.9579 13.1412 12 13.0394 12 12.9333V12.3333M6.754 2.92333C7.09133 2.76333 7.502 2.66667 8 2.66667C10.1333 2.66667 10.6667 4.44467 10.6667 5.33333V8H11.6C11.7061 8 11.8078 8.04214 11.8828 8.11716C11.9579 8.19217 12 8.29391 12 8.4V8.66667M5.33333 5.33333V8M2 2L14 14"
            stroke="#1574F6"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "user-header":
      iconElement = (
        <svg
          width="34"
          height="34"
          viewBox="0 0 34 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.9997 0.333008C7.79467 0.333008 0.333008 7.79467 0.333008 16.9997C0.333008 26.2047 7.79467 33.6663 16.9997 33.6663C26.2047 33.6663 33.6663 26.2047 33.6663 16.9997C33.6663 7.79467 26.2047 0.333008 16.9997 0.333008ZM11.1663 12.833C11.1663 12.067 11.3172 11.3084 11.6104 10.6007C11.9035 9.89296 12.3332 9.24989 12.8749 8.70822C13.4166 8.16654 14.0596 7.73686 14.7674 7.44371C15.4751 7.15056 16.2336 6.99967 16.9997 6.99967C17.7657 6.99967 18.5243 7.15056 19.232 7.44371C19.9397 7.73686 20.5828 8.16654 21.1245 8.70822C21.6661 9.24989 22.0958 9.89296 22.389 10.6007C22.6821 11.3084 22.833 12.067 22.833 12.833C22.833 14.3801 22.2184 15.8638 21.1245 16.9578C20.0305 18.0518 18.5468 18.6663 16.9997 18.6663C15.4526 18.6663 13.9688 18.0518 12.8749 16.9578C11.7809 15.8638 11.1663 14.3801 11.1663 12.833ZM27.4297 25.3063C26.1821 26.8757 24.596 28.1429 22.79 29.0133C20.9839 29.8838 19.0045 30.3349 16.9997 30.333C14.9948 30.3349 13.0154 29.8838 11.2094 29.0133C9.40334 28.1429 7.81728 26.8757 6.56967 25.3063C9.27134 23.368 12.958 21.9997 16.9997 21.9997C21.0413 21.9997 24.728 23.368 27.4297 25.3063Z"
            fill="white"
          />
        </svg>
      )
      break

    case "file-upload":
      iconElement = (
        <svg
          width="16"
          height="20"
          viewBox="0 0 16 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 0H2C0.9 0 0.0100002 0.9 0.0100002 2L0 18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6L10 0ZM2 18V2H9V7H14V18H2Z"
            fill="white"
          />
        </svg>
      )
      break
    case "icon-pdf":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.0751 1.55469L22.2481 5.90469V22.4467H6.6593V22.5007H22.3013V5.95944L18.0751 1.55469Z"
            fill="#909090"
          />
          <path
            d="M18.0232 1.5H6.60596V22.446H22.248V5.90475L18.0232 1.5Z"
            fill="#F4F4F4"
          />
          <path
            d="M6.49123 2.625H1.69873V7.74525H16.7737V2.625H6.49123Z"
            fill="#7A7B7C"
          />
          <path
            d="M16.854 7.65916H1.79626V2.53516H16.854V7.65916Z"
            fill="#DD2025"
          />
          <path
            d="M6.78897 3.40003H5.80872V7.00003H6.57972V5.78578L6.74997 5.79553C6.91539 5.79268 7.07927 5.76305 7.23522 5.70778C7.37194 5.66075 7.49772 5.58651 7.60497 5.48953C7.71409 5.39714 7.80013 5.28055 7.85622 5.14903C7.93144 4.9304 7.95831 4.69805 7.93497 4.46803C7.93028 4.30371 7.90147 4.14097 7.84947 3.98503C7.80212 3.87246 7.73186 3.77098 7.64315 3.68705C7.55444 3.60312 7.44923 3.53857 7.33422 3.49753C7.23477 3.46153 7.13203 3.4354 7.02747 3.41953C6.94829 3.40731 6.86833 3.40079 6.78822 3.40003M6.64647 5.12053H6.57972V4.01053H6.72447C6.78835 4.00592 6.85245 4.01573 6.91204 4.03922C6.97163 4.06272 7.02517 4.09931 7.06872 4.14628C7.15895 4.26704 7.20716 4.41403 7.20597 4.56478C7.20597 4.74928 7.20597 4.91653 7.03947 5.03428C6.91952 5.10025 6.78298 5.1307 6.64647 5.12053ZM9.39972 3.39028C9.31647 3.39028 9.23547 3.39628 9.17847 3.39853L8.99997 3.40303H8.41497V7.00303H9.10347C9.36658 7.01024 9.62855 6.96564 9.87447 6.87178C10.0724 6.79327 10.2477 6.66671 10.3845 6.50353C10.5175 6.33887 10.613 6.14716 10.6642 5.94178C10.7231 5.70918 10.7519 5.46996 10.7497 5.23003C10.7643 4.94665 10.7423 4.66257 10.6845 4.38478C10.6296 4.1803 10.5267 3.99185 10.3845 3.83503C10.2729 3.7084 10.1362 3.60626 9.98322 3.53503C9.8518 3.47422 9.71356 3.42939 9.57147 3.40153C9.51496 3.39219 9.45773 3.38793 9.40047 3.38878M9.26397 6.34153H9.18897V4.04353H9.19872C9.35334 4.02574 9.50978 4.05364 9.64872 4.12378C9.75046 4.20502 9.83337 4.30738 9.89172 4.42378C9.95468 4.54628 9.99098 4.68073 9.99822 4.81828C10.005 4.98328 9.99822 5.11828 9.99822 5.23003C10.0013 5.35876 9.99299 5.4875 9.97347 5.61478C9.95035 5.74545 9.90762 5.87188 9.84672 5.98978C9.77778 6.09939 9.68465 6.19176 9.57447 6.25978C9.48193 6.31963 9.37236 6.34755 9.26247 6.33928M13.0725 3.40303H11.25V7.00303H12.021V5.57503H12.996V4.90603H12.021V4.07203H13.071V3.40303"
            fill="#464648"
          />
          <path
            d="M16.3358 15.1921C16.3358 15.1921 18.7268 14.7586 18.7268 15.5754C18.7268 16.3921 17.2455 16.0599 16.3358 15.1921ZM14.568 15.2544C14.1881 15.3383 13.8179 15.4612 13.4633 15.6211L13.7633 14.9461C14.0633 14.2711 14.3745 13.3509 14.3745 13.3509C14.7325 13.9534 15.149 14.5191 15.618 15.0399C15.2643 15.0926 14.9138 15.1647 14.568 15.2559V15.2544ZM13.6215 10.3794C13.6215 9.66761 13.8518 9.47336 14.031 9.47336C14.2103 9.47336 14.412 9.55961 14.4188 10.1776C14.3604 10.799 14.2302 11.4116 14.031 12.0031C13.7581 11.5065 13.6169 10.9483 13.6208 10.3816L13.6215 10.3794ZM10.1348 18.2664C9.40126 17.8276 11.673 16.4769 12.0848 16.4334C12.0825 16.4341 10.9028 18.7254 10.1348 18.2664ZM19.425 15.6721C19.4175 15.5971 19.35 14.7669 17.8725 14.8021C17.2567 14.7922 16.6411 14.8356 16.0328 14.9319C15.4435 14.3382 14.936 13.6685 14.5238 12.9406C14.7835 12.1902 14.9406 11.4081 14.991 10.6156C14.9693 9.71561 14.754 9.19961 14.064 9.20711C13.374 9.21461 13.2735 9.81836 13.3643 10.7169C13.4532 11.3206 13.6208 11.9102 13.863 12.4704C13.863 12.4704 13.5443 13.4626 13.1228 14.4496C12.7013 15.4366 12.4133 15.9541 12.4133 15.9541C11.6803 16.1927 10.9903 16.5472 10.3695 17.0041C9.75151 17.5794 9.50026 18.0211 9.82576 18.4629C10.1063 18.8439 11.088 18.9301 11.9655 17.7804C12.4318 17.1865 12.8577 16.5621 13.2405 15.9114C13.2405 15.9114 14.5785 15.5446 14.9948 15.4441C15.411 15.3436 15.9143 15.2641 15.9143 15.2641C15.9143 15.2641 17.136 16.4934 18.3143 16.4499C19.4925 16.4064 19.4355 15.7456 19.428 15.6736"
            fill="#DD2025"
          />
          <path
            d="M17.9655 1.55859V5.96334H22.1902L17.9655 1.55859Z"
            fill="#909090"
          />
          <path d="M18.0232 1.5V5.90475H22.2479L18.0232 1.5Z" fill="#F4F4F4" />
          <path
            d="M6.73123 3.34339H5.75098V6.94339H6.52498V5.72989L6.69598 5.73964C6.8614 5.73679 7.02528 5.70716 7.18123 5.65189C7.31794 5.60484 7.44372 5.5306 7.55098 5.43364C7.65928 5.341 7.74453 5.22443 7.79998 5.09314C7.8752 4.87451 7.90207 4.64216 7.87873 4.41214C7.87404 4.24782 7.84523 4.08508 7.79323 3.92914C7.74588 3.81657 7.67562 3.71509 7.58691 3.63116C7.4982 3.54723 7.39299 3.48268 7.27798 3.44164C7.17808 3.40529 7.07482 3.37891 6.96973 3.36289C6.89055 3.35067 6.81059 3.34415 6.73048 3.34339M6.58873 5.06389H6.52198V3.95389H6.66748C6.73136 3.94928 6.79547 3.95909 6.85505 3.98258C6.91464 4.00608 6.96818 4.04267 7.01173 4.08964C7.10197 4.2104 7.15017 4.35739 7.14898 4.50814C7.14898 4.69264 7.14898 4.85989 6.98248 4.97764C6.86253 5.04361 6.72599 5.07331 6.58948 5.06314M9.34198 3.33364C9.25873 3.33364 9.17773 3.33964 9.12073 3.34189L8.94448 3.34639H8.35948V6.94639H9.04798C9.3111 6.9536 9.57306 6.909 9.81898 6.81514C10.0169 6.73663 10.1922 6.61007 10.329 6.44689C10.462 6.28223 10.5575 6.09052 10.6087 5.88514C10.6676 5.65254 10.6964 5.41332 10.6942 5.17339C10.7088 4.89001 10.6868 4.60593 10.629 4.32814C10.5741 4.12366 10.4712 3.93521 10.329 3.77839C10.2174 3.65176 10.0808 3.54961 9.92773 3.47839C9.79631 3.41758 9.65807 3.37275 9.51598 3.34489C9.45947 3.33555 9.40224 3.33129 9.34498 3.33214M9.20848 6.28489H9.13348V3.98689H9.14323C9.29785 3.9691 9.45429 3.997 9.59323 4.06714C9.69497 4.14838 9.77788 4.25074 9.83623 4.36714C9.89919 4.48964 9.93549 4.62409 9.94273 4.76164C9.94948 4.92664 9.94273 5.06164 9.94273 5.17339C9.94578 5.30212 9.9375 5.43086 9.91798 5.55814C9.89486 5.68881 9.85213 5.81524 9.79123 5.93314C9.72229 6.04275 9.62916 6.13512 9.51898 6.20314C9.42644 6.26299 9.31687 6.29091 9.20698 6.28264M13.0147 3.34639H11.1922V6.94639H11.9632V5.51839H12.9382V4.84939H11.9632V4.01539H13.0132V3.34639"
            fill="white"
          />
        </svg>
      )
      break
    case "icon-word":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.6045 2.25H7.27878C7.16138 2.2499 7.04511 2.27293 6.93661 2.31777C6.8281 2.3626 6.72949 2.42837 6.64641 2.51132C6.56332 2.59426 6.49739 2.69276 6.45237 2.80119C6.40735 2.90962 6.38413 3.02585 6.38403 3.14325V7.125L14.6858 9.5625L22.5 7.125V3.14325C22.4999 3.02579 22.4767 2.90949 22.4316 2.80102C22.3866 2.69254 22.3206 2.59401 22.2374 2.51105C22.1542 2.4281 22.0555 2.36234 21.9469 2.31755C21.8384 2.27276 21.722 2.2498 21.6045 2.25Z"
            fill="#41A5EE"
          />
          <path
            d="M22.5 7.125H6.38403V12L14.6858 13.4625L22.5 12V7.125Z"
            fill="#2B7CD3"
          />
          <path
            d="M6.38403 12V16.875L14.1975 17.85L22.5 16.875V12H6.38403Z"
            fill="#185ABD"
          />
          <path
            d="M7.27878 21.75H21.6038C21.7213 21.7503 21.8377 21.7274 21.9464 21.6827C22.0551 21.6379 22.1539 21.5722 22.2371 21.4892C22.3204 21.4062 22.3864 21.3077 22.4316 21.1992C22.4767 21.0906 22.4999 20.9743 22.5 20.8568V16.875H6.38403V20.8568C6.38413 20.9742 6.40735 21.0904 6.45237 21.1988C6.49739 21.3072 6.56332 21.4057 6.64641 21.4887C6.72949 21.5716 6.8281 21.6374 6.93661 21.6822C7.04511 21.7271 7.16138 21.7501 7.27878 21.75Z"
            fill="#103F91"
          />
          <path
            opacity="0.1"
            d="M12.3255 6.15039H6.38403V18.3379H12.3255C12.5623 18.3367 12.789 18.2423 12.9567 18.0751C13.1243 17.9079 13.2193 17.6814 13.221 17.4446V7.04364C13.2193 6.80689 13.1243 6.58038 12.9567 6.41318C12.789 6.24598 12.5623 6.15157 12.3255 6.15039Z"
            fill="black"
          />
          <path
            opacity="0.2"
            d="M11.8373 6.63672H6.38403V18.8242H11.8373C12.074 18.823 12.3008 18.7286 12.4684 18.5614C12.636 18.3942 12.731 18.1677 12.7328 17.931V7.52997C12.731 7.29322 12.636 7.06671 12.4684 6.89951C12.3008 6.73231 12.074 6.6379 11.8373 6.63672Z"
            fill="black"
          />
          <path
            opacity="0.2"
            d="M11.8373 6.63672H6.38403V17.8492H11.8373C12.074 17.848 12.3008 17.7536 12.4684 17.5864C12.636 17.4192 12.731 17.1927 12.7328 16.956V7.52997C12.731 7.29322 12.636 7.06671 12.4684 6.89951C12.3008 6.73231 12.074 6.6379 11.8373 6.63672Z"
            fill="black"
          />
          <path
            opacity="0.2"
            d="M11.349 6.63672H6.38403V17.8492H11.349C11.5858 17.848 11.8125 17.7536 11.9802 17.5864C12.1478 17.4192 12.2428 17.1927 12.2445 16.956V7.52997C12.2428 7.29322 12.1478 7.06671 11.9802 6.89951C11.8125 6.73231 11.5858 6.6379 11.349 6.63672Z"
            fill="black"
          />
          <path
            d="M2.3955 6.63672H11.349C11.5862 6.63652 11.8137 6.73049 11.9816 6.89799C12.1496 7.06549 12.2441 7.2928 12.2445 7.52997V16.4685C12.2441 16.7056 12.1496 16.933 11.9816 17.1004C11.8137 17.2679 11.5862 17.3619 11.349 17.3617H2.3955C2.27804 17.3619 2.16168 17.339 2.05309 17.2942C1.9445 17.2494 1.84581 17.1836 1.76264 17.1007C1.67948 17.0177 1.61348 16.9192 1.56841 16.8107C1.52334 16.7022 1.5001 16.5859 1.5 16.4685V7.52997C1.5001 7.41251 1.52334 7.29621 1.56841 7.18773C1.61348 7.07926 1.67948 6.98073 1.76264 6.89777C1.84581 6.81481 1.9445 6.74906 2.05309 6.70427C2.16168 6.65948 2.27804 6.63652 2.3955 6.63672Z"
            fill="url(#paint0_linear_1862_36458)"
          />
          <path
            d="M5.17496 13.4908C5.19221 13.6288 5.20421 13.7488 5.20946 13.8516H5.23046C5.23796 13.7541 5.25446 13.6363 5.27921 13.4991C5.30396 13.3618 5.32571 13.2456 5.34596 13.1503L6.28721 9.09509H7.50521L8.48021 13.0896C8.537 13.3367 8.57758 13.5872 8.60171 13.8396H8.61821C8.63612 13.5939 8.66994 13.3497 8.71946 13.1083L9.49871 9.08984H10.6065L9.23846 14.9008H7.94321L7.01546 11.0563C6.98846 10.9453 6.95796 10.8008 6.92396 10.6228C6.88996 10.4448 6.86896 10.3148 6.86096 10.2328H6.84521C6.83471 10.3273 6.81371 10.4676 6.78221 10.6536C6.75071 10.8403 6.72596 10.9776 6.70721 11.0676L5.83496 14.9031H4.51796L3.14246 9.09509H4.26746L5.11571 13.1586C5.14102 13.2683 5.1608 13.3792 5.17496 13.4908Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1862_36458"
              x1="3.3705"
              y1="5.93472"
              x2="10.374"
              y2="18.0637"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#2368C4" />
              <stop offset="0.5" stop-color="#1A5DBE" />
              <stop offset="1" stop-color="#1146AC" />
            </linearGradient>
          </defs>
        </svg>
      )
      break
    case "icon-excel":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.5858 3.30392H13.9882V1.51367L1.5 3.44117V20.3364L13.9882 22.4874V19.8339H21.5858C21.8158 19.8456 22.0412 19.7656 22.2125 19.6116C22.3839 19.4576 22.4872 19.242 22.5 19.0119V4.12517C22.487 3.89527 22.3836 3.67985 22.2123 3.52597C22.041 3.37209 21.8157 3.29226 21.5858 3.30392ZM21.7057 19.1484H13.9628L13.95 17.7317H15.8153V16.0817H13.9357L13.9268 15.1067H15.8153V13.4567H13.9125L13.9035 12.4817H15.8153V10.8317H13.8975V9.85667H15.8153V8.20667H13.8975V7.23167H15.8153V5.58167H13.8975V4.08167H21.7057V19.1484Z"
            fill="#20744A"
          />
          <path
            d="M16.8652 5.58008H20.1075V7.23008H16.8652V5.58008ZM16.8652 8.20583H20.1075V9.85583H16.8652V8.20583ZM16.8652 10.8316H20.1075V12.4816H16.8652V10.8316ZM16.8652 13.4573H20.1075V15.1073H16.8652V13.4573ZM16.8652 16.0831H20.1075V17.7331H16.8652V16.0831Z"
            fill="#20744A"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.76019 8.00433L6.36969 7.91208L7.38144 10.6938L8.57694 7.79733L10.1864 7.70508L8.23194 11.6546L10.1864 15.6138L8.48469 15.4991L7.33569 12.4811L6.18594 15.3843L4.62219 15.2463L6.43869 11.7491L4.76019 8.00433Z"
            fill="white"
          />
        </svg>
      )
      break
    case "arrow-right-circle":
      iconElement = (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.5 11C0.5 13.0767 1.11581 15.1068 2.26957 16.8335C3.42332 18.5602 5.0632 19.906 6.98182 20.7007C8.90045 21.4955 11.0116 21.7034 13.0484 21.2982C15.0852 20.8931 16.9562 19.8931 18.4246 18.4246C19.8931 16.9562 20.8931 15.0852 21.2982 13.0484C21.7034 11.0116 21.4955 8.90045 20.7007 6.98182C19.906 5.0632 18.5602 3.42332 16.8335 2.26957C15.1068 1.11581 13.0767 0.5 11 0.5C8.21523 0.5 5.54451 1.60625 3.57538 3.57538C1.60625 5.54451 0.5 8.21523 0.5 11ZM5 10.25H14.1125L9.9275 6.04475L11 5L17 11L11 17L9.9275 15.9298L14.1125 11.75H5V10.25Z"
            fill="#01638D"
          />
        </svg>
      )
      break
    case "arrow-left-circle":
      iconElement = (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.5 11C21.5 8.9233 20.8842 6.89323 19.7304 5.16651C18.5767 3.4398 16.9368 2.09398 15.0182 1.29926C13.0996 0.504545 10.9884 0.29661 8.95155 0.701756C6.91475 1.1069 5.04383 2.10693 3.57538 3.57538C2.10693 5.04383 1.1069 6.91475 0.701756 8.95155C0.29661 10.9884 0.504545 13.0996 1.29926 15.0182C2.09398 16.9368 3.4398 18.5767 5.16651 19.7304C6.89323 20.8842 8.9233 21.5 11 21.5C13.7848 21.5 16.4555 20.3938 18.4246 18.4246C20.3938 16.4555 21.5 13.7848 21.5 11ZM17 11.75L7.8875 11.75L12.0725 15.9553L11 17L5 11L11 5L12.0725 6.07025L7.8875 10.25L17 10.25V11.75Z"
            fill="#01638D"
          />
        </svg>
      )
      break
    case "reload-yellow":
      iconElement = (
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 4.05273V10.0527H7"
            stroke="#FFA800"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M23 20.0527V14.0527H17"
            stroke="#FFA800"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M20.49 9.05232C19.9828 7.61911 19.1209 6.33772 17.9845 5.32774C16.8482 4.31776 15.4745 3.61209 13.9917 3.27658C12.5089 2.94107 10.9652 2.98666 9.50481 3.4091C8.04437 3.83153 6.71475 4.61704 5.64 5.69232L1 10.0523M23 14.0523L18.36 18.4123C17.2853 19.4876 15.9556 20.2731 14.4952 20.6955C13.0348 21.118 11.4911 21.1636 10.0083 20.8281C8.52547 20.4926 7.1518 19.7869 6.01547 18.7769C4.87913 17.7669 4.01717 16.4855 3.51 15.0523"
            stroke="#FFA800"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "filter-close":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_236_25401)">
            <path
              d="M7.41 15.41L12 10.83L16.59 15.41L18 14L12 8L6 14L7.41 15.41Z"
              fill="#01638D"
            />
          </g>
          <defs>
            <clipPath id="clip0_236_25401">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "png":
      iconElement = (
        <svg
          width="17"
          height="20"
          viewBox="0 0 17 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8696 7.28832H15.412V5.08039C15.4117 5.06659 15.4103 5.05283 15.4079 5.03922C15.4087 4.95042 15.3773 4.86435 15.3195 4.79689L11.6455 0.600418L11.6428 0.597718C11.6208 0.573954 11.5958 0.553086 11.5686 0.535618L11.5443 0.520768C11.5209 0.507793 11.4962 0.497382 11.4707 0.489718L11.4504 0.482968C11.4224 0.475976 11.3936 0.47235 11.3647 0.472168H2.33522C1.9228 0.472168 1.588 0.807643 1.588 1.21939V7.28764H1.13035C0.5404 7.28764 0.0625 7.76554 0.0625 8.35549V13.9094C0.0625 14.4987 0.5404 14.9772 1.13035 14.9772H1.588V18.7788C1.588 19.1906 1.9228 19.5261 2.33522 19.5261H14.6648C15.0765 19.5261 15.412 19.1906 15.412 18.7788V14.9772H15.8696C16.4596 14.9772 16.9375 14.4993 16.9375 13.9094V8.35549C16.9375 7.76622 16.4589 7.28832 15.8696 7.28832ZM2.33522 1.22007H10.9908V5.04327C10.9908 5.24982 11.1581 5.41722 11.3647 5.41722H14.6655V7.28899H2.33522V1.22007ZM6.9124 12.3832V14.0268H5.77975V8.57014H7.22087L7.8412 9.66567L8.35353 10.5702C8.67685 11.1453 8.99275 11.8243 9.24385 12.4406H9.25938C9.18715 11.7204 9.16218 10.9833 9.16218 10.1577V8.57082H10.2955V14.0275H9.00085L8.51148 13.1439L7.84053 11.933L7.83512 11.9229C7.5118 11.3316 7.14663 10.6356 6.8881 9.99574H6.8557C6.8962 10.7234 6.9124 11.4929 6.9124 12.3832ZM2.29608 12.0673V14.0262H1.07365V8.64304C1.45368 8.57824 1.9876 8.52964 2.7409 8.52964C3.5023 8.52964 4.045 8.67544 4.40883 8.97514C4.76523 9.24177 4.99203 9.69537 4.99203 10.2293C4.99203 10.772 4.82193 11.2256 4.48983 11.5246C4.0693 11.9134 3.4456 12.0997 2.71727 12.0997C2.57614 12.1033 2.435 12.0925 2.29608 12.0673ZM14.6648 18.5777H2.33522V14.9779H14.6648V18.5777ZM15.9264 13.7757C15.5457 13.9053 14.8254 14.0835 14.1052 14.0835C13.1089 14.0835 12.3887 13.8324 11.8872 13.3552C11.3931 12.8773 11.1177 12.1645 11.1177 11.3633C11.1258 9.54957 12.4454 8.51344 14.2341 8.51344C14.9388 8.51344 15.4809 8.65114 15.7482 8.77264L15.489 9.76894C15.1893 9.63124 14.8254 9.53404 14.226 9.53404C13.198 9.53404 12.4123 10.1166 12.4123 11.2985C12.4123 12.4325 13.1251 13.0872 14.1369 13.0872C14.4116 13.0872 14.6385 13.0548 14.7363 13.015V11.8655H13.8939V10.9016H15.9264V13.7757Z"
            fill="#DD2025"
          />
        </svg>
      )
      break
    case "pdf":
      iconElement = (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.0874 1.81299L25.9559 6.88799V26.187H7.76904V26.25H26.018V6.95186L21.0874 1.81299Z"
            fill="#909090"
          />
          <path
            d="M21.0272 1.75H7.70703V26.187H25.956V6.88888L21.0272 1.75Z"
            fill="#F4F4F4"
          />
          <path
            d="M7.57318 3.0625H1.98193V9.03612H19.5694V3.0625H7.57318Z"
            fill="#7A7B7C"
          />
          <path
            d="M19.6631 8.93454H2.0957V2.95654H19.6631V8.93454Z"
            fill="#DD2025"
          />
          <path
            d="M7.92048 3.96735H6.77686V8.16735H7.67636V6.75073L7.87498 6.7621C8.06798 6.75878 8.25917 6.72421 8.44111 6.65973C8.60062 6.60486 8.74737 6.51824 8.87248 6.4051C8.99979 6.29732 9.10017 6.16129 9.16561 6.00785C9.25336 5.75279 9.28471 5.48171 9.25748 5.21335C9.25202 5.02164 9.21841 4.83178 9.15773 4.64985C9.10249 4.51852 9.02052 4.40013 8.91703 4.30221C8.81354 4.20429 8.69079 4.12899 8.55661 4.0811C8.44059 4.0391 8.32072 4.00862 8.19873 3.9901C8.10635 3.97585 8.01307 3.96824 7.91961 3.96735M7.75423 5.9746H7.67636V4.6796H7.84523C7.91976 4.67423 7.99455 4.68567 8.06407 4.71308C8.13358 4.74049 8.19605 4.78318 8.24686 4.83798C8.35213 4.97886 8.40838 5.15035 8.40698 5.32623C8.40698 5.54148 8.40698 5.7366 8.21273 5.87398C8.07279 5.95094 7.9135 5.98647 7.75423 5.9746ZM10.9664 3.95598C10.8692 3.95598 10.7747 3.96298 10.7082 3.9656L10.5 3.97085H9.81748V8.17085H10.6207C10.9277 8.17927 11.2333 8.12724 11.5202 8.01773C11.7512 7.92613 11.9556 7.77848 12.1152 7.5881C12.2704 7.396 12.3818 7.17233 12.4416 6.93273C12.5103 6.66136 12.5439 6.38228 12.5414 6.10235C12.5583 5.77174 12.5327 5.44032 12.4652 5.11623C12.4012 4.87767 12.2812 4.65781 12.1152 4.47485C11.985 4.32712 11.8256 4.20795 11.6471 4.12485C11.4938 4.0539 11.3325 4.00161 11.1667 3.9691C11.1008 3.95821 11.034 3.95323 10.9672 3.95423M10.808 7.3991H10.7205V4.7181H10.7319C10.9122 4.69735 11.0948 4.72989 11.2569 4.81173C11.3756 4.90651 11.4723 5.02593 11.5404 5.16173C11.6138 5.30464 11.6562 5.4615 11.6646 5.62198C11.6725 5.81448 11.6646 5.97198 11.6646 6.10235C11.6682 6.25253 11.6585 6.40274 11.6357 6.55123C11.6088 6.70368 11.5589 6.85117 11.4879 6.98873C11.4074 7.11661 11.2988 7.22437 11.1702 7.30373C11.0623 7.37355 10.9344 7.40612 10.8062 7.39648M15.2512 3.97085H13.125V8.17085H14.0245V6.50485H15.162V5.72435H14.0245V4.75135H15.2495V3.97085"
            fill="#464648"
          />
          <path
            d="M19.0586 17.7233C19.0586 17.7233 21.8481 17.2176 21.8481 18.1704C21.8481 19.1233 20.12 18.7357 19.0586 17.7233ZM16.9962 17.7959C16.553 17.8939 16.1211 18.0373 15.7073 18.2238L16.0573 17.4363C16.4073 16.6488 16.7705 15.5752 16.7705 15.5752C17.1881 16.2781 17.674 16.9381 18.2212 17.5457C17.8086 17.6072 17.3996 17.6913 16.9962 17.7977V17.7959ZM15.892 12.1084C15.892 11.2781 16.1606 11.0514 16.3697 11.0514C16.5788 11.0514 16.8142 11.1521 16.8221 11.8731C16.754 12.5981 16.6022 13.3127 16.3697 14.0028C16.0513 13.4234 15.8865 12.7722 15.8911 12.1111L15.892 12.1084ZM11.8241 21.3099C10.9683 20.7981 13.6187 19.2222 14.0991 19.1714C14.0965 19.1723 12.7201 21.8454 11.8241 21.3099ZM22.6627 18.2833C22.654 18.1958 22.5752 17.2272 20.8515 17.2683C20.133 17.2567 19.4148 17.3074 18.7051 17.4197C18.0176 16.727 17.4255 15.9458 16.9446 15.0966C17.2476 14.2211 17.4309 13.3087 17.4897 12.3841C17.4643 11.3341 17.2132 10.7321 16.4082 10.7408C15.6032 10.7496 15.486 11.4539 15.5918 12.5022C15.6956 13.2066 15.8912 13.8944 16.1737 14.5479C16.1737 14.5479 15.8018 15.7056 15.3101 16.8571C14.8183 18.0086 14.4823 18.6123 14.4823 18.6123C13.6272 18.8907 12.8222 19.3043 12.098 19.8373C11.377 20.5084 11.0838 21.0238 11.4636 21.5392C11.7908 21.9837 12.9362 22.0843 13.96 20.7429C14.5039 20.0501 15.0009 19.3217 15.4475 18.5624C15.4475 18.5624 17.0085 18.1346 17.4941 18.0173C17.9797 17.9001 18.5668 17.8073 18.5668 17.8073C18.5668 17.8073 19.9922 19.2414 21.3668 19.1907C22.7415 19.1399 22.675 18.3691 22.6662 18.2851"
            fill="#DD2025"
          />
          <path
            d="M20.96 1.81738V6.95626H25.8888L20.96 1.81738Z"
            fill="#909090"
          />
          <path
            d="M21.0273 1.75V6.88888H25.9562L21.0273 1.75Z"
            fill="#F4F4F4"
          />
          <path
            d="M7.8531 3.89997H6.70947V8.09997H7.61247V6.68422L7.81197 6.69559C8.00497 6.69227 8.19616 6.6577 8.3781 6.59322C8.5376 6.53833 8.68434 6.45172 8.80947 6.33859C8.93583 6.23052 9.03529 6.09451 9.09997 5.94134C9.18773 5.68628 9.21908 5.4152 9.19185 5.14684C9.18638 4.95514 9.15277 4.76528 9.0921 4.58334C9.03686 4.45201 8.95489 4.33362 8.8514 4.2357C8.7479 4.13778 8.62516 4.06248 8.49097 4.01459C8.37442 3.97218 8.25396 3.94141 8.13135 3.92272C8.03897 3.90846 7.94569 3.90086 7.85222 3.89997M7.68685 5.90722H7.60897V4.61222H7.77872C7.85326 4.60684 7.92804 4.61828 7.99756 4.6457C8.06708 4.67311 8.12954 4.71579 8.18035 4.77059C8.28563 4.91148 8.34187 5.08297 8.34047 5.25884C8.34047 5.47409 8.34047 5.66922 8.14622 5.80659C8.00628 5.88356 7.84699 5.91822 7.68772 5.90634M10.899 3.88859C10.8018 3.88859 10.7073 3.89559 10.6408 3.89822L10.4352 3.90347H9.75272V8.10347H10.556C10.8629 8.11188 11.1686 8.05985 11.4555 7.95034C11.6864 7.85875 11.8909 7.7111 12.0505 7.52072C12.2057 7.32862 12.3171 7.10495 12.3768 6.86534C12.4456 6.59398 12.4791 6.31489 12.4766 6.03497C12.4936 5.70436 12.468 5.37293 12.4005 5.04884C12.3364 4.81029 12.2164 4.59042 12.0505 4.40747C11.9203 4.25974 11.7609 4.14057 11.5823 4.05747C11.429 3.98652 11.2678 3.93423 11.102 3.90172C11.036 3.89083 10.9693 3.88585 10.9025 3.88684M10.7432 7.33172H10.6557V4.65072H10.6671C10.8475 4.62996 11.03 4.66251 11.1921 4.74434C11.3108 4.83913 11.4075 4.95854 11.4756 5.09434C11.5491 5.23726 11.5914 5.39412 11.5998 5.55459C11.6077 5.74709 11.5998 5.90459 11.5998 6.03497C11.6034 6.18515 11.5937 6.33535 11.571 6.48384C11.544 6.63629 11.4941 6.78379 11.4231 6.92134C11.3427 7.04923 11.234 7.15699 11.1055 7.23634C10.9975 7.30617 10.8697 7.33874 10.7415 7.32909M15.1838 3.90347H13.0576V8.10347H13.9571V6.43747H15.0946V5.65697H13.9571V4.68397H15.1821V3.90347"
            fill="white"
          />
        </svg>
      )
      break
    case "jpg":
      iconElement = (
        <svg
          width="19"
          height="21"
          viewBox="0 0 19 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.36799 9.55185C8.18129 9.54672 7.99471 9.56542 7.8128 9.6075V11.4219C7.92785 11.4503 8.06823 11.4587 8.26244 11.4587C8.9749 11.4587 9.41609 11.0849 9.41609 10.4559C9.41609 9.8889 9.03612 9.55185 8.36799 9.55185ZM17.8632 7.5117H17.3207L17.3492 5.5272C17.3458 5.41122 17.3009 5.30027 17.2225 5.2143L12.5615 0.1407C12.524 0.0981358 12.4782 0.0636821 12.4268 0.0394781C12.3754 0.0152741 12.3196 0.00183667 12.2628 0L2.50998 0C2.29131 0.00349236 2.08254 0.0912463 1.9276 0.244789C1.77266 0.398332 1.68365 0.605685 1.67931 0.8232V7.5117H1.13573C0.83491 7.5117 0.544649 7.6356 0.333549 7.8561C0.118164 8.0802 -0.00140664 8.3787 1.24892e-05 8.68875V14.8103C1.24892e-05 15.4592 0.508762 15.9862 1.13573 15.9862H1.67931V20.1758C1.6834 20.3938 1.77258 20.6017 1.928 20.7556C2.08341 20.9094 2.29288 20.997 2.51209 21H16.527C16.965 21 17.3503 20.6304 17.3503 20.1768V15.9873H17.8643C18.4912 15.9873 19 15.4592 19 14.8092V8.6877C19 8.3769 18.8807 8.0766 18.6675 7.8561C18.5641 7.74781 18.4397 7.66147 18.3018 7.60228C18.164 7.5431 18.0155 7.51228 17.8653 7.5117H17.8632ZM3.11373 1.4469H10.4558V6.25275C10.4554 6.36096 10.4969 6.46515 10.5719 6.5436C10.6082 6.58161 10.6519 6.61191 10.7004 6.63266C10.7488 6.65342 10.8009 6.66419 10.8537 6.66435H15.8768V7.5117H3.11373V1.4469ZM10.745 10.4192C10.745 11.0208 10.5508 11.5322 10.1993 11.8787C9.74119 12.326 9.06356 12.5265 8.27088 12.5265C8.09461 12.5265 7.93629 12.5171 7.8128 12.4992V14.6979H6.57787V8.631C6.99268 8.5575 7.47926 8.5029 8.29832 8.5029C9.12478 8.5029 9.7148 8.66775 10.1106 8.9964C10.4895 9.30615 10.7439 9.81645 10.7439 10.4192H10.745ZM2.52054 13.5303C2.70525 13.5933 2.94274 13.6395 3.20661 13.6395C3.77025 13.6395 4.12173 13.3749 4.12173 12.4173V8.5491H5.46009V12.4341C5.46009 14.1876 4.64947 14.7977 3.34699 14.7977C3.01608 14.7973 2.68706 14.7481 2.37066 14.6517L2.52054 13.5303ZM3.11373 19.5531V15.9862H15.8768V19.5531H3.11373ZM16.5544 14.4144C15.9165 14.6331 15.2479 14.7501 14.5732 14.7609C13.4914 14.7609 12.7082 14.4785 12.1625 13.9314C11.6168 13.4022 11.317 12.6 11.3255 11.696C11.335 9.65265 12.7694 8.48505 14.7147 8.48505C15.481 8.48505 16.071 8.6394 16.3613 8.78535L16.0794 9.89835C15.7533 9.7524 15.348 9.63375 14.6967 9.63375C13.579 9.63375 12.7335 10.291 12.7335 11.6235C12.7335 12.8909 13.4998 13.6395 14.6007 13.6395C14.9089 13.6395 15.1548 13.6028 15.2604 13.5482V12.2619H14.3453V11.1762H16.5544V14.4144ZM11.9176 1.596L12.324 2.0517L15.0472 5.04735L15.1981 5.229H12.4148C12.2037 5.229 12.0717 5.19435 12.0158 5.124C11.9598 5.05575 11.9271 4.9455 11.9176 4.79535V1.596Z"
            fill="#DD2025"
          />
        </svg>
      )
      break
    case "import-cloud":
      iconElement = (
        <svg
          width="36"
          height="29"
          viewBox="0 0 36 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.1982 11.84C29.4098 11.1296 29.6214 10.4192 29.6214 9.472C29.6214 4.2624 25.8129 0 21.1581 0C17.9844 0 15.0223 2.1312 13.7528 5.2096C13.118 4.9728 12.2717 4.736 11.637 4.736C8.67483 4.736 6.34743 7.3408 6.34743 10.656C6.34743 11.1296 6.34743 11.6032 6.55901 11.84C2.75055 12.5504 0 15.8656 0 20.128C0 24.6272 3.3853 28.416 7.40534 28.416H14.8107V21.312H8.46324L17.9844 10.656L27.5055 21.312H21.1581V28.416H28.5634C32.5835 28.416 35.9688 24.6272 35.9688 20.128C35.9688 15.8656 33.0067 12.3136 29.1982 11.84Z"
            fill="#01638D"
          />
        </svg>
      )
      break
    case "export":
      iconElement = (
        <svg
          width="71"
          height="69"
          viewBox="0 0 71 69"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.8335 10.0625L59.1668 10.0625C62.421 10.0625 65.0835 12.65 65.0835 15.8125V50.3125C65.0835 53.475 62.421 56.0625 59.1668 56.0625H11.8335C8.57933 56.0625 5.91682 53.475 5.91682 50.3125V15.8125C5.91682 12.65 8.57933 10.0625 11.8335 10.0625Z"
            fill="#C5DDFD"
          />
          <path
            d="M36.5 65.3813L23.1875 50H49.8125L36.5 65.3813Z"
            fill="#3689FC"
          />
          <path
            d="M40.9375 24.125V57.1875H32.0625V24.125H40.9375Z"
            fill="#3689FC"
          />
        </svg>
      )
      break
    case "warning-denied":
      iconElement = (
        <svg
          width="84"
          height="84"
          viewBox="0 0 84 84"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M41.9999 0.333496C18.9583 0.333496 0.333252 18.9585 0.333252 42.0002C0.333252 65.0418 18.9583 83.6668 41.9999 83.6668C65.0416 83.6668 83.6666 65.0418 83.6666 42.0002C83.6666 18.9585 65.0416 0.333496 41.9999 0.333496ZM41.9999 75.3335C23.6249 75.3335 8.66658 60.3752 8.66658 42.0002C8.66658 23.6252 23.6249 8.66683 41.9999 8.66683C60.3749 8.66683 75.3332 23.6252 75.3332 42.0002C75.3332 60.3752 60.3749 75.3335 41.9999 75.3335ZM56.9583 21.1668L41.9999 36.1252L27.0416 21.1668L21.1666 27.0418L36.1249 42.0002L21.1666 56.9585L27.0416 62.8335L41.9999 47.8752L56.9583 62.8335L62.8332 56.9585L47.8749 42.0002L62.8332 27.0418L56.9583 21.1668Z"
            fill="#FF6569"
          />
        </svg>
      )
      break
    case "solid-warning":
      iconElement = (
        <svg
          width="92"
          height="80"
          viewBox="0 0 92 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.166626 79.5002H91.8333L46 0.333496L0.166626 79.5002ZM50.1666 67.0002H41.8333V58.6668H50.1666V67.0002ZM50.1666 50.3335H41.8333V33.6668H50.1666V50.3335Z"
            fill="#FFA800"
          />
        </svg>
      )
      break
    case "solid-folder":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 6H11L9 4H4C2.9 4 2 4.9 2 6V10H22V8C22 6.9 21.1 6 20 6Z"
            fill="#FFA000"
          />
          <path
            d="M20 6H4C2.9 6 2 6.9 2 8V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6Z"
            fill="#FFCA28"
          />
        </svg>
      )
      break
    case "thumb-up":
      iconElement = (
        <svg
          width="22"
          height="20"
          viewBox="0 0 22 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 20H17C17.83 20 18.54 19.5 18.84 18.78L21.86 11.73C21.95 11.5 22 11.26 22 11V9C22 7.9 21.1 7 20 7H13.69L14.64 2.43L14.67 2.11C14.67 1.7 14.5 1.32 14.23 1.05L13.17 0L6.58 6.59C6.22 6.95 6 7.45 6 8V18C6 19.1 6.9 20 8 20ZM8 8L12.34 3.66L11 9H20V11L17 18H8V8ZM0 8H4V20H0V8Z"
            fill="#01638D"
          />
        </svg>
      )
      break
    case "red-x":
      iconElement = (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
            fill="#CE3135"
          />
        </svg>
      )
      break

    case "upload":
      iconElement = (
        <svg
          width="16"
          height="20"
          viewBox="0 0 16 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 0H2C0.9 0 0.0100002 0.9 0.0100002 2L0 18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6L10 0ZM2 18V2H9V7H14V18H2Z"
            fill="white"
          />
        </svg>
      )
      break
    case "close-blue-outline":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_389_44468)">
            <mask
              id="mask0_389_44468"
              style={{ maskType: "luminance" }}
              maskUnits={"userSpaceOnUse"}
              x="0"
              y="0"
              width="16"
              height="16"
            >
              <path
                d="M7.99998 14.6668C11.682 14.6668 14.6666 11.6822 14.6666 8.00016C14.6666 4.31816 11.682 1.3335 7.99998 1.3335C4.31798 1.3335 1.33331 4.31816 1.33331 8.00016C1.33331 11.6822 4.31798 14.6668 7.99998 14.6668Z"
                fill="white"
                stroke="white"
                stroke-width="2"
                stroke-linejoin="round"
              />
              <path
                d="M9.88565 6.11426L6.11432 9.88559M6.11432 6.11426L9.88565 9.88559"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </mask>
            <g mask="url(#mask0_389_44468)">
              <path d="M0 0H16V16H0V0Z" fill="#3699FF" />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_389_44468">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "close-blue-circle":
      iconElement = (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 1.375C5.6375 1.375 1.375 5.6375 1.375 11C1.375 16.3625 5.6375 20.625 11 20.625C16.3625 20.625 20.625 16.3625 20.625 11C20.625 5.6375 16.3625 1.375 11 1.375ZM11 19.25C6.4625 19.25 2.75 15.5375 2.75 11C2.75 6.4625 6.4625 2.75 11 2.75C15.5375 2.75 19.25 6.4625 19.25 11C19.25 15.5375 15.5375 19.25 11 19.25Z"
            fill="#01638D"
          />
          <path
            d="M14.7125 15.8125L11 12.1L7.2875 15.8125L6.1875 14.7125L9.9 11L6.1875 7.2875L7.2875 6.1875L11 9.9L14.7125 6.1875L15.8125 7.2875L12.1 11L15.8125 14.7125L14.7125 15.8125Z"
            fill="#01638D"
          />
        </svg>
      )
      break
    case "check-blue-circle":
      iconElement = (
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.7031 10.4844C17.0469 13.7656 14.5728 16.8552 11.1013 17.5456C9.40813 17.8828 7.65177 17.6772 6.08227 16.9581C4.51278 16.2391 3.21015 15.0431 2.35988 13.5406C1.50961 12.0382 1.15504 10.3057 1.34665 8.59001C1.53827 6.87429 2.2663 5.26276 3.42708 3.98487C5.80796 1.3625 9.82814 0.640624 13.1094 1.95312"
            stroke="#1574F6"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.54688 9.17188L9.82812 12.4531L17.7031 3.92188"
            stroke="#1574F6"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "view-blue":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_236_23755)">
            <path
              d="M12 6.5C15.79 6.5 19.17 8.63 20.82 12C19.17 15.37 15.8 17.5 12 17.5C8.2 17.5 4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5ZM12 7.5C9.52 7.5 7.5 9.52 7.5 12C7.5 14.48 9.52 16.5 12 16.5C14.48 16.5 16.5 14.48 16.5 12C16.5 9.52 14.48 7.5 12 7.5Z"
              fill="#1574F6"
            />
          </g>
          <defs>
            <clipPath id="clip0_236_23755">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "like-blue":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_241_24170)">
            <path
              d="M9 21H18C18.83 21 19.54 20.5 19.84 19.78L22.86 12.73C22.95 12.5 23 12.26 23 12V10C23 8.9 22.1 8 21 8H14.69L15.64 3.43L15.67 3.11C15.67 2.7 15.5 2.32 15.23 2.05L14.17 1L7.58 7.59C7.22 7.95 7 8.45 7 9V19C7 20.1 7.9 21 9 21ZM9 9L13.34 4.66L12 10H21V12L18 19H9V9ZM1 9H5V21H1V9Z"
              fill="#01638D"
            />
          </g>
          <defs>
            <clipPath id="clip0_241_24170">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "delete-profile":
      iconElement = (
        <svg
          width="100"
          height="100"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_368_44812)">
            <path d="M0 0H100V100H0V0Z" fill="white" />
            <path
              d="M66.6666 37.5V79.1667H33.3333V37.5H66.6666ZM60.4166 12.5H39.5833L35.4166 16.6667H20.8333V25H79.1666V16.6667H64.5833L60.4166 12.5ZM74.9999 29.1667H24.9999V79.1667C24.9999 83.75 28.7499 87.5 33.3333 87.5H66.6666C71.2499 87.5 74.9999 83.75 74.9999 79.1667V29.1667Z"
              fill="#FF6569"
            />
          </g>
          <defs>
            <clipPath id="clip0_368_44812">
              <rect width="100" height="100" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "company-blue":
      iconElement = (
        <svg
          width="20"
          height="14"
          viewBox="0 0 20 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.49705 12.602C3.59199 12.5969 3.68697 12.6113 3.77619 12.6441C3.86542 12.6769 3.94702 12.7276 4.01602 12.793C4.08502 12.8584 4.13998 12.9372 4.17753 13.0245C4.21509 13.1119 4.23445 13.2059 4.23445 13.301C4.23445 13.3961 4.21509 13.4902 4.17753 13.5775C4.13998 13.6649 4.08502 13.7436 4.01602 13.8091C3.94702 13.8745 3.86542 13.9251 3.77619 13.958C3.68697 13.9908 3.59199 14.0051 3.49705 14H0.70005C0.60511 14.0051 0.510131 13.9908 0.420906 13.958C0.33168 13.9251 0.250078 13.8745 0.181077 13.8091C0.112076 13.7436 0.0571228 13.6649 0.0195686 13.5775C-0.0179857 13.4902 -0.0373535 13.3961 -0.0373535 13.301C-0.0373535 13.2059 -0.0179857 13.1119 0.0195686 13.0245C0.0571228 12.9372 0.112076 12.8584 0.181077 12.793C0.250078 12.7276 0.33168 12.6769 0.420906 12.6441C0.510131 12.6113 0.60511 12.5969 0.70005 12.602H3.49705ZM19.3 12.602C19.395 12.5969 19.49 12.6113 19.5792 12.6441C19.6684 12.6769 19.75 12.7276 19.819 12.793C19.888 12.8584 19.943 12.9372 19.9805 13.0245C20.0181 13.1119 20.0375 13.2059 20.0375 13.301C20.0375 13.3961 20.0181 13.4902 19.9805 13.5775C19.943 13.6649 19.888 13.7436 19.819 13.8091C19.75 13.8745 19.6684 13.9251 19.5792 13.958C19.49 13.9908 19.395 14.0051 19.3 14H5.52905C5.43411 14.0051 5.33913 13.9908 5.24991 13.958C5.16068 13.9251 5.07908 13.8745 5.01008 13.8091C4.94108 13.7436 4.88612 13.6649 4.84857 13.5775C4.81101 13.4902 4.79165 13.3961 4.79165 13.301C4.79165 13.2059 4.81101 13.1119 4.84857 13.0245C4.88612 12.9372 4.94108 12.8584 5.01008 12.793C5.07908 12.7276 5.16068 12.6769 5.24991 12.6441C5.33913 12.6113 5.43411 12.5969 5.52905 12.602H19.3ZM3.49705 6.33402C3.59113 6.33047 3.68497 6.34592 3.77294 6.37947C3.86091 6.41302 3.94121 6.46398 4.00903 6.52928C4.07686 6.59459 4.13081 6.6729 4.16766 6.75955C4.20451 6.84619 4.2235 6.93937 4.2235 7.03352C4.2235 7.12768 4.20451 7.22086 4.16766 7.3075C4.13081 7.39414 4.07686 7.47246 4.00903 7.53776C3.94121 7.60307 3.86091 7.65402 3.77294 7.68757C3.68497 7.72112 3.59113 7.73658 3.49705 7.73302H0.70005C0.605965 7.73658 0.512129 7.72112 0.424157 7.68757C0.336186 7.65402 0.255887 7.60307 0.188065 7.53776C0.120243 7.47246 0.0662923 7.39414 0.0294414 7.3075C-0.0074094 7.22086 -0.0264031 7.12768 -0.0264031 7.03352C-0.0264031 6.93937 -0.0074094 6.84619 0.0294414 6.75955C0.0662923 6.6729 0.120243 6.59459 0.188065 6.52928C0.255887 6.46398 0.336186 6.41302 0.424157 6.37947C0.512129 6.34592 0.605965 6.33047 0.70005 6.33402H3.49705ZM19.3 6.33402C19.3941 6.33047 19.488 6.34592 19.5759 6.37947C19.6639 6.41302 19.7442 6.46398 19.812 6.52928C19.8799 6.59459 19.9338 6.6729 19.9707 6.75955C20.0075 6.84619 20.0265 6.93937 20.0265 7.03352C20.0265 7.12768 20.0075 7.22086 19.9707 7.3075C19.9338 7.39414 19.8799 7.47246 19.812 7.53776C19.7442 7.60307 19.6639 7.65402 19.5759 7.68757C19.488 7.72112 19.3941 7.73658 19.3 7.73302H5.52805C5.43396 7.73658 5.34013 7.72112 5.25216 7.68757C5.16419 7.65402 5.08389 7.60307 5.01606 7.53776C4.94824 7.47246 4.89429 7.39414 4.85744 7.3075C4.82059 7.22086 4.8016 7.12768 4.8016 7.03352C4.8016 6.93937 4.82059 6.84619 4.85744 6.75955C4.89429 6.6729 4.94824 6.59459 5.01606 6.52928C5.08389 6.46398 5.16419 6.41302 5.25216 6.37947C5.34013 6.34592 5.43396 6.33047 5.52805 6.33402H19.3ZM3.49705 2.34838e-05C3.59199 -0.00505668 3.68697 0.00925649 3.77619 0.0420901C3.86542 0.0749236 3.94702 0.125589 4.01602 0.190997C4.08502 0.256404 4.13998 0.335182 4.17753 0.422526C4.21509 0.50987 4.23445 0.603948 4.23445 0.699023C4.23445 0.794098 4.21509 0.888177 4.17753 0.975521C4.13998 1.06286 4.08502 1.14164 4.01602 1.20705C3.94702 1.27246 3.86542 1.32312 3.77619 1.35596C3.68697 1.38879 3.59199 1.4031 3.49705 1.39802H0.70005C0.60511 1.4031 0.510131 1.38879 0.420906 1.35596C0.33168 1.32312 0.250078 1.27246 0.181077 1.20705C0.112076 1.14164 0.0571228 1.06286 0.0195686 0.975521C-0.0179857 0.888177 -0.0373535 0.794098 -0.0373535 0.699023C-0.0373535 0.603948 -0.0179857 0.50987 0.0195686 0.422526C0.0571228 0.335182 0.112076 0.256404 0.181077 0.190997C0.250078 0.125589 0.33168 0.0749236 0.420906 0.0420901C0.510131 0.00925649 0.60511 -0.00505668 0.70005 2.34838e-05H3.49705ZM19.3 2.34838e-05C19.395 -0.00505668 19.49 0.00925649 19.5792 0.0420901C19.6684 0.0749236 19.75 0.125589 19.819 0.190997C19.888 0.256404 19.943 0.335182 19.9805 0.422526C20.0181 0.50987 20.0375 0.603948 20.0375 0.699023C20.0375 0.794098 20.0181 0.888177 19.9805 0.975521C19.943 1.06286 19.888 1.14164 19.819 1.20705C19.75 1.27246 19.6684 1.32312 19.5792 1.35596C19.49 1.38879 19.395 1.4031 19.3 1.39802H5.52805C5.43311 1.4031 5.33813 1.38879 5.24891 1.35596C5.15968 1.32312 5.07808 1.27246 5.00908 1.20705C4.94008 1.14164 4.88512 1.06286 4.84757 0.975521C4.81001 0.888177 4.79065 0.794098 4.79065 0.699023C4.79065 0.603948 4.81001 0.50987 4.84757 0.422526C4.88512 0.335182 4.94008 0.256404 5.00908 0.190997C5.07808 0.125589 5.15968 0.0749236 5.24891 0.0420901C5.33813 0.00925649 5.43311 -0.00505668 5.52805 2.34838e-05H19.3Z"
            fill="#01638D"
          />
        </svg>
      )
      break
    case "history-orege":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_230_34553)">
            <path
              d="M13 3C8.03 3 4 7.03 4 12H1L4.89 15.89L4.96 16.03L9 12H6C6 8.13 9.13 5 13 5C16.87 5 20 8.13 20 12C20 15.87 16.87 19 13 19C11.07 19 9.32 18.21 8.06 16.94L6.64 18.36C8.27 19.99 10.51 21 13 21C17.97 21 22 16.97 22 12C22 7.03 17.97 3 13 3ZM12 8V13L16.25 15.52L17.02 14.24L13.5 12.15V8H12Z"
              fill="#FFA800"
            />
          </g>
          <defs>
            <clipPath id="clip0_230_34553">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "pen-green":
      iconElement = (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.71 5.03957L14.37 7.36957L10.62 3.61957L12.96 1.28957C13.35 0.89957 14 0.89957 14.37 1.28957L16.71 3.62957C17.1 3.99957 17.1 4.64957 16.71 5.03957ZM0 14.2496L10.06 4.17957L13.81 7.92957L3.75 17.9996H0V14.2496ZM13.62 2.03957L12.08 3.57957L14.42 5.91957L15.96 4.37957L13.62 2.03957ZM12.36 7.99957L10 5.63957L1 14.6596V16.9996H3.34L12.36 7.99957Z"
            fill="#219653"
          />
        </svg>
      )
      break
    case "unlock":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.5 10H4.6C4.44087 10 4.28826 10.0632 4.17574 10.1757C4.06321 10.2883 4 10.4409 4 10.6V17.4C4 17.5591 4.06321 17.7117 4.17574 17.8243C4.28826 17.9368 4.44087 18 4.6 18H15.4C15.5591 18 15.7117 17.9368 15.8243 17.8243C15.9368 17.7117 16 17.5591 16 17.4V16.5M8.131 2.385C8.637 2.145 9.253 2 10 2C13.2 2 14 4.667 14 6V10H15.4C15.5591 10 15.7117 10.0632 15.8243 10.1757C15.9368 10.2883 16 10.4409 16 10.6V11M6 6V10M1 1L19 19"
            stroke="#1574F6"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "lock":
      iconElement = (
        <svg
          width="14"
          height="17"
          viewBox="0 0 14 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.33333 6.47619V5.05952C2.33333 2.3031 4.28011 0 7 0C9.71989 0 11.6667 2.3031 11.6667 5.05952V6.47619H12.0556C12.5713 6.47619 13.0658 6.68941 13.4305 7.06895C13.7951 7.44849 14 7.96325 14 8.5V14.9762C14 15.5129 13.7951 16.0277 13.4305 16.4072C13.0658 16.7868 12.5713 17 12.0556 17H1.94444C1.42875 17 0.934169 16.7868 0.569515 16.4072C0.204861 16.0277 0 15.5129 0 14.9762V8.5C0 7.96325 0.204861 7.44849 0.569515 7.06895C0.934169 6.68941 1.42875 6.47619 1.94444 6.47619H2.33333ZM1.16667 8.5V14.9762C1.16667 15.1909 1.24861 15.3968 1.39447 15.5486C1.54033 15.7004 1.73817 15.7857 1.94444 15.7857H12.0556C12.2618 15.7857 12.4597 15.7004 12.6055 15.5486C12.7514 15.3968 12.8333 15.1909 12.8333 14.9762V8.5C12.8333 8.2853 12.7514 8.0794 12.6055 7.92758C12.4597 7.77577 12.2618 7.69048 12.0556 7.69048H1.94444C1.73817 7.69048 1.54033 7.77577 1.39447 7.92758C1.24861 8.0794 1.16667 8.2853 1.16667 8.5ZM3.5 5.05952V6.47619H10.5V5.05952C10.5 2.8981 9.00511 1.21429 7 1.21429C4.99489 1.21429 3.5 2.8981 3.5 5.05952Z"
            fill="#1574F6"
          />
        </svg>
      )
      break
    case "delete-blue":
      iconElement = (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.50073 6V15C4.50073 15.8284 5.17231 16.5 6.00073 16.5H12.0007C12.8292 16.5 13.5007 15.8284 13.5007 15V6H4.50073Z"
            fill="#3699FF"
          />
          <path
            opacity="0.3"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.5007 3.375V3.25C10.5007 2.69772 10.053 2.25 9.50073 2.25H8.50073C7.94845 2.25 7.50073 2.69772 7.50073 3.25V3.375H4.25073C3.97459 3.375 3.75073 3.59886 3.75073 3.875V4C3.75073 4.27614 3.97459 4.5 4.25073 4.5H13.7507C14.0269 4.5 14.2507 4.27614 14.2507 4V3.875C14.2507 3.59886 14.0269 3.375 13.7507 3.375H10.5007Z"
            fill="#3699FF"
          />
        </svg>
      )
      break
    case "edit-blue":
      iconElement = (
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.0557 3.01857C15.6503 3.57823 15.6601 4.48273 15.0776 5.05362L9.27489 10.7411C8.99139 11.0189 8.6023 11.1796 8.19308 11.1876L5.75527 11.2358L5.80674 8.9266C5.81514 8.55021 5.97833 8.19155 6.26198 7.92611L12.1938 2.37516C12.7975 1.81017 13.7732 1.81148 14.3752 2.37811L15.0557 3.01857Z"
            fill="#3699FF"
          />
          <path
            opacity="0.3"
            d="M9.13752 1.3335C9.52872 1.3335 9.84585 1.63197 9.84585 2.00016C9.84585 2.36835 9.52872 2.66683 9.13752 2.66683H4.25002C3.46762 2.66683 2.83335 3.26378 2.83335 4.00016V12.0002C2.83335 12.7365 3.46762 13.3335 4.25002 13.3335H12.75C13.5324 13.3335 14.1667 12.7365 14.1667 12.0002V8.66683C14.1667 8.29864 14.4838 8.00016 14.875 8.00016C15.2662 8.00016 15.5834 8.29864 15.5834 8.66683V12.0002C15.5834 13.4729 14.3148 14.6668 12.75 14.6668H4.25002C2.68521 14.6668 1.41669 13.4729 1.41669 12.0002V4.00016C1.41669 2.5274 2.68521 1.3335 4.25002 1.3335H9.13752Z"
            fill="#3699FF"
          />
        </svg>
      )
      break
    case "add-blue-circle":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 1C6.15042 1.02231 4.38287 1.76698 3.07493 3.07493C1.76698 4.38287 1.02231 6.15042 1 8C1.02231 9.84958 1.76698 11.6171 3.07493 12.9251C4.38287 14.233 6.15042 14.9777 8 15C9.84958 14.9777 11.6171 14.233 12.9251 12.9251C14.233 11.6171 14.9777 9.84958 15 8C14.9777 6.15042 14.233 4.38287 12.9251 3.07493C11.6171 1.76698 9.84958 1.02231 8 1ZM12 8.5H8.5V12H7.5V8.5H4V7.5H7.5V4H8.5V7.5H12V8.5Z"
            fill="#3699FF"
          />
        </svg>
      )
      break
    case "add-blue-square":
      iconElement = (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.18126 1.0217C9.04858 0.593027 12.9514 0.593027 16.8188 1.0217C18.96 1.2617 20.6875 2.94795 20.9388 5.0967C21.3974 9.01875 21.3974 12.9809 20.9388 16.903C20.8116 17.9471 20.3355 18.9176 19.5877 19.6573C18.8399 20.3969 17.8642 20.8623 16.8188 20.978C12.9515 21.408 9.04851 21.408 5.18126 20.978C4.13582 20.8623 3.1601 20.3969 2.41228 19.6573C1.66447 18.9176 1.1884 17.9471 1.06126 16.903C0.602628 12.9813 0.602628 9.01959 1.06126 5.09795C1.18834 4.05404 1.66423 3.08363 2.4118 2.344C3.15936 1.60438 4.1348 1.13888 5.18001 1.02295L5.18126 1.0217ZM11 4.7592C11.2486 4.7592 11.4871 4.85797 11.6629 5.03379C11.8387 5.2096 11.9375 5.44806 11.9375 5.6967V10.0629H16.3038C16.5524 10.0629 16.7909 10.1617 16.9667 10.3375C17.1425 10.5134 17.2413 10.7518 17.2413 11.0005C17.2413 11.2491 17.1425 11.4875 16.9667 11.6634C16.7909 11.8392 16.5524 11.938 16.3038 11.938H11.9375V16.3042C11.9375 16.5528 11.8387 16.7913 11.6629 16.9671C11.4871 17.1429 11.2486 17.2417 11 17.2417C10.7514 17.2417 10.5129 17.1429 10.3371 16.9671C10.1613 16.7913 10.0625 16.5528 10.0625 16.3042V11.938H5.69626C5.44762 11.938 5.20916 11.8392 5.03334 11.6634C4.85753 11.4875 4.75876 11.2491 4.75876 11.0005C4.75876 10.7518 4.85753 10.5134 5.03334 10.3375C5.20916 10.1617 5.44762 10.0629 5.69626 10.0629H10.0625V5.6967C10.0625 5.44806 10.1613 5.2096 10.3371 5.03379C10.5129 4.85797 10.7514 4.7592 11 4.7592Z"
            fill="#01638D"
          />
        </svg>
      )
      break
    case "refresh-blue-square":
      iconElement = (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="21" height="21" rx="6" fill="#01638D" />
          <path
            d="M4.66675 15.3337V14.0003H6.50008L6.23342 13.767C5.68897 13.2225 5.29164 12.6308 5.04142 11.9917C4.79119 11.3525 4.6663 10.6999 4.66675 10.0337C4.66675 8.80033 5.0363 7.70299 5.77542 6.74166C6.51453 5.78033 7.4783 5.14433 8.66675 4.83366V6.23366C7.86675 6.52255 7.2223 7.0141 6.73342 7.70833C6.24453 8.40255 6.00008 9.17766 6.00008 10.0337C6.00008 10.5337 6.09453 11.0199 6.28342 11.4923C6.4723 11.9648 6.76675 12.4008 7.16675 12.8003L7.33342 12.967V11.3337H8.66675V15.3337H4.66675ZM11.3334 15.167V13.767C12.1334 13.4781 12.7779 12.9865 13.2667 12.2923C13.7556 11.5981 14.0001 10.823 14.0001 9.96699C14.0001 9.46699 13.9056 8.98099 13.7167 8.50899C13.5279 8.03699 13.2334 7.60077 12.8334 7.20033L12.6667 7.03366V8.66699H11.3334V4.66699H15.3334V6.00033H13.5001L13.7667 6.23366C14.3112 6.7781 14.7085 7.36988 14.9587 8.00899C15.209 8.6481 15.3339 9.30077 15.3334 9.96699C15.3334 11.2003 14.9639 12.2977 14.2247 13.259C13.4856 14.2203 12.5219 14.8563 11.3334 15.167Z"
            fill="white"
          />
        </svg>
      )
      break
    case "File-black":
      iconElement = (
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 3.60449C9.2198 3.60447 9.43348 3.67687 9.608 3.81049L9.708 3.89749L12.414 6.60449H19C19.7652 6.60445 20.5015 6.89682 21.0583 7.42178C21.615 7.94673 21.9501 8.6646 21.995 9.42849L22 9.60449V17.6045C22 18.3697 21.7077 19.106 21.1827 19.6628C20.6578 20.2195 19.9399 20.5546 19.176 20.5995L19 20.6045H5C4.23479 20.6045 3.49849 20.3122 2.94174 19.7872C2.38499 19.2622 2.04989 18.5444 2.005 17.7805L2 17.6045V6.60449C1.99996 5.83928 2.29233 5.10298 2.81728 4.54623C3.34224 3.98949 4.06011 3.65438 4.824 3.60949L5 3.60449H9Z"
            fill="black"
          />
        </svg>
      )
      break
    case "dowload-export":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_230_34667)">
            <path
              d="M19 9H15V3H9V9H5L12 16L19 9ZM11 11V5H13V11H14.17L12 13.17L9.83 11H11ZM5 18H19V20H5V18Z"
              fill="#01638D"
            />
          </g>
          <defs>
            <clipPath id="clip0_230_34667">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "filter-table":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.00006 6H17.0001L11.9901 12.3L7.00006 6ZM4.25006 5.61C6.27006 8.2 10.0001 13 10.0001 13V19C10.0001 19.55 10.4501 20 11.0001 20H13.0001C13.5501 20 14.0001 19.55 14.0001 19V13C14.0001 13 17.7201 8.2 19.7401 5.61C20.2501 4.95 19.7801 4 18.9501 4H5.04006C4.21006 4 3.74006 4.95 4.25006 5.61Z"
            fill="#01638D"
          />
        </svg>
      )
      break
    case "creat-new":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_230_34513)">
            <path
              d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
              fill="#01638D"
            />
          </g>
          <defs>
            <clipPath id="clip0_230_34513">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "data-box":
      iconElement = (
        <svg
          width="50"
          height="65"
          viewBox="0 0 50 65"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M45.7637 55.7588H4.23625C1.63125 55.7588 0.652495 52.8956 0.499995 51.3843L0.494995 32.2256C0.495439 32.1245 0.509833 32.0243 0.537495 31.9298L6.36625 12.4493C6.66426 11.4739 7.18696 10.6421 7.86275 10.0678C8.53855 9.49357 9.33438 9.20498 10.1412 9.24156H39.8387C40.6524 9.20367 41.4551 9.4946 42.1363 10.0743C42.8175 10.654 43.3437 11.494 43.6425 12.4786L49.4612 31.9298C49.4889 32.0243 49.5033 32.1245 49.5037 32.2256V51.2787C49.3475 52.8972 48.37 55.7588 45.7637 55.7588ZM1.745 32.3783V51.2787C1.77125 51.4721 2.12125 54.1354 4.23625 54.1354H45.7637C47.9362 54.1354 48.2462 51.2949 48.2587 51.1747L48.2537 32.3799L42.4687 13.0424C42.4375 12.9303 41.8412 10.8698 39.86 10.8698H10.1637C8.12749 10.8698 7.54625 12.9888 7.54 13.0099L1.745 32.3783Z"
            fill="#01638D"
          />
          <path
            d="M33.9575 36.7546H16.045C15.9574 36.754 15.871 36.7297 15.7911 36.6831C15.7113 36.6365 15.6398 36.5687 15.5813 36.4841C15.5228 36.3995 15.4785 36.2999 15.4514 36.1917C15.4243 36.0835 15.4148 35.9691 15.4237 35.8559C15.5762 33.9856 15.3837 32.5978 14.8625 31.8454C14.3475 31.1012 13.5575 31.1581 13.4862 31.1646L6.51997 31.1727C6.41828 31.1723 6.31819 31.1397 6.22838 31.0777C6.13858 31.0157 6.06177 30.9261 6.00462 30.8168C5.94748 30.7074 5.91172 30.5816 5.90045 30.4502C5.88919 30.3188 5.90275 30.1858 5.93997 30.0628L10.3012 15.7401C10.3473 15.5886 10.4274 15.4586 10.5311 15.3671C10.6347 15.2755 10.7572 15.2265 10.8825 15.2266H39.1175C39.2428 15.2265 39.3652 15.2755 39.4689 15.3671C39.5725 15.4586 39.6526 15.5886 39.6987 15.7401L44 29.8694C44.0706 29.9899 44.1139 30.1336 44.125 30.2844C44.1361 30.4352 44.1145 30.5869 44.0628 30.7226C44.0111 30.8583 43.9312 30.9725 43.8322 31.0523C43.7332 31.1321 43.619 31.1744 43.5025 31.1743H36.5975C36.5012 31.1646 36.4537 31.1597 36.3837 31.1597C36.095 31.1597 35.5512 31.2491 35.1375 31.8471C34.6175 32.6011 34.4237 33.9856 34.5775 35.8576C34.5874 35.9708 34.5787 36.0855 34.552 36.194C34.5253 36.3026 34.4812 36.4025 34.4226 36.4873C34.364 36.5721 34.2923 36.6397 34.2121 36.6858C34.1319 36.7318 34.0451 36.7553 33.9575 36.7546ZM16.7175 35.1296H33.2837C33.2237 33.2023 33.5337 31.7349 34.2075 30.7616C35.2262 29.2893 36.6875 29.5591 36.6862 29.5574L42.5575 29.5509L38.6912 16.8516H11.3075L7.44122 29.5509H13.3775C13.3962 29.5461 13.49 29.5363 13.6175 29.5363C14.1137 29.5363 15.0537 29.6956 15.7925 30.7616C16.4662 31.7349 16.7775 33.2023 16.7175 35.1296Z"
            fill="#01638D"
          />
        </svg>
      )
      break
    case "refresh-black":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 4V10H7"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M23 20V14H17"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M20.49 8.99959C19.9828 7.56637 19.1209 6.28499 17.9845 5.27501C16.8482 4.26502 15.4745 3.55935 13.9917 3.22385C12.5089 2.88834 10.9652 2.93393 9.50481 3.35636C8.04437 3.77879 6.71475 4.5643 5.64 5.63959L1 9.99959M23 13.9996L18.36 18.3596C17.2853 19.4349 15.9556 20.2204 14.4952 20.6428C13.0348 21.0652 11.4911 21.1108 10.0083 20.7753C8.52547 20.4398 7.1518 19.7342 6.01547 18.7242C4.87913 17.7142 4.01717 16.4328 3.51 14.9996"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "bell-blue":
      iconElement = (
        <svg
          width="16"
          height="22"
          viewBox="0 0 18 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.00006 23.667C10.2834 23.667 11.3334 22.617 11.3334 21.3337H6.66673C6.66673 22.617 7.70506 23.667 9.00006 23.667ZM16.0001 16.667V10.8337C16.0001 7.25199 14.0867 4.25366 10.7501 3.46033V2.66699C10.7501 1.69866 9.96839 0.916992 9.00006 0.916992C8.03173 0.916992 7.25006 1.69866 7.25006 2.66699V3.46033C3.90173 4.25366 2.00006 7.24033 2.00006 10.8337V16.667L0.49506 18.172C-0.23994 18.907 0.273393 20.167 1.31173 20.167H16.6767C17.7151 20.167 18.2401 18.907 17.5051 18.172L16.0001 16.667Z"
            fill="#01638D"
          />
        </svg>
      )
      break
    case "post-blog":
      iconElement = (
        <svg
          fill="#000000"
          height="20px"
          width="20px"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <g>
              <g>
                <g>
                  <path d="M93.238,220.968h172.463c4.466,0,8.084-3.619,8.084-8.084s-3.618-8.084-8.084-8.084H93.238 c-4.466,0-8.084,3.619-8.084,8.084S88.772,220.968,93.238,220.968z"></path>{" "}
                  <path d="M93.238,177.853h97.01c4.466,0,8.084-3.619,8.084-8.084s-3.618-8.084-8.084-8.084h-97.01 c-4.466,0-8.084,3.619-8.084,8.084S88.772,177.853,93.238,177.853z"></path>{" "}
                  <path d="M114.796,398.282h280.253c16.344,0,29.642-13.298,29.642-29.642v-91.082c0-5.206-1.371-10.333-3.968-14.822 c-2.233-3.865-7.179-5.189-11.044-2.953c-3.866,2.233-5.188,7.179-2.953,11.044c1.176,2.034,1.797,4.362,1.797,6.732v91.082 c0,7.43-6.044,13.474-13.474,13.474H114.796c-7.43,0-13.474-6.044-13.474-13.474v-91.082c0-7.43,6.044-13.474,13.474-13.474 h150.905c4.466,0,8.084-3.619,8.084-8.084c0-4.466-3.618-8.084-8.084-8.084H114.796c-16.344,0-29.642,13.298-29.642,29.642 v91.082C85.154,384.984,98.452,398.282,114.796,398.282z"></path>{" "}
                  <path d="M477.068,412.237c1.684-5.067,2.596-10.484,2.596-16.11V158.989c0-28.231-22.969-51.2-51.2-51.2h-45.81V29.642 C382.653,13.298,369.355,0,353.01,0h-21.558c-16.344,0-29.642,13.298-29.642,29.642v78.147H83.537 c-28.231,0-51.2,22.969-51.2,51.2v237.137c0,5.627,0.912,11.043,2.596,16.11C14.43,419.065,0,438.368,0,460.8 C0,489.031,22.969,512,51.2,512h409.6c28.231,0,51.2-22.969,51.2-51.2C512,438.368,497.57,419.065,477.068,412.237z M317.979,29.642c0-7.43,6.044-13.474,13.474-13.474h21.558c7.43,0,13.474,6.044,13.474,13.474v13.474h-48.505V29.642z M366.484,59.284v188.632h-16.168V59.284H366.484z M317.979,59.284h16.168v188.632h-16.168V59.284z M317.979,264.084h48.505 v20.66c0,0.579-0.192,1.153-0.539,1.617l-21.558,28.743c-0.704,0.938-1.652,1.078-2.156,1.078c-0.503,0-1.452-0.14-2.156-1.078 l-21.557-28.741c-0.348-0.466-0.54-1.04-0.54-1.619V264.084z M48.505,158.989c0-19.317,15.715-35.032,35.032-35.032h218.274 v37.726h-57.667c-4.466,0-8.084,3.619-8.084,8.084s3.618,8.084,8.084,8.084h57.667v106.892c0,4.053,1.339,8.071,3.773,11.318 l21.558,28.743c3.596,4.796,9.096,7.545,15.091,7.545c5.994,0,11.495-2.75,15.091-7.545l21.559-28.745 c2.433-3.244,3.772-7.263,3.772-11.316v-63.776h33.954c4.466,0,8.084-3.619,8.084-8.084s-3.619-8.084-8.084-8.084h-33.954 v-26.947h33.954c4.466,0,8.084-3.619,8.084-8.084s-3.619-8.084-8.084-8.084h-33.954v-37.726h45.81 c19.317,0,35.032,15.715,35.032,35.032v237.137c0,19.317-15.715,35.032-35.032,35.032H83.537 c-19.317,0-35.032-15.715-35.032-35.032V158.989z M460.8,495.832H51.2c-19.317,0-35.032-15.715-35.032-35.032 c0-16.257,11.071-30.113,26.426-33.963c9.349,12.434,24.222,20.49,40.943,20.49h344.926c16.72,0,31.594-8.056,40.943-20.49 c15.355,3.85,26.426,17.707,26.426,33.963C495.832,480.117,480.117,495.832,460.8,495.832z"></path>{" "}
                  <path d="M235.52,463.495h-1.078c-4.466,0-8.084,3.618-8.084,8.084c0,4.466,3.618,8.084,8.084,8.084h1.078 c4.466,0,8.084-3.618,8.084-8.084C243.604,467.113,239.986,463.495,235.52,463.495z"></path>{" "}
                  <path d="M433.853,463.495H272.168c-4.466,0-8.084,3.618-8.084,8.084c0,4.466,3.618,8.084,8.084,8.084h161.684 c4.466,0,8.084-3.618,8.084-8.084C441.937,467.113,438.318,463.495,433.853,463.495z"></path>{" "}
                  <path d="M202.105,463.495h-1.078c-4.466,0-8.084,3.618-8.084,8.084c0,4.466,3.618,8.084,8.084,8.084h1.078 c4.466,0,8.084-3.618,8.084-8.084C210.189,467.113,206.571,463.495,202.105,463.495z"></path>{" "}
                  <path d="M164.379,463.495H78.147c-4.466,0-8.084,3.618-8.084,8.084c0,4.466,3.618,8.084,8.084,8.084h86.232 c4.466,0,8.084-3.618,8.084-8.084C172.463,467.113,168.845,463.495,164.379,463.495z"></path>{" "}
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
      break
    case "headphone":
      iconElement = (
        <svg
          fill="#000000"
          width="24px"
          height="24px"
          viewBox="0 0 32 32"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <g id="Icon">
              <path d="M5.003,15.386c-0.776,0.808 -1.253,1.906 -1.253,3.114c-0,2.353 1.809,4.286 4.111,4.483l0,0.017c0,0.552 0.448,1 1,1l3.139,0c0.552,0 1,-0.448 1,-1l0,-9c0,-0.552 -0.448,-1 -1,-1l-3.139,0c-0.552,0 -1,0.448 -1,1l0,0.017c-0.276,0.023 -0.546,0.072 -0.806,0.144c0.221,-3.123 1.105,-5.455 2.52,-7.049c1.588,-1.79 3.834,-2.605 6.425,-2.605c2.594,-0 4.844,0.765 6.434,2.51c1.433,1.574 2.319,3.907 2.521,7.085c-0.264,-0.057 -0.537,-0.091 -0.816,-0.1l-0,-0.002c-0,-0.552 -0.448,-1 -1,-1l-3.139,0c-0.552,0 -1,0.448 -1,1l-0,9c-0,0.552 0.448,1 1,1l3.139,0c0.552,0 1,-0.448 1,-1l-0,-0.002c0.381,-0.012 0.75,-0.071 1.101,-0.171l0,2.923c0,0.138 -0.112,0.25 -0.25,0.25l-3.37,0l0,-0.414c0,-0.552 -0.447,-1 -1,-1l-5.24,0c-0.553,0 -1,0.448 -1,1l-0,2.828c-0,0.552 0.447,1 1,1l5.24,-0c0.553,-0 1,-0.448 1,-1l0,-0.414l3.37,0c1.242,0 2.25,-1.008 2.25,-2.25l0,-4.129c0.78,-0.809 1.26,-1.909 1.26,-3.121c0,-1.333 -0.581,-2.531 -1.503,-3.356c-0.068,-4.349 -1.233,-7.441 -3.085,-9.473c-1.961,-2.154 -4.711,-3.164 -7.912,-3.164c-3.204,-0 -5.958,1.064 -7.921,3.278c-1.853,2.088 -3.014,5.24 -3.076,9.601Zm11.377,11.2l3.24,0c0,0 0,0.828 0,0.828c0,-0 -3.24,-0 -3.24,-0l-0,-0.828Zm5.759,-11.586l-0,7c-0,0 -1.139,0 -1.139,0c-0,-0 -0,-7 -0,-7l1.139,0Zm-11.139,0l-0,7c0,0 -1.139,0 -1.139,0c0,-0 0,-7 0,-7l1.139,0Zm13.139,1.004l-0,4.992c1.315,-0.072 2.361,-1.163 2.361,-2.496c-0,-1.333 -1.046,-2.424 -2.361,-2.496Zm-16.278,0.026c-1.195,0.187 -2.111,1.222 -2.111,2.47c-0,1.248 0.916,2.283 2.111,2.47l0,-4.94Z"></path>{" "}
            </g>
          </g>
        </svg>
      )
      break
    case "rounded":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM16.92 6H13.97C13.65 4.75 13.19 3.55 12.59 2.44C14.43 3.07 15.96 4.35 16.92 6ZM10 2.04C10.83 3.24 11.48 4.57 11.91 6H8.09C8.52 4.57 9.17 3.24 10 2.04ZM2.26 12C2.1 11.36 2 10.69 2 10C2 9.31 2.1 8.64 2.26 8H5.64C5.56 8.66 5.5 9.32 5.5 10C5.5 10.68 5.56 11.34 5.64 12H2.26ZM3.08 14H6.03C6.35 15.25 6.81 16.45 7.41 17.56C5.57 16.93 4.04 15.66 3.08 14ZM6.03 6H3.08C4.04 4.34 5.57 3.07 7.41 2.44C6.81 3.55 6.35 4.75 6.03 6ZM10 17.96C9.17 16.76 8.52 15.43 8.09 14H11.91C11.48 15.43 10.83 16.76 10 17.96ZM12.34 12H7.66C7.57 11.34 7.5 10.68 7.5 10C7.5 9.32 7.57 8.65 7.66 8H12.34C12.43 8.65 12.5 9.32 12.5 10C12.5 10.68 12.43 11.34 12.34 12ZM12.59 17.56C13.19 16.45 13.65 15.25 13.97 14H16.92C15.96 15.65 14.43 16.93 12.59 17.56ZM14.36 12C14.44 11.34 14.5 10.68 14.5 10C14.5 9.32 14.44 8.66 14.36 8H17.74C17.9 8.64 18 9.31 18 10C18 10.69 17.9 11.36 17.74 12H14.36Z"
            fill="black"
          />
        </svg>
      )
      break
    case "word-update-green":
      iconElement = (
        <svg
          width="18px"
          height="18px"
          viewBox="0 0 800 800"
          enable-background="new 0 0 800 800"
          id="GUIDE"
          version="1.1"
          space="preserve"
          xmlns="http://www.w3.org/2000/svg"
          cc="http://creativecommons.org/ns#"
          dc="http://purl.org/dc/elements/1.1/"
          inkscape="http://www.inkscape.org/namespaces/inkscape"
          rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
          sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
          svg="http://www.w3.org/2000/svg"
          xlink="http://www.w3.org/1999/xlink"
          fill="#00C590"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <g>
              <path d="M774.721,110.344c4.668-10.011,0.337-21.91-9.674-26.578L649.241,29.765c-4.807-2.242-10.309-2.482-15.292-0.668 c-4.985,1.814-9.045,5.534-11.287,10.342l-59.898,128.455l-29.281-86.015c-2.76-8.104-10.372-13.555-18.934-13.555H121.323 c-6.015,0-11.71,2.707-15.508,7.37l-77.922,95.678c-4.352,5.344-5.646,12.551-3.425,19.075L217.865,758.55 c2.759,8.104,10.371,13.555,18.933,13.555H659.33c11.047,0,20-8.954,20-20s-8.953-20-20-20H251.116L71.339,204.007l94.295,0.02 c0.001,0,0.003,0,0.004,0c6.824,0,13.178-3.479,16.853-9.229c3.676-5.751,4.164-12.98,1.296-19.174l-31.162-67.3H500.23 l38.11,111.947L405.278,505.625c-1.536,3.292-2.108,6.908-1.749,10.463c-0.008,0.002-0.015,0.003-0.023,0.005l12.581,124.188 c0.711,7.012,5.059,13.132,11.446,16.11c2.69,1.255,5.576,1.874,8.45,1.874c3.948,0,7.875-1.168,11.247-3.461l103.225-70.188 c-0.002-0.003-0.003-0.006-0.004-0.009c2.886-1.958,5.303-4.688,6.884-8.078l59.123-126.789l105.126,308.81 c2.833,8.321,10.605,13.56,18.932,13.56c2.137,0,4.312-0.345,6.447-1.072c10.457-3.559,16.047-14.922,12.488-25.378 L640.883,397.363L774.721,110.344z M85.477,164.01l31.145-38.242l17.713,38.252L85.477,164.01z M650.463,74.47l79.554,37.096 l-18.285,39.214l-79.554-37.097L650.463,74.47z M446.85,547.077l52.008,24.251L452.5,602.85L446.85,547.077z M529.535,541.499 l-79.553-37.096l165.291-354.468l79.553,37.097L529.535,541.499z"></path>
              <path d="M608.921,220.086L528.08,393.45c-4.668,10.011-0.338,21.91,9.674,26.578c2.734,1.275,5.609,1.879,8.438,1.879 c7.532,0,14.747-4.275,18.14-11.553l80.841-173.364c4.669-10.011,0.337-21.91-9.674-26.578 C625.49,205.743,613.589,210.075,608.921,220.086z"></path>
              <path d="M528.939,438.928c-10.01-4.668-21.91-0.336-26.578,9.675l-2.725,5.843c-4.667,10.012-0.336,21.911,9.676,26.578 c2.734,1.275,5.607,1.879,8.438,1.879c7.533,0,14.748-4.277,18.141-11.553l2.725-5.844 C543.283,455.494,538.951,443.595,528.939,438.928z"></path>
              <path d="M176.516,244.257c-11.046,0-20,8.954-20,20s8.954,20,20,20h3.322c11.046,0,20-8.954,20-20s-8.954-20-20-20H176.516z"></path>
              <path d="M443.271,284.257c11.046,0,20-8.954,20-20s-8.954-20-20-20H240.67c-11.045,0-20,8.954-20,20s8.955,20,20,20H443.271z"></path>
              <path d="M418.624,420.214c0-11.046-8.954-20-20-20H229.608c-11.046,0-20,8.954-20,20s8.954,20,20,20h169.016 C409.67,440.214,418.624,431.26,418.624,420.214z"></path>
              <path d="M282.698,556.171c-11.046,0-20,8.954-20,20s8.954,20,20,20h80.904c11.046,0,20-8.954,20-20s-8.954-20-20-20H282.698z"></path>
            </g>
          </g>
        </svg>
      )
      break

    case "more":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="90"
          height="90"
          viewBox="0 0 64 64"
        >
          <path
            fill="#85cbf8"
            d="M31 3A28 28 0 1 0 31 59A28 28 0 1 0 31 3Z"
          ></path>
          <path
            fill="#c2cde7"
            d="M31,3A28,28,0,1,0,59,31,28,28,0,0,0,31,3Zm0,50A22,22,0,1,1,46.17,15.07l.68.67q.39.4.75.82A22,22,0,0,1,31,53Z"
          ></path>
          <path
            fill="#acb7d0"
            d="M31,53A22,22,0,0,1,9,31H7.34a4,4,0,0,0-3.95,4.71,28,28,0,0,0,55.21,0A4,4,0,0,0,54.66,31H53A22,22,0,0,1,31,53Z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M31,2A29,29,0,1,0,60,31,29,29,0,0,0,31,2Zm0,56A27,27,0,1,1,58,31,27,27,0,0,1,31,58Z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M31 50a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V51A1 1 0 0 0 31 50zM37 50.08a1 1 0 0 0-1.93.52l.52 1.93A1 1 0 0 0 37.53 52zM21.75 47.52a1 1 0 0 0-1.37.37l-1 1.73a1 1 0 1 0 1.73 1l1-1.73A1 1 0 0 0 21.75 47.52zM41.62 47.89a1 1 0 1 0-1.73 1l1 1.73a1 1 0 1 0 1.73-1zM26.21 49.37a1 1 0 0 0-1.22.71L24.47 52a1 1 0 1 0 1.93.52l.52-1.93A1 1 0 0 0 26.21 49.37z"
          ></path>
          <path
            fill="#faefde"
            d="M43,30H32V19a1,1,0,0,0-2,0V30H19a1,1,0,0,0,0,2H30V43a1,1,0,0,0,2,0V32H43a1,1,0,0,0,0-2Z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M38.35 11.32a21 21 0 0 1 2.1.92 1 1 0 0 0 .9-1.79 23 23 0 0 0-2.3-1 1 1 0 1 0-.7 1.87zM16.15 16.15a21.08 21.08 0 0 1 18.19-5.88 1 1 0 1 0 .32-2 23 23 0 0 0-19.92 39 1 1 0 0 0 1.41-1.41A21 21 0 0 1 16.15 16.15zM47.26 14.74a23.19 23.19 0 0 0-2.09-1.86 1 1 0 0 0-1.23 1.57 21.26 21.26 0 0 1 1.91 1.7 21 21 0 0 1 0 29.7 1 1 0 1 0 1.41 1.41A23 23 0 0 0 47.26 14.74z"
          ></path>
        </svg>
      )
      break
    case "new":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="90"
          height="90"
          viewBox="0 0 64 64"
        >
          <path
            fill="#f9e3ae"
            d="M47,57H17c-5.523,0-10-4.477-10-10V17c0-5.523,4.477-10,10-10h30c5.523,0,10,4.477,10,10v30	C57,52.523,52.523,57,47,57z"
          ></path>
          <path
            fill="#efc88e"
            d="M30.996,12.278c-0.354-0.422-0.983-0.479-1.408-0.124l-1.498,1.257	c-3.24-3.303-8.54-3.614-12.141-0.592c-1.832,1.538-2.956,3.696-3.165,6.079c-0.188,2.149,0.396,4.246,1.639,5.981l-1.316,1.104	c-0.423,0.355-0.479,0.986-0.123,1.409c0.197,0.236,0.48,0.357,0.767,0.357c0.227,0,0.454-0.077,0.642-0.234l16.48-13.829	C31.296,13.332,31.352,12.701,30.996,12.278z"
          ></path>
          <path
            fill="#b5c4e0"
            d="M13.361,24.292l12.188-10.227l0,0c-2.824-3.366-7.842-3.804-11.207-0.98l0,0	C10.976,15.909,10.537,20.927,13.361,24.292L13.361,24.292z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M28.496,11.778c-0.354-0.422-0.983-0.479-1.408-0.124l-1.358,1.139	c-3.249-3.197-8.473-3.462-12.031-0.475c-1.832,1.538-2.956,3.696-3.165,6.079c-0.183,2.096,0.362,4.143,1.542,5.853l-1.469,1.233	c-0.423,0.355-0.479,0.986-0.123,1.409c0.197,0.236,0.48,0.357,0.767,0.357c0.227,0,0.454-0.077,0.642-0.234l16.48-13.829	C28.796,12.832,28.852,12.201,28.496,11.778z M14.984,13.851c1.301-1.091,2.887-1.624,4.465-1.624c1.671,0,3.332,0.597,4.636,1.761	l-10.546,8.849C11.75,19.949,12.307,16.098,14.984,13.851z"
          ></path>
          <path
            fill="#f9dd8f"
            d="M51,46.347c-14-2.779-27.403-2.428-38,0c0,0-0.862,3.602-0.985,9.314C13.484,56.508,15.183,57,17,57	h30c1.824,0,3.529-0.496,5.001-1.349C51.941,49.946,51,46.347,51,46.347z"
          ></path>
          <path
            fill="#efc88e"
            d="M53.267,46.067c-0.179-0.58-0.522-0.973-0.768-1.244c0.124-2.566-1.676-3.612-1.676-3.612	s0.928-1.766,0.928-5.605c0-3.789-2.251-11.074-8.409-13.647l2.363,23.483c-11.684-1.692-22.737-1.24-31.83,0.718	c-0.053,0.217-0.078,0.448-0.063,0.697c0.127,2.046,0.871,3.626,2.46,3.726c1.79,0.113,3.18-0.749,4.246-3.284	c7.351-0.954,17.937-0.954,22.928,0.551c2.717,0.819,2.258,2.846,1.57,3.67c3.206,0.634,4.483,2.891,4.734,5.096l4.177-2.523	C53.929,51.312,53.849,47.949,53.267,46.067z"
          ></path>
          <path
            fill="#acb7d0"
            d="M48.649,42.342c-0.373-0.121-0.755-0.158-1.141-0.16C48.502,40.655,49.025,38.33,49,36	c-0.109-10.049-7.542-17-16.5-17C23.534,19,15,26.94,15,35.5c0,2.913,0.5,5.514,1.472,7.394c-0.008,0-0.015,0-0.023,0	c-1.695,0.074-2.985,0.884-2.948,2.248c0.037,1.363,0.747,3.832,2.469,3.832c1.327,0,2.356-1.683,2.117-3.268l3.815-0.788	c-0.008-0.006-0.015-0.01-0.023-0.016c6.022-0.64,12.605-0.676,19.48,0.022c-0.019,0.013-0.037,0.024-0.056,0.037	c2.726,0.252,3.495,0.479,4.402,0.626c0.153,1.839,0.795,2.678,2.084,2.679C49.535,48.267,52.672,43.647,48.649,42.342z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M28.442,37.571c0.438-1.946,4.326-0.587,6.46-0.723c0.975-0.062,1.712-1.807,2.898-1.651	c1.186,0.156,1.993,3.975-2.125,4.798C32.399,40.65,28.2,38.646,28.442,37.571z"
          ></path>
          <ellipse
            cx="39.788"
            cy="31.516"
            fill="#8d6c9f"
            rx=".972"
            ry="1.748"
            transform="rotate(-13.468 39.791 31.512)"
          ></ellipse>
          <ellipse
            cx="24.906"
            cy="34.307"
            fill="#8d6c9f"
            rx=".972"
            ry="1.738"
            transform="rotate(-13.468 24.91 34.304)"
          ></ellipse>
          <path
            fill="#8d6c9f"
            d="M47,58H17c-6.065,0-11-4.935-11-11V17c0-6.065,4.935-11,11-11h30c6.065,0,11,4.935,11,11v30	C58,53.065,53.065,58,47,58z M17,8c-4.963,0-9,4.038-9,9v30c0,4.962,4.037,9,9,9h30c4.963,0,9-4.038,9-9V17c0-4.962-4.037-9-9-9H17z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M22.431,53.181c-0.514,0-0.951-0.394-0.995-0.915l-0.17-1.993c-0.047-0.55,0.361-1.034,0.911-1.082	s1.035,0.361,1.081,0.912l0.17,1.993c0.047,0.55-0.361,1.034-0.911,1.082C22.487,53.18,22.459,53.181,22.431,53.181z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M27.257,52.868c-0.531,0-0.974-0.418-0.998-0.955l-0.09-1.998c-0.024-0.552,0.402-1.019,0.954-1.044	c0.533-0.019,1.019,0.402,1.044,0.954l0.09,1.998c0.024,0.552-0.402,1.019-0.954,1.044C27.287,52.868,27.272,52.868,27.257,52.868z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M32.093,52.747c-0.55,0-0.997-0.444-1-0.995l-0.01-2c-0.003-0.552,0.442-1.002,0.995-1.005	c0.002,0,0.003,0,0.005,0c0.55,0,0.997,0.444,1,0.995l0.01,2c0.003,0.552-0.442,1.002-0.995,1.005	C32.096,52.747,32.095,52.747,32.093,52.747z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M36.927,52.826c-0.013,0-0.026,0-0.039,0c-0.552-0.021-0.982-0.486-0.961-1.038l0.076-1.999	c0.021-0.552,0.485-0.978,1.037-0.961c0.552,0.021,0.982,0.486,0.961,1.038l-0.076,1.999C37.904,52.403,37.461,52.826,36.927,52.826	z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M41.741,53.131c-0.03,0-0.061-0.001-0.091-0.004c-0.551-0.05-0.956-0.537-0.906-1.086l0.181-1.992	c0.05-0.55,0.542-0.945,1.086-0.906c0.551,0.05,0.956,0.537,0.906,1.086l-0.181,1.992C42.689,52.741,42.253,53.131,41.741,53.131z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M51.962,46.228c-0.012-0.042-0.026-0.083-0.043-0.123c-0.059-0.136-0.144-0.252-0.248-0.347	c-0.059-0.053-0.137-0.082-0.208-0.121c0.033-0.131,0.077-0.26,0.098-0.391c0.282-1.774-0.671-3.201-2.545-3.832	c0.643-1.513,1.006-3.398,0.985-5.424C49.89,25.734,42.366,18,32.5,18C22.99,18,14,26.505,14,35.5c0,2.542,0.37,4.798,1.05,6.62	c-1.598,0.457-2.589,1.577-2.549,3.049c0.004,0.144,0.016,0.297,0.031,0.453c-0.096,0.051-0.185,0.113-0.258,0.19	c-0.086,0.09-0.155,0.196-0.203,0.317c-0.016,0.04-0.029,0.08-0.04,0.121c-0.09,0.327-0.906,3.441-1.019,9.392	c-0.01,0.552,0.429,1.008,0.981,1.019c0.006,0,0.013,0,0.019,0c0.544,0,0.989-0.436,1-0.981c0.06-3.213,0.336-5.555,0.575-7.032	c0.552,0.775,1.332,1.326,2.382,1.326c0.806,0,1.574-0.377,2.164-1.063c0.558-0.648,0.9-1.512,0.973-2.394l2.606-0.539	c6.191-0.737,12.767-0.759,19.42-0.042c0.027,0.005,0.051,0.017,0.079,0.02c0.243,0.022,0.468,0.045,0.68,0.067	c0.691,0.08,1.383,0.172,2.075,0.268c0.326,0.053,0.597,0.103,0.842,0.149c0.345,1.874,1.344,2.823,2.979,2.825	c0.001,0,0.001,0,0.002,0c0.849,0,1.774-0.583,2.504-1.429c0.273,1.33,0.677,3.938,0.709,7.83c0.005,0.549,0.451,0.992,1,0.992	c0.003,0,0.006,0,0.009,0c0.552-0.004,0.996-0.456,0.991-1.008C52.954,49.689,52.063,46.561,51.962,46.228z M17.885,44.727	c-0.521,0.108-0.866,0.604-0.787,1.129c0.094,0.616-0.095,1.303-0.48,1.751c-0.118,0.137-0.359,0.368-0.647,0.368	c-0.85,0-1.438-1.694-1.469-2.86c-0.023-0.836,1.058-1.181,1.99-1.221c0.184-0.008,0.359-0.014,0.532-0.014	c0.704,0,1.363,0.098,2.275,0.555L17.885,44.727z M41.053,43.924c-6.45-0.677-12.836-0.696-18.876-0.037	c-2.161-1.553-3.498-1.98-5.071-2.003C16.398,40.234,16,38.011,16,35.5C16,27.533,24.019,20,32.5,20	c8.738,0,15.401,6.883,15.5,16.011c0.021,2.011-0.405,3.895-1.098,5.191C44.857,41.426,42.813,42.739,41.053,43.924z M47.79,47.266	c-0.397,0-0.941-0.001-1.087-1.761c-0.038-0.458-0.384-0.832-0.838-0.905c-0.205-0.033-0.403-0.071-0.621-0.112	c-0.288-0.055-0.62-0.117-1.048-0.186c1.582-0.909,2.954-1.396,4.145-1.009c1.264,0.41,1.33,1.087,1.246,1.631	C49.398,46.146,48.192,47.263,47.79,47.266z"
          ></path>
        </svg>
      )
      break
    case "idic":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="90"
          height="90"
          viewBox="0 0 64 64"
        >
          <path
            fill="#f9dd8f"
            d="M51,7H13c-3.3,0-6,2.7-6,6v38c0,3.3,2.7,6,6,6h38c3.3,0,6-2.7,6-6V13C57,9.7,54.3,7,51,7z"
          ></path>
          <path
            fill="#ffeb9b"
            d="M54,50H10c-1.7,0-3,1.3-3,3l0,0c0,2.2,1.8,4,4,4h42c2.2,0,4-1.8,4-4l0,0C57,51.3,55.7,50,54,50z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M51,6H13c-3.9,0-7,3.1-7,7v38c0,3.9,3.1,7,7,7h38c3.9,0,7-3.1,7-7V13C58,9.1,54.9,6,51,6z M56,51	c0,2.8-2.2,5-5,5H13c-2.8,0-5-2.2-5-5V13c0-2.8,2.2-5,5-5h38c2.8,0,5,2.2,5,5V51z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M17,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C18,48.4,17.6,48,17,48z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M12,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C13,48.4,12.6,48,12,48z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M32,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1v-2C33,48.4,32.6,48,32,48z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M37,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C38,48.4,37.6,48,37,48z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M42,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C43,48.4,42.6,48,42,48z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M47,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C48,48.4,47.6,48,47,48z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M52,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C53,48.4,52.6,48,52,48z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M22,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C23,48.4,22.6,48,22,48z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M27,48c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C28,48.4,27.6,48,27,48z"
          ></path>
          <path
            fill="#fff8ee"
            stroke="#8d6c9f"
            stroke-miterlimit="10"
            stroke-width="2"
            d="M20,44h37v-4H20c-1.1,0-2,0.9-2,2v0C18,43.1,18.9,44,20,44z"
          ></path>
          <rect
            width="4"
            height="21"
            x="32.4"
            y="15.1"
            fill="#fff8ee"
            stroke="#8d6c9f"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
            transform="rotate(45.001 34.375 25.567)"
          ></rect>
          <path
            fill="#fff8ee"
            stroke="#8d6c9f"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
            d="M45.4,17.4l-2.8-2.8l2.1-2.1c0.8-0.8,2-0.8,2.8,0l0,0c0.8,0.8,0.8,2,0,2.8L45.4,17.4z"
          ></path>
          <polygon
            fill="#fff8ee"
            stroke="#8d6c9f"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
            points="20.5,39.4 20.5,39.4 23.4,33.7 26.3,36.5"
          ></polygon>
        </svg>
      )
      break
    case "fileClole":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="45"
          height="45"
          viewBox="0 0 64 64"
        >
          <path
            fill="#cda1a7"
            d="M53,53H4a3,3,0,0,1-3-3V10A3,3,0,0,1,4,7H17l9,6H50a3,3,0,0,1,3,3Z"
          ></path>
          <path
            fill="#faefde"
            d="M53.44,53H8.56a2,2,0,0,1-1.94-2.49l7-28A2,2,0,0,1,15.56,21H60.44a2,2,0,0,1,1.94,2.49l-7,28A2,2,0,0,1,53.44,53Z"
          ></path>
          <path
            fill="#fff7f0"
            d="M62.25,24l.13-.51A2,2,0,0,0,60.44,21H15.56a2,2,0,0,0-1.94,1.51L13.25,24Z"
          ></path>
          <path
            fill="#efd8be"
            d="M8.5,43,6.62,50.51A2,2,0,0,0,8.56,53H53.44a2,2,0,0,0,1.94-1.51L57.5,43Z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M53 42H49a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2zM11.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 11.74 46zM16.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 16.74 46zM21.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 21.74 46zM26.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 26.74 46zM31.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 31.74 46zM36.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 36.74 46zM41.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 41.74 46zM46.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 46.74 46zM51.74 46a1 1 0 0 0-1.21.73l-.5 2a1 1 0 1 0 1.94.48l.5-2A1 1 0 0 0 51.74 46z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M62.81,21.15A3,3,0,0,0,60.44,20H54V15a3,3,0,0,0-3-3H25.71a3,3,0,0,1-2.11-.87L19.87,7.45A5,5,0,0,0,16.36,6H3A3,3,0,0,0,0,9V50a4,4,0,0,0,4,4H52.7a4,4,0,0,0,3.87-3l6.79-27.29A3,3,0,0,0,62.81,21.15ZM4,52a2,2,0,0,1-2-2V9A1,1,0,0,1,3,8H16.36a3,3,0,0,1,2.11.87l3.72,3.68A5,5,0,0,0,25.71,14H51a1,1,0,0,1,1,1v5H16.51a4,4,0,0,0-3.88,3L6,49.7S5.46,52,4,52ZM61.41,23.24,54.63,50.52A2,2,0,0,1,52.7,52H7.21A6.28,6.28,0,0,0,8,50.15L9.49,44H45a1,1,0,0,0,0-2H10l4.59-18.48A2,2,0,0,1,16.51,22H60.44a1,1,0,0,1,1,1.24Z"
          ></path>
        </svg>
      )
      break
    case "fileRecovery":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="90"
          height="90"
          viewBox="0 0 64 64"
        >
          <path
            fill="#85cbf8"
            d="M51,43.77v5.82a2,2,0,0,1-1,1.72L33,61.39a2,2,0,0,1-2,0L14,51.31a2,2,0,0,1-1-1.72V43l16-5.61,3.08-1.08,3,1.16Z"
          ></path>
          <path
            fill="#9fddff"
            d="M13.72 24.89L27.02 9.06 50.41 24.89 31.09 36.97 13.72 24.89z"
          ></path>
          <path
            fill="#7bbeeb"
            d="M51,44.77v2.17l-5.58,3.67a1,1,0,0,1-1.19-.07L32.71,40.85a1,1,0,0,0-1.29,0L19.9,50.54a1,1,0,0,1-1.19.07L13,46.85V44l16-7.61h6.16Z"
          ></path>
          <path
            fill="#85cbf8"
            d="M61.86 14L45.42 3.16a1 1 0 0 0-1.19.07L32.07 13.47 50.42 24.89l11.52-9.3A1 1 0 0 0 61.86 14zM32.07 13.47L19.9 3.23a1 1 0 0 0-1.19-.07L2.28 14a1 1 0 0 0-.08 1.61l11.52 9.3 10.36-6.44"
          ></path>
          <path
            fill="#85cbf8"
            d="M32.07,36.31,19.9,46.54a1,1,0,0,1-1.19.07L2.28,35.8a1,1,0,0,1-.08-1.61l11.52-9.3L32.07,36.31,50.42,24.89l11.52,9.3a1,1,0,0,1-.08,1.61L45.42,46.61a1,1,0,0,1-1.19-.07L32.07,36.31Z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M27.35,17.4a1,1,0,0,0,.53-.15l1.35-.84a1,1,0,1,0-1.06-1.7l-1.35.84a1,1,0,0,0,.53,1.85Z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M52,24.89l10.55-8.52a2,2,0,0,0-.16-3.23L46,2.33a2,2,0,0,0-2.39.14L32.07,12.16,20.55,2.47a2,2,0,0,0-2.39-.14L1.73,13.14a2,2,0,0,0-.16,3.23l10.55,8.52L1.57,33.41a2,2,0,0,0,.16,3.23L12,43.39v6.2a3,3,0,0,0,1.47,2.58l17,10.08a3,3,0,0,0,3.06,0l17-10.08A3,3,0,0,0,52,49.59V43.77a1,1,0,0,0-.05-.25L62.4,36.63a2,2,0,0,0,.16-3.23ZM44.87,4,61.31,14.81l-11,8.85L33.76,13.35ZM19.26,4,31.42,14.23l.07,0,0,0,17,10.57L32.15,35.08,32.07,35l-.09.07L15.61,24.89l9-5.6a1,1,0,1,0-1.06-1.7l-9.75,6.07-11-8.85ZM13.79,26.11,30.37,36.43,19.26,45.78,2.83,35ZM50,49.59a1,1,0,0,1-.49.86l-17,10.08a1,1,0,0,1-1,0l-17-10.08a1,1,0,0,1-.49-.86V44.71l4.16,2.74a2,2,0,0,0,2.39-.14l11.52-9.69,11.52,9.69a2,2,0,0,0,2.39.14l4-2.65Zm-5.13-3.81L33.76,36.43,50.34,26.11l11,8.85Z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M33 41H31a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM33 46H31a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM33 51H31a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM33 56H31a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z"
          ></path>
        </svg>
      )
      break
    case "user-info":
      iconElement = (
        <svg
          width="18"
          height="18"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM5.07 16.28C5.5 15.38 8.12 14.5 10 14.5C11.88 14.5 14.51 15.38 14.93 16.28C13.57 17.36 11.86 18 10 18C8.14 18 6.43 17.36 5.07 16.28ZM16.36 14.83C14.93 13.09 11.46 12.5 10 12.5C8.54 12.5 5.07 13.09 3.64 14.83C2.62 13.49 2 11.82 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 11.82 17.38 13.49 16.36 14.83ZM10 4C8.06 4 6.5 5.56 6.5 7.5C6.5 9.44 8.06 11 10 11C11.94 11 13.5 9.44 13.5 7.5C13.5 5.56 11.94 4 10 4ZM10 9C9.17 9 8.5 8.33 8.5 7.5C8.5 6.67 9.17 6 10 6C10.83 6 11.5 6.67 11.5 7.5C11.5 8.33 10.83 9 10 9Z"
            fill="black"
          />
        </svg>
      )
      break
    case "pendding":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="90"
          height="90"
          viewBox="0 0 64 64"
        >
          <path
            fill="#c5e4fa"
            d="M31 3A28 28 0 1 0 31 59A28 28 0 1 0 31 3Z"
          ></path>
          <path
            fill="#e3f2ff"
            d="M12.71 52.29a28 28 0 0 0 9.18 5.82L56 24V17.57a28.1 28.1 0 0 0-3.71-4.86zM10.76 50.24L50 11H44L8.22 46.78A28.08 28.08 0 0 0 10.76 50.24zM7.79 43.21L41 10 38 8 6.36 39.64A27.81 27.81 0 0 0 7.79 43.21z"
          ></path>
          <path
            fill="#72caaf"
            d="M31,3A28,28,0,1,0,59,31,28,28,0,0,0,31,3Zm0,50A22,22,0,1,1,46.17,15.07l.68.67q.39.4.75.82A22,22,0,0,1,31,53Z"
          ></path>
          <path
            fill="#66bfa1"
            d="M31,53A22,22,0,0,1,9,31H7.34a4,4,0,0,0-3.95,4.71,28,28,0,0,0,55.21,0A4,4,0,0,0,54.66,31H53A22,22,0,0,1,31,53Z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M31,2A29,29,0,1,0,60,31,29,29,0,0,0,31,2Zm0,56A27,27,0,1,1,58,31,27,27,0,0,1,31,58Z"
          ></path>
          <path
            fill="#ed7899"
            d="M31,18a1,1,0,0,0,1-1V15a1,1,0,0,0-2,0v2A1,1,0,0,0,31,18Z"
          ></path>
          <path fill="#8d6c9f" d="M15,30a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"></path>
          <path
            fill="#ed7899"
            d="M48,31a1,1,0,0,0-1-1H45a1,1,0,0,0,0,2h2A1,1,0,0,0,48,31Z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M30,45v2a1,1,0,0,0,2,0V45a1,1,0,0,0-2,0Z"
          ></path>
          <path
            fill="#ed7899"
            d="M35.87 18.95a1 1 0 0 0 1.3-.55l.75-1.85a1 1 0 0 0-1.85-.75l-.75 1.85A1 1 0 0 0 35.87 18.95zM45.46 37.92a1 1 0 0 0 .75-1.85l-1.85-.75a1 1 0 0 0-.75 1.85zM40 20.23a1 1 0 0 0 1.44 1.39l1.39-1.44A1 1 0 0 0 41.4 18.8zM41.77 40a1 1 0 0 0-1.41 0 1 1 0 0 0-.25.56 1 1 0 0 0 .19 1.12L41.61 43A1 1 0 0 0 43 43a.39.39 0 0 1 .21-.21 1 1 0 0 0 0-1.41zM45.21 23.58l-1.83.81a1 1 0 1 0 .81 1.83L46 25.41a1 1 0 1 0-.81-1.83z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M38.5,39.5a1,1,0,0,0,.71-1.71l-6.28-6.28A1.94,1.94,0,0,0,32,29.28V21a1,1,0,0,0-2,0v8.28a2,2,0,0,0,1.51,3.65l6.28,6.28A1,1,0,0,0,38.5,39.5Z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M31,54A23,23,0,1,1,34.36,8.24a1,1,0,0,1-.29,2A21.28,21.28,0,0,0,31,10a21,21,0,1,0,13,4.48,1,1,0,0,1,1.24-1.57A23,23,0,0,1,31,54Z"
          ></path>
          <path
            fill="#8d6c9f"
            d="M41,12.4a1,1,0,0,1-.45-.11,21,21,0,0,0-2.31-1,1,1,0,0,1,.69-1.88,23,23,0,0,1,2.53,1.11A1,1,0,0,1,41,12.4Z"
          ></path>
        </svg>
      )
      break
    case "word-update":
      iconElement = (
        <svg
          width="18px"
          height="18px"
          viewBox="0 0 800 800"
          enable-background="new 0 0 800 800"
          id="GUIDE"
          version="1.1"
          space="preserve"
          xmlns="http://www.w3.org/2000/svg"
          cc="http://creativecommons.org/ns#"
          dc="http://purl.org/dc/elements/1.1/"
          inkscape="http://www.inkscape.org/namespaces/inkscape"
          rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
          sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
          svg="http://www.w3.org/2000/svg"
          xlink="http://www.w3.org/1999/xlink"
          fill="#000000"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <g>
              <path d="M774.721,110.344c4.668-10.011,0.337-21.91-9.674-26.578L649.241,29.765c-4.807-2.242-10.309-2.482-15.292-0.668 c-4.985,1.814-9.045,5.534-11.287,10.342l-59.898,128.455l-29.281-86.015c-2.76-8.104-10.372-13.555-18.934-13.555H121.323 c-6.015,0-11.71,2.707-15.508,7.37l-77.922,95.678c-4.352,5.344-5.646,12.551-3.425,19.075L217.865,758.55 c2.759,8.104,10.371,13.555,18.933,13.555H659.33c11.047,0,20-8.954,20-20s-8.953-20-20-20H251.116L71.339,204.007l94.295,0.02 c0.001,0,0.003,0,0.004,0c6.824,0,13.178-3.479,16.853-9.229c3.676-5.751,4.164-12.98,1.296-19.174l-31.162-67.3H500.23 l38.11,111.947L405.278,505.625c-1.536,3.292-2.108,6.908-1.749,10.463c-0.008,0.002-0.015,0.003-0.023,0.005l12.581,124.188 c0.711,7.012,5.059,13.132,11.446,16.11c2.69,1.255,5.576,1.874,8.45,1.874c3.948,0,7.875-1.168,11.247-3.461l103.225-70.188 c-0.002-0.003-0.003-0.006-0.004-0.009c2.886-1.958,5.303-4.688,6.884-8.078l59.123-126.789l105.126,308.81 c2.833,8.321,10.605,13.56,18.932,13.56c2.137,0,4.312-0.345,6.447-1.072c10.457-3.559,16.047-14.922,12.488-25.378 L640.883,397.363L774.721,110.344z M85.477,164.01l31.145-38.242l17.713,38.252L85.477,164.01z M650.463,74.47l79.554,37.096 l-18.285,39.214l-79.554-37.097L650.463,74.47z M446.85,547.077l52.008,24.251L452.5,602.85L446.85,547.077z M529.535,541.499 l-79.553-37.096l165.291-354.468l79.553,37.097L529.535,541.499z"></path>
              <path d="M608.921,220.086L528.08,393.45c-4.668,10.011-0.338,21.91,9.674,26.578c2.734,1.275,5.609,1.879,8.438,1.879 c7.532,0,14.747-4.275,18.14-11.553l80.841-173.364c4.669-10.011,0.337-21.91-9.674-26.578 C625.49,205.743,613.589,210.075,608.921,220.086z"></path>
              <path d="M528.939,438.928c-10.01-4.668-21.91-0.336-26.578,9.675l-2.725,5.843c-4.667,10.012-0.336,21.911,9.676,26.578 c2.734,1.275,5.607,1.879,8.438,1.879c7.533,0,14.748-4.277,18.141-11.553l2.725-5.844 C543.283,455.494,538.951,443.595,528.939,438.928z"></path>
              <path d="M176.516,244.257c-11.046,0-20,8.954-20,20s8.954,20,20,20h3.322c11.046,0,20-8.954,20-20s-8.954-20-20-20H176.516z"></path>
              <path d="M443.271,284.257c11.046,0,20-8.954,20-20s-8.954-20-20-20H240.67c-11.045,0-20,8.954-20,20s8.955,20,20,20H443.271z"></path>
              <path d="M418.624,420.214c0-11.046-8.954-20-20-20H229.608c-11.046,0-20,8.954-20,20s8.954,20,20,20h169.016 C409.67,440.214,418.624,431.26,418.624,420.214z"></path>
              <path d="M282.698,556.171c-11.046,0-20,8.954-20,20s8.954,20,20,20h80.904c11.046,0,20-8.954,20-20s-8.954-20-20-20H282.698z"></path>
            </g>
          </g>
        </svg>
      )
      break
    case "copy-black":
      iconElement = (
        <svg
          width="30"
          height="29"
          viewBox="0 0 30 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 21C11.8954 21 11 20.1046 11 19V3H20L25 8V19C25 20.1046 24.1046 21 23 21H13Z"
            stroke="#343A42"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19 3V9H25"
            stroke="#343A42"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M7 26C5.89543 26 5 25.1046 5 24V8H14L19 13V24C19 25.1046 18.1046 26 17 26H7Z"
            fill="white"
            stroke="#343A42"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13 8V14H19"
            stroke="#343A42"
            stroke-width="2"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "delete-red-row":
      iconElement = (
        <svg
          width="18px"
          height="18px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path
              d="M7 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2h4a1 1 0 1 1 0 2h-1.069l-.867 12.142A2 2 0 0 1 17.069 22H6.93a2 2 0 0 1-1.995-1.858L4.07 8H3a1 1 0 0 1 0-2h4V4zm2 2h6V4H9v2zM6.074 8l.857 12H17.07l.857-12H6.074zM10 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1z"
              fill="#fa0000"
            ></path>
          </g>
        </svg>
      )
      break
    case "arrow-back-sign":
      iconElement = (
        <svg
          width="18px"
          height="18px"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          transform="matrix(-1, 0, 0, -1, 0, 0)"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              stroke="#154398"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11 18h3.75a5.25 5.25 0 100-10.5H5M7.5 4L4 7.5 7.5 11"
            ></path>{" "}
          </g>
        </svg>
      )
      break
    case "notepad":
      iconElement = (
        <svg
          fill="#154398"
          width="18px"
          height="18px"
          viewBox="0 0 1920 1920"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="">
            {" "}
            <g fill-rule="evenodd">
              {" "}
              <path d="M106.667 267H320v213.333h853.33V267h213.34v160h106.66V160.333h-329.1C1142.26 98.19 1083 53.667 1013.33 53.667H480c-69.665 0-128.931 44.523-150.896 106.666H0V1867h1493.33v-320h-106.66v213.33H106.667V267Zm320 106.667v-160c0-29.456 23.878-53.334 53.333-53.334h533.33c29.46 0 53.34 23.878 53.34 53.334v160H426.667Z"></path>{" "}
              <path d="m1677.57 528.309 225.88 225.883c22.02 22.023 22.02 57.713 0 79.849L1225.8 1511.69c-10.62 10.5-24.96 16.49-39.98 16.49H959.937c-31.171 0-56.47-25.3-56.47-56.47v-225.89c0-15.02 5.986-29.36 16.489-39.86L1597.6 528.309c22.14-22.136 57.83-22.136 79.97 0Zm-155.41 235.144 146.03 146.033 115.43-115.426-146.04-146.033-115.42 115.426Zm-505.75 651.787h146.03l425.9-425.9-146.03-146.038-425.9 425.898v146.04Z"></path>{" "}
            </g>{" "}
          </g>
        </svg>
      )
      break
    case "delete-black-row":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 11V17"
            stroke="#343A42"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 11V17"
            stroke="#343A42"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6 7V19C6 20.1046 6.89543 21 8 21H16C17.1046 21 18 20.1046 18 19V7"
            stroke="#343A42"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4 7H20"
            stroke="#343A42"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7 7L9 3H15L17 7"
            stroke="#343A42"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "pne-black-arrow":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 3V2C2.44772 2 2 2.44772 2 3H3ZM18.293 14.293L17.3818 13.8809C17.2104 14.2601 17.2916 14.7058 17.5859 15.0001L18.293 14.293ZM21 17L21.7071 17.7071C22.0976 17.3166 22.0976 16.6834 21.7071 16.2929L21 17ZM17 21L16.2929 21.7071C16.6834 22.0976 17.3166 22.0976 17.7071 21.7071L17 21ZM14.293 18.293L15.0001 17.5859C14.7058 17.2916 14.2601 17.2104 13.8809 17.3818L14.293 18.293ZM11 2H3V4H11V2ZM20 11C20 6.02944 15.9706 2 11 2V4C14.866 4 18 7.13401 18 11H20ZM19.2041 14.7051C19.7157 13.5738 20 12.3188 20 11H18C18 12.029 17.7786 13.0036 17.3818 13.8809L19.2041 14.7051ZM17.5859 15.0001L20.2929 17.7071L21.7071 16.2929L19.0001 13.5859L17.5859 15.0001ZM20.2929 16.2929L16.2929 20.2929L17.7071 21.7071L21.7071 17.7071L20.2929 16.2929ZM17.7071 20.2929L15.0001 17.5859L13.5859 19.0001L16.2929 21.7071L17.7071 20.2929ZM11 20C12.3188 20 13.5738 19.7157 14.7051 19.2041L13.8809 17.3818C13.0036 17.7786 12.029 18 11 18V20ZM2 11C2 15.9706 6.02944 20 11 20V18C7.13401 18 4 14.866 4 11H2ZM2 3V11H4V3H2Z"
            fill="#343A42"
          />
          <ellipse
            cx="11"
            cy="11"
            rx="2"
            ry="2"
            transform="rotate(-180 11 11)"
            fill="#343A42"
          />
          <path
            d="M3 3L11 11"
            stroke="#343A42"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "eye-black":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
            stroke="#343A42"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2 12C3.60014 7.90264 7.33603 5 12 5C16.664 5 20.3999 7.90264 22 12C20.3999 16.0974 16.664 19 12 19C7.33603 19 3.60014 16.0974 2 12Z"
            stroke="#343A42"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "right-arrow-backup":
      iconElement = (
        <svg
          width="20px"
          height="20px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.29289 4.29289C8.68342 3.90237 9.31658 3.90237 9.70711 4.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L9.70711 19.7071C9.31658 20.0976 8.68342 20.0976 8.29289 19.7071C7.90237 19.3166 7.90237 18.6834 8.29289 18.2929L14.5858 12L8.29289 5.70711C7.90237 5.31658 7.90237 4.68342 8.29289 4.29289Z"
              fill="#ffffff"
            ></path>{" "}
          </g>
        </svg>
      )
      break
    case "left-arrow-backup":
      iconElement = (
        <svg
          width="20px"
          height="20px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#ffffff"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L9.41421 12L15.7071 18.2929C16.0976 18.6834 16.0976 19.3166 15.7071 19.7071C15.3166 20.0976 14.6834 20.0976 14.2929 19.7071L7.29289 12.7071C7.10536 12.5196 7 12.2652 7 12C7 11.7348 7.10536 11.4804 7.29289 11.2929L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289Z"
              fill="#ffffff"
            ></path>{" "}
          </g>
        </svg>
      )
      break
    case "search-company-new":
      iconElement = (
        <svg
          width="21px"
          height="21px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.25 5.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zM7 6a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2H7zm0 5a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H7zm-1 6a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1zm-4-5a1.25 1.25 0 1 1 2.5 0A1.25 1.25 0 0 1 2 12zm1.25 3.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5z"
              fill="#000000"
            ></path>
          </g>
        </svg>
      )
      break
    case "user-company-new":
      iconElement = (
        <svg
          width="21px"
          height="21px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              d="M12 12.75C11.2583 12.75 10.5333 12.5301 9.91661 12.118C9.29993 11.706 8.81928 11.1203 8.53545 10.4351C8.25163 9.74984 8.17736 8.99584 8.32206 8.26841C8.46675 7.54098 8.8239 6.8728 9.34835 6.34835C9.8728 5.8239 10.541 5.46675 11.2684 5.32206C11.9958 5.17736 12.7498 5.25162 13.4351 5.53545C14.1203 5.81928 14.706 6.29993 15.118 6.91661C15.5301 7.5333 15.75 8.25832 15.75 9C15.75 9.99456 15.3549 10.9484 14.6517 11.6517C13.9484 12.3549 12.9946 12.75 12 12.75ZM12 6.75C11.555 6.75 11.12 6.88196 10.75 7.12919C10.38 7.37643 10.0916 7.72783 9.92127 8.13896C9.75098 8.5501 9.70642 9.0025 9.79323 9.43895C9.88005 9.87541 10.0943 10.2763 10.409 10.591C10.7237 10.9057 11.1246 11.12 11.561 11.2068C11.9975 11.2936 12.4499 11.249 12.861 11.0787C13.2722 10.9084 13.6236 10.62 13.8708 10.25C14.118 9.88002 14.25 9.44501 14.25 9C14.25 8.40326 14.0129 7.83097 13.591 7.40901C13.169 6.98705 12.5967 6.75 12 6.75Z"
              fill="#000000"
            ></path>{" "}
            <path
              d="M19 19.75C18.8019 19.7474 18.6126 19.6676 18.4725 19.5275C18.3324 19.3874 18.2526 19.1981 18.25 19C18.25 17.05 17.19 15.75 12 15.75C6.81 15.75 5.75 17.05 5.75 19C5.75 19.1989 5.67098 19.3897 5.53033 19.5303C5.38968 19.671 5.19891 19.75 5 19.75C4.80109 19.75 4.61032 19.671 4.46967 19.5303C4.32902 19.3897 4.25 19.1989 4.25 19C4.25 14.25 9.68 14.25 12 14.25C14.32 14.25 19.75 14.25 19.75 19C19.7474 19.1981 19.6676 19.3874 19.5275 19.5275C19.3874 19.6676 19.1981 19.7474 19 19.75Z"
              fill="#000000"
            ></path>{" "}
            <path
              d="M19 14.5C18.8019 14.4974 18.6126 14.4176 18.4725 14.2775C18.3324 14.1374 18.2526 13.9481 18.25 13.75V10.25C18.25 10.0511 18.329 9.86032 18.4697 9.71967C18.6103 9.57902 18.8011 9.5 19 9.5C19.1989 9.5 19.3897 9.57902 19.5303 9.71967C19.671 9.86032 19.75 10.0511 19.75 10.25V13.75C19.7474 13.9481 19.6676 14.1374 19.5275 14.2775C19.3874 14.4176 19.1981 14.4974 19 14.5Z"
              fill="#000000"
            ></path>{" "}
            <path
              d="M20.75 12.75H17.25C17.0511 12.75 16.8603 12.671 16.7197 12.5303C16.579 12.3897 16.5 12.1989 16.5 12C16.5 11.8011 16.579 11.6103 16.7197 11.4697C16.8603 11.329 17.0511 11.25 17.25 11.25H20.75C20.9489 11.25 21.1397 11.329 21.2803 11.4697C21.421 11.6103 21.5 11.8011 21.5 12C21.5 12.1989 21.421 12.3897 21.2803 12.5303C21.1397 12.671 20.9489 12.75 20.75 12.75Z"
              fill="#000000"
            ></path>{" "}
          </g>
        </svg>
      )
      break
    case "calender-company":
      iconElement = (
        <svg
          width="21px"
          height="21px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17 2C17 1.44772 16.5523 1 16 1C15.4477 1 15 1.44772 15 2V3H9V2C9 1.44772 8.55228 1 8 1C7.44772 1 7 1.44772 7 2V3H5C3.34315 3 2 4.34315 2 6V20C2 21.6569 3.34315 23 5 23H19C20.6569 23 22 21.6569 22 20V6C22 4.34315 20.6569 3 19 3H17V2ZM20 9V6C20 5.44772 19.5523 5 19 5H17V6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6V5H9V6C9 6.55228 8.55228 7 8 7C7.44772 7 7 6.55228 7 6V5H5C4.44772 5 4 5.44772 4 6V9H20ZM4 11H20V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V11Z"
              fill="#000000"
            ></path>{" "}
          </g>
        </svg>
      )
      break
    case "user-company":
      iconElement = (
        <svg
          width="21px"
          height="21px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9ZM15.8243 13.6235C17.1533 12.523 18 10.8604 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 10.8604 6.84668 12.523 8.17572 13.6235C4.98421 14.7459 3 17.2474 3 20C3 20.5523 3.44772 21 4 21C4.55228 21 5 20.5523 5 20C5 17.7306 7.3553 15 12 15C16.6447 15 19 17.7306 19 20C19 20.5523 19.4477 21 20 21C20.5523 21 21 20.5523 21 20C21 17.2474 19.0158 14.7459 15.8243 13.6235Z"
              fill="#000000"
            ></path>{" "}
          </g>
        </svg>
      )
      break
    case "history-company":
      iconElement = (
        <svg
          width="21px"
          height="21px"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <g fill="#000000">
              {" "}
              <path d="M1.5 1.25a.75.75 0 011.5 0v1.851A7 7 0 111 8a.75.75 0 011.5 0 5.5 5.5 0 101.725-4H5.75a.75.75 0 010 1.5h-3.5a.75.75 0 01-.75-.75v-3.5z"></path>{" "}
              <path d="M8.25 4a.75.75 0 01.75.75v3.763l1.805.802a.75.75 0 01-.61 1.37l-2.25-1A.75.75 0 017.5 9V4.75A.75.75 0 018.25 4z"></path>{" "}
            </g>{" "}
          </g>
        </svg>
      )
      break
    case "service-company":
      iconElement = (
        <svg
          fill="#000000"
          width="21px"
          height="21px"
          viewBox="0 0 24.00 24.00"
          xmlns="http://www.w3.org/2000/svg"
          data-name="Layer 1"
          stroke="#000000"
          stroke-width="0.00024000000000000003"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke="#CCCCCC"
            stroke-width="0.048"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path d="M22,16H19.82A3,3,0,0,0,20,15V10a3,3,0,0,0-3-3H11a3,3,0,0,0-3,3v5a3,3,0,0,0,.18,1H7a1,1,0,0,1-1-1V5A3,3,0,0,0,3,2H2A1,1,0,0,0,2,4H3A1,1,0,0,1,4,5V15a3,3,0,0,0,2.22,2.88,3,3,0,1,0,5.6.12h3.36a3,3,0,1,0,5.64,0H22a1,1,0,0,0,0-2ZM9,20a1,1,0,1,1,1-1A1,1,0,0,1,9,20Zm2-4a1,1,0,0,1-1-1V10a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v5a1,1,0,0,1-1,1Zm7,4a1,1,0,1,1,1-1A1,1,0,0,1,18,20Z"></path>
          </g>
        </svg>
      )
      break
    case "searchWhite":
      iconElement = (
        <svg
          width="55px"
          height="60px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <g id="Interface / Search_Magnifying_Glass">
              <path
                id="Vector"
                d="M15 15L21 21M10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17Z"
                stroke="#ffffff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </g>
          </g>
        </svg>
      )
      break
    case "briefcaseWhite":
      iconElement = (
        <svg
          width="55px"
          height="60px"
          viewBox="0 0 24.00 24.00"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#ffffff"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              opacity="0.1"
              d="M21 11.152C20.7154 12.0872 20.2501 12.9557 19.6405 13.7265C17.9516 15.8622 15.1545 17.25 12 17.25C8.84545 17.25 6.04844 15.8622 4.35949 13.7265C3.74993 12.9557 3.28461 12.0872 3 11.152V17C3 18.8856 3 19.8284 3.58579 20.4142C4.17157 21 5.11438 21 7 21H17C18.8856 21 19.8284 21 20.4142 20.4142C21 19.8284 21 18.8856 21 17V11.152Z"
              fill="#fcfcfc"
            ></path>{" "}
            <path
              d="M3 10C3 9.06812 3 8.60218 3.15224 8.23463C3.35523 7.74458 3.74458 7.35523 4.23463 7.15224C4.60218 7 5.06812 7 6 7V7H18V7C18.9319 7 19.3978 7 19.7654 7.15224C20.2554 7.35523 20.6448 7.74458 20.8478 8.23463C21 8.60218 21 9.06812 21 10V17C21 18.8856 21 19.8284 20.4142 20.4142C19.8284 21 18.8856 21 17 21H16H8H7C5.11438 21 4.17157 21 3.58579 20.4142C3 19.8284 3 18.8856 3 17V10Z"
              stroke="#fcfcfc"
              stroke-width="2"
              stroke-linejoin="round"
            ></path>{" "}
            <path
              d="M8 7V5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V7"
              stroke="#fcfcfc"
              stroke-width="2"
              stroke-linejoin="round"
            ></path>{" "}
            <path
              d="M3 10C3.18614 11.3166 3.73499 12.5338 4.55558 13.5714C6.19462 15.644 8.91777 17 12 17C15.0822 17 17.8054 15.644 19.4444 13.5714C20.265 12.5338 20.8139 11.3166 21 10"
              stroke="#fcfcfc"
              stroke-width="2"
              stroke-linecap="round"
            ></path>{" "}
            <path
              d="M11.5 13H12.5"
              stroke="#fcfcfc"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>{" "}
          </g>
        </svg>
      )
      break
    case "Star":
      iconElement = (
        <svg
          data-v-2f8a5019=""
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          class="icon icon-filled"
        >
          <path
            data-v-2f8a5019=""
            stroke="none"
            d="M0 0h24v24H0z"
            fill="none"
          ></path>{" "}
          <path
            data-v-2f8a5019=""
            d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
          ></path>
        </svg>
      )
      break
    case "blue-mark":
      iconElement = (
        <svg
          style={{ color: "#2fb344" }}
          data-v-2f8a5019=""
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          class="icon me-1 text-success"
        >
          <path
            data-v-2f8a5019=""
            stroke="none"
            d="M0 0h24v24H0z"
            fill="none"
          ></path>{" "}
          <path data-v-2f8a5019="" d="M5 12l5 5l10 -10"></path>
        </svg>
      )
      break
    case "red-mark":
      iconElement = (
        <svg
          style={{ color: "#d63939" }}
          data-v-2f8a5019=""
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          class="icon me-1 text-danger"
        >
          <path
            data-v-2f8a5019=""
            stroke="none"
            d="M0 0h24v24H0z"
            fill="none"
          ></path>
          <line data-v-2f8a5019="" x1="18" y1="6" x2="6" y2="18"></line>{" "}
          <line data-v-2f8a5019="" x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      )
      break
    case "user-outline":
      iconElement = (
        <svg
          fill="#333"
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#333"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path d="M12,1A11,11,0,1,0,23,12,11.013,11.013,0,0,0,12,1Zm0,20a9.641,9.641,0,0,1-5.209-1.674,7,7,0,0,1,10.418,0A9.167,9.167,0,0,1,12,21Zm6.694-3.006a8.98,8.98,0,0,0-13.388,0,9,9,0,1,1,13.388,0ZM12,6a4,4,0,1,0,4,4A4,4,0,0,0,12,6Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,12Z"></path>
          </g>
        </svg>
      )
      break
    case "starvn":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 576 512"
          fill="#686868"
        >
          <path d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.6 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z" />
        </svg>
      )
      break
    case "whatsapp-header":
      iconElement = (
        <svg
          width="20px"
          height="20px"
          viewBox="0 0 24 24"
          id="meteor-icon-kit__regular-whatsapp"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke="#CCCCCC"
            stroke-width="0.048"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.5129 3.4866C18.2882 1.24722 15.2597 -0.00837473 12.1032 4.20445e-05C5.54964 4.20445e-05 0.216056 5.33306 0.213776 11.8883C0.210977 13.9746 0.75841 16.0247 1.80085 17.8319L0.114014 23.9932L6.41672 22.34C8.15975 23.2898 10.1131 23.7874 12.0981 23.7874H12.1032C18.6556 23.7874 23.9897 18.4538 23.992 11.8986C24.0022 8.74248 22.7494 5.71347 20.5129 3.4866ZM12.1032 21.7768H12.0992C10.3294 21.7776 8.59195 21.3025 7.06888 20.4012L6.70803 20.1874L2.96836 21.1685L3.96713 17.52L3.73169 17.1461C2.74331 15.5709 2.22039 13.7484 2.22328 11.8889C2.22328 6.44185 6.65615 2.00783 12.1072 2.00783C14.7284 2.00934 17.2417 3.05207 19.0941 4.90662C20.9465 6.76117 21.9863 9.27564 21.9848 11.8969C21.9825 17.3456 17.5496 21.7768 12.1032 21.7768ZM17.5234 14.3755C17.2264 14.2267 15.7659 13.5085 15.4934 13.4064C15.2209 13.3044 15.0231 13.2576 14.8253 13.5552C14.6275 13.8528 14.058 14.5215 13.8847 14.7199C13.7114 14.9182 13.5381 14.9427 13.241 14.794C12.944 14.6452 11.9869 14.3316 10.8519 13.3198C9.96884 12.5319 9.36969 11.5594 9.19867 11.2618C9.02765 10.9642 9.18043 10.8057 9.32922 10.6552C9.46261 10.5224 9.62622 10.3086 9.77444 10.1348C9.92266 9.9609 9.97283 9.83776 10.0714 9.63938C10.1701 9.44099 10.121 9.26769 10.0469 9.1189C9.97283 8.97011 9.37824 7.50788 9.13083 6.9133C8.88969 6.3341 8.64513 6.4122 8.46271 6.40023C8.29169 6.39168 8.09102 6.38997 7.89264 6.38997C7.58822 6.39793 7.30097 6.53267 7.10024 6.76166C6.82831 7.05923 6.061 7.77752 6.061 9.23976C6.061 10.702 7.12532 12.1146 7.27354 12.313C7.42176 12.5114 9.36855 15.5117 12.3472 16.7989C12.9004 17.0375 13.4657 17.2468 14.0409 17.426C14.7523 17.654 15.3999 17.6204 15.9118 17.544C16.4819 17.4585 17.6694 16.8251 17.9173 16.1313C18.1653 15.4376 18.1648 14.8424 18.0884 14.7187C18.012 14.595 17.8204 14.5266 17.5234 14.3778V14.3755Z"
              fill="#989898"
            ></path>
          </g>
          <g id="SVGRepo_iconCarrier">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.5129 3.4866C18.2882 1.24722 15.2597 -0.00837473 12.1032 4.20445e-05C5.54964 4.20445e-05 0.216056 5.33306 0.213776 11.8883C0.210977 13.9746 0.75841 16.0247 1.80085 17.8319L0.114014 23.9932L6.41672 22.34C8.15975 23.2898 10.1131 23.7874 12.0981 23.7874H12.1032C18.6556 23.7874 23.9897 18.4538 23.992 11.8986C24.0022 8.74248 22.7494 5.71347 20.5129 3.4866ZM12.1032 21.7768H12.0992C10.3294 21.7776 8.59195 21.3025 7.06888 20.4012L6.70803 20.1874L2.96836 21.1685L3.96713 17.52L3.73169 17.1461C2.74331 15.5709 2.22039 13.7484 2.22328 11.8889C2.22328 6.44185 6.65615 2.00783 12.1072 2.00783C14.7284 2.00934 17.2417 3.05207 19.0941 4.90662C20.9465 6.76117 21.9863 9.27564 21.9848 11.8969C21.9825 17.3456 17.5496 21.7768 12.1032 21.7768ZM17.5234 14.3755C17.2264 14.2267 15.7659 13.5085 15.4934 13.4064C15.2209 13.3044 15.0231 13.2576 14.8253 13.5552C14.6275 13.8528 14.058 14.5215 13.8847 14.7199C13.7114 14.9182 13.5381 14.9427 13.241 14.794C12.944 14.6452 11.9869 14.3316 10.8519 13.3198C9.96884 12.5319 9.36969 11.5594 9.19867 11.2618C9.02765 10.9642 9.18043 10.8057 9.32922 10.6552C9.46261 10.5224 9.62622 10.3086 9.77444 10.1348C9.92266 9.9609 9.97283 9.83776 10.0714 9.63938C10.1701 9.44099 10.121 9.26769 10.0469 9.1189C9.97283 8.97011 9.37824 7.50788 9.13083 6.9133C8.88969 6.3341 8.64513 6.4122 8.46271 6.40023C8.29169 6.39168 8.09102 6.38997 7.89264 6.38997C7.58822 6.39793 7.30097 6.53267 7.10024 6.76166C6.82831 7.05923 6.061 7.77752 6.061 9.23976C6.061 10.702 7.12532 12.1146 7.27354 12.313C7.42176 12.5114 9.36855 15.5117 12.3472 16.7989C12.9004 17.0375 13.4657 17.2468 14.0409 17.426C14.7523 17.654 15.3999 17.6204 15.9118 17.544C16.4819 17.4585 17.6694 16.8251 17.9173 16.1313C18.1653 15.4376 18.1648 14.8424 18.0884 14.7187C18.012 14.595 17.8204 14.5266 17.5234 14.3778V14.3755Z"
              fill="#989898"
            ></path>
          </g>
        </svg>
      )
      break
    case "note-header":
      iconElement = (
        <svg
          width="20px"
          height="20px"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
          fill="#989898"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke="#CCCCCC"
            stroke-width="0.16"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2 2l1-1h9l1 1v12l-1 1H3l-1-1V2zm1 0v12h9V2H3zm1 2l1-1h5l1 1v1l-1 1H5L4 5V4zm1 0v1h5V4H5zm10 1h-1v2h1V5zm-1 3h1v2h-1V8zm1 3h-1v2h1v-2z"
            ></path>
          </g>
          <g id="SVGRepo_iconCarrier">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2 2l1-1h9l1 1v12l-1 1H3l-1-1V2zm1 0v12h9V2H3zm1 2l1-1h5l1 1v1l-1 1H5L4 5V4zm1 0v1h5V4H5zm10 1h-1v2h1V5zm-1 3h1v2h-1V8zm1 3h-1v2h1v-2z"
            ></path>
          </g>
        </svg>
      )
      break
    case "briefcase-header":
      iconElement = (
        <svg
          fill="#424242"
          height="20px"
          width="20px"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 297.001 297.001"
          stroke="#424242"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <g>
              {" "}
              <g>
                {" "}
                <g>
                  {" "}
                  <path d="M257.424,46.164h-50.117V33.563c0-16.984-13.819-30.803-30.804-30.803h-56.007c-16.984,0-30.803,13.819-30.803,30.803 v12.601H39.576C17.754,46.164,0,63.918,0,85.74v168.925c0,21.822,17.754,39.576,39.576,39.576h217.849 c21.822,0,39.576-17.754,39.576-39.576V85.74C297,63.918,279.246,46.164,257.424,46.164z M109.46,33.563 c0-6.086,4.95-11.036,11.036-11.036h56.007c6.086,0,11.037,4.95,11.037,11.036v12.601h-78.08V33.563z M277.231,254.664 c0.002,10.923-8.885,19.809-19.807,19.809H39.576c-10.922,0-19.809-8.887-19.809-19.809V175.34 c5.463,3.02,11.737,4.745,18.408,4.745h2.594v6.424c0,14.442,11.749,26.191,26.191,26.191s26.191-11.749,26.191-26.191v-6.424 h110.696v6.424c0,14.442,11.749,26.191,26.191,26.191s26.191-11.749,26.191-26.191v-6.424h2.594 c6.671,0,12.945-1.725,18.408-4.745V254.664z M60.537,186.51v-32.616c0-3.542,2.882-6.424,6.424-6.424s6.424,2.882,6.424,6.424 v32.616c0,3.542-2.882,6.424-6.424,6.424S60.537,190.052,60.537,186.51z M223.615,186.51v-32.616 c0-3.542,2.882-6.424,6.424-6.424s6.424,2.882,6.424,6.424v32.616c0,3.542-2.882,6.424-6.424,6.424 S223.615,190.052,223.615,186.51z M277.234,141.911c0,10.15-8.258,18.408-18.408,18.408h-2.594v-6.424 c0-14.442-11.749-26.191-26.191-26.191s-26.191,11.749-26.191,26.191v6.424H93.152v-6.424c0-14.442-11.749-26.191-26.191-26.191 s-26.191,11.748-26.191,26.19v6.424h-2.594c-10.15,0-18.408-8.258-18.408-18.408V85.74h-0.001 c0-10.922,8.886-19.809,19.809-19.809h217.849c10.922,0,19.809,8.886,19.809,19.809V141.911z"></path>{" "}
                  <path d="M181.116,194.911h-65.231c-4.367,0-7.907,3.54-7.907,7.907s3.54,7.907,7.907,7.907h65.231 c4.367,0,7.907-3.54,7.907-7.907C189.022,198.451,185.482,194.911,181.116,194.911z"></path>{" "}
                </g>{" "}
              </g>{" "}
            </g>{" "}
          </g>
        </svg>
      )
      break
    case "user-ability":
      iconElement = (
        <svg
          width="21"
          height="17"
          viewBox="0 0 21 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 16C13 13.7909 10.3137 12 7 12C3.68629 12 1 13.7909 1 16M17 13V7M14 10H20M7 9C4.79086 9 3 7.20914 3 5C3 2.79086 4.79086 1 7 1C9.20914 1 11 2.79086 11 5C11 7.20914 9.20914 9 7 9Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "share-android":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 13.5L15 16.5M15 7.5L9 10.5M18 21C16.3431 21 15 19.6569 15 18C15 16.3431 16.3431 15 18 15C19.6569 15 21 16.3431 21 18C21 19.6569 19.6569 21 18 21ZM6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12C9 13.6569 7.65685 15 6 15ZM18 9C16.3431 9 15 7.65685 15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6C21 7.65685 19.6569 9 18 9Z"
            stroke="#686868"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "specialize":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 12L12 18L3 12M21 16L12 22L3 16M21 8L12 14L3 8L12 2L21 8Z"
            stroke="#686868"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "container-d":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 15C13.8954 15 13 15.8954 13 17C13 18.1046 13.8954 19 15 19C16.1046 19 17 18.1046 17 17C17 15.8954 16.1046 15 15 15ZM15 15H7.29395C6.83269 15 6.60197 15 6.41211 14.918C6.24466 14.8456 6.09934 14.7288 5.99349 14.5802C5.87348 14.4118 5.82609 14.1863 5.72945 13.7353L3.27148 2.26477C3.17484 1.81376 3.12587 1.58825 3.00586 1.4198C2.90002 1.27123 2.75525 1.15441 2.5878 1.08205C2.39794 1 2.16779 1 1.70653 1H1M4 4H16.8732C17.595 4 17.9557 4 18.1979 4.15036C18.4101 4.28206 18.5652 4.48838 18.6329 4.72876C18.7102 5.00319 18.611 5.34996 18.411 6.04346L17.0264 10.8435C16.9068 11.2581 16.8469 11.4655 16.7256 11.6193C16.6185 11.7551 16.4772 11.8608 16.3171 11.926C16.1356 12 15.9199 12 15.4883 12H5.73047M6 19C4.89543 19 4 18.1046 4 17C4 15.8954 4.89543 15 6 15C7.10457 15 8 15.8954 8 17C8 18.1046 7.10457 19 6 19Z"
            stroke="#686868"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "chat-conver-d":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 8H20C20.5523 8 21 8.44772 21 9V20L17.6665 17.2308C17.487 17.0817 17.2612 17 17.0278 17H9C8.44771 17 8 16.5523 8 16V13M15 4C15.5523 4 16 4.44772 16 5V12C16 12.5523 15.5523 13 15 13H6.97217C6.73875 13 6.51304 13.0817 6.3335 13.2308L3 16V5C3 4.44772 3.44772 4 4 4H15Z"
            stroke="#686868"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "calendar-d":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 7C3.44772 7 3 7.44772 3 8C3 8.55228 3.44772 9 4 9V7ZM20 9C20.5523 9 21 8.55228 21 8C21 7.44772 20.5523 7 20 7V9ZM5.0918 19.782L5.54579 18.891H5.54579L5.0918 19.782ZM4.21799 18.908L3.32698 19.362H3.32698L4.21799 18.908ZM19.7822 18.908L18.8912 18.454L19.7822 18.908ZM18.9078 19.782L18.4538 18.891L18.9078 19.782ZM18.9078 4.21799L19.3618 3.32698V3.32698L18.9078 4.21799ZM19.7822 5.09204L18.8912 5.54603L19.7822 5.09204ZM5.0918 4.21799L5.54579 5.10899L5.0918 4.21799ZM4.21799 5.09204L5.10899 5.54603L4.21799 5.09204ZM14.5 15C15.0523 15 15.5 14.5523 15.5 14C15.5 13.4477 15.0523 13 14.5 13V15ZM9.5 13C8.94772 13 8.5 13.4477 8.5 14C8.5 14.5523 8.94772 15 9.5 15V13ZM13 11.5C13 10.9477 12.5523 10.5 12 10.5C11.4477 10.5 11 10.9477 11 11.5H13ZM11 16.5C11 17.0523 11.4477 17.5 12 17.5C12.5523 17.5 13 17.0523 13 16.5H11ZM17 2C17 1.44772 16.5523 1 16 1C15.4477 1 15 1.44772 15 2H17ZM15 4C15 4.55228 15.4477 5 16 5C16.5523 5 17 4.55228 17 4H15ZM9 2C9 1.44772 8.55228 1 8 1C7.44772 1 7 1.44772 7 2H9ZM7 4C7 4.55228 7.44772 5 8 5C8.55228 5 9 4.55228 9 4H7ZM4 9H20V7H4V9ZM7.2002 5H16.8002V3H7.2002V5ZM19 7.19995V16.8H21V7.19995H19ZM16.8002 19H7.2002V21H16.8002V19ZM5 16.8V7.19995H3V16.8H5ZM7.2002 19C6.62367 19 6.25127 18.9992 5.96782 18.9761C5.69598 18.9538 5.59519 18.9161 5.54579 18.891L4.63781 20.673C5.01623 20.8658 5.40959 20.9371 5.80496 20.9694C6.18873 21.0008 6.65662 21 7.2002 21V19ZM3 16.8C3 17.3435 2.99922 17.8113 3.03057 18.195C3.06287 18.5904 3.13418 18.9836 3.32698 19.362L5.10899 18.454C5.08381 18.4046 5.04613 18.3039 5.02393 18.0322C5.00078 17.7488 5 17.3765 5 16.8H3ZM5.54579 18.891C5.35778 18.7952 5.20494 18.6424 5.10899 18.454L3.32698 19.362C3.61452 19.9264 4.07317 20.3853 4.63781 20.673L5.54579 18.891ZM19 16.8C19 17.3766 18.9993 17.7489 18.9762 18.0323C18.954 18.3041 18.9163 18.4047 18.8912 18.454L20.6732 19.362C20.8661 18.9835 20.9373 18.5902 20.9696 18.1949C21.0008 17.8112 21 17.3434 21 16.8H19ZM16.8002 21C17.3438 21 17.8115 21.0008 18.1951 20.9694C18.5904 20.9371 18.9835 20.8657 19.3618 20.673L18.4538 18.891C18.4043 18.9162 18.3036 18.9539 18.0321 18.9761C17.7489 18.9992 17.3767 19 16.8002 19V21ZM18.8912 18.454C18.7956 18.6417 18.6425 18.7948 18.4538 18.891L19.3618 20.673C19.9257 20.3856 20.3853 19.927 20.6732 19.362L18.8912 18.454ZM16.8002 5C17.3768 5 17.7489 5.00078 18.0321 5.02393C18.3036 5.04611 18.4043 5.08377 18.4538 5.10899L19.3618 3.32698C18.9835 3.13421 18.5904 3.06288 18.1951 3.03057C17.8115 2.99922 17.3437 3 16.8002 3V5ZM21 7.19995C21 6.6565 21.0008 6.1887 20.9695 5.80511C20.9373 5.40983 20.8661 5.01653 20.6732 4.63805L18.8912 5.54603C18.9164 5.59537 18.954 5.69598 18.9762 5.96767C18.9993 6.25105 19 6.6233 19 7.19995H21ZM18.4538 5.10899C18.6424 5.20508 18.7956 5.35828 18.8912 5.54603L20.6732 4.63805C20.3854 4.07315 19.9259 3.61439 19.3618 3.32698L18.4538 5.10899ZM7.2002 3C6.65663 3 6.18874 2.99922 5.80498 3.03057C5.40962 3.06286 5.01624 3.13416 4.63781 3.32698L5.54579 5.10899C5.59517 5.08383 5.69595 5.04613 5.9678 5.02393C6.25126 5.00078 6.62365 5 7.2002 5V3ZM5 7.19995C5 6.6234 5.00078 6.25114 5.02393 5.96783C5.04612 5.6962 5.0838 5.59549 5.10899 5.54603L3.32698 4.63805C3.13419 5.01642 3.06287 5.40961 3.03057 5.80495C2.99922 6.18861 3 6.6564 3 7.19995H5ZM4.63781 3.32698C4.07306 3.61473 3.61447 4.07382 3.32698 4.63805L5.10899 5.54603C5.205 5.35761 5.35788 5.20474 5.54579 5.10899L4.63781 3.32698ZM14.5 13H9.5V15H14.5V13ZM11 11.5V16.5H13V11.5H11ZM15 2V4H17V2H15ZM7 2V4H9V2H7Z"
            fill="#686868"
          />
        </svg>
      )
      break
    case "link-d":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.17185 14.8285L14.8287 9.17166M7.0509 11.2929L5.63669 12.7071C4.07459 14.2692 4.07429 16.8018 5.63639 18.3639C7.19848 19.926 9.73145 19.926 11.2935 18.3639L12.7072 16.9497M11.2929 7.05011L12.7072 5.6359C14.2693 4.0738 16.8018 4.07386 18.3639 5.63596C19.926 7.19806 19.9263 9.73065 18.3642 11.2928L16.9502 12.707"
            stroke="#686868"
            stroke-opacity="0.7"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "chat-2mess":
      iconElement = (
        <svg
          width="28px"
          height="28px"
          viewBox="0 0 24.00 24.00"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#ffffff"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke="#CCCCCC"
            stroke-width="0.624"
          >
            <g id="Communication / Chat_Conversation_Circle">
              <path
                id="Vector"
                d="M9.33814 15.9905C12.4946 15.8151 15 13.2003 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 11.1807 3.34094 12.2817 3.92989 13.21L3.50586 14.482L3.50518 14.4839C3.34278 14.9711 3.26154 15.2149 3.31938 15.3771C3.36979 15.5184 3.48169 15.6299 3.62305 15.6803C3.78472 15.7379 4.02675 15.6573 4.51069 15.4959L4.51758 15.4939L5.79004 15.0698C6.7183 15.6588 7.81935 15.9998 9.00006 15.9998C9.11352 15.9998 9.22624 15.9967 9.33814 15.9905ZM9.33814 15.9905C9.33822 15.9907 9.33806 15.9902 9.33814 15.9905ZM9.33814 15.9905C10.1591 18.3259 12.3841 20.0002 15.0001 20.0002C16.1808 20.0002 17.2817 19.6588 18.2099 19.0698L19.482 19.4939L19.4845 19.4944C19.9717 19.6567 20.2158 19.7381 20.378 19.6803C20.5194 19.6299 20.6299 19.5184 20.6803 19.3771C20.7382 19.2146 20.6572 18.9706 20.4943 18.4821L20.0703 17.21L20.2123 16.9746C20.7138 16.0979 20.9995 15.0823 20.9995 14C20.9995 10.6863 18.3137 8 15 8L14.7754 8.00414L14.6621 8.00967"
                stroke="#ffffff"
                stroke-width="1.752"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>{" "}
            </g>{" "}
          </g>
          <g id="SVGRepo_iconCarrier">
            <g id="Communication / Chat_Conversation_Circle">
              <path
                id="Vector"
                d="M9.33814 15.9905C12.4946 15.8151 15 13.2003 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 11.1807 3.34094 12.2817 3.92989 13.21L3.50586 14.482L3.50518 14.4839C3.34278 14.9711 3.26154 15.2149 3.31938 15.3771C3.36979 15.5184 3.48169 15.6299 3.62305 15.6803C3.78472 15.7379 4.02675 15.6573 4.51069 15.4959L4.51758 15.4939L5.79004 15.0698C6.7183 15.6588 7.81935 15.9998 9.00006 15.9998C9.11352 15.9998 9.22624 15.9967 9.33814 15.9905ZM9.33814 15.9905C9.33822 15.9907 9.33806 15.9902 9.33814 15.9905ZM9.33814 15.9905C10.1591 18.3259 12.3841 20.0002 15.0001 20.0002C16.1808 20.0002 17.2817 19.6588 18.2099 19.0698L19.482 19.4939L19.4845 19.4944C19.9717 19.6567 20.2158 19.7381 20.378 19.6803C20.5194 19.6299 20.6299 19.5184 20.6803 19.3771C20.7382 19.2146 20.6572 18.9706 20.4943 18.4821L20.0703 17.21L20.2123 16.9746C20.7138 16.0979 20.9995 15.0823 20.9995 14C20.9995 10.6863 18.3137 8 15 8L14.7754 8.00414L14.6621 8.00967"
                stroke="#ffffff"
                stroke-width="1.752"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </g>
          </g>
        </svg>
      )
      break
    case "clock-company":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7H13ZM12 12H11C11 12.5523 11.4477 13 12 13V12ZM17 13C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11V13ZM20.3608 5.33719C20.7839 5.6922 21.4147 5.63701 21.7697 5.21394C22.1247 4.79086 22.0695 4.16011 21.6464 3.80511L20.3608 5.33719ZM18.5822 1.23396C18.1592 0.878954 17.5284 0.934138 17.1734 1.35721C16.8184 1.78029 16.8736 2.41104 17.2967 2.76604L18.5822 1.23396ZM6.70697 2.76617C7.13004 2.41116 7.18522 1.78041 6.83022 1.35733C6.47522 0.93426 5.84446 0.879076 5.42139 1.23408L6.70697 2.76617ZM2.35721 3.80523C1.93414 4.16023 1.87895 4.79099 2.23396 5.21406C2.58896 5.63713 3.21971 5.69232 3.64279 5.33732L2.35721 3.80523ZM11 7V12H13V7H11ZM12 13H17V11H12V13ZM12 19C8.13401 19 5 15.866 5 12H3C3 16.9706 7.02944 21 12 21V19ZM5 12C5 8.13401 8.13401 5 12 5V3C7.02944 3 3 7.02944 3 12H5ZM12 5C15.866 5 19 8.13401 19 12H21C21 7.02944 16.9706 3 12 3V5ZM19 12C19 15.866 15.866 19 12 19V21C16.9706 21 21 16.9706 21 12H19ZM21.6464 3.80511L18.5822 1.23396L17.2967 2.76604L20.3608 5.33719L21.6464 3.80511ZM5.42139 1.23408L2.35721 3.80523L3.64279 5.33732L6.70697 2.76617L5.42139 1.23408Z"
            fill="#686868"
            fill-opacity="0.68"
          />
        </svg>
      )
      break

    case "user-plus":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 640 512"
        >
          <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z" />
        </svg>
      )
      break
    case "chevron-left":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 320 512"
        >
          <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
        </svg>
      )

      break
    case "chevron-right":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 320 512"
        >
          <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
        </svg>
      )

      break
    case "bookmark":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 384 512"
        >
          <path d="M0 48C0 21.5 21.5 0 48 0l0 48V441.4l130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4V48H48V0H336c26.5 0 48 21.5 48 48V488c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488V48z" />
        </svg>
      )
      break
    case "user-check":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 640 512"
        >
          <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
        </svg>
      )
      break

    case "briefcase":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 512 512"
        >
          <path d="M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z" />
        </svg>
      )
      break

    case "save-company":
      iconElement = (
        <svg
          width="14"
          height="19"
          viewBox="0 0 14 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 13.6851V4.19995V4.19666C13 3.07875 13 2.51945 12.7822 2.09204C12.5905 1.71572 12.2841 1.40973 11.9078 1.21799C11.48 1 10.9203 1 9.8002 1H4.2002C3.08009 1 2.51962 1 2.0918 1.21799C1.71547 1.40973 1.40973 1.71572 1.21799 2.09204C1 2.51986 1 3.07985 1 4.19995V13.6851C1 15.0462 1 15.7268 1.20412 16.1432C1.58245 16.9151 2.41157 17.3589 3.26367 17.2455C3.7234 17.1843 4.28964 16.8069 5.4221 16.0519L5.42432 16.0504C5.87352 15.7509 6.09829 15.6011 6.33318 15.5181C6.76443 15.3656 7.23476 15.3656 7.66602 15.5181C7.90129 15.6012 8.12663 15.7515 8.57731 16.0519L8.57732 16.0519C9.70978 16.8069 10.2768 17.1843 10.7366 17.2455C11.5886 17.3589 12.4176 16.9151 12.7959 16.1432C13 15.7268 13 15.0463 13 13.6855V13.6851Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "dowload-company":
      iconElement = (
        <svg
          width="14"
          height="20"
          viewBox="0 0 14 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1 19H13Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7 1L7 15Z"
            fill="white"
          />
          <path
            d="M1 19H13M7 1L7 15M7 15L12 10M7 15L2 10"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "experience-company":
      iconElement = (
        <svg
          width="20"
          height="18"
          viewBox="0 0 20 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 5C14 2.79086 12.2091 1 10 1C7.79086 1 6 2.79086 6 5M19 8.19995V13.8C19 14.9201 19.0002 15.4802 18.7822 15.908C18.5905 16.2844 18.2841 16.5902 17.9078 16.782C17.48 17 16.9203 17 15.8002 17H4.2002C3.08009 17 2.51962 17 2.0918 16.782C1.71547 16.5902 1.40973 16.2844 1.21799 15.908C1 15.4802 1 14.9201 1 13.8V8.19995C1 7.07985 1 6.51986 1.21799 6.09204C1.40973 5.71572 1.71547 5.40973 2.0918 5.21799C2.51962 5 3.08009 5 4.2002 5H15.8002C16.9203 5 17.48 5 17.9078 5.21799C18.2841 5.40973 18.5905 5.71572 18.7822 6.09204C19.0002 6.51986 19 7.07985 19 8.19995Z"
            stroke="#686868"
            stroke-opacity="0.68"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "map-company":
      iconElement = (
        <svg
          width="24px"
          height="20px"
          viewBox="-20.48 -20.48 1064.96 1064.96"
          xmlns="http://www.w3.org/2000/svg"
          fill="#959698"
          stroke="#959698"
          stroke-width="26.624000000000002"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke="#CCCCCC"
            stroke-width="4.096"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path
              fill="#959698"
              d="M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416zM512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544z"
            ></path>
            <path
              fill="#959698"
              d="M512 512a96 96 0 1 0 0-192 96 96 0 0 0 0 192zm0 64a160 160 0 1 1 0-320 160 160 0 0 1 0 320z"
            ></path>
          </g>
        </svg>
      )
      break
    case "job-company":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 20H22M7 10H11M14 20H20V12C20 11.0681 19.9999 10.6022 19.8477 10.2346C19.6447 9.74456 19.2554 9.35523 18.7654 9.15224C18.3978 9 17.9321 9 17.0002 9C16.0683 9 15.6024 9 15.2349 9.15224C14.7448 9.35523 14.3552 9.74456 14.1522 10.2346C14 10.6022 14 11.0681 14 12V20ZM14 20V6.19995C14 5.07985 14.0002 4.51986 13.7822 4.09204C13.5905 3.71572 13.2841 3.40973 12.9078 3.21799C12.48 3 11.9203 3 10.8002 3H7.2002C6.08009 3 5.51962 3 5.0918 3.21799C4.71547 3.40973 4.40973 3.71572 4.21799 4.09204C4 4.51986 4 5.07985 4 6.19995V20H14ZM7 7L11 7"
            stroke="#686868"
            stroke-opacity="0.68"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "save-gray":
      iconElement = (
        <svg
          data-v-0db2ad03=""
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="icon icon-tabler icon-tabler-bookmark m-0"
        >
          <path
            data-v-0db2ad03=""
            stroke="none"
            d="M0 0h24v24H0z"
            fill="none"
          ></path>
          <path
            data-v-0db2ad03=""
            d="M9 4h6a2 2 0 0 1 2 2v14l-5 -3l-5 3v-14a2 2 0 0 1 2 -2"
          ></path>
        </svg>
      )
      break
    case "job-building":
      iconElement = (
        <svg
          data-v-0db2ad03=""
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          viewBox="0 0 16 16"
          class="bi bi-building me-1"
        >
          <path
            data-v-0db2ad03=""
            fill-rule="evenodd"
            d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022zM6 8.694 1 10.36V15h5V8.694zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15z"
          ></path>
          <path
            data-v-0db2ad03=""
            d="M2 11h1v1H2v-1zm2 0h1v1H4v-1zm-2 2h1v1H2v-1zm2 0h1v1H4v-1zm4-4h1v1H8V9zm2 0h1v1h-1V9zm-2 2h1v1H8v-1zm2 0h1v1h-1v-1zm2-2h1v1h-1V9zm0 2h1v1h-1v-1zM8 7h1v1H8V7zm2 0h1v1h-1V7zm2 0h1v1h-1V7zM8 5h1v1H8V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm0-2h1v1h-1V3z"
          ></path>
        </svg>
      )
      break
    case "process-group-green":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path d="M20 6H10V8H20V6Z" fill="#39d762" />
            <path
              d="M2.26668 21.1875V2.81249C2.26668 2.29554 2.77506 1.87499 3.39998 1.87499H19.6001C20.225 1.87499 20.7334 2.29554 20.7334 2.81249V10.0683L23 12V2.81249C23 1.26168 21.4748 0 19.6001 0H3.39998C1.52526 0 0 1.26168 0 2.81249V21.1875C0 22.7383 1.5252 24 3.39993 24H10L10.5 22.125H3.39998C2.77506 22.125 2.26668 21.7045 2.26668 21.1875Z"
              fill="#39d762"
            />
            <path d="M20 11H10V13H18L20 11Z" fill="#39d762" />
            <path
              d="M20.117 12L13.8232 18.4717C13.4635 18.8328 13.1888 19.2791 13.0285 19.7629L13.0143 19.8058L12 24L16.4723 23.265L16.5165 23.2503C17.0027 23.0894 17.4512 22.8131 17.8134 22.451L24.1063 15.9804L20.117 12ZM16.4851 21.1301C16.45 21.1648 16.413 21.1976 16.3745 21.2284L15.0515 19.9045C15.0832 19.8651 15.117 19.8273 15.1527 19.7916L20.137 14.6665L21.4738 16.0003L16.4851 21.1301Z"
              fill="#39d762"
            />
            <path
              d="M8.48433 9.40326L6.19176 12.0036L5.05096 10.9323L3.76855 12.298L6.31856 14.6926L9.8896 10.6423L8.48433 9.40326Z"
              fill="#39d762"
            />
            <path
              d="M8.48433 3.73624L6.19176 6.33654L5.05096 5.26526L3.76855 6.63097L6.31856 9.02554L9.8896 4.97519L8.48433 3.73624Z"
              fill="#39d762"
            />
            <path
              d="M5.05096 16.5526L3.76855 17.9183L6.31856 20.3129L9.8896 16.2626L8.48433 15.0236L6.19176 17.6239L5.05096 16.5526Z"
              fill="#39d762"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "check-box-learn":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="15" cy="15" r="15" fill="#00C590" />
          <path d="M6 15L12.5 21L23 10" stroke="white" strokeWidth="3" />
        </svg>
      )
      break
    case "share_cv":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 512 512"
          style={{ fill: "#fff" }}
        >
          <path d="M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z" />
        </svg>
      )
      break
    case "eye-slash-cv":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 640 512"
          style={{ fill: "#fff" }}
        >
          <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z" />
        </svg>
      )
      break
    case "eye_cv":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 576 512"
          style={{ fill: "#fff" }}
        >
          <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
        </svg>
      )
      break
    case "download_cv":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 512 512"
          style={{ fill: "#fff" }}
        >
          <path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
        </svg>
      )
      break
    case "edit_cv":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 512 512"
          style={{ fill: "#fff" }}
        >
          <path d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z" />
        </svg>
      )
      break
    case "floppy-disk":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1.5em"
          viewBox="0 0 448 512"
        >
          <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
        </svg>
      )
      break
    case "user-info":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 448 512"
        >
          <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z" />
        </svg>
      )
      break
    case "chart-line":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 448 512"
        >
          <path d="M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z" />
        </svg>
      )
      break
    case "student":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 640 512"
        >
          <path d="M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z" />
        </svg>
      )
      break
    case "paper":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 576 512"
        >
          <path d="M0 80v48c0 17.7 14.3 32 32 32H48 96V80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48V384c0 35.3 28.7 64 64 64s64-28.7 64-64v-5.3c0-32.4 26.3-58.7 58.7-58.7H480V128c0-53-43-96-96-96H112zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16H314.7c-14.7 0-26.7 11.9-26.7 26.7V384c0 53-43 96-96 96H368h96z" />
        </svg>
      )
      break
    case "language":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 640 512"
        >
          <path d="M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z" />
        </svg>
      )
      break
    case "coder":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 640 512"
        >
          <path d="M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z" />
        </svg>
      )
      break
    case "trophy":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 576 512"
        >
          <path d="M400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H24C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.9C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6h84.4c-5.1 66.3-31.1 111.2-63 142.3z" />
        </svg>
      )
      break
    case "notice-partner-white":
      iconElement = (
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.4043 7H13.4043V9H11.4043V7ZM11.4043 11H13.4043V17H11.4043V11ZM12.4043 2C6.8843 2 2.4043 6.48 2.4043 12C2.4043 17.52 6.8843 22 12.4043 22C17.9243 22 22.4043 17.52 22.4043 12C22.4043 6.48 17.9243 2 12.4043 2ZM12.4043 20C7.9943 20 4.4043 16.41 4.4043 12C4.4043 7.59 7.9943 4 12.4043 4C16.8143 4 20.4043 7.59 20.4043 12C20.4043 16.41 16.8143 20 12.4043 20Z"
            fill="#fff"
          />
        </svg>
      )
      break
    case "play-icon":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 16.5V7.5L16 12L10 16.5Z"
            fill="#666"
            fill-opacity="0.54"
          />
        </svg>
      )
      break
    case "group":
      iconElement = (
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 12C17.88 12 18.99 10.88 18.99 9.5C18.99 8.12 17.88 7 16.5 7C15.12 7 14 8.12 14 9.5C14 10.88 15.12 12 16.5 12ZM9 11C10.66 11 11.99 9.66 11.99 8C11.99 6.34 10.66 5 9 5C7.34 5 6 6.34 6 8C6 9.66 7.34 11 9 11ZM16.5 14C14.67 14 11 14.92 11 16.75V19H22V16.75C22 14.92 18.33 14 16.5 14ZM9 13C6.67 13 2 14.17 2 16.5V19H9V16.75C9 15.9 9.33 14.41 11.37 13.28C10.5 13.1 9.66 13 9 13Z"
            fill="#666"
            fill-opacity="0.54"
          />
        </svg>
      )
      break
    case "group-white":
      iconElement = (
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 12C17.88 12 18.99 10.88 18.99 9.5C18.99 8.12 17.88 7 16.5 7C15.12 7 14 8.12 14 9.5C14 10.88 15.12 12 16.5 12ZM9 11C10.66 11 11.99 9.66 11.99 8C11.99 6.34 10.66 5 9 5C7.34 5 6 6.34 6 8C6 9.66 7.34 11 9 11ZM16.5 14C14.67 14 11 14.92 11 16.75V19H22V16.75C22 14.92 18.33 14 16.5 14ZM9 13C6.67 13 2 14.17 2 16.5V19H9V16.75C9 15.9 9.33 14.41 11.37 13.28C10.5 13.1 9.66 13 9 13Z"
            fill="#fff"
            fill-opacity="0.54"
          />
        </svg>
      )
      break
    case "config":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.4308 12.98C19.4708 12.66 19.5008 12.34 19.5008 12C19.5008 11.66 19.4708 11.34 19.4308 11.02L21.5408 9.37C21.7308 9.22 21.7808 8.95 21.6608 8.73L19.6608 5.27C19.5708 5.11 19.4008 5.02 19.2208 5.02C19.1608 5.02 19.1008 5.03 19.0508 5.05L16.5608 6.05C16.0408 5.65 15.4808 5.32 14.8708 5.07L14.4908 2.42C14.4608 2.18 14.2508 2 14.0008 2H10.0008C9.75082 2 9.54082 2.18 9.51082 2.42L9.13082 5.07C8.52082 5.32 7.96082 5.66 7.44082 6.05L4.95082 5.05C4.89082 5.03 4.83082 5.02 4.77082 5.02C4.60082 5.02 4.43082 5.11 4.34082 5.27L2.34082 8.73C2.21082 8.95 2.27082 9.22 2.46082 9.37L4.57082 11.02C4.53082 11.34 4.50082 11.67 4.50082 12C4.50082 12.33 4.53082 12.66 4.57082 12.98L2.46082 14.63C2.27082 14.78 2.22082 15.05 2.34082 15.27L4.34082 18.73C4.43082 18.89 4.60082 18.98 4.78082 18.98C4.84082 18.98 4.90082 18.97 4.95082 18.95L7.44082 17.95C7.96082 18.35 8.52082 18.68 9.13082 18.93L9.51082 21.58C9.54082 21.82 9.75082 22 10.0008 22H14.0008C14.2508 22 14.4608 21.82 14.4908 21.58L14.8708 18.93C15.4808 18.68 16.0408 18.34 16.5608 17.95L19.0508 18.95C19.1108 18.97 19.1708 18.98 19.2308 18.98C19.4008 18.98 19.5708 18.89 19.6608 18.73L21.6608 15.27C21.7808 15.05 21.7308 14.78 21.5408 14.63L19.4308 12.98ZM17.4508 11.27C17.4908 11.58 17.5008 11.79 17.5008 12C17.5008 12.21 17.4808 12.43 17.4508 12.73L17.3108 13.86L18.2008 14.56L19.2808 15.4L18.5808 16.61L17.3108 16.1L16.2708 15.68L15.3708 16.36C14.9408 16.68 14.5308 16.92 14.1208 17.09L13.0608 17.52L12.9008 18.65L12.7008 20H11.3008L11.1108 18.65L10.9508 17.52L9.89082 17.09C9.46082 16.91 9.06082 16.68 8.66082 16.38L7.75082 15.68L6.69082 16.11L5.42082 16.62L4.72082 15.41L5.80082 14.57L6.69082 13.87L6.55082 12.74C6.52082 12.43 6.50082 12.2 6.50082 12C6.50082 11.8 6.52082 11.57 6.55082 11.27L6.69082 10.14L5.80082 9.44L4.72082 8.6L5.42082 7.39L6.69082 7.9L7.73082 8.32L8.63082 7.64C9.06082 7.32 9.47082 7.08 9.88082 6.91L10.9408 6.48L11.1008 5.35L11.3008 4H12.6908L12.8808 5.35L13.0408 6.48L14.1008 6.91C14.5308 7.09 14.9308 7.32 15.3308 7.62L16.2408 8.32L17.3008 7.89L18.5708 7.38L19.2708 8.59L18.2008 9.44L17.3108 10.14L17.4508 11.27ZM12.0008 8C9.79082 8 8.00082 9.79 8.00082 12C8.00082 14.21 9.79082 16 12.0008 16C14.2108 16 16.0008 14.21 16.0008 12C16.0008 9.79 14.2108 8 12.0008 8ZM12.0008 14C10.9008 14 10.0008 13.1 10.0008 12C10.0008 10.9 10.9008 10 12.0008 10C13.1008 10 14.0008 10.9 14.0008 12C14.0008 13.1 13.1008 14 12.0008 14Z"
            fill="#4d4d4d"
          />
        </svg>
      )
      break
    case "usd":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="26"
          height="26"
          viewBox="0 0 172 172"
        >
          <g
            fill="none"
            fill-rule="nonzero"
            stroke="none"
            stroke-width="1"
            stroke-linecap="butt"
            stroke-linejoin="miter"
            stroke-miterlimit="10"
            stroke-dasharray=""
            stroke-dashoffset="0"
            font-family="none"
            font-weight="none"
            font-size="none"
            text-anchor="none"
          >
            <path d="M0,172v-172h172v172z" fill="none"></path>
            <g fill="#1fb141">
              <path d="M21.5,21.5v129h64.5v-32.25v-64.5v-32.25zM86,53.75c0,17.7805 14.4695,32.25 32.25,32.25c17.7805,0 32.25,-14.4695 32.25,-32.25c0,-17.7805 -14.4695,-32.25 -32.25,-32.25c-17.7805,0 -32.25,14.4695 -32.25,32.25zM118.25,86c-17.7805,0 -32.25,14.4695 -32.25,32.25c0,17.7805 14.4695,32.25 32.25,32.25c17.7805,0 32.25,-14.4695 32.25,-32.25c0,-17.7805 -14.4695,-32.25 -32.25,-32.25z"></path>
            </g>
          </g>
        </svg>
      )
      break
    case "linked-in":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="40"
          height="40"
          viewBox="0 0 64 64"
        >
          <radialGradient
            id="jAVUMfCM1liBjYZwQpghOa"
            cx="32"
            cy="31.5"
            r="31.259"
            gradientUnits="userSpaceOnUse"
            spreadMethod="reflect"
          >
            <stop offset="0" stop-color="#c5f1ff"></stop>
            <stop offset=".35" stop-color="#cdf3ff"></stop>
            <stop offset=".907" stop-color="#e4faff"></stop>
            <stop offset="1" stop-color="#e9fbff"></stop>
          </radialGradient>
          <path
            fill="url(#undefined)"
            d="M58,54c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2h2.5c1.925,0,3.5-1.575,3.5-3.5 S62.425,43,60.5,43H50c-1.381,0-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5h8c1.65,0,3-1.35,3-3c0-1.65-1.35-3-3-3H42v-6h18 c2.335,0,4.22-2.028,3.979-4.41C63.77,19.514,61.897,18,59.811,18H58c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2h0.357 c1.308,0,2.499-0.941,2.63-2.242C61.137,10.261,59.966,9,58.5,9h-14C43.672,9,43,8.328,43,7.5S43.672,6,44.5,6h3.857 c1.308,0,2.499-0.941,2.63-2.242C51.137,2.261,49.966,1,48.5,1L15.643,1c-1.308,0-2.499,0.941-2.63,2.242 C12.863,4.739,14.034,6,15.5,6H19c1.105,0,2,0.895,2,2c0,1.105-0.895,2-2,2H6.189c-2.086,0-3.958,1.514-4.168,3.59 C1.78,15.972,3.665,18,6,18h2.5c1.933,0,3.5,1.567,3.5,3.5c0,1.933-1.567,3.5-3.5,3.5H5.189c-2.086,0-3.958,1.514-4.168,3.59 C0.78,30.972,2.665,33,5,33h17v11H6c-1.65,0-3,1.35-3,3c0,1.65,1.35,3,3,3h0c1.105,0,2,0.895,2,2c0,1.105-0.895,2-2,2H4.189 c-2.086,0-3.958,1.514-4.168,3.59C-0.22,59.972,1.665,62,4,62h53.811c2.086,0,3.958-1.514,4.168-3.59C62.22,56.028,60.335,54,58,54z"
          ></path>
          <linearGradient
            id="jAVUMfCM1liBjYZwQpghOb_118979_gr1"
            x1="32"
            x2="32"
            y1="59.381"
            y2="15.381"
            gradientUnits="userSpaceOnUse"
            spreadMethod="reflect"
          >
            <stop offset="0" stop-color="#155cde"></stop>
            <stop offset=".278" stop-color="#1f7fe5"></stop>
            <stop offset=".569" stop-color="#279ceb"></stop>
            <stop offset=".82" stop-color="#2cafef"></stop>
            <stop offset="1" stop-color="#2eb5f0"></stop>
          </linearGradient>
          <path
            fill="url(#jAVUMfCM1liBjYZwQpghOb_118979_gr1)"
            d="M50,12H14c-2.209,0-4,1.791-4,4v36c0,2.209,1.791,4,4,4h36c2.209,0,4-1.791,4-4V16 C54,13.791,52.209,12,50,12z"
          ></path>
          <path
            fill="#fff"
            d="M19 28h2c1.105 0 2 .895 2 2v17c0 1.105-.895 2-2 2h-2c-1.105 0-2-.895-2-2V30C17 28.895 17.895 28 19 28zM19.981 25h-.033C18.158 25 17 23.664 17 22c0-1.706 1.195-3 3.019-3 1.823 0 2.948 1.294 2.981 3C23 23.664 21.842 25 19.981 25zM45 49h-2c-1.105 0-2-.895-2-2v-9.372c0-2.749-1.506-4.624-4.239-4.624-1.953 0-3.133 1.265-3.626 2.485C32.954 35.929 33 37.14 33 37.75V47c0 1.105-.888 2-1.993 2H29c-1.105 0-2-.895-2-2V30c0-1.105.895-2 2-2h2.007c1.105 0 2 .895 2 2v1.021C33.911 29.625 35.564 28 39.173 28 43.646 28 47 30.563 47 36.842V47C47 48.105 46.105 49 45 49z"
          ></path>
        </svg>
      )
      break
    case "view":
      iconElement = (
        <svg
          width="17"
          height="17"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 4.37402C3.75 4.37402 1.25 9.99963 1.25 9.99963C1.25 9.99963 3.75 15.624 10 15.624C16.25 15.624 18.75 9.99963 18.75 9.99963C18.75 9.99963 16.25 4.37402 10 4.37402Z"
            stroke="#777777"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875C8.27411 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125Z"
            stroke="#777777"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "bell":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.39144 8.12495C4.3904 7.38371 4.53609 6.64959 4.8201 5.96491C5.1041 5.28024 5.52082 4.65854 6.04621 4.13567C6.57161 3.61279 7.19531 3.19907 7.88134 2.91837C8.56738 2.63766 9.30219 2.49551 10.0434 2.50011C13.1364 2.5231 15.6103 5.09396 15.6103 8.19557V8.74995C15.6103 11.548 16.1957 13.1717 16.7113 14.0592C16.7669 14.154 16.7964 14.2618 16.797 14.3717C16.7976 14.4816 16.7692 14.5897 16.7147 14.6851C16.6602 14.7805 16.5814 14.8599 16.4865 14.9151C16.3915 14.9704 16.2836 14.9997 16.1737 15H3.82742C3.71752 14.9997 3.60963 14.9704 3.51464 14.9151C3.41966 14.8598 3.34093 14.7805 3.28641 14.685C3.23189 14.5896 3.2035 14.4815 3.20411 14.3716C3.20472 14.2617 3.2343 14.1539 3.28987 14.059C3.80575 13.1716 4.39143 11.5479 4.39143 8.74995L4.39144 8.12495Z"
            stroke="#2160bd"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.5 15V15.625C7.5 16.288 7.76339 16.9239 8.23223 17.3928C8.70107 17.8616 9.33696 18.125 10 18.125C10.663 18.125 11.2989 17.8616 11.7678 17.3928C12.2366 16.9239 12.5 16.288 12.5 15.625V15"
            stroke="#2160bd"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )
      break
    case "gitbranch-slide":
      iconElement = (
        <svg
          width="130"
          height="132"
          viewBox="0 0 130 132"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.7538 69.0241L32.53 33.5581C33.5044 30.8531 35.8555 28.879 38.6884 28.3873L75.8785 21.932C78.687 21.4445 81.5428 22.4882 83.375 24.6718L108.16 54.2099C109.993 56.3934 110.525 59.3867 109.557 62.0678L96.7462 97.5676C95.7702 100.272 93.4181 102.245 90.585 102.735L53.4342 109.162C50.627 109.648 47.7734 108.604 45.9421 106.421L21.152 76.8777C19.3208 74.6955 18.7883 71.7042 19.7538 69.0241Z"
            stroke="white"
            strokeWidth="4"
          />
          <path
            d="M55.625 79.75C58.0412 79.75 60 77.7912 60 75.375C60 72.9588 58.0412 71 55.625 71C53.2088 71 51.25 72.9588 51.25 75.375C51.25 77.7912 53.2088 79.75 55.625 79.75Z"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M74.375 61C76.7912 61 78.75 59.0412 78.75 56.625C78.75 54.2088 76.7912 52.25 74.375 52.25C71.9588 52.25 70 54.2088 70 56.625C70 59.0412 71.9588 61 74.375 61Z"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M55.625 61C58.0412 61 60 59.0412 60 56.625C60 54.2088 58.0412 52.25 55.625 52.25C53.2088 52.25 51.25 54.2088 51.25 56.625C51.25 59.0412 53.2088 61 55.625 61Z"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M55.625 71V69.75C55.625 68.7554 56.0201 67.8017 56.7234 67.0984C57.4266 66.3952 58.3804 66.0001 59.3749 66.0001L70.6251 65.9999C71.6196 65.9999 72.5734 65.6048 73.2766 64.9016C73.9799 64.1983 74.375 63.2446 74.375 62.25V61"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M55.625 61V71"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "gear-slide":
      iconElement = (
        <svg
          width="180"
          height="182"
          viewBox="0 0 180 182"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.9239 97.6039L45.1697 44.1787C46.1441 41.4737 48.4952 39.4996 51.3281 39.0079L107.346 29.2845C110.155 28.797 113.011 29.8407 114.843 32.0243L152.1 76.4253C153.932 78.6088 154.464 81.6021 153.496 84.2832L134.2 137.756C133.224 140.46 130.872 142.433 128.038 142.923L72.0758 152.605C69.2686 153.09 66.415 152.047 64.5837 149.864L27.3221 105.458C25.491 103.275 24.9584 100.284 25.9239 97.6039Z"
            stroke="white"
            strokeWidth="4"
          />
          <path
            d="M90 100.375C95.1777 100.375 99.375 96.1777 99.375 91C99.375 85.8223 95.1777 81.625 90 81.625C84.8223 81.625 80.625 85.8223 80.625 91C80.625 96.1777 84.8223 100.375 90 100.375Z"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M88.9991 74.6229L85.3137 71.8596C85.1159 71.7108 84.8857 71.6112 84.6419 71.5689C84.3981 71.5266 84.1477 71.5429 83.9114 71.6163C82.77 71.9737 81.6626 72.4319 80.6023 72.9854C80.3828 73.1006 80.1939 73.2662 80.051 73.4688C79.9082 73.6713 79.8156 73.9049 79.7808 74.1503L79.1293 78.7111C78.881 78.9312 78.6378 79.1602 78.3999 79.3979C78.1621 79.6358 77.9331 79.879 77.7129 80.1275L77.7128 80.1276L73.1529 80.7797C72.9079 80.8143 72.6746 80.9067 72.4723 81.0492C72.27 81.1917 72.1044 81.3802 71.9893 81.5992C71.4349 82.659 70.9759 83.7661 70.6175 84.9072C70.5437 85.1438 70.5273 85.3946 70.5695 85.6388C70.6117 85.883 70.7114 86.1137 70.8603 86.3118L73.6246 89.9974C73.6046 90.3287 73.5946 90.6625 73.5945 90.9989C73.5945 91.3352 73.6045 91.6691 73.6246 92.0006L73.6246 92.0007L70.8613 95.6861C70.7126 95.8839 70.6129 96.1141 70.5706 96.3579C70.5283 96.6017 70.5446 96.8521 70.618 97.0884C70.9754 98.2298 71.4336 99.3372 71.9871 100.397C72.1023 100.617 72.2679 100.806 72.4705 100.949C72.673 101.092 72.9067 101.184 73.1521 101.219L77.7128 101.87C77.9329 102.119 78.1619 102.362 78.3996 102.6C78.6375 102.838 78.8807 103.067 79.1292 103.287L79.1293 103.287L79.7814 107.847C79.816 108.092 79.9084 108.325 80.0509 108.528C80.1934 108.73 80.3819 108.895 80.6009 109.011C81.6607 109.565 82.7678 110.024 83.9089 110.382C84.1455 110.456 84.3963 110.473 84.6405 110.43C84.8847 110.388 85.1154 110.288 85.3135 110.139L88.9991 107.375C89.3304 107.395 89.6642 107.405 90.0006 107.405C90.3369 107.405 90.6708 107.395 91.0023 107.375L91.0024 107.375L94.6878 110.138C94.8856 110.287 95.1158 110.387 95.3596 110.429C95.6034 110.471 95.8538 110.455 96.0901 110.382C97.2315 110.024 98.3389 109.566 99.3992 109.013C99.6187 108.898 99.8076 108.732 99.9505 108.529C100.093 108.327 100.186 108.093 100.221 107.848L100.872 103.287C101.121 103.067 101.364 102.838 101.602 102.6C101.839 102.362 102.068 102.119 102.289 101.871L102.289 101.871L106.849 101.218C107.094 101.184 107.327 101.091 107.529 100.949C107.732 100.806 107.897 100.618 108.012 100.399C108.567 99.3391 109.026 98.232 109.384 97.0909C109.458 96.8543 109.474 96.6035 109.432 96.3593C109.39 96.1151 109.29 95.8844 109.141 95.6863L106.377 92.0007C106.397 91.6694 106.407 91.3356 106.407 90.9992C106.407 90.6629 106.397 90.329 106.377 89.9975L106.377 89.9974L109.14 86.312C109.289 86.1142 109.389 85.884 109.431 85.6402C109.473 85.3964 109.457 85.146 109.383 84.9097C109.026 83.7683 108.568 82.6609 108.014 81.6006C107.899 81.3811 107.734 81.1922 107.531 81.0493C107.328 80.9065 107.095 80.8139 106.849 80.7791L102.289 80.1276C102.069 79.8793 101.84 79.6361 101.602 79.3982C101.364 79.1604 101.121 78.9314 100.872 78.7112L100.872 78.7111L100.22 74.1512C100.185 73.9061 100.093 73.6729 99.9506 73.4706C99.8082 73.2683 99.6196 73.1027 99.4006 72.9876C98.3408 72.4332 97.2337 71.9742 96.0926 71.6158C95.856 71.542 95.6052 71.5255 95.361 71.5678C95.1168 71.61 94.8861 71.7097 94.688 71.8586L91.0024 74.6229C90.6711 74.6029 90.3373 74.5929 90.001 74.5928C89.6646 74.5928 89.3307 74.6028 88.9993 74.6229L88.9991 74.6229Z"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "users-slide":
      iconElement = (
        <svg
          width="246"
          height="250"
          viewBox="0 0 246 250"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M34.0581 136.28L61.833 59.1789C62.8075 56.4739 65.1586 54.4998 67.9914 54.0081L148.832 39.9762C151.64 39.4887 154.496 40.5324 156.328 42.716L210.026 106.711C211.859 108.895 212.391 111.888 211.423 114.569L183.576 191.736C182.6 194.441 180.248 196.413 177.415 196.904L96.6517 210.876C93.8444 211.361 90.9908 210.317 89.1596 208.135L35.4563 144.134C33.6252 141.952 33.0927 138.96 34.0581 136.28Z"
            stroke="white"
            strokeWidth="4"
          />
          <path
            d="M113.625 132.5C120.356 132.5 125.812 127.043 125.812 120.312C125.812 113.582 120.356 108.125 113.625 108.125C106.894 108.125 101.438 113.582 101.438 120.312C101.438 127.043 106.894 132.5 113.625 132.5Z"
            stroke="white"
            strokeWidth="4"
            strokeMiterlimit="10"
          />
          <path
            d="M129.425 108.58C131.101 108.108 132.859 108 134.581 108.264C136.302 108.529 137.947 109.159 139.404 110.112C140.861 111.066 142.097 112.321 143.029 113.792C143.96 115.264 144.566 116.918 144.804 118.643C145.043 120.368 144.909 122.124 144.412 123.793C143.914 125.462 143.065 127.005 141.921 128.318C140.777 129.632 139.365 130.684 137.78 131.406C136.195 132.127 134.473 132.501 132.732 132.501"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M96.75 141.265C98.6534 138.557 101.18 136.348 104.117 134.822C107.055 133.297 110.316 132.5 113.625 132.5C116.935 132.5 120.196 133.296 123.133 134.821C126.07 136.347 128.597 138.556 130.501 141.264"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M132.732 132.5C136.042 132.498 139.303 133.293 142.241 134.818C145.178 136.344 147.705 138.555 149.607 141.264"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "laptop-slide":
      iconElement = (
        <svg
          width="246"
          height="250"
          viewBox="0 0 246 250"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M34.0581 136.28L61.833 59.1789C62.8075 56.4739 65.1586 54.4998 67.9914 54.0081L148.832 39.9762C151.64 39.4887 154.496 40.5324 156.328 42.716L210.026 106.711C211.859 108.895 212.391 111.888 211.423 114.569L183.576 191.736C182.6 194.441 180.248 196.413 177.415 196.904L96.6517 210.876C93.8444 211.361 90.9908 210.317 89.1596 208.135L35.4563 144.134C33.6252 141.952 33.0927 138.96 34.0581 136.28Z"
            stroke="white"
            strokeWidth="4"
          />
          <path
            d="M102.375 136.25V111.875C102.375 110.88 102.77 109.927 103.473 109.223C104.177 108.52 105.13 108.125 106.125 108.125H139.875C140.87 108.125 141.823 108.52 142.527 109.223C143.23 109.927 143.625 110.88 143.625 111.875V136.25"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M98.625 136.25H147.375V140C147.375 140.995 146.98 141.948 146.277 142.652C145.573 143.355 144.62 143.75 143.625 143.75H102.375C101.38 143.75 100.427 143.355 99.7233 142.652C99.0201 141.948 98.625 140.995 98.625 140V136.25Z"
            fill="white"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M126.75 115.625H119.25"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "chartbar-slide":
      iconElement = (
        <svg
          width="130"
          height="133"
          viewBox="0 0 130 133"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.7538 70.0202L32.53 34.5542C33.5044 31.8492 35.8555 29.8751 38.6884 29.3834L75.8785 22.9281C78.687 22.4406 81.5428 23.4843 83.375 25.6679L108.16 55.206C109.993 57.3895 110.525 60.3828 109.557 63.0639L96.7462 98.5637C95.7702 101.268 93.4181 103.241 90.585 103.731L53.4342 110.158C50.627 110.644 47.7734 109.6 45.9421 107.418L21.152 77.8738C19.3208 75.6916 18.7883 72.7003 19.7538 70.0202Z"
            stroke="white"
            strokeWidth="4"
          />
          <path
            d="M51.875 79.498V68.248H60.625"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M80.625 79.498H49.375"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M60.625 79.498V60.748H69.375"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M78.125 53.248H69.375V79.498H78.125V53.248Z"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "search-slide":
      iconElement = (
        <svg
          width="180"
          height="183"
          viewBox="0 0 180 183"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.9239 98.6019L45.1697 45.1768C46.1442 42.4717 48.4952 40.4977 51.3281 40.006L107.346 30.2825C110.155 29.795 113.011 30.8387 114.843 33.0224L152.1 77.4234C153.932 79.6068 154.464 82.6002 153.496 85.2812L134.2 138.754C133.224 141.458 130.872 143.431 128.038 143.921L72.0758 153.603C69.2686 154.089 66.415 153.045 64.5837 150.862L27.3221 106.456C25.491 104.273 24.9584 101.282 25.9239 98.6019Z"
            stroke="white"
            strokeWidth="4"
          />
          <path
            d="M87.6562 106.062C96.7172 106.062 104.062 98.7172 104.062 89.6562C104.062 80.5953 96.7172 73.25 87.6562 73.25C78.5953 73.25 71.25 80.5953 71.25 89.6562C71.25 98.7172 78.5953 106.062 87.6562 106.062Z"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M99.2559 101.258L108.748 110.75"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "teacher-orange":
      iconElement = (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="15" cy="15" r="15" fill="#F88C00" />
          <path
            d="M15 15.0026C16.8417 15.0026 18.3333 13.5109 18.3333 11.6693C18.3333 9.8276 16.8417 8.33594 15 8.33594C13.1583 8.33594 11.6667 9.8276 11.6667 11.6693C11.6667 13.5109 13.1583 15.0026 15 15.0026ZM15 16.6693C12.775 16.6693 8.33334 17.7859 8.33334 20.0026V20.8359C8.33334 21.2943 8.70834 21.6693 9.16668 21.6693H20.8333C21.2917 21.6693 21.6667 21.2943 21.6667 20.8359V20.0026C21.6667 17.7859 17.225 16.6693 15 16.6693Z"
            fill="white"
          />
        </svg>
      )
      break
    case "book-orange":
      iconElement = (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="15" cy="15" r="15" fill="#F88C00" />
          <path
            d="M22.5 9.16667C21.575 8.875 20.5583 8.75 19.5833 8.75C17.9583 8.75 16.2083 9.08333 15 10C13.7917 9.08333 12.0417 8.75 10.4167 8.75C8.79168 8.75 7.04168 9.08333 5.83334 10V22.2083C5.83334 22.4167 6.04168 22.625 6.25001 22.625C6.33334 22.625 6.37501 22.5833 6.45834 22.5833C7.58334 22.0417 9.20834 21.6667 10.4167 21.6667C12.0417 21.6667 13.7917 22 15 22.9167C16.125 22.2083 18.1667 21.6667 19.5833 21.6667C20.9583 21.6667 22.375 21.9167 23.5417 22.5417C23.625 22.5833 23.6667 22.5833 23.75 22.5833C23.9583 22.5833 24.1667 22.375 24.1667 22.1667V10C23.6667 9.625 23.125 9.375 22.5 9.16667ZM22.5 20.4167C21.5833 20.125 20.5833 20 19.5833 20C18.1667 20 16.125 20.5417 15 21.25V11.6667C16.125 10.9583 18.1667 10.4167 19.5833 10.4167C20.5833 10.4167 21.5833 10.5417 22.5 10.8333V20.4167Z"
            fill="white"
          />
          <path
            d="M19.5833 13.75C20.3167 13.75 21.025 13.825 21.6667 13.9667V12.7C21.0083 12.575 20.3 12.5 19.5833 12.5C18.1667 12.5 16.8833 12.7417 15.8333 13.1917V14.575C16.775 14.0417 18.0833 13.75 19.5833 13.75Z"
            fill="white"
          />
          <path
            d="M15.8333 15.4104V16.7937C16.775 16.2604 18.0833 15.9688 19.5833 15.9688C20.3167 15.9688 21.025 16.0438 21.6667 16.1854V14.9187C21.0083 14.7937 20.3 14.7188 19.5833 14.7188C18.1667 14.7188 16.8833 14.9687 15.8333 15.4104Z"
            fill="white"
          />
          <path
            d="M19.5833 16.9453C18.1667 16.9453 16.8833 17.187 15.8333 17.637V19.0203C16.775 18.487 18.0833 18.1953 19.5833 18.1953C20.3167 18.1953 21.025 18.2703 21.6667 18.412V17.1453C21.0083 17.012 20.3 16.9453 19.5833 16.9453Z"
            fill="white"
          />
        </svg>
      )
      break
    case "student-orange":
      iconElement = (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="15" cy="15" r="15" fill="#F88C00" />
          <path
            d="M18.75 14.9974C19.9 14.9974 20.825 14.0641 20.825 12.9141C20.825 11.7641 19.9 10.8307 18.75 10.8307C17.6 10.8307 16.6667 11.7641 16.6667 12.9141C16.6667 14.0641 17.6 14.9974 18.75 14.9974ZM12.5 14.1641C13.8833 14.1641 14.9917 13.0474 14.9917 11.6641C14.9917 10.2807 13.8833 9.16406 12.5 9.16406C11.1167 9.16406 9.99999 10.2807 9.99999 11.6641C9.99999 13.0474 11.1167 14.1641 12.5 14.1641ZM18.75 16.6641C17.225 16.6641 14.1667 17.4307 14.1667 18.9557V19.9974C14.1667 20.4557 14.5417 20.8307 15 20.8307H22.5C22.9583 20.8307 23.3333 20.4557 23.3333 19.9974V18.9557C23.3333 17.4307 20.275 16.6641 18.75 16.6641ZM12.5 15.8307C10.5583 15.8307 6.66666 16.8057 6.66666 18.7474V19.9974C6.66666 20.4557 7.04166 20.8307 7.49999 20.8307H12.5V18.9557C12.5 18.2474 12.775 17.0057 14.475 16.0641C13.75 15.9141 13.05 15.8307 12.5 15.8307Z"
            fill="white"
          />
        </svg>
      )
      break
    case "register-orange":
      iconElement = (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="15" cy="15" r="15" fill="#F88C00" />
          <path
            d="M17.5 15.0026C19.3417 15.0026 20.8333 13.5109 20.8333 11.6693C20.8333 9.8276 19.3417 8.33594 17.5 8.33594C15.6583 8.33594 14.1667 9.8276 14.1667 11.6693C14.1667 13.5109 15.6583 15.0026 17.5 15.0026ZM10 13.3359V11.6693C10 11.2109 9.62501 10.8359 9.16668 10.8359C8.70834 10.8359 8.33334 11.2109 8.33334 11.6693V13.3359H6.66668C6.20834 13.3359 5.83334 13.7109 5.83334 14.1693C5.83334 14.6276 6.20834 15.0026 6.66668 15.0026H8.33334V16.6693C8.33334 17.1276 8.70834 17.5026 9.16668 17.5026C9.62501 17.5026 10 17.1276 10 16.6693V15.0026H11.6667C12.125 15.0026 12.5 14.6276 12.5 14.1693C12.5 13.7109 12.125 13.3359 11.6667 13.3359H10ZM17.5 16.6693C15.275 16.6693 10.8333 17.7859 10.8333 20.0026V20.8359C10.8333 21.2943 11.2083 21.6693 11.6667 21.6693H23.3333C23.7917 21.6693 24.1667 21.2943 24.1667 20.8359V20.0026C24.1667 17.7859 19.725 16.6693 17.5 16.6693Z"
            fill="white"
          />
        </svg>
      )
      break
    case "date-orange":
      iconElement = (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="15" cy="15" r="15" fill="#F88C00" />
          <path
            d="M20.8333 8.33073H20V7.4974C20 7.03906 19.625 6.66406 19.1667 6.66406C18.7083 6.66406 18.3333 7.03906 18.3333 7.4974V8.33073H11.6667V7.4974C11.6667 7.03906 11.2917 6.66406 10.8333 6.66406C10.375 6.66406 10 7.03906 10 7.4974V8.33073H9.16667C8.24167 8.33073 7.50833 9.08073 7.50833 9.9974L7.5 21.6641C7.5 22.5807 8.24167 23.3307 9.16667 23.3307H20.8333C21.75 23.3307 22.5 22.5807 22.5 21.6641V9.9974C22.5 9.08073 21.75 8.33073 20.8333 8.33073ZM20.8333 20.8307C20.8333 21.2891 20.4583 21.6641 20 21.6641H10C9.54167 21.6641 9.16667 21.2891 9.16667 20.8307V12.4974H20.8333V20.8307ZM10.8333 14.1641H12.5V15.8307H10.8333V14.1641ZM14.1667 14.1641H15.8333V15.8307H14.1667V14.1641ZM17.5 14.1641H19.1667V15.8307H17.5V14.1641Z"
            fill="white"
          />
        </svg>
      )
      break
    case "check-blu":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.14644 13.8282L7.49981 14.1815L7.85337 13.8283L16.0867 5.60334L16.0869 5.60316C16.2166 5.47342 16.425 5.47342 16.5548 5.60316C16.6845 5.7329 16.6845 5.94132 16.5548 6.07106L7.73811 14.8877C7.60837 15.0175 7.39995 15.0175 7.27021 14.8877L3.78688 11.4044C3.65714 11.2747 3.65714 11.0662 3.78688 10.9365C3.91662 10.8068 4.12503 10.8068 4.25477 10.9365L7.14644 13.8282Z"
            fill="#0D99FF"
            stroke="#0D99FF"
          />
        </svg>
      )
      break
    case "activity":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.38056 2.50136C8.74477 2.5221 9.05315 2.77732 9.14162 3.13123L11.8259 13.8683L13.3862 9.70741C13.5082 9.38215 13.8191 9.16668 14.1665 9.16668H17.4998C17.9601 9.16668 18.3332 9.53977 18.3332 10C18.3332 10.4602 17.9601 10.8333 17.4998 10.8333H14.744L12.4468 16.9593C12.3187 17.3009 11.9833 17.5194 11.6191 17.4987C11.2549 17.4779 10.9465 17.2227 10.8581 16.8688L8.17378 6.13171L6.61345 10.2926C6.49148 10.6179 6.18054 10.8333 5.83317 10.8333H2.49984C2.0396 10.8333 1.6665 10.4602 1.6665 10C1.6665 9.53977 2.0396 9.16668 2.49984 9.16668H5.25567L7.5529 3.04074C7.68099 2.69917 8.01635 2.48061 8.38056 2.50136Z"
            fill="#154398"
          />
        </svg>
      )
      break
    case "reply-right":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.6667 7.50152V6.17652C11.6667 5.43485 12.5667 5.05985 13.0917 5.58485L16.9167 9.40985C17.2417 9.73485 17.2417 10.2599 16.9167 10.5849L13.0917 14.4099C12.5667 14.9349 11.6667 14.5682 11.6667 13.8265V12.4182C7.49998 12.4182 4.58332 13.7515 2.49998 16.6682C3.33332 12.5015 5.83332 8.33485 11.6667 7.50152Z"
            fill="#F88C00"
          />
        </svg>
      )
      break
    case "mode-comment":
      iconElement = (
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.3335 11.9454L12.5535 11.1654H2.66683V3.16536H13.3335V11.9454ZM13.3335 1.83203H2.66683C1.9335 1.83203 1.3335 2.43203 1.3335 3.16536V11.1654C1.3335 11.8987 1.9335 12.4987 2.66683 12.4987H12.0002L14.6668 15.1654V3.16536C14.6668 2.43203 14.0668 1.83203 13.3335 1.83203Z"
            fill="#777777"
          />
        </svg>
      )
      break
    case "mic-orange":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 11.668C11.3833 11.668 12.5 10.5513 12.5 9.16797V4.16797C12.5 2.78464 11.3833 1.66797 10 1.66797C8.61668 1.66797 7.50001 2.78464 7.50001 4.16797V9.16797C7.50001 10.5513 8.61668 11.668 10 11.668ZM14.925 9.16797C14.5167 9.16797 14.175 9.46797 14.1083 9.8763C13.7667 11.8346 12.0583 13.3346 10 13.3346C7.94168 13.3346 6.23334 11.8346 5.89168 9.8763C5.82501 9.46797 5.48334 9.16797 5.07501 9.16797C4.56668 9.16797 4.16668 9.61797 4.24168 10.118C4.65001 12.618 6.65001 14.5763 9.16668 14.9346V16.668C9.16668 17.1263 9.54168 17.5013 10 17.5013C10.4583 17.5013 10.8333 17.1263 10.8333 16.668V14.9346C13.35 14.5763 15.35 12.618 15.7583 10.118C15.8417 9.61797 15.4333 9.16797 14.925 9.16797Z"
            fill="#F88C00"
          />
        </svg>
      )
      break
    case "more-horiz":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
            fill="#777777"
          />
        </svg>
      )
      break
    case "liked":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.3721 4.123C10.3721 2.45471 9.61744 1.5258 8.1081 1.33627C8.0779 1.33248 8.04743 1.33123 8.01701 1.33253C7.72768 1.34493 7.50356 1.58092 7.51641 1.85963L7.62859 4.28884C7.55125 5.18155 7.0342 6.07444 6.07743 6.96753L5.96555 7.07733C5.42556 7.63512 5.17665 8.32422 5.21881 9.14465L5.21914 12.7398C5.23164 13.6318 5.6183 14.6236 9.73289 14.6236C12.5258 14.6236 13.7924 14.0829 13.5327 13.0015C14.0674 12.809 14.368 12.5214 14.4343 12.1385C14.5007 11.7557 14.4017 11.4208 14.1376 11.1338C14.6868 10.804 14.9614 10.3796 14.9614 9.86078C14.9614 9.34193 14.7226 8.94207 14.2449 8.66123C14.5513 8.4384 14.6162 8.20523 14.6162 7.96172C14.6162 6.97356 13.1661 6.44857 10.0891 6.38675C10.2778 5.21477 10.3721 4.46019 10.3721 4.123ZM2.00004 7.9987C1.63185 7.9987 1.33337 8.29718 1.33337 8.66536V13.9987C1.33337 14.3669 1.63185 14.6654 2.00004 14.6654H4.00004C4.36823 14.6654 4.66671 14.3669 4.66671 13.9987V8.66536C4.66671 8.29717 4.36823 7.9987 4.00004 7.9987H2.00004Z"
            fill="#038CF5"
          />
        </svg>
      )
      break
    case "arrow-bend-down":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 6.5L14 9.5L11 12.5"
            stroke="#666666"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 3.5C2 5.0913 2.63214 6.61742 3.75736 7.74264C4.88258 8.86786 6.4087 9.5 8 9.5H14"
            stroke="#666666"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "react-like-fb":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.81871 7.0625C1.58137 7.0625 1.33337 8.57249 1.33337 8.83183V12.3292C1.33337 12.5892 1.58071 14.0985 2.81871 14.0985H2.8927C3.21404 14.09 3.51936 13.9563 3.74353 13.7259C3.9677 13.4955 4.093 13.1866 4.09271 12.8652V8.29783C4.09317 7.97626 3.96794 7.66723 3.74375 7.43669C3.51957 7.20615 3.21416 7.07234 2.8927 7.06382L2.81871 7.0625Z"
            stroke="#777777"
            strokeWidth="1.5"
          />
          <path
            d="M11.5572 5.97116C11.1033 5.952 10.6485 5.97163 10.1979 6.02983C10.4674 5.61996 10.6229 5.14568 10.6483 4.65579C10.6737 4.1659 10.5682 3.67807 10.3426 3.2425C10.1589 2.74624 9.79555 2.33703 9.32455 2.09583C9.19372 2.02936 9.0484 1.99652 8.9017 2.00029C8.755 2.00407 8.61156 2.04433 8.48432 2.11744C8.35709 2.19055 8.25007 2.29421 8.17294 2.41905C8.09581 2.5439 8.051 2.68598 8.04255 2.83249C8.03485 3.18644 8.05537 3.54046 8.10389 3.89116C8.29589 4.83516 7.95787 5.21715 7.21654 5.83249C7.21654 5.83249 5.80587 7.0485 5.80587 8.03783C5.80587 8.6585 5.78055 9.20316 5.81855 11.5605C5.85655 13.9178 9.27855 13.5212 11.4132 13.4065C11.8875 13.4067 12.3537 13.284 12.7665 13.0505C14.4005 12.3425 14.5432 10.4718 14.5432 7.98983C14.5432 5.50783 11.5572 5.97116 11.5572 5.97116Z"
            stroke="#777777"
            strokeWidth="1.5"
          />
        </svg>
      )
      break
    case "arrow-back-red":
      iconElement = (
        <svg
          width="7"
          height="20"
          viewBox="0 0 7 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.25833 13.2331L2.02499 9.99974L5.25833 6.76641C5.58333 6.44141 5.58333 5.91641 5.25833 5.59141C4.93333 5.26641 4.40833 5.26641 4.08333 5.59141L0.258325 9.41641C-0.0666752 9.74141 -0.0666752 10.2664 0.258325 10.5914L4.08333 14.4164C4.40833 14.7414 4.93333 14.7414 5.25833 14.4164C5.57499 14.0914 5.58333 13.5581 5.25833 13.2331Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "pen-red":
      iconElement = (
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.37333 6.51333L9.98667 7.12667L3.94667 13.1667H3.33333V12.5533L9.37333 6.51333ZM11.7733 2.5C11.6067 2.5 11.4333 2.56667 11.3067 2.69333L10.0867 3.91333L12.5867 6.41333L13.8067 5.19333C14.0667 4.93333 14.0667 4.51333 13.8067 4.25333L12.2467 2.69333C12.1133 2.56 11.9467 2.5 11.7733 2.5ZM9.37333 4.62667L2 12V14.5H4.5L11.8733 7.12667L9.37333 4.62667Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "fall":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.9289 4.4601V5.53153C13.9289 5.62944 13.8488 5.70954 13.7509 5.70954H5.17946C5.08155 5.70954 5.00145 5.62944 5.00145 5.53153V4.4601C5.00145 4.36219 5.08155 4.28209 5.17946 4.28209H13.7509C13.8488 4.28209 13.9289 4.36219 13.9289 4.4601ZM5.00145 7.67439C5.00145 7.57648 5.08155 7.49637 5.17946 7.49637H9.2866C9.38451 7.49637 9.46462 7.57648 9.46462 7.67439V8.74582C9.46462 8.84372 9.38451 8.92383 9.2866 8.92383H5.17946C5.08155 8.92383 5.00145 8.84372 5.00145 8.74582V7.67439ZM8.75145 14.9065C8.75145 12.2439 10.9097 10.0857 13.5723 10.0857C16.235 10.0857 18.3932 12.2439 18.3932 14.9065C18.3932 17.5692 16.235 19.7274 13.5723 19.7274C10.9097 19.7274 8.75145 17.5692 8.75145 14.9065ZM13.5723 18.2999C14.4787 18.2999 15.3315 17.9472 15.9723 17.3065C16.613 16.6657 16.9657 15.8129 16.9657 14.9065C16.9657 14.0001 16.613 13.1473 15.9723 12.5066C15.3315 11.8659 14.4787 11.5131 13.5723 11.5131C12.6659 11.5131 11.8131 11.8659 11.1724 12.5066C10.5316 13.1473 10.1789 14.0001 10.1789 14.9065C10.1789 15.8129 10.5316 16.6657 11.1724 17.3065C11.8131 17.9472 12.6659 18.2999 13.5723 18.2999ZM3.21518 17.5851V17.5857H8.39375C8.49165 17.5857 8.57176 17.6658 8.57176 17.7637V19.0137C8.57176 19.1116 8.49165 19.1917 8.39375 19.1917H2.32232C1.92754 19.1917 1.60859 18.8727 1.60859 18.478V0.977958C1.60859 0.583176 1.92754 0.26423 2.32232 0.26423H16.608C17.0028 0.26423 17.3218 0.583176 17.3218 0.977958V9.54939C17.3218 9.64729 17.2417 9.7274 17.1437 9.7274H15.8937C15.7958 9.7274 15.7157 9.64729 15.7157 9.54939V1.87081H15.7152V1.87026H3.21518V1.87081H3.21462V17.5851H3.21518Z"
            fill="#ED1117"
            stroke="#ED1117"
            strokeWidth="0.00111607"
          />
          <path
            d="M14.4004 13.3008C14.4628 13.2383 14.5641 13.2383 14.6266 13.3008L15.2842 13.9584C15.3467 14.0209 15.3467 14.1222 15.2842 14.1847L12.6821 16.7868C12.6196 16.8493 12.5183 16.8493 12.4558 16.7868L11.7982 16.1292C11.7357 16.0667 11.7357 15.9654 11.7982 15.9029L14.4004 13.3008Z"
            fill="#ED1117"
          />
          <path
            d="M11.7982 14.1847C11.7357 14.1222 11.7357 14.0209 11.7982 13.9584L12.4558 13.3008C12.5183 13.2383 12.6196 13.2383 12.6821 13.3008L15.2842 15.9029C15.3467 15.9654 15.3467 16.0667 15.2842 16.1292L14.6266 16.7868C14.5641 16.8493 14.4628 16.8493 14.4004 16.7868L11.7982 14.1847Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "elect":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.0076 15.2436L13.008 15.2433L13.009 15.2425L14.4254 13.2841L14.425 13.2838L14.4255 13.2841C14.4588 13.2374 14.5122 13.2107 14.5701 13.2107H15.5589C15.7036 13.2107 15.7881 13.3753 15.7013 13.4933L13.1522 17.02C13.081 17.1179 12.9364 17.1179 12.8652 17.02L11.2179 14.741C11.1333 14.6231 11.2179 14.4584 11.3625 14.4584H12.3469C12.3751 14.4582 12.403 14.4647 12.4281 14.4775C12.4533 14.4903 12.475 14.5089 12.4915 14.5319L13.0071 15.2439L13.0076 15.2436ZM13.9289 4.4601V5.53153C13.9289 5.62944 13.8488 5.70954 13.7509 5.70954H5.17946C5.08155 5.70954 5.00145 5.62944 5.00145 5.53153V4.4601C5.00145 4.36219 5.08155 4.28209 5.17946 4.28209H13.7509C13.8488 4.28209 13.9289 4.36219 13.9289 4.4601ZM5.00145 7.67439C5.00145 7.57648 5.08155 7.49637 5.17946 7.49637H9.2866C9.38451 7.49637 9.46462 7.57648 9.46462 7.67439V8.74582C9.46462 8.84372 9.38451 8.92383 9.2866 8.92383H5.17946C5.08155 8.92383 5.00145 8.84372 5.00145 8.74582V7.67439ZM8.75145 14.9065C8.75145 12.2439 10.9097 10.0857 13.5723 10.0857C16.235 10.0857 18.3932 12.2439 18.3932 14.9065C18.3932 17.5692 16.235 19.7274 13.5723 19.7274C10.9097 19.7274 8.75145 17.5692 8.75145 14.9065ZM13.5723 18.2999C14.4787 18.2999 15.3315 17.9472 15.9723 17.3065C16.613 16.6657 16.9657 15.8129 16.9657 14.9065C16.9657 14.0001 16.613 13.1473 15.9723 12.5066C15.3315 11.8659 14.4787 11.5131 13.5723 11.5131C12.6659 11.5131 11.8131 11.8659 11.1724 12.5066C10.5316 13.1473 10.1789 14.0001 10.1789 14.9065C10.1789 15.8129 10.5316 16.6657 11.1724 17.3065C11.8131 17.9472 12.6659 18.2999 13.5723 18.2999ZM3.21518 17.5851V17.5857H8.39375C8.49165 17.5857 8.57176 17.6658 8.57176 17.7637V19.0137C8.57176 19.1116 8.49165 19.1917 8.39375 19.1917H2.32232C1.92754 19.1917 1.60859 18.8727 1.60859 18.478V0.977958C1.60859 0.583176 1.92754 0.26423 2.32232 0.26423H16.608C17.0028 0.26423 17.3218 0.583176 17.3218 0.977958V9.54939C17.3218 9.64729 17.2417 9.7274 17.1437 9.7274H15.8937C15.7958 9.7274 15.7157 9.64729 15.7157 9.54939V1.87081H15.7152V1.87026H3.21518V1.87081H3.21462V17.5851H3.21518Z"
            fill="#0D99FF"
            stroke="#0D99FF"
            strokeWidth="0.00111607"
          />
        </svg>
      )
      break
    case "shopping-bag":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.3334 7.63987H14.3417L10.6917 2.42747C10.5334 2.20499 10.2667 2.09375 10 2.09375C9.73337 2.09375 9.46671 2.20499 9.30837 2.43542L5.65837 7.63987H1.66671C1.20837 7.63987 0.833374 7.99743 0.833374 8.43445C0.833374 8.50596 0.841707 8.57747 0.866707 8.64898L2.98337 16.0147C3.17504 16.6821 3.81671 17.1748 4.58337 17.1748H15.4167C16.1834 17.1748 16.825 16.6821 17.025 16.0147L19.1417 8.64898L19.1667 8.43445C19.1667 7.99743 18.7917 7.63987 18.3334 7.63987ZM10 4.30266L12.3334 7.63987H7.66671L10 4.30266ZM15.4167 15.5856L4.59171 15.5936L2.75837 9.22902H17.25L15.4167 15.5856ZM10 10.8182C9.08337 10.8182 8.33337 11.5333 8.33337 12.4073C8.33337 13.2813 9.08337 13.9965 10 13.9965C10.9167 13.9965 11.6667 13.2813 11.6667 12.4073C11.6667 11.5333 10.9167 10.8182 10 10.8182Z"
            fill="#212529"
          />
        </svg>
      )
      break
    case "login-facebook":
      iconElement = (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="16"
            cy="16"
            r="14"
            fill="url(#paint0_linear_2296_73794)"
          />
          <path
            d="M21.2137 20.2816L21.8356 16.3301H17.9452V13.767C17.9452 12.6857 18.4877 11.6311 20.2302 11.6311H22V8.26699C22 8.26699 20.3945 8 18.8603 8C15.6548 8 13.5617 9.89294 13.5617 13.3184V16.3301H10V20.2816H13.5617V29.8345C14.2767 29.944 15.0082 30 15.7534 30C16.4986 30 17.2302 29.944 17.9452 29.8345V20.2816H21.2137Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2296_73794"
              x1="16"
              y1="2"
              x2="16"
              y2="29.917"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#18ACFE" />
              <stop offset="1" stopColor="#0163E0" />
            </linearGradient>
          </defs>
        </svg>
      )
      break
    case "login-google":
      iconElement = (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M30.0014 16.3114C30.0014 15.1603 29.9061 14.3203 29.6998 13.4492H16.2871V18.6447H24.1601C24.0014 19.9359 23.1442 21.8803 21.2394 23.1869L21.2127 23.3609L25.4536 26.5805L25.7474 26.6092C28.4458 24.167 30.0014 20.5736 30.0014 16.3114Z"
            fill="#4285F4"
          />
          <path
            d="M16.2863 30.0008C20.1434 30.0008 23.3814 28.7562 25.7466 26.6096L21.2386 23.1873C20.0323 24.0117 18.4132 24.5873 16.2863 24.5873C12.5086 24.5873 9.30225 22.1451 8.15929 18.7695L7.99176 18.7835L3.58208 22.128L3.52441 22.2851C5.87359 26.8584 10.699 30.0008 16.2863 30.0008Z"
            fill="#34A853"
          />
          <path
            d="M8.15964 18.7699C7.85806 17.8988 7.68352 16.9654 7.68352 16.001C7.68352 15.0365 7.85806 14.1032 8.14377 13.2321L8.13578 13.0466L3.67083 9.64844L3.52475 9.71653C2.55654 11.6143 2.00098 13.7455 2.00098 16.001C2.00098 18.2566 2.55654 20.3876 3.52475 22.2854L8.15964 18.7699Z"
            fill="#FBBC05"
          />
          <path
            d="M16.2864 7.4133C18.9689 7.4133 20.7784 8.54885 21.8102 9.4978L25.8419 5.64C23.3658 3.38445 20.1435 2 16.2864 2C10.699 2 5.8736 5.1422 3.52441 9.71549L8.14345 13.2311C9.30229 9.85555 12.5086 7.4133 16.2864 7.4133Z"
            fill="#EB4335"
          />
        </svg>
      )
      break
    case "info":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM13 9H11V7H13V9Z"
            fill="#0D99FF"
          />
        </svg>
      )
      break
    case "dot-black":
      iconElement = (
        <svg
          width="4"
          height="4"
          viewBox="0 0 4 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="2" cy="2" r="2" fill="#212529" />
        </svg>
      )
      break
    case "person-seminar":
      iconElement = (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.99992 5.50004C10.9166 5.50004 11.6666 6.25004 11.6666 7.16671C11.6666 8.08337 10.9166 8.83337 9.99992 8.83337C9.08325 8.83337 8.33325 8.08337 8.33325 7.16671C8.33325 6.25004 9.08325 5.50004 9.99992 5.50004ZM9.99992 13.8334C12.2499 13.8334 14.8333 14.9084 14.9999 15.5H4.99992C5.19159 14.9 7.75825 13.8334 9.99992 13.8334ZM9.99992 3.83337C8.15825 3.83337 6.66659 5.32504 6.66659 7.16671C6.66659 9.00837 8.15825 10.5 9.99992 10.5C11.8416 10.5 13.3333 9.00837 13.3333 7.16671C13.3333 5.32504 11.8416 3.83337 9.99992 3.83337ZM9.99992 12.1667C7.77492 12.1667 3.33325 13.2834 3.33325 15.5V17.1667H16.6666V15.5C16.6666 13.2834 12.2249 12.1667 9.99992 12.1667Z"
            fill="black"
            fillOpacity="0.54"
          />
        </svg>
      )
      break
    case "edit-seminar":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
            fill="#00AEAC"
          />
        </svg>
      )
      break
    case "reply":
      iconElement = (
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.83335 7.50152V6.17652C8.83335 5.43485 7.93335 5.05985 7.40835 5.58485L3.58335 9.40985C3.25835 9.73485 3.25835 10.2599 3.58335 10.5849L7.40835 14.4099C7.93335 14.9349 8.83335 14.5682 8.83335 13.8265V12.4182C13 12.4182 15.9167 13.7515 18 16.6682C17.1667 12.5015 14.6667 8.33485 8.83335 7.50152Z"
            fill="#F88C00"
          />
        </svg>
      )
      break
    case "ellipe-blue":
      iconElement = (
        <svg
          width="4"
          height="5"
          viewBox="0 0 4 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="2" cy="2.5" r="2" fill="#0D99FF" />
        </svg>
      )
      break
    case "ellipe":
      iconElement = (
        <svg
          width="4"
          height="5"
          viewBox="0 0 4 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="2" cy="2.5" r="2" fill="#212529" />
        </svg>
      )
      break
    case "status_order_1":
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 12H26"
            stroke="#154398"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 16L26 16"
            stroke="#154398"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 20L26 20"
            stroke="#154398"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.5 31V5.875C4.5 5.57663 4.61853 5.29048 4.82951 5.07951C5.04048 4.86853 5.32663 4.75 5.625 4.75H30.375C30.6734 4.75 30.9595 4.86853 31.1705 5.07951C31.3815 5.29048 31.5 5.57663 31.5 5.875V31L26.5 27L22 31L17.5 27L13 31L8.5 27L4.5 31Z"
            stroke="#154398"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "status_order_2":
      iconElement = (
        <svg
          width="31"
          height="34"
          viewBox="0 0 31 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.871 0C19.0599 0 19.2362 0.0541495 19.3851 0.147822C19.4462 0.186162 19.5032 0.231446 19.5551 0.283306L26.522 7.2502C26.7033 7.43149 26.8051 7.67734 26.8051 7.93368V14.9877C26.8051 15.5216 26.3723 15.9543 25.8384 15.9543C25.3045 15.9543 24.8718 15.5216 24.8718 14.9877V8.90018H18.871C18.3372 8.90018 17.9044 8.46742 17.9044 7.93354V1.9335H1.93328V31.9782H13.8554C14.3892 31.9782 14.8221 32.4109 14.8221 32.9448C14.8221 33.4787 14.3892 33.9114 13.8554 33.9114H0.966638C0.432752 33.9114 0 33.4787 0 32.9448V0.966861C0 0.432975 0.432752 0.000146539 0.966638 0.000146539H18.8528L18.871 0ZM19.8377 6.9669V3.30002L23.5045 6.9669H19.8377ZM7.79414 10.9378C7.26032 10.9378 6.8275 11.3706 6.8275 11.9045C6.8275 12.4384 7.26032 12.8711 7.79414 12.8711H18.3141C18.848 12.8711 19.2808 12.4384 19.2808 11.9045C19.2808 11.3706 18.848 10.9378 18.3141 10.9378H7.79414ZM3.71822 16.3633C3.71822 15.8294 4.15097 15.3966 4.68486 15.3966H14.8218C15.3557 15.3966 15.7885 15.8294 15.7885 16.3633C15.7885 16.8972 15.3557 17.3299 14.8218 17.3299H4.68486C4.15097 17.3299 3.71822 16.8972 3.71822 16.3633ZM5.00702 19.8555C4.47314 19.8555 4.04038 20.2882 4.04038 20.8221C4.04038 21.356 4.47314 21.7887 5.00702 21.7887H11.0857C11.6195 21.7887 12.0523 21.356 12.0523 20.8221C12.0523 20.2882 11.6195 19.8555 11.0857 19.8555H5.00702ZM4.04038 25.2809C4.04038 24.747 4.47314 24.3143 5.00702 24.3143H10.18C10.7138 24.3143 11.1466 24.747 11.1466 25.2809C11.1466 25.8148 10.7138 26.2475 10.18 26.2475H5.00702C4.47314 26.2475 4.04038 25.8148 4.04038 25.2809ZM14.2644 25.0023C14.2644 21.1113 17.4186 17.957 21.3097 17.957C25.2006 17.957 28.3549 21.1113 28.3549 25.0023C28.3549 28.8933 25.2006 32.0475 21.3097 32.0475C17.4186 32.0475 14.2644 28.8933 14.2644 25.0023ZM21.3097 16.0238C16.3509 16.0238 12.331 20.0435 12.331 25.0023C12.331 29.961 16.3509 33.9809 21.3097 33.9809C26.2684 33.9809 30.2882 29.961 30.2882 25.0023C30.2882 20.0435 26.2684 16.0238 21.3097 16.0238Z"
            fill="#154398"
          />
          <path
            d="M21.2652 24.4158C23.0414 24.4158 24.4874 25.7011 24.4874 27.28C24.4874 28.61 23.4562 29.7217 22.0707 30.0421V30.7707C22.0707 31.2156 21.7101 31.5762 21.2652 31.5762C20.8203 31.5762 20.4596 31.2156 20.4596 30.7707V30.0421C19.3607 29.7879 18.4847 29.036 18.1694 28.0722C18.031 27.6494 18.4036 27.28 18.8486 27.28C19.2934 27.28 19.6414 27.6706 19.8968 28.0349C20.1814 28.4411 20.6885 28.712 21.2652 28.712C22.1533 28.712 22.8762 28.0694 22.8762 27.28C22.8762 26.4905 22.1533 25.8479 21.2652 25.8479C19.489 25.8479 18.043 24.5626 18.043 22.9837C18.043 21.6537 19.0741 20.542 20.4596 20.2216V19.493C20.4596 19.0482 20.8203 18.6875 21.2652 18.6875C21.7101 18.6875 22.0707 19.0482 22.0707 19.493V20.2216C23.1697 20.4758 24.0456 21.2277 24.361 22.1915C24.4993 22.6143 24.1267 22.9837 23.6818 22.9837C23.2369 22.9837 22.8889 22.5931 22.6336 22.2288C22.3489 21.8226 21.8419 21.5517 21.2652 21.5517C20.377 21.5517 19.6541 22.1943 19.6541 22.9837C19.6541 23.7732 20.377 24.4158 21.2652 24.4158Z"
            fill="#154398"
          />
        </svg>
      )
      break
    case "status_order_3":
      iconElement = (
        <svg
          width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1872_78335)">
            <path
              d="M28.7989 17.1729L14.5612 2.9352C14.7748 2.60565 14.7381 2.15405 14.4513 1.86111C14.1157 1.52546 13.5725 1.52546 13.2369 1.86111L3.47244 11.6255C3.13679 11.9612 3.13679 12.5043 3.47244 12.84C3.77148 13.139 4.16205 13.1878 4.54653 12.9498L18.7843 27.1876C20.9141 29.3174 25.1494 30.837 28.7989 27.1876C32.485 23.5015 30.8738 19.2479 28.7989 17.1729ZM5.77318 11.7476L13.365 4.16185L23.5017 14.2985H8.32413L5.77318 11.7476ZM27.5905 25.9731C24.9725 28.5912 21.4756 27.45 20.0048 25.9731L10.039 16.0134H25.2166L27.5905 18.3874C29.1223 19.9192 30.2452 23.3184 27.5905 25.9731Z"
              fill="#154398"
            />
            <path
              d="M4.74184 18.7475C4.57097 18.54 4.32075 18.418 4.05833 18.418C3.78981 18.418 3.5396 18.54 3.38093 18.7536C2.81337 19.486 0 23.2453 0 25.2042C0 27.4378 1.81862 29.2626 4.05833 29.2626C6.29194 29.2626 8.11667 27.4439 8.11667 25.2042C8.11667 23.2453 5.3033 19.486 4.74184 18.7475ZM4.05833 27.5477C2.77065 27.5477 1.72098 26.498 1.72098 25.2103C1.72098 24.3682 2.93543 22.3298 4.06444 20.7309C5.19345 22.3359 6.40179 24.3682 6.40179 25.2103C6.39569 26.498 5.34602 27.5477 4.05833 27.5477Z"
              fill="#154398"
            />
          </g>
          <defs>
            <clipPath id="clip0_1872_78335">
              <rect width="31" height="31" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "status_order_4":
      iconElement = (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1872_78348)">
            <path
              d="M24.5508 4.79297C25.1836 5.42578 25.9746 5.0625 26.2441 4.79297C26.6602 4.37695 26.7539 3.60937 26.2441 3.09961L24.1641 1.01953C23.6953 0.550781 22.9395 0.550781 22.4707 1.01953C22.002 1.48828 22.002 2.24414 22.4707 2.71289L24.5508 4.79297Z"
              fill="#154398"
            />
            <path
              d="M28.1309 26.9902H19.4004C19.7227 26.7324 20.0273 26.457 20.3262 26.1641C24.4102 22.0801 24.6035 15.5527 20.9004 11.2344L24.1875 7.94727C24.6562 7.47852 24.6562 6.72266 24.1875 6.25391L21.0117 3.07812C20.543 2.60938 19.7871 2.60938 19.3184 3.07812L10.7812 11.6152C10.3125 12.084 10.3125 12.8398 10.7812 13.3086L11.5254 14.0527L10.5996 14.9785C10.1309 15.4473 10.1309 16.2031 10.5996 16.6719C11.0684 17.1406 11.8242 17.1406 12.293 16.6719L13.2188 15.7461L13.9629 16.4902C14.666 17.1465 15.4336 16.7363 15.6563 16.4902L19.207 12.9395C21.9785 16.3145 21.791 21.3242 18.6387 24.4766C16.9629 26.1523 14.7363 27.0371 12.3574 26.9961C12.3457 26.9961 12.3398 26.9961 12.3281 26.9961C12.3105 26.9961 12.2988 26.9961 12.2812 26.9961H8.90625V23.5391H10.6582C11.3203 23.5391 11.8535 23.0059 11.8535 22.3437C11.8535 21.6816 11.3203 21.1484 10.6582 21.1484H4.75195C4.08984 21.1484 3.55664 21.6816 3.55664 22.3437C3.55664 23.0059 4.08984 23.5391 4.75195 23.5391H6.50391V26.9961H1.81641C1.1543 26.9961 0.621094 27.5293 0.621094 28.1914C0.621094 28.8535 1.1543 29.3867 1.81641 29.3867H28.1367C28.7988 29.3867 29.332 28.8535 29.332 28.1914C29.332 27.5293 28.793 26.9902 28.1309 26.9902V26.9902ZM14.8008 13.9473L13.3184 12.4648L20.1621 5.61523L21.6445 7.09766L14.8008 13.9473V13.9473Z"
              fill="#154398"
            />
          </g>
          <defs>
            <clipPath id="clip0_1872_78348">
              <rect width="30" height="30" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "status_order_5":
      iconElement = (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.23423 27.2986H14.1148C13.4494 26.7335 12.8844 26.0555 12.47 25.2771H7.34722C6.054 25.2771 5.36341 24.6116 5.36341 23.356V4.3591C5.36341 3.11608 6.04141 2.40042 7.34722 2.40042H20.468C21.7236 2.40042 22.4393 3.10355 22.4393 4.3591V15.3078C23.2178 15.7221 23.8958 16.2746 24.4608 16.94V4.32144C24.4608 1.69725 23.1676 0.378906 20.5685 0.378906H7.23423C4.64775 0.378906 3.34195 1.70983 3.34195 4.32144V23.3686C3.34195 25.9927 4.64775 27.2986 7.23423 27.2986ZM9.15525 7.52319H18.6726C19.112 7.52319 19.451 7.1716 19.451 6.73216C19.451 6.30525 19.112 5.97878 18.6726 5.97878H9.15525C8.69073 5.97878 8.36427 6.30525 8.36427 6.73216C8.36427 7.1716 8.69073 7.52319 9.15525 7.52319ZM9.15525 11.9051H18.6726C19.112 11.9051 19.451 11.5536 19.451 11.1141C19.451 10.6872 19.112 10.3608 18.6726 10.3608H9.15525C8.69073 10.3608 8.36427 10.6872 8.36427 11.1141C8.36427 11.5536 8.69073 11.9051 9.15525 11.9051ZM18.8232 27.2986C19.9533 27.2986 21.0205 26.9721 21.8994 26.382L24.7245 29.2196C25.0258 29.5084 25.3021 29.6214 25.6411 29.6214C26.2186 29.6214 26.6581 29.1694 26.6581 28.529C26.6581 28.2528 26.52 27.9766 26.3066 27.7631L23.4438 24.9004C24.0841 23.9838 24.4608 22.8664 24.4608 21.661C24.4608 18.5346 21.9371 16.0109 18.8232 16.0109C15.7094 16.0109 13.1606 18.5597 13.1606 21.661C13.1606 24.7749 15.7094 27.2986 18.8232 27.2986ZM18.8232 25.5031C16.6888 25.5031 14.9561 23.7829 14.9561 21.661C14.9561 19.5642 16.6888 17.8189 18.8232 17.8189C20.9201 17.8189 22.6527 19.5642 22.6527 21.661C22.6527 23.7829 20.9326 25.5031 18.8232 25.5031Z"
            fill="#154398"
          />
        </svg>
      )
      break
    case "status_order_6":
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.6203 26.8218L25.7128 31.3153C26.6194 31.8897 27.745 31.0354 27.476 29.9771L25.4268 21.9162C25.3691 21.6916 25.3759 21.4554 25.4465 21.2346C25.5171 21.0138 25.6486 20.8174 25.8258 20.668L32.1859 15.3744C33.0216 14.6788 32.5903 13.2919 31.5166 13.2222L23.2107 12.6832C22.987 12.6672 22.7724 12.588 22.592 12.4548C22.4115 12.3216 22.2727 12.1398 22.1915 11.9307L19.0938 4.12984C19.0096 3.90792 18.8598 3.71685 18.6645 3.58203C18.4691 3.44721 18.2374 3.375 18 3.375C17.7626 3.375 17.5309 3.44721 17.3355 3.58203C17.1402 3.71685 16.9904 3.90792 16.9062 4.12984L13.8085 11.9307C13.7273 12.1398 13.5885 12.3216 13.408 12.4548C13.2276 12.588 13.013 12.6672 12.7893 12.6832L4.48341 13.2222C3.40972 13.2919 2.97839 14.6788 3.81408 15.3744L10.1742 20.668C10.3514 20.8174 10.4829 21.0138 10.5535 21.2346C10.6241 21.4554 10.6309 21.6916 10.5732 21.9162L8.67282 29.3918C8.35 30.6617 9.70072 31.6869 10.7886 30.9976L17.3797 26.8218C17.5651 26.7038 17.7803 26.6411 18 26.6411C18.2197 26.6411 18.4349 26.7038 18.6203 26.8218V26.8218Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "status_order_7":
      iconElement = (
        <svg
          width="55"
          height="54"
          viewBox="0 0 55 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.5 18V27"
            stroke="#ED1117"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14 40V14.875C14 14.5766 14.1185 14.2905 14.3295 14.0795C14.5405 13.8685 14.8266 13.75 15.125 13.75H39.875C40.1734 13.75 40.4595 13.8685 40.6705 14.0795C40.8815 14.2905 41 14.5766 41 14.875V40L36 36L31.5 40L27 36L22.5 40L18 36L14 40Z"
            stroke="#ED1117"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="27.5" cy="30" r="1" fill="#ED1117" />
          <circle cx="27.5" cy="27" r="26" stroke="#ED1117" strokeWidth="2" />
        </svg>
      )
      break
    case "date-range":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8333 3.33464H15V2.5013C15 2.04297 14.625 1.66797 14.1667 1.66797C13.7083 1.66797 13.3333 2.04297 13.3333 2.5013V3.33464H6.66667V2.5013C6.66667 2.04297 6.29167 1.66797 5.83333 1.66797C5.375 1.66797 5 2.04297 5 2.5013V3.33464H4.16667C3.24167 3.33464 2.50833 4.08464 2.50833 5.0013L2.5 16.668C2.5 17.5846 3.24167 18.3346 4.16667 18.3346H15.8333C16.75 18.3346 17.5 17.5846 17.5 16.668V5.0013C17.5 4.08464 16.75 3.33464 15.8333 3.33464ZM15.8333 15.8346C15.8333 16.293 15.4583 16.668 15 16.668H5C4.54167 16.668 4.16667 16.293 4.16667 15.8346V7.5013H15.8333V15.8346ZM5.83333 9.16797H7.5V10.8346H5.83333V9.16797ZM9.16667 9.16797H10.8333V10.8346H9.16667V9.16797ZM12.5 9.16797H14.1667V10.8346H12.5V9.16797Z"
            fill="black"
            fillOpacity="0.54"
          />
        </svg>
      )
      break
    case "person":
      iconElement = (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.99998 5.4987C10.9166 5.4987 11.6666 6.2487 11.6666 7.16536C11.6666 8.08203 10.9166 8.83203 9.99998 8.83203C9.08331 8.83203 8.33331 8.08203 8.33331 7.16536C8.33331 6.2487 9.08331 5.4987 9.99998 5.4987ZM9.99998 13.832C12.25 13.832 14.8333 14.907 15 15.4987H4.99998C5.19165 14.8987 7.75831 13.832 9.99998 13.832ZM9.99998 3.83203C8.15831 3.83203 6.66665 5.3237 6.66665 7.16536C6.66665 9.00703 8.15831 10.4987 9.99998 10.4987C11.8416 10.4987 13.3333 9.00703 13.3333 7.16536C13.3333 5.3237 11.8416 3.83203 9.99998 3.83203ZM9.99998 12.1654C7.77498 12.1654 3.33331 13.282 3.33331 15.4987V17.1654H16.6666V15.4987C16.6666 13.282 12.225 12.1654 9.99998 12.1654Z"
            fill="black"
            fillOpacity="0.54"
          />
        </svg>
      )
      break
    case "delete-small":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8" cy="8" r="8" fill="white" />
          <path
            d="M7.99992 1.33301C4.31325 1.33301 1.33325 4.31301 1.33325 7.99967C1.33325 11.6863 4.31325 14.6663 7.99992 14.6663C11.6866 14.6663 14.6666 11.6863 14.6666 7.99967C14.6666 4.31301 11.6866 1.33301 7.99992 1.33301ZM10.8666 10.8663C10.6066 11.1263 10.1866 11.1263 9.92659 10.8663L7.99992 8.93967L6.07325 10.8663C5.81325 11.1263 5.39325 11.1263 5.13325 10.8663C4.87325 10.6063 4.87325 10.1863 5.13325 9.92634L7.05992 7.99967L5.13325 6.07301C4.87325 5.81301 4.87325 5.39301 5.13325 5.13301C5.39325 4.87301 5.81325 4.87301 6.07325 5.13301L7.99992 7.05967L9.92659 5.13301C10.1866 4.87301 10.6066 4.87301 10.8666 5.13301C11.1266 5.39301 11.1266 5.81301 10.8666 6.07301L8.93992 7.99967L10.8666 9.92634C11.1199 10.1797 11.1199 10.6063 10.8666 10.8663Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "person-register":
      iconElement = (
        <svg
          width="80"
          height="81"
          viewBox="0 0 80 81"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="40"
            cy="40.5"
            r="39"
            fill="url(#paint0_linear_1801_17715)"
            stroke="url(#paint1_linear_1801_17715)"
            strokeWidth="2"
          />
          <path
            d="M39.9997 40.5007C44.0513 40.5007 47.333 37.219 47.333 33.1673C47.333 29.1157 44.0513 25.834 39.9997 25.834C35.948 25.834 32.6663 29.1157 32.6663 33.1673C32.6663 37.219 35.948 40.5007 39.9997 40.5007ZM39.9997 44.1673C35.1047 44.1673 25.333 46.624 25.333 51.5007V53.334C25.333 54.3423 26.158 55.1673 27.1663 55.1673H52.833C53.8413 55.1673 54.6663 54.3423 54.6663 53.334V51.5007C54.6663 46.624 44.8947 44.1673 39.9997 44.1673Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1801_17715"
              x1="40"
              y1="78.5"
              x2="40"
              y2="2.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#82D99F" />
              <stop offset="1" stopColor="#31966D" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_1801_17715"
              x1="40"
              y1="78.5"
              x2="40"
              y2="2.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#31966D" />
              <stop offset="1" stopColor="#82D99F" />
            </linearGradient>
          </defs>
        </svg>
      )
      break
    case "enterprise-register":
      iconElement = (
        <svg
          width="80"
          height="81"
          viewBox="0 0 80 81"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="40"
            cy="40.5"
            r="39"
            fill="url(#paint0_linear_1801_4689)"
            stroke="url(#paint1_linear_1801_4689)"
            strokeWidth="2"
          />
          <path
            d="M40.0003 22.166C29.8803 22.166 21.667 30.3793 21.667 40.4993C21.667 50.6193 29.8803 58.8327 40.0003 58.8327C50.1203 58.8327 58.3337 50.6193 58.3337 40.4993C58.3337 30.3793 50.1203 22.166 40.0003 22.166ZM46.6187 33.7893C48.5803 33.7893 50.157 35.366 50.157 37.3277C50.157 39.2893 48.5803 40.866 46.6187 40.866C44.657 40.866 43.0803 39.2893 43.0803 37.3277C43.062 35.366 44.657 33.7893 46.6187 33.7893ZM35.6187 30.8927C38.002 30.8927 39.9453 32.836 39.9453 35.2193C39.9453 37.6027 38.002 39.546 35.6187 39.546C33.2353 39.546 31.292 37.6027 31.292 35.2193C31.292 32.8177 33.217 30.8927 35.6187 30.8927ZM35.6187 47.631V54.506C31.2187 53.131 27.7353 49.7393 26.1953 45.4127C28.1203 43.3593 32.9237 42.3143 35.6187 42.3143C36.5903 42.3143 37.8187 42.461 39.102 42.7177C36.0953 44.3127 35.6187 46.421 35.6187 47.631ZM40.0003 55.166C39.5053 55.166 39.0287 55.1477 38.552 55.0927V47.631C38.552 45.0277 43.942 43.726 46.6187 43.726C48.5803 43.726 51.972 44.441 53.6587 45.8343C51.5137 51.2793 46.2153 55.166 40.0003 55.166Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1801_4689"
              x1="40"
              y1="78.5"
              x2="40"
              y2="2.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#D1BC9A" />
              <stop offset="1" stopColor="#BD9C6D" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_1801_4689"
              x1="40"
              y1="78.5"
              x2="40"
              y2="2.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#BD9C6D" />
              <stop offset="1" stopColor="#D1BC9A" />
            </linearGradient>
          </defs>
        </svg>
      )
      break
    case "test-site-register":
      iconElement = (
        <svg
          width="80"
          height="81"
          viewBox="0 0 80 81"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="40"
            cy="40.5"
            r="39"
            fill="url(#paint0_linear_1801_17703)"
            stroke="url(#paint1_linear_1801_17703)"
            strokeWidth="2"
          />
          <path
            d="M39.9997 38.666C37.5613 38.666 32.6663 39.8944 32.6663 42.3327V42.626C34.4447 44.6793 37.0663 45.9993 39.9997 45.9993C42.933 45.9993 45.5547 44.6793 47.333 42.626V42.3327C47.333 39.8944 42.438 38.666 39.9997 38.666ZM39.9997 36.8327C42.0163 36.8327 43.6663 35.1827 43.6663 33.166C43.6663 31.1493 42.0163 29.4993 39.9997 29.4993C37.983 29.4993 36.333 31.1493 36.333 33.166C36.333 35.1827 37.983 36.8327 39.9997 36.8327ZM39.9997 22.166C47.6997 22.166 54.6663 28.0693 54.6663 37.1993C54.6663 43.0293 50.1747 49.886 41.2097 57.7877C40.513 58.3927 39.468 58.3927 38.7713 57.7877C29.8247 49.886 25.333 43.0293 25.333 37.1993C25.333 28.0693 32.2997 22.166 39.9997 22.166Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1801_17703"
              x1="40"
              y1="78.5"
              x2="40"
              y2="2.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#5CD9E1" />
              <stop offset="1" stopColor="#01AFEF" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_1801_17703"
              x1="40"
              y1="78.5"
              x2="40"
              y2="2.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#01AFEF" />
              <stop offset="1" stopColor="#5CD9E1" />
            </linearGradient>
          </defs>
        </svg>
      )
      break
    case "delete-outline":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.99999 15.8333C4.99999 16.75 5.74999 17.5 6.66666 17.5H13.3333C14.25 17.5 15 16.75 15 15.8333V7.5C15 6.58333 14.25 5.83333 13.3333 5.83333H6.66666C5.74999 5.83333 4.99999 6.58333 4.99999 7.5V15.8333ZM7.49999 7.5H12.5C12.9583 7.5 13.3333 7.875 13.3333 8.33333V15C13.3333 15.4583 12.9583 15.8333 12.5 15.8333H7.49999C7.04166 15.8333 6.66666 15.4583 6.66666 15V8.33333C6.66666 7.875 7.04166 7.5 7.49999 7.5ZM12.9167 3.33333L12.325 2.74167C12.175 2.59167 11.9583 2.5 11.7417 2.5H8.25832C8.04166 2.5 7.82499 2.59167 7.67499 2.74167L7.08332 3.33333H4.99999C4.54166 3.33333 4.16666 3.70833 4.16666 4.16667C4.16666 4.625 4.54166 5 4.99999 5H15C15.4583 5 15.8333 4.625 15.8333 4.16667C15.8333 3.70833 15.4583 3.33333 15 3.33333H12.9167Z"
            fill="#FF4648"
          />
        </svg>
      )
      break
    case "face-book":
      iconElement = (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="16"
            cy="16"
            r="14"
            fill="url(#paint0_linear_1615_165267)"
          />
          <path
            d="M21.2137 20.2816L21.8356 16.3301H17.9452V13.767C17.9452 12.6857 18.4877 11.6311 20.2302 11.6311H22V8.26699C22 8.26699 20.3945 8 18.8603 8C15.6548 8 13.5617 9.89294 13.5617 13.3184V16.3301H10V20.2816H13.5617V29.8345C14.2767 29.944 15.0082 30 15.7534 30C16.4986 30 17.2302 29.944 17.9452 29.8345V20.2816H21.2137Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1615_165267"
              x1="16"
              y1="2"
              x2="16"
              y2="29.917"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#18ACFE" />
              <stop offset="1" stopColor="#0163E0" />
            </linearGradient>
          </defs>
        </svg>
      )
      break
    case "reset-pass":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.4555 14.1025L16.458 14.1037L16.5258 13.9967C16.5599 13.9444 16.5934 13.8917 16.6262 13.8385L16.6979 13.7253C16.7268 13.6798 16.7745 13.6444 16.8328 13.6301C16.8914 13.6158 16.953 13.6246 17.0039 13.6535C17.0544 13.6822 17.0889 13.7274 17.1032 13.7772C17.117 13.825 17.1122 13.8762 17.0889 13.9214C16.0338 15.7067 14.3005 17.014 12.2636 17.5555C10.2233 18.0978 8.0473 17.8266 6.21128 16.8022L6.19596 16.7936L6.18007 16.7862C6.16638 16.7797 6.15321 16.7724 6.14066 16.7643L6.12968 16.7572L6.11834 16.7507C4.30214 15.708 2.98108 14.0073 2.43795 12.0195C1.8949 10.0321 2.17232 7.91454 3.21137 6.1251L3.22063 6.10915L3.22869 6.09257C3.23419 6.08124 3.24077 6.07028 3.24838 6.05985L3.26155 6.0418L3.27306 6.02264C4.34172 4.24421 6.08568 2.94912 8.12733 2.42299C10.1692 1.89681 12.34 2.18332 14.1663 3.21888L14.1678 3.21975C15.3734 3.89773 16.375 4.87352 17.0735 6.04853L17.684 7.07548L17.987 5.91985L18.1294 5.37667L18.1314 5.36906L18.1331 5.36138C18.1405 5.32897 18.1546 5.29779 18.1751 5.2698C18.1955 5.24179 18.222 5.21744 18.2534 5.19866C18.2847 5.17987 18.3201 5.16717 18.3574 5.16172L18.2851 4.66697L18.3574 5.16172C18.3947 5.15626 18.4328 5.15824 18.4692 5.16745C18.5056 5.17667 18.5391 5.19282 18.568 5.21449L18.8682 4.81466L18.568 5.21449C18.5968 5.23615 18.6203 5.26277 18.6374 5.29238C18.6546 5.32197 18.6652 5.35414 18.6691 5.38699C18.673 5.41982 18.6701 5.45315 18.6606 5.48514L18.6582 5.49312L18.6561 5.50118L18.1306 7.50073C18.1252 7.52108 18.1174 7.5409 18.107 7.55977L18.0946 7.58257L18.0846 7.60653C18.0622 7.65997 18.0208 7.70647 17.9651 7.73633C17.9093 7.76625 17.8436 7.77687 17.7797 7.76545C17.7796 7.76544 17.7796 7.76543 17.7795 7.76542L15.7139 7.39161C15.7137 7.39157 15.7135 7.39154 15.7134 7.39151C15.6772 7.38479 15.6432 7.37127 15.6132 7.35209L15.3438 7.77327L15.6132 7.35209C15.5831 7.33284 15.5579 7.30839 15.5384 7.28054C15.519 7.25273 15.5058 7.22196 15.4989 7.19008L15.01 7.29492L15.4989 7.19007C15.4921 7.1582 15.4917 7.12542 15.4978 7.09345C15.504 7.06146 15.5165 7.03047 15.5353 7.00232C15.554 6.97414 15.5787 6.94921 15.6083 6.92936C15.6379 6.9095 15.6717 6.89523 15.7079 6.88778C15.744 6.88033 15.7814 6.87992 15.8178 6.88661L15.8192 6.88687L16.1511 6.94691L17.2461 7.14506L16.6671 6.19473C15.9925 5.08767 15.0361 4.17321 13.8931 3.54049C12.7501 2.9078 11.4595 2.57835 10.1482 2.58392C8.83691 2.5895 7.5492 2.92992 6.41184 3.57232C5.27442 4.21476 4.32615 5.13736 3.66138 6.25015L3.65673 6.25793L3.65236 6.26588L3.63603 6.29561C2.63557 7.99658 2.36267 10.0184 2.87862 11.9175C3.39518 13.8189 4.65921 15.4386 6.38966 16.4236L6.39083 16.4243C8.1251 17.4053 10.1845 17.6704 12.117 17.1624C13.8979 16.6943 15.4394 15.6041 16.4555 14.1025ZM10.9984 10.0601L11.9378 10.9943H11.9184L12.7925 11.8513L13.6114 12.6542L13.7501 12.7902L13.6494 12.8898L13.4997 12.743L13.1497 12.3998L12.7996 12.743L12.3564 13.1776L12.2517 13.0749L12.6808 12.6542L13.045 12.2972L12.6808 11.9401L12.2536 11.5212L11.9033 11.1778L11.5532 11.5215L10.9904 12.0742L10.8859 11.9718L11.4361 11.4324L11.8002 11.0754L11.4361 10.7184L11.1513 10.4391L10.8665 10.1598L10.5171 9.81734L10.1671 10.1591C9.80913 10.5086 9.32245 10.7065 8.81312 10.7065C8.3067 10.7065 7.82269 10.5108 7.46529 10.1651L7.4321 10.1302L7.43212 10.1302L7.42853 10.1265C7.08594 9.77396 6.89917 9.30612 6.905 8.82327C6.91084 8.34041 7.10889 7.8769 7.46005 7.53227L7.4608 7.53153L8.28356 6.72065C8.28361 6.7206 8.28367 6.72054 8.28373 6.72049C8.64128 6.36898 9.12865 6.16938 9.63916 6.16865C10.1498 6.16792 10.6378 6.36619 10.9964 6.71679C11.3547 7.06706 11.5546 7.54042 11.5553 8.03215C11.5561 8.52388 11.3576 8.99778 11.0004 9.34906L10.6399 9.70358L10.9984 10.0601ZM10.7512 6.93024L10.7513 6.9302L10.7457 6.92484C10.4471 6.63616 10.0466 6.47598 9.63129 6.47598C9.21599 6.47598 8.8155 6.63616 8.51687 6.92484L8.51557 6.9261L7.68814 7.73178L7.68812 7.73176L7.68425 7.73561C7.39639 8.02209 7.23004 8.40802 7.2226 8.81422C7.21516 9.22044 7.36729 9.61219 7.64468 9.90884L7.65647 9.92145L7.66911 9.93321L7.69474 9.95709C7.99313 10.2431 8.39189 10.4017 8.80528 10.4017C9.22026 10.4017 9.62049 10.2419 9.91924 9.9538L9.91925 9.95381L9.92131 9.9518L10.7473 9.14611L10.7473 9.14613L10.7512 9.14227C11.0454 8.84892 11.2121 8.4519 11.2121 8.03625C11.2121 7.62061 11.0454 7.22359 10.7512 6.93024Z"
            fill="#0D99FF"
            stroke="#0D99FF"
          />
        </svg>
      )
      break
    case "cloud-upload":
      iconElement = (
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_631_26457)">
            <path
              d="M16.1344 8.46303L16.2085 8.8387L16.5905 8.86515C18.5001 8.99735 20 10.5675 20 12.4997C20 14.5235 18.3572 16.1663 16.3333 16.1663H5.5C3.01781 16.1663 1 14.1485 1 11.6663C1 9.34916 2.75498 7.43674 5.01119 7.19687L5.2779 7.16852L5.40179 6.93064C6.36089 5.08918 8.28562 3.83301 10.5 3.83301C13.2897 3.83301 15.613 5.81771 16.1344 8.46303ZM5.0822 7.86063L5.08188 7.86066C3.13251 8.06232 1.66667 9.70465 1.66667 11.6663C1.66667 13.7842 3.38219 15.4997 5.5 15.4997H16.3333C17.9845 15.4997 19.3333 14.1508 19.3333 12.4997C19.3333 10.9455 18.1134 9.63539 16.5506 9.53416C16.55 9.53412 16.5493 9.53407 16.5487 9.53403L15.6573 9.46993L15.4821 8.59402C15.4821 8.5938 15.482 8.59359 15.482 8.59338C15.0104 6.21857 12.9223 4.49967 10.5 4.49967C8.5954 4.49967 6.87563 5.55467 5.99857 7.243L5.70733 7.79636L5.0822 7.86063ZM9.79167 10.833V10.333H9.29167H8.37377L10.5 8.20678L12.6262 10.333H11.7083H11.2083V10.833V12.833H9.79167V10.833Z"
              fill="#0D99FF"
              stroke="#0D99FF"
            />
          </g>
          <defs>
            <clipPath id="clip0_631_26457">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "green-accept":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667ZM13.8253 6.31699L8.33366 11.8087L6.17533 9.65866L5.00033 10.8337L8.33366 14.167L15.0003 7.50033L13.8253 6.31699Z"
            fill="#00C590"
          />
        </svg>
      )
      break

    case "cloud-icon":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.6344 8.46303L15.7085 8.8387L16.0905 8.86515C18.0001 8.99735 19.5 10.5675 19.5 12.4997C19.5 14.5235 17.8572 16.1663 15.8333 16.1663H5C2.51781 16.1663 0.5 14.1485 0.5 11.6663C0.5 9.34916 2.25498 7.43674 4.51119 7.19687L4.7779 7.16852L4.90179 6.93064C5.86089 5.08918 7.78562 3.83301 10 3.83301C12.7897 3.83301 15.113 5.81771 15.6344 8.46303ZM4.5822 7.86063L4.58188 7.86066C2.63251 8.06232 1.16667 9.70465 1.16667 11.6663C1.16667 13.7842 2.88219 15.4997 5 15.4997H15.8333C17.4845 15.4997 18.8333 14.1508 18.8333 12.4997C18.8333 10.9455 17.6134 9.63539 16.0506 9.53416C16.05 9.53412 16.0493 9.53407 16.0487 9.53403L15.1573 9.46993L14.9821 8.59402C14.9821 8.5938 14.982 8.59359 14.982 8.59338C14.5104 6.21857 12.4223 4.49967 10 4.49967C8.0954 4.49967 6.37563 5.55467 5.49857 7.243L5.20733 7.79636L4.5822 7.86063ZM8.79167 11.333H9.29167V10.833V8.83301H10.7083V10.833V11.333H11.2083H12.1262L10 13.4592L7.87377 11.333H8.79167Z"
            fill="#0D99FF"
            stroke="#0D99FF"
          />
        </svg>
      )
      break

    case "yellow-print":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8337 6.66667H15.0003V2.5H5.00033V6.66667H4.16699C2.78366 6.66667 1.66699 7.78333 1.66699 9.16667V14.1667H5.00033V17.5H15.0003V14.1667H18.3337V9.16667C18.3337 7.78333 17.217 6.66667 15.8337 6.66667ZM6.66699 4.16667H13.3337V6.66667H6.66699V4.16667ZM13.3337 14.1667V15.8333H6.66699V12.5H13.3337V14.1667ZM15.0003 12.5V10.8333H5.00033V12.5H3.33366V9.16667C3.33366 8.70833 3.70866 8.33333 4.16699 8.33333H15.8337C16.292 8.33333 16.667 8.70833 16.667 9.16667V12.5H15.0003Z"
            fill="#FEC328"
          />
          <path
            d="M15.3337 9.58333C15.3337 9.76743 15.1844 9.91667 15.0003 9.91667C14.8162 9.91667 14.667 9.76743 14.667 9.58333C14.667 9.39924 14.8162 9.25 15.0003 9.25C15.1844 9.25 15.3337 9.39924 15.3337 9.58333Z"
            fill="#FEC328"
            stroke="#FEC328"
          />
        </svg>
      )
      break

    case "delete-box":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.00002 15.8333C5.00002 16.75 5.75002 17.5 6.66669 17.5H13.3334C14.25 17.5 15 16.75 15 15.8333V5.83333H5.00002V15.8333ZM6.66669 7.5H13.3334V15.8333H6.66669V7.5ZM12.9167 3.33333L12.0834 2.5H7.91669L7.08335 3.33333H4.16669V5H15.8334V3.33333H12.9167Z"
            fill="#666666"
          />
        </svg>
      )
      break
    case "edit-box":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
            fill="#666666"
          />
        </svg>
      )
      break
    case "add-box":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8333 2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 15.8333H4.16667V4.16667H15.8333V15.8333ZM9.16667 14.1667H10.8333V10.8333H14.1667V9.16667H10.8333V5.83333H9.16667V9.16667H5.83333V10.8333H9.16667V14.1667Z"
            fill="#666666"
          />
        </svg>
      )
      break
    case "recallIcon":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.33335 7.49957V6.17457C8.33335 5.4329 7.43335 5.0579 6.90835 5.5829L3.08335 9.4079C2.75835 9.7329 2.75835 10.2579 3.08335 10.5829L6.90835 14.4079C7.43335 14.9329 8.33335 14.5662 8.33335 13.8246V12.4162C12.5 12.4162 15.4167 13.7496 17.5 16.6662C16.6667 12.4996 14.1667 8.3329 8.33335 7.49957Z"
            fill="#F88C00"
          />
        </svg>
      )
      break
    case "code-request":
      iconElement = (
        <svg
          width="12"
          height="16"
          viewBox="0 0 12 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2316_56202)">
            <path
              d="M2 0C0.896875 0 0 0.896875 0 2V14C0 15.1031 0.896875 16 2 16H10C11.1031 16 12 15.1031 12 14V5H8C7.44688 5 7 4.55312 7 4V0H2ZM8 0V4H12L8 0ZM2.5 2H4.5C4.775 2 5 2.225 5 2.5C5 2.775 4.775 3 4.5 3H2.5C2.225 3 2 2.775 2 2.5C2 2.225 2.225 2 2.5 2ZM2.5 4H4.5C4.775 4 5 4.225 5 4.5C5 4.775 4.775 5 4.5 5H2.5C2.225 5 2 4.775 2 4.5C2 4.225 2.225 4 2.5 4ZM3 7H9C9.55313 7 10 7.44688 10 8V10C10 10.5531 9.55313 11 9 11H3C2.44688 11 2 10.5531 2 10V8C2 7.44688 2.44688 7 3 7ZM3 8V10H9V8H3ZM7.5 13H9.5C9.775 13 10 13.225 10 13.5C10 13.775 9.775 14 9.5 14H7.5C7.225 14 7 13.775 7 13.5C7 13.225 7.225 13 7.5 13Z"
              fill="#00C590"
            />
          </g>
          <defs>
            <clipPath id="clip0_2316_56202">
              <rect width="12" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "location":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.99992 10.0001C9.08325 10.0001 8.33325 9.25008 8.33325 8.33342C8.33325 7.41675 9.08325 6.66675 9.99992 6.66675C10.9166 6.66675 11.6666 7.41675 11.6666 8.33342C11.6666 9.25008 10.9166 10.0001 9.99992 10.0001ZM14.9999 8.50008C14.9999 5.47508 12.7916 3.33341 9.99992 3.33341C7.20825 3.33341 4.99992 5.47508 4.99992 8.50008C4.99992 10.4501 6.62492 13.0334 9.99992 16.1167C13.3749 13.0334 14.9999 10.4501 14.9999 8.50008ZM9.99992 1.66675C13.4999 1.66675 16.6666 4.35008 16.6666 8.50008C16.6666 11.2667 14.4416 14.5417 9.99992 18.3334C5.55825 14.5417 3.33325 11.2667 3.33325 8.50008C3.33325 4.35008 6.49992 1.66675 9.99992 1.66675Z"
            fill="black"
            fillOpacity="0.54"
          />
        </svg>
      )
      break
    case "ship":
      iconElement = (
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.6667 6.65333L11.4734 6.65333L8.55342 2.28C8.42675 2.09333 8.21342 2 8.00008 2C7.78675 2 7.57342 2.09333 7.44675 2.28667L4.52675 6.65333H1.33341C0.966748 6.65333 0.666748 6.95333 0.666748 7.32C0.666748 7.38 0.673415 7.44 0.693415 7.5L2.38675 13.68C2.54008 14.24 3.05341 14.6533 3.66675 14.6533L12.3334 14.6533C12.9467 14.6533 13.4601 14.24 13.6201 13.68L15.3134 7.5L15.3334 7.32C15.3334 6.95333 15.0334 6.65333 14.6667 6.65333ZM8.00008 3.85333L9.86675 6.65333H6.13341L8.00008 3.85333ZM12.3334 13.32L3.67342 13.3267L2.20675 7.98667L13.8001 7.98667L12.3334 13.32ZM8.00008 9.32C7.26675 9.32 6.66675 9.92 6.66675 10.6533C6.66675 11.3867 7.26675 11.9867 8.00008 11.9867C8.73342 11.9867 9.33342 11.3867 9.33342 10.6533C9.33342 9.92 8.73342 9.32 8.00008 9.32Z"
            fill="black"
          />
        </svg>
      )
      break
    case "hiring":
      iconElement = (
        <svg
          width="17"
          height="13"
          viewBox="0 0 17 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.5164 3.97126V3.3284C11.5164 3.26948 11.4682 3.22126 11.4093 3.22126H6.26639C6.20746 3.22126 6.15925 3.26948 6.15925 3.3284V3.97126C6.15925 4.03019 6.20746 4.0784 6.26639 4.0784H11.4093C11.4682 4.0784 11.5164 4.03019 11.5164 3.97126ZM6.26639 5.14983C6.20746 5.14983 6.15925 5.19805 6.15925 5.25698V5.89983C6.15925 5.95876 6.20746 6.00698 6.26639 6.00698H8.73068C8.78961 6.00698 8.83782 5.95876 8.83782 5.89983V5.25698C8.83782 5.19805 8.78961 5.14983 8.73068 5.14983H6.26639ZM11.3021 6.7034C9.70434 6.7034 8.40925 7.99849 8.40925 9.59626C8.40925 11.194 9.70434 12.4891 11.3021 12.4891C12.8999 12.4891 14.195 11.194 14.195 9.59626C14.195 7.99849 12.8999 6.7034 11.3021 6.7034ZM12.7418 11.036C12.3575 11.4204 11.8459 11.632 11.3021 11.632C10.7584 11.632 10.2467 11.4204 9.86237 11.036C9.478 10.6516 9.26639 10.14 9.26639 9.59626C9.26639 9.05251 9.478 8.5409 9.86237 8.15653C10.2467 7.77215 10.7584 7.56055 11.3021 7.56055C11.8459 7.56055 12.3575 7.77215 12.7418 8.15653C13.1262 8.5409 13.3378 9.05251 13.3378 9.59626C13.3378 10.14 13.1262 10.6516 12.7418 11.036ZM12.4941 8.5784H11.9008C11.8659 8.5784 11.8338 8.59448 11.8137 8.6226L10.9633 9.79849L10.6539 9.37126C10.644 9.35746 10.6309 9.34624 10.6158 9.33855C10.6006 9.33086 10.5838 9.32692 10.5668 9.32707H9.97621C9.88916 9.32707 9.83827 9.42617 9.88916 9.49715L10.8776 10.8646C10.9204 10.9235 11.0075 10.9235 11.0503 10.8646L12.5798 8.74849C12.632 8.67751 12.5811 8.5784 12.4941 8.5784ZM8.19496 11.2034H5.08782V1.77483H12.5878V6.38198C12.5878 6.4409 12.636 6.48912 12.695 6.48912H13.445C13.5039 6.48912 13.5521 6.4409 13.5521 6.38198V1.23912C13.5521 1.00206 13.3606 0.810547 13.1235 0.810547H4.55211C4.31505 0.810547 4.12354 1.00206 4.12354 1.23912V11.7391C4.12354 11.9762 4.31505 12.1677 4.55211 12.1677H8.19496C8.25389 12.1677 8.30211 12.1195 8.30211 12.0605V11.3105C8.30211 11.2516 8.25389 11.2034 8.19496 11.2034Z"
            fill="#212529"
          />
        </svg>
      )
      break
    case "register":
      iconElement = (
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.545 8.49935C12.0183 8.49935 13.2117 7.30602 13.2117 5.83268C13.2117 4.35935 12.0183 3.16602 10.545 3.16602C9.07167 3.16602 7.87834 4.35935 7.87834 5.83268C7.87834 7.30602 9.07167 8.49935 10.545 8.49935ZM10.545 4.49935C11.2783 4.49935 11.8783 5.09935 11.8783 5.83268C11.8783 6.56602 11.2783 7.16602 10.545 7.16602C9.81167 7.16602 9.21167 6.56602 9.21167 5.83268C9.21167 5.09935 9.81167 4.49935 10.545 4.49935ZM10.545 9.83268C8.765 9.83268 5.21167 10.726 5.21167 12.4993V13.8327H15.8783V12.4993C15.8783 10.726 12.325 9.83268 10.545 9.83268ZM6.545 12.4993C6.69167 12.0193 8.75167 11.166 10.545 11.166C12.345 11.166 14.4117 12.026 14.545 12.4993H6.545ZM4.545 10.4993V8.49935H6.545V7.16602H4.545V5.16602H3.21167V7.16602H1.21167V8.49935H3.21167V10.4993H4.545Z"
            fill="black"
          />
        </svg>
      )
      break
    case "next-ios":
      iconElement = (
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.5">
            <path
              d="M17.22 6.97664C18.3633 5.83331 20.2067 5.83331 21.35 6.97664L40.74 26.3666C41.65 27.2766 41.65 28.7466 40.74 29.6566L21.35 49.0466C20.2067 50.19 18.3633 50.19 17.22 49.0466C16.0767 47.9033 16.0767 46.06 17.22 44.9166L34.1133 28L17.1967 11.0833C16.0767 9.96331 16.0767 8.09664 17.22 6.97664Z"
              fill="white"
            />
          </g>
        </svg>
      )

      break
    case "back-ios":
      iconElement = (
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.5">
            <path
              d="M38.78 6.97664C37.6367 5.83331 35.7933 5.83331 34.65 6.97664L15.26 26.3666C14.35 27.2766 14.35 28.7466 15.26 29.6566L34.65 49.0466C35.7933 50.19 37.6367 50.19 38.78 49.0466C39.9233 47.9033 39.9233 46.06 38.78 44.9166L21.8867 28L38.8033 11.0833C39.9233 9.96331 39.9233 8.09664 38.78 6.97664Z"
              fill="white"
            />
          </g>
        </svg>
      )

      break
    case "playlist-add-check":
      iconElement = (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.75 7.5H2.25C1.8375 7.5 1.5 7.8375 1.5 8.25C1.5 8.6625 1.8375 9 2.25 9H9.75C10.1625 9 10.5 8.6625 10.5 8.25C10.5 7.8375 10.1625 7.5 9.75 7.5ZM9.75 4.5H2.25C1.8375 4.5 1.5 4.8375 1.5 5.25C1.5 5.6625 1.8375 6 2.25 6H9.75C10.1625 6 10.5 5.6625 10.5 5.25C10.5 4.8375 10.1625 4.5 9.75 4.5ZM2.25 12H6.75C7.1625 12 7.5 11.6625 7.5 11.25C7.5 10.8375 7.1625 10.5 6.75 10.5H2.25C1.8375 10.5 1.5 10.8375 1.5 11.25C1.5 11.6625 1.8375 12 2.25 12ZM16.6575 9.1575L16.725 9.225C17.0175 9.5175 17.0175 9.99 16.725 10.2825L12.54 14.475C12.2475 14.7675 11.775 14.7675 11.4825 14.475L9.165 12.1575C8.8725 11.865 8.8725 11.3925 9.165 11.1L9.2325 11.0325C9.525 10.74 9.9975 10.74 10.29 11.0325L12.015 12.7575L15.6 9.165C15.885 8.865 16.365 8.865 16.6575 9.1575Z"
            fill="#666666"
          />
        </svg>
      )

      break
    case "search-blue":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.5006 14.0006H14.7106L14.4306 13.7306C15.6306 12.3306 16.2506 10.4206 15.9106 8.39063C15.4406 5.61063 13.1206 3.39063 10.3206 3.05063C6.09063 2.53063 2.53063 6.09063 3.05063 10.3206C3.39063 13.1206 5.61063 15.4406 8.39063 15.9106C10.4206 16.2506 12.3306 15.6306 13.7306 14.4306L14.0006 14.7106V15.5006L18.2506 19.7506C18.6606 20.1606 19.3306 20.1606 19.7406 19.7506C20.1506 19.3406 20.1506 18.6706 19.7406 18.2606L15.5006 14.0006ZM9.50063 14.0006C7.01063 14.0006 5.00063 11.9906 5.00063 9.50063C5.00063 7.01063 7.01063 5.00063 9.50063 5.00063C11.9906 5.00063 14.0006 7.01063 14.0006 9.50063C14.0006 11.9906 11.9906 14.0006 9.50063 14.0006Z"
            fill="#154398"
          />
        </svg>
      )

      break
    case "star-green":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0003 17.5198L16.1503 20.0298C16.9103 20.4898 17.8403 19.8098 17.6403 18.9498L16.5403 14.2298L20.2103 11.0498C20.8803 10.4698 20.5203 9.36977 19.6403 9.29977L14.8103 8.88977L12.9203 4.42977C12.5803 3.61977 11.4203 3.61977 11.0803 4.42977L9.19032 8.87977L4.36032 9.28977C3.48032 9.35977 3.12032 10.4598 3.79032 11.0398L7.46032 14.2198L6.36032 18.9398C6.16032 19.7998 7.09032 20.4798 7.85032 20.0198L12.0003 17.5198Z"
            fill="#00C590"
          />
        </svg>
      )

      break
    case "user-green":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V19C4 19.55 4.45 20 5 20H19C19.55 20 20 19.55 20 19V18C20 15.34 14.67 14 12 14Z"
            fill="#00C590"
          />
        </svg>
      )

      break
    case "library-books":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 6C2.45 6 2 6.45 2 7V20C2 21.1 2.9 22 4 22H17C17.55 22 18 21.55 18 21C18 20.45 17.55 20 17 20H5C4.45 20 4 19.55 4 19V7C4 6.45 3.55 6 3 6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM18 11H10C9.45 11 9 10.55 9 10C9 9.45 9.45 9 10 9H18C18.55 9 19 9.45 19 10C19 10.55 18.55 11 18 11ZM14 15H10C9.45 15 9 14.55 9 14C9 13.45 9.45 13 10 13H14C14.55 13 15 13.45 15 14C15 14.55 14.55 15 14 15ZM18 7H10C9.45 7 9 6.55 9 6C9 5.45 9.45 5 10 5H18C18.55 5 19 5.45 19 6C19 6.55 18.55 7 18 7Z"
            fill="#00C590"
          />
        </svg>
      )

      break
    case "video-youtube":
      iconElement = (
        <svg
          width="20"
          height="15"
          viewBox="0 0 20 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="0.5" width="20" height="14" rx="3" fill="#777777" />
          <path
            d="M7.66797 4.03075V9.96617C7.66797 10.4188 8.17547 10.6938 8.5663 10.4474L13.3146 7.47971C13.6763 7.25627 13.6763 6.74065 13.3146 6.51148L8.5663 3.5495C8.17547 3.30315 7.66797 3.57815 7.66797 4.03075Z"
            fill="white"
          />
        </svg>
      )

      break
    case "up":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.11973 14.7105L11.9997 10.8305L15.8797 14.7105C16.2697 15.1005 16.8997 15.1005 17.2897 14.7105C17.6797 14.3205 17.6797 13.6905 17.2897 13.3005L12.6997 8.71047C12.3097 8.32047 11.6797 8.32047 11.2897 8.71047L6.69973 13.3005C6.30973 13.6905 6.30973 14.3205 6.69973 14.7105C7.08973 15.0905 7.72973 15.1005 8.11973 14.7105Z"
            fill="#ED1117"
          />
        </svg>
      )

      break
    case "infor":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM13 9H11V7H13V9Z"
            fill="#00C590"
          />
        </svg>
      )

      break
    case "shopping-cart-white":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.55 13C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C21.25 4.82 20.77 4 20.01 4H5.21L4.27 2H1V4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H19V15H7L8.1 13H15.55ZM6.16 6H18.31L15.55 11H8.53L6.16 6ZM7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z"
            fill="white"
          />
        </svg>
      )

      break
    case "check-green":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.00009 10.7809L3.68676 8.46753C3.42676 8.20753 3.00676 8.20753 2.74676 8.46753C2.48676 8.72753 2.48676 9.14753 2.74676 9.40753L5.53342 12.1942C5.79342 12.4542 6.21342 12.4542 6.47342 12.1942L13.5268 5.14086C13.7868 4.88086 13.7868 4.46086 13.5268 4.20086C13.2668 3.94086 12.8468 3.94086 12.5868 4.20086L6.00009 10.7809Z"
            fill="#00C590"
          />
        </svg>
      )

      break
    case "sms-message":
      iconElement = (
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.3333 3.32031L2.66659 3.32031C1.93325 3.32031 1.33992 3.92031 1.33992 4.65365L1.33325 12.6536C1.33325 13.387 1.93325 13.987 2.66659 13.987L13.3333 13.987C14.0666 13.987 14.6666 13.387 14.6666 12.6536L14.6666 4.65365C14.6666 3.92031 14.0666 3.32031 13.3333 3.32031ZM12.6666 12.6536L3.33325 12.6536C2.96659 12.6536 2.66659 12.3536 2.66659 11.987L2.66659 5.98698L7.29325 8.88031C7.72659 9.15365 8.27325 9.15365 8.70659 8.88031L13.3333 5.98698L13.3333 11.987C13.3333 12.3536 13.0333 12.6536 12.6666 12.6536ZM7.99992 7.98698L2.66659 4.65365L13.3333 4.65365L7.99992 7.98698Z"
            fill="black"
          />
        </svg>
      )

      break
    case "menu-book":
      iconElement = (
        <svg
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.125 3.49609C11.6625 3.49609 10.0875 3.79609 9 4.62109C7.9125 3.79609 6.3375 3.49609 4.875 3.49609C3.7875 3.49609 2.6325 3.66109 1.665 4.08859C1.1175 4.33609 0.75 4.86859 0.75 5.47609V13.9361C0.75 14.9111 1.665 15.6311 2.61 15.3911C3.345 15.2036 4.125 15.1211 4.875 15.1211C6.045 15.1211 7.29 15.3161 8.295 15.8111C8.745 16.0361 9.255 16.0361 9.6975 15.8111C10.7025 15.3086 11.9475 15.1211 13.1175 15.1211C13.8675 15.1211 14.6475 15.2036 15.3825 15.3911C16.3275 15.6386 17.2425 14.9186 17.2425 13.9361V5.47609C17.2425 4.86859 16.875 4.33609 16.3275 4.08859C15.3675 3.66109 14.2125 3.49609 13.125 3.49609ZM15.75 13.0436C15.75 13.5161 15.315 13.8611 14.85 13.7786C14.2875 13.6736 13.7025 13.6286 13.125 13.6286C11.85 13.6286 10.0125 14.1161 9 14.7536V6.12109C10.0125 5.48359 11.85 4.99609 13.125 4.99609C13.815 4.99609 14.4975 5.06359 15.15 5.20609C15.495 5.28109 15.75 5.58859 15.75 5.94109V13.0436Z"
            fill="#666666"
          />
          <path
            d="M10.4854 8.37897C10.2454 8.37897 10.0279 8.22897 9.9529 7.98897C9.8554 7.69647 10.0204 7.37397 10.3129 7.28397C11.4679 6.90897 12.9604 6.78897 14.3329 6.94647C14.6404 6.98397 14.8654 7.26147 14.8279 7.56897C14.7904 7.87647 14.5129 8.10147 14.2054 8.06397C12.9904 7.92147 11.6629 8.03397 10.6579 8.35647C10.5979 8.36397 10.5379 8.37897 10.4854 8.37897Z"
            fill="#666666"
          />
          <path
            d="M10.4854 10.3751C10.2454 10.3751 10.0279 10.2251 9.9529 9.98507C9.8554 9.69257 10.0204 9.37007 10.3129 9.28007C11.4604 8.90507 12.9604 8.78507 14.3329 8.94257C14.6404 8.98007 14.8654 9.25757 14.8279 9.56507C14.7904 9.87257 14.5129 10.0976 14.2054 10.0601C12.9904 9.91757 11.6629 10.0301 10.6579 10.3526C10.5979 10.3676 10.5379 10.3751 10.4854 10.3751Z"
            fill="#666666"
          />
          <path
            d="M10.4854 12.3673C10.2454 12.3673 10.0279 12.2173 9.9529 11.9773C9.8554 11.6848 10.0204 11.3623 10.3129 11.2723C11.4604 10.8973 12.9604 10.7773 14.3329 10.9348C14.6404 10.9723 14.8654 11.2498 14.8279 11.5573C14.7904 11.8648 14.5129 12.0823 14.2054 12.0523C12.9904 11.9098 11.6629 12.0223 10.6579 12.3448C10.5979 12.3598 10.5379 12.3673 10.4854 12.3673Z"
            fill="#666666"
          />
        </svg>
      )
      break
    case "supervisor-account":
      iconElement = (
        <svg
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.375 9.12109C13.41 9.12109 14.2425 8.28109 14.2425 7.24609C14.2425 6.21109 13.41 5.37109 12.375 5.37109C11.34 5.37109 10.5 6.21109 10.5 7.24609C10.5 8.28109 11.34 9.12109 12.375 9.12109ZM6.75 8.37109C7.995 8.37109 8.9925 7.36609 8.9925 6.12109C8.9925 4.87609 7.995 3.87109 6.75 3.87109C5.505 3.87109 4.5 4.87609 4.5 6.12109C4.5 7.36609 5.505 8.37109 6.75 8.37109ZM12.375 10.6211C11.0025 10.6211 8.25 11.3111 8.25 12.6836V13.6211C8.25 14.0336 8.5875 14.3711 9 14.3711H15.75C16.1625 14.3711 16.5 14.0336 16.5 13.6211V12.6836C16.5 11.3111 13.7475 10.6211 12.375 10.6211ZM6.75 9.87109C5.0025 9.87109 1.5 10.7486 1.5 12.4961V13.6211C1.5 14.0336 1.8375 14.3711 2.25 14.3711H6.75V12.6836C6.75 12.0461 6.9975 10.9286 8.5275 10.0811C7.875 9.94609 7.245 9.87109 6.75 9.87109Z"
            fill="#666666"
          />
        </svg>
      )
      break
    case "next-arrow-slide":
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="18" cy="18" r="17.5" fill="white" stroke="#DDDDDD" />
          <path
            d="M14.1501 25.507C14.5584 25.9154 15.2167 25.9154 15.6251 25.507L22.5501 18.582C22.8751 18.257 22.8751 17.732 22.5501 17.407L15.6251 10.482C15.2167 10.0737 14.5584 10.0737 14.1501 10.482C13.7417 10.8904 13.7417 11.5487 14.1501 11.957L20.1834 17.9987L14.1417 24.0404C13.7417 24.4404 13.7417 25.107 14.1501 25.507Z"
            fill="#666666"
          />
        </svg>
      )
      break

    case "prev-arrow-slide":
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="18" cy="18" r="17.5" fill="white" stroke="#DDDDDD" />
          <path
            d="M21.8498 10.4898C21.4415 10.0815 20.7831 10.0815 20.3748 10.4898L13.4498 17.4148C13.1248 17.7398 13.1248 18.2648 13.4498 18.5898L20.3748 25.5148C20.7831 25.9232 21.4415 25.9232 21.8498 25.5148C22.2581 25.1065 22.2581 24.4482 21.8498 24.0398L15.8165 17.9982L21.8581 11.9565C22.2581 11.5565 22.2581 10.8898 21.8498 10.4898Z"
            fill="#666666"
          />
        </svg>
      )
      break
    case "manual-step1":
      iconElement = (
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="25" cy="25" r="25" fill="url(#paint0_linear_204_12425)" />
          <path
            d="M25 34.3346L23.9967 33.3313C22.62 31.9546 22.6317 29.7146 24.02 28.3613L25 27.4046C24.545 27.358 24.2067 27.3346 23.8333 27.3346C20.7183 27.3346 14.5 28.898 14.5 32.0013V34.3346H25ZM23.8333 25.0013C26.4117 25.0013 28.5 22.913 28.5 20.3346C28.5 17.7563 26.4117 15.668 23.8333 15.668C21.255 15.668 19.1667 17.7563 19.1667 20.3346C19.1667 22.913 21.255 25.0013 23.8333 25.0013Z"
            fill="white"
          />
          <path
            d="M29.8768 34.0765C29.4218 34.5315 28.6752 34.5315 28.2202 34.0765L25.8052 31.6382C25.3618 31.1832 25.3618 30.4598 25.8052 30.0165L25.8168 30.0048C26.2718 29.5498 27.0068 29.5498 27.4502 30.0048L29.0485 31.6032L34.2168 26.3998C34.6718 25.9448 35.4068 25.9448 35.8618 26.3998L35.8735 26.4115C36.3168 26.8665 36.3168 27.5898 35.8735 28.0332L29.8768 34.0765Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_204_12425"
              x1="0"
              y1="50.0011"
              x2="50"
              y2="50.0011"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#154297" />
              <stop offset="1" stopColor="#ED1E24" />
            </linearGradient>
          </defs>
        </svg>
      )
      break
    case "manual-step2":
      iconElement = (
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="25" cy="25" r="25" fill="url(#paint0_linear_204_12431)" />
          <path
            d="M22.6667 22.69H28.5V35.5H22.6667V22.69ZM30.8333 35.5H34.3333C35.6167 35.5 36.6667 34.45 36.6667 33.1667V22.6667H30.8333V35.5ZM34.3333 14.5H16.8333C15.55 14.5 14.5 15.55 14.5 16.8333V20.3333H36.6667V16.8333C36.6667 15.55 35.6167 14.5 34.3333 14.5ZM14.5 33.1667C14.5 34.45 15.55 35.5 16.8333 35.5H20.3333V22.6667H14.5V33.1667Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_204_12431"
              x1="0"
              y1="50.0011"
              x2="50"
              y2="50.0011"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#154297" />
              <stop offset="1" stopColor="#ED1E24" />
            </linearGradient>
          </defs>
        </svg>
      )
      break
    case "manual-step3":
      iconElement = (
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="25" cy="25" r="25" fill="url(#paint0_linear_204_12437)" />
          <path
            d="M33.1667 14.5013H28.29C27.8 13.148 26.5167 12.168 25 12.168C23.4833 12.168 22.2 13.148 21.71 14.5013H16.8333C15.55 14.5013 14.5 15.5513 14.5 16.8346V33.168C14.5 34.4513 15.55 35.5013 16.8333 35.5013H33.1667C34.45 35.5013 35.5 34.4513 35.5 33.168V16.8346C35.5 15.5513 34.45 14.5013 33.1667 14.5013ZM25 14.5013C25.6417 14.5013 26.1667 15.0263 26.1667 15.668C26.1667 16.3096 25.6417 16.8346 25 16.8346C24.3583 16.8346 23.8333 16.3096 23.8333 15.668C23.8333 15.0263 24.3583 14.5013 25 14.5013ZM25 19.168C26.9367 19.168 28.5 20.7313 28.5 22.668C28.5 24.6046 26.9367 26.168 25 26.168C23.0633 26.168 21.5 24.6046 21.5 22.668C21.5 20.7313 23.0633 19.168 25 19.168ZM32 33.168H18V31.5346C18 29.2013 22.6667 27.918 25 27.918C27.3333 27.918 32 29.2013 32 31.5346V33.168Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_204_12437"
              x1="0"
              y1="50.0011"
              x2="50"
              y2="50.0011"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#154297" />
              <stop offset="1" stopColor="#ED1E24" />
            </linearGradient>
          </defs>
        </svg>
      )
      break
    case "manual-step4":
      iconElement = (
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="25" cy="25" r="25" fill="url(#paint0_linear_204_12443)" />
          <path
            d="M24.9997 13.332C18.5597 13.332 13.333 18.5587 13.333 24.9987C13.333 31.4387 18.5597 36.6654 24.9997 36.6654C31.4397 36.6654 36.6663 31.4387 36.6663 24.9987C36.6663 18.5587 31.4397 13.332 24.9997 13.332ZM29.2113 20.7287C30.4597 20.7287 31.463 21.732 31.463 22.9804C31.463 24.2287 30.4597 25.232 29.2113 25.232C27.963 25.232 26.9597 24.2287 26.9597 22.9804C26.948 21.732 27.963 20.7287 29.2113 20.7287ZM22.2113 18.8854C23.728 18.8854 24.9647 20.122 24.9647 21.6387C24.9647 23.1554 23.728 24.392 22.2113 24.392C20.6947 24.392 19.458 23.1554 19.458 21.6387C19.458 20.1104 20.683 18.8854 22.2113 18.8854ZM22.2113 29.537V33.912C19.4113 33.037 17.1947 30.8787 16.2147 28.1254C17.4397 26.8187 20.4963 26.1537 22.2113 26.1537C22.8297 26.1537 23.6113 26.247 24.428 26.4104C22.5147 27.4254 22.2113 28.767 22.2113 29.537ZM24.9997 34.332C24.6847 34.332 24.3813 34.3204 24.078 34.2854V29.537C24.078 27.8804 27.508 27.052 29.2113 27.052C30.4597 27.052 32.618 27.507 33.6913 28.3937C32.3263 31.8587 28.9547 34.332 24.9997 34.332Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_204_12443"
              x1="0"
              y1="50.0011"
              x2="50"
              y2="50.0011"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#154297" />
              <stop offset="1" stopColor="#ED1E24" />
            </linearGradient>
          </defs>
        </svg>
      )
      break
    case "file-excel-icon":
      iconElement = (
        <svg
          width="26"
          height="34"
          viewBox="0 0 26 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_363_14496)">
            <path
              d="M4.25 0C1.90586 0 0 1.90586 0 4.25V29.75C0 32.0941 1.90586 34 4.25 34H21.25C23.5941 34 25.5 32.0941 25.5 29.75V10.625H17C15.8246 10.625 14.875 9.67539 14.875 8.5V0H4.25ZM17 0V8.5H25.5L17 0ZM10.3395 16.6148L12.75 20.0613L15.1605 16.6148C15.6652 15.891 16.6613 15.7184 17.3785 16.223C18.0957 16.7277 18.275 17.7238 17.7703 18.441L14.6957 22.8438L17.777 27.2398C18.2816 27.9637 18.109 28.9531 17.3852 29.4578C16.6613 29.9625 15.6719 29.7898 15.1672 29.066L12.75 25.6195L10.3395 29.066C9.83477 29.7898 8.83867 29.9625 8.12148 29.4578C7.4043 28.9531 7.225 27.957 7.72969 27.2398L10.8043 22.8438L7.72305 18.4477C7.21836 17.7238 7.39102 16.7344 8.11484 16.2297C8.83867 15.725 9.82812 15.8977 10.3328 16.6215L10.3395 16.6148Z"
              fill="#00C590"
            />
          </g>
          <defs>
            <clipPath id="clip0_363_14496">
              <rect width="25.5" height="34" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "seminar-time":
      iconElement = (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="15" cy="15" r="15" fill="#F88C00" />
          <path
            d="M14.9917 6.66675C10.3917 6.66675 6.66675 10.4001 6.66675 15.0001C6.66675 19.6001 10.3917 23.3334 14.9917 23.3334C19.6001 23.3334 23.3334 19.6001 23.3334 15.0001C23.3334 10.4001 19.6001 6.66675 14.9917 6.66675ZM15.0001 21.6667C11.3167 21.6667 8.33341 18.6834 8.33341 15.0001C8.33341 11.3167 11.3167 8.33341 15.0001 8.33341C18.6834 8.33341 21.6667 11.3167 21.6667 15.0001C21.6667 18.6834 18.6834 21.6667 15.0001 21.6667ZM14.8167 10.8334H14.7667C14.4334 10.8334 14.1667 11.1001 14.1667 11.4334V15.3667C14.1667 15.6584 14.3167 15.9334 14.5751 16.0834L18.0334 18.1584C18.3167 18.3251 18.6834 18.2417 18.8501 17.9584C19.0251 17.6751 18.9334 17.3001 18.6417 17.1334L15.4167 15.2167V11.4334C15.4167 11.1001 15.1501 10.8334 14.8167 10.8334Z"
            fill="white"
          />
        </svg>
      )
      break
    case "send-mess-primary":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.7792 20.8284L21.8291 3.2002C22.1543 2.37995 21.3482 1.57385 20.528 1.89912L2.89982 8.94898C2.22807 9.21061 2.05837 10.0733 2.56041 10.5753L5.8131 13.8422C6.16666 14.1957 6.73234 14.2381 7.12832 13.927L18.4562 5.27202L9.79411 16.5928C9.49006 16.9959 9.53248 17.5615 9.88604 17.9151L13.1529 21.1678C13.6549 21.6698 14.5176 21.5001 14.7792 20.8284Z"
            fill="#154398"
          />
        </svg>
      )
      break
    case "refresh-icon":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.709 5.29182C13.3507 3.93349 11.4257 3.15016 9.30904 3.36682C6.25071 3.67516 3.73404 6.15849 3.39238 9.21682C2.93404 13.2585 6.05904 16.6668 10.0007 16.6668C12.659 16.6668 14.9424 15.1085 16.009 12.8668C16.2757 12.3085 15.8757 11.6668 15.259 11.6668C14.9507 11.6668 14.659 11.8335 14.5257 12.1085C13.584 14.1335 11.3257 15.4168 8.85904 14.8668C7.00904 14.4585 5.51738 12.9502 5.12571 11.1002C4.42571 7.86682 6.88404 5.00016 10.0007 5.00016C11.384 5.00016 12.6174 5.57516 13.5174 6.48349L12.259 7.74182C11.734 8.26682 12.1007 9.16682 12.8424 9.16682H15.834C16.2924 9.16682 16.6674 8.79182 16.6674 8.33349V5.34182C16.6674 4.60016 15.7674 4.22516 15.2424 4.75016L14.709 5.29182Z"
            fill="#212529"
          />
        </svg>
      )
      break
    case "face-sad":
      iconElement = (
        <svg
          width="69"
          height="117"
          viewBox="0 0 69 117"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28.2563 61.051C28.4875 60.733 28.95 60.733 29.1812 61.051C30.1352 62.3012 32.1225 65.2207 32.1225 66.666C32.1225 68.5449 30.6338 70.0625 28.6537 70.0625C26.8037 70.0625 25.185 68.5449 25.185 66.666C25.185 65.2207 27.3168 62.3012 28.2563 61.051ZM42.5938 65.0617C43.3092 65.6977 43.367 66.7961 42.7311 67.5115C42.0879 68.227 40.9967 68.2848 40.2162 67.6488C38.742 66.2686 36.7186 65.4375 34.5 65.4375C33.5389 65.4375 32.7656 64.6643 32.7656 63.7031C32.7656 62.742 33.5389 61.9688 34.5 61.9688C37.6074 61.9688 40.4475 63.1395 42.5938 65.0617ZM40.2523 52.7188C41.5314 52.7188 42.5648 53.7521 42.5648 55.0312C42.5648 56.3104 41.5314 57.3438 40.2523 57.3438C38.9154 57.3438 37.9398 56.3104 37.9398 55.0312C37.9398 53.7521 38.9154 52.7188 40.2523 52.7188ZM28.6898 57.3438C27.3529 57.3438 26.3773 56.3104 26.3773 55.0312C26.3773 53.7521 27.3529 52.7188 28.6898 52.7188C29.9689 52.7188 31.0023 53.7521 31.0023 55.0312C31.0023 56.3104 29.9689 57.3438 28.6898 57.3438ZM34.5 40C44.7184 40 53 48.2816 53 58.5C53 68.7184 44.7184 77 34.5 77C24.2816 77 16 68.7184 16 58.5C16 48.2816 24.2816 40 34.5 40ZM28.7115 72.375C30.4893 73.1193 32.4477 73.5312 34.5 73.5312C42.8033 73.5312 49.5312 66.8033 49.5312 58.5C49.5312 50.1967 42.8033 43.4688 34.5 43.4688C26.1967 43.4688 19.4688 50.1967 19.4688 58.5C19.4688 62.3084 20.8844 65.7844 23.2179 68.4293C23.9781 70.7418 26.1822 72.3678 28.7115 72.375Z"
            fill="#B2B2B2"
          />
        </svg>
      )
      break
    case "face-frown":
      iconElement = (
        <svg
          width="69"
          height="117"
          viewBox="0 0 69 117"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.399 68.8051C25.4957 68.4799 25.026 67.4826 25.3512 66.5865C26.6158 63.0816 30.3736 60.8125 34.5 60.8125C38.6264 60.8125 42.3842 63.0816 43.6488 66.5865C43.974 67.4826 43.5043 68.4799 42.601 68.8051C41.7049 69.1303 40.7076 68.6605 40.3824 67.7572C39.7176 65.9072 37.4773 64.2812 34.5 64.2812C31.5227 64.2812 29.2824 65.9072 28.6176 67.7572C28.2924 68.6605 27.2951 69.1303 26.399 68.8051ZM31.0602 55.0312C31.0602 56.3104 30.0195 57.3438 28.7477 57.3438C27.4686 57.3438 26.4352 56.3104 26.4352 55.0312C26.4352 53.7521 27.4686 52.7188 28.7477 52.7188C30.0195 52.7188 31.0602 53.7521 31.0602 55.0312ZM37.9977 55.0312C37.9977 53.7521 39.0311 52.7188 40.3102 52.7188C41.582 52.7188 42.6227 53.7521 42.6227 55.0312C42.6227 56.3104 41.582 57.3438 40.3102 57.3438C39.0311 57.3438 37.9977 56.3104 37.9977 55.0312ZM53 58.5C53 68.7184 44.7184 77 34.5 77C24.2816 77 16 68.7184 16 58.5C16 48.2816 24.2816 40 34.5 40C44.7184 40 53 48.2816 53 58.5ZM34.5 43.4688C26.1967 43.4688 19.4688 50.1967 19.4688 58.5C19.4688 66.8033 26.1967 73.5312 34.5 73.5312C42.8033 73.5312 49.5312 66.8033 49.5312 58.5C49.5312 50.1967 42.8033 43.4688 34.5 43.4688Z"
            fill="#B2B2B2"
          />
        </svg>
      )
      break
    case "face-meh":
      iconElement = (
        <svg
          width="69"
          height="117"
          viewBox="0 0 69 117"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.4352 55.0312C26.4352 53.7521 27.4686 52.7188 28.7477 52.7188C30.0195 52.7188 31.0602 53.7521 31.0602 55.0312C31.0602 56.3104 30.0195 57.3438 28.7477 57.3438C27.4686 57.3438 26.4352 56.3104 26.4352 55.0312ZM42.6227 55.0312C42.6227 56.3104 41.582 57.3438 40.3102 57.3438C39.0311 57.3438 37.9977 56.3104 37.9977 55.0312C37.9977 53.7521 39.0311 52.7188 40.3102 52.7188C41.582 52.7188 42.6227 53.7521 42.6227 55.0312ZM39.7031 63.7031C40.6643 63.7031 41.4375 64.4764 41.4375 65.4375C41.4375 66.3986 40.6643 67.1719 39.7031 67.1719H29.2969C28.3357 67.1719 27.5625 66.3986 27.5625 65.4375C27.5625 64.4764 28.3357 63.7031 29.2969 63.7031H39.7031ZM53 58.5C53 68.7184 44.7184 77 34.5 77C24.2816 77 16 68.7184 16 58.5C16 48.2816 24.2816 40 34.5 40C44.7184 40 53 48.2816 53 58.5ZM34.5 73.5312C42.8033 73.5312 49.5312 66.8033 49.5312 58.5C49.5312 50.1967 42.8033 43.4688 34.5 43.4688C26.1967 43.4688 19.4688 50.1967 19.4688 58.5C19.4688 66.8033 26.1967 73.5312 34.5 73.5312Z"
            fill="#B2B2B2"
          />
        </svg>
      )
      break
    case "face-smile":
      iconElement = (
        <svg
          width="69"
          height="117"
          viewBox="0 0 69 117"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M34.5 65.4375C37.1883 65.4375 39.0672 64.1729 40.1656 62.9877C40.8088 62.2867 41.9072 62.2361 42.6154 62.8865C43.3164 63.5369 43.3598 64.6354 42.7094 65.3363C41.1268 67.0635 38.3807 68.9062 34.5 68.9062C30.6193 68.9062 27.8732 67.0635 26.2906 65.3363C25.6402 64.6354 25.6186 63.5369 26.3846 62.8865C27.0928 62.2361 28.1912 62.2867 28.8344 62.9877C29.9328 64.1729 31.8117 65.4375 34.5 65.4375ZM31.0602 55.0312C31.0602 56.3104 30.0195 57.3438 28.7477 57.3438C27.4686 57.3438 26.4352 56.3104 26.4352 55.0312C26.4352 53.7521 27.4686 52.7188 28.7477 52.7188C30.0195 52.7188 31.0602 53.7521 31.0602 55.0312ZM37.9977 55.0312C37.9977 53.7521 39.0311 52.7188 40.3102 52.7188C41.582 52.7188 42.6227 53.7521 42.6227 55.0312C42.6227 56.3104 41.582 57.3438 40.3102 57.3438C39.0311 57.3438 37.9977 56.3104 37.9977 55.0312ZM53 58.5C53 68.7184 44.7184 77 34.5 77C24.2816 77 16 68.7184 16 58.5C16 48.2816 24.2816 40 34.5 40C44.7184 40 53 48.2816 53 58.5ZM34.5 43.4688C26.1967 43.4688 19.4688 50.1967 19.4688 58.5C19.4688 66.8033 26.1967 73.5312 34.5 73.5312C42.8033 73.5312 49.5312 66.8033 49.5312 58.5C49.5312 50.1967 42.8033 43.4688 34.5 43.4688Z"
            fill="#B2B2B2"
          />
        </svg>
      )
      break
    case "face-grin-hearts":
      iconElement = (
        <svg
          width="69"
          height="117"
          viewBox="0 0 69 117"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M41.2568 62.2867C42.6082 61.9037 43.8512 63.1539 43.0346 64.3174C41.3219 67.0707 38.135 68.8412 34.4928 68.8412C30.8578 68.8412 27.6709 67.0707 25.8932 64.3174C25.1416 63.1539 26.3846 61.9037 27.7287 62.2867C29.8244 62.7709 32.1008 63.0383 34.4928 63.0383C36.8848 63.0383 39.1684 62.7709 41.2568 62.2867ZM33.2643 52.7982L31.9996 57.5605C31.8334 58.182 31.2047 58.5434 30.5832 58.3771L25.8787 57.1197C24.5924 56.7729 23.8336 55.4504 24.1732 54.1713C24.5201 52.885 25.8426 52.1189 27.0639 52.4658L28.2924 52.7766L28.6031 51.6131C28.95 50.3268 30.2725 49.568 31.5588 49.9076C32.8451 50.2545 33.6039 51.577 33.2643 52.7982ZM40.7076 52.7766L41.8711 52.4658C43.1574 52.1189 44.4799 52.885 44.8268 54.1713C45.1664 55.4504 44.4076 56.7729 43.1213 57.1197L38.4168 58.3771C37.7953 58.5434 37.1666 58.182 37.0004 57.5605L35.7357 52.7982C35.3961 51.577 36.1549 50.2545 37.4412 49.9076C38.7275 49.568 40.05 50.3268 40.3969 51.6131L40.7076 52.7766ZM53 58.5C53 68.7184 44.7184 77 34.5 77C24.2816 77 16 68.7184 16 58.5C16 48.2816 24.2816 40 34.5 40C44.7184 40 53 48.2816 53 58.5ZM34.5 43.4688C26.1967 43.4688 19.4688 50.1967 19.4688 58.5C19.4688 66.8033 26.1967 73.5312 34.5 73.5312C42.8033 73.5312 49.5312 66.8033 49.5312 58.5C49.5312 50.1967 42.8033 43.4688 34.5 43.4688Z"
            fill="#B2B2B2"
          />
        </svg>
      )
      break
    case "order-step1":
      iconElement = (
        <svg
          width="54"
          height="54"
          viewBox="0 0 54 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 21H35"
            stroke="#154398"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19 25L35 25"
            stroke="#154398"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19 29L35 29"
            stroke="#154398"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.5 40V14.875C13.5 14.5766 13.6185 14.2905 13.8295 14.0795C14.0405 13.8685 14.3266 13.75 14.625 13.75H39.375C39.6734 13.75 39.9595 13.8685 40.1705 14.0795C40.3815 14.2905 40.5 14.5766 40.5 14.875V40L35.5 36L31 40L26.5 36L22 40L17.5 36L13.5 40Z"
            stroke="#154398"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="27" cy="27" r="26" stroke="#154398" strokeWidth="2" />
        </svg>
      )
      break
    case "order-step2":
      iconElement = (
        <svg
          width="54"
          height="54"
          viewBox="0 0 54 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="27"
            cy="27"
            r="26"
            fill="white"
            stroke="#154398"
            strokeWidth="2"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M31.871 10C32.0599 10 32.2362 10.0541 32.3851 10.1478C32.4462 10.1862 32.5032 10.2314 32.5551 10.2833L39.522 17.2502C39.7033 17.4315 39.8051 17.6773 39.8051 17.9337V24.9877C39.8051 25.5216 39.3723 25.9543 38.8384 25.9543C38.3045 25.9543 37.8718 25.5216 37.8718 24.9877V18.9002H31.871C31.3372 18.9002 30.9044 18.4674 30.9044 17.9335V11.9335H14.9333V41.9782H26.8554C27.3892 41.9782 27.8221 42.4109 27.8221 42.9448C27.8221 43.4787 27.3892 43.9114 26.8554 43.9114H13.9666C13.4328 43.9114 13 43.4787 13 42.9448V10.9669C13 10.433 13.4328 10.0001 13.9666 10.0001H31.8528L31.871 10ZM32.8377 16.9669V13.3L36.5045 16.9669H32.8377ZM20.7941 20.9378C20.2603 20.9378 19.8275 21.3706 19.8275 21.9045C19.8275 22.4384 20.2603 22.8711 20.7941 22.8711H31.3141C31.848 22.8711 32.2808 22.4384 32.2808 21.9045C32.2808 21.3706 31.848 20.9378 31.3141 20.9378H20.7941ZM16.7182 26.3633C16.7182 25.8294 17.151 25.3966 17.6849 25.3966H27.8218C28.3557 25.3966 28.7885 25.8294 28.7885 26.3633C28.7885 26.8972 28.3557 27.3299 27.8218 27.3299H17.6849C17.151 27.3299 16.7182 26.8972 16.7182 26.3633ZM18.007 29.8555C17.4731 29.8555 17.0404 30.2882 17.0404 30.8221C17.0404 31.356 17.4731 31.7887 18.007 31.7887H24.0857C24.6195 31.7887 25.0523 31.356 25.0523 30.8221C25.0523 30.2882 24.6195 29.8555 24.0857 29.8555H18.007ZM17.0404 35.2809C17.0404 34.747 17.4731 34.3143 18.007 34.3143H23.18C23.7138 34.3143 24.1466 34.747 24.1466 35.2809C24.1466 35.8148 23.7138 36.2475 23.18 36.2475H18.007C17.4731 36.2475 17.0404 35.8148 17.0404 35.2809ZM27.2644 35.0023C27.2644 31.1113 30.4186 27.957 34.3097 27.957C38.2006 27.957 41.3549 31.1113 41.3549 35.0023C41.3549 38.8933 38.2006 42.0475 34.3097 42.0475C30.4186 42.0475 27.2644 38.8933 27.2644 35.0023ZM34.3097 26.0238C29.3509 26.0238 25.331 30.0435 25.331 35.0023C25.331 39.961 29.3509 43.9809 34.3097 43.9809C39.2684 43.9809 43.2882 39.961 43.2882 35.0023C43.2882 30.0435 39.2684 26.0238 34.3097 26.0238Z"
            fill="#154398"
          />
          <path
            d="M34.2662 34.4158C36.0424 34.4158 37.4883 35.7011 37.4883 37.28C37.4883 38.61 36.4572 39.7217 35.0717 40.0421V40.7707C35.0717 41.2156 34.711 41.5762 34.2662 41.5762C33.8212 41.5762 33.4606 41.2156 33.4606 40.7707V40.0421C32.3616 39.7879 31.4857 39.036 31.1703 38.0722C31.032 37.6494 31.4046 37.28 31.8495 37.28C32.2944 37.28 32.6424 37.6706 32.8977 38.0349C33.1824 38.4411 33.6894 38.712 34.2662 38.712C35.1543 38.712 35.8772 38.0694 35.8772 37.28C35.8772 36.4905 35.1543 35.8479 34.2662 35.8479C32.49 35.8479 31.0439 34.5626 31.0439 32.9837C31.0439 31.6537 32.0751 30.542 33.4606 30.2216V29.493C33.4606 29.0482 33.8212 28.6875 34.2662 28.6875C34.711 28.6875 35.0717 29.0482 35.0717 29.493V30.2216C36.1706 30.4758 37.0466 31.2277 37.3619 32.1915C37.5003 32.6143 37.1277 32.9837 36.6828 32.9837C36.2379 32.9837 35.8899 32.5931 35.6346 32.2288C35.3499 31.8226 34.8428 31.5517 34.2662 31.5517C33.378 31.5517 32.6551 32.1943 32.6551 32.9837C32.6551 33.7732 33.378 34.4158 34.2662 34.4158Z"
            fill="#154398"
          />
        </svg>
      )
      break
    case "order-step3":
      iconElement = (
        <svg
          width="54"
          height="54"
          viewBox="0 0 54 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="27"
            cy="27"
            r="26"
            fill="white"
            stroke="#154398"
            strokeWidth="2"
          />
          <path
            d="M43.0563 37.3135H41.9677V35.7329H43.0563C43.1247 35.7329 43.18 35.6772 43.18 35.6092V29.8996C43.18 29.8696 43.169 29.8407 43.1488 29.8178L37.455 23.4131C37.4317 23.3871 37.3977 23.3716 37.3625 23.3716H32.3658V35.7329H36.8291V37.3135H30.7852V21.791H37.3625C37.8486 21.791 38.3133 21.9993 38.6365 22.3628L44.3299 28.7675C44.6073 29.0793 44.7606 29.4815 44.7606 29.8996V35.6088C44.7606 36.5489 43.996 37.3135 43.0563 37.3135Z"
            fill="#154398"
          />
          <path
            d="M32.3665 37.3134H20.6643V35.7328H30.7858V19.953C30.7858 19.007 30.2057 18.2076 29.5194 18.2076H12.0448C11.358 18.208 10.7779 19.007 10.7779 19.953V35.3009C10.7779 35.5794 10.9292 35.7328 10.9794 35.7328H15.5296V37.3134H10.9794C9.99667 37.3134 9.19727 36.4108 9.19727 35.3009V19.953C9.19727 18.1191 10.4744 16.627 12.0448 16.627H29.5194C31.0893 16.627 32.3665 18.1187 32.3665 19.953V37.3134Z"
            fill="#154398"
          />
          <path
            d="M39.3987 39.7528C37.5462 39.7528 36.0391 38.2457 36.0391 36.3928C36.0391 34.5399 37.5458 33.0332 39.3987 33.0332C41.2516 33.0332 42.7583 34.5399 42.7583 36.3928C42.7583 38.2457 41.2512 39.7528 39.3987 39.7528ZM39.3987 34.6138C38.4179 34.6138 37.6197 35.412 37.6197 36.3928C37.6197 37.374 38.4179 38.1722 39.3987 38.1722C40.3795 38.1722 41.1777 37.374 41.1777 36.3928C41.1777 35.4116 40.3795 34.6138 39.3987 34.6138Z"
            fill="#154398"
          />
          <path
            d="M18.0959 39.7528C16.2435 39.7528 14.7363 38.2457 14.7363 36.3928C14.7363 34.5399 16.2435 33.0332 18.0959 33.0332C19.9484 33.0332 21.4556 34.5399 21.4556 36.3928C21.4556 38.2457 19.9484 39.7528 18.0959 39.7528ZM18.0959 34.6138C17.1152 34.6138 16.317 35.412 16.317 36.3928C16.317 37.374 17.1152 38.1722 18.0959 38.1722C19.0767 38.1722 19.8749 37.374 19.8749 36.3928C19.8749 35.4116 19.0767 34.6138 18.0959 34.6138Z"
            fill="#154398"
          />
          <path
            d="M43.9719 30.3433H35.936C35.0493 30.3433 34.3281 29.6221 34.3281 28.7354V22.582H35.9088V28.7358L43.9719 28.7627V30.3433Z"
            fill="#154398"
          />
        </svg>
      )
      break
    case "order-step4":
      iconElement = (
        <svg
          width="54"
          height="54"
          viewBox="0 0 54 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="27"
            cy="27"
            r="26"
            fill="white"
            stroke="#154398"
            strokeWidth="2"
          />
          <path
            d="M13 26L23 35.5L40 18"
            stroke="#154398"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "order-step5":
      iconElement = (
        <svg
          width="54"
          height="54"
          viewBox="0 0 54 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="27"
            cy="27"
            r="26"
            fill="url(#paint0_linear_1319_42017)"
            stroke="url(#paint1_linear_1319_42017)"
            strokeWidth="2"
          />
          <path
            d="M27.6203 35.8218L34.7128 40.3153C35.6194 40.8897 36.745 40.0354 36.476 38.9771L34.4268 30.9162C34.3691 30.6916 34.3759 30.4554 34.4465 30.2346C34.5171 30.0138 34.6486 29.8174 34.8258 29.668L41.1859 24.3744C42.0216 23.6788 41.5903 22.2919 40.5166 22.2222L32.2107 21.6832C31.987 21.6672 31.7724 21.588 31.592 21.4548C31.4116 21.3216 31.2727 21.1398 31.1915 20.9307L28.0938 13.1298C28.0096 12.9079 27.8598 12.7169 27.6645 12.582C27.4691 12.4472 27.2374 12.375 27 12.375C26.7626 12.375 26.5309 12.4472 26.3355 12.582C26.1402 12.7169 25.9905 12.9079 25.9062 13.1298L22.8085 20.9307C22.7273 21.1398 22.5885 21.3216 22.408 21.4548C22.2276 21.588 22.013 21.6672 21.7893 21.6832L13.4834 22.2222C12.4097 22.2919 11.9784 23.6788 12.8141 24.3744L19.1742 29.668C19.3514 29.8174 19.4829 30.0138 19.5535 30.2346C19.6241 30.4554 19.6309 30.6916 19.5732 30.9162L17.6728 38.3918C17.35 39.6617 18.7007 40.6869 19.7886 39.9976L26.3797 35.8218C26.5651 35.7038 26.7803 35.6411 27 35.6411C27.2197 35.6411 27.4349 35.7038 27.6203 35.8218V35.8218Z"
            fill="white"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1319_42017"
              x1="2"
              y1="27"
              x2="52"
              y2="27"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#154398" />
              <stop offset="1" stopColor="#ED1117" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_1319_42017"
              x1="2"
              y1="27"
              x2="52"
              y2="27"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#154398" />
              <stop offset="1" stopColor="#ED1117" />
            </linearGradient>
          </defs>
        </svg>
      )
      break
    case "call-received":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.0827 3.9249C15.7577 3.5999 15.2327 3.5999 14.9077 3.9249L5.83268 12.9916V8.33324C5.83268 7.8749 5.45768 7.4999 4.99935 7.4999C4.54102 7.4999 4.16602 7.8749 4.16602 8.33324V14.9999C4.16602 15.4582 4.54102 15.8332 4.99935 15.8332H11.666C12.1244 15.8332 12.4993 15.4582 12.4993 14.9999C12.4993 14.5416 12.1244 14.1666 11.666 14.1666H7.00768L16.0827 5.09157C16.3994 4.7749 16.3994 4.24157 16.0827 3.9249Z"
            fill="#0D99FF"
          />
        </svg>
      )
      break
    case "add-media-video":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.8333 17.5H3C2.72386 17.5 2.5 17.2762 2.5 17V3C2.5 2.72386 2.72386 2.5 3 2.5H17C17.2762 2.5 17.5 2.72386 17.5 3V10.8333"
            stroke="#ED1117"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.334 15.8335H15.834M18.334 15.8335H15.834M15.834 15.8335V13.3335M15.834 15.8335V18.3335"
            stroke="#ED1117"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.24807 7.09396C7.91474 6.90349 7.5 7.14417 7.5 7.52809V12.4716C7.5 12.8555 7.91474 13.0962 8.24807 12.9057L12.5736 10.4339C12.9095 10.242 12.9095 9.75766 12.5736 9.56574L8.24807 7.09396Z"
            stroke="#ED1117"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "filter-white":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.28784 3.75H16.7122C16.8332 3.75 16.9517 3.78517 17.0532 3.85124C17.1546 3.9173 17.2347 4.01142 17.2837 4.12215C17.3327 4.23288 17.3485 4.35546 17.3291 4.47498C17.3097 4.5945 17.2561 4.70583 17.1746 4.79542L12.0375 10.4462C11.9329 10.5613 11.875 10.7112 11.875 10.8666V15.2905C11.875 15.3934 11.8496 15.4947 11.801 15.5854C11.7525 15.6761 11.6823 15.7535 11.5967 15.8105L9.09669 17.4772C9.00256 17.54 8.89317 17.576 8.78018 17.5814C8.66718 17.5869 8.55483 17.5616 8.45509 17.5082C8.35535 17.4548 8.27197 17.3754 8.21383 17.2784C8.1557 17.1813 8.125 17.0703 8.125 16.9572V10.8666C8.125 10.7112 8.06705 10.5613 7.96246 10.4462L2.82538 4.79542C2.74393 4.70583 2.69026 4.5945 2.67089 4.47498C2.65152 4.35546 2.66729 4.23288 2.71627 4.12215C2.76525 4.01142 2.84535 3.9173 2.94682 3.85124C3.04829 3.78517 3.16676 3.75 3.28784 3.75V3.75Z"
            stroke="#666666"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "sort-up-down":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.3334 14.1759V9.16758C13.3334 8.70924 12.9584 8.33424 12.5 8.33424C12.0417 8.33424 11.6667 8.70924 11.6667 9.16758V14.1759H10.175C9.80002 14.1759 9.61669 14.6259 9.88336 14.8842L12.2084 17.2009C12.375 17.3592 12.6334 17.3592 12.8 17.2009L15.125 14.8842C15.3917 14.6259 15.2 14.1759 14.8334 14.1759H13.3334ZM7.20836 2.79258L4.88336 5.11758C4.61669 5.37591 4.80003 5.82591 5.17503 5.82591H6.66669V10.8342C6.66669 11.2926 7.04169 11.6676 7.50003 11.6676C7.95836 11.6676 8.33336 11.2926 8.33336 10.8342V5.82591H9.82503C10.2 5.82591 10.3834 5.37591 10.1167 5.11758L7.79169 2.79258C7.63336 2.63424 7.36669 2.63424 7.20836 2.79258Z"
            fill="black"
            fillOpacity="0.54"
          />
        </svg>
      )
      break
    case "cancel-post":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.2496 4.75794C14.9246 4.43294 14.3996 4.43294 14.0746 4.75794L9.99961 8.82461L5.92461 4.74961C5.59961 4.42461 5.07461 4.42461 4.74961 4.74961C4.42461 5.07461 4.42461 5.59961 4.74961 5.92461L8.82461 9.99961L4.74961 14.0746C4.42461 14.3996 4.42461 14.9246 4.74961 15.2496C5.07461 15.5746 5.59961 15.5746 5.92461 15.2496L9.99961 11.1746L14.0746 15.2496C14.3996 15.5746 14.9246 15.5746 15.2496 15.2496C15.5746 14.9246 15.5746 14.3996 15.2496 14.0746L11.1746 9.99961L15.2496 5.92461C15.5663 5.60794 15.5663 5.07461 15.2496 4.75794Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "re-post":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.33333 7.50033V4.16699L2.5 10.0003L8.33333 15.8337V12.417C12.5 12.417 15.4167 13.7503 17.5 16.667C16.6667 12.5003 14.1667 8.33366 8.33333 7.50033Z"
            fill="#0D99FF"
          />
        </svg>
      )
      break
    case "delete-black":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.99935 15.8333C4.99935 16.75 5.74935 17.5 6.66602 17.5H13.3327C14.2493 17.5 14.9993 16.75 14.9993 15.8333V5.83333H4.99935V15.8333ZM6.66602 7.5H13.3327V15.8333H6.66602V7.5ZM12.916 3.33333L12.0827 2.5H7.91602L7.08268 3.33333H4.16602V5H15.8327V3.33333H12.916Z"
            fill="#666666"
          />
        </svg>
      )
      break
    case "edit-black":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
            fill="#666666"
          />
        </svg>
      )
      break

    case "search-black":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14V14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
            fill="#666666"
          />
        </svg>
      )
      break
    case "dashboard":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8333 4.16667V5.83333H12.5V4.16667H15.8333ZM7.5 4.16667V9.16667H4.16667V4.16667H7.5ZM15.8333 10.8333V15.8333H12.5V10.8333H15.8333ZM7.5 14.1667V15.8333H4.16667V14.1667H7.5ZM17.5 2.5H10.8333V7.5H17.5V2.5ZM9.16667 2.5H2.5V10.8333H9.16667V2.5ZM17.5 9.16667H10.8333V17.5H17.5V9.16667ZM9.16667 12.5H2.5V17.5H9.16667V12.5Z"
            fill="#212529"
          />
        </svg>
      )
      break
    case "dolar":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.83268 9.08333C7.94102 8.59167 7.33268 8.08333 7.33268 7.29167C7.33268 6.38333 8.17435 5.75 9.58268 5.75C10.766 5.75 11.3577 6.2 11.5743 6.91667C11.6743 7.25 11.9493 7.5 12.2993 7.5H12.5493C13.0993 7.5 13.491 6.95833 13.2993 6.44167C12.9493 5.45833 12.1327 4.64167 10.8327 4.325V3.75C10.8327 3.05833 10.2743 2.5 9.58268 2.5C8.89102 2.5 8.33268 3.05833 8.33268 3.75V4.3C6.71602 4.65 5.41602 5.7 5.41602 7.30833C5.41602 9.23333 7.00768 10.1917 9.33268 10.75C11.416 11.25 11.8327 11.9833 11.8327 12.7583C11.8327 13.3333 11.4243 14.25 9.58268 14.25C8.20768 14.25 7.49935 13.7583 7.22435 13.0583C7.09935 12.7333 6.81602 12.5 6.47435 12.5H6.24102C5.68268 12.5 5.29102 13.0667 5.49935 13.5833C5.97435 14.7417 7.08268 15.425 8.33268 15.6917V16.25C8.33268 16.9417 8.89102 17.5 9.58268 17.5C10.2743 17.5 10.8327 16.9417 10.8327 16.25V15.7083C12.4577 15.4 13.7493 14.4583 13.7493 12.75C13.7493 10.3833 11.7243 9.575 9.83268 9.08333Z"
            fill="#212529"
          />
        </svg>
      )
      break
    case "shopping-icon":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.334 7.50026H14.3423L10.6923 2.03359C10.534 1.80026 10.2673 1.68359 10.0007 1.68359C9.73398 1.68359 9.46732 1.80026 9.30898 2.04193L5.65898 7.50026H1.66732C1.20898 7.50026 0.833984 7.87526 0.833984 8.33359C0.833984 8.40859 0.842318 8.48359 0.867318 8.55859L2.98398 16.2836C3.17565 16.9836 3.81732 17.5003 4.58398 17.5003H15.4173C16.184 17.5003 16.8257 16.9836 17.0257 16.2836L19.1423 8.55859L19.1673 8.33359C19.1673 7.87526 18.7923 7.50026 18.334 7.50026ZM10.0007 4.00026L12.334 7.50026H7.66732L10.0007 4.00026ZM15.4173 15.8336L4.59232 15.8419L2.75898 9.16693H17.2507L15.4173 15.8336ZM10.0007 10.8336C9.08398 10.8336 8.33398 11.5836 8.33398 12.5003C8.33398 13.4169 9.08398 14.1669 10.0007 14.1669C10.9173 14.1669 11.6673 13.4169 11.6673 12.5003C11.6673 11.5836 10.9173 10.8336 10.0007 10.8336Z"
            fill="#212529"
          />
        </svg>
      )
      break
    case "check-box-buy-water":
      iconElement = (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="15" cy="15" r="15" fill="#DDDDDD" />
          <path d="M6 15L12.5 21L23 10" stroke="white" strokeWidth="3" />
        </svg>
      )
      break
    case "dang-ky-mua-nuoc":
      iconElement = (
        <svg
          width="38"
          height="36"
          viewBox="0 0 38 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.41618 6.01953C5.62829 6.01953 4.09807 7.45231 4.09807 9.33772V14.7157H1.85319C1.32721 14.7157 0.900879 15.142 0.900879 15.668C0.900879 16.1939 1.32721 16.6202 1.85319 16.6202H4.09807V26.0974H1.85319C1.32721 26.0974 0.900879 26.5237 0.900879 27.0497C0.900879 27.5756 1.32721 28.002 1.85319 28.002H4.09807V32.6126C4.09807 34.4005 5.53078 35.9308 7.41618 35.9308H22.8902C23.1427 35.9308 23.385 35.8304 23.5635 35.6518L29.9578 29.2577C30.1364 29.079 30.2367 28.8368 30.2367 28.5843V13.8776C30.2367 13.3517 29.8103 12.9253 29.2844 12.9253C28.7585 12.9253 28.3322 13.3517 28.3322 13.8776V27.568H22.8901C22.3642 27.568 21.9379 27.9943 21.9379 28.5203V34.0262H7.41618C6.61606 34.0262 6.00261 33.3824 6.00261 32.6126V28.002H8.24734C8.77332 28.002 9.19965 27.5756 9.19965 27.0497C9.19965 26.5237 8.77332 26.0974 8.24734 26.0974H6.00261V16.6202H8.24734C8.77332 16.6202 9.19965 16.1939 9.19965 15.668C9.19965 15.142 8.77332 14.7157 8.24734 14.7157H6.00261V9.33772C6.00261 8.53752 6.64642 7.92415 7.41618 7.92415H26.1513C26.6772 7.92415 27.1035 7.49775 27.1035 6.97184C27.1035 6.44593 26.6772 6.01953 26.1513 6.01953H7.41618ZM23.8424 32.6796L27.0494 29.4726H23.8424V32.6796Z"
            fill="#EAFEFF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M30.1155 1.91945C30.9468 1.08823 32.0338 0.640625 33.1847 0.640625C34.2718 0.640625 35.3588 1.08823 36.1261 1.98343C36.9573 2.75068 37.4049 3.83774 37.4049 4.98869C37.4049 6.13965 36.9573 7.16273 36.19 7.99396L23.2098 20.9742C22.3785 21.7415 21.3555 22.1891 20.2685 22.1891H15.9204V17.841C15.9204 16.6901 16.368 15.667 17.1353 14.8997L30.1155 1.91945ZM22.7297 18.8918L32.6732 8.88916L29.1564 5.37232L19.213 15.375L22.7297 18.8918ZM17.9542 16.8097C17.796 17.124 17.7107 17.4718 17.7107 17.841V20.3987H20.2685C20.6376 20.3987 20.9855 20.3135 21.2998 20.1552L17.9542 16.8097ZM33.9521 7.67423L34.9112 6.65115C35.4227 6.20362 35.6785 5.56417 35.7424 4.86082C35.8064 4.22137 35.4866 3.51801 35.039 3.07041C34.5914 2.62281 33.9521 2.36706 33.2487 2.36706C32.5454 2.36706 31.9059 2.62281 31.4583 3.13439L30.4352 4.15747L33.9521 7.67423ZM29.8967 8.02705C30.2668 8.40063 30.2641 9.00359 29.8905 9.3737L22.9208 16.2795C22.5472 16.6496 21.9442 16.6469 21.5741 16.2733C21.2039 15.8996 21.2067 15.2968 21.5803 14.9266L28.55 8.02077C28.9235 7.65066 29.5265 7.6534 29.8967 8.02705Z"
            fill="#FFF501"
          />
        </svg>
      )
      break
    case "tra-cuu-su-dung-nuoc":
      iconElement = (
        <svg
          width="40"
          height="29"
          viewBox="0 0 40 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 0C8.97278 0 0 8.82788 0 19.677V23.819C0 26.6775 2.36058 29 5.26196 29H34.736C37.6374 29 40 26.6775 40 23.821V19.679C40 8.82788 31.0272 0 20 0ZM37.896 23.821C37.896 25.5337 36.4788 26.928 34.738 26.928H5.26196C3.5211 26.928 2.10399 25.5337 2.10399 23.821V20.714H5.26196C5.84222 20.714 6.31396 20.2499 6.31396 19.679C6.31594 19.1062 5.84421 18.6421 5.26196 18.6421H2.15726C2.40004 14.568 4.04817 10.8706 6.64167 8.00267L8.72788 10.0533C8.93516 10.2553 9.20358 10.3582 9.47398 10.3582C9.74439 10.3582 10.0128 10.2572 10.2201 10.0553C10.6306 9.65136 10.6306 8.99502 10.2201 8.59106L8.1338 6.54049C11.0491 3.98886 14.8071 2.36547 18.9478 2.12655V5.17923C18.9478 5.75012 19.4196 6.21423 19.9998 6.21423C20.5801 6.21423 21.0518 5.75012 21.0518 5.17923V2.12467C25.1928 2.36352 28.9508 3.98496 31.8658 6.53854L29.7795 8.58918C29.369 8.99307 29.369 9.64941 29.7795 10.0533C29.9868 10.2553 30.2572 10.3582 30.5256 10.3582C30.796 10.3582 31.0645 10.2572 31.2718 10.0553L33.358 8.00462C36.1706 11.1155 37.8977 15.1994 37.8977 19.681V23.8211L37.896 23.821Z"
            fill="white"
          />
          <path
            d="M32.7738 16.2152L25.1932 17.5333C24.4293 15.4727 22.5212 14 20.2787 14C17.3692 14 15 16.4669 15 19.5011C15 22.5352 17.3692 25 20.2787 25C23.1229 25 25.4328 22.6425 25.5377 19.7012L33.1183 18.3831C33.6923 18.2841 34.0822 17.7169 33.9852 17.1188C33.8921 16.5186 33.3459 16.1143 32.7739 16.2153L32.7738 16.2152ZM20.2788 22.8014C18.5331 22.8014 17.112 21.3205 17.112 19.5012C17.112 17.682 18.5331 16.201 20.2788 16.201C21.8484 16.201 23.1428 17.3973 23.3922 18.9608C23.4219 19.1383 23.4457 19.3176 23.4457 19.5012C23.4457 21.3205 22.0245 22.8014 20.2788 22.8014Z"
            fill="#FFF001"
          />
        </svg>
      )
      break
    case "hoa-don-dien-tu":
      iconElement = (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M33.2192 3.20672H27.4339C27.1195 2.27578 26.2384 1.60341 25.2026 1.60341H23.5576C22.8149 0.604781 21.6387 0 20.3926 0C19.1465 0 17.9702 0.604781 17.2276 1.60331H15.5826C14.5468 1.60331 13.6658 2.27569 13.3513 3.20663H7.56574C5.82518 3.20663 4.40918 4.62272 4.40918 6.36319V40.0333C4.40918 41.7739 5.82527 43.1899 7.56574 43.1899H23.5991C24.0142 43.1899 24.3507 42.8534 24.3507 42.4383C24.3507 42.0233 24.0143 41.6867 23.5991 41.6867H7.56574C6.65402 41.6867 5.91227 40.9449 5.91227 40.0332V6.36328C5.91227 5.45156 6.65402 4.70981 7.56574 4.70981H13.2277V7.16494C13.2277 7.57997 13.5641 7.91653 13.9793 7.91653H26.806C27.221 7.91653 27.5576 7.58006 27.5576 7.16494V4.70981H33.2192C34.1309 4.70981 34.8727 5.45156 34.8727 6.36328V28.0084C34.8727 28.4234 35.2091 28.76 35.6243 28.76C36.0393 28.76 36.3759 28.4235 36.3759 28.0084V6.36328C36.3758 4.62272 34.9598 3.20672 33.2192 3.20672ZM26.0545 6.41334H14.7309V3.96113C14.7309 3.96009 14.731 3.95925 14.731 3.95822C14.731 3.95775 14.7309 3.95719 14.7309 3.95681C14.7317 3.48769 15.1134 3.10641 15.5826 3.10641H17.6306C17.8982 3.10641 18.1456 2.96419 18.2802 2.73281C18.7285 1.96284 19.5181 1.50309 20.3926 1.50309C21.2671 1.50309 22.0568 1.96284 22.505 2.73281C22.6395 2.96409 22.887 3.10641 23.1546 3.10641H25.2026C25.6713 3.10641 26.0527 3.48694 26.0544 3.95531C26.0544 3.95634 26.0543 3.95719 26.0543 3.95822C26.0543 3.96019 26.0546 3.96206 26.0546 3.96403L26.0545 6.41334Z"
            fill="white"
          />
          <path
            d="M23.599 38.4809H9.11906V7.91725H10.7728C11.1878 7.91725 11.5244 7.58078 11.5244 7.16566C11.5244 6.75053 11.1879 6.41406 10.7728 6.41406H8.36756C7.95253 6.41406 7.61597 6.75053 7.61597 7.16566V39.2325C7.61597 39.6475 7.95244 39.9841 8.36756 39.9841H23.5991C24.0142 39.9841 24.3507 39.6476 24.3507 39.2325C24.3506 38.8173 24.0142 38.4809 23.599 38.4809Z"
            fill="white"
          />
          <path
            d="M32.4175 6.41406H30.0126C29.5975 6.41406 29.261 6.75053 29.261 7.16566C29.261 7.58078 29.5975 7.91725 30.0126 7.91725H31.666V28.0089C31.666 28.4239 32.0025 28.7605 32.4176 28.7605C32.8328 28.7605 33.1692 28.424 33.1692 28.0089V7.16566C33.1691 6.75063 32.8326 6.41406 32.4175 6.41406Z"
            fill="white"
          />
          <path
            d="M34.8225 30.4609C29.9876 30.4609 26.0542 34.3943 26.0542 39.2292C26.0542 44.0641 29.9877 47.9974 34.8225 47.9974C39.6572 47.9974 43.5907 44.0641 43.5907 39.2292C43.5907 34.3943 39.6573 30.4609 34.8225 30.4609ZM34.8225 46.4943C30.8164 46.4943 27.5573 43.2352 27.5573 39.2292C27.5573 35.2232 30.8164 31.964 34.8225 31.964C38.8285 31.964 42.0876 35.2232 42.0876 39.2292C42.0876 43.2352 38.8286 46.4943 34.8225 46.4943Z"
            fill="white"
          />
          <path
            d="M20.4006 3.20703H20.3926C19.9776 3.20703 19.645 3.5435 19.645 3.95862C19.645 4.37366 19.9854 4.71022 20.4006 4.71022C20.8156 4.71022 21.1521 4.37375 21.1521 3.95862C21.1522 3.5435 20.8158 3.20703 20.4006 3.20703Z"
            fill="white"
          />
          <path
            d="M39.3624 36.2944C39.0689 36.0008 38.593 36.0008 38.2995 36.2944L33.2192 41.3747L30.544 38.6994C30.2504 38.4059 29.7746 38.4059 29.4811 38.6994C29.1876 38.993 29.1876 39.4688 29.4811 39.7623L32.6879 42.969C32.8346 43.1157 33.0269 43.1891 33.2192 43.1891C33.4115 43.1891 33.6039 43.1158 33.7506 42.969L39.3623 37.3573C39.6558 37.0637 39.6558 36.5878 39.3624 36.2944Z"
            fill="#FFF501"
          />
          <path
            d="M17.1357 16.6221V13.5904C18.1946 13.7717 18.8392 14.3112 18.8392 14.705C18.8392 15.12 19.1757 15.4566 19.5908 15.4566C20.0059 15.4566 20.3424 15.1201 20.3424 14.705C20.3424 13.3765 18.9838 12.303 17.1357 12.0714V11.9743C17.1357 11.5592 16.7992 11.2227 16.3841 11.2227C15.969 11.2227 15.6325 11.5591 15.6325 11.9743V12.0714C13.7844 12.3029 12.4258 13.3764 12.4258 14.705C12.4258 16.5869 14.191 17.3101 15.6325 17.7482V20.7799C14.5736 20.5986 13.929 20.0592 13.929 19.6653C13.929 19.2503 13.5925 18.9137 13.1774 18.9137C12.7622 18.9137 12.4258 19.2502 12.4258 19.6653C12.4258 20.9938 13.7844 22.0673 15.6325 22.2989V22.3961C15.6325 22.8111 15.969 23.1477 16.3841 23.1477C16.7992 23.1477 17.1357 22.8112 17.1357 22.3961V22.2989C18.9838 22.0674 20.3424 20.9939 20.3424 19.6653C20.3423 17.7835 18.5772 17.0602 17.1357 16.6221ZM15.6325 16.1629C14.3646 15.7211 13.929 15.3226 13.929 14.705C13.929 14.4673 14.1386 14.2048 14.504 13.985C14.8128 13.7992 15.2046 13.6648 15.6325 13.5914V16.1629ZM18.2642 20.3853C17.9553 20.5711 17.5636 20.7055 17.1357 20.7789V18.2074C18.4036 18.6493 18.8392 19.0477 18.8392 19.6653C18.8392 19.9031 18.6296 20.1655 18.2642 20.3853Z"
            fill="#FFF501"
          />
          <path
            d="M27.6076 12.8281H23.5992C23.1842 12.8281 22.8477 13.1646 22.8477 13.5797C22.8477 13.9948 23.1841 14.3313 23.5992 14.3313H27.6076C28.0227 14.3313 28.3592 13.9948 28.3592 13.5797C28.3592 13.1646 28.0228 12.8281 27.6076 12.8281Z"
            fill="white"
          />
          <path
            d="M26.0042 16.0352H23.5993C23.1842 16.0352 22.8477 16.3716 22.8477 16.7867C22.8477 17.2019 23.1841 17.5383 23.5993 17.5383H26.0042C26.4192 17.5383 26.7558 17.2019 26.7558 16.7867C26.7558 16.3716 26.4192 16.0352 26.0042 16.0352Z"
            fill="white"
          />
          <path
            d="M27.6074 19.2383H23.599C23.184 19.2383 22.8474 19.5747 22.8474 19.9899C22.8474 20.405 23.1839 20.7415 23.599 20.7415H27.6074C28.0224 20.7415 28.359 20.405 28.359 19.9899C28.359 19.5747 28.0225 19.2383 27.6074 19.2383Z"
            fill="white"
          />
          <path
            d="M14.7809 26.457H13.1776C12.7626 26.457 12.426 26.7935 12.426 27.2086C12.426 27.6237 12.7625 27.9602 13.1776 27.9602H14.7809C15.196 27.9602 15.5325 27.6237 15.5325 27.2086C15.5325 26.7935 15.196 26.457 14.7809 26.457Z"
            fill="white"
          />
          <path
            d="M14.7807 32.8672H13.1774C12.7623 32.8672 12.4258 33.2037 12.4258 33.6188C12.4258 34.0339 12.7622 34.3704 13.1774 34.3704H14.7807C15.1957 34.3704 15.5323 34.0339 15.5323 33.6188C15.5323 33.2037 15.1957 32.8672 14.7807 32.8672Z"
            fill="white"
          />
          <path
            d="M14.7807 29.6641H13.1774C12.7623 29.6641 12.4258 30.0005 12.4258 30.4157C12.4258 30.8308 12.7622 31.1672 13.1774 31.1672H14.7807C15.1957 31.1672 15.5323 30.8308 15.5323 30.4157C15.5323 30.0005 15.1957 29.6641 14.7807 29.6641Z"
            fill="white"
          />
          <path
            d="M27.6075 26.457H17.9874C17.5724 26.457 17.2358 26.7935 17.2358 27.2086C17.2358 27.6237 17.5723 27.9602 17.9874 27.9602H27.6075C28.0225 27.9602 28.3591 27.6237 28.3591 27.2086C28.3591 26.7935 28.0226 26.457 27.6075 26.457Z"
            fill="white"
          />
          <path
            d="M25.2024 32.8672H17.9874C17.5724 32.8672 17.2358 33.2037 17.2358 33.6188C17.2358 34.0339 17.5723 34.3704 17.9874 34.3704H25.2024C25.6175 34.3704 25.954 34.0339 25.954 33.6188C25.954 33.2037 25.6175 32.8672 25.2024 32.8672Z"
            fill="white"
          />
          <path
            d="M27.6075 29.6641H17.9874C17.5724 29.6641 17.2358 30.0005 17.2358 30.4157C17.2358 30.8308 17.5723 31.1672 17.9874 31.1672H27.6075C28.0225 31.1672 28.3591 30.8308 28.3591 30.4157C28.3591 30.0005 28.0226 29.6641 27.6075 29.6641Z"
            fill="white"
          />
        </svg>
      )
      break
    case "thanh-toan-truc-tuyen":
      iconElement = (
        <svg
          width="32"
          height="35"
          viewBox="0 0 32 35"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.7265 0.378906C19.9154 0.378906 20.0916 0.433056 20.2406 0.526728C20.3017 0.565068 20.3587 0.610352 20.4105 0.662212L27.3774 7.62911C27.5587 7.8104 27.6605 8.05625 27.6605 8.31259V15.3666C27.6605 15.9005 27.2278 16.3332 26.6939 16.3332C26.16 16.3332 25.7273 15.9005 25.7273 15.3666V9.27908H19.7265C19.1927 9.27908 18.7598 8.84633 18.7598 8.31244V2.31241H2.78875V32.3571H14.7109C15.2447 32.3571 15.6775 32.7898 15.6775 33.3237C15.6775 33.8576 15.2447 34.2903 14.7109 34.2903H1.82211C1.28822 34.2903 0.855469 33.8576 0.855469 33.3237V1.34577C0.855469 0.811881 1.28822 0.379053 1.82211 0.379053H19.7082L19.7265 0.378906ZM20.6932 7.3458V3.67893L24.36 7.3458H20.6932ZM8.6496 11.3167C8.11579 11.3167 7.68297 11.7495 7.68297 12.2834C7.68297 12.8173 8.11579 13.25 8.6496 13.25H19.1696C19.7035 13.25 20.1363 12.8173 20.1363 12.2834C20.1363 11.7495 19.7035 11.3167 19.1696 11.3167H8.6496ZM4.57369 16.7422C4.57369 16.2083 5.00644 15.7756 5.54033 15.7756H15.6773C16.2112 15.7756 16.644 16.2083 16.644 16.7422C16.644 17.2761 16.2112 17.7088 15.6773 17.7088H5.54033C5.00644 17.7088 4.57369 17.2761 4.57369 16.7422ZM5.86249 20.2344C5.32861 20.2344 4.89585 20.6671 4.89585 21.201C4.89585 21.7349 5.32861 22.1676 5.86249 22.1676H11.9411C12.4749 22.1676 12.9078 21.7349 12.9078 21.201C12.9078 20.6671 12.4749 20.2344 11.9411 20.2344H5.86249ZM4.89585 25.6598C4.89585 25.1259 5.32861 24.6932 5.86249 24.6932H11.0354C11.5693 24.6932 12.0021 25.1259 12.0021 25.6598C12.0021 26.1937 11.5693 26.6264 11.0354 26.6264H5.86249C5.32861 26.6264 4.89585 26.1937 4.89585 25.6598ZM15.1199 25.3812C15.1199 21.4902 18.2741 18.3359 22.1651 18.3359C26.0561 18.3359 29.2103 21.4902 29.2103 25.3812C29.2103 29.2722 26.0561 32.4264 22.1651 32.4264C18.2741 32.4264 15.1199 29.2722 15.1199 25.3812ZM22.1651 16.4027C17.2063 16.4027 13.1865 20.4224 13.1865 25.3812C13.1865 30.3399 17.2063 34.3598 22.1651 34.3598C27.1238 34.3598 31.1437 30.3399 31.1437 25.3812C31.1437 20.4224 27.1238 16.4027 22.1651 16.4027Z"
            fill="white"
          />
          <path
            d="M22.1216 24.7947C23.8979 24.7947 25.3438 26.08 25.3438 27.6589C25.3438 28.9889 24.3127 30.1006 22.9272 30.421V31.1496C22.9272 31.5945 22.5665 31.9551 22.1216 31.9551C21.6767 31.9551 21.316 31.5945 21.316 31.1496V30.421C20.2171 30.1668 19.3412 29.415 19.0258 28.4511C18.8874 28.0283 19.2601 27.6589 19.705 27.6589C20.1499 27.6589 20.4978 28.0495 20.7532 28.4138C21.0378 28.82 21.5449 29.0909 22.1216 29.0909C23.0098 29.0909 23.7327 28.4483 23.7327 27.6589C23.7327 26.8694 23.0098 26.2268 22.1216 26.2268C20.3454 26.2268 18.8994 24.9415 18.8994 23.3626C18.8994 22.0326 19.9305 20.9209 21.316 20.6005V19.8719C21.316 19.4271 21.6767 19.0664 22.1216 19.0664C22.5665 19.0664 22.9272 19.4271 22.9272 19.8719V20.6005C24.0261 20.8547 24.902 21.6066 25.2174 22.5704C25.3558 22.9932 24.9831 23.3626 24.5383 23.3626C24.0933 23.3626 23.7454 22.972 23.4901 22.6077C23.2054 22.2015 22.6983 21.9306 22.1216 21.9306C21.2335 21.9306 20.5105 22.5732 20.5105 23.3626C20.5105 24.1521 21.2335 24.7947 22.1216 24.7947Z"
            fill="#FFF001"
          />
        </svg>
      )
      break
    case "sua-chua":
      iconElement = (
        <svg
          width="34"
          height="34"
          viewBox="0 0 34 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_552_10132)">
            <path
              d="M31.7058 10.5995C30.118 6.82871 27.1858 3.78242 23.4782 2.05204C19.7707 0.321651 15.5525 0.0306268 11.6425 1.23546C7.73244 2.4403 4.4096 5.05503 2.31902 8.57205C0.228435 12.0891 -0.480721 16.2574 0.329222 20.2679C1.13917 24.2784 3.41042 27.8448 6.70205 30.2749C9.99368 32.7049 14.0708 33.8252 18.142 33.4181C22.2131 33.0111 25.9878 31.1059 28.7332 28.0723C31.4786 25.0387 32.9988 21.0932 32.9988 17.0017C33.0017 14.8025 32.5619 12.6252 31.7058 10.5995ZM29.8124 22.6031C28.4233 25.9045 25.857 28.5719 22.6117 30.0874C19.3664 31.603 15.6737 31.8585 12.2506 30.8045C8.82747 29.7504 5.91817 27.4619 4.08752 24.3834C2.25687 21.3048 1.6355 17.6558 2.34405 14.1449C3.0526 10.634 5.04051 7.51156 7.92184 5.38394C10.8032 3.25632 14.3723 2.27528 17.9363 2.6313C21.5003 2.98732 24.8048 4.65499 27.2083 7.31053C29.6118 9.96607 30.9428 13.42 30.9429 17.0017C30.9455 18.9258 30.5611 20.8307 29.8124 22.6031V22.6031Z"
              fill="white"
            />
            <path
              d="M21.4629 18.4041C21.4014 18.342 21.3323 18.2881 21.2573 18.2435C22.1317 16.0269 21.6749 13.4015 19.8846 11.6116C19.0359 10.763 17.9582 10.1803 16.7834 9.93499C15.6086 9.68965 14.3878 9.79225 13.2704 10.2302C13.1113 10.2924 12.9702 10.3931 12.8599 10.5234C12.7495 10.6538 12.6734 10.8095 12.6383 10.9766C12.6033 11.1438 12.6104 11.317 12.659 11.4807C12.7077 11.6443 12.7964 11.7933 12.917 11.9142L14.795 13.7921L13.3414 15.2457L11.4647 13.369C11.3439 13.2484 11.1949 13.1597 11.0312 13.111C10.8675 13.0624 10.6943 13.0553 10.5272 13.0903C10.3601 13.1254 10.2043 13.2015 10.074 13.3119C9.9437 13.4223 9.84292 13.5633 9.7808 13.7224C9.33214 14.8715 9.23815 16.1287 9.51096 17.3318C9.78376 18.5348 10.4108 19.6285 11.3113 20.4717C12.2117 21.3149 13.3441 21.869 14.5625 22.0623C15.7809 22.2556 17.0292 22.0794 18.1464 21.5564L20.6974 24.1073C20.9093 24.3219 21.1615 24.4925 21.4396 24.6092C21.7176 24.7259 22.016 24.7865 22.3176 24.7874C22.6192 24.7884 22.918 24.7297 23.1968 24.6147C23.4756 24.4998 23.7289 24.3308 23.9421 24.1175C24.1554 23.9043 24.3243 23.651 24.4393 23.3722C24.5543 23.0934 24.613 22.7946 24.612 22.493C24.6111 22.1915 24.5505 21.8931 24.4338 21.615C24.317 21.3369 24.1465 21.0847 23.9319 20.8728L21.4629 18.4041ZM12.6157 18.8814C11.9074 18.1733 11.4819 17.2309 11.4191 16.2312L12.6157 17.4278C12.8085 17.6206 13.0699 17.7288 13.3425 17.7288C13.6151 17.7288 13.8765 17.6206 14.0693 17.4278L16.9768 14.5203C17.1695 14.3276 17.2778 14.0661 17.2778 13.7935C17.2778 13.521 17.1695 13.2595 16.9768 13.0667L15.7805 11.8698C16.4445 11.9115 17.0884 12.1137 17.657 12.459C18.2257 12.8043 18.702 13.2824 19.0452 13.8523C19.3884 14.4222 19.5882 15.0669 19.6275 15.731C19.6667 16.3951 19.5442 17.0588 19.2706 17.6652C18.9969 18.2715 18.5801 18.8024 18.0561 19.2123C17.5321 19.6222 16.9165 19.8988 16.2621 20.0184C15.6076 20.138 14.934 20.097 14.2989 19.899C13.6638 19.701 13.0862 19.3518 12.6157 18.8814V18.8814ZM22.4776 22.6534C22.4343 22.6967 22.3755 22.7211 22.3141 22.7211C22.2528 22.7211 22.194 22.6967 22.1506 22.6534L19.858 20.3607L19.884 20.3354C19.9853 20.2341 20.0817 20.1302 20.1731 20.0238L22.476 22.3267C22.4976 22.348 22.5148 22.3734 22.5266 22.4013C22.5383 22.4293 22.5445 22.4593 22.5447 22.4896C22.5449 22.52 22.5391 22.5501 22.5276 22.5782C22.5162 22.6062 22.4993 22.6318 22.478 22.6534H22.4776Z"
              fill="#FFF501"
            />
          </g>
          <defs>
            <clipPath id="clip0_552_10132">
              <rect
                width="33.0967"
                height="33"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "lap-dat":
      iconElement = (
        <svg
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_552_10119)">
            <path
              d="M6.79384 1.24144e-05C5.72135 1.24144e-05 4.74374 0.193885 3.76612 0.68063C3.18038 0.973502 2.98238 1.75312 3.47325 2.23986L6.79384 5.54808L5.62235 6.7175L2.30176 3.40723C2.21569 3.31168 2.10986 3.236 1.99163 3.18543C1.87339 3.13486 1.74557 3.11061 1.61702 3.11435C1.22515 3.11435 0.932279 3.31029 0.738406 3.7001C0.0952743 4.98114 -0.128307 6.43213 0.0993581 7.84735C0.327023 9.26258 0.994383 10.5702 2.00683 11.585C3.37425 12.9462 5.03661 13.5299 6.79384 13.5299C7.57758 13.5299 8.3572 13.4329 9.04194 13.1421L19.8844 23.9474C19.0058 26.3812 19.5915 29.1057 21.4478 31.0527C22.8152 32.4139 24.4755 32.9997 26.2327 32.9997C27.3093 32.9997 28.2849 32.8058 29.2645 32.319C29.8482 32.0262 30.0442 31.2466 29.5553 30.7598L26.2348 27.4516L27.4062 26.2822L30.7268 29.5924C30.8129 29.688 30.9187 29.7637 31.037 29.8142C31.1552 29.8648 31.283 29.8891 31.4116 29.8853C31.8034 29.8853 32.0963 29.6894 32.2902 29.2996C32.9333 28.0185 33.1569 26.5675 32.9292 25.1523C32.7016 23.7371 32.0342 22.4294 31.0218 21.4147C29.6544 20.0535 27.992 19.4698 26.2348 19.4698C25.451 19.4698 24.6714 19.5667 23.8897 19.8576L13.0493 9.05429C13.928 6.62057 13.3422 3.89603 11.486 1.94905C10.8717 1.32992 10.1407 0.838849 9.33524 0.504285C8.52981 0.169721 7.66599 -0.00168018 6.79384 1.24144e-05ZM5.52336 8.76142C5.77888 8.7595 6.03149 8.70693 6.26656 8.60674C6.50163 8.50655 6.7145 8.36074 6.89284 8.17774L8.06433 7.00831C8.24938 6.83294 8.39676 6.6217 8.49747 6.38749C8.59819 6.15327 8.65013 5.901 8.65013 5.64605C8.65013 5.3911 8.59819 5.13882 8.49747 4.90461C8.39676 4.67039 8.24938 4.45915 8.06433 4.28378L5.81623 2.04187C6.11116 2.04187 6.40403 1.94493 6.69691 1.94493C7.96739 1.94493 9.23582 2.43167 10.1165 3.40516C11.4839 4.7664 11.8737 6.71544 11.288 8.46649C10.9951 9.1471 11.191 9.92672 11.7768 10.5104L22.6192 21.3178C23.0111 21.7055 23.4999 21.8994 23.9867 21.8994C24.1826 21.8994 24.4755 21.8994 24.6714 21.8025C25.2021 21.6036 25.765 21.505 26.3317 21.5117C27.6022 21.5117 28.8727 21.9984 29.7513 22.9719C30.9228 24.1393 31.4116 25.6964 31.1187 27.2536L28.8706 25.0158C28.6927 24.8333 28.4806 24.6878 28.2462 24.5876C28.0119 24.4874 27.7601 24.4346 27.5052 24.4321C27.2497 24.434 26.9971 24.4866 26.762 24.5868C26.527 24.687 26.3141 24.8328 26.1358 25.0158L24.9643 26.1832C24.7812 26.3599 24.6352 26.5712 24.5346 26.8049C24.4341 27.0386 24.381 27.29 24.3785 27.5444C24.3805 27.7995 24.4333 28.0517 24.5338 28.2861C24.6344 28.5205 24.7808 28.7326 24.9643 28.9098L27.2124 31.1476C26.9174 31.1476 26.6246 31.2445 26.3317 31.2445C25.0612 31.2445 23.7928 30.7577 22.9121 29.7843C22.2613 29.1357 21.8062 28.3171 21.599 27.4219C21.3918 26.5268 21.4409 25.5915 21.7406 24.7229C22.0335 24.0423 21.8376 23.2627 21.2518 22.6811L10.4094 11.8737C10.2313 11.6909 10.0187 11.5453 9.78403 11.4451C9.54933 11.3449 9.29712 11.2922 9.04194 11.29C8.84601 11.29 8.65007 11.29 8.3572 11.387C7.82667 11.5865 7.26369 11.6858 6.69691 11.6798C5.42642 11.6798 4.15593 11.1931 3.27732 10.2196C2.10583 9.05017 1.61702 7.493 1.90989 5.93582L4.158 8.17568C4.5478 8.56342 5.03661 8.75936 5.52336 8.75936V8.76142Z"
              fill="white"
            />
            <path
              d="M10.2483 18.1749C9.99833 18.1771 9.75132 18.229 9.52155 18.3274C9.29178 18.4258 9.08383 18.5689 8.90974 18.7482L2.02106 25.6349C1.83966 25.8076 1.69525 26.0155 1.59658 26.2457C1.4979 26.476 1.44702 26.7239 1.44702 26.9744C1.44702 27.225 1.4979 27.4729 1.59658 27.7031C1.69525 27.9334 1.83966 28.1412 2.02106 28.314L4.70228 30.9911C4.87637 31.1705 5.08433 31.3135 5.31409 31.4119C5.54386 31.5104 5.79088 31.5622 6.04083 31.5645C6.29078 31.5622 6.5378 31.5104 6.76757 31.4119C6.99734 31.3135 7.20529 31.1705 7.37938 30.9911L14.2681 24.1045C14.4495 23.9317 14.5939 23.7239 14.6925 23.4936C14.7912 23.2633 14.8421 23.0154 14.8421 22.7649C14.8421 22.5144 14.7912 22.2665 14.6925 22.0362C14.5939 21.806 14.4495 21.5981 14.2681 21.4253L11.5848 18.7482C11.2981 18.3646 10.8217 18.1749 10.2462 18.1749H10.2483ZM6.1357 29.6526L3.45861 26.9734L10.3452 20.0889L13.0223 22.768L6.1357 29.6546V29.6526ZM29.3798 2.29585L30.7184 3.63647L27.371 6.98387L26.7007 6.31356L26.0304 5.64326L29.3798 2.29585ZM29.3798 0.000316533C29.2538 -0.00308617 29.1286 0.0209798 29.0129 0.0708426C28.8971 0.120706 28.7936 0.19517 28.7095 0.289063L24.0236 4.97501C23.9329 5.06132 23.8607 5.16514 23.8114 5.28019C23.7621 5.39524 23.7366 5.51911 23.7366 5.64429C23.7366 5.76946 23.7621 5.89334 23.8114 6.00838C23.8607 6.12343 23.9329 6.22726 24.0236 6.31356L24.6918 6.98387L20.0059 11.6698C19.9149 11.7561 19.8424 11.8601 19.7929 11.9753C19.7434 12.0906 19.7178 12.2147 19.7178 12.3401C19.7178 12.4656 19.7434 12.5897 19.7929 12.7049C19.8424 12.8201 19.9149 12.9241 20.0059 13.0104C20.1977 13.2002 20.4844 13.2951 20.6741 13.2951C20.925 13.2841 21.1632 13.1822 21.3444 13.0084L26.0304 8.32242L26.7007 8.99066C26.8925 9.18247 27.1792 9.2794 27.371 9.2794C27.6214 9.2674 27.8589 9.16478 28.0392 8.99066L32.7272 4.30471C32.8182 4.21838 32.8907 4.11443 32.9402 3.99919C32.9897 3.88395 33.0153 3.75983 33.0153 3.6344C33.0153 3.50897 32.9897 3.38486 32.9402 3.26962C32.8907 3.15438 32.8182 3.05043 32.7272 2.9641L30.0481 0.289063C29.9532 0.0951905 29.6665 0.000316533 29.3798 0.000316533Z"
              fill="#FFF501"
            />
          </g>
          <defs>
            <clipPath id="clip0_552_10119">
              <rect width="33" height="33" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "sang-ten":
      iconElement = (
        <svg
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_552_10162)">
            <path
              d="M21.6777 0H7.17998C6.92368 0 6.6777 0.101967 6.49642 0.283241L0.283241 6.49642C0.101967 6.6777 0 6.92368 0 7.17998V29.9621C0 31.6372 1.36283 33 3.03786 33H21.6777C22.4896 33 23.2527 32.6838 23.8258 32.11C24.3995 31.5365 24.7155 30.7736 24.7155 29.9621V20L21 23.7605L18.5 22L24.7155 10.2324V3.03786C24.7155 2.2264 24.3995 1.46354 23.8263 0.890259C23.2527 0.316223 22.4896 0 21.6777 0ZM7.24896 2.26517V6.14445C7.24896 6.75348 6.75348 7.24871 6.1447 7.24871H2.26517L7.24896 2.26517ZM22.7822 29.9621C22.7822 30.257 22.6671 30.5342 22.4581 30.7431C22.2499 30.9516 21.9727 31.0664 21.6779 31.0664H3.03786C2.42908 31.0664 1.93359 30.5709 1.93359 29.9621V9.18256H6.14445C7.81947 9.18256 9.1823 7.81973 9.1823 6.1447V1.93359H21.6777C21.9727 1.93359 22.2499 2.0484 22.4586 2.25737C22.6671 2.46584 22.7819 2.74303 22.7819 3.03786L22.782 10.6558L17 23L21.5 25L22.7821 23.7605L22.7822 29.9621Z"
              fill="white"
            />
            <path
              d="M18.5711 12.4258H6.14453C5.61078 12.4258 5.17773 12.8586 5.17773 13.3926C5.17773 13.9266 5.61078 14.3594 6.14453 14.3594H18.5711C19.1051 14.3594 19.5379 13.9266 19.5379 13.3926C19.5379 12.8586 19.1051 12.4258 18.5711 12.4258Z"
              fill="white"
            />
            <path
              d="M16.7058 16.5703H6.00988C5.55047 16.5703 5.17773 17.0031 5.17773 17.5371C5.17773 18.0711 5.55047 18.5039 6.00988 18.5039H16.7058C17.1654 18.5039 17.5379 18.0711 17.5379 17.5371C17.5379 17.0031 17.1654 16.5703 16.7058 16.5703Z"
              fill="white"
            />
            <path
              d="M14.8404 20.7109H5.87523C5.49016 20.7109 5.17773 21.144 5.17773 21.6777C5.17773 22.2117 5.49016 22.6445 5.87523 22.6445H14.8404C15.2257 22.6445 15.5379 22.2117 15.5379 21.6777C15.5379 21.144 15.2257 20.7109 14.8404 20.7109Z"
              fill="white"
            />
            <path
              d="M12.358 24.8516H6.14453C5.61078 24.8516 5.17773 25.2844 5.17773 25.8184C5.17773 26.3521 5.61078 26.7852 6.14453 26.7852H12.358C12.8917 26.7852 13.3248 26.3521 13.3248 25.8184C13.3248 25.2844 12.892 24.8516 12.358 24.8516Z"
              fill="white"
            />
            <path
              d="M29.9562 2.30854C28.4445 1.58703 26.6276 2.22992 25.9061 3.74159L17.1955 21.9916C15.8261 24.8606 15.1332 28.057 15.1916 31.2354C15.1982 31.6015 15.4113 31.9325 15.7416 32.0902C16.0722 32.248 16.4634 32.2053 16.7524 31.9803C19.2599 30.0267 21.3094 27.4775 22.6787 24.6087L31.3892 6.35866C32.1107 4.847 31.4679 3.03004 29.9562 2.30854V2.30854ZM29.1233 4.05356C29.6727 4.31578 29.9064 4.97637 29.6442 5.52578L28.7225 7.45689L26.7294 6.50558L27.6511 4.57447C27.9133 4.02506 28.5737 3.79122 29.1233 4.05356ZM21.1395 23.3445L19.1463 22.3932L25.8965 8.2506L27.8896 9.20191L21.1395 23.3445ZM17.2157 29.0019C17.3825 27.3477 17.7712 25.7151 18.3664 24.1635L20.2537 25.0643C19.4216 26.5031 18.3966 27.8317 17.2157 29.0019Z"
              fill="#FFF501"
            />
            <g clipPath="url(#clip1_552_10162)">
              <path
                d="M292.9 -101L268 -125.9C247.75 -146.15 215 -146.15 194.75 -125.9L35.5 32.8C5.39999 62.8 -11.9 104.3 -12 146.8C-15.875 146.55 -19.5 144.413 -21.375 140.538C-33.255 116.658 -67.625 110.158 -87.375 126.418L-101.255 84.788C-104.5 74.9 -113.6 68.3 -124 68.3C-134.4 68.3 -143.5 74.925 -146.75 84.8L-165 139.4C-166.5 144 -170.75 147 -175.62 147H-188C-196.87 147 -204 154.1 -204 163C-204 171.9 -196.87 179 -188 179H-175.6C-156.98 179 -140.5 167.12 -134.62 149.5L-124 117.6L-107.2 168C-102.6 181.6 -84 182.9 -77.7 170.1L-69.951 154.72C-65.951 146.72 -54.261 146.22 -49.761 155.095C-42.6 169.6 -28.1 178.7 -12 178.9L20 179C86.84 179 132.1 132.7 134.1 131.5L292.9 -27.8C302.6 -37.5 308 -50.6 308 -64.4C308 -78.2 302.6 -91.2 292.9 -101ZM111.5 109C87.3 133.3 54.4 146.9 20 146.9C20 112.52 33.75 79.58 57.1 55.46L177.7 -64.44L230.45 -11.69L111.5 109ZM270.3 -50.4L249 -29.2L196.3 -82L217.42 -103.25C225.17 -110.875 237.67 -110.999 245.42 -103.25L270.3 -78.37C277.9 -70.6 277.9 -58.1 270.3 -50.4ZM96.4 211C89.771 211 83.3 214.795 81.2 221.1C76.1 233.8 65 243 50.1 243H-205.1C-222.72 243 -236.99 228.67 -236.99 211V-173C-236.99 -190.67 -222.71 -205 -205.1 -205H-77.5V-93C-77.5 -66.49 -56.08 -45 -29.66 -45H34.41C43.062 -45 50.07 -52.037 50.07 -60.72V-61.3C50.1 -70 43.9 -77 35.3 -77H-28.8C-37.6 -77 -44.7 -84.2 -44.7 -93V-202.92C-40.239 -201.354 -36.063 -199.074 -32.62 -195.621L57.23 -105.481C63.347 -99.342 73.27 -99.342 79.38 -105.481L79.7 -105.9C85.817 -112.039 85.817 -121.99 79.7 -128.13L-10.1 -218.25C-22.1 -230.258 -38.3 -237 -55.2 -237H-204.07C-239.3 -237 -268 -208.35 -268 -173L-267.993 211C-267.993 246.35 -239.293 275 -204.063 275H50.9365C79.1365 275 103.057 256.64 111.487 231.2C114.8 221.2 106.9 211 96.4 211Z"
                fill="black"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_552_10162">
              <rect width="33" height="33" fill="white" />
            </clipPath>
            <clipPath id="clip1_552_10162">
              <rect
                width="576"
                height="512"
                fill="white"
                transform="translate(-268 -237)"
              />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "cap-lai":
      iconElement = (
        <svg
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_552_10145)">
            <path
              d="M21.6777 0H7.17998C6.92368 0 6.6777 0.101967 6.49642 0.283241L0.283241 6.49642C0.101967 6.6777 0 6.92368 0 7.17998V29.9621C0 31.6372 1.36283 33 3.03786 33H21.6777C22.4896 33 23.2527 32.6838 23.8258 32.11C24.3995 31.5365 24.7155 30.7736 24.7155 29.9621V3.03786C24.7155 2.2264 24.3995 1.46354 23.8263 0.890259C23.2527 0.316223 22.4896 0 21.6777 0V0ZM7.24896 2.26517V6.14445C7.24896 6.75348 6.75348 7.24871 6.1447 7.24871H2.26517L7.24896 2.26517ZM22.7822 29.9621C22.7822 30.257 22.6671 30.5342 22.4581 30.7431C22.2499 30.9516 21.9727 31.0664 21.6779 31.0664H3.03786C2.42908 31.0664 1.93359 30.5709 1.93359 29.9621V9.18256H6.14445C7.81947 9.18256 9.1823 7.81973 9.1823 6.1447V1.93359H21.6777C21.9727 1.93359 22.2499 2.0484 22.4586 2.25737C22.6671 2.46584 22.7819 2.74303 22.7819 3.03786V29.9621H22.7822Z"
              fill="white"
            />
            <path
              d="M18.5711 12.4258H6.14453C5.61078 12.4258 5.17773 12.8586 5.17773 13.3926C5.17773 13.9266 5.61078 14.3594 6.14453 14.3594H18.5711C19.1051 14.3594 19.5379 13.9266 19.5379 13.3926C19.5379 12.8586 19.1051 12.4258 18.5711 12.4258Z"
              fill="white"
            />
            <path
              d="M18.5711 16.5703H6.14453C5.61078 16.5703 5.17773 17.0031 5.17773 17.5371C5.17773 18.0711 5.61078 18.5039 6.14453 18.5039H18.5711C19.1051 18.5039 19.5379 18.0711 19.5379 17.5371C19.5379 17.0031 19.1051 16.5703 18.5711 16.5703Z"
              fill="white"
            />
            <path
              d="M18.571 20.7109H6.14441C5.61066 20.7109 5.17761 21.144 5.17761 21.6777C5.17761 22.2117 5.61066 22.6445 6.14441 22.6445H18.571C19.105 22.6445 19.5378 22.2117 19.5378 21.6777C19.5378 21.144 19.105 20.7109 18.571 20.7109Z"
              fill="white"
            />
            <path
              d="M12.358 24.8516H6.14453C5.61078 24.8516 5.17773 25.2844 5.17773 25.8184C5.17773 26.3521 5.61078 26.7852 6.14453 26.7852H12.358C12.8917 26.7852 13.3248 26.3521 13.3248 25.8184C13.3248 25.2844 12.892 24.8516 12.358 24.8516Z"
              fill="white"
            />
            <path
              d="M29.9622 0C28.2871 0 26.9243 1.36283 26.9243 3.03786V23.26C26.9243 26.4391 27.6758 29.6223 29.0976 32.4655C29.2612 32.793 29.5961 33 29.9622 33C30.3285 33 30.6631 32.793 30.827 32.4655C32.2485 29.6223 33 26.4389 33 23.26V3.03786C33 1.36283 31.6372 0 29.9622 0V0ZM29.9622 1.93359C30.571 1.93359 31.0664 2.42908 31.0664 3.03786V5.17765H28.8579V3.03786C28.8579 2.42908 29.3531 1.93359 29.9622 1.93359ZM31.0664 22.7822H28.8579V7.11124H31.0664V22.7822ZM29.9622 29.5779C29.4002 28.0132 29.0477 26.3724 28.9166 24.7158H31.0078C30.8766 26.3727 30.5239 28.0132 29.9622 29.5779Z"
              fill="#FFF501"
            />
          </g>
          <defs>
            <clipPath id="clip0_552_10145">
              <rect width="33" height="33" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "dang-ki-thay-doi":
      iconElement = (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M42.4597 30.923L39.5983 28.0547L29.9258 37.764L32.7872 40.6323L42.4597 30.923Z"
            stroke="#FFF001"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M32.7793 40.6286L29.0908 41.4656L29.9195 37.7656"
            stroke="#FFF001"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M40.5884 32.7985L37.7285 29.9297"
            stroke="#FFF001"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.7993 41.6244C21.6214 42.4881 17.2774 41.9801 13.4095 40.1757C9.54172 38.3712 6.35547 35.3661 4.32194 31.6047C2.28849 27.8432 1.51577 23.5252 2.11799 19.2892C2.72028 15.0532 4.66553 11.124 7.66614 8.08272C10.6668 5.04148 14.5635 3.04962 18.78 2.40174C22.9964 1.7538 27.3089 2.48419 31.0795 4.48499C34.8502 6.48571 37.8788 9.65054 39.7176 13.5115C41.5564 17.3724 42.1077 21.7245 41.29 25.924"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5418 28.2386C26.1168 27.537 25.8571 26.7472 25.7822 25.9297"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5301 25.6758C17.4503 26.566 17.2105 27.4343 16.8223 28.2387"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.6904 27.3291H21.7882C23.1059 27.3291 24.4122 27.0578 24.9359 26.5325C25.6897 25.7764 29.0042 21.2279 28.4805 15.5654C28.0662 11.0688 25.2063 9.03125 21.6616 9.03125C18.1169 9.03125 15.3318 11.0573 14.8945 15.5654C14.3766 21.2279 17.6911 25.7764 18.4449 26.5325C18.9629 27.0578 20.2748 27.3233 21.5926 27.3291H21.6904Z"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.8983 30.5276C30.2046 29.5587 28.4075 28.7843 26.541 28.2188"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.8229 28.2383C16.8229 28.2383 9.67598 30.3104 8.93945 33.1793"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "green-pencil":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.5 14.5501V17.0835C2.5 17.3168 2.68333 17.5001 2.91667 17.5001H5.45C5.55833 17.5001 5.66667 17.4585 5.74167 17.3751L14.8417 8.28346L11.7167 5.15846L2.625 14.2501C2.54167 14.3335 2.5 14.4335 2.5 14.5501ZM17.2583 5.8668C17.5833 5.5418 17.5833 5.0168 17.2583 4.6918L15.3083 2.7418C14.9833 2.4168 14.4583 2.4168 14.1333 2.7418L12.6083 4.2668L15.7333 7.3918L17.2583 5.8668Z"
            fill="#00C590"
          />
        </svg>
      )

      break
    case "information":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_363_15847)">
            <path
              d="M8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16ZM6.75 10.5H7.5V8.5H6.75C6.33437 8.5 6 8.16562 6 7.75C6 7.33437 6.33437 7 6.75 7H8.25C8.66562 7 9 7.33437 9 7.75V10.5H9.25C9.66562 10.5 10 10.8344 10 11.25C10 11.6656 9.66562 12 9.25 12H6.75C6.33437 12 6 11.6656 6 11.25C6 10.8344 6.33437 10.5 6.75 10.5ZM8 6C7.44688 6 7 5.55312 7 5C7 4.44688 7.44688 4 8 4C8.55313 4 9 4.44688 9 5C9 5.55312 8.55313 6 8 6Z"
              fill="#00C590"
            />
          </g>
          <defs>
            <clipPath id="clip0_363_15847">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "download-red":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8333 10.8333V15C15.8333 15.4583 15.4583 15.8333 15 15.8333H5C4.54167 15.8333 4.16667 15.4583 4.16667 15V10.8333C4.16667 10.375 3.79167 10 3.33333 10C2.875 10 2.5 10.375 2.5 10.8333V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V10.8333C17.5 10.375 17.125 10 16.6667 10C16.2083 10 15.8333 10.375 15.8333 10.8333ZM10.8333 10.5583L12.4 8.99167C12.725 8.66667 13.25 8.66667 13.575 8.99167C13.9 9.31667 13.9 9.84167 13.575 10.1667L10.5833 13.1583C10.2583 13.4833 9.73333 13.4833 9.40833 13.1583L6.41667 10.1667C6.09167 9.84167 6.09167 9.31667 6.41667 8.99167C6.74167 8.66667 7.26667 8.66667 7.59167 8.99167L9.16667 10.5583V3.33333C9.16667 2.875 9.54167 2.5 10 2.5C10.4583 2.5 10.8333 2.875 10.8333 3.33333V10.5583Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "printer-red":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8333 6.66667H4.16667C2.78334 6.66667 1.66667 7.78333 1.66667 9.16667V12.5C1.66667 13.4167 2.41667 14.1667 3.33334 14.1667H5.00001V15.8333C5.00001 16.75 5.75001 17.5 6.66667 17.5H13.3333C14.25 17.5 15 16.75 15 15.8333V14.1667H16.6667C17.5833 14.1667 18.3333 13.4167 18.3333 12.5V9.16667C18.3333 7.78333 17.2167 6.66667 15.8333 6.66667ZM12.5 15.8333H7.50001C7.04167 15.8333 6.66667 15.4583 6.66667 15V11.6667H13.3333V15C13.3333 15.4583 12.9583 15.8333 12.5 15.8333ZM15.8333 10C15.375 10 15 9.625 15 9.16667C15 8.70833 15.375 8.33333 15.8333 8.33333C16.2917 8.33333 16.6667 8.70833 16.6667 9.16667C16.6667 9.625 16.2917 10 15.8333 10ZM14.1667 2.5H5.83334C5.37501 2.5 5.00001 2.875 5.00001 3.33333V5C5.00001 5.45833 5.37501 5.83333 5.83334 5.83333H14.1667C14.625 5.83333 15 5.45833 15 5V3.33333C15 2.875 14.625 2.5 14.1667 2.5Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "eye-red":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.99998 3.75C5.83331 3.75 2.27498 6.34167 0.833313 10C2.27498 13.6583 5.83331 16.25 9.99998 16.25C14.1666 16.25 17.725 13.6583 19.1666 10C17.725 6.34167 14.1666 3.75 9.99998 3.75ZM9.99998 14.1667C7.69998 14.1667 5.83331 12.3 5.83331 10C5.83331 7.7 7.69998 5.83333 9.99998 5.83333C12.3 5.83333 14.1666 7.7 14.1666 10C14.1666 12.3 12.3 14.1667 9.99998 14.1667ZM9.99998 7.5C8.61665 7.5 7.49998 8.61667 7.49998 10C7.49998 11.3833 8.61665 12.5 9.99998 12.5C11.3833 12.5 12.5 11.3833 12.5 10C12.5 8.61667 11.3833 7.5 9.99998 7.5Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "clear-orange":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.9397 2.76904L1.8138 12.338C0.728733 13.3634 0.728733 15.0245 1.8138 16.0499L5.28602 19.3312C5.80686 19.8233 6.51432 20.0981 7.25217 20.0981H11.8225H12.2305H21.5447C22.3129 20.0981 22.9336 19.5116 22.9336 18.7856C22.9336 18.0597 22.3129 17.4731 21.5447 17.4731H16.1584L21.8312 12.1165C22.9162 11.0911 22.9162 9.42998 21.8312 8.40459L15.872 2.76904C14.7869 1.74365 13.0291 1.74365 11.944 2.76904H11.9397ZM12.2305 17.4772H11.8225H7.24783L3.77561 14.196L9.18793 9.08135L15.1515 14.7169L12.2305 17.4772Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "save-orange":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.59 3.59C17.21 3.21 16.7 3 16.17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V7.83C21 7.3 20.79 6.79 20.41 6.42L17.59 3.59ZM12 19C10.34 19 9 17.66 9 16C9 14.34 10.34 13 12 13C13.66 13 15 14.34 15 16C15 17.66 13.66 19 12 19ZM13 9H7C5.9 9 5 8.1 5 7C5 5.9 5.9 5 7 5H13C14.1 5 15 5.9 15 7C15 8.1 14.1 9 13 9Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "download-white":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_363_13605)">
            <path
              d="M11.25 1.25C11.25 0.558594 10.6914 0 10 0C9.30859 0 8.75 0.558594 8.75 1.25V10.7305L5.88281 7.86328C5.39453 7.375 4.60156 7.375 4.11328 7.86328C3.625 8.35156 3.625 9.14453 4.11328 9.63281L9.11328 14.6328C9.60156 15.1211 10.3945 15.1211 10.8828 14.6328L15.8828 9.63281C16.3711 9.14453 16.3711 8.35156 15.8828 7.86328C15.3945 7.375 14.6016 7.375 14.1133 7.86328L11.25 10.7305V1.25ZM2.5 13.75C1.12109 13.75 0 14.8711 0 16.25V17.5C0 18.8789 1.12109 20 2.5 20H17.5C18.8789 20 20 18.8789 20 17.5V16.25C20 14.8711 18.8789 13.75 17.5 13.75H13.5352L11.7656 15.5195C10.7891 16.4961 9.20703 16.4961 8.23047 15.5195L6.46484 13.75H2.5ZM16.875 17.8125C16.3555 17.8125 15.9375 17.3945 15.9375 16.875C15.9375 16.3555 16.3555 15.9375 16.875 15.9375C17.3945 15.9375 17.8125 16.3555 17.8125 16.875C17.8125 17.3945 17.3945 17.8125 16.875 17.8125Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_363_13605">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "qr-code":
      iconElement = (
        <svg
          width="20"
          height="23"
          viewBox="0 0 20 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.14286 1.42773C0.959821 1.42773 0 2.38756 0 3.57059V7.85631C0 9.03934 0.959821 9.99916 2.14286 9.99916H6.42857C7.61161 9.99916 8.57143 9.03934 8.57143 7.85631V3.57059C8.57143 2.38756 7.61161 1.42773 6.42857 1.42773H2.14286ZM5.71429 4.28488V7.14202H2.85714V4.28488H5.71429ZM2.14286 12.8563C0.959821 12.8563 0 13.8161 0 14.9992V19.2849C0 20.4679 0.959821 21.4277 2.14286 21.4277H6.42857C7.61161 21.4277 8.57143 20.4679 8.57143 19.2849V14.9992C8.57143 13.8161 7.61161 12.8563 6.42857 12.8563H2.14286ZM5.71429 15.7134V18.5706H2.85714V15.7134H5.71429ZM11.4286 3.57059V7.85631C11.4286 9.03934 12.3884 9.99916 13.5714 9.99916H17.8571C19.0402 9.99916 20 9.03934 20 7.85631V3.57059C20 2.38756 19.0402 1.42773 17.8571 1.42773H13.5714C12.3884 1.42773 11.4286 2.38756 11.4286 3.57059ZM14.2857 4.28488H17.1429V7.14202H14.2857V4.28488ZM15.7143 19.9992V21.4277H17.1429V19.9992H15.7143ZM20 19.9992H18.5714V21.4277H20V19.9992ZM18.5714 12.8563V14.2849H15.7143V12.8563H11.4286V17.142V21.4277H14.2857V17.142H15.7143V18.5706H20V15.7134V14.2849V12.8563H18.5714Z"
            fill="#00C590"
          />
        </svg>
      )

      break
    case "small-image-red":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 16.6673H3.33333V5.00065H10.8333V3.33398H3.33333C2.41667 3.33398 1.66667 4.08398 1.66667 5.00065V16.6673C1.66667 17.584 2.41667 18.334 3.33333 18.334H15C15.9167 18.334 16.6667 17.584 16.6667 16.6673V9.16732H15V16.6673ZM8.50833 14.0257L6.875 12.059L4.58333 15.0007H13.75L10.8 11.0757L8.50833 14.0257ZM16.6667 3.33398V0.833984H15V3.33398H12.5C12.5083 3.34232 12.5 5.00065 12.5 5.00065H15V7.49232C15.0083 7.50065 16.6667 7.49232 16.6667 7.49232V5.00065H19.1667V3.33398H16.6667Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "user-setting":
      iconElement = (
        <svg
          width="20"
          height="16"
          viewBox="0 0 20 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_363_13524)">
            <path
              d="M7 8C4.79063 8 3 6.20937 3 4C3 1.79062 4.79063 0 7 0C9.20938 0 11 1.79062 11 4C11 6.20937 9.20938 8 7 8ZM5.57188 9.5H8.42813C8.79688 9.5 9.15938 9.5375 9.50625 9.60312C9.44063 10.1812 9.7375 10.7156 10.1875 11.0031C9.66875 11.3344 9.35312 11.9906 9.5625 12.6687C9.6875 13.0719 9.85625 13.4656 10.075 13.8437C10.2937 14.2219 10.55 14.5656 10.8375 14.875C11.3281 15.4031 12.075 15.45 12.625 15.1469V15.175C12.625 15.4625 12.7094 15.7531 12.8719 15.9969H0.928125C0.415625 16 0 15.5844 0 15.0719C0 11.9937 2.49375 9.5 5.57188 9.5ZM13.625 6.81875C13.625 6.6 13.7656 6.40312 13.9781 6.35625C14.3062 6.28125 14.65 6.24062 15 6.24062C15.35 6.24062 15.6938 6.28125 16.0219 6.35625C16.2344 6.40312 16.375 6.6 16.375 6.81875V7.775C16.6219 7.88125 16.8562 8.01562 17.0719 8.175L17.85 7.72812C18.0406 7.61875 18.2781 7.64375 18.4281 7.80312C18.6656 8.05625 18.875 8.34062 19.0562 8.65312C19.2375 8.96562 19.3781 9.29062 19.4781 9.62187C19.5437 9.83125 19.4437 10.05 19.2531 10.1594L18.4719 10.6094C18.4844 10.7344 18.4937 10.8625 18.4937 10.9937C18.4937 11.125 18.4875 11.25 18.4719 11.3781L19.2531 11.8281C19.4437 11.9375 19.5406 12.1562 19.4781 12.3656C19.375 12.6969 19.2344 13.0219 19.0562 13.3344C18.8781 13.6469 18.6656 13.9312 18.4281 14.1844C18.2781 14.3437 18.0375 14.3687 17.85 14.2594L17.0719 13.8125C16.8562 13.9719 16.625 14.1062 16.375 14.2125V15.1687C16.375 15.3875 16.2344 15.5844 16.0219 15.6312C15.6938 15.7062 15.35 15.7469 15 15.7469C14.65 15.7469 14.3062 15.7062 13.9781 15.6312C13.7656 15.5844 13.625 15.3875 13.625 15.1687V14.2125C13.375 14.1062 13.1375 13.9719 12.9219 13.8094L12.15 14.2562C11.9594 14.3656 11.7219 14.3406 11.5719 14.1812C11.3344 13.9281 11.125 13.6437 10.9438 13.3312C10.7625 13.0187 10.6219 12.6937 10.5219 12.3625C10.4563 12.1531 10.5562 11.9344 10.7469 11.825L11.5219 11.3781C11.5094 11.25 11.5 11.1219 11.5 10.9906C11.5 10.8594 11.5063 10.7312 11.5219 10.6031L10.7437 10.1562C10.5531 10.0469 10.4563 9.82812 10.5188 9.61875C10.6219 9.2875 10.7594 8.9625 10.9406 8.65C11.1219 8.3375 11.3313 8.05312 11.5688 7.8C11.7188 7.64062 11.9563 7.61562 12.1469 7.725L12.9219 8.17187C13.1375 8.0125 13.375 7.87812 13.625 7.76875V6.81875ZM16.5031 10.9906C16.5031 10.1625 15.8313 9.49062 15 9.49062C14.1687 9.49062 13.4969 10.1625 13.4969 10.9906C13.4969 11.8187 14.1687 12.4906 15 12.4906C15.8313 12.4906 16.5031 11.8187 16.5031 10.9906Z"
              fill="#00C590"
            />
          </g>
          <defs>
            <clipPath id="clip0_363_13524">
              <rect width="20" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "speed-icon":
      iconElement = (
        <svg
          width="53"
          height="8"
          viewBox="0 0 53 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="49" cy="4" r="4" fill="#ED1117" />
          <path
            d="M49 4.00044C49 6 17 6.00045 0 4.00044C17 3.00045 49 2.5 49 4.00044Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "close-tag":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM16.3 16.3C15.91 16.69 15.28 16.69 14.89 16.3L12 13.41L9.11 16.3C8.72 16.69 8.09 16.69 7.7 16.3C7.31 15.91 7.31 15.28 7.7 14.89L10.59 12L7.7 9.11C7.31 8.72 7.31 8.09 7.7 7.7C8.09 7.31 8.72 7.31 9.11 7.7L12 10.59L14.89 7.7C15.28 7.31 15.91 7.31 16.3 7.7C16.69 8.09 16.69 8.72 16.3 9.11L13.41 12L16.3 14.89C16.68 15.27 16.68 15.91 16.3 16.3Z"
            fill="#838383"
          />
        </svg>
      )
      break
    case "small-image":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.02 5H19V2.98C19 2.44 18.56 2 18.02 2H17.99C17.44 2 17 2.44 17 2.98V5H14.99C14.45 5 14.01 5.44 14 5.98V6.01C14 6.56 14.44 7 14.99 7H17V9.01C17 9.55 17.44 10 17.99 9.99H18.02C18.56 9.99 19 9.55 19 9.01V7H21.02C21.56 7 22 6.56 22 6.02V5.98C22 5.44 21.56 5 21.02 5ZM16 9.01V8H14.99C14.46 8 13.96 7.79 13.58 7.42C13.21 7.04 13 6.54 13 5.98C13 5.62 13.1 5.29 13.27 5H5C3.9 5 3 5.9 3 7V19C3 20.1 3.9 21 5 21H17C18.1 21 19 20.1 19 19V10.72C18.7 10.89 18.36 11 17.98 11C16.89 10.99 16 10.1 16 9.01ZM15.96 19H6C5.59 19 5.35 18.53 5.6 18.2L7.58 15.57C7.79 15.29 8.2 15.31 8.4 15.59L10 18L12.61 14.52C12.81 14.26 13.2 14.25 13.4 14.51L16.35 18.19C16.61 18.52 16.38 19 15.96 19Z"
            fill="black"
            fillOpacity="0.54"
          />
        </svg>
      )

      break
    case "arrow-orange":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.66663 9.99967C1.66663 14.5997 5.39996 18.333 9.99996 18.333C14.6 18.333 18.3333 14.5997 18.3333 9.99967C18.3333 5.39967 14.6 1.66634 9.99996 1.66634C5.39996 1.66634 1.66663 5.39967 1.66663 9.99967ZM12.2083 10.2913L9.88329 12.6163C9.61663 12.883 9.16663 12.6997 9.16663 12.3247V7.66634C9.16663 7.29134 9.61663 7.10801 9.87496 7.37467L12.2 9.69967C12.3666 9.86634 12.3666 10.133 12.2083 10.2913Z"
            fill="#F88C00"
          />
        </svg>
      )
      break
    case "shopping-cart":
      iconElement = (
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.55 13.5C16.3 13.5 16.96 13.09 17.3 12.47L20.88 5.98C21.25 5.32 20.77 4.5 20.01 4.5H5.21L4.27 2.5H1V4.5H3L6.6 12.09L5.25 14.53C4.52 15.87 5.48 17.5 7 17.5H19V15.5H7L8.1 13.5H15.55ZM6.16 6.5H18.31L15.55 11.5H8.53L6.16 6.5ZM7 18.5C5.9 18.5 5.01 19.4 5.01 20.5C5.01 21.6 5.9 22.5 7 22.5C8.1 22.5 9 21.6 9 20.5C9 19.4 8.1 18.5 7 18.5ZM17 18.5C15.9 18.5 15.01 19.4 15.01 20.5C15.01 21.6 15.9 22.5 17 22.5C18.1 22.5 19 21.6 19 20.5C19 19.4 18.1 18.5 17 18.5Z"
            fill="black"
            fillOpacity="0.54"
          />
        </svg>
      )
      break
    case "favorite":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.6602 3.99065C17.0202 2.19065 13.7602 3.03065 12.0002 5.09065C10.2402 3.03065 6.98021 2.18065 4.34021 3.99065C2.94021 4.95065 2.06021 6.57065 2.00021 8.28065C1.86021 12.1607 5.30021 15.2707 10.5502 20.0407L10.6502 20.1307C11.4102 20.8207 12.5802 20.8207 13.3402 20.1207L13.4502 20.0207C18.7002 15.2607 22.1302 12.1507 22.0002 8.27065C21.9402 6.57065 21.0602 4.95065 19.6602 3.99065ZM12.1002 18.5507L12.0002 18.6507L11.9002 18.5507C7.14021 14.2407 4.00021 11.3907 4.00021 8.50065C4.00021 6.50065 5.50021 5.00065 7.50021 5.00065C9.04021 5.00065 10.5402 5.99065 11.0702 7.36065H12.9402C13.4602 5.99065 14.9602 5.00065 16.5002 5.00065C18.5002 5.00065 20.0002 6.50065 20.0002 8.50065C20.0002 11.3907 16.8602 14.2407 12.1002 18.5507Z"
            fill="#838383"
          />
        </svg>
      )
      break
    case "truck":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.7138 12.7116L18.6672 9.67489C18.5177 9.52572 18.303 9.4404 18.0781 9.4404H15.2805V7.72687C15.2805 6.91794 14.6526 6.25977 13.8808 6.25977H4.53006C3.7583 6.25977 3.13037 6.91794 3.13037 7.72687V15.7367C3.13037 16.2026 3.50264 16.5815 3.95984 16.5815H6.13577C6.30411 17.2425 6.97122 17.738 7.76749 17.738C8.56377 17.738 9.23057 17.2425 9.39921 16.5815H14.6825H15.2805H17.5357C17.704 17.2425 18.3712 17.738 19.1674 17.738C19.9637 17.738 20.6308 17.2425 20.7991 16.5815H21.1248C21.5592 16.5815 21.913 16.268 21.913 15.883V13.1756C21.913 13.005 21.8424 12.8402 21.7138 12.7116ZM20.9481 12.7458H17.3138C17.2376 12.7458 17.1754 12.691 17.1754 12.6234V11.182C17.1754 11.1144 17.2376 11.0593 17.3138 11.0593H19.2559L20.9481 12.7458ZM7.76749 17.2081C7.17425 17.2081 6.69164 16.7804 6.69164 16.2548C6.69164 15.7291 7.17425 15.3011 7.76749 15.3011C8.36074 15.3011 8.84335 15.7288 8.84335 16.2548C8.84335 16.7804 8.36074 17.2081 7.76749 17.2081ZM9.42373 16.0515C9.3113 15.3298 8.61251 14.7715 7.76749 14.7715C6.92248 14.7715 6.22368 15.3298 6.11125 16.0515H3.95984C3.8504 16.0515 3.7284 15.9225 3.7284 15.7367V7.72687C3.7284 7.21019 4.08812 6.78969 4.53006 6.78969H13.8808C14.3231 6.78969 14.6825 7.21019 14.6825 7.72687V9.4404V13.5733H6.39262C6.22757 13.5733 6.09361 13.6918 6.09361 13.8383C6.09361 13.9848 6.22757 14.1032 6.39262 14.1032H14.6825V16.0515H9.42373ZM19.1671 17.2081C18.5742 17.2081 18.0913 16.7804 18.0913 16.2548C18.0913 15.7291 18.5739 15.3011 19.1671 15.3011C19.7604 15.3011 20.2433 15.7288 20.2433 16.2548C20.2433 16.7804 19.7607 17.2081 19.1671 17.2081ZM21.1248 16.0515H20.8237C20.7112 15.3298 20.0121 14.7715 19.1671 14.7715C18.3221 14.7715 17.6233 15.3298 17.5109 16.0515H15.2802V9.97033H18.0778C18.1322 9.97033 18.1837 9.99099 18.2201 10.027L18.7243 10.5294H17.3138C16.9078 10.5294 16.5774 10.8222 16.5774 11.182V12.6234C16.5774 12.983 16.9075 13.2758 17.3138 13.2758H21.3149V15.883C21.3149 15.976 21.2297 16.0515 21.1248 16.0515Z"
            fill="black"
            stroke="black"
            strokeWidth="0.5"
          />
        </svg>
      )
      break
    case "share":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08Z"
            fill="#838383"
          />
        </svg>
      )
      break
    case "key-next":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.29006 15.8805L13.1701 12.0005L9.29006 8.12047C8.90006 7.73047 8.90006 7.10047 9.29006 6.71047C9.68006 6.32047 10.3101 6.32047 10.7001 6.71047L15.2901 11.3005C15.6801 11.6905 15.6801 12.3205 15.2901 12.7105L10.7001 17.3005C10.3101 17.6905 9.68006 17.6905 9.29006 17.3005C8.91006 16.9105 8.90006 16.2705 9.29006 15.8805Z"
            fill="#838383"
          />
        </svg>
      )
      break
    case "key-previous":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.7099 15.8805L10.8299 12.0005L14.7099 8.12047C15.0999 7.73047 15.0999 7.10047 14.7099 6.71047C14.3199 6.32047 13.6899 6.32047 13.2999 6.71047L8.70994 11.3005C8.31994 11.6905 8.31994 12.3205 8.70994 12.7105L13.2999 17.3005C13.6899 17.6905 14.3199 17.6905 14.7099 17.3005C15.0899 16.9105 15.0999 16.2705 14.7099 15.8805Z"
            fill="#838383"
          />
        </svg>
      )
      break
    case "media-solid":
      iconElement = (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_28_4323)">
            <path
              d="M0.937857 0H8.43786C8.7484 0 9.04137 0.158203 9.21715 0.416016L13.9691 7.54102C11.0687 7.78125 8.46129 9.04102 6.49254 10.957L0.15856 1.45898C-0.0347996 1.17188 -0.0523777 0.802734 0.111685 0.498047C0.275747 0.193359 0.592153 0 0.937857 0ZM29.8422 1.45898L23.5082 10.9629C21.5453 9.04688 18.932 7.78711 16.0316 7.54688L20.7836 0.416016C20.9593 0.152344 21.2523 0 21.5629 0H29.0629C29.4086 0 29.725 0.1875 29.889 0.498047C30.0531 0.808594 30.0355 1.17188 29.8422 1.45898ZM25.3129 19.6875C25.3129 25.3828 20.6957 30 15.0004 30C9.30504 30 4.68786 25.3828 4.68786 19.6875C4.68786 13.9922 9.30504 9.375 15.0004 9.375C20.6957 9.375 25.3129 13.9922 25.3129 19.6875ZM15.4925 14.127C15.2933 13.7168 14.7132 13.7168 14.5082 14.127L13.1957 16.7871C13.1136 16.9512 12.9613 17.0625 12.7855 17.0859L9.84411 17.5137C9.39293 17.5781 9.21715 18.1289 9.53942 18.4512L11.6664 20.5254C11.7953 20.6543 11.8539 20.8301 11.8246 21.0117L11.3207 23.9355C11.2445 24.3809 11.7132 24.7266 12.1175 24.5156L14.7425 23.1328C14.9007 23.0508 15.0941 23.0508 15.2523 23.1328L17.8773 24.5156C18.2816 24.7266 18.7504 24.3867 18.6742 23.9355L18.1703 21.0117C18.141 20.8359 18.1996 20.6543 18.3285 20.5254L20.4554 18.4512C20.7836 18.1348 20.6019 17.584 20.1507 17.5137L17.2152 17.0859C17.0394 17.0625 16.8812 16.9453 16.805 16.7871L15.4925 14.127Z"
              fill="#00C590"
            />
          </g>
          <defs>
            <clipPath id="clip0_28_4323">
              <rect width="30" height="30" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "handshake":
      iconElement = (
        <svg
          width="38"
          height="30"
          viewBox="0 0 38 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_28_4342)">
            <path
              d="M18.9492 4.99219L13.2773 9.58594C12.334 10.3477 12.1523 11.7188 12.8672 12.6973C13.623 13.7402 15.0938 13.9453 16.1074 13.1543L21.9258 8.63086C22.3359 8.31445 22.9219 8.38477 23.2441 8.79492C23.5664 9.20508 23.4902 9.79102 23.0801 10.1133L21.8555 11.0625L30 18.5625V7.5H29.959L29.7305 7.35352L25.4766 4.62891C24.5801 4.05469 23.5312 3.75 22.4648 3.75C21.1875 3.75 19.9453 4.18945 18.9492 4.99219ZM20.2852 12.2813L17.2559 14.6367C15.4102 16.0781 12.7324 15.7031 11.3496 13.8047C10.0488 12.0176 10.377 9.52148 12.0938 8.13281L16.9688 4.18945C16.2891 3.90234 15.5566 3.75586 14.8125 3.75586C13.7109 3.75 12.6387 4.07813 11.7188 4.6875L7.5 7.5V20.625H9.15234L14.5078 25.5117C15.6562 26.5605 17.4316 26.4785 18.4805 25.3301C18.8027 24.9727 19.0195 24.5566 19.1309 24.123L20.127 25.0371C21.2695 26.0859 23.0508 26.0098 24.0996 24.8672C24.3633 24.5801 24.5566 24.2461 24.6797 23.9004C25.8164 24.6621 27.3633 24.5039 28.3184 23.4609C29.3672 22.3184 29.291 20.5371 28.1484 19.4883L20.2852 12.2813ZM5.625 7.5H0V20.625C0 21.6621 0.837891 22.5 1.875 22.5H3.75C4.78711 22.5 5.625 21.6621 5.625 20.625V7.5ZM2.8125 20.625C2.29688 20.625 1.875 20.2031 1.875 19.6875C1.875 19.1719 2.29688 18.75 2.8125 18.75C3.32812 18.75 3.75 19.1719 3.75 19.6875C3.75 20.2031 3.32812 20.625 2.8125 20.625ZM31.875 7.5V20.625C31.875 21.6621 32.7129 22.5 33.75 22.5H35.625C36.6621 22.5 37.5 21.6621 37.5 20.625V7.5H31.875ZM35.625 19.6875C35.625 20.2031 35.2031 20.625 34.6875 20.625C34.1719 20.625 33.75 20.2031 33.75 19.6875C33.75 19.1719 34.1719 18.75 34.6875 18.75C35.2031 18.75 35.625 19.1719 35.625 19.6875Z"
              fill="#00C590"
            />
          </g>
          <defs>
            <clipPath id="clip0_28_4342">
              <rect width="37.5" height="30" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "file-sign":
      iconElement = (
        <svg
          width="33"
          height="30"
          viewBox="0 0 33 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_28_4295)">
            <path
              d="M21.5 25.8011V26.25C21.5 28.0529 20.0691 29.5 18.3333 29.5H3.66667C1.93095 29.5 0.5 28.0529 0.5 26.25V3.75C0.5 1.94713 1.93095 0.5 3.66667 0.5H12.3333V7.5C12.3333 8.8026 13.3659 9.875 14.6667 9.875H21.5V11.7259L16.2112 17.1348C15.6785 17.6797 15.3019 18.3574 15.1203 19.1069L14.2611 22.6276L14.2606 22.6298C14.2225 22.789 14.1962 22.9491 14.1815 23.109C13.6396 22.4196 12.8125 22 11.9167 22C11.4771 22 11.0538 22.0999 10.6721 22.2848L10.1964 20.6657L10.1963 20.6655C9.94136 19.7988 9.15626 19.1875 8.25 19.1875C7.34376 19.1875 6.55867 19.7988 6.30368 20.6655C6.30367 20.6655 6.30367 20.6655 6.30366 20.6655L5.45002 23.5659L5.44916 23.5688C5.39499 23.7572 5.23267 23.875 5.05312 23.875H4.58333C3.79249 23.875 3.16667 24.5314 3.16667 25.3125C3.16667 26.0936 3.79249 26.75 4.58333 26.75H5.05312C6.49583 26.75 7.75803 25.7833 8.16826 24.387L8.16848 24.3863L8.25369 24.0946L8.73812 25.7276C8.89899 26.2893 9.39269 26.6935 9.96759 26.7478C10.5521 26.803 11.1089 26.482 11.3642 25.952C11.3644 25.9517 11.3645 25.9513 11.3647 25.951L11.8679 24.9159L11.868 24.9159L11.8725 24.9063C11.8764 24.8977 11.8828 24.8901 11.8923 24.8841C11.9022 24.8778 11.913 24.875 11.9224 24.875C11.9361 24.875 11.9605 24.8826 11.9772 24.9165C11.9773 24.9167 11.9773 24.9168 11.9774 24.9169L12.481 25.953L12.4815 25.954C12.7186 26.439 13.2062 26.75 13.75 26.75H17.4167C17.4952 26.75 17.5696 26.7417 17.6172 26.7363C17.8185 26.7218 18.0144 26.6876 18.203 26.6426L18.2031 26.6427L18.2106 26.6407L21.5 25.8011ZM18.2268 19.1582L18.2269 19.158L25.2715 11.9478L28.6399 15.3927L21.5795 22.6192C21.5794 22.6192 21.5794 22.6193 21.5793 22.6193C21.4094 22.7931 21.1927 22.9168 20.9597 22.9765C20.9596 22.9765 20.9595 22.9765 20.9595 22.9765L17.5164 23.8554L17.5141 23.856C17.3767 23.8917 17.2336 23.8534 17.1268 23.7442C17.0189 23.6339 16.9755 23.478 17.0138 23.3239L17.0144 23.3217L17.8738 19.8002L17.8742 19.7984C17.9334 19.5521 18.0551 19.3337 18.2268 19.1582ZM20.8118 7H15.1667V1.22655L20.8118 7ZM28.6126 8.53625C28.6128 8.53608 28.613 8.5359 28.6131 8.53574C29.3174 7.82061 30.4446 7.82244 31.1415 8.53511L31.9653 9.37771C31.9656 9.37796 31.9658 9.37821 31.9661 9.37846C32.6712 10.105 32.6694 11.2773 31.9665 11.9961L30.6396 13.3532L27.2712 9.9082L28.6126 8.53625Z"
              fill="#00C590"
              stroke="#00C590"
            />
          </g>
          <defs>
            <clipPath id="clip0_28_4295">
              <rect width="33" height="30" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "back-arrow":
      iconElement = (
        <svg
          width="60"
          height="60"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M41.55 7.4749C40.325 6.2499 38.35 6.2499 37.125 7.4749L16.35 28.2499C15.375 29.2249 15.375 30.7999 16.35 31.7749L37.125 52.5499C38.35 53.7749 40.325 53.7749 41.55 52.5499C42.775 51.3249 42.775 49.3499 41.55 48.1249L23.45 29.9999L41.575 11.8749C42.775 10.6749 42.775 8.6749 41.55 7.4749Z"
            fill="white"
          />
        </svg>
      )

      break
    case "next-arrow":
      iconElement = (
        <svg
          width="60"
          height="68"
          viewBox="0 0 60 68"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_225_8601)">
            <path
              d="M18.45 11.4749C19.675 10.2499 21.65 10.2499 22.875 11.4749L43.65 32.2499C44.625 33.2249 44.625 34.7999 43.65 35.7749L22.875 56.5499C21.65 57.7749 19.675 57.7749 18.45 56.5499C17.225 55.3249 17.225 53.3499 18.45 52.1249L36.55 33.9999L18.425 15.8749C17.225 14.6749 17.225 12.6749 18.45 11.4749Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_225_8601"
              x="-10"
              y="-6"
              width="80"
              height="80"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_225_8601"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_225_8601"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      )
      break
    case "shopping":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.55 13C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C21.25 4.82 20.77 4 20.01 4H5.21L4.27 2H1V4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H19V15H7L8.1 13H15.55ZM6.16 6H18.31L15.55 11H8.53L6.16 6ZM7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z"
            fill="#154398"
          />
        </svg>
      )
      break
    case "access-time":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.99325 1.33301C4.31325 1.33301 1.33325 4.31967 1.33325 7.99967C1.33325 11.6797 4.31325 14.6663 7.99325 14.6663C11.6799 14.6663 14.6666 11.6797 14.6666 7.99967C14.6666 4.31967 11.6799 1.33301 7.99325 1.33301ZM7.99992 13.333C5.05325 13.333 2.66659 10.9463 2.66659 7.99967C2.66659 5.05301 5.05325 2.66634 7.99992 2.66634C10.9466 2.66634 13.3333 5.05301 13.3333 7.99967C13.3333 10.9463 10.9466 13.333 7.99992 13.333Z"
            fill="#838383"
          />
          <path
            d="M8.33325 4.66699H7.33325V8.66699L10.8333 10.767L11.3333 9.94699L8.33325 8.16699V4.66699Z"
            fill="#838383"
          />
        </svg>
      )
      break
    case "author":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.37333 6.01333L9.98667 6.62667L3.94667 12.6667H3.33333V12.0533L9.37333 6.01333ZM11.7733 2C11.6067 2 11.4333 2.06667 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333L12.2467 2.19333C12.1133 2.06 11.9467 2 11.7733 2ZM9.37333 4.12667L2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667Z"
            fill="#838383"
          />
        </svg>
      )
      break
    case "arrow-right-orange":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.74167 13.2333L10.975 9.99998L7.74167 6.76665C7.41667 6.44165 7.41667 5.91665 7.74167 5.59165C8.06667 5.26665 8.59167 5.26665 8.91667 5.59165L12.7417 9.41665C13.0667 9.74165 13.0667 10.2667 12.7417 10.5917L8.91667 14.4166C8.59167 14.7416 8.06667 14.7416 7.74167 14.4166C7.42501 14.0916 7.41667 13.5583 7.74167 13.2333Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "yellow-checked":
      iconElement = (
        <svg
          width="21"
          height="15"
          viewBox="0 0 21 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.29188 5.72323C2.44867 5.00974 1.18672 5.1149 0.473227 5.95812C-0.240261 6.80133 -0.135098 8.06328 0.708115 8.77677L3.29188 5.72323ZM8.5 12.75L7.20812 14.2768C8.00217 14.9487 9.1787 14.8997 9.91421 14.1642L8.5 12.75ZM20.4142 3.66421C21.1953 2.88317 21.1953 1.61683 20.4142 0.835786C19.6332 0.0547378 18.3668 0.0547378 17.5858 0.835786L20.4142 3.66421ZM0.708115 8.77677L7.20812 14.2768L9.79188 11.2232L3.29188 5.72323L0.708115 8.77677ZM9.91421 14.1642L20.4142 3.66421L17.5858 0.835786L7.08579 11.3358L9.91421 14.1642Z"
            fill="#FFF501"
          />
        </svg>
      )
      break
    case "phone-animation":
      iconElement = (
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2_21117)">
            <path
              d="M27.9796 55.9592C43.4323 55.9592 55.9592 43.4323 55.9592 27.9796C55.9592 12.5269 43.4323 0 27.9796 0C12.5269 0 0 12.5269 0 27.9796C0 43.4323 12.5269 55.9592 27.9796 55.9592Z"
              fill="#1552C1"
            />
            <path
              d="M21.3722 15.5806C22.0247 15.8253 22.5958 16.274 22.922 16.8858C23.8601 18.2317 24.7167 19.6185 25.4508 21.0868C25.614 21.4131 25.7363 21.7801 25.8587 22.1472C26.0218 22.5959 25.9403 23.0853 25.614 23.4116C25.2061 23.8603 24.7167 24.2681 24.3088 24.676C23.8601 25.0839 23.7786 25.1246 24.0233 25.7364C25.2061 28.7139 27.6125 31.0387 30.6715 32.1399C30.8346 32.2215 31.0794 32.1807 31.1609 32.0176C31.528 31.5689 31.9359 31.1203 32.3438 30.6716C32.7924 30.1006 33.5674 29.9375 34.2199 30.2638C35.158 30.7124 36.0553 31.1611 36.9526 31.6505C37.8499 32.1807 38.7065 32.7925 39.6038 33.3635C39.7669 33.4451 39.8893 33.5675 40.0116 33.6898C40.5826 34.3424 40.7458 34.9542 40.1748 35.6884C39.7669 36.2186 39.3183 36.708 38.8696 37.1567C37.7684 38.2171 36.5856 39.1552 35.3212 39.971C34.6686 40.3788 34.0568 40.5012 33.4042 40.3788C31.2833 39.971 29.244 39.1552 27.4086 37.9724C23.2891 35.4437 19.9038 31.936 17.4974 27.735C16.6409 26.2259 16.0291 24.5944 15.662 22.8814L15.5397 22.188V21.617C15.6212 21.4539 15.7028 21.2907 15.7844 21.1276C16.5593 19.7816 17.4974 18.558 18.5579 17.416C19.2105 16.641 19.9854 15.9884 20.8827 15.5398H21.3722V15.5806ZM21.1274 17.2936C21.0459 17.3344 21.0051 17.3752 20.9643 17.416C19.6183 18.6396 18.4355 20.0263 17.4566 21.5354C17.2935 21.7801 17.2119 22.1064 17.2935 22.3919C17.5382 23.7379 17.9869 25.0431 18.6395 26.2667C20.9235 30.6308 24.3904 34.2608 28.6322 36.7896C30.1413 37.7277 31.8543 38.4211 33.6081 38.7474C33.8936 38.8289 34.1791 38.7474 34.4239 38.5842C35.5659 37.8093 36.6671 36.9528 37.646 35.9739C38.0131 35.6068 38.3394 35.2805 38.7065 34.9134C38.5841 34.8319 38.5025 34.7503 38.421 34.7095C36.9526 33.649 35.4027 32.711 33.7713 31.936C33.6081 31.8136 33.4042 31.8544 33.2818 32.0176C32.7924 32.5886 32.2622 33.2004 31.732 33.7714C31.4872 34.0161 31.1202 34.1385 30.7939 34.0161C28.7137 33.4451 26.7968 32.3031 25.2877 30.7532C23.7786 29.2849 22.6773 27.4495 22.0655 25.4509C21.8616 24.9615 22.0247 24.3905 22.4326 24.0642C22.9628 23.6155 23.4931 23.1261 24.0641 22.6367C24.1864 22.5551 24.1864 22.3919 24.1456 22.3104C23.4523 20.8421 22.6365 19.4145 21.6985 18.0686C21.4945 17.7831 21.3314 17.5383 21.1274 17.2936Z"
              fill="white"
            />
            <path
              d="M28.8362 18.5172V16.845C31.365 16.845 33.8121 17.7423 35.7291 19.3737C38.1763 21.4131 39.6038 24.4313 39.6038 27.6126H37.9316C37.9316 22.5959 33.8529 18.558 28.8362 18.5172Z"
              fill="white"
            />
            <path
              d="M28.8362 22.6774V21.0459C32.0583 20.842 35.5252 23.7786 35.4436 27.6533H33.8121C33.8121 24.9206 31.5689 22.7181 28.8362 22.6774Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_2_21117">
              <rect width="56" height="56" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "arrow-up-orange":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.12 14.71L12 10.83L15.88 14.71C16.27 15.1 16.9 15.1 17.29 14.71C17.68 14.32 17.68 13.69 17.29 13.3L12.7 8.70998C12.31 8.31998 11.68 8.31998 11.29 8.70998L6.7 13.3C6.31 13.69 6.31 14.32 6.7 14.71C7.09 15.09 7.73 15.1 8.12 14.71Z"
            fill="#F88C00"
          />
        </svg>
      )

      break
    case "link":
      iconElement = (
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.1423 6.59564L9.7783 8.05835C9.52823 8.32651 9.54304 8.75052 9.8112 9.00058C10.0794 9.25065 10.5034 9.23584 10.7534 8.96768L12.1174 7.50497C12.8676 6.70048 14.1396 6.65606 14.9441 7.40626C15.7486 8.15646 15.793 9.42848 15.0428 10.233L13.6789 11.6957C13.4288 11.9638 13.4436 12.3878 13.7118 12.6379C13.9799 12.888 14.4039 12.8732 14.654 12.605L16.018 11.1423C17.2729 9.79661 17.1992 7.686 15.8535 6.43112C14.5078 5.17625 12.3972 5.24995 11.1423 6.59564ZM9.48815 13.2571C9.75631 13.5072 10.1803 13.4924 10.4304 13.2242L13.1584 10.2988C13.4084 10.0306 13.3936 9.6066 13.1255 9.35654C12.8573 9.10647 12.4333 9.12128 12.1832 9.38944L9.45525 12.3149C9.20518 12.583 9.21999 13.007 9.48815 13.2571ZM11.8602 13.646L10.4962 15.1087C9.74599 15.9131 8.47398 15.9576 7.66949 15.2074C6.865 14.4572 6.82058 13.1852 7.57078 12.3807L8.93477 10.918C9.18484 10.6498 9.17003 10.2258 8.90187 9.97572C8.63371 9.72566 8.2097 9.74046 7.95964 10.0086L6.59564 11.4713C5.34076 12.817 5.41447 14.9276 6.76016 16.1825C8.10585 17.4374 10.2165 17.3637 11.4713 16.018L12.8353 14.5553C13.0854 14.2871 13.0706 13.8631 12.8024 13.613C12.5343 13.363 12.1103 13.3778 11.8602 13.646Z"
            fill="black"
          />
        </svg>
      )
      break
    case "download-app":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.6667 8.66667V12C12.6667 12.3667 12.3667 12.6667 12 12.6667H4C3.63333 12.6667 3.33333 12.3667 3.33333 12V8.66667C3.33333 8.3 3.03333 8 2.66667 8C2.3 8 2 8.3 2 8.66667V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8.66667C14 8.3 13.7 8 13.3333 8C12.9667 8 12.6667 8.3 12.6667 8.66667ZM8.66667 8.44667L9.92 7.19333C10.18 6.93333 10.6 6.93333 10.86 7.19333C11.12 7.45333 11.12 7.87333 10.86 8.13333L8.46667 10.5267C8.20667 10.7867 7.78667 10.7867 7.52667 10.5267L5.13333 8.13333C4.87333 7.87333 4.87333 7.45333 5.13333 7.19333C5.39333 6.93333 5.81333 6.93333 6.07333 7.19333L7.33333 8.44667V2.66667C7.33333 2.3 7.63333 2 8 2C8.36667 2 8.66667 2.3 8.66667 2.66667V8.44667Z"
            fill="black"
          />
        </svg>
      )
      break
    case "small-phone":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.82 10.1733L11.1267 9.98C10.72 9.93334 10.32 10.0733 10.0334 10.36L8.80669 11.5867C6.92003 10.6267 5.37336 9.08667 4.41336 7.19334L5.64669 5.96C5.93336 5.67333 6.07336 5.27334 6.02669 4.86667L5.83336 3.18667C5.75336 2.51333 5.18669 2.00667 4.50669 2.00667L3.35336 2.00667C2.60003 2.00667 1.97336 2.63333 2.02003 3.38667C2.37336 9.08 6.92669 13.6267 12.6134 13.98C13.3667 14.0267 13.9934 13.4 13.9934 12.6467V11.4933C14 10.82 13.4934 10.2533 12.82 10.1733Z"
            fill="black"
          />
        </svg>
      )
      break
    case "home-work":
      iconElement = (
        <svg
          width="68"
          height="68"
          viewBox="0 0 68 68"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M56.6665 8.5H33.9998C32.4415 8.5 31.1665 9.775 31.1665 11.3333V15.895C31.1665 15.895 31.1665 15.895 31.1948 15.9233L45.3615 28.6733C47.1465 30.26 48.1665 32.5833 48.1665 34.9917V36.8333H53.8332V42.5H48.1665V48.1667H53.8332V53.8333H48.1665V59.5H56.6665C58.2248 59.5 59.4998 58.225 59.4998 56.6667V11.3333C59.4998 9.775 58.2248 8.5 56.6665 8.5ZM42.4998 19.8333H36.8332V14.1667H42.4998V19.8333ZM53.8332 31.1667H48.1665V25.5H53.8332V31.1667ZM53.8332 19.8333H48.1665V14.1667H53.8332V19.8333Z"
            fill="white"
          />
          <path
            d="M42.5 56.6667V34.9917C42.5 34.1983 42.16 33.4333 41.565 32.895L27.3983 20.145C26.86 19.635 26.18 19.4083 25.5 19.4083C24.82 19.4083 24.14 19.6633 23.6017 20.145L9.435 32.895C8.84 33.405 8.5 34.17 8.5 34.9917V56.6667C8.5 58.225 9.775 59.5 11.3333 59.5H17C18.5583 59.5 19.8333 58.225 19.8333 56.6667V45.3333H31.1667V56.6667C31.1667 58.225 32.4417 59.5 34 59.5H39.6667C41.225 59.5 42.5 58.225 42.5 56.6667Z"
            fill="white"
          />
        </svg>
      )
      break

    case "online":
      iconElement = (
        <svg
          width="68"
          height="68"
          viewBox="0 0 68 68"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M33.9998 5.66663C18.3598 5.66663 5.6665 18.36 5.6665 34C5.6665 49.64 18.3598 62.3333 33.9998 62.3333C49.6398 62.3333 62.3332 49.64 62.3332 34C62.3332 18.36 49.6398 5.66663 33.9998 5.66663ZM31.1665 56.4683C19.9748 55.08 11.3332 45.56 11.3332 34C11.3332 32.2433 11.5598 30.5716 11.9282 28.9283L25.4998 42.5V45.3333C25.4998 48.45 28.0498 51 31.1665 51V56.4683ZM50.7165 49.2716C49.9798 46.9766 47.8832 45.3333 45.3332 45.3333H42.4998V36.8333C42.4998 35.275 41.2248 34 39.6665 34H22.6665V28.3333H28.3332C29.8915 28.3333 31.1665 27.0583 31.1665 25.5V19.8333H36.8332C39.9498 19.8333 42.4998 17.2833 42.4998 14.1666V13.005C50.8015 16.3766 56.6665 24.5083 56.6665 34C56.6665 39.8933 54.3998 45.2483 50.7165 49.2716Z"
            fill="white"
          />
        </svg>
      )
      break
    case "message":
      iconElement = (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.13882 23.595L5.29076 26.8298C5.1541 26.9447 4.98748 27.0182 4.8105 27.0416C4.63351 27.065 4.45352 27.0374 4.29168 26.9621C4.12984 26.8867 3.99289 26.7667 3.89693 26.6161C3.80098 26.4656 3.75 26.2907 3.75 26.1122V7.50006C3.75 7.25142 3.84877 7.01296 4.02459 6.83715C4.2004 6.66133 4.43886 6.56256 4.6875 6.56256H25.3125C25.5611 6.56256 25.7996 6.66133 25.9754 6.83715C26.1512 7.01296 26.25 7.25142 26.25 7.50006V22.5001C26.25 22.7487 26.1512 22.9872 25.9754 23.163C25.7996 23.3388 25.5611 23.4376 25.3125 23.4376H9.57081L9.13882 23.595Z"
            fill="white"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.25 13.125H18.75"
            stroke="#154398"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.25 16.875H18.75"
            stroke="#154398"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "call":
      iconElement = (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.6812 4.6875C20.2704 5.11493 21.7195 5.95245 22.8832 7.11618C24.047 8.2799 24.8845 9.72899 25.3119 11.3183"
            fill="white"
          />
          <path
            d="M18.6812 4.6875C20.2704 5.11493 21.7195 5.95245 22.8832 7.11618C24.047 8.2799 24.8845 9.72899 25.3119 11.3183"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.7114 8.31079C18.665 8.56725 19.5344 9.06976 20.2327 9.768C20.9309 10.4662 21.4334 11.3357 21.6899 12.2893"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.8371 14.6268C11.8095 16.6149 13.4211 18.2192 15.4136 19.1826C15.5594 19.2516 15.7207 19.2816 15.8815 19.2694C16.0424 19.2572 16.1973 19.2034 16.3311 19.1131L19.2649 17.1568C19.3947 17.0702 19.544 17.0175 19.6993 17.0032C19.8546 16.9889 20.011 17.0136 20.1543 17.0751L25.643 19.4274C25.8295 19.5066 25.9852 19.6442 26.0866 19.8196C26.188 19.995 26.2297 20.1985 26.2054 20.3996C26.0319 21.7571 25.3695 23.0049 24.3423 23.9092C23.3151 24.8135 21.9935 25.3124 20.625 25.3125C16.3981 25.3125 12.3443 23.6334 9.35549 20.6445C6.36662 17.6556 4.6875 13.6019 4.6875 9.37499C4.68757 8.00645 5.18648 6.68485 6.0908 5.65766C6.99512 4.63047 8.24285 3.96812 9.60035 3.79464C9.80146 3.7703 10.005 3.81198 10.1804 3.9134C10.3558 4.01482 10.4934 4.17048 10.5726 4.35693L12.927 9.85043C12.9879 9.99253 13.0127 10.1475 12.9992 10.3015C12.9857 10.4555 12.9344 10.6038 12.8497 10.7331L10.9001 13.712C10.8114 13.846 10.7589 14.0007 10.7479 14.1611C10.7368 14.3214 10.7676 14.4819 10.8371 14.6268Z"
            fill="white"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "youtube":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.6752 8.69886C18.5185 8.10977 18.0549 7.64504 17.4652 7.48577C16.3988 7.19995 12.1203 7.19995 12.1203 7.19995C12.1203 7.19995 7.84391 7.19995 6.77537 7.48577C6.18778 7.64286 5.72423 8.10759 5.56536 8.69886C5.28027 9.76795 5.28027 12 5.28027 12C5.28027 12 5.28027 14.232 5.56536 15.301C5.72206 15.8901 6.1856 16.3549 6.77537 16.5141C7.84391 16.8 12.1203 16.8 12.1203 16.8C12.1203 16.8 16.3988 16.8 17.4652 16.5141C18.0528 16.357 18.5163 15.8923 18.6752 15.301C18.9603 14.232 18.9603 12 18.9603 12C18.9603 12 18.9603 9.76795 18.6752 8.69886Z"
            fill="white"
          />
          <path
            d="M10.7536 14.0574L14.3074 12L10.7536 9.9425V14.0574Z"
            fill="#154398"
          />
        </svg>
      )
      break
    case "facebook":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.8079 12.7496L15.1499 10.5789H13.0435V9.16789C13.0435 8.57434 13.3375 7.99435 14.2779 7.99435H15.2491V6.14585C14.6835 6.05574 14.112 6.00699 13.5393 6C11.8056 6 10.6737 7.04127 10.6737 8.92369V10.5789H8.75195V12.7496H10.6737V18H13.0435V12.7496H14.8079Z"
            fill="white"
          />
        </svg>
      )
      break
    case "phone":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.23 15.26L16.69 14.97C16.08 14.9 15.48 15.11 15.05 15.54L13.21 17.38C10.38 15.94 8.06004 13.63 6.62004 10.79L8.47004 8.94001C8.90004 8.51001 9.11004 7.91001 9.04004 7.30001L8.75004 4.78001C8.63004 3.77001 7.78004 3.01001 6.76004 3.01001H5.03004C3.90004 3.01001 2.96004 3.95001 3.03004 5.08001C3.56004 13.62 10.39 20.44 18.92 20.97C20.05 21.04 20.99 20.1 20.99 18.97V17.24C21 16.23 20.24 15.38 19.23 15.26Z"
            fill="white"
          />
        </svg>
      )
      break
    case "fax":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 8H5C3.34 8 2 9.34 2 11V15C2 16.1 2.9 17 4 17H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V17H20C21.1 17 22 16.1 22 15V11C22 9.34 20.66 8 19 8ZM15 19H9C8.45 19 8 18.55 8 18V14H16V18C16 18.55 15.55 19 15 19ZM19 12C18.45 12 18 11.55 18 11C18 10.45 18.45 10 19 10C19.55 10 20 10.45 20 11C20 11.55 19.55 12 19 12ZM17 3H7C6.45 3 6 3.45 6 4V6C6 6.55 6.45 7 7 7H17C17.55 7 18 6.55 18 6V4C18 3.45 17.55 3 17 3Z"
            fill="white"
          />
        </svg>
      )
      break
    case "email":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19.6 8.25L13.06 12.34C12.41 12.75 11.59 12.75 10.94 12.34L4.4 8.25C4.15 8.09 4 7.82 4 7.53C4 6.86 4.73 6.46 5.3 6.81L12 11L18.7 6.81C19.27 6.46 20 6.86 20 7.53C20 7.82 19.85 8.09 19.6 8.25Z"
            fill="white"
          />
        </svg>
      )
      break
    case "address":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C8.13 2 5 5.13 5 9C5 13.17 9.42 18.92 11.24 21.11C11.64 21.59 12.37 21.59 12.77 21.11C14.58 18.92 19 13.17 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
            fill="white"
          />
        </svg>
      )
      break
    case "credit-card":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 5.25H3C2.58579 5.25 2.25 5.58579 2.25 6V18C2.25 18.4142 2.58579 18.75 3 18.75H21C21.4142 18.75 21.75 18.4142 21.75 18V6C21.75 5.58579 21.4142 5.25 21 5.25Z"
            stroke="#3776FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.75 15.75H18.75"
            stroke="#3776FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.25 15.75H12.75"
            stroke="#3776FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.25 9.07983H21.75"
            stroke="#3776FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "signup":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.75 4.375H17.5"
            stroke="#172B4D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.625 2.5V6.25"
            stroke="#172B4D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.4209 16.8743C3.1893 15.5442 4.29419 14.4398 5.62456 13.672C6.95493 12.9042 8.46393 12.5 9.99997 12.5C11.536 12.5 13.045 12.9043 14.3754 13.6721C15.7057 14.44 16.8106 15.5444 17.579 16.8744"
            stroke="#172B4D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.6915 9.23303C14.3573 10.1354 13.7696 10.9221 12.9991 11.4987C12.2286 12.0752 11.3081 12.417 10.348 12.483C9.38799 12.549 8.42931 12.3364 7.58715 11.8708C6.74499 11.4052 6.05519 10.7063 5.60059 9.85813C5.146 9.00997 4.94596 8.04859 5.0245 7.0895C5.10305 6.1304 5.45683 5.21438 6.04336 4.45148C6.62989 3.68857 7.42421 3.11124 8.3309 2.78883C9.23759 2.46642 10.2181 2.41265 11.1546 2.63397"
            stroke="#172B4D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "signin":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.34473 13.2812L10.6251 10L7.34473 6.71875"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.875 10H10.6227"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.625 3.125H15C15.1658 3.125 15.3247 3.19085 15.4419 3.30806C15.5592 3.42527 15.625 3.58424 15.625 3.75V16.25C15.625 16.4158 15.5592 16.5747 15.4419 16.6919C15.3247 16.8092 15.1658 16.875 15 16.875H10.625"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "home":
      iconElement = (
        <svg
          width="25"
          height="25"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 19V14H14V19C14 19.55 14.45 20 15 20H18C18.55 20 19 19.55 19 19V12H20.7C21.16 12 21.38 11.43 21.03 11.13L12.67 3.6C12.29 3.26 11.71 3.26 11.33 3.6L2.97001 11.13C2.63001 11.43 2.84001 12 3.30001 12H5.00001V19C5.00001 19.55 5.45001 20 6.00001 20H9.00001C9.55001 20 10 19.55 10 19Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "contact":
      iconElement = (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.59241 11.75L2.5 14.25V4.25C2.5 4.08424 2.56585 3.92527 2.68306 3.80806C2.80027 3.69085 2.95924 3.625 3.125 3.625H13.125C13.2908 3.625 13.4497 3.69085 13.5669 3.80806C13.6842 3.92527 13.75 4.08424 13.75 4.25V11.125C13.75 11.2908 13.6842 11.4497 13.5669 11.5669C13.4497 11.6842 13.2908 11.75 13.125 11.75H5.59241Z"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.25 11.75V14.875C6.25 15.0408 6.31585 15.1997 6.43306 15.3169C6.55027 15.4342 6.70924 15.5 6.875 15.5H14.4076L17.5 18V8C17.5 7.83424 17.4342 7.67527 17.3169 7.55806C17.1997 7.44085 17.0408 7.375 16.875 7.375H13.75"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "sort":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 10H12"
            stroke="#8B939F"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.875 6.25H18.125"
            stroke="#8B939F"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 14H5.75"
            stroke="#8B939F"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "video":
      iconElement = (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.875 5.1875H11.875C12.538 5.1875 13.1739 5.45089 13.6428 5.91973C14.1116 6.38857 14.375 7.02446 14.375 7.6875V15.1875C14.375 15.3533 14.3092 15.5122 14.1919 15.6294C14.0747 15.7467 13.9158 15.8125 13.75 15.8125H3.75C3.08696 15.8125 2.45107 15.5491 1.98223 15.0803C1.51339 14.6114 1.25 13.9755 1.25 13.3125V5.8125C1.25 5.64674 1.31585 5.48777 1.43306 5.37056C1.55027 5.25335 1.70924 5.1875 1.875 5.1875V5.1875Z"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.375 9.25L18.75 6.75V14.25L14.375 11.75"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "camera":
      iconElement = (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.25 16.75H3.75C3.41848 16.75 3.10054 16.6183 2.86612 16.3839C2.6317 16.1495 2.5 15.8315 2.5 15.5V6.75C2.5 6.41848 2.6317 6.10054 2.86612 5.86612C3.10054 5.6317 3.41848 5.5 3.75 5.5H6.24954L7.49954 3.625H12.4995L13.7495 5.5H16.25C16.5815 5.5 16.8995 5.6317 17.1339 5.86612C17.3683 6.10054 17.5 6.41848 17.5 6.75V15.5C17.5 15.8315 17.3683 16.1495 17.1339 16.3839C16.8995 16.6183 16.5815 16.75 16.25 16.75Z"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 13.625C11.5533 13.625 12.8125 12.3658 12.8125 10.8125C12.8125 9.2592 11.5533 8 10 8C8.4467 8 7.1875 9.2592 7.1875 10.8125C7.1875 12.3658 8.4467 13.625 10 13.625Z"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "rating":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5 12V18L10 16L6.5 18V12"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="10" cy="7.5" r="5.5" stroke="#0D99FF" strokeWidth="2" />
        </svg>
      )
      break
    case "voting":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5 12V18L10 16L6.5 18V12"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="10" cy="7.5" r="5.5" stroke="#0D99FF" strokeWidth="2" />
        </svg>
      )
      break
    case "file-icon":
      iconElement = (
        <svg
          width="89"
          height="89"
          viewBox="0 0 89 89"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.3">
            <path
              opacity="0.3"
              d="M61.7206 22.3036C59.9655 22.3019 58.2827 21.5995 57.0417 20.3505C55.8007 19.1016 55.1027 17.4081 55.101 15.6419V6.39238H25.5249C24.3901 6.39196 23.2664 6.61648 22.2179 7.05319C21.1694 7.48991 20.2168 8.13025 19.4142 8.93759C18.6117 9.74493 17.9751 10.7035 17.5407 11.7585C17.1064 12.8135 16.8828 13.9442 16.8828 15.0862V67.4948C16.8828 68.6367 17.1064 69.7676 17.5407 70.8226C17.9751 71.8776 18.6117 72.8361 19.4142 73.6434C20.2168 74.4508 21.1694 75.091 22.2179 75.5278C23.2664 75.9645 24.3901 76.1891 25.5249 76.1887H61.0303C62.1648 76.1887 63.2882 75.9638 64.3363 75.5269C65.3844 75.09 66.3367 74.4496 67.1389 73.6423C67.9411 72.835 68.5774 71.8766 69.0116 70.8218C69.4457 69.767 69.6692 68.6365 69.6692 67.4948V22.3036H61.7206Z"
              fill="#0072FF"
            />
          </g>
          <path
            d="M69.6697 22.3036H61.7211C59.966 22.3019 58.2833 21.5995 57.0423 20.3505C55.8012 19.1016 55.1033 17.4081 55.1016 15.6419V6.39238L69.6697 22.3036Z"
            fill="#0072FF"
          />
          <path
            d="M58.8083 33.4431H25.6655C25.3471 33.4431 25.0417 33.3158 24.8165 33.0892C24.5914 32.8626 24.4648 32.5553 24.4648 32.2348C24.4644 32.0759 24.4952 31.9184 24.5553 31.7714C24.6155 31.6245 24.7039 31.4909 24.8154 31.3783C24.9269 31.2658 25.0594 31.1765 25.2053 31.1156C25.3512 31.0547 25.5075 31.0233 25.6655 31.0233H58.8083C59.1275 31.0233 59.4337 31.151 59.6595 31.3782C59.8853 31.6054 60.0121 31.9135 60.0121 32.2348C60.0113 32.5556 59.884 32.8629 59.6584 33.0894C59.4327 33.3159 59.127 33.4431 58.8083 33.4431Z"
            fill="#0072FF"
          />
          <path
            d="M58.8083 40.6702H25.6655C25.3471 40.6702 25.0417 40.5429 24.8165 40.3163C24.5914 40.0897 24.4648 39.7824 24.4648 39.462C24.4644 39.303 24.4952 39.1455 24.5553 38.9986C24.6155 38.8516 24.7039 38.718 24.8154 38.6055C24.9269 38.4929 25.0594 38.4036 25.2053 38.3427C25.3512 38.2818 25.5075 38.2504 25.6655 38.2504H58.8083C59.1275 38.2504 59.4337 38.378 59.6595 38.6052C59.8853 38.8324 60.0121 39.1406 60.0121 39.462C60.0113 39.7827 59.884 40.09 59.6584 40.3165C59.4327 40.543 59.127 40.6702 58.8083 40.6702Z"
            fill="#0072FF"
          />
          <path
            d="M58.8083 47.8973H25.6655C25.5075 47.8973 25.3512 47.8659 25.2053 47.805C25.0594 47.7441 24.9269 47.6548 24.8154 47.5423C24.7039 47.4297 24.6155 47.2961 24.5553 47.1492C24.4952 47.0022 24.4644 46.8447 24.4648 46.6858C24.4648 46.3653 24.5914 46.058 24.8165 45.8314C25.0417 45.6048 25.3471 45.4775 25.6655 45.4775H58.8083C59.127 45.4775 59.4327 45.6047 59.6584 45.8312C59.884 46.0577 60.0113 46.365 60.0121 46.6858C60.0121 47.0071 59.8853 47.3152 59.6595 47.5424C59.4337 47.7697 59.1275 47.8973 58.8083 47.8973Z"
            fill="#0072FF"
          />
          <path
            d="M45.736 55.1244H25.6655C25.5075 55.1244 25.3512 55.0931 25.2053 55.0322C25.0594 54.9712 24.9269 54.8819 24.8154 54.7693C24.7039 54.6568 24.6155 54.5233 24.5553 54.3763C24.4952 54.2293 24.4644 54.0719 24.4648 53.9129C24.4648 53.5925 24.5914 53.2851 24.8165 53.0585C25.0417 52.8319 25.3471 52.7046 25.6655 52.7046H45.736C46.0545 52.7046 46.3599 52.8319 46.5851 53.0585C46.8102 53.2851 46.9367 53.5925 46.9367 53.9129C46.9371 54.0719 46.9064 54.2293 46.8462 54.3763C46.7861 54.5233 46.6977 54.6568 46.5862 54.7693C46.4747 54.8819 46.3421 54.9712 46.1963 55.0322C46.0504 55.0931 45.894 55.1244 45.736 55.1244Z"
            fill="#0072FF"
          />
          <path
            d="M41.3509 75.3292V77.678H38.9336V75.3292H41.3509Z"
            fill="white"
          />
        </svg>
      )
      break
    case "add-primary":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.125 10H16.875"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 3.125V16.875"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "edit-green":
      iconElement = (
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.2167 7.51667L12.9833 8.28333L5.43333 15.8333H4.66667V15.0667L12.2167 7.51667ZM15.2167 2.5C15.0083 2.5 14.7917 2.58333 14.6333 2.74167L13.1083 4.26667L16.2333 7.39167L17.7583 5.86667C18.0833 5.54167 18.0833 5.01667 17.7583 4.69167L15.8083 2.74167C15.6417 2.575 15.4333 2.5 15.2167 2.5ZM12.2167 5.15833L3 14.375V17.5H6.125L15.3417 8.28333L12.2167 5.15833Z"
            fill="#00C590"
          />
        </svg>
      )
      break
    case "edit-orange":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.37333 6.01333L9.98667 6.62667L3.94667 12.6667H3.33333V12.0533L9.37333 6.01333ZM11.7733 2C11.6067 2 11.4333 2.06667 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333L12.2467 2.19333C12.1133 2.06 11.9467 2 11.7733 2ZM9.37333 4.12667L2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "arrow-up":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_395_40305)">
            <path d="M12 8L18 14H6L12 8Z" fill="#6A7688" />
          </g>
          <defs>
            <clipPath id="clip0_395_40305">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0 24) rotate(-90)"
              />
            </clipPath>
          </defs>
        </svg>
      )
      break

    case "search-white":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.0625 15.625C12.6869 15.625 15.625 12.6869 15.625 9.0625C15.625 5.43813 12.6869 2.5 9.0625 2.5C5.43813 2.5 2.5 5.43813 2.5 9.0625C2.5 12.6869 5.43813 15.625 9.0625 15.625Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.7021 13.7031L17.4991 17.5"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "check-special":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.25476 15.7452C3.53569 15.0262 4.01262 13.5165 3.64662 12.632C3.26722 11.715 1.875 10.9769 1.875 9.99997C1.875 9.02301 3.26722 8.285 3.64663 7.36803C4.01262 6.48346 3.5357 4.97382 4.25476 4.25476C4.97382 3.53569 6.48346 4.01262 7.36804 3.64662C8.28503 3.26722 9.02305 1.875 10 1.875C10.977 1.875 11.715 3.26722 12.632 3.64663C13.5165 4.01262 15.0262 3.5357 15.7452 4.25476C16.4643 4.97382 15.9874 6.48346 16.3534 7.36804C16.7328 8.28503 18.125 9.02305 18.125 10C18.125 10.977 16.7328 11.715 16.3534 12.632C15.9874 13.5165 16.4643 15.0262 15.7452 15.7452C15.0262 16.4643 13.5165 15.9874 12.632 16.3534C11.715 16.7328 10.9769 18.125 9.99997 18.125C9.02301 18.125 8.285 16.7328 7.36803 16.3534C6.48346 15.9874 4.97382 16.4643 4.25476 15.7452Z"
            fill="#0D99FF"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.4375 8.125L8.85414 12.5L6.5625 10.3125"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "diem-danh":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 12.5C12.7614 12.5 15 10.2614 15 7.5C15 4.73858 12.7614 2.5 10 2.5C7.23858 2.5 5 4.73858 5 7.5C5 10.2614 7.23858 12.5 10 12.5Z"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M2.4209 16.8743C3.1893 15.5442 4.29419 14.4398 5.62456 13.672C6.95493 12.9042 8.46393 12.5 9.99997 12.5C11.536 12.5 13.045 12.9043 14.3754 13.6721"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18 14L14 18L12 16.0001"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "gear":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 13.75C12.0711 13.75 13.75 12.0711 13.75 10C13.75 7.92893 12.0711 6.25 10 6.25C7.92893 6.25 6.25 7.92893 6.25 10C6.25 12.0711 7.92893 13.75 10 13.75Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.59963 3.44993L8.12545 2.34462C8.04635 2.28512 7.95425 2.24527 7.85673 2.22835C7.75921 2.21143 7.65906 2.21793 7.56455 2.2473C7.10798 2.39028 6.66502 2.57355 6.24091 2.79495C6.15311 2.841 6.07753 2.90727 6.02039 2.98829C5.96325 3.06931 5.9262 3.16276 5.9123 3.26092L5.6517 5.08521C5.55236 5.17326 5.45511 5.26485 5.35994 5.35996C5.26481 5.4551 5.1732 5.55237 5.08513 5.65179L5.08509 5.65182L3.26112 5.91265C3.16312 5.92651 3.06981 5.96346 2.98889 6.02045C2.90797 6.07744 2.84175 6.15285 2.79569 6.24046C2.57395 6.6644 2.39032 7.10721 2.24698 7.56366C2.21746 7.6583 2.21088 7.75861 2.22777 7.8563C2.24465 7.95399 2.28453 8.04627 2.34411 8.12551L3.4498 9.59975C3.44182 9.73225 3.43782 9.86578 3.43778 10.0003C3.43778 10.1349 3.44179 10.2684 3.44981 10.401L3.4498 10.4011L2.3445 11.8752C2.285 11.9543 2.24514 12.0464 2.22822 12.144C2.21131 12.2415 2.2178 12.3416 2.24718 12.4361C2.39016 12.8927 2.57343 13.3357 2.79483 13.7598C2.84088 13.8476 2.90715 13.9232 2.98817 13.9803C3.06919 14.0374 3.16264 14.0745 3.2608 14.0884L5.08509 14.349C5.17314 14.4483 5.26472 14.5456 5.35983 14.6407C5.45497 14.7359 5.55225 14.8275 5.65166 14.9156L5.65169 14.9156L5.91253 16.7396C5.92638 16.8376 5.96333 16.9309 6.02032 17.0118C6.07732 17.0927 6.15273 17.1589 6.24033 17.205C6.66427 17.4267 7.10708 17.6104 7.56353 17.7537C7.65818 17.7832 7.75848 17.7898 7.85617 17.7729C7.95387 17.756 8.04614 17.7161 8.12538 17.6566L9.59962 16.5509C9.73213 16.5589 9.86565 16.5629 10.0002 16.5629C10.1347 16.5629 10.2683 16.5589 10.4009 16.5509L10.4009 16.5509L11.8751 17.6562C11.9542 17.7157 12.0463 17.7555 12.1438 17.7725C12.2413 17.7894 12.3415 17.7829 12.436 17.7535C12.8926 17.6105 13.3355 17.4273 13.7596 17.2059C13.8474 17.1598 13.923 17.0935 13.9802 17.0125C14.0373 16.9315 14.0744 16.838 14.0883 16.7399L14.3489 14.9156C14.4482 14.8275 14.5454 14.736 14.6406 14.6408C14.7357 14.5457 14.8274 14.4484 14.9154 14.349L14.9155 14.349L16.7394 14.0881C16.8374 14.0743 16.9307 14.0373 17.0117 13.9804C17.0926 13.9234 17.1588 13.848 17.2049 13.7603C17.4266 13.3364 17.6102 12.8936 17.7536 12.4371C17.7831 12.3425 17.7897 12.2422 17.7728 12.1445C17.7559 12.0468 17.716 11.9545 17.6564 11.8753L16.5508 10.4011C16.5587 10.2686 16.5627 10.135 16.5628 10.0005C16.5628 9.86594 16.5588 9.73238 16.5507 9.5998L16.5508 9.59975L17.6561 8.12557C17.7156 8.04647 17.7554 7.95437 17.7723 7.85685C17.7893 7.75933 17.7828 7.65918 17.7534 7.56467C17.6104 7.1081 17.4271 6.66515 17.2057 6.24103C17.1597 6.15323 17.0934 6.07765 17.0124 6.02051C16.9314 5.96338 16.8379 5.92633 16.7398 5.91242L14.9155 5.65182C14.8274 5.55248 14.7358 5.45523 14.6407 5.36007C14.5456 5.26493 14.4483 5.17332 14.3489 5.08525L14.3489 5.08521L14.088 3.26124C14.0742 3.16324 14.0372 3.06993 13.9802 2.98901C13.9232 2.90809 13.8478 2.84187 13.7602 2.79581C13.3363 2.57407 12.8935 2.39044 12.437 2.2471C12.3424 2.21759 12.2421 2.211 12.1444 2.22789C12.0467 2.24478 11.9544 2.28466 11.8752 2.34423L10.4009 3.44993C10.2684 3.44195 10.1349 3.43794 10.0004 3.4379C9.86581 3.4379 9.73225 3.44191 9.59968 3.44993L9.59963 3.44993Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "white-down":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.76668 7.7418L10 10.9751L13.2333 7.7418C13.5583 7.4168 14.0834 7.4168 14.4083 7.7418C14.7333 8.0668 14.7333 8.5918 14.4083 8.9168L10.5833 12.7418C10.2583 13.0668 9.73335 13.0668 9.40835 12.7418L5.58335 8.9168C5.25835 8.5918 5.25835 8.0668 5.58335 7.7418C5.90835 7.42513 6.44168 7.4168 6.76668 7.7418Z"
            fill="white"
          />
        </svg>
      )
      break
    case "icon-statistic":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_184_10368)">
            <path
              d="M3.4375 17.2496V13.5137H7.8125"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.8125 17.25H2.1875"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.8125 17.25V11.0234H12.1875"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.5625 8.5332H12.1875V17.2504H16.5625V8.5332Z"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.04779 11.2575C6.12347 9.2211 9.23522 7.0368 12.5 3.5"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M13.9071 5.15438L13.5752 2.04705L10.4679 2.37891"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_184_10368">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "logo-icon":
      iconElement = (
        <svg
          width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_184_10359)">
            <path
              d="M11.6067 7.48552V2.6465H18.714C18.714 9.18674 18.714 -7.22058 18.714 13.9123C18.1847 14.2904 17.8445 14.8953 17.8823 15.6136C18.0335 18.0709 21.7384 17.9953 21.7384 15.5002C21.7384 14.8575 21.3981 14.2526 20.9067 13.9123C20.9067 11.077 20.9067 3.25138 20.9067 0.416016C18.2603 0.416016 13.1945 0.416016 9.37618 0.416016C9.33837 0.416016 9.37618 7.52333 9.37618 7.48552C9.37618 8.95991 11.6067 8.92211 11.6067 7.48552Z"
              fill="white"
            />
            <path
              d="M7.14568 19.0168H2.30666V11.9095C10.4347 11.9095 8.27982 11.9095 13.5725 11.9095C14.631 13.4217 17.0128 12.7034 17.0884 10.8888C17.164 8.96073 14.6688 8.12903 13.5725 9.71683C10.8506 9.71683 2.79812 9.71683 0.0761719 9.71683V21.2473C0.0761719 21.2851 7.18348 21.2473 7.14568 21.2473C8.65787 21.2095 8.62007 19.0168 7.14568 19.0168Z"
              fill="white"
            />
            <path
              d="M22.0409 10.8134C22.0409 12.2878 23.5153 11.9098 28.0141 11.9098V19.0171C21.4738 19.0171 37.8811 19.0171 16.7482 19.0171C16.3702 18.4878 15.7653 18.1476 15.047 18.1854C12.5897 18.3366 12.6653 22.0415 15.1604 22.0415C15.8031 22.0415 16.408 21.7012 16.7482 21.2098C30.736 21.2098 30.2445 21.2476 30.2445 21.2098V9.67928C23.2506 9.71708 22.0409 9.33903 22.0409 10.8134Z"
              fill="white"
            />
            <path
              d="M18.714 28.317H11.6067C11.6067 10.3219 11.6067 34.9707 11.6067 17.0512C12.1359 16.6731 12.4762 16.0683 12.4384 15.35C12.2871 12.8926 8.58228 12.9683 8.58228 15.4634C8.58228 16.1061 8.92251 16.7109 9.41398 17.0512C9.41398 24.6122 9.41398 22.9865 9.41398 30.5475C12.0603 30.5475 17.1262 30.5475 20.9445 30.5475C20.9823 30.5475 20.9445 23.4402 20.9445 23.478C20.9445 22.2305 19.5457 22.3817 19.8481 22.3817C18.3359 22.3439 18.714 23.8183 18.714 28.317Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_184_10359">
              <rect width="30.2439" height="30.2439" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "export-kq":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.71875 8.59473L10 11.8751L13.2812 8.59473"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 3.125V11.8727"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "printer-white":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 6.25V3.125H15V6.25"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.999 11.875H4.99902V17.1875H14.999V11.875Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.99902 13.75H2.18652V7.5C2.18652 6.80964 2.7928 6.25 3.54069 6.25H16.4574C17.2052 6.25 17.8115 6.80964 17.8115 7.5V13.75H14.999"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.6875 10C15.2053 10 15.625 9.58027 15.625 9.0625C15.625 8.54473 15.2053 8.125 14.6875 8.125C14.1697 8.125 13.75 8.54473 13.75 9.0625C13.75 9.58027 14.1697 10 14.6875 10Z"
            fill="white"
          />
        </svg>
      )
      break
    case "printer":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 6.25V3.125H15V6.25"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.999 11.875H4.99902V17.1875H14.999V11.875Z"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.99902 13.75H2.18652V7.5C2.18652 6.80964 2.7928 6.25 3.54069 6.25H16.4574C17.2052 6.25 17.8115 6.80964 17.8115 7.5V13.75H14.999"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.5625 9.0625C15.5625 9.54575 15.1707 9.9375 14.6875 9.9375C14.2043 9.9375 13.8125 9.54575 13.8125 9.0625C13.8125 8.57925 14.2043 8.1875 14.6875 8.1875C15.1707 8.1875 15.5625 8.57925 15.5625 9.0625Z"
            fill="#2260BD"
            stroke="#2260BD"
            strokeWidth="0.125"
          />
        </svg>
      )
      break
    case "disease-history":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.875 10H4.375L7.5 3.125L12.5 16.25L15.625 10H18.125"
            stroke="#172B4D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "transfer":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.625 2.5L18.125 10L10.625 17.5V13.75H8.125V6.25H10.625V2.5Z"
            stroke="#00AEAC"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.125 13.75V6.25"
            stroke="#00AEAC"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.625 13.75V6.25"
            stroke="#00AEAC"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "chat-mess":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.54912 13.828C2.6173 12.2572 2.29097 10.4002 2.6314 8.60583C2.97184 6.81142 3.95563 5.203 5.39803 4.08261C6.84044 2.96222 8.64224 2.40692 10.4651 2.52099C12.2879 2.63506 14.0065 3.41065 15.2979 4.70212C16.5894 5.99359 17.365 7.71211 17.4791 9.53496C17.5932 11.3578 17.0379 13.1596 15.9175 14.602C14.7971 16.0444 13.1887 17.0282 11.3943 17.3687C9.59988 17.7091 7.74291 17.3828 6.17207 16.451L6.17209 16.4509L3.58173 17.191C3.47456 17.2216 3.36115 17.223 3.25325 17.1951C3.14536 17.1671 3.0469 17.1108 2.96809 17.032C2.88927 16.9532 2.83297 16.8547 2.80501 16.7468C2.77705 16.6389 2.77846 16.5255 2.80908 16.4184L3.54918 13.828L3.54912 13.828Z"
            stroke="#00AEAC"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "money-circle":
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="18" cy="18" r="18" fill="#E0F3F4" />
          <path
            d="M26.125 13H9.875C9.52982 13 9.25 13.2798 9.25 13.625V22.375C9.25 22.7202 9.52982 23 9.875 23H26.125C26.4702 23 26.75 22.7202 26.75 22.375V13.625C26.75 13.2798 26.4702 13 26.125 13Z"
            stroke="#00AEAC"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18 20.5C19.3807 20.5 20.5 19.3807 20.5 18C20.5 16.6193 19.3807 15.5 18 15.5C16.6193 15.5 15.5 16.6193 15.5 18C15.5 19.3807 16.6193 20.5 18 20.5Z"
            stroke="#00AEAC"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.75 13L26.75 17.375"
            stroke="#00AEAC"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.75 23L26.75 18.625"
            stroke="#00AEAC"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.25 13L9.25 17.375"
            stroke="#00AEAC"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.25 23L9.25 18.625"
            stroke="#00AEAC"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "user-circle":
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="18" cy="18" r="18" fill="#E3F3FE" />
          <path
            d="M14.875 19.5C17.1187 19.5 18.9375 17.6812 18.9375 15.4375C18.9375 13.1938 17.1187 11.375 14.875 11.375C12.6313 11.375 10.8125 13.1938 10.8125 15.4375C10.8125 17.6812 12.6313 19.5 14.875 19.5Z"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M20.1416 11.5263C20.7004 11.3688 21.2864 11.333 21.8602 11.4211C22.434 11.5092 22.9822 11.7193 23.468 12.0371C23.9538 12.355 24.3658 12.7732 24.6763 13.2637C24.9868 13.7542 25.1886 14.3055 25.2681 14.8806C25.3476 15.4557 25.303 16.0411 25.1372 16.5974C24.9714 17.1537 24.6883 17.6681 24.307 18.1058C23.9256 18.5435 23.4549 18.8944 22.9266 19.1349C22.3982 19.3754 21.8244 19.4999 21.2439 19.5"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.25 22.4216C9.88448 21.5191 10.7268 20.7825 11.7058 20.274C12.6849 19.7655 13.7719 19.5 14.8751 19.5C15.9783 19.5 17.0653 19.7654 18.0444 20.2738C19.0234 20.7822 19.8658 21.5187 20.5004 22.4212"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.2441 19.5C22.3475 19.4992 23.4347 19.7643 24.4139 20.2728C25.393 20.7813 26.2352 21.5182 26.8692 22.4212"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "send":
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="36" height="36" rx="4" fill="#0D99FF" />
          <path
            d="M24.4263 10.8028L9.8694 14.9085C9.74694 14.9431 9.63793 15.0142 9.55696 15.1123C9.47598 15.2105 9.42689 15.331 9.41625 15.4578C9.40561 15.5846 9.43392 15.7116 9.49741 15.8219C9.56089 15.9322 9.65652 16.0204 9.77151 16.0749L16.4599 19.2431C16.5903 19.3049 16.6953 19.4099 16.7571 19.5404L19.9253 26.2287C19.9798 26.3437 20.068 26.4393 20.1783 26.5028C20.2886 26.5663 20.4156 26.5946 20.5424 26.584C20.6692 26.5733 20.7897 26.5242 20.8879 26.4433C20.986 26.3623 21.0571 26.2533 21.0917 26.1308L25.1974 11.574C25.2276 11.467 25.2287 11.354 25.2007 11.2465C25.1726 11.139 25.1164 11.0409 25.0379 10.9624C24.9593 10.8838 24.8612 10.8276 24.7537 10.7995C24.6462 10.7715 24.5332 10.7726 24.4263 10.8028Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.6611 19.3388L20.1967 15.8032"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "building":
      iconElement = (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 6.33333V3H1.66669V18H18.3334V6.33333H10ZM5.00002 16.3333H3.33335V14.6667H5.00002V16.3333ZM5.00002 13H3.33335V11.3333H5.00002V13ZM5.00002 9.66667H3.33335V8H5.00002V9.66667ZM5.00002 6.33333H3.33335V4.66667H5.00002V6.33333ZM8.33335 16.3333H6.66669V14.6667H8.33335V16.3333ZM8.33335 13H6.66669V11.3333H8.33335V13ZM8.33335 9.66667H6.66669V8H8.33335V9.66667ZM8.33335 6.33333H6.66669V4.66667H8.33335V6.33333ZM16.6667 16.3333H10V14.6667H11.6667V13H10V11.3333H11.6667V9.66667H10V8H16.6667V16.3333ZM15 9.66667H13.3334V11.3333H15V9.66667ZM15 13H13.3334V14.6667H15V13Z"
            fill="black"
            fillOpacity="0.54"
          />
        </svg>
      )
      break
    case "examination":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.875 5.625H3.125C2.77982 5.625 2.5 5.90482 2.5 6.25V16.25C2.5 16.5952 2.77982 16.875 3.125 16.875H16.875C17.2202 16.875 17.5 16.5952 17.5 16.25V6.25C17.5 5.90482 17.2202 5.625 16.875 5.625Z"
            stroke="#BBBBBB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.125 5.625V4.375C13.125 4.04348 12.9933 3.72554 12.7589 3.49112C12.5245 3.2567 12.2065 3.125 11.875 3.125H8.125C7.79348 3.125 7.47554 3.2567 7.24112 3.49112C7.0067 3.72554 6.875 4.04348 6.875 4.375V5.625"
            stroke="#BBBBBB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 9.0625V13.4375"
            stroke="#BBBBBB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.1875 11.25H7.8125"
            stroke="#BBBBBB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    // case "export":
    //   iconElement = (
    //     <svg
    //       width="20"
    //       height="20"
    //       viewBox="0 0 20 20"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         d="M6.71875 8.59473L10 11.8751L13.2812 8.59473"
    //         stroke="#00AEAC"
    //         strokeWidth="2"
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //       />
    //       <path
    //         d="M10 3.125V11.8727"
    //         stroke="#00AEAC"
    //         strokeWidth="2"
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //       />
    //       <path
    //         d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
    //         stroke="#00AEAC"
    //         strokeWidth="2"
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //       />
    //     </svg>
    //   )
    //   break
    case "cancel-video":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.00065 1.3335C4.31398 1.3335 1.33398 4.3135 1.33398 8.00016C1.33398 11.6868 4.31398 14.6668 8.00065 14.6668C11.6873 14.6668 14.6673 11.6868 14.6673 8.00016C14.6673 4.3135 11.6873 1.3335 8.00065 1.3335ZM10.8673 10.8668C10.6073 11.1268 10.1873 11.1268 9.92732 10.8668L8.00065 8.94016L6.07398 10.8668C5.81398 11.1268 5.39398 11.1268 5.13398 10.8668C4.87398 10.6068 4.87398 10.1868 5.13398 9.92683L7.06065 8.00016L5.13398 6.0735C4.87398 5.8135 4.87398 5.3935 5.13398 5.1335C5.39398 4.8735 5.81398 4.8735 6.07398 5.1335L8.00065 7.06016L9.92732 5.1335C10.1873 4.8735 10.6073 4.8735 10.8673 5.1335C11.1273 5.3935 11.1273 5.8135 10.8673 6.0735L8.94065 8.00016L10.8673 9.92683C11.1207 10.1802 11.1207 10.6068 10.8673 10.8668Z"
            fill="#ED1117"
          />
        </svg>
      )
      break
    case "cancel":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
            stroke="#FF4648"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M12.5 7.5L7.5 12.5"
            stroke="#FF4648"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.5 12.5L7.5 7.5"
            stroke="#FF4648"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "recall":
      iconElement = (
        <svg
          width="17"
          height="19"
          viewBox="0 0 17 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.00006 3.00052V1.21052C9.00006 0.760519 8.46006 0.540519 8.15006 0.860519L5.35006 3.65052C5.15006 3.85052 5.15006 4.16052 5.35006 4.36052L8.14006 7.15052C8.46006 7.46052 9.00006 7.24052 9.00006 6.79052V5.00052C12.3101 5.00052 15.0001 7.69052 15.0001 11.0005C15.0001 13.7205 13.1701 16.0205 10.6901 16.7505C10.2701 16.8705 10.0001 17.2705 10.0001 17.7005C10.0001 18.3505 10.6201 18.8605 11.2501 18.6705C12.909 18.1858 14.3661 17.1763 15.4029 15.7935C16.4396 14.4106 17 12.7288 17.0001 11.0005C17.0001 6.58052 13.4201 3.00052 9.00006 3.00052ZM3.00006 11.0005C3.00006 9.66052 3.44006 8.42052 4.19006 7.41052C4.49006 7.01052 4.45006 6.46052 4.10006 6.10052C3.68006 5.68052 2.96006 5.72052 2.60006 6.20052C1.82403 7.23368 1.31011 8.43962 1.10237 9.71496C0.894623 10.9903 0.999247 12.297 1.40727 13.523C1.81529 14.7491 2.51455 15.8579 3.44508 16.7544C4.37562 17.6509 5.50968 18.3084 6.75006 18.6705C7.38006 18.8605 8.00006 18.3505 8.00006 17.7005C8.00006 17.2705 7.73006 16.8705 7.31006 16.7505C4.83006 16.0205 3.00006 13.7205 3.00006 11.0005Z"
            fill="#FFA800"
          />
        </svg>
      )
      break
    case "checks":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.5625 6.5625L4.6875 13.4375L1.25 10.0002"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.7498 6.5625L11.8748 13.4375L10.0488 11.6116"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "check-circle":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.4375 8.125L8.85414 12.5L6.5625 10.3125"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "check-square":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.4375 11.1932V4.0625C3.4375 3.89674 3.50335 3.73777 3.62056 3.62056C3.73777 3.50335 3.89674 3.4375 4.0625 3.4375H15.9375C16.1033 3.4375 16.2622 3.50335 16.3794 3.62056C16.4967 3.73777 16.5625 3.89674 16.5625 4.0625V15.9375C16.5625 16.1033 16.4967 16.2622 16.3794 16.3794C16.2622 16.4967 16.1033 16.5625 15.9375 16.5625H10.5966"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 11.875L5 16.875L2.5 14.375"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "plus-circle":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M6.875 10H13.125"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 6.875V13.125"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "time-discount":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M10 10H14.375"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.0936 13.0936L10 10"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "csyt":
      iconElement = (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.25 17.3738H18.75"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.25 17.3735V3.62354C11.25 3.45777 11.1842 3.2988 11.0669 3.18159C10.9497 3.06438 10.7908 2.99854 10.625 2.99854H3.125C2.95924 2.99854 2.80027 3.06438 2.68306 3.18159C2.56585 3.2988 2.5 3.45777 2.5 3.62354V17.3735"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 17.3735V8.62354C17.5 8.45777 17.4342 8.2988 17.3169 8.18159C17.1997 8.06438 17.0408 7.99854 16.875 7.99854H11.25"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 6.12354H7.5"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.25 11.1235H8.75"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 14.2485H7.5"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.75 14.2485H15"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.75 11.1235H15"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "warning-import":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 9.75V13.5"
            stroke="#FEC328"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.7018 3.74857L2.45402 17.9978C2.32204 18.2258 2.25245 18.4846 2.25223 18.748C2.25201 19.0115 2.32118 19.2703 2.45278 19.4986C2.58437 19.7268 2.77376 19.9163 3.00187 20.0481C3.22999 20.1799 3.48879 20.2493 3.75223 20.2493H20.2478C20.5112 20.2493 20.77 20.1799 20.9981 20.0481C21.2263 19.9163 21.4156 19.7268 21.5472 19.4986C21.6788 19.2703 21.748 19.0115 21.7478 18.748C21.7476 18.4846 21.678 18.2258 21.546 17.9978L13.2982 3.74857C13.1664 3.52093 12.9771 3.33193 12.7493 3.20055C12.5214 3.06916 12.263 3 12 3C11.737 3 11.4786 3.06916 11.2507 3.20055C11.0229 3.33193 10.8336 3.52093 10.7018 3.74857V3.74857Z"
            stroke="#FEC328"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 18C12.6213 18 13.125 17.4963 13.125 16.875C13.125 16.2537 12.6213 15.75 12 15.75C11.3787 15.75 10.875 16.2537 10.875 16.875C10.875 17.4963 11.3787 18 12 18Z"
            fill="#FEC328"
          />
        </svg>
      )
      break
    case "quanlysuckhoe":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 11.875H12.5"
            stroke="#BBBBBB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.5 9.375H12.5"
            stroke="#BBBBBB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.5002 3.125H15.625C15.7908 3.125 15.9497 3.19085 16.0669 3.30806C16.1842 3.42527 16.25 3.58424 16.25 3.75V16.875C16.25 17.0408 16.1842 17.1997 16.0669 17.3169C15.9497 17.4342 15.7908 17.5 15.625 17.5H4.375C4.20924 17.5 4.05027 17.4342 3.93306 17.3169C3.81585 17.1997 3.75 17.0408 3.75 16.875V3.75C3.75 3.58424 3.81585 3.42527 3.93306 3.30806C4.05027 3.19085 4.20924 3.125 4.375 3.125H7.49983"
            stroke="#BBBBBB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.875 5.625V5C6.875 4.1712 7.20424 3.37634 7.79029 2.79029C8.37634 2.20424 9.1712 1.875 10 1.875C10.8288 1.875 11.6237 2.20424 12.2097 2.79029C12.7958 3.37634 13.125 4.1712 13.125 5V5.625H6.875Z"
            stroke="#BBBBBB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "cauhinhdichvu":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.25 16.25V3.75C16.25 3.05964 15.6904 2.5 15 2.5L5 2.5C4.30964 2.5 3.75 3.05964 3.75 3.75V16.25C3.75 16.9404 4.30964 17.5 5 17.5H15C15.6904 17.5 16.25 16.9404 16.25 16.25Z"
            stroke="#BBBBBB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.5 5H12.5"
            stroke="#BBBBBB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "quanlychung":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 13.125C10.6066 13.125 13.125 10.6066 13.125 7.5C13.125 4.3934 10.6066 1.875 7.5 1.875C4.3934 1.875 1.875 4.3934 1.875 7.5C1.875 10.6066 4.3934 13.125 7.5 13.125Z"
            stroke="#BBBBBB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.5 18.125C15.6066 18.125 18.125 15.6066 18.125 12.5C18.125 9.3934 15.6066 6.875 12.5 6.875C9.3934 6.875 6.875 9.3934 6.875 12.5C6.875 15.6066 9.3934 18.125 12.5 18.125Z"
            stroke="#BBBBBB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.57166 7.69727L12.3035 10.4291"
            stroke="#BBBBBB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.69653 9.57227L10.4284 12.3041"
            stroke="#BBBBBB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "management-skdn":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 12C17.88 12 18.99 10.88 18.99 9.5C18.99 8.12 17.88 7 16.5 7C15.12 7 14 8.12 14 9.5C14 10.88 15.12 12 16.5 12ZM9 11C10.66 11 11.99 9.66 11.99 8C11.99 6.34 10.66 5 9 5C7.34 5 6 6.34 6 8C6 9.66 7.34 11 9 11ZM16.5 14C14.67 14 11 14.92 11 16.75V19H22V16.75C22 14.92 18.33 14 16.5 14ZM9 13C6.67 13 2 14.17 2 16.5V19H9V16.75C9 15.9 9.33 14.41 11.37 13.28C10.5 13.1 9.66 13 9 13Z"
            fill="black"
            fill-opacity="none"
          />
        </svg>
      )
      break
    case "pen-black":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667L2 11.5ZM3.94667 12.6667H3.33333V12.0533L9.37333 6.01333L9.98667 6.62667L3.94667 12.6667ZM13.8067 3.75333L12.2467 2.19333C12.1133 2.06 11.9467 2 11.7733 2C11.6 2 11.4333 2.06667 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333Z"
            fill="#222D4B"
          />
        </svg>
      )
      break
    case "pen-primary":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667L2 11.5ZM3.94667 12.6667H3.33333V12.0533L9.37333 6.01333L9.98667 6.62667L3.94667 12.6667ZM13.8067 3.75333L12.2467 2.19333C12.1133 2.06 11.9467 2 11.7733 2C11.6 2 11.4333 2.06667 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333Z"
            fill="#0D99FF"
          />
        </svg>
      )
      break
    case "upload-success":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
            fill="#0D99FF"
          />
        </svg>
      )
      break
    case "upload-green":
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5 24H22.5V15H28.5L18 4.5L7.5 15H13.5V24ZM18 8.745L21.255 12H19.5V21H16.5V12H14.745L18 8.745ZM7.5 27H28.5V30H7.5V27Z"
            fill="#00C968"
          />
        </svg>
      )
      break

    case "dot-border":
      iconElement = (
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="4" cy="4" r="3.5" fill="white" stroke="#222D4B" />
        </svg>
      )
      break
    case "plus-plus":
      iconElement = (
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.66634 5.66732H5.66634V9.66732H4.33301V5.66732H0.333008V4.33398H4.33301V0.333984H5.66634V4.33398H9.66634V5.66732Z"
            fill="#222D4B"
          />
        </svg>
      )
      break
    case "apart-apart":
      iconElement = (
        <svg
          width="10"
          height="2"
          viewBox="0 0 10 2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.66634 1.66732H0.333008V0.333984H9.66634V1.66732Z"
            fill="#222D4B"
          />
        </svg>
      )
      break

    case "rectangle-black":
      iconElement = (
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="8" height="8" fill="#222D4B" />
        </svg>
      )
      break
    case "square-square":
      iconElement = (
        <svg
          width="6"
          height="6"
          viewBox="0 0 6 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="5"
            height="5"
            fill="white"
            stroke="#C5CED9"
          />
        </svg>
      )
      break
    case "eraser":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_5168_17024)">
            <path
              d="M14.0205 6L21.0916 13.0711L13.1419 21.0208L6.99963 21.0208L2.99969 17.0208L14.0205 6Z"
              stroke="#626262"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path d="M9.5 11L14 6.5L20.5 13L16 17.5L9.5 11Z" fill="#626262" />
          </g>
          <defs>
            <clipPath id="clip0_5168_17024">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break

    case "edit-primary":
      iconElement = (
        <svg
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02V6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0V0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19V3.19Z"
            fill="#01638D"
          />
        </svg>
      )
      break
    case "edit-gray":
      iconElement = (
        <svg
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02V6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0V0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19V3.19Z"
            fill="#8e8e93"
          />
        </svg>
      )
      break
    case "white-upload":
      iconElement = (
        <svg
          width="14"
          height="17"
          viewBox="0 0 14 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 13H10V7H14L7 0L0 7H4V13ZM7 2.83L9.17 5H8V11H6V5H4.83L7 2.83ZM0 15H14V17H0V15Z"
            fill="white"
          />
        </svg>
      )
      break
    case "red-warning":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.00033 3.99398L13.0203 12.6673H2.98033L8.00033 3.99398ZM8.00033 1.33398L0.666992 14.0007H15.3337L8.00033 1.33398ZM8.66699 10.6673H7.33366V12.0007H8.66699V10.6673ZM8.66699 6.66732H7.33366V9.33398H8.66699V6.66732Z"
            fill="#E50500"
          />
        </svg>
      )
      break

    case "black-dot":
      iconElement = (
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="4" cy="4" r="4" fill="#222D4B" />
        </svg>
      )
      break

    case "expire-date-sign":
      iconElement = (
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_4831_16432)">
            <path
              d="M24.9992 11.1104C17.3604 11.1104 11.1104 17.3604 11.1104 24.9992C11.1104 32.6381 17.3604 38.8881 24.9992 38.8881C32.6381 38.8881 38.8881 32.6381 38.8881 24.9992C38.8881 17.3604 32.6381 11.1104 24.9992 11.1104ZM24.9992 36.1103C18.8742 36.1103 13.8881 31.1242 13.8881 24.9992C13.8881 18.8742 18.8742 13.8881 24.9992 13.8881C31.1242 13.8881 36.1103 18.8742 36.1103 24.9992C36.1103 31.1242 31.1242 36.1103 24.9992 36.1103ZM25.6937 18.0548H23.6103V26.3881L30.8326 30.8326L31.9437 29.027L25.6937 25.277V18.0548Z"
              fill="#E50500"
            />
          </g>
          <circle
            cx="25"
            cy="25"
            r="24.5"
            stroke="#E50500"
            strokeDasharray="5 5"
          />
          <defs>
            <clipPath id="clip0_4831_16432">
              <rect
                width="33.3333"
                height="33.3333"
                fill="white"
                transform="translate(8.33301 8.33301)"
              />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "zoom-in":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect opacity="0.5" width="24" height="24" rx="4" fill="#222D4B" />
          <path
            d="M15 3L17.3 5.3L14.41 8.17L15.83 9.59L18.7 6.7L21 9V3H15ZM3 9L5.3 6.7L8.17 9.59L9.59 8.17L6.7 5.3L9 3H3V9ZM9 21L6.7 18.7L9.59 15.83L8.17 14.41L5.3 17.3L3 15V21H9ZM21 15L18.7 17.3L15.83 14.41L14.41 15.83L17.3 18.7L15 21H21V15Z"
            fill="white"
          />
        </svg>
      )
      break
    case "zoom-out":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="24" height="24" rx="4" fill="#0D99FF" />
          <path
            d="M15 3L17.3 5.3L14.41 8.17L15.83 9.59L18.7 6.7L21 9V3H15ZM3 9L5.3 6.7L8.17 9.59L9.59 8.17L6.7 5.3L9 3H3V9ZM9 21L6.7 18.7L9.59 15.83L8.17 14.41L5.3 17.3L3 15V21H9ZM21 15L18.7 17.3L15.83 14.41L14.41 15.83L17.3 18.7L15 21H21V15Z"
            fill="white"
          />
        </svg>
      )
      break
    case "arrow-down-primary":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M7 10L12 15L17 10H7Z" fill={fill || "#0D99FF"} />
        </svg>
      )
      break

    case "arrow-up-primary":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M7 14L12 9L17 14H7Z" fill={fill || "#0D99FF"} />
        </svg>
      )
      break
    case "arrow-down-primary-black":
      iconElement = (
        <svg
          width="10"
          height="5"
          viewBox="0 0 10 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 0L5 5L10 0H0Z" fill="#323232" />
        </svg>
      )
      break
    case "arrow-up-primary-black":
      iconElement = (
        <svg
          width="10"
          height="5"
          viewBox="0 0 10 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 5L5 0L10 5H0Z" fill="#323232" />
        </svg>
      )
      break

    case "pin":
      iconElement = (
        <svg
          width="27"
          height="28"
          viewBox="0 0 27 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_4412_19837)">
            <path
              d="M18.6293 10.4433L14.658 19.1651C13.8948 20.8411 11.9191 21.5806 10.243 20.8174C8.56689 20.0542 7.82747 18.0785 8.59066 16.4024L12.9073 6.92223C13.3839 5.87562 14.6201 5.41297 15.6667 5.88953C16.7133 6.36609 17.1759 7.60228 16.6994 8.64889L13.0734 16.6122C12.8835 17.0294 12.3868 17.2152 11.9696 17.0253C11.5525 16.8354 11.3666 16.3387 11.5566 15.9216L14.8372 8.71664L13.6996 8.19864L10.4189 15.4036C9.94238 16.4502 10.405 17.6864 11.4516 18.1629C12.4983 18.6395 13.7344 18.1768 14.211 17.1302L17.837 9.16689C18.6002 7.4908 17.8608 5.5151 16.1847 4.75191C14.5086 3.98873 12.5329 4.72814 11.7697 6.40423L7.45304 15.8844C6.40323 18.19 7.41941 20.9052 9.72498 21.955C12.0306 23.0048 14.7458 21.9886 15.7956 19.6831L19.7669 10.9613L18.6293 10.4433Z"
              fill="#0D99FF"
            />
          </g>
          <defs>
            <clipPath id="clip0_4412_19837">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="translate(0.106445 18.9487) rotate(-65.5185)"
              />
            </clipPath>
          </defs>
        </svg>
      )
      break

    case "copyVBM":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM15 5H8C6.9 5 6.01 5.9 6.01 7L6 21C6 22.1 6.89 23 7.99 23H19C20.1 23 21 22.1 21 21V11L15 5ZM8 21V7H14V12H19V21H8Z"
            fill="#8E24AA"
          />
        </svg>
      )
      break
    case "emptySign":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 15H13V17H11V15ZM11 7H13V13H11V7ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
            fill="#E50500"
          />
        </svg>
      )
      break
    case "empty":
      iconElement = (
        <svg
          width="97"
          height="62"
          viewBox="0 0 97 62"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M48.5 61.9989C75.2858 61.9989 97 57.2596 97 51.4135C97 45.5674 75.2858 40.8281 48.5 40.8281C21.7142 40.8281 0 45.5674 0 51.4135C0 57.2596 21.7142 61.9989 48.5 61.9989Z"
            fill="#DCDCDC"
          />
          <path
            d="M83.3594 20.8082L67.9823 3.41315C67.2444 2.22824 66.1659 1.51172 65.0306 1.51172H31.9694C30.8341 1.51172 29.7556 2.22842 29.0177 3.41315L13.6406 20.8082L13.6406 34.78H83.3594V20.8082Z"
            stroke="#B3AAAA"
          />
          <path
            d="M63.0701 25.6029C63.0701 23.1749 64.5762 21.1703 66.4445 21.1699H83.3594V48.5968C83.3594 51.8054 81.3578 54.4382 78.8889 54.4382H18.1111C15.642 54.4382 13.6406 51.8052 13.6406 48.5968V21.1699H30.5555C32.4238 21.1699 33.9299 23.1703 33.9299 25.5983V25.6304C33.9299 28.0584 35.4531 30.0181 37.3214 30.0181H59.6786C61.5469 30.0181 63.0701 28.0404 63.0701 25.6123V25.6029Z"
            fill="#FAFAFA"
            stroke="#B3AAAA"
          />
        </svg>
      )
      break
    case "uploadVBMIcon":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.71875 6.40539L10 3.125L13.2812 6.40539"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 11.8747V3.12695"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "settingVBM":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.4308 12.98C19.4708 12.66 19.5008 12.34 19.5008 12C19.5008 11.66 19.4708 11.34 19.4308 11.02L21.5408 9.37C21.7308 9.22 21.7808 8.95 21.6608 8.73L19.6608 5.27C19.5708 5.11 19.4008 5.02 19.2208 5.02C19.1608 5.02 19.1008 5.03 19.0508 5.05L16.5608 6.05C16.0408 5.65 15.4808 5.32 14.8708 5.07L14.4908 2.42C14.4608 2.18 14.2508 2 14.0008 2H10.0008C9.75082 2 9.54082 2.18 9.51082 2.42L9.13082 5.07C8.52082 5.32 7.96082 5.66 7.44082 6.05L4.95082 5.05C4.89082 5.03 4.83082 5.02 4.77082 5.02C4.60082 5.02 4.43082 5.11 4.34082 5.27L2.34082 8.73C2.21082 8.95 2.27082 9.22 2.46082 9.37L4.57082 11.02C4.53082 11.34 4.50082 11.67 4.50082 12C4.50082 12.33 4.53082 12.66 4.57082 12.98L2.46082 14.63C2.27082 14.78 2.22082 15.05 2.34082 15.27L4.34082 18.73C4.43082 18.89 4.60082 18.98 4.78082 18.98C4.84082 18.98 4.90082 18.97 4.95082 18.95L7.44082 17.95C7.96082 18.35 8.52082 18.68 9.13082 18.93L9.51082 21.58C9.54082 21.82 9.75082 22 10.0008 22H14.0008C14.2508 22 14.4608 21.82 14.4908 21.58L14.8708 18.93C15.4808 18.68 16.0408 18.34 16.5608 17.95L19.0508 18.95C19.1108 18.97 19.1708 18.98 19.2308 18.98C19.4008 18.98 19.5708 18.89 19.6608 18.73L21.6608 15.27C21.7808 15.05 21.7308 14.78 21.5408 14.63L19.4308 12.98V12.98ZM17.4508 11.27C17.4908 11.58 17.5008 11.79 17.5008 12C17.5008 12.21 17.4808 12.43 17.4508 12.73L17.3108 13.86L18.2008 14.56L19.2808 15.4L18.5808 16.61L17.3108 16.1L16.2708 15.68L15.3708 16.36C14.9408 16.68 14.5308 16.92 14.1208 17.09L13.0608 17.52L12.9008 18.65L12.7008 20H11.3008L11.1108 18.65L10.9508 17.52L9.89082 17.09C9.46082 16.91 9.06082 16.68 8.66082 16.38L7.75082 15.68L6.69082 16.11L5.42082 16.62L4.72082 15.41L5.80082 14.57L6.69082 13.87L6.55082 12.74C6.52082 12.43 6.50082 12.2 6.50082 12C6.50082 11.8 6.52082 11.57 6.55082 11.27L6.69082 10.14L5.80082 9.44L4.72082 8.6L5.42082 7.39L6.69082 7.9L7.73082 8.32L8.63082 7.64C9.06082 7.32 9.47082 7.08 9.88082 6.91L10.9408 6.48L11.1008 5.35L11.3008 4H12.6908L12.8808 5.35L13.0408 6.48L14.1008 6.91C14.5308 7.09 14.9308 7.32 15.3308 7.62L16.2408 8.32L17.3008 7.89L18.5708 7.38L19.2708 8.59L18.2008 9.44L17.3108 10.14L17.4508 11.27ZM12.0008 8C9.79082 8 8.00082 9.79 8.00082 12C8.00082 14.21 9.79082 16 12.0008 16C14.2108 16 16.0008 14.21 16.0008 12C16.0008 9.79 14.2108 8 12.0008 8ZM12.0008 14C10.9008 14 10.0008 13.1 10.0008 12C10.0008 10.9 10.9008 10 12.0008 10C13.1008 10 14.0008 10.9 14.0008 12C14.0008 13.1 13.1008 14 12.0008 14Z"
            fill="#F57C00"
          />
        </svg>
      )
      break
    case "starOrange":
      iconElement = (
        <svg
          width="8"
          height="7"
          viewBox="0 0 8 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.99935 5.75797L6.05935 7.0013L5.51268 4.65797L7.33268 3.0813L4.93602 2.87797L3.99935 0.667969L3.06268 2.87797L0.666016 3.0813L2.48602 4.65797L1.93935 7.0013L3.99935 5.75797Z"
            fill="#F57C00"
          />
        </svg>
      )
      break
    case "logoHome":
      iconElement = (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.2496 9.34999V2.95H24.6496C24.6496 11.6 24.6496 -10.1 24.6496 17.85C23.9496 18.35 23.4996 19.15 23.5496 20.1C23.7496 23.35 28.6496 23.25 28.6496 19.95C28.6496 19.1 28.1996 18.3 27.5496 17.85C27.5496 14.1 27.5496 3.75 27.5496 0C24.0496 0 17.3496 0 12.2996 0C12.2496 0 12.2996 9.39999 12.2996 9.34999C12.2996 11.3 15.2496 11.25 15.2496 9.34999Z"
            fill="white"
          />
          <path
            d="M9.34999 24.6009H2.95V15.2009C13.7 15.2009 10.85 15.2009 17.85 15.2009C19.25 17.2009 22.4 16.2509 22.5 13.8509C22.6 11.3009 19.3 10.201 17.85 12.301C14.25 12.301 3.6 12.301 0 12.301V27.551C0 27.601 9.39999 27.551 9.34999 27.551C11.35 27.501 11.3 24.6009 9.34999 24.6009Z"
            fill="white"
          />
          <path
            d="M29.0501 13.7512C29.0501 15.7012 31.0001 15.2012 36.9501 15.2012V24.6012C28.3001 24.6012 50.0001 24.6012 22.0501 24.6012C21.5501 23.9012 20.7501 23.4512 19.8001 23.5012C16.5501 23.7012 16.6501 28.6012 19.9501 28.6012C20.8001 28.6012 21.6001 28.1512 22.0501 27.5012C40.5501 27.5012 39.9001 27.5512 39.9001 27.5012V12.2512C30.6501 12.3012 29.0501 11.8012 29.0501 13.7512Z"
            fill="white"
          />
          <path
            d="M24.65 36.9013H15.25C15.25 13.1013 15.25 45.7013 15.25 22.0013C15.95 21.5013 16.4 20.7013 16.35 19.7513C16.15 16.5013 11.25 16.6013 11.25 19.9013C11.25 20.7513 11.7 21.5513 12.35 22.0013C12.35 32.0013 12.35 29.8513 12.35 39.8513C15.85 39.8513 22.55 39.8513 27.6 39.8513C27.65 39.8513 27.6 30.4513 27.6 30.5013C27.6 28.8513 25.75 29.0513 26.15 29.0513C24.15 29.0013 24.65 30.9513 24.65 36.9013Z"
            fill="white"
          />
        </svg>
      )
      break
    case "writeVBM":
      iconElement = (
        <svg
          width="100"
          height="100"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="50" cy="50" r="49" stroke="#8E24AA" strokeWidth="2" />
          <path
            d="M54.2917 43.7917L56.2083 45.7083L37.3333 64.5833H35.4167V62.6667L54.2917 43.7917V43.7917ZM61.7917 31.25C61.2708 31.25 60.7292 31.4583 60.3333 31.8542L56.5208 35.6667L64.3333 43.4792L68.1458 39.6667C68.9583 38.8542 68.9583 37.5417 68.1458 36.7292L63.2708 31.8542C62.8542 31.4375 62.3333 31.25 61.7917 31.25V31.25ZM54.2917 37.8958L31.25 60.9375V68.75H39.0625L62.1042 45.7083L54.2917 37.8958V37.8958Z"
            fill="#8E24AA"
          />
        </svg>
      )
      break
    case "uploadVBM":
      iconElement = (
        <svg
          width="100"
          height="100"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="50" cy="50" r="49" stroke="#00C968" strokeWidth="2" />
          <path
            d="M43.7493 58.3333H56.2494V45.8333H64.5827L49.9993 31.25L35.416 45.8333H43.7493V58.3333ZM49.9993 37.1458L54.5202 41.6667H52.0827V54.1667H47.916V41.6667H45.4785L49.9993 37.1458ZM35.416 62.5H64.5827V66.6667H35.416V62.5Z"
            fill="#00C968"
          />
        </svg>
      )
      break
    case "sign":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 0H3C1.34325 0 0 1.34325 0 3V21C0 22.6568 1.34325 24 3 24H11.25V22.5H3C2.17387 22.5 1.5 21.8276 1.5 21V3C1.5 2.17237 2.17387 1.5 3 1.5H18C18.8276 1.5 19.5 2.17237 19.5 3V11.8183L21 10.3183V3C21 1.34325 19.6568 0 18 0Z"
            fill="#8E24AA"
          />
          <path
            d="M23.5605 13.5L22.5 12.4395C22.2069 12.1464 21.8233 12 21.4395 12C21.0557 12 20.6719 12.1464 20.379 12.4395L13.9395 18.879C13.6464 19.1721 12.7504 20.3049 12.75 20.6887L12 24L15.3105 23.25C15.3105 23.25 16.8281 22.3536 17.121 22.0605L23.5605 15.621C24.1464 15.0352 24.1464 14.0852 23.5605 13.5ZM16.5922 21.5287C16.5073 21.6094 16.2135 21.8078 15.8546 22.0363L13.9116 20.0933C14.1109 19.8201 14.3327 19.5454 14.4697 19.4092L19.3183 14.5607L21.4395 16.6819L16.5922 21.5287Z"
            fill="#8E24AA"
          />
          <path opacity="0.3" d="M16.5 6H4.5V4.5H16.5V6Z" fill="#8E24AA" />
          <path opacity="0.3" d="M16.5 9H4.5V7.5H16.5V9Z" fill="#8E24AA" />
          <path opacity="0.3" d="M16.5 12H4.5V10.5H16.5V12Z" fill="#8E24AA" />
          <path opacity="0.3" d="M10.5 15H4.5V13.5H10.5V15Z" fill="#8E24AA" />
        </svg>
      )
      break
    case "iconSigned":
      iconElement = (
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2210_12464)">
            <path
              d="M14.3242 8.95268C14.4809 8.97506 14.6376 9.01982 14.8166 9.06458L15.1747 9.98222L15.6223 9.15411C15.9357 9.15411 16.249 9.17649 16.5624 9.17649L15.9581 8.39314C15.9804 8.326 16.0028 8.25885 16.0252 8.19171C15.9581 8.16933 15.8909 8.14695 15.7566 8.10219C15.9581 7.90075 16.0476 7.81123 16.1595 7.85599C16.2043 7.74408 16.249 7.60979 16.2938 7.49789C15.9804 7.58741 15.6671 7.7217 15.3538 7.83361C15.1747 7.69932 14.9957 7.58741 14.8166 7.45312C14.8166 7.60979 14.839 7.78885 14.7718 7.99028C14.6823 7.78885 14.6152 7.63218 14.548 7.52027C14.5704 7.76646 14.5704 8.03504 14.5928 8.28124C14.5704 8.30362 14.5257 8.326 14.5033 8.37076C14.5928 8.37076 14.6823 8.37076 14.7942 8.37076C14.7942 8.66172 14.6823 8.84077 14.3242 8.95268Z"
              fill="#00C968"
            />
            <path
              d="M13.8545 8.86288C13.8993 8.86288 13.944 8.88527 13.9888 8.88527C13.9888 8.8405 13.9888 8.79574 13.9888 8.75098C13.9216 8.79574 13.8993 8.81812 13.8545 8.86288Z"
              fill="#00C968"
            />
            <path
              d="M20.1208 5.93097C19.9194 5.68477 19.6956 5.43858 19.4718 5.19238C19.4046 5.5281 19.3375 5.84144 19.2927 6.17716L18.8451 6.3786L18.3975 6.60241C18.7108 6.7367 19.0018 6.87099 19.2927 7.02766L19.427 7.99006L20.0761 7.31861C20.3894 7.38576 20.6804 7.49766 20.9713 7.58719L20.5908 6.69193C20.7699 6.42336 20.9489 6.1324 21.128 5.86382C20.7923 5.86382 20.4565 5.90859 20.1208 5.93097Z"
              fill="#00C968"
            />
            <path
              d="M10.9897 12.1309L11.5716 12.9142C11.6387 12.6009 11.7283 12.3099 11.8178 11.9966C12.1087 11.907 12.4445 11.8623 12.7354 11.7951L11.9521 11.1908C11.9744 10.8775 11.9968 10.5418 12.0416 10.2061C11.7506 10.3851 11.4821 10.5865 11.2135 10.7656C10.9001 10.6537 10.5868 10.5418 10.2735 10.4299C10.363 10.7432 10.4749 11.0565 10.5868 11.3699C10.3854 11.6385 10.1839 11.907 10.0049 12.1756C10.3406 12.1756 10.6539 12.1532 10.9897 12.1309Z"
              fill="#00C968"
            />
            <path
              d="M18.1292 35.8776C18.1515 35.6538 18.1292 35.5867 17.9053 35.4748C17.5696 35.3181 17.9501 35.139 18.0396 34.9824C17.9501 34.8929 17.9053 34.8257 17.7934 34.6914C18.0396 34.5795 18.2635 34.4676 18.5096 34.3333C18.6216 34.7138 18.7111 35.0271 18.8006 35.3629C19.2706 35.3629 19.4273 35.721 19.6287 36.1462C19.2259 36.0567 19.3154 35.9672 19.1587 36.4595L22.8293 38.5858C22.8069 38.4291 22.8516 38.2948 23.0083 38.2724C23.0978 38.2501 23.2097 38.2948 23.2769 38.3396L25.1122 35.1614C25.0674 35.1614 25.045 35.1838 25.0002 35.1838C24.9555 35.1838 24.9107 35.0719 24.9107 35.0495C24.9331 35.0048 25.0002 34.96 25.1122 34.8928C25.1345 34.96 25.1569 35.0048 25.1793 35.0495L25.9403 33.7514C25.8507 33.729 25.7388 33.7066 25.5598 33.6395C25.7388 33.5723 25.9179 33.4828 26.0969 33.5052L26.6788 32.4757C26.5893 32.5204 26.4998 32.5652 26.3655 32.5876C26.1193 31.9161 26.3431 31.5804 27.0817 31.5804C27.0593 31.6923 27.0369 31.7818 27.0146 31.8937L30.797 25.3584C30.7523 25.4031 30.7299 25.4255 30.6627 25.4703C30.6851 25.1346 30.7075 24.9331 30.9985 25.0003L33.4828 20.7031C33.4604 20.6583 33.4156 20.5688 33.3709 20.4792C33.438 20.4792 33.5276 20.4792 33.5947 20.5016L37.1533 14.3244L30.5508 10.5195L20.3002 28.2903L13.7872 24.5303L9.95996 31.1552L18.1292 35.8776Z"
              fill="#00C968"
            />
            <path
              d="M0 25.0001C0 25.0896 0 25.1567 0 25.2463C0.0447628 25.2239 0.0895255 25.2015 0.179051 25.2015C0.201432 25.2015 0.290958 25.3134 0.268577 25.3134C0.201432 25.4029 0.15667 25.5148 0.0671442 25.5596C0.0447628 25.5596 0.0223814 25.582 0 25.582C0.0223814 26.9025 0.15667 28.2006 0.402865 29.4764C0.470009 29.4316 0.514772 29.3644 0.559535 29.2749C0.626679 29.1406 0.895255 29.0959 1.09669 29.0063C1.16383 28.6035 0.738586 28.7154 0.581916 28.5363C0.49239 28.2006 0.425246 27.8649 0.290958 27.3725C0.760967 27.7082 0.984781 28.1335 1.38765 28.3349C1.49955 28.3797 1.61146 28.4468 1.72337 28.514C1.70099 28.2901 1.65622 28.0887 1.63384 27.8649C1.41003 27.932 1.20859 27.9768 1.00716 27.753C0.581916 27.2606 0.783348 26.7906 0.80573 26.6339C1.09669 26.522 1.3205 26.4772 1.49955 26.5444C1.47717 26.3206 1.47717 26.0968 1.45479 25.8506C1.41003 25.8506 1.38765 25.8282 1.34288 25.8282C1.09669 25.7163 1.25336 25.582 1.36526 25.4029C1.38765 25.4253 1.41003 25.4477 1.43241 25.4701C1.38765 23.6124 1.5667 21.7772 1.96956 20.009C1.79051 19.8524 1.74575 19.7181 1.79051 19.5614C1.83527 19.4271 1.9248 19.36 2.12623 19.3824C3.9615 11.9517 9.35542 5.61781 16.8979 2.8649C16.8308 2.79775 16.7637 2.73061 16.6741 2.66346C16.8532 2.6187 16.9651 2.57394 17.1441 2.52918C17.1218 2.6187 17.1218 2.70823 17.1218 2.79775C17.547 2.64108 17.9946 2.50679 18.4423 2.37251C18.3751 2.17107 18.2856 1.94726 18.1961 1.67868C18.4199 1.74583 19.3151 1.85773 19.0913 2.19345C22.5381 1.2982 26.0295 1.20867 29.3196 1.83535C29.2972 1.81297 29.2972 1.81297 29.2748 1.79059C29.7225 1.67868 29.7672 1.6563 29.9687 1.96964C30.5058 2.08155 31.0206 2.21584 31.5354 2.37251C31.5577 2.35012 31.5801 2.30536 31.6249 2.2606C31.6473 2.32774 31.6697 2.37251 31.692 2.41727C34.333 3.20062 36.795 4.43159 39.0107 6.06543C39.0107 5.99829 39.0107 5.90876 38.9884 5.75209C39.4136 5.95353 39.3689 5.81924 39.2569 6.2221C39.2346 6.2221 39.2122 6.19972 39.1898 6.19972C43.2408 9.24359 46.3518 13.6303 47.7619 18.89C51.1191 31.4235 43.6437 44.3824 31.1101 47.7396C29.8568 48.0753 28.6034 48.2991 27.3277 48.4334C27.4172 48.5677 27.5515 48.6796 27.5739 48.8139C27.6634 49.3734 27.2381 49.4182 26.6338 49.6867C26.88 49.2167 27.0591 48.8362 27.2605 48.4334C26.0072 48.5453 24.7314 48.5677 23.5005 48.5005C23.6124 48.6348 23.6571 48.702 23.5676 48.9929C23.5676 49.0153 23.3885 49.0153 23.3662 48.9929C23.2319 48.7691 23.3214 48.6124 23.3885 48.5005C23.12 48.4781 22.8514 48.4558 22.5828 48.4334V48.4558C22.4933 48.4558 22.4261 48.4334 22.3814 48.411C20.9937 48.2543 19.6061 47.9634 18.2856 47.5605C18.5765 47.9186 18.487 48.0305 17.9499 48.3439C17.9722 48.1648 18.0618 47.9634 18.017 47.8738C17.9275 47.7172 17.9499 47.6053 18.017 47.4934C16.2936 46.9562 14.6374 46.2176 13.0931 45.3C12.8022 45.3 12.735 45.3 12.6679 45.0538C12.4888 44.9419 12.3098 44.83 12.1531 44.7181C12.1083 44.7628 12.1083 44.7405 11.9964 44.6733C11.9964 44.6509 12.0188 44.6509 12.0188 44.6285C7.38586 41.5623 3.82722 36.8622 2.2829 31.1102C2.12623 30.5283 1.99194 29.924 1.88004 29.3421C1.79051 29.3421 1.70099 29.3197 1.5667 29.2973C1.3205 29.7225 1.07431 30.1254 0.581916 30.2373C0.716204 30.8416 0.872874 31.4459 1.02954 32.0502C1.07431 32.0054 1.16383 31.9607 1.25336 31.8935C1.18621 32.0054 1.14145 32.1397 1.07431 32.2516C1.70099 34.3555 2.61862 36.3474 3.76007 38.1827L3.78245 38.1603C3.93912 38.026 3.62578 37.5336 4.16294 37.6232C4.2077 37.9589 4.2077 38.2499 3.91674 38.4737C3.93912 38.5184 3.9615 38.5632 4.00627 38.608C4.05103 38.5856 4.14056 38.5632 4.29723 38.5184C4.23008 38.5856 4.18532 38.6751 4.11817 38.7646C8.46016 45.3447 15.8236 49.7763 24.239 50.0225C24.2167 50.0001 24.1943 49.9553 24.1719 49.9329C24.3062 49.9777 24.4181 50.0001 24.5076 50.0225C24.6643 50.0225 24.8433 50.0225 25 50.0225C31.0654 50.0225 36.6159 47.8738 40.9355 44.2704C40.8013 44.2704 40.7565 44.2481 40.846 43.9571C41.0251 44.1138 41.0475 44.1138 41.0475 44.1585C44.1361 41.5847 46.5757 38.2499 48.12 34.4898C48.0081 34.5569 47.8962 34.6465 47.7619 34.736C47.7619 34.4226 47.829 34.2212 48.0976 34.1541C48.12 34.1541 48.1647 34.1988 48.2095 34.2436C48.2766 34.0869 48.3438 33.9079 48.4109 33.7512C48.3662 33.7512 48.3214 33.7512 48.2766 33.7512C48.3438 33.6617 48.4333 33.5721 48.5228 33.4379C48.6124 33.1917 48.7019 32.9455 48.769 32.6993C48.7467 32.6993 48.7243 32.7217 48.7019 32.744C48.7914 32.4531 48.8809 32.1621 48.9705 31.8488C48.9928 31.8488 49.0152 31.8488 49.0152 31.8712C49.06 31.6921 49.1048 31.5131 49.1719 31.334C49.1271 31.2669 49.1719 31.1773 49.239 31.0207C49.7091 29.0959 49.9776 27.0815 49.9776 25.0001C49.9776 18.1738 47.2471 11.9741 42.7932 7.47546C42.7708 7.47546 42.7261 7.49784 42.7037 7.52022C42.4575 7.40832 42.3903 7.22926 42.368 7.05021C40.4879 5.23732 38.3169 3.69301 35.9445 2.52918C35.9221 2.55156 35.8774 2.57394 35.855 2.6187C35.855 2.57394 35.855 2.52918 35.855 2.50679C34.2435 1.67868 32.4754 1.07439 30.6625 0.64914C30.5506 0.850572 30.3939 1.02962 30.1477 1.16391C30.0134 1.25344 29.8791 1.36534 29.7001 1.16391C29.9015 1.052 29.9015 0.693902 30.2596 0.761046C30.282 0.761046 30.3715 0.671521 30.3939 0.604377C30.1925 0.559614 29.9911 0.514851 29.7896 0.470088C29.6777 0.537233 29.521 0.626758 29.3196 0.738665C29.2077 0.581995 29.2077 0.470088 29.2301 0.380563C29.0958 0.358182 28.9391 0.3358 28.8048 0.313419C28.7825 0.425326 28.7825 0.581995 28.8048 0.828191C28.6034 0.98486 28.402 1.16391 28.1782 1.34296C28.1558 1.18629 28.0663 1.02962 28.0886 0.895335C28.1334 0.581995 28.1334 0.358182 28.0663 0.201512C27.0815 0.0896051 26.0519 0.0224609 25.0224 0.0224609C23.3214 0.0224609 21.6428 0.201512 20.0313 0.514851C20.0313 0.559614 20.0537 0.626758 20.0313 0.716284C19.8747 0.671521 19.7628 0.626758 19.6956 0.559614C18.8675 0.738665 18.0394 0.962479 17.2337 1.23106C17.1218 1.34296 17.0546 1.36534 16.9651 1.32058C7.0949 4.67779 0 14.0108 0 25.0001Z"
              fill="#00C968"
            />
            <path
              d="M6.02022 25.2235C5.97545 21.8439 6.82595 18.5091 8.57169 15.51L7.27357 14.749C4.54305 19.4939 3.80446 24.9997 5.23687 30.2817C6.6469 35.5637 10.0489 39.9728 14.7713 42.7257L15.5323 41.4276C11.2127 38.9433 8.10169 34.937 6.7588 30.125C6.7588 30.1698 6.73642 30.1698 6.6469 30.2146C6.46784 29.946 6.46784 30.0131 6.69166 29.9012C6.4007 28.7822 6.19927 27.6631 6.10974 26.544C6.08736 26.5664 6.06498 26.6112 6.06498 26.6112C6.08736 27.1707 5.63973 27.2602 5.25925 27.5064C5.12496 27.2378 5.01305 27.014 4.87877 26.7678C5.12496 26.7007 5.41592 26.6783 5.57259 26.5216C5.72926 26.3873 5.77402 26.0964 5.86355 25.8949C5.70688 25.7159 5.57259 25.5816 5.41592 25.4026C5.61735 25.2459 5.75164 25.134 5.88593 24.9997C5.90831 25.0668 5.93069 25.1116 6.02022 25.2235Z"
              fill="#00C968"
            />
            <path
              d="M25.2014 5.3269C25.0671 5.03594 24.9105 4.7226 24.7538 4.43164C24.6195 4.7226 24.4628 5.03594 24.3285 5.3269C23.9928 5.37166 23.6795 5.4388 23.3438 5.52833C23.6123 5.72976 23.8585 5.93119 24.1047 6.15501L23.9928 7.13979C24.2614 6.96074 24.5076 6.80407 24.7985 6.6474C25.0671 6.78169 25.3357 6.96074 25.6043 7.11741L25.4476 6.15501C25.6938 5.93119 25.94 5.70738 26.1862 5.50595C25.8729 5.39404 25.5371 5.37166 25.2014 5.3269Z"
              fill="#00C968"
            />
            <path
              d="M34.7135 40.5778L34.3554 39.6602L33.9078 40.4883C33.5945 40.4883 33.2811 40.4659 32.9678 40.4659L33.5721 41.2492C33.4825 41.5626 33.3706 41.8759 33.2363 42.1669C33.5497 42.0773 33.863 41.9431 34.1764 41.8312C34.4449 42.0326 34.7135 42.2116 35.0045 42.3907C34.9821 42.055 34.9597 41.7192 34.9373 41.4059C35.2059 41.2045 35.4521 40.9807 35.6983 40.7568C35.3402 40.7121 35.0269 40.6449 34.7135 40.5778Z"
              fill="#00C968"
            />
            <path
              d="M29.3871 43.6885C29.5886 43.9347 29.8124 44.2033 30.0362 44.4495C30.1033 44.1138 30.1705 43.8004 30.2152 43.4647L30.6629 43.2633L31.1105 43.0395C30.8867 42.9499 30.6852 42.838 30.4838 42.7485C30.4838 42.7709 30.4838 42.7709 30.4614 42.7933C30.3048 43.0395 30.0586 42.7709 29.4543 42.3233C29.1409 42.2561 28.85 42.1442 28.559 42.0547L28.9395 42.9499C28.7604 43.2185 28.5814 43.5095 28.4023 43.7781C28.7381 43.7557 29.0514 43.7109 29.3871 43.6885Z"
              fill="#00C968"
            />
            <path
              d="M30.1927 42.278L30.1032 41.6289L29.4541 42.3003C29.7898 42.2108 30.036 42.2108 30.1927 42.278Z"
              fill="#00C968"
            />
            <path
              d="M24.3061 44.3148C24.4404 44.6058 24.597 44.9191 24.7537 45.2101C24.888 44.9191 25.0447 44.6058 25.1789 44.3148C25.5147 44.2701 25.828 44.2029 26.1637 44.1134C25.8952 43.912 25.649 43.7105 25.4028 43.4867L25.5147 42.502C25.2461 42.681 24.9999 42.8377 24.7089 42.9943C24.4404 42.8601 24.1718 42.681 23.9032 42.5243L24.0599 43.4867C23.8137 43.7105 23.5675 43.9344 23.3213 44.1358C23.657 44.2253 23.9704 44.2477 24.3061 44.3148Z"
              fill="#00C968"
            />
            <path
              d="M29.5654 7.13982C29.7892 7.36364 30.013 7.58745 30.2368 7.81126L30.3263 6.82648C30.6173 6.66981 30.9082 6.51314 31.1992 6.37886C30.9082 6.22219 30.5949 6.11028 30.2816 5.97599C30.2144 5.66265 30.1473 5.32693 30.0801 4.99121C29.8563 5.23741 29.6549 5.50598 29.4535 5.77456C29.1177 5.75218 28.782 5.7298 28.4463 5.70742C28.6477 5.97599 28.8492 6.22219 29.0282 6.51314L28.6701 7.43078L29.5654 7.13982Z"
              fill="#00C968"
            />
            <path
              d="M19.4491 44.6062C19.673 44.36 19.8744 44.0914 20.0758 43.8228C20.4115 43.8452 20.7473 43.8676 21.083 43.89C20.8816 43.6214 20.6801 43.3752 20.5011 43.0843L20.8592 42.1666L19.9639 42.4576C19.7401 42.2338 19.5163 42.0099 19.2925 41.7861L19.203 42.7709C18.912 42.9276 18.621 43.0843 18.3301 43.2185C18.621 43.3752 18.9344 43.4871 19.2477 43.6214V43.6438C19.2925 43.5766 19.3372 43.5095 19.4044 43.4424C19.5834 43.599 19.7401 43.7333 19.9415 43.89C19.6506 43.9571 19.4715 44.0243 19.3372 44.0466C19.382 44.2705 19.4044 44.4271 19.4491 44.6062Z"
              fill="#00C968"
            />
            <path
              d="M38.5407 37.4884L37.9588 36.7051C37.8916 37.0184 37.8021 37.3094 37.7126 37.6227C37.4216 37.7122 37.0859 37.757 36.7949 37.8241L37.5783 38.4284C37.5559 38.7418 37.5335 39.0775 37.4887 39.4132C37.7797 39.2342 38.0483 39.0327 38.3169 38.8537C38.6302 38.9656 38.9435 39.0775 39.2569 39.1894C39.1673 38.8761 39.0554 38.5627 38.9435 38.2494C39.145 37.9808 39.3464 37.7122 39.5255 37.4437C39.1897 37.4437 38.854 37.466 38.5407 37.4884Z"
              fill="#00C968"
            />
            <path
              d="M38.6746 9.73629C37.6226 8.79627 36.4812 7.96816 35.2502 7.25195L34.4893 8.55007C38.876 11.0792 42.0094 15.175 43.3299 20.0765C43.4866 20.6584 43.6209 21.2627 43.7104 21.8446C43.7999 21.867 43.8894 21.9118 43.979 21.9789C43.9342 22.0684 43.9118 22.2027 43.8447 22.2027C43.8223 22.2027 43.7999 22.2027 43.7775 22.2251C43.8447 22.7175 43.9118 23.2099 43.9342 23.6799C43.979 23.7023 44.0237 23.747 44.0685 23.7694C44.0237 23.8142 43.979 23.8366 43.9566 23.8589C44.0685 25.6718 43.9118 27.4847 43.5089 29.2305C43.7328 29.1633 43.9342 29.0962 44.1804 29.32C44.2252 29.1633 44.2699 29.2081 43.9118 28.9619C43.6656 28.7828 43.6656 28.7828 43.9342 28.4471C44.1356 28.5143 44.158 28.8947 44.4937 28.8052C44.5161 28.8052 44.6056 29.0738 44.6056 29.0514C44.5161 29.32 44.2252 29.5662 44.5833 29.8348C44.3594 30.1033 44.158 30.2824 43.8223 30.3048C44.0461 30.7076 43.6209 30.7972 43.5313 31.0434C43.3299 31.0657 43.1285 31.0657 42.9494 31.0881C42.6585 31.9386 42.3004 32.7667 41.8975 33.5725C41.9646 33.6172 42.0318 33.662 42.0989 33.7067C41.8975 33.9306 41.8303 33.9977 41.6513 34.0201C41.5842 34.1544 41.517 34.2887 41.4275 34.4229L42.7256 35.1839C45.4561 30.4391 46.1947 24.9332 44.7623 19.6512C43.7328 15.7793 41.6289 12.3773 38.7193 9.75867C38.585 10.072 38.6746 10.4749 38.2717 10.6092C37.8465 10.7434 37.5779 10.4525 37.3093 10.0944C37.7793 10.0049 38.0703 9.40056 38.6746 9.73629Z"
              fill="#00C968"
            />
            <path
              d="M43.8227 30.3713C43.8899 29.6327 44.0018 29.4537 43.5765 29.5208C43.6884 29.8118 43.3079 30.1699 43.8227 30.3713Z"
              fill="#00C968"
            />
          </g>
          <defs>
            <clipPath id="clip0_2210_12464">
              <rect width="50" height="50" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "iconRejectSigned":
      iconElement = (
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2210_12522)">
            <path
              d="M14.3242 8.95268C14.4809 8.97506 14.6376 9.01982 14.8166 9.06458L15.1747 9.98222L15.6223 9.15411C15.9357 9.15411 16.249 9.17649 16.5624 9.17649L15.9581 8.39314C15.9804 8.326 16.0028 8.25885 16.0252 8.19171C15.9581 8.16933 15.8909 8.14695 15.7566 8.10219C15.9581 7.90075 16.0476 7.81123 16.1595 7.85599C16.2043 7.74408 16.249 7.60979 16.2938 7.49789C15.9804 7.58741 15.6671 7.7217 15.3538 7.83361C15.1747 7.69932 14.9957 7.58741 14.8166 7.45312C14.8166 7.60979 14.839 7.78885 14.7718 7.99028C14.6823 7.78885 14.6152 7.63218 14.548 7.52027C14.5704 7.76646 14.5704 8.03504 14.5928 8.28124C14.5704 8.30362 14.5257 8.326 14.5033 8.37076C14.5928 8.37076 14.6823 8.37076 14.7942 8.37076C14.7942 8.66172 14.6823 8.84077 14.3242 8.95268Z"
              fill="#E50500"
            />
            <path
              d="M13.8545 8.86288C13.8993 8.86288 13.944 8.88527 13.9888 8.88527C13.9888 8.8405 13.9888 8.79574 13.9888 8.75098C13.9216 8.79574 13.8993 8.81812 13.8545 8.86288Z"
              fill="#E50500"
            />
            <path
              d="M20.1208 5.93097C19.9194 5.68477 19.6956 5.43858 19.4718 5.19238C19.4046 5.5281 19.3375 5.84144 19.2927 6.17716L18.8451 6.3786L18.3975 6.60241C18.7108 6.7367 19.0018 6.87099 19.2927 7.02766L19.427 7.99006L20.0761 7.31861C20.3894 7.38576 20.6804 7.49766 20.9713 7.58719L20.5908 6.69193C20.7699 6.42336 20.9489 6.1324 21.128 5.86382C20.7923 5.86382 20.4565 5.90859 20.1208 5.93097Z"
              fill="#E50500"
            />
            <path
              d="M10.9897 12.1309L11.5716 12.9142C11.6387 12.6009 11.7283 12.3099 11.8178 11.9966C12.1087 11.907 12.4445 11.8623 12.7354 11.7951L11.9521 11.1908C11.9744 10.8775 11.9968 10.5418 12.0416 10.2061C11.7506 10.3851 11.4821 10.5865 11.2135 10.7656C10.9001 10.6537 10.5868 10.5418 10.2735 10.4299C10.363 10.7432 10.4749 11.0565 10.5868 11.3699C10.3854 11.6385 10.1839 11.907 10.0049 12.1756C10.3406 12.1756 10.6539 12.1532 10.9897 12.1309Z"
              fill="#E50500"
            />
            <path
              d="M18.1292 35.8776C18.1515 35.6538 18.1292 35.5867 17.9053 35.4748C17.5696 35.3181 17.9501 35.139 18.0396 34.9824C17.9501 34.8929 17.9053 34.8257 17.7934 34.6914C18.0396 34.5795 18.2635 34.4676 18.5096 34.3333C18.6216 34.7138 18.7111 35.0271 18.8006 35.3629C19.2706 35.3629 19.4273 35.721 19.6287 36.1462C19.2259 36.0567 19.3154 35.9672 19.1587 36.4595L22.8293 38.5858C22.8069 38.4291 22.8516 38.2948 23.0083 38.2724C23.0978 38.2501 23.2097 38.2948 23.2769 38.3396L25.1122 35.1614C25.0674 35.1614 25.045 35.1838 25.0002 35.1838C24.9555 35.1838 24.9107 35.0719 24.9107 35.0495C24.9331 35.0048 25.0002 34.96 25.1122 34.8928C25.1345 34.96 25.1569 35.0048 25.1793 35.0495L25.9403 33.7514C25.8507 33.729 25.7388 33.7066 25.5598 33.6395C25.7388 33.5723 25.9179 33.4828 26.0969 33.5052L26.6788 32.4757C26.5893 32.5204 26.4998 32.5652 26.3655 32.5876C26.1193 31.9161 26.3431 31.5804 27.0817 31.5804C27.0593 31.6923 27.0369 31.7818 27.0146 31.8937L30.797 25.3584C30.7523 25.4031 30.7299 25.4255 30.6627 25.4703C30.6851 25.1346 30.7075 24.9331 30.9985 25.0003L33.4828 20.7031C33.4604 20.6583 33.4156 20.5688 33.3709 20.4792C33.438 20.4792 33.5276 20.4792 33.5947 20.5016L37.1533 14.3244L30.5508 10.5195L20.3002 28.2903L13.7872 24.5303L9.95996 31.1552L18.1292 35.8776Z"
              fill="#E50500"
            />
            <path
              d="M0 25.0001C0 25.0896 0 25.1567 0 25.2463C0.0447628 25.2239 0.0895255 25.2015 0.179051 25.2015C0.201432 25.2015 0.290958 25.3134 0.268577 25.3134C0.201432 25.4029 0.15667 25.5148 0.0671442 25.5596C0.0447628 25.5596 0.0223814 25.582 0 25.582C0.0223814 26.9025 0.15667 28.2006 0.402865 29.4764C0.470009 29.4316 0.514772 29.3644 0.559535 29.2749C0.626679 29.1406 0.895255 29.0959 1.09669 29.0063C1.16383 28.6035 0.738586 28.7154 0.581916 28.5363C0.49239 28.2006 0.425246 27.8649 0.290958 27.3725C0.760967 27.7082 0.984781 28.1335 1.38765 28.3349C1.49955 28.3797 1.61146 28.4468 1.72337 28.514C1.70099 28.2901 1.65622 28.0887 1.63384 27.8649C1.41003 27.932 1.20859 27.9768 1.00716 27.753C0.581916 27.2606 0.783348 26.7906 0.80573 26.6339C1.09669 26.522 1.3205 26.4772 1.49955 26.5444C1.47717 26.3206 1.47717 26.0968 1.45479 25.8506C1.41003 25.8506 1.38765 25.8282 1.34288 25.8282C1.09669 25.7163 1.25336 25.582 1.36526 25.4029C1.38765 25.4253 1.41003 25.4477 1.43241 25.4701C1.38765 23.6124 1.5667 21.7772 1.96956 20.009C1.79051 19.8524 1.74575 19.7181 1.79051 19.5614C1.83527 19.4271 1.9248 19.36 2.12623 19.3824C3.9615 11.9517 9.35542 5.61781 16.8979 2.8649C16.8308 2.79775 16.7637 2.73061 16.6741 2.66346C16.8532 2.6187 16.9651 2.57394 17.1441 2.52918C17.1218 2.6187 17.1218 2.70823 17.1218 2.79775C17.547 2.64108 17.9946 2.50679 18.4423 2.37251C18.3751 2.17107 18.2856 1.94726 18.1961 1.67868C18.4199 1.74583 19.3151 1.85773 19.0913 2.19345C22.5381 1.2982 26.0295 1.20867 29.3196 1.83535C29.2972 1.81297 29.2972 1.81297 29.2748 1.79059C29.7225 1.67868 29.7672 1.6563 29.9687 1.96964C30.5058 2.08155 31.0206 2.21584 31.5354 2.37251C31.5577 2.35012 31.5801 2.30536 31.6249 2.2606C31.6473 2.32774 31.6697 2.37251 31.692 2.41727C34.333 3.20062 36.795 4.43159 39.0107 6.06543C39.0107 5.99829 39.0107 5.90876 38.9884 5.75209C39.4136 5.95353 39.3689 5.81924 39.2569 6.2221C39.2346 6.2221 39.2122 6.19972 39.1898 6.19972C43.2408 9.24359 46.3518 13.6303 47.7619 18.89C51.1191 31.4235 43.6437 44.3824 31.1101 47.7396C29.8568 48.0753 28.6034 48.2991 27.3277 48.4334C27.4172 48.5677 27.5515 48.6796 27.5739 48.8139C27.6634 49.3734 27.2381 49.4182 26.6338 49.6867C26.88 49.2167 27.0591 48.8362 27.2605 48.4334C26.0072 48.5453 24.7314 48.5677 23.5005 48.5005C23.6124 48.6348 23.6571 48.702 23.5676 48.9929C23.5676 49.0153 23.3885 49.0153 23.3662 48.9929C23.2319 48.7691 23.3214 48.6124 23.3885 48.5005C23.12 48.4781 22.8514 48.4558 22.5828 48.4334V48.4558C22.4933 48.4558 22.4261 48.4334 22.3814 48.411C20.9937 48.2543 19.6061 47.9634 18.2856 47.5605C18.5765 47.9186 18.487 48.0305 17.9499 48.3439C17.9722 48.1648 18.0618 47.9634 18.017 47.8738C17.9275 47.7172 17.9499 47.6053 18.017 47.4934C16.2936 46.9562 14.6374 46.2176 13.0931 45.3C12.8022 45.3 12.735 45.3 12.6679 45.0538C12.4888 44.9419 12.3098 44.83 12.1531 44.7181C12.1083 44.7628 12.1083 44.7405 11.9964 44.6733C11.9964 44.6509 12.0188 44.6509 12.0188 44.6285C7.38586 41.5623 3.82722 36.8622 2.2829 31.1102C2.12623 30.5283 1.99194 29.924 1.88004 29.3421C1.79051 29.3421 1.70099 29.3197 1.5667 29.2973C1.3205 29.7225 1.07431 30.1254 0.581916 30.2373C0.716204 30.8416 0.872874 31.4459 1.02954 32.0502C1.07431 32.0054 1.16383 31.9607 1.25336 31.8935C1.18621 32.0054 1.14145 32.1397 1.07431 32.2516C1.70099 34.3555 2.61862 36.3474 3.76007 38.1827L3.78245 38.1603C3.93912 38.026 3.62578 37.5336 4.16294 37.6232C4.2077 37.9589 4.2077 38.2499 3.91674 38.4737C3.93912 38.5184 3.9615 38.5632 4.00627 38.608C4.05103 38.5856 4.14056 38.5632 4.29723 38.5184C4.23008 38.5856 4.18532 38.6751 4.11817 38.7646C8.46016 45.3447 15.8236 49.7763 24.239 50.0225C24.2167 50.0001 24.1943 49.9553 24.1719 49.9329C24.3062 49.9777 24.4181 50.0001 24.5076 50.0225C24.6643 50.0225 24.8433 50.0225 25 50.0225C31.0654 50.0225 36.6159 47.8738 40.9355 44.2704C40.8013 44.2704 40.7565 44.2481 40.846 43.9571C41.0251 44.1138 41.0475 44.1138 41.0475 44.1585C44.1361 41.5847 46.5757 38.2499 48.12 34.4898C48.0081 34.5569 47.8962 34.6465 47.7619 34.736C47.7619 34.4226 47.829 34.2212 48.0976 34.1541C48.12 34.1541 48.1647 34.1988 48.2095 34.2436C48.2766 34.0869 48.3438 33.9079 48.4109 33.7512C48.3662 33.7512 48.3214 33.7512 48.2766 33.7512C48.3438 33.6617 48.4333 33.5721 48.5228 33.4379C48.6124 33.1917 48.7019 32.9455 48.769 32.6993C48.7467 32.6993 48.7243 32.7217 48.7019 32.744C48.7914 32.4531 48.8809 32.1621 48.9705 31.8488C48.9928 31.8488 49.0152 31.8488 49.0152 31.8712C49.06 31.6921 49.1048 31.5131 49.1719 31.334C49.1271 31.2669 49.1719 31.1773 49.239 31.0207C49.7091 29.0959 49.9776 27.0815 49.9776 25.0001C49.9776 18.1738 47.2471 11.9741 42.7932 7.47546C42.7708 7.47546 42.7261 7.49784 42.7037 7.52022C42.4575 7.40832 42.3903 7.22926 42.368 7.05021C40.4879 5.23732 38.3169 3.69301 35.9445 2.52918C35.9221 2.55156 35.8774 2.57394 35.855 2.6187C35.855 2.57394 35.855 2.52918 35.855 2.50679C34.2435 1.67868 32.4754 1.07439 30.6625 0.64914C30.5506 0.850572 30.3939 1.02962 30.1477 1.16391C30.0134 1.25344 29.8791 1.36534 29.7001 1.16391C29.9015 1.052 29.9015 0.693902 30.2596 0.761046C30.282 0.761046 30.3715 0.671521 30.3939 0.604377C30.1925 0.559614 29.9911 0.514851 29.7896 0.470088C29.6777 0.537233 29.521 0.626758 29.3196 0.738665C29.2077 0.581995 29.2077 0.470088 29.2301 0.380563C29.0958 0.358182 28.9391 0.3358 28.8048 0.313419C28.7825 0.425326 28.7825 0.581995 28.8048 0.828191C28.6034 0.98486 28.402 1.16391 28.1782 1.34296C28.1558 1.18629 28.0663 1.02962 28.0886 0.895335C28.1334 0.581995 28.1334 0.358182 28.0663 0.201512C27.0815 0.0896051 26.0519 0.0224609 25.0224 0.0224609C23.3214 0.0224609 21.6428 0.201512 20.0313 0.514851C20.0313 0.559614 20.0537 0.626758 20.0313 0.716284C19.8747 0.671521 19.7628 0.626758 19.6956 0.559614C18.8675 0.738665 18.0394 0.962479 17.2337 1.23106C17.1218 1.34296 17.0546 1.36534 16.9651 1.32058C7.0949 4.67779 0 14.0108 0 25.0001Z"
              fill="#E50500"
            />
            <path
              d="M6.02022 25.2235C5.97545 21.8439 6.82595 18.5091 8.57169 15.51L7.27357 14.749C4.54305 19.4939 3.80446 24.9997 5.23687 30.2817C6.6469 35.5637 10.0489 39.9728 14.7713 42.7257L15.5323 41.4276C11.2127 38.9433 8.10169 34.937 6.7588 30.125C6.7588 30.1698 6.73642 30.1698 6.6469 30.2146C6.46784 29.946 6.46784 30.0131 6.69166 29.9012C6.4007 28.7822 6.19927 27.6631 6.10974 26.544C6.08736 26.5664 6.06498 26.6112 6.06498 26.6112C6.08736 27.1707 5.63973 27.2602 5.25925 27.5064C5.12496 27.2378 5.01305 27.014 4.87877 26.7678C5.12496 26.7007 5.41592 26.6783 5.57259 26.5216C5.72926 26.3873 5.77402 26.0964 5.86355 25.8949C5.70688 25.7159 5.57259 25.5816 5.41592 25.4026C5.61735 25.2459 5.75164 25.134 5.88593 24.9997C5.90831 25.0668 5.93069 25.1116 6.02022 25.2235Z"
              fill="#E50500"
            />
            <path
              d="M25.2014 5.3269C25.0671 5.03594 24.9105 4.7226 24.7538 4.43164C24.6195 4.7226 24.4628 5.03594 24.3285 5.3269C23.9928 5.37166 23.6795 5.4388 23.3438 5.52833C23.6123 5.72976 23.8585 5.93119 24.1047 6.15501L23.9928 7.13979C24.2614 6.96074 24.5076 6.80407 24.7985 6.6474C25.0671 6.78169 25.3357 6.96074 25.6043 7.11741L25.4476 6.15501C25.6938 5.93119 25.94 5.70738 26.1862 5.50595C25.8729 5.39404 25.5371 5.37166 25.2014 5.3269Z"
              fill="#E50500"
            />
            <path
              d="M34.7135 40.5778L34.3554 39.6602L33.9078 40.4883C33.5945 40.4883 33.2811 40.4659 32.9678 40.4659L33.5721 41.2492C33.4825 41.5626 33.3706 41.8759 33.2363 42.1669C33.5497 42.0773 33.863 41.9431 34.1764 41.8312C34.4449 42.0326 34.7135 42.2116 35.0045 42.3907C34.9821 42.055 34.9597 41.7192 34.9373 41.4059C35.2059 41.2045 35.4521 40.9807 35.6983 40.7568C35.3402 40.7121 35.0269 40.6449 34.7135 40.5778Z"
              fill="#E50500"
            />
            <path
              d="M29.3871 43.6885C29.5886 43.9347 29.8124 44.2033 30.0362 44.4495C30.1033 44.1138 30.1705 43.8004 30.2152 43.4647L30.6629 43.2633L31.1105 43.0395C30.8867 42.9499 30.6852 42.838 30.4838 42.7485C30.4838 42.7709 30.4838 42.7709 30.4614 42.7933C30.3048 43.0395 30.0586 42.7709 29.4543 42.3233C29.1409 42.2561 28.85 42.1442 28.559 42.0547L28.9395 42.9499C28.7604 43.2185 28.5814 43.5095 28.4023 43.7781C28.7381 43.7557 29.0514 43.7109 29.3871 43.6885Z"
              fill="#E50500"
            />
            <path
              d="M30.1927 42.278L30.1032 41.6289L29.4541 42.3003C29.7898 42.2108 30.036 42.2108 30.1927 42.278Z"
              fill="#E50500"
            />
            <path
              d="M24.3061 44.3148C24.4404 44.6058 24.597 44.9191 24.7537 45.2101C24.888 44.9191 25.0447 44.6058 25.1789 44.3148C25.5147 44.2701 25.828 44.2029 26.1637 44.1134C25.8952 43.912 25.649 43.7105 25.4028 43.4867L25.5147 42.502C25.2461 42.681 24.9999 42.8377 24.7089 42.9943C24.4404 42.8601 24.1718 42.681 23.9032 42.5243L24.0599 43.4867C23.8137 43.7105 23.5675 43.9344 23.3213 44.1358C23.657 44.2253 23.9704 44.2477 24.3061 44.3148Z"
              fill="#E50500"
            />
            <path
              d="M29.5654 7.13982C29.7892 7.36364 30.013 7.58745 30.2368 7.81126L30.3263 6.82648C30.6173 6.66981 30.9082 6.51314 31.1992 6.37886C30.9082 6.22219 30.5949 6.11028 30.2816 5.97599C30.2144 5.66265 30.1473 5.32693 30.0801 4.99121C29.8563 5.23741 29.6549 5.50598 29.4535 5.77456C29.1177 5.75218 28.782 5.7298 28.4463 5.70742C28.6477 5.97599 28.8492 6.22219 29.0282 6.51314L28.6701 7.43078L29.5654 7.13982Z"
              fill="#E50500"
            />
            <path
              d="M19.4491 44.6062C19.673 44.36 19.8744 44.0914 20.0758 43.8228C20.4115 43.8452 20.7473 43.8676 21.083 43.89C20.8816 43.6214 20.6801 43.3752 20.5011 43.0843L20.8592 42.1666L19.9639 42.4576C19.7401 42.2338 19.5163 42.0099 19.2925 41.7861L19.203 42.7709C18.912 42.9276 18.621 43.0843 18.3301 43.2185C18.621 43.3752 18.9344 43.4871 19.2477 43.6214V43.6438C19.2925 43.5766 19.3372 43.5095 19.4044 43.4424C19.5834 43.599 19.7401 43.7333 19.9415 43.89C19.6506 43.9571 19.4715 44.0243 19.3372 44.0466C19.382 44.2705 19.4044 44.4271 19.4491 44.6062Z"
              fill="#E50500"
            />
            <path
              d="M38.5407 37.4884L37.9588 36.7051C37.8916 37.0184 37.8021 37.3094 37.7126 37.6227C37.4216 37.7122 37.0859 37.757 36.7949 37.8241L37.5783 38.4284C37.5559 38.7418 37.5335 39.0775 37.4887 39.4132C37.7797 39.2342 38.0483 39.0327 38.3169 38.8537C38.6302 38.9656 38.9435 39.0775 39.2569 39.1894C39.1673 38.8761 39.0554 38.5627 38.9435 38.2494C39.145 37.9808 39.3464 37.7122 39.5255 37.4437C39.1897 37.4437 38.854 37.466 38.5407 37.4884Z"
              fill="#E50500"
            />
            <path
              d="M38.6746 9.73629C37.6226 8.79627 36.4812 7.96816 35.2502 7.25195L34.4893 8.55007C38.876 11.0792 42.0094 15.175 43.3299 20.0765C43.4866 20.6584 43.6209 21.2627 43.7104 21.8446C43.7999 21.867 43.8894 21.9118 43.979 21.9789C43.9342 22.0684 43.9118 22.2027 43.8447 22.2027C43.8223 22.2027 43.7999 22.2027 43.7775 22.2251C43.8447 22.7175 43.9118 23.2099 43.9342 23.6799C43.979 23.7023 44.0237 23.747 44.0685 23.7694C44.0237 23.8142 43.979 23.8366 43.9566 23.8589C44.0685 25.6718 43.9118 27.4847 43.5089 29.2305C43.7328 29.1633 43.9342 29.0962 44.1804 29.32C44.2252 29.1633 44.2699 29.2081 43.9118 28.9619C43.6656 28.7828 43.6656 28.7828 43.9342 28.4471C44.1356 28.5143 44.158 28.8947 44.4937 28.8052C44.5161 28.8052 44.6056 29.0738 44.6056 29.0514C44.5161 29.32 44.2252 29.5662 44.5833 29.8348C44.3594 30.1033 44.158 30.2824 43.8223 30.3048C44.0461 30.7076 43.6209 30.7972 43.5313 31.0434C43.3299 31.0657 43.1285 31.0657 42.9494 31.0881C42.6585 31.9386 42.3004 32.7667 41.8975 33.5725C41.9646 33.6172 42.0318 33.662 42.0989 33.7067C41.8975 33.9306 41.8303 33.9977 41.6513 34.0201C41.5842 34.1544 41.517 34.2887 41.4275 34.4229L42.7256 35.1839C45.4561 30.4391 46.1947 24.9332 44.7623 19.6512C43.7328 15.7793 41.6289 12.3773 38.7193 9.75867C38.585 10.072 38.6746 10.4749 38.2717 10.6092C37.8465 10.7434 37.5779 10.4525 37.3093 10.0944C37.7793 10.0049 38.0703 9.40056 38.6746 9.73629Z"
              fill="#E50500"
            />
            <path
              d="M43.8227 30.3713C43.8899 29.6327 44.0018 29.4537 43.5765 29.5208C43.6884 29.8118 43.3079 30.1699 43.8227 30.3713Z"
              fill="#E50500"
            />
          </g>
          <defs>
            <clipPath id="clip0_2210_12522">
              <rect width="50" height="50" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "signSuccess":
      iconElement = (
        <svg
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M50.0005 73.9005L36.1005 60.0005L31.3672 64.7005L50.0005 83.3338L90.0005 43.3338L85.3005 38.6338L50.0005 73.9005Z"
            fill="#0D99FF"
          />
          <circle
            cx="60"
            cy="60"
            r="59.5"
            stroke="#0D99FF"
            strokeDasharray="5 5"
          />
        </svg>
      )
      break
    case "hidePassLogin":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.00033 4.00003C10.527 4.00003 12.7803 5.42003 13.8803 7.6667C13.487 8.48003 12.9337 9.18003 12.2737 9.7467L13.2137 10.6867C14.1403 9.8667 14.8737 8.84003 15.3337 7.6667C14.1803 4.74003 11.3337 2.6667 8.00033 2.6667C7.15366 2.6667 6.34032 2.80003 5.57366 3.0467L6.67366 4.1467C7.10699 4.06003 7.54699 4.00003 8.00033 4.00003ZM7.28699 4.76003L8.66699 6.14003C9.04699 6.3067 9.35366 6.61336 9.52032 6.99336L10.9003 8.37336C10.9537 8.1467 10.9937 7.9067 10.9937 7.66003C11.0003 6.0067 9.65366 4.6667 8.00033 4.6667C7.75366 4.6667 7.52033 4.70003 7.28699 4.76003ZM1.34033 2.58003L3.12699 4.3667C2.04033 5.22003 1.18033 6.35336 0.666992 7.6667C1.82033 10.5934 4.66699 12.6667 8.00033 12.6667C9.01366 12.6667 9.98699 12.4734 10.8803 12.12L13.1603 14.4L14.1003 13.46L2.28033 1.63336L1.34033 2.58003ZM6.34033 7.58003L8.08033 9.32003C8.05366 9.32669 8.02699 9.33336 8.00033 9.33336C7.08033 9.33336 6.33366 8.5867 6.33366 7.6667C6.33366 7.63336 6.34033 7.61336 6.34033 7.58003ZM4.07366 5.31336L5.24033 6.48003C5.08699 6.8467 5.00033 7.2467 5.00033 7.6667C5.00033 9.32003 6.34699 10.6667 8.00033 10.6667C8.42033 10.6667 8.82032 10.58 9.18033 10.4267L9.83366 11.08C9.24699 11.24 8.63366 11.3334 8.00033 11.3334C5.47366 11.3334 3.22033 9.91336 2.12033 7.6667C2.58699 6.71336 3.26699 5.92669 4.07366 5.31336Z"
            fill="#323232"
          />
        </svg>
      )
      break
    case "checkDisabled":
      iconElement = (
        <svg
          width="70"
          height="70"
          viewBox="0 0 70 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.5" clipPath="url(#clip0_2178_12364)">
            <path
              d="M20.0547 12.5339C20.274 12.5653 20.4934 12.6279 20.744 12.6906L21.2454 13.9753L21.8721 12.816C22.3107 12.816 22.7494 12.8473 23.1881 12.8473L22.3421 11.7506C22.3734 11.6566 22.4047 11.5626 22.4361 11.4686C22.3421 11.4373 22.2481 11.4059 22.0601 11.3433C22.3421 11.0612 22.4674 10.9359 22.6241 10.9986C22.6867 10.8419 22.7494 10.6539 22.8121 10.4972C22.3734 10.6226 21.9347 10.8106 21.496 10.9672C21.2454 10.7792 20.9947 10.6226 20.744 10.4346C20.744 10.6539 20.7754 10.9046 20.6814 11.1866C20.556 10.9046 20.462 10.6852 20.368 10.5286C20.3994 10.8732 20.3994 11.2493 20.4307 11.5939C20.3994 11.6253 20.3367 11.6566 20.3054 11.7193C20.4307 11.7193 20.556 11.7193 20.7127 11.7193C20.7127 12.1266 20.556 12.3773 20.0547 12.5339Z"
              fill="white"
            />
            <path
              d="M19.3965 12.4086C19.4592 12.4086 19.5218 12.44 19.5845 12.44C19.5845 12.3773 19.5845 12.3146 19.5845 12.252C19.4905 12.3146 19.4592 12.346 19.3965 12.4086Z"
              fill="white"
            />
            <path
              d="M28.1686 8.30355C27.8866 7.95888 27.5732 7.6142 27.2599 7.26953C27.1659 7.73954 27.0719 8.17822 27.0092 8.64822L26.3825 8.93023L25.7559 9.24357C26.1945 9.43157 26.6019 9.61958 27.0092 9.83891L27.1972 11.1863L28.1059 10.2463C28.5446 10.3403 28.9519 10.4969 29.3593 10.6223L28.8266 9.3689C29.0773 8.9929 29.3279 8.58556 29.5786 8.20955C29.1086 8.20955 28.6386 8.27222 28.1686 8.30355Z"
              fill="white"
            />
            <path
              d="M15.3846 16.9828L16.1992 18.0795C16.2932 17.6408 16.4186 17.2335 16.5439 16.7948C16.9513 16.6695 17.4213 16.6068 17.8286 16.5128L16.7319 15.6668C16.7633 15.2281 16.7946 14.7581 16.8573 14.2881C16.4499 14.5388 16.0739 14.8208 15.6979 15.0714C15.2592 14.9148 14.8205 14.7581 14.3819 14.6014C14.5072 15.0401 14.6639 15.4788 14.8205 15.9175C14.5385 16.2935 14.2565 16.6695 14.0059 17.0455C14.4759 17.0455 14.9145 17.0141 15.3846 16.9828Z"
              fill="white"
            />
            <path
              d="M25.3802 50.2279C25.4116 49.9146 25.3802 49.8206 25.0669 49.6639C24.5969 49.4446 25.1296 49.1939 25.2549 48.9746C25.1296 48.8492 25.0669 48.7552 24.9102 48.5672C25.2549 48.4105 25.5682 48.2539 25.9129 48.0659C26.0696 48.5985 26.1949 49.0372 26.3203 49.5072C26.9783 49.5072 27.1976 50.0086 27.4796 50.6039C26.9156 50.4786 27.0409 50.3532 26.8216 51.0426L31.9604 54.0193C31.929 53.8 31.9917 53.612 32.211 53.5806C32.3364 53.5493 32.493 53.612 32.587 53.6746L35.1564 49.2252C35.0938 49.2252 35.0624 49.2566 34.9998 49.2566C34.9371 49.2566 34.8744 49.0999 34.8744 49.0686C34.9058 49.0059 34.9998 48.9432 35.1564 48.8492C35.1878 48.9432 35.2191 49.0059 35.2504 49.0686L36.3158 47.2512C36.1904 47.2199 36.0338 47.1885 35.7831 47.0945C36.0338 47.0005 36.2844 46.8752 36.5351 46.9065L37.3498 45.4652C37.2245 45.5278 37.0991 45.5905 36.9111 45.6218C36.5665 44.6818 36.8798 44.2118 37.9138 44.2118C37.8825 44.3685 37.8511 44.4938 37.8198 44.6505L43.1152 35.501C43.0526 35.5636 43.0212 35.595 42.9272 35.6576C42.9586 35.1876 42.9899 34.9056 43.3972 34.9996L46.8753 28.9835C46.844 28.9208 46.7813 28.7955 46.7186 28.6702C46.8126 28.6702 46.938 28.6702 47.032 28.7015L52.0141 20.0533L42.7706 14.7266L28.4196 39.6057L19.3015 34.3416L13.9434 43.6164L25.3802 50.2279Z"
              fill="white"
            />
            <path
              d="M0 34.9999C0 35.1252 0 35.2192 0 35.3446C0.0626679 35.3133 0.125336 35.2819 0.250671 35.2819C0.282005 35.2819 0.407341 35.4386 0.376007 35.4386C0.282005 35.5639 0.219338 35.7206 0.0940018 35.7833C0.0626679 35.7833 0.0313339 35.8146 0 35.8146C0.0313339 37.6633 0.219338 39.4807 0.564011 41.2667C0.658013 41.204 0.72068 41.11 0.783348 40.9847C0.87735 40.7967 1.25336 40.734 1.53536 40.6087C1.62936 40.0447 1.03402 40.2013 0.814682 39.9507C0.689346 39.4807 0.595345 39.0107 0.407341 38.3213C1.06535 38.7913 1.37869 39.3867 1.9427 39.6687C2.09937 39.7313 2.25604 39.8253 2.41271 39.9193C2.38138 39.606 2.31871 39.324 2.28738 39.0107C1.97404 39.1047 1.69203 39.1673 1.41003 38.854C0.814682 38.1646 1.09669 37.5066 1.12802 37.2873C1.53536 37.1306 1.8487 37.068 2.09937 37.162C2.06804 36.8486 2.06804 36.5353 2.03671 36.1906C1.97404 36.1906 1.9427 36.1593 1.88004 36.1593C1.53536 36.0026 1.7547 35.8146 1.91137 35.5639C1.9427 35.5953 1.97404 35.6266 2.00537 35.6579C1.9427 33.0572 2.19338 30.4878 2.75739 28.0124C2.50671 27.7931 2.44405 27.6051 2.50671 27.3858C2.56938 27.1978 2.69472 27.1038 2.97672 27.1351C5.54611 16.7322 13.0976 7.86473 23.6571 4.01066C23.5631 3.91666 23.4691 3.82265 23.3438 3.72865C23.5945 3.66599 23.7511 3.60332 24.0018 3.54065C23.9705 3.66599 23.9705 3.79132 23.9705 3.91666C24.5658 3.69732 25.1925 3.50932 25.8192 3.32131C25.7252 3.03931 25.5998 2.72597 25.4745 2.34996C25.7878 2.44396 27.0412 2.60063 26.7278 3.07064C31.5533 1.81728 36.4414 1.69195 41.0475 2.5693C41.0161 2.53796 41.0161 2.53796 40.9848 2.50663C41.6115 2.34996 41.6741 2.31863 41.9561 2.7573C42.7081 2.91397 43.4288 3.10197 44.1495 3.32131C44.1808 3.28998 44.2122 3.22731 44.2748 3.16464C44.3062 3.25864 44.3375 3.32131 44.3689 3.38398C48.0663 4.48067 51.513 6.20403 54.615 8.49141C54.615 8.39741 54.615 8.27207 54.5837 8.05274C55.1791 8.33474 55.1164 8.14674 54.9597 8.71075C54.9284 8.71075 54.8971 8.67941 54.8657 8.67941C60.5372 12.9408 64.8926 19.0823 66.8666 26.4458C71.5667 43.9927 61.1012 62.1351 43.5542 66.8352C41.7995 67.3052 40.0448 67.6185 38.2587 67.8065C38.3841 67.9945 38.5721 68.1512 38.6034 68.3392C38.7287 69.1226 38.1334 69.1852 37.2874 69.5612C37.6321 68.9032 37.8827 68.3705 38.1647 67.8065C36.41 67.9632 34.624 67.9945 32.9006 67.9005C33.0573 68.0885 33.12 68.1825 32.9946 68.5899C32.9946 68.6212 32.744 68.6212 32.7126 68.5899C32.5246 68.2765 32.65 68.0572 32.744 67.9005C32.368 67.8692 31.9919 67.8379 31.6159 67.8065V67.8379C31.4906 67.8379 31.3966 67.8065 31.3339 67.7752C29.3912 67.5559 27.4485 67.1485 25.5998 66.5845C26.0072 67.0859 25.8818 67.2425 25.1298 67.6812C25.1611 67.4305 25.2865 67.1485 25.2238 67.0232C25.0985 66.8038 25.1298 66.6472 25.2238 66.4905C22.8111 65.7385 20.4924 64.7045 18.3304 63.4198C17.923 63.4198 17.829 63.4198 17.735 63.0751C17.4843 62.9184 17.2337 62.7618 17.0143 62.6051C16.9517 62.6678 16.9517 62.6364 16.795 62.5424C16.795 62.5111 16.8263 62.5111 16.8263 62.4798C10.3402 58.187 5.3581 51.6069 3.19606 43.5541C2.97672 42.7394 2.78872 41.8934 2.63205 41.0787C2.50671 41.0787 2.38138 41.0474 2.19338 41.016C1.8487 41.6114 1.50403 42.1754 0.814682 42.3321C1.00269 43.1781 1.22202 44.0241 1.44136 44.8701C1.50403 44.8074 1.62936 44.7448 1.7547 44.6508C1.6607 44.8074 1.59803 44.9954 1.50403 45.1521C2.38138 48.0975 3.66607 50.8862 5.2641 53.4556L5.29543 53.4243C5.51477 53.2363 5.0761 52.5469 5.82811 52.6722C5.89078 53.1423 5.89078 53.5496 5.48344 53.8629C5.51477 53.9256 5.54611 53.9883 5.60877 54.0509C5.67144 54.0196 5.79678 53.9883 6.01612 53.9256C5.92211 54.0196 5.85945 54.1449 5.76544 54.2703C11.8442 63.4824 22.1531 69.6866 33.9347 70.0312C33.9033 69.9999 33.872 69.9372 33.8406 69.9059C34.0287 69.9686 34.1853 69.9999 34.3107 70.0312C34.53 70.0312 34.7807 70.0312 35 70.0312C43.4915 70.0312 51.2623 67.0232 57.3098 61.9784C57.1218 61.9784 57.0591 61.9471 57.1844 61.5397C57.4351 61.7591 57.4664 61.7591 57.4664 61.8218C61.7905 58.2183 65.2059 53.5496 67.368 48.2855C67.2113 48.3795 67.0546 48.5048 66.8666 48.6302C66.8666 48.1915 66.9606 47.9095 67.3366 47.8155C67.368 47.8155 67.4306 47.8782 67.4933 47.9408C67.5873 47.7215 67.6813 47.4708 67.7753 47.2515C67.7126 47.2515 67.65 47.2515 67.5873 47.2515C67.6813 47.1261 67.8066 47.0008 67.932 46.8128C68.0573 46.4681 68.1826 46.1235 68.2766 45.7788C68.2453 45.7788 68.214 45.8101 68.1826 45.8414C68.308 45.4341 68.4333 45.0268 68.5586 44.5881C68.59 44.5881 68.6213 44.5881 68.6213 44.6194C68.684 44.3688 68.7466 44.1181 68.8406 43.8674C68.778 43.7734 68.8407 43.6481 68.9347 43.4287C69.5927 40.734 69.9687 37.914 69.9687 34.9999C69.9687 25.4431 66.1459 16.7636 59.9105 10.4654C59.8791 10.4654 59.8165 10.4968 59.7851 10.5281C59.4405 10.3714 59.3465 10.1208 59.3151 9.8701C56.6831 7.33205 53.6437 5.17001 50.3223 3.54065C50.291 3.57198 50.2283 3.60332 50.197 3.66599C50.197 3.60332 50.197 3.54065 50.197 3.50932C47.9409 2.34996 45.4655 1.50394 42.9275 0.9086C42.7708 1.19061 42.5515 1.44128 42.2068 1.62928C42.0188 1.75462 41.8308 1.91129 41.5801 1.62928C41.8621 1.47261 41.8621 0.971268 42.3635 1.06527C42.3948 1.06527 42.5201 0.939934 42.5515 0.845932C42.2695 0.783264 41.9875 0.720596 41.7055 0.657928C41.5488 0.75193 41.3295 0.877266 41.0475 1.03394C40.8908 0.814598 40.8908 0.657929 40.9221 0.532593C40.7341 0.501259 40.5148 0.469925 40.3268 0.438591C40.2954 0.595261 40.2954 0.814598 40.3268 1.15927C40.0448 1.37861 39.7628 1.62928 39.4494 1.87995C39.4181 1.66061 39.2928 1.44128 39.3241 1.25327C39.3868 0.814598 39.3868 0.501259 39.2928 0.281921C37.9141 0.125252 36.4727 0.03125 35.0313 0.03125C32.65 0.03125 30.2999 0.281921 28.0439 0.720596C28.0439 0.783264 28.0752 0.877266 28.0439 1.0026C27.8245 0.939934 27.6679 0.877266 27.5739 0.783264C26.4145 1.03394 25.2551 1.34727 24.1271 1.72328C23.9705 1.87995 23.8765 1.91129 23.7511 1.84862C9.93286 6.54871 0 19.615 0 34.9999Z"
              fill="white"
            />
            <path
              d="M8.4283 35.3137C8.36564 30.5823 9.55633 25.9135 12.0004 21.7148L10.183 20.6494C6.36026 27.2922 5.32624 35.0004 7.33162 42.3952C9.30565 49.79 14.0684 55.9628 20.6799 59.8168L21.7452 57.9995C15.6978 54.5214 11.3424 48.9126 9.46232 42.1758C9.46232 42.2385 9.43099 42.2385 9.30565 42.3012C9.05498 41.9252 9.05498 42.0192 9.36832 41.8625C8.96098 40.2958 8.67898 38.7291 8.55364 37.1624C8.52231 37.1937 8.49097 37.2564 8.49097 37.2564C8.52231 38.0397 7.89563 38.1651 7.36295 38.5098C7.17495 38.1337 7.01828 37.8204 6.83027 37.4757C7.17495 37.3817 7.58229 37.3504 7.80162 37.1311C8.02096 36.9431 8.08363 36.5357 8.20897 36.2537C7.98963 36.003 7.80163 35.815 7.58229 35.5644C7.86429 35.345 8.0523 35.1884 8.2403 35.0004C8.27163 35.0944 8.30297 35.157 8.4283 35.3137Z"
              fill="white"
            />
            <path
              d="M35.2824 7.45746C35.0944 7.05012 34.875 6.61144 34.6557 6.2041C34.4677 6.61144 34.2483 7.05012 34.0603 7.45746C33.5903 7.52013 33.1517 7.61413 32.6816 7.73947C33.0576 8.02147 33.4023 8.30348 33.747 8.61682L33.5903 9.99551C33.9663 9.74484 34.311 9.5255 34.7184 9.30616C35.0944 9.49417 35.4704 9.74484 35.8464 9.96417L35.627 8.61682C35.9717 8.30348 36.3164 7.99014 36.6611 7.70813C36.2224 7.55146 35.7524 7.52013 35.2824 7.45746Z"
              fill="white"
            />
            <path
              d="M48.5983 56.8081L48.097 55.5234L47.4703 56.6828C47.0316 56.6828 46.593 56.6515 46.1543 56.6515L47.0003 57.7482C46.875 58.1868 46.7183 58.6255 46.5303 59.0328C46.969 58.9075 47.4077 58.7195 47.8463 58.5628C48.2223 58.8448 48.5983 59.0955 49.0057 59.3462C48.9743 58.8762 48.943 58.4062 48.9117 57.9675C49.2877 57.6855 49.6324 57.3721 49.977 57.0588C49.4757 56.9961 49.037 56.9021 48.5983 56.8081Z"
              fill="white"
            />
            <path
              d="M41.1424 61.1634C41.4244 61.508 41.7377 61.884 42.051 62.2287C42.145 61.7587 42.2391 61.32 42.3017 60.85L42.9284 60.568L43.5551 60.2547C43.2417 60.1293 42.9597 59.9727 42.6777 59.8473C42.6777 59.8787 42.6777 59.8787 42.6464 59.91C42.4271 60.2547 42.0824 59.8787 41.2364 59.252C40.7977 59.158 40.3903 59.0013 39.983 58.876L40.5157 60.1293C40.265 60.5053 40.0143 60.9127 39.7637 61.2887C40.2337 61.2574 40.6724 61.1947 41.1424 61.1634Z"
              fill="white"
            />
            <path
              d="M42.2703 59.1899L42.145 58.2812L41.2363 59.2213C41.7063 59.0959 42.051 59.0959 42.2703 59.1899Z"
              fill="white"
            />
            <path
              d="M34.0291 62.041C34.2171 62.4483 34.4364 62.887 34.6558 63.2943C34.8438 62.887 35.0631 62.4483 35.2511 62.041C35.7211 61.9783 36.1598 61.8843 36.6298 61.759C36.2538 61.477 35.9091 61.195 35.5645 60.8816L35.7211 59.5029C35.3451 59.7536 35.0004 59.9729 34.5931 60.1923C34.2171 60.0043 33.8411 59.7536 33.4651 59.5343L33.6844 60.8816C33.3397 61.195 32.9951 61.5083 32.6504 61.7903C33.1204 61.9156 33.5591 61.947 34.0291 62.041Z"
              fill="white"
            />
            <path
              d="M41.3929 9.99536C41.7062 10.3087 42.0196 10.622 42.3329 10.9354L42.4582 9.55669C42.8656 9.33735 43.2729 9.11801 43.6803 8.93001C43.2729 8.71067 42.8342 8.554 42.3956 8.366C42.3016 7.92732 42.2076 7.45731 42.1136 6.9873C41.8002 7.33198 41.5182 7.70799 41.2362 8.08399C40.7662 8.05266 40.2962 8.02132 39.8262 7.98999C40.1082 8.366 40.3902 8.71067 40.6409 9.11801L40.1395 10.4027L41.3929 9.99536Z"
              fill="white"
            />
            <path
              d="M27.2288 62.4481C27.5421 62.1034 27.8241 61.7274 28.1062 61.3514C28.5762 61.3827 29.0462 61.4141 29.5162 61.4454C29.2342 61.0694 28.9522 60.7247 28.7015 60.3174L29.2028 59.0327L27.9495 59.44C27.6361 59.1267 27.3228 58.8133 27.0095 58.5L26.8841 59.8787C26.4768 60.098 26.0695 60.3174 25.6621 60.5054C26.0695 60.7247 26.5081 60.8814 26.9468 61.0694V61.1007C27.0095 61.0067 27.0721 60.9127 27.1661 60.8187C27.4168 61.038 27.6361 61.226 27.9182 61.4454C27.5108 61.5394 27.2601 61.6334 27.0721 61.6647C27.1348 61.9781 27.1661 62.1974 27.2288 62.4481Z"
              fill="white"
            />
            <path
              d="M53.9577 52.4844L53.143 51.3877C53.049 51.8264 52.9237 52.2337 52.7984 52.6724C52.391 52.7977 51.921 52.8604 51.5137 52.9544L52.6104 53.8004C52.579 54.2391 52.5477 54.7091 52.485 55.1791C52.8924 54.9284 53.2684 54.6464 53.6444 54.3958C54.0831 54.5524 54.5217 54.7091 54.9604 54.8658C54.8351 54.4271 54.6784 53.9884 54.5217 53.5497C54.8037 53.1737 55.0857 52.7977 55.3364 52.4217C54.8664 52.4217 54.3964 52.453 53.9577 52.4844Z"
              fill="white"
            />
            <path
              d="M54.1446 13.6304C52.6719 12.3144 51.0739 11.155 49.3505 10.1523L48.2852 11.9697C54.4266 15.5104 58.8134 21.2446 60.6621 28.1067C60.8814 28.9214 61.0694 29.7674 61.1947 30.5821C61.3201 30.6134 61.4454 30.6761 61.5707 30.7701C61.5081 30.8954 61.4767 31.0834 61.3827 31.0834C61.3514 31.0834 61.3201 31.0834 61.2887 31.1147C61.3827 31.8041 61.4767 32.4934 61.5081 33.1514C61.5707 33.1828 61.6334 33.2454 61.6961 33.2768C61.6334 33.3394 61.5707 33.3708 61.5394 33.4021C61.6961 35.9402 61.4767 38.4782 60.9127 40.9223C61.2261 40.8283 61.5081 40.7343 61.8527 41.0476C61.9154 40.8283 61.9781 40.8909 61.4767 40.5462C61.1321 40.2956 61.1321 40.2956 61.5081 39.8256C61.7901 39.9196 61.8214 40.4522 62.2914 40.3269C62.3228 40.3269 62.4481 40.7029 62.4481 40.6716C62.3228 41.0476 61.9154 41.3923 62.4168 41.7683C62.1034 42.1443 61.8214 42.395 61.3514 42.4263C61.6647 42.9903 61.0694 43.1156 60.9441 43.4603C60.6621 43.4916 60.3801 43.4916 60.1294 43.523C59.722 44.7137 59.2207 45.873 58.6567 47.001C58.7507 47.0637 58.8447 47.1264 58.9387 47.189C58.6567 47.5024 58.5627 47.5964 58.312 47.6277C58.218 47.8157 58.124 48.0037 57.9987 48.1917L59.816 49.2571C63.6388 42.6143 64.6728 34.9061 62.6674 27.5113C61.2261 22.0906 58.2807 17.3278 54.2073 13.6617C54.0193 14.1004 54.1446 14.6644 53.5806 14.8524C52.9852 15.0404 52.6092 14.6331 52.2332 14.1318C52.8912 14.0064 53.2986 13.1604 54.1446 13.6304Z"
              fill="white"
            />
            <path
              d="M61.3518 42.5205C61.4458 41.4864 61.6025 41.2358 61.0071 41.3298C61.1638 41.7371 60.6311 42.2385 61.3518 42.5205Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_2178_12364">
              <rect width="70" height="70" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "checkEnabled":
      iconElement = (
        <svg
          width="70"
          height="70"
          viewBox="0 0 70 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.5" clipPath="url(#clip0_2178_12343)">
            <path
              d="M20.0547 12.5339C20.274 12.5653 20.4934 12.6279 20.744 12.6906L21.2454 13.9753L21.8721 12.816C22.3107 12.816 22.7494 12.8473 23.1881 12.8473L22.3421 11.7506C22.3734 11.6566 22.4047 11.5626 22.4361 11.4686C22.3421 11.4373 22.2481 11.4059 22.0601 11.3433C22.3421 11.0612 22.4674 10.9359 22.6241 10.9986C22.6867 10.8419 22.7494 10.6539 22.8121 10.4972C22.3734 10.6226 21.9347 10.8106 21.496 10.9672C21.2454 10.7792 20.9947 10.6226 20.744 10.4346C20.744 10.6539 20.7754 10.9046 20.6814 11.1866C20.556 10.9046 20.462 10.6852 20.368 10.5286C20.3994 10.8732 20.3994 11.2493 20.4307 11.5939C20.3994 11.6253 20.3367 11.6566 20.3054 11.7193C20.4307 11.7193 20.556 11.7193 20.7127 11.7193C20.7127 12.1266 20.556 12.3773 20.0547 12.5339Z"
              fill="#00C968"
            />
            <path
              d="M19.3965 12.4086C19.4592 12.4086 19.5218 12.44 19.5845 12.44C19.5845 12.3773 19.5845 12.3146 19.5845 12.252C19.4905 12.3146 19.4592 12.346 19.3965 12.4086Z"
              fill="#00C968"
            />
            <path
              d="M28.1686 8.30355C27.8866 7.95888 27.5732 7.6142 27.2599 7.26953C27.1659 7.73954 27.0719 8.17822 27.0092 8.64822L26.3825 8.93023L25.7559 9.24357C26.1945 9.43157 26.6019 9.61958 27.0092 9.83891L27.1972 11.1863L28.1059 10.2463C28.5446 10.3403 28.9519 10.4969 29.3593 10.6223L28.8266 9.3689C29.0773 8.9929 29.3279 8.58556 29.5786 8.20955C29.1086 8.20955 28.6386 8.27222 28.1686 8.30355Z"
              fill="#00C968"
            />
            <path
              d="M15.3846 16.9828L16.1992 18.0795C16.2932 17.6408 16.4186 17.2335 16.5439 16.7948C16.9513 16.6695 17.4213 16.6068 17.8286 16.5128L16.7319 15.6668C16.7633 15.2281 16.7946 14.7581 16.8573 14.2881C16.4499 14.5388 16.0739 14.8208 15.6979 15.0714C15.2592 14.9148 14.8205 14.7581 14.3819 14.6014C14.5072 15.0401 14.6639 15.4788 14.8205 15.9175C14.5385 16.2935 14.2565 16.6695 14.0059 17.0455C14.4759 17.0455 14.9145 17.0141 15.3846 16.9828Z"
              fill="#00C968"
            />
            <path
              d="M25.3802 50.2279C25.4116 49.9146 25.3802 49.8206 25.0669 49.6639C24.5969 49.4446 25.1296 49.1939 25.2549 48.9746C25.1296 48.8492 25.0669 48.7552 24.9102 48.5672C25.2549 48.4105 25.5682 48.2539 25.9129 48.0659C26.0696 48.5985 26.1949 49.0372 26.3203 49.5072C26.9783 49.5072 27.1976 50.0086 27.4796 50.6039C26.9156 50.4786 27.0409 50.3532 26.8216 51.0426L31.9604 54.0193C31.929 53.8 31.9917 53.612 32.211 53.5806C32.3364 53.5493 32.493 53.612 32.587 53.6746L35.1564 49.2252C35.0938 49.2252 35.0624 49.2566 34.9998 49.2566C34.9371 49.2566 34.8744 49.0999 34.8744 49.0686C34.9058 49.0059 34.9998 48.9432 35.1564 48.8492C35.1878 48.9432 35.2191 49.0059 35.2504 49.0686L36.3158 47.2512C36.1904 47.2199 36.0338 47.1885 35.7831 47.0945C36.0338 47.0005 36.2844 46.8752 36.5351 46.9065L37.3498 45.4652C37.2245 45.5278 37.0991 45.5905 36.9111 45.6218C36.5665 44.6818 36.8798 44.2118 37.9138 44.2118C37.8825 44.3685 37.8511 44.4938 37.8198 44.6505L43.1152 35.501C43.0526 35.5636 43.0212 35.595 42.9272 35.6576C42.9586 35.1876 42.9899 34.9056 43.3973 34.9996L46.8753 28.9835C46.844 28.9208 46.7813 28.7955 46.7186 28.6702C46.8127 28.6702 46.938 28.6702 47.032 28.7015L52.0141 20.0533L42.7706 14.7266L28.4196 39.6057L19.3015 34.3416L13.9434 43.6164L25.3802 50.2279Z"
              fill="#00C968"
            />
            <path
              d="M0 34.9999C0 35.1252 0 35.2193 0 35.3446C0.0626679 35.3133 0.125336 35.2819 0.250671 35.2819C0.282005 35.2819 0.407341 35.4386 0.376007 35.4386C0.282005 35.5639 0.219338 35.7206 0.0940018 35.7833C0.0626679 35.7833 0.0313339 35.8146 0 35.8146C0.0313339 37.6633 0.219338 39.4807 0.564011 41.2667C0.658013 41.204 0.72068 41.11 0.783348 40.9847C0.87735 40.7967 1.25336 40.734 1.53536 40.6087C1.62936 40.0447 1.03402 40.2013 0.814682 39.9507C0.689346 39.4807 0.595345 39.0107 0.407341 38.3213C1.06535 38.7913 1.37869 39.3867 1.9427 39.6687C2.09937 39.7313 2.25604 39.8253 2.41271 39.9193C2.38138 39.606 2.31871 39.324 2.28738 39.0107C1.97404 39.1047 1.69203 39.1673 1.41003 38.854C0.814682 38.1646 1.09669 37.5066 1.12802 37.2873C1.53536 37.1306 1.8487 37.068 2.09937 37.162C2.06804 36.8486 2.06804 36.5353 2.03671 36.1906C1.97404 36.1906 1.9427 36.1593 1.88004 36.1593C1.53536 36.0026 1.7547 35.8146 1.91137 35.5639C1.9427 35.5953 1.97404 35.6266 2.00537 35.6579C1.9427 33.0572 2.19338 30.4878 2.75739 28.0124C2.50671 27.7931 2.44405 27.6051 2.50671 27.3858C2.56938 27.1978 2.69472 27.1038 2.97672 27.1351C5.54611 16.7322 13.0976 7.86473 23.6571 4.01066C23.5631 3.91666 23.4691 3.82265 23.3438 3.72865C23.5945 3.66599 23.7511 3.60332 24.0018 3.54065C23.9705 3.66599 23.9705 3.79132 23.9705 3.91666C24.5658 3.69732 25.1925 3.50932 25.8192 3.32131C25.7252 3.03931 25.5998 2.72597 25.4745 2.34996C25.7878 2.44396 27.0412 2.60063 26.7278 3.07064C31.5533 1.81728 36.4414 1.69195 41.0475 2.5693C41.0161 2.53796 41.0161 2.53796 40.9848 2.50663C41.6115 2.34996 41.6741 2.31863 41.9561 2.7573C42.7081 2.91397 43.4288 3.10197 44.1495 3.32131C44.1808 3.28998 44.2122 3.22731 44.2748 3.16464C44.3062 3.25864 44.3375 3.32131 44.3689 3.38398C48.0663 4.48067 51.513 6.20403 54.615 8.49141C54.615 8.39741 54.615 8.27207 54.5837 8.05274C55.1791 8.33474 55.1164 8.14674 54.9597 8.71075C54.9284 8.71075 54.8971 8.67941 54.8657 8.67941C60.5372 12.9408 64.8926 19.0823 66.8666 26.4458C71.5667 43.9927 61.1012 62.1351 43.5542 66.8352C41.7995 67.3052 40.0448 67.6185 38.2587 67.8065C38.3841 67.9945 38.5721 68.1512 38.6034 68.3392C38.7287 69.1226 38.1334 69.1852 37.2874 69.5612C37.6321 68.9032 37.8827 68.3705 38.1647 67.8065C36.41 67.9632 34.624 67.9945 32.9006 67.9005C33.0573 68.0885 33.12 68.1825 32.9946 68.5899C32.9946 68.6212 32.744 68.6212 32.7126 68.5899C32.5246 68.2765 32.65 68.0572 32.744 67.9005C32.368 67.8692 31.9919 67.8379 31.6159 67.8065V67.8379C31.4906 67.8379 31.3966 67.8065 31.3339 67.7752C29.3912 67.5559 27.4485 67.1485 25.5998 66.5845C26.0072 67.0859 25.8818 67.2425 25.1298 67.6812C25.1611 67.4305 25.2865 67.1485 25.2238 67.0232C25.0985 66.8038 25.1298 66.6472 25.2238 66.4905C22.8111 65.7385 20.4924 64.7045 18.3304 63.4198C17.923 63.4198 17.829 63.4198 17.735 63.0751C17.4843 62.9184 17.2337 62.7618 17.0143 62.6051C16.9517 62.6678 16.9517 62.6364 16.795 62.5424C16.795 62.5111 16.8263 62.5111 16.8263 62.4798C10.3402 58.187 5.3581 51.6069 3.19606 43.5541C2.97672 42.7394 2.78872 41.8934 2.63205 41.0787C2.50671 41.0787 2.38138 41.0474 2.19338 41.016C1.8487 41.6114 1.50403 42.1754 0.814682 42.3321C1.00269 43.1781 1.22202 44.0241 1.44136 44.8701C1.50403 44.8074 1.62936 44.7448 1.7547 44.6508C1.6607 44.8074 1.59803 44.9954 1.50403 45.1521C2.38138 48.0975 3.66607 50.8862 5.2641 53.4556L5.29543 53.4243C5.51477 53.2363 5.0761 52.5469 5.82811 52.6722C5.89078 53.1423 5.89078 53.5496 5.48344 53.8629C5.51477 53.9256 5.54611 53.9883 5.60877 54.0509C5.67144 54.0196 5.79678 53.9883 6.01612 53.9256C5.92211 54.0196 5.85945 54.1449 5.76544 54.2703C11.8442 63.4824 22.1531 69.6866 33.9346 70.0312C33.9033 69.9999 33.872 69.9372 33.8406 69.9059C34.0287 69.9686 34.1853 69.9999 34.3107 70.0312C34.53 70.0312 34.7807 70.0312 35 70.0312C43.4915 70.0312 51.2623 67.0232 57.3098 61.9784C57.1218 61.9784 57.0591 61.9471 57.1844 61.5397C57.4351 61.7591 57.4664 61.7591 57.4664 61.8218C61.7905 58.2184 65.2059 53.5496 67.368 48.2855C67.2113 48.3795 67.0546 48.5048 66.8666 48.6302C66.8666 48.1915 66.9606 47.9095 67.3366 47.8155C67.368 47.8155 67.4306 47.8782 67.4933 47.9408C67.5873 47.7215 67.6813 47.4708 67.7753 47.2515C67.7126 47.2515 67.65 47.2515 67.5873 47.2515C67.6813 47.1261 67.8066 47.0008 67.932 46.8128C68.0573 46.4681 68.1826 46.1235 68.2766 45.7788C68.2453 45.7788 68.214 45.8101 68.1826 45.8414C68.308 45.4341 68.4333 45.0268 68.5586 44.5881C68.59 44.5881 68.6213 44.5881 68.6213 44.6194C68.684 44.3688 68.7466 44.1181 68.8406 43.8674C68.778 43.7734 68.8406 43.6481 68.9347 43.4287C69.5927 40.734 69.9687 37.914 69.9687 34.9999C69.9687 25.4431 66.1459 16.7636 59.9105 10.4654C59.8791 10.4654 59.8165 10.4968 59.7851 10.5281C59.4405 10.3714 59.3465 10.1208 59.3151 9.8701C56.6831 7.33205 53.6437 5.17001 50.3223 3.54065C50.291 3.57198 50.2283 3.60332 50.197 3.66599C50.197 3.60332 50.197 3.54065 50.197 3.50932C47.9409 2.34996 45.4655 1.50394 42.9275 0.9086C42.7708 1.19061 42.5515 1.44128 42.2068 1.62928C42.0188 1.75462 41.8308 1.91129 41.5801 1.62928C41.8621 1.47261 41.8621 0.971268 42.3635 1.06527C42.3948 1.06527 42.5201 0.939934 42.5515 0.845932C42.2695 0.783264 41.9875 0.720596 41.7055 0.657928C41.5488 0.75193 41.3295 0.877266 41.0475 1.03394C40.8908 0.814598 40.8908 0.657929 40.9221 0.532593C40.7341 0.501259 40.5148 0.469925 40.3268 0.438591C40.2954 0.595261 40.2954 0.814598 40.3268 1.15927C40.0448 1.37861 39.7628 1.62928 39.4494 1.87995C39.4181 1.66061 39.2928 1.44128 39.3241 1.25327C39.3868 0.814598 39.3868 0.501259 39.2928 0.281921C37.9141 0.125252 36.4727 0.03125 35.0313 0.03125C32.65 0.03125 30.2999 0.281921 28.0439 0.720596C28.0439 0.783264 28.0752 0.877266 28.0439 1.0026C27.8245 0.939934 27.6679 0.877266 27.5739 0.783264C26.4145 1.03394 25.2551 1.34727 24.1271 1.72328C23.9705 1.87995 23.8765 1.91129 23.7511 1.84862C9.93286 6.54871 0 19.615 0 34.9999Z"
              fill="#00C968"
            />
            <path
              d="M8.4283 35.3137C8.36564 30.5823 9.55633 25.9135 12.0004 21.7148L10.183 20.6494C6.36026 27.2922 5.32624 35.0004 7.33162 42.3952C9.30565 49.79 14.0684 55.9628 20.6799 59.8168L21.7452 57.9995C15.6978 54.5214 11.3424 48.9126 9.46232 42.1758C9.46232 42.2385 9.43099 42.2385 9.30565 42.3012C9.05498 41.9252 9.05498 42.0192 9.36832 41.8625C8.96098 40.2958 8.67898 38.7291 8.55364 37.1624C8.52231 37.1937 8.49097 37.2564 8.49097 37.2564C8.52231 38.0397 7.89563 38.1651 7.36295 38.5098C7.17495 38.1337 7.01828 37.8204 6.83027 37.4757C7.17495 37.3817 7.58229 37.3504 7.80162 37.1311C8.02096 36.9431 8.08363 36.5357 8.20897 36.2537C7.98963 36.003 7.80163 35.815 7.58229 35.5644C7.86429 35.345 8.0523 35.1884 8.2403 35.0004C8.27163 35.0944 8.30297 35.157 8.4283 35.3137Z"
              fill="#00C968"
            />
            <path
              d="M35.2824 7.45746C35.0944 7.05012 34.875 6.61144 34.6557 6.2041C34.4677 6.61144 34.2483 7.05012 34.0603 7.45746C33.5903 7.52013 33.1517 7.61413 32.6816 7.73947C33.0576 8.02147 33.4023 8.30348 33.747 8.61682L33.5903 9.99551C33.9663 9.74484 34.311 9.5255 34.7184 9.30616C35.0944 9.49417 35.4704 9.74484 35.8464 9.96417L35.627 8.61682C35.9717 8.30348 36.3164 7.99014 36.6611 7.70813C36.2224 7.55146 35.7524 7.52013 35.2824 7.45746Z"
              fill="#00C968"
            />
            <path
              d="M48.5983 56.8081L48.097 55.5234L47.4703 56.6828C47.0316 56.6828 46.593 56.6515 46.1543 56.6515L47.0003 57.7482C46.875 58.1868 46.7183 58.6255 46.5303 59.0328C46.969 58.9075 47.4077 58.7195 47.8463 58.5628C48.2223 58.8448 48.5983 59.0955 49.0057 59.3462C48.9743 58.8762 48.943 58.4062 48.9117 57.9675C49.2877 57.6855 49.6324 57.3721 49.977 57.0588C49.4757 56.9961 49.037 56.9021 48.5983 56.8081Z"
              fill="#00C968"
            />
            <path
              d="M41.1424 61.1634C41.4244 61.508 41.7377 61.884 42.051 62.2287C42.145 61.7587 42.2391 61.32 42.3017 60.85L42.9284 60.568L43.5551 60.2547C43.2417 60.1293 42.9597 59.9727 42.6777 59.8473C42.6777 59.8787 42.6777 59.8787 42.6464 59.91C42.4271 60.2547 42.0824 59.8787 41.2364 59.252C40.7977 59.158 40.3903 59.0013 39.983 58.876L40.5157 60.1293C40.265 60.5053 40.0143 60.9127 39.7637 61.2887C40.2337 61.2574 40.6724 61.1947 41.1424 61.1634Z"
              fill="#00C968"
            />
            <path
              d="M42.2703 59.1899L42.145 58.2812L41.2363 59.2213C41.7063 59.0959 42.051 59.0959 42.2703 59.1899Z"
              fill="#00C968"
            />
            <path
              d="M34.0291 62.041C34.2171 62.4483 34.4364 62.887 34.6558 63.2943C34.8438 62.887 35.0631 62.4483 35.2511 62.041C35.7211 61.9783 36.1598 61.8843 36.6298 61.759C36.2538 61.477 35.9091 61.195 35.5645 60.8816L35.7211 59.5029C35.3451 59.7536 35.0004 59.9729 34.5931 60.1923C34.2171 60.0043 33.8411 59.7536 33.4651 59.5343L33.6844 60.8816C33.3397 61.195 32.9951 61.5083 32.6504 61.7903C33.1204 61.9156 33.5591 61.947 34.0291 62.041Z"
              fill="#00C968"
            />
            <path
              d="M41.3929 9.99536C41.7062 10.3087 42.0196 10.622 42.3329 10.9354L42.4582 9.55669C42.8656 9.33735 43.2729 9.11801 43.6803 8.93001C43.2729 8.71067 42.8342 8.554 42.3956 8.366C42.3016 7.92732 42.2076 7.45731 42.1136 6.9873C41.8002 7.33198 41.5182 7.70799 41.2362 8.08399C40.7662 8.05266 40.2962 8.02132 39.8262 7.98999C40.1082 8.366 40.3902 8.71067 40.6409 9.11801L40.1395 10.4027L41.3929 9.99536Z"
              fill="#00C968"
            />
            <path
              d="M27.2288 62.4481C27.5421 62.1034 27.8241 61.7274 28.1062 61.3514C28.5762 61.3827 29.0462 61.4141 29.5162 61.4454C29.2342 61.0694 28.9522 60.7247 28.7015 60.3174L29.2028 59.0327L27.9495 59.44C27.6361 59.1267 27.3228 58.8133 27.0095 58.5L26.8841 59.8787C26.4768 60.098 26.0695 60.3174 25.6621 60.5054C26.0695 60.7247 26.5081 60.8814 26.9468 61.0694V61.1007C27.0095 61.0067 27.0721 60.9127 27.1661 60.8187C27.4168 61.038 27.6361 61.226 27.9182 61.4454C27.5108 61.5394 27.2601 61.6334 27.0721 61.6647C27.1348 61.9781 27.1661 62.1974 27.2288 62.4481Z"
              fill="#00C968"
            />
            <path
              d="M53.9577 52.4844L53.143 51.3877C53.049 51.8264 52.9237 52.2337 52.7984 52.6724C52.391 52.7977 51.921 52.8604 51.5137 52.9544L52.6104 53.8004C52.579 54.2391 52.5477 54.7091 52.485 55.1791C52.8924 54.9284 53.2684 54.6464 53.6444 54.3958C54.0831 54.5524 54.5217 54.7091 54.9604 54.8658C54.8351 54.4271 54.6784 53.9884 54.5217 53.5497C54.8037 53.1737 55.0857 52.7977 55.3364 52.4217C54.8664 52.4217 54.3964 52.453 53.9577 52.4844Z"
              fill="#00C968"
            />
            <path
              d="M54.1446 13.6304C52.6719 12.3144 51.0739 11.155 49.3505 10.1523L48.2852 11.9697C54.4266 15.5104 58.8134 21.2446 60.6621 28.1067C60.8814 28.9214 61.0694 29.7674 61.1947 30.5821C61.3201 30.6134 61.4454 30.6761 61.5707 30.7701C61.5081 30.8954 61.4767 31.0834 61.3827 31.0834C61.3514 31.0834 61.3201 31.0834 61.2887 31.1147C61.3827 31.8041 61.4767 32.4934 61.5081 33.1514C61.5707 33.1828 61.6334 33.2454 61.6961 33.2768C61.6334 33.3394 61.5707 33.3708 61.5394 33.4021C61.6961 35.9402 61.4767 38.4782 60.9127 40.9223C61.2261 40.8283 61.5081 40.7343 61.8527 41.0476C61.9154 40.8283 61.9781 40.8909 61.4767 40.5462C61.1321 40.2956 61.1321 40.2956 61.5081 39.8256C61.7901 39.9196 61.8214 40.4522 62.2914 40.3269C62.3228 40.3269 62.4481 40.7029 62.4481 40.6716C62.3228 41.0476 61.9154 41.3923 62.4168 41.7683C62.1034 42.1443 61.8214 42.395 61.3514 42.4263C61.6647 42.9903 61.0694 43.1156 60.9441 43.4603C60.6621 43.4916 60.3801 43.4916 60.1294 43.523C59.722 44.7137 59.2207 45.873 58.6567 47.001C58.7507 47.0637 58.8447 47.1264 58.9387 47.189C58.6567 47.5024 58.5627 47.5964 58.312 47.6277C58.218 47.8157 58.124 48.0037 57.9987 48.1917L59.816 49.2571C63.6388 42.6143 64.6728 34.9061 62.6674 27.5113C61.2261 22.0906 58.2807 17.3278 54.2073 13.6617C54.0193 14.1004 54.1446 14.6644 53.5806 14.8524C52.9852 15.0404 52.6092 14.6331 52.2332 14.1318C52.8912 14.0064 53.2986 13.1604 54.1446 13.6304Z"
              fill="#00C968"
            />
            <path
              d="M61.3518 42.5205C61.4458 41.4864 61.6025 41.2358 61.0071 41.3298C61.1638 41.7371 60.6311 42.2385 61.3518 42.5205Z"
              fill="#00C968"
            />
          </g>
          <defs>
            <clipPath id="clip0_2178_12343">
              <rect width="70" height="70" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "closeSigner":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.6654 4.2735L11.7254 3.3335L7.9987 7.06016L4.27203 3.3335L3.33203 4.2735L7.0587 8.00016L3.33203 11.7268L4.27203 12.6668L7.9987 8.94016L11.7254 12.6668L12.6654 11.7268L8.9387 8.00016L12.6654 4.2735Z"
            fill="#222D4B"
          />
        </svg>
      )
      break
    case "iconPdf":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM16 12V9C16 8.45 15.55 8 15 8H13V13H15C15.55 13 16 12.55 16 12ZM14 9H15V12H14V9ZM18 11H19V10H18V9H19V8H17V13H18V11ZM10 11H11C11.55 11 12 10.55 12 10V9C12 8.45 11.55 8 11 8H9V13H10V11ZM10 9H11V10H10V9Z"
            fill="#222D4B"
          />
        </svg>
      )
      break
    case "trashIcon":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
            fill="#E50500"
          />
        </svg>
      )
      break
    case "uploadProfile":
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5 24H22.5V15H28.5L18 4.5L7.5 15H13.5V24ZM18 8.745L21.255 12H19.5V21H16.5V12H14.745L18 8.745ZM7.5 27H28.5V30H7.5V27Z"
            fill="#00C968"
          />
        </svg>
      )
      break
    case "noticePartner":
      iconElement = (
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.4043 7H13.4043V9H11.4043V7ZM11.4043 11H13.4043V17H11.4043V11ZM12.4043 2C6.8843 2 2.4043 6.48 2.4043 12C2.4043 17.52 6.8843 22 12.4043 22C17.9243 22 22.4043 17.52 22.4043 12C22.4043 6.48 17.9243 2 12.4043 2ZM12.4043 20C7.9943 20 4.4043 16.41 4.4043 12C4.4043 7.59 7.9943 4 12.4043 4C16.8143 4 20.4043 7.59 20.4043 12C20.4043 16.41 16.8143 20 12.4043 20Z"
            fill="#0D99FF"
          />
        </svg>
      )
      break
    case "partner":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 6H17V4C17 2.89 16.11 2 15 2H9C7.89 2 7 2.89 7 4V6H4C2.89 6 2 6.89 2 8V19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM9 4H15V6H9V4ZM20 19H4V17H20V19ZM20 14H4V8H7V10H9V8H15V10H17V8H20V14Z"
            fill="rgba(0, 0, 0, 0.5)"
          />
        </svg>
      )
      break
    case "exportStatistic":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 9H15V3H9V9H5L12 16L19 9ZM11 11V5H13V11H14.17L12 13.17L9.83 11H11ZM5 18H19V20H5V18Z"
            fill="white"
          />
        </svg>
      )
      break
    case "editTypeConfig":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
            fill="#0D99FF"
          />
        </svg>
      )
      break
    case "configTypeProfile":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.4308 12.98C19.4708 12.66 19.5008 12.34 19.5008 12C19.5008 11.66 19.4708 11.34 19.4308 11.02L21.5408 9.37C21.7308 9.22 21.7808 8.95 21.6608 8.73L19.6608 5.27C19.5708 5.11 19.4008 5.02 19.2208 5.02C19.1608 5.02 19.1008 5.03 19.0508 5.05L16.5608 6.05C16.0408 5.65 15.4808 5.32 14.8708 5.07L14.4908 2.42C14.4608 2.18 14.2508 2 14.0008 2H10.0008C9.75082 2 9.54082 2.18 9.51082 2.42L9.13082 5.07C8.52082 5.32 7.96082 5.66 7.44082 6.05L4.95082 5.05C4.89082 5.03 4.83082 5.02 4.77082 5.02C4.60082 5.02 4.43082 5.11 4.34082 5.27L2.34082 8.73C2.21082 8.95 2.27082 9.22 2.46082 9.37L4.57082 11.02C4.53082 11.34 4.50082 11.67 4.50082 12C4.50082 12.33 4.53082 12.66 4.57082 12.98L2.46082 14.63C2.27082 14.78 2.22082 15.05 2.34082 15.27L4.34082 18.73C4.43082 18.89 4.60082 18.98 4.78082 18.98C4.84082 18.98 4.90082 18.97 4.95082 18.95L7.44082 17.95C7.96082 18.35 8.52082 18.68 9.13082 18.93L9.51082 21.58C9.54082 21.82 9.75082 22 10.0008 22H14.0008C14.2508 22 14.4608 21.82 14.4908 21.58L14.8708 18.93C15.4808 18.68 16.0408 18.34 16.5608 17.95L19.0508 18.95C19.1108 18.97 19.1708 18.98 19.2308 18.98C19.4008 18.98 19.5708 18.89 19.6608 18.73L21.6608 15.27C21.7808 15.05 21.7308 14.78 21.5408 14.63L19.4308 12.98ZM17.4508 11.27C17.4908 11.58 17.5008 11.79 17.5008 12C17.5008 12.21 17.4808 12.43 17.4508 12.73L17.3108 13.86L18.2008 14.56L19.2808 15.4L18.5808 16.61L17.3108 16.1L16.2708 15.68L15.3708 16.36C14.9408 16.68 14.5308 16.92 14.1208 17.09L13.0608 17.52L12.9008 18.65L12.7008 20H11.3008L11.1108 18.65L10.9508 17.52L9.89082 17.09C9.46082 16.91 9.06082 16.68 8.66082 16.38L7.75082 15.68L6.69082 16.11L5.42082 16.62L4.72082 15.41L5.80082 14.57L6.69082 13.87L6.55082 12.74C6.52082 12.43 6.50082 12.2 6.50082 12C6.50082 11.8 6.52082 11.57 6.55082 11.27L6.69082 10.14L5.80082 9.44L4.72082 8.6L5.42082 7.39L6.69082 7.9L7.73082 8.32L8.63082 7.64C9.06082 7.32 9.47082 7.08 9.88082 6.91L10.9408 6.48L11.1008 5.35L11.3008 4H12.6908L12.8808 5.35L13.0408 6.48L14.1008 6.91C14.5308 7.09 14.9308 7.32 15.3308 7.62L16.2408 8.32L17.3008 7.89L18.5708 7.38L19.2708 8.59L18.2008 9.44L17.3108 10.14L17.4508 11.27ZM12.0008 8C9.79082 8 8.00082 9.79 8.00082 12C8.00082 14.21 9.79082 16 12.0008 16C14.2108 16 16.0008 14.21 16.0008 12C16.0008 9.79 14.2108 8 12.0008 8ZM12.0008 14C10.9008 14 10.0008 13.1 10.0008 12C10.0008 10.9 10.9008 10 12.0008 10C13.1008 10 14.0008 10.9 14.0008 12C14.0008 13.1 13.1008 14 12.0008 14Z"
            fill="#F57C00"
          />
        </svg>
      )
      break
    case "searchStatistic":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
            fill="#222D4B"
          />
        </svg>
      )
      break
    case "statistic":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z"
            fill="rgba(0, 0, 0, 0.5)"
          />
        </svg>
      )
      break
    case "warningInactive":
      iconElement = (
        <svg
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M59.9997 93.333C63.6663 93.333 66.6663 90.333 66.6663 86.6663H53.333C53.333 90.333 56.333 93.333 59.9997 93.333ZM79.9997 73.333V56.6663C79.9997 46.433 74.5663 37.8663 64.9997 35.5997V33.333C64.9997 30.5663 62.7663 28.333 59.9997 28.333C57.233 28.333 54.9997 30.5663 54.9997 33.333V35.5997C45.4663 37.8663 39.9997 46.3997 39.9997 56.6663V73.333L33.333 79.9997V83.333H86.6663V79.9997L79.9997 73.333ZM73.333 76.6663H46.6663V56.6663C46.6663 48.3997 51.6997 41.6663 59.9997 41.6663C68.2997 41.6663 73.333 48.3997 73.333 56.6663V76.6663Z"
            fill="#F57C00"
          />
          <circle
            cx="60"
            cy="60"
            r="59.5"
            stroke="#F57C00"
            strokeDasharray="5 5"
          />
        </svg>
      )
      break
    case "closeTab":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="10" r="10" fill="white" />
          <path
            d="M14.6668 6.2735L13.7268 5.3335L10.0002 9.06016L6.2735 5.3335L5.3335 6.2735L9.06016 10.0002L5.3335 13.7268L6.2735 14.6668L10.0002 10.9402L13.7268 14.6668L14.6668 13.7268L10.9402 10.0002L14.6668 6.2735Z"
            fill="#323232"
          />
        </svg>
      )
      break
    case "defaultAvatar":
      iconElement = (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="20" cy="20" r="20" fill="#F4F4F4" />
          <path
            d="M20 14C21.1 14 22 14.9 22 16C22 17.1 21.1 18 20 18C18.9 18 18 17.1 18 16C18 14.9 18.9 14 20 14ZM20 23C22.7 23 25.8 24.29 26 25V26H14V25.01C14.2 24.29 17.3 23 20 23ZM20 12C17.79 12 16 13.79 16 16C16 18.21 17.79 20 20 20C22.21 20 24 18.21 24 16C24 13.79 22.21 12 20 12ZM20 21C17.33 21 12 22.34 12 25V28H28V25C28 22.34 22.67 21 20 21Z"
            fill="#626262"
          />
        </svg>
      )
      break
    case "bigLogo":
      iconElement = (
        <svg
          width="264"
          height="45"
          viewBox="0 0 264 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path
              d="M28.2558 27.1657C28.186 23.1565 27.8372 20.2532 27.0698 18.2486C26.3023 16.1058 24.7674 14.5159 22.6047 13.6173C20.5814 12.7878 17.6512 12.373 13.7442 12.373C9.69767 12.373 6.76744 12.9952 4.81395 14.3085C2.7907 15.6219 1.46512 17.5574 0.837209 19.9767C0.27907 22.1887 0 25.2993 0 29.3085C0 32.2118 0.209302 34.6311 0.55814 36.4975C0.976744 38.5021 1.67442 40.0919 2.7907 41.3362C3.83721 42.5804 5.37209 43.5482 7.32558 44.1012C9.13953 44.6542 11.5814 44.8615 14.4419 44.8615C17.5116 44.8615 19.9535 44.6542 21.7674 44.2394C23.7907 43.8247 25.3953 42.7878 26.5116 41.1979C27.6977 39.6772 28.2558 37.3961 28.2558 34.3546V33.3178H21.4884V35.3224C21.4884 37.8108 20.5116 38.2256 20.1628 38.433C19.0465 38.986 17.2326 39.1933 14.9302 39.1933H13.7442C11.4419 39.1933 9.76744 38.8477 8.86047 38.1565C7.95349 37.4652 7.39535 36.5666 7.18605 35.4606C6.97674 34.2855 6.83721 32.6265 6.83721 30.4836H28.3256V27.1657H28.2558ZM6.76744 24.9537C6.83721 23.1565 7.04651 21.7048 7.39535 20.7371C7.74419 19.7002 8.37209 19.009 9.34884 18.5942C10.3953 18.1104 12 17.903 14.1628 17.903C16.6047 17.903 18.4186 18.1104 19.4651 18.5942C20.3721 18.9399 20.9302 19.562 21.1395 20.5297C21.4186 21.4975 21.5581 23.0182 21.6279 25.0919H6.76744V24.9537Z"
              fill="#0D99FF"
            />
            <path
              d="M66.2791 30.9677C66.2094 30.1382 66.2094 29.5161 66.2094 29.1014V28.0645H59.3721V29.1014C59.3721 29.5853 59.3721 30.4147 59.4419 31.5207C59.5117 32.6267 59.5117 33.3871 59.5117 33.871C59.4419 35.7373 58.6745 36.9124 57.1396 37.6037C55.3954 38.3641 53.0931 38.7097 50.3721 38.7097C49.8838 38.7097 49.1861 38.7097 48.2791 38.6406C47.3721 38.5714 46.7442 38.5714 46.3954 38.5714C42.2094 38.5714 39.628 37.8111 38.7908 36.4286C37.7442 34.5622 37.2559 30.8295 37.2559 25.2304V15.4147C37.2559 13.2719 37.3954 11.5438 37.7442 10.2995C38.0233 9.19355 38.5815 8.36406 39.4187 7.74194C40.3256 7.11982 41.6512 6.70507 43.4652 6.56682C46.7442 6.35945 49.7442 6.2212 52.3954 6.2212C54.4187 6.2212 55.9535 6.4977 56.8605 7.05069C57.6977 7.53456 58.2559 8.22581 58.4652 9.19355C58.7442 10.3687 58.8838 12.0968 58.8838 14.447V15.4839H65.7907L65.721 14.3779C65.5117 11.3364 65.1628 8.84793 64.7442 7.05069C64.2559 5.18433 63.4187 3.66359 62.2326 2.62673C61.1163 1.58986 59.5117 0.898618 57.628 0.483871C55.8838 0.207373 53.4419 0 50.3721 0C46.5349 0 43.7442 0.138249 41.9303 0.345622C38.9303 0.691244 36.4884 1.52074 34.7442 2.8341C33.0001 4.14747 31.7442 5.9447 31.0466 8.15668C30.4187 10.2304 30.0698 12.7189 30.0698 15.6912V22.4654C30.1396 24.47 30.2094 26.8203 30.2791 29.5853C30.4187 32.4194 30.7675 34.9078 31.4652 36.9816C32.1628 39.1244 33.4884 40.9217 35.3024 42.3733C37.1163 43.7558 39.6977 44.5853 42.907 44.7926H48.9768C51.2791 44.7926 53.5814 44.7235 55.8838 44.5853C62.721 43.9631 66.3489 39.9539 66.3489 33.1106C66.4187 32.5576 66.3489 31.8664 66.2791 30.9677Z"
              fill="#1F2A49"
            />
            <path
              d="M96.1394 18.3874C95.3022 16.1063 93.7673 14.4473 91.6045 13.5487C89.5115 12.6501 86.5115 12.2354 82.5347 12.2354C78.7673 12.2354 75.9766 12.7883 73.9533 13.8252C71.9301 14.9312 70.4649 16.6593 69.7673 19.0095C69.1394 21.1524 68.7905 24.1248 68.7905 27.7883V30.6224C68.7905 34.4934 69.2091 37.3966 70.1161 39.4012C71.0929 41.5441 72.6975 43.0648 74.9301 43.8943C77.0231 44.6547 79.9533 45.0003 83.7905 45.0003C87.9068 45.0003 90.9068 44.3091 92.9301 42.8575C94.9533 41.4059 96.2091 39.4012 96.6277 36.9819C97.0463 34.7699 97.2556 31.5902 97.2556 27.5118C97.2556 23.5026 96.9068 20.5303 96.1394 18.3874ZM90.4184 27.1662C90.4184 30.0695 90.4184 32.3506 90.3487 33.8713C90.2789 35.4612 89.9301 36.7054 89.4417 37.4658C88.9533 38.157 88.2557 38.6409 87.4184 38.8483C86.3719 39.1248 84.9766 39.263 83.1626 39.263H80.9301C78.3487 39.263 77.3022 38.7791 76.8836 38.3644C76.1859 37.604 75.3487 35.5994 75.3487 30.2768V26.8206C75.3487 23.9865 75.558 21.9128 75.9068 20.6685C76.1859 19.6317 76.8138 18.9404 77.7208 18.5948C78.7673 18.1801 80.5812 17.9036 83.1626 17.9036H84.1394C86.8603 17.9036 88.1161 18.3183 88.6743 18.733C89.4417 19.2169 89.9301 19.9773 90.1394 21.0142C90.2789 22.3275 90.4184 24.4012 90.4184 27.1662Z"
              fill="#1F2A49"
            />
            <path
              d="M125.861 17.0741C125.023 15.2769 123.698 13.9635 121.954 13.2032C120.209 12.4428 117.977 12.0972 115.116 12.0972C112.675 12.0972 110.512 12.4428 108.698 13.134C107.651 13.5488 106.744 14.1018 105.907 14.8621V12.7884H99.7676V44.5165H106.326V25.2999C106.326 20.1847 108.837 17.8345 114.14 17.8345C116.093 17.8345 117.489 18.0419 118.395 18.3875C119.163 18.7331 119.651 19.217 119.93 19.9774C120.279 20.876 120.419 22.3276 120.419 24.1939V44.5165H127.047V23.8483C127.047 21.0142 126.628 18.7331 125.861 17.0741Z"
              fill="#1F2A49"
            />
            <path
              d="M146.163 32.0044V34.9076C146.163 36.9813 145.814 37.9491 145.535 38.3638C145.256 38.8477 144.279 39.1242 142.884 39.1242C141 39.1242 140.442 38.7094 140.302 38.5021C140.093 38.2256 139.744 37.5343 139.744 35.5297V18.456H151.256V12.7878H139.744V5.66797H133.116V12.7878H129.209V18.456H133.116V35.5297C133.116 37.8108 133.396 39.6081 134.023 40.9214C134.651 42.373 135.768 43.4099 137.302 44.032C138.698 44.585 140.512 44.8615 142.884 44.8615C146.721 44.8615 149.372 43.8246 150.628 41.6818C151.814 39.6772 152.442 36.9122 152.442 33.0412V32.0044H146.163Z"
              fill="#1F2A49"
            />
            <path
              d="M168.349 12.0972C165.488 12.0972 163.116 12.8575 161.302 14.3783V12.7884H154.884V44.5165H161.442V23.7101C161.442 19.7009 163.326 17.8345 167.372 17.8345C169.116 17.8345 170.233 18.2492 170.721 19.0096C171.279 19.9774 171.628 21.4981 171.628 23.5718V24.6087H178.047V23.5718C178.047 14.1018 172.744 12.0972 168.349 12.0972Z"
              fill="#1F2A49"
            />
            <path
              d="M206.512 16.9353C205.395 15.2072 203.791 14.0321 201.698 13.4791C199.814 12.9952 197.233 12.7188 194.093 12.7188C189.768 12.7188 186.698 13.2717 184.605 14.3777C182.372 15.622 181.186 18.3178 181.186 22.3962V23.433H187.884V22.3962C187.884 22.1197 187.814 21.9123 187.744 21.6358C187.675 21.4284 187.675 21.3593 187.675 21.3593C187.675 20.1842 187.954 19.3547 188.581 18.9399C189.14 18.5252 190.465 17.9722 193.674 17.9722C196.116 17.9722 197.93 18.1105 198.977 18.4561C199.814 18.7326 200.372 19.2164 200.721 20.1151C201.14 21.1519 201.279 22.8109 201.279 25.1611V26.1289C200.581 25.645 199.744 25.2994 198.837 25.092C197.233 24.7464 195.209 24.539 192.768 24.539C190.116 24.539 187.954 24.7464 186.209 25.2303C184.326 25.7141 182.791 26.751 181.744 28.2026C180.698 29.6542 180.14 31.7971 180.14 34.4929C180.14 37.3271 180.628 39.4699 181.675 40.9906C182.721 42.5805 184.186 43.6174 186.14 44.1704C187.884 44.6542 190.186 44.9307 192.977 44.9307C195.488 44.9307 197.581 44.6542 199.256 44.1704C200.163 43.8939 201 43.4791 201.768 42.9261L201.628 44.3777H208.047V24.1934C208.116 20.9446 207.558 18.5943 206.512 16.9353ZM201.698 34.7694C201.698 36.2211 201.349 37.1888 200.581 37.8109C199.744 38.5022 198.768 38.9169 197.581 39.0552C196.326 39.2625 194.651 39.3317 192.768 39.3317C189.907 39.3317 188.651 38.7787 188.093 38.2948C187.326 37.6727 186.977 36.2211 186.977 34.0782C186.977 32.0045 187.465 31.3823 187.605 31.2441L187.675 31.175C188.093 30.7602 189.419 30.1381 193.326 30.1381H194.442C197.023 30.1381 198.977 30.4146 200.233 31.0367C201.209 31.5206 201.698 32.7648 201.698 34.7694Z"
              fill="#1F2A49"
            />
            <path
              d="M232.047 31.5894V32.6262C232.047 34.7691 231.837 36.2898 231.419 37.1884C231.07 37.9488 230.512 38.4327 229.605 38.7092C228.558 38.9857 226.884 39.1239 224.581 39.1239C222.279 39.1239 220.605 38.8474 219.628 38.2253C218.721 37.6723 218.163 36.9119 217.884 35.8059C217.605 34.5617 217.465 32.6262 217.465 30.1377V27.1654C217.465 24.3313 217.674 22.2576 218.023 20.9442C218.372 19.9073 218.93 19.147 219.907 18.8013C221.023 18.3175 222.837 18.1101 225.419 18.1101C227.093 18.1101 228.419 18.2483 229.326 18.594C230.093 18.8705 230.581 19.2852 230.93 19.9765C231.349 20.7368 231.488 21.9119 231.488 23.5709V24.6078H237.907V22.6032C237.907 18.594 236.651 15.8981 234.279 14.4465C232.047 13.1331 228.907 12.4419 224.86 12.4419C221.163 12.4419 218.372 12.9258 216.279 14.0318C214.116 15.1377 212.651 16.7967 211.814 19.0778C211.047 21.2207 210.628 24.1239 210.628 27.7184C210.628 31.0364 210.767 33.6631 210.977 35.4603C211.186 37.3958 211.814 39.1239 212.721 40.5064C213.698 41.958 215.163 43.064 217.186 43.7553C219.07 44.4465 221.581 44.723 224.86 44.723C228.209 44.723 230.721 44.4465 232.605 43.8244C234.628 43.1331 236.163 41.8889 237.14 40.0917C238.047 38.3636 238.535 35.9442 238.535 32.6953V31.6585H232.047V31.5894Z"
              fill="#1F2A49"
            />
            <path
              d="M257.721 32.0044V34.9076C257.721 36.9813 257.372 37.9491 257.093 38.3638C256.814 38.8477 255.837 39.1242 254.442 39.1242C252.558 39.1242 252 38.7094 251.861 38.5021C251.651 38.2256 251.302 37.5343 251.302 35.5297V18.456H262.814V12.7878H251.302V5.66797H244.675V12.7878H240.768V18.456H244.675V35.5297C244.675 37.8108 244.954 39.6081 245.582 40.9214C246.209 42.373 247.326 43.4099 248.861 44.032C250.256 44.585 252.07 44.8615 254.442 44.8615C258.279 44.8615 260.93 43.8246 262.186 41.6818C263.372 39.6772 264 36.9122 264 33.0412V32.0044H257.721Z"
              fill="#1F2A49"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="264" height="45" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "signMethod":
      iconElement = (
        <svg
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M66.6665 40L63.3332 33.3333H36.6665V90H43.3332V66.6667H59.9998L63.3332 73.3333H86.6665V40H66.6665ZM79.9998 66.6667H66.6665L63.3332 60H43.3332V40H59.9998L63.3332 46.6667H79.9998V66.6667Z"
            fill="#0D99FF"
          />
          <circle
            cx="60"
            cy="60"
            r="59.5"
            stroke="#0D99FF"
            strokeDasharray="5 5"
          />
        </svg>
      )
      break
    case "trashRed":
      iconElement = (
        <svg
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M40.0003 83.3333C40.0003 87 43.0003 90 46.667 90H73.3337C77.0003 90 80.0003 87 80.0003 83.3333V43.3333H40.0003V83.3333ZM46.667 50H73.3337V83.3333H46.667V50ZM71.667 33.3333L68.3337 30H51.667L48.3337 33.3333H36.667V40H83.3337V33.3333H71.667Z"
            fill="#E50500"
          />
          <circle
            cx="60"
            cy="60"
            r="59.5"
            stroke="#E50500"
            strokeDasharray="5 5"
          />
        </svg>
      )
      break
    case "logoutIcon":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 7L9.6 8.4L12.2 11H2V13H12.2L9.6 15.6L11 17L16 12L11 7ZM20 19H12V21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3H12V5H20V19Z"
            fill="#222D4B"
          />
        </svg>
      )
      break
    case "updateUnit":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19Z"
            fill="white"
          />
        </svg>
      )
      break
    case "warningCKS":
      iconElement = (
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.9148 5.99L20.4156 19H5.41406L12.9148 5.99ZM12.9148 2L1.95752 21H23.8722L12.9148 2ZM13.911 16H11.9187V18H13.911V16ZM13.911 10H11.9187V14H13.911V10Z"
            fill="#F57C00"
          />
        </svg>
      )
      break
    case "warningAmber":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 5.99L19.53 19H4.47L12 5.99ZM12 2L1 21H23L12 2ZM13 16H11V18H13V16ZM13 10H11V14H13V10Z"
            fill="#E50500"
          />
        </svg>
      )
      break
    case "arrowDownTree":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.5 4.5L8 12L0.5 4.5"
            stroke="#868E96"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "undo":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 16H16C19.866 16 23 12.866 23 9C23 5.134 19.866 2 16 2H9"
            stroke="#219653"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 11L2 16L7 21"
            stroke="#219653"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "refresh":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 6V9L16 5L12 1V4C7.58 4 4 7.58 4 12C4 13.57 4.46 15.03 5.24 16.26L6.7 14.8C6.25 13.97 6 13.01 6 12C6 8.69 8.69 6 12 6ZM18.76 7.74L17.3 9.2C17.74 10.04 18 10.99 18 12C18 15.31 15.31 18 12 18V15L8 19L12 23V20C16.42 20 20 16.42 20 12C20 10.43 19.54 8.97 18.76 7.74Z"
            fill="#00C968"
          />
        </svg>
      )
    case "refresh-white":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 6V9L16 5L12 1V4C7.58 4 4 7.58 4 12C4 13.57 4.46 15.03 5.24 16.26L6.7 14.8C6.25 13.97 6 13.01 6 12C6 8.69 8.69 6 12 6ZM18.76 7.74L17.3 9.2C17.74 10.04 18 10.99 18 12C18 15.31 15.31 18 12 18V15L8 19L12 23V20C16.42 20 20 16.42 20 12C20 10.43 19.54 8.97 18.76 7.74Z"
            fill="#FFF"
          />
        </svg>
      )
      break
    case "refresh-blue":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.33398 7.99998C1.33398 4.33331 4.33398 1.33331 8.00065 1.33331C10.6007 1.33331 12.8673 2.79998 13.934 4.99998"
            stroke="#448AFF"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.6664 8C14.6664 11.6667 11.6664 14.6667 7.99974 14.6667C5.39974 14.6667 3.13307 13.2 2.06641 11"
            stroke="#448AFF"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.5333 1.13336L14 5.0667L10 4.53336"
            stroke="#448AFF"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.4668 14.8667L2.00013 10.9333L6.00013 11.4667"
            stroke="#448AFF"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "users":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.992 18.7371L8.2 20.4001C8.704 20.7781 9 21.3701 9 22.0001V23.0001H1V22.0001C1 21.3701 1.296 20.7781 1.8 20.4001L4.008 18.7371"
            stroke="#F2994A"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 19C3.895 19 3 18.105 3 17V16C3 14.895 3.895 14 5 14C6.105 14 7 14.895 7 16V17C7 18.105 6.105 19 5 19Z"
            stroke="#F2994A"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.992 5.73706L15.2 7.40006C15.704 7.77806 16 8.37006 16 9.00006V10.0001H8V9.00006C8 8.37006 8.296 7.77806 8.8 7.40006L11.008 5.73706"
            stroke="#F2994A"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 6C10.895 6 10 5.105 10 4V3C10 1.895 10.895 1 12 1C13.105 1 14 1.895 14 3V4C14 5.105 13.105 6 12 6Z"
            stroke="#F2994A"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.992 18.7371L22.2 20.4001C22.704 20.7781 23 21.3701 23 22.0001V23.0001H15V22.0001C15 21.3701 15.296 20.7781 15.8 20.4001L18.008 18.7371"
            stroke="#F2994A"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19 19C17.895 19 17 18.105 17 17V16C17 14.895 17.895 14 19 14C20.105 14 21 14.895 21 16V17C21 18.105 20.105 19 19 19Z"
            stroke="#F2994A"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "restore":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 6C12.5523 6 13 6.44772 13 7V11.5858L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12V7C11 6.44772 11.4477 6 12 6Z"
            fill="#24B8CC"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.20019 7.06373C3.96759 3.41846 7.71737 1 12 1C18.0523 1 23 5.94772 23 12C23 18.0523 18.0523 23 12 23C5.94772 23 1 18.0523 1 12C1 11.4477 1.44772 11 2 11C2.55228 11 3 11.4477 3 12C3 16.9477 7.05228 21 12 21C16.9477 21 21 16.9477 21 12C21 7.05228 16.9477 3 12 3C8.48263 3 5.43241 4.98154 3.99981 7.93627C3.75887 8.43323 3.16068 8.64076 2.66373 8.39981C2.16677 8.15887 1.95924 7.56068 2.20019 7.06373Z"
            fill="#24B8CC"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.09664 1.58406C2.64116 1.49172 3.15742 1.85828 3.24976 2.4028L3.91857 6.34687L7.86264 5.67806C8.40716 5.58572 8.92342 5.95228 9.01576 6.4968C9.10809 7.04131 8.74153 7.55757 8.19702 7.64991L3.26702 8.48591C3.00554 8.53025 2.73715 8.4689 2.5209 8.31536C2.30465 8.16181 2.15825 7.92865 2.11391 7.66717L1.27791 2.73717C1.18557 2.19266 1.55213 1.67639 2.09664 1.58406Z"
            fill="#24B8CC"
          />
        </svg>
      )
      break
    case "back":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 2C8 1.44772 8.44772 1 9 1H16C20.4183 1 24 4.58172 24 9C24 13.4183 20.4183 17 16 17H2C1.44772 17 1 16.5523 1 16C1 15.4477 1.44772 15 2 15H16C19.3137 15 22 12.3137 22 9C22 5.68628 19.3137 3 16 3H9C8.44772 3 8 2.55228 8 2Z"
            fill="#219653"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.70711 10.2929C8.09763 10.6834 8.09763 11.3166 7.70711 11.7071L3.41421 16L7.70711 20.2929C8.09763 20.6834 8.09763 21.3166 7.70711 21.7071C7.31658 22.0976 6.68342 22.0976 6.29289 21.7071L1.29289 16.7071C0.902369 16.3166 0.902369 15.6834 1.29289 15.2929L6.29289 10.2929C6.68342 9.90237 7.31658 9.90237 7.70711 10.2929Z"
            fill="#219653"
          />
        </svg>
      )
      break
    case "remove":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4142 12.0002L17.7072 7.70725C18.0982 7.31625 18.0982 6.68425 17.7072 6.29325C17.3162 5.90225 16.6842 5.90225 16.2933 6.29325L12.0002 10.5862L7.70725 6.29325C7.31625 5.90225 6.68425 5.90225 6.29325 6.29325C5.90225 6.68425 5.90225 7.31625 6.29325 7.70725L10.5862 12.0002L6.29325 16.2933C5.90225 16.6842 5.90225 17.3162 6.29325 17.7072C6.48825 17.9022 6.74425 18.0002 7.00025 18.0002C7.25625 18.0002 7.51225 17.9022 7.70725 17.7072L12.0002 13.4142L16.2933 17.7072C16.4882 17.9022 16.7443 18.0002 17.0002 18.0002C17.2562 18.0002 17.5122 17.9022 17.7072 17.7072C18.0982 17.3162 18.0982 16.6842 17.7072 16.2933L13.4142 12.0002Z"
            fill="#616161"
          />
          <mask
            id="mask0"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="6"
            y="6"
            width="13"
            height="13"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.4142 12.0002L17.7072 7.70725C18.0982 7.31625 18.0982 6.68425 17.7072 6.29325C17.3162 5.90225 16.6842 5.90225 16.2933 6.29325L12.0002 10.5862L7.70725 6.29325C7.31625 5.90225 6.68425 5.90225 6.29325 6.29325C5.90225 6.68425 5.90225 7.31625 6.29325 7.70725L10.5862 12.0002L6.29325 16.2933C5.90225 16.6842 5.90225 17.3162 6.29325 17.7072C6.48825 17.9022 6.74425 18.0002 7.00025 18.0002C7.25625 18.0002 7.51225 17.9022 7.70725 17.7072L12.0002 13.4142L16.2933 17.7072C16.4882 17.9022 16.7443 18.0002 17.0002 18.0002C17.2562 18.0002 17.5122 17.9022 17.7072 17.7072C18.0982 17.3162 18.0982 16.6842 17.7072 16.2933L13.4142 12.0002Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0)" />
        </svg>
      )
      break
    case "filter-main":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.00018 6H17.0002L11.9902 12.3L7.00018 6ZM4.25018 5.61C6.27018 8.2 10.0002 13 10.0002 13V19C10.0002 19.55 10.4502 20 11.0002 20H13.0002C13.5502 20 14.0002 19.55 14.0002 19V13C14.0002 13 17.7202 8.2 19.7402 5.61C20.2502 4.95 19.7802 4 18.9502 4H5.04018C4.21018 4 3.74018 4.95 4.25018 5.61Z"
            fill="#0D99FF"
          />
        </svg>
      )
      break
    case "filter-white1":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.99969 6H16.9997L11.9897 12.3L6.99969 6ZM4.24969 5.61C6.26969 8.2 9.99969 13 9.99969 13V19C9.99969 19.55 10.4497 20 10.9997 20H12.9997C13.5497 20 13.9997 19.55 13.9997 19V13C13.9997 13 17.7197 8.2 19.7397 5.61C20.2497 4.95 19.7797 4 18.9497 4H5.03969C4.20969 4 3.73969 4.95 4.24969 5.61Z"
            fill="white"
          />
        </svg>
      )
      break
    case "box-confirm":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.7071 16.2929C23.0976 16.6834 23.0976 17.3166 22.7071 17.7071L17.7071 22.7071C17.3166 23.0976 16.6834 23.0976 16.2929 22.7071L14.2929 20.7071C13.9024 20.3166 13.9024 19.6834 14.2929 19.2929C14.6834 18.9024 15.3166 18.9024 15.7071 19.2929L17 20.5858L21.2929 16.2929C21.6834 15.9024 22.3166 15.9024 22.7071 16.2929Z"
            fill="#27AE60"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 2C0 1.44772 0.447715 1 1 1H23C23.5523 1 24 1.44772 24 2V12C24 12.5523 23.5523 13 23 13C22.4477 13 22 12.5523 22 12V3H2V21H10C10.5523 21 11 21.4477 11 22C11 22.5523 10.5523 23 10 23H1C0.447715 23 0 22.5523 0 22V2Z"
            fill="#27AE60"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.4933 4.09558C11.8433 4.26069 12.0667 4.61297 12.0667 5.00001V7.39811C13.5323 7.5105 15.0816 7.89853 16.3582 8.84625C17.986 10.0547 19 12.043 19 15C19 15.4438 18.7075 15.8345 18.2816 15.9595C17.8558 16.0845 17.3985 15.9139 17.1586 15.5405C15.9136 13.6021 14.0982 12.8713 12.0667 12.7055V15C12.0667 15.387 11.8433 15.7393 11.4933 15.9044C11.1432 16.0696 10.7293 16.0179 10.4307 15.7717L4.364 10.7717C4.13351 10.5817 4 10.2987 4 10C4 9.70133 4.13351 9.41829 4.364 9.22833L10.4307 4.22833C10.7293 3.98217 11.1432 3.93046 11.4933 4.09558ZM6.57232 10L10.0667 12.88V11.6667C10.0667 11.1144 10.5144 10.6667 11.0667 10.6667C12.8672 10.6667 14.7811 10.9756 16.4404 12.0328C16.1114 11.3266 15.6632 10.8211 15.1661 10.4521C14.0907 9.65379 12.6097 9.36084 11.0667 9.36084C10.5144 9.36084 10.0667 8.91313 10.0667 8.36084V7.12005L6.57232 10Z"
            fill="#27AE60"
          />
        </svg>
      )
      break
    case "check-list":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11 6C11 5.44772 11.4477 5 12 5H23C23.5523 5 24 5.44772 24 6C24 6.55228 23.5523 7 23 7H12C11.4477 7 11 6.55228 11 6Z"
              fill="#EB5757"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1 3C1 2.44772 1.44772 2 2 2H8C8.55228 2 9 2.44772 9 3V9C9 9.55228 8.55228 10 8 10H2C1.44772 10 1 9.55228 1 9V3ZM3 4V8H7V4H3Z"
              fill="#EB5757"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11 18C11 17.4477 11.4477 17 12 17H23C23.5523 17 24 17.4477 24 18C24 18.5523 23.5523 19 23 19H12C11.4477 19 11 18.5523 11 18Z"
              fill="#EB5757"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.7071 13.2929C11.0976 13.6834 11.0976 14.3166 10.7071 14.7071L4.70711 20.7071C4.31658 21.0976 3.68342 21.0976 3.29289 20.7071L1.29289 18.7071C0.902369 18.3166 0.902369 17.6834 1.29289 17.2929C1.68342 16.9024 2.31658 16.9024 2.70711 17.2929L4 18.5858L9.29289 13.2929C9.68342 12.9024 10.3166 12.9024 10.7071 13.2929Z"
              fill="#EB5757"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "handout-2":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.5 9C5.67157 9 5 9.67157 5 10.5C5 11.3284 5.67157 12 6.5 12C7.32843 12 8 11.3284 8 10.5C8 9.67157 7.32843 9 6.5 9ZM3 10.5C3 8.567 4.567 7 6.5 7C8.433 7 10 8.567 10 10.5C10 12.433 8.433 14 6.5 14C4.567 14 3 12.433 3 10.5Z"
              fill="#27AE60"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24 12C24 11.4477 23.5523 11 23 11H22C21.3492 11 20.2719 11.124 19.1976 11.4598C18.2997 11.7404 17.2686 12.2106 16.5281 13H14C12.3643 13 10.912 13.7856 9.99972 15H5C3.32232 15 2.2698 15.6124 1.66114 16.3773C1.37282 16.7397 1.21171 17.1021 1.12193 17.3773C1.07682 17.5156 1.04873 17.6348 1.03132 17.7254C1.02259 17.7709 1.01646 17.8096 1.01219 17.8404C1.01006 17.8558 1.00838 17.8693 1.00707 17.8808L1.00537 17.8964L1.00471 17.903L1.00442 17.9061L1.00429 17.9075C1.00422 17.9082 1.00416 17.9089 2 18L1.00416 17.9089C0.963396 18.3544 1.22348 18.7728 1.64102 18.9333L13.4057 23.4582C13.4058 23.4583 13.4056 23.4582 13.4057 23.4582C14.4555 23.8623 15.6264 23.8048 16.6312 23.3024L23.4472 19.8944C23.786 19.725 24 19.3788 24 19V12ZM3.3817 17.46C3.63075 17.2423 4.09907 17 5 17H9.10003C9.03444 17.3231 9 17.6575 9 18C9 18.5523 9.44771 19 10 19H17C17.5523 19 18 18.5523 18 18C18 17.4477 17.5523 17 17 17H11.1707C11.5826 15.8349 12.6939 15 14 15H17C17.3262 15 17.6319 14.8409 17.8191 14.5737C18.1762 14.0637 18.893 13.6504 19.7942 13.3687C20.6701 13.095 21.5458 13 22 13V18.382L15.7368 21.5136C15.2337 21.7651 14.6484 21.7936 14.1243 21.5918L3.3817 17.46Z"
              fill="#27AE60"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.7071 0.292893C21.0976 0.683417 21.0976 1.31658 20.7071 1.70711L14.7071 7.70711C14.3166 8.09763 13.6834 8.09763 13.2929 7.70711L11.2929 5.70711C10.9024 5.31658 10.9024 4.68342 11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289L14 5.58579L19.2929 0.292893C19.6834 -0.0976311 20.3166 -0.0976311 20.7071 0.292893Z"
              fill="#27AE60"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "cheque":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 11C0 10.4477 0.447715 10 1 10H6C6.55228 10 7 10.4477 7 11C7 11.5523 6.55228 12 6 12H2V21H22V12H17C16.4477 12 16 11.5523 16 11C16 10.4477 16.4477 10 17 10H23C23.5523 10 24 10.4477 24 11V22C24 22.5523 23.5523 23 23 23H1C0.447715 23 0 22.5523 0 22V11Z"
            fill="#24B8CC"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2929 1.29289C14.6834 0.902369 15.3166 0.902369 15.7071 1.29289L18.7071 4.29289C19.0976 4.68342 19.0976 5.31658 18.7071 5.70711L9.70711 14.7071C9.51957 14.8946 9.26522 15 9 15H6C5.44772 15 5 14.5523 5 14V11C5 10.7348 5.10536 10.4804 5.29289 10.2929L14.2929 1.29289ZM7 11.4142V13H8.58579L16.5858 5L15 3.41421L7 11.4142Z"
            fill="#24B8CC"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 18C5 17.4477 5.44772 17 6 17H18C18.5523 17 19 17.4477 19 18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18Z"
            fill="#24B8CC"
          />
        </svg>
      )
      break
    case "curved-previous":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3827 2.07615C10.7564 2.23093 11 2.59557 11 3.00003V7.02266C13.6775 7.14467 16.6994 7.78362 19.1713 9.50429C22.0179 11.4858 24 14.8085 24 20C24 20.4513 23.6978 20.8467 23.2623 20.965C22.8268 21.0834 22.366 20.8954 22.1376 20.5062C20.8447 18.3035 19.6007 16.9885 17.8759 16.1806C16.2711 15.429 14.1535 15.0694 11 15.0092V19C11 19.4045 10.7564 19.7691 10.3827 19.9239C10.009 20.0787 9.57889 19.9931 9.29289 19.7071L1.29289 11.7071C0.902369 11.3166 0.902369 10.6834 1.29289 10.2929L9.29289 2.29292C9.57889 2.00692 10.009 1.92137 10.3827 2.07615ZM3.41421 11L9 16.5858V14C9 13.4477 9.44772 13 10 13C13.7848 13 16.5429 13.3478 18.7241 14.3694C19.8286 14.8867 20.756 15.5624 21.5819 16.405C20.9399 13.9086 19.6174 12.2516 18.0287 11.1458C15.7141 9.5346 12.6976 9.00003 10 9.00003C9.44772 9.00003 9 8.55231 9 8.00003V5.41424L3.41421 11Z"
            fill="#9B51E0"
          />
        </svg>
      )
      break
    case "g-chart":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 14C1 13.4477 1.44772 13 2 13H6C6.55228 13 7 13.4477 7 14V20C7 20.5523 6.55228 21 6 21H2C1.44772 21 1 20.5523 1 20V14ZM3 15V19H5V15H3Z"
            fill="#27AE60"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 9C9 8.44772 9.44772 8 10 8H14C14.5523 8 15 8.44772 15 9V20C15 20.5523 14.5523 21 14 21H10C9.44772 21 9 20.5523 9 20V9ZM11 10V19H13V10H11Z"
            fill="#27AE60"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 4C17 3.44772 17.4477 3 18 3H22C22.5523 3 23 3.44772 23 4V20C23 20.5523 22.5523 21 22 21H18C17.4477 21 17 20.5523 17 20V4ZM19 5V19H21V5H19Z"
            fill="#27AE60"
          />
        </svg>
      )
      break
    case "handout":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5 8C16.6716 8 16 8.67157 16 9.5C16 10.3284 16.6716 11 17.5 11C18.3284 11 19 10.3284 19 9.5C19 8.67157 18.3284 8 17.5 8ZM14 9.5C14 7.567 15.567 6 17.5 6C19.433 6 21 7.567 21 9.5C21 11.433 19.433 13 17.5 13C15.567 13 14 11.433 14 9.5Z"
            fill="#F2994A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.5 2C8.67157 2 8 2.67157 8 3.5C8 4.32843 8.67157 5 9.5 5C10.3284 5 11 4.32843 11 3.5C11 2.67157 10.3284 2 9.5 2ZM6 3.5C6 1.567 7.567 0 9.5 0C11.433 0 13 1.567 13 3.5C13 5.433 11.433 7 9.5 7C7.567 7 6 5.433 6 3.5Z"
            fill="#F2994A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 12C0 11.4477 0.447715 11 1 11H2C2.65081 11 3.72806 11.124 4.80242 11.4598C5.70034 11.7404 6.73139 12.2106 7.4719 13H10C11.6357 13 13.088 13.7856 14.0003 15H19C20.6777 15 21.7302 15.6124 22.3389 16.3773C22.6272 16.7397 22.7883 17.1021 22.8781 17.3773C22.9232 17.5156 22.9513 17.6348 22.9687 17.7254C22.9774 17.7709 22.9835 17.8096 22.9878 17.8404C22.9899 17.8558 22.9916 17.8693 22.9929 17.8808L22.9946 17.8964L22.9953 17.903L22.9956 17.9061L22.9957 17.9075C22.9958 17.9082 22.9958 17.9089 22 18L22.9958 17.9089C23.0366 18.3544 22.7765 18.7728 22.359 18.9333L10.5943 23.4582C10.5942 23.4583 10.5944 23.4582 10.5943 23.4582C9.54446 23.8623 8.37357 23.8048 7.36879 23.3024L0.552786 19.8944C0.214002 19.725 0 19.3788 0 19V12ZM20.6183 17.46C20.3693 17.2423 19.9009 17 19 17H14.9C14.9656 17.3231 15 17.6575 15 18C15 18.5523 14.5523 19 14 19H7C6.44772 19 6 18.5523 6 18C6 17.4477 6.44772 17 7 17H12.8293C12.4174 15.8349 11.3061 15 10 15H7C6.67378 15 6.36806 14.8409 6.18092 14.5737C5.82377 14.0637 5.10703 13.6504 4.20583 13.3687C3.32994 13.095 2.45419 13 2 13V18.382L8.26321 21.5136C8.76633 21.7651 9.35162 21.7936 9.8757 21.5918L20.6183 17.46Z"
            fill="#F2994A"
          />
        </svg>
      )
      break
    case "send-message":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289Z"
            fill="#2F80ED"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.7071 2.29292C21.9829 2.56873 22.0732 2.97973 21.9384 3.34573L14.9384 22.3457C14.8005 22.7199 14.4535 22.9764 14.0553 22.9985C13.6571 23.0206 13.2839 22.8039 13.1056 22.4472L9.25465 14.7454L1.55279 10.8945C1.19611 10.7161 0.979485 10.3429 1.00154 9.94473C1.02359 9.54656 1.28011 9.19955 1.6543 9.06169L20.6543 2.06169C21.0203 1.92684 21.4313 2.01711 21.7071 2.29292ZM4.51462 10.1393L10.4472 13.1056C10.6407 13.2024 10.7977 13.3593 10.8944 13.5528L13.8607 19.4854L19.3126 4.6874L4.51462 10.1393Z"
            fill="#2F80ED"
          />
        </svg>
      )
      break
    case "warning-usb":
      iconElement = (
        <svg
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M59.9997 39.966L85.0997 83.3327H34.8997L59.9997 39.966ZM59.9997 26.666L23.333 89.9993H96.6663L59.9997 26.666ZM63.333 73.3327H56.6663V79.9993H63.333V73.3327ZM63.333 53.3327H56.6663V66.666H63.333V53.3327Z"
            fill="#F57C00"
          />
          <circle
            cx="60"
            cy="60"
            r="59.5"
            stroke="#F57C00"
            strokeDasharray="5 5"
          />
        </svg>
      )
      break
    case "warning-usb2":
      iconElement = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
        >
          <path
            d="M56.666 69.9998H63.3327V76.6665H56.666V69.9998ZM56.666 43.3332H63.3327V63.3332H56.666V43.3332ZM59.966 26.6665C41.566 26.6665 26.666 41.5998 26.666 59.9998C26.666 78.3998 41.566 93.3332 59.966 93.3332C78.3994 93.3332 93.3327 78.3998 93.3327 59.9998C93.3327 41.5998 78.3994 26.6665 59.966 26.6665ZM59.9994 86.6665C45.266 86.6665 33.3327 74.7332 33.3327 59.9998C33.3327 45.2665 45.266 33.3332 59.9994 33.3332C74.7327 33.3332 86.666 45.2665 86.666 59.9998C86.666 74.7332 74.7327 86.6665 59.9994 86.6665Z"
            fill="#E50500"
          />
          <circle
            cx="60"
            cy="60"
            r="59.5"
            stroke="#E50500"
            strokeDasharray="5 5"
          />
        </svg>
      )
      break
    case "not-cks":
      iconElement = (
        <svg
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M56.667 69.9994H63.3337V76.666H56.667V69.9994ZM56.667 43.3327H63.3337V63.3327H56.667V43.3327ZM59.967 26.666C41.567 26.666 26.667 41.5993 26.667 59.9994C26.667 78.3994 41.567 93.3327 59.967 93.3327C78.4003 93.3327 93.3337 78.3994 93.3337 59.9994C93.3337 41.5993 78.4003 26.666 59.967 26.666ZM60.0003 86.666C45.267 86.666 33.3337 74.7327 33.3337 59.9994C33.3337 45.266 45.267 33.3327 60.0003 33.3327C74.7337 33.3327 86.667 45.266 86.667 59.9994C86.667 74.7327 74.7337 86.666 60.0003 86.666Z"
            fill="#E50500"
          />
          <circle
            cx="60"
            cy="60"
            r="59.5"
            stroke="#E50500"
            strokeDasharray="5 5"
          />
        </svg>
      )
      break
    case "d-check":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.7071 7.29289C19.0976 7.68342 19.0976 8.31658 18.7071 8.70711L10.7071 16.7071C10.3166 17.0976 9.68342 17.0976 9.29289 16.7071L5.29289 12.7071C4.90237 12.3166 4.90237 11.6834 5.29289 11.2929C5.68342 10.9024 6.31658 10.9024 6.70711 11.2929L10 14.5858L17.2929 7.29289C17.6834 6.90237 18.3166 6.90237 18.7071 7.29289Z"
            fill="#868E96"
          />
        </svg>
      )
      break
    case "bin":
      iconElement = (
        <svg
          width="14"
          height="18"
          viewBox="0 0 14 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z"
            fill="#FF6569"
          />
        </svg>
      )
      break
    case "hierarchy":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 9V15"
            stroke="#1574F6"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 15V12H21V15"
            stroke="#1574F6"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 23C4.10457 23 5 22.1046 5 21C5 19.8954 4.10457 19 3 19C1.89543 19 1 19.8954 1 21C1 22.1046 1.89543 23 3 23Z"
            stroke="#1574F6"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M12 23C13.1046 23 14 22.1046 14 21C14 19.8954 13.1046 19 12 19C10.8954 19 10 19.8954 10 21C10 22.1046 10.8954 23 12 23Z"
            stroke="#1574F6"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M21 23C22.1046 23 23 22.1046 23 21C23 19.8954 22.1046 19 21 19C19.8954 19 19 19.8954 19 21C19 22.1046 19.8954 23 21 23Z"
            stroke="#1574F6"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M14 1H10V5H14V1Z"
            stroke="#1574F6"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "settings":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path
              d="M14 19L16.95 21.95C17.2759 22.2826 17.6648 22.5468 18.0941 22.7272C18.5234 22.9076 18.9844 23.0005 19.45 23.0005C19.9156 23.0005 20.3766 22.9076 20.8059 22.7272C21.2352 22.5468 21.6241 22.2826 21.95 21.95V21.95C22.2826 21.6241 22.5468 21.2352 22.7272 20.8059C22.9076 20.3766 23.0005 19.9156 23.0005 19.45C23.0005 18.9844 22.9076 18.5234 22.7272 18.0941C22.5468 17.6648 22.2826 17.2759 21.95 16.95L20 15"
              stroke="#F2994A"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.925 10.225L6.5 6.79999"
              stroke="#F2994A"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.4001 7.49999L6.5001 6.79999L7.2001 4.69999L4.4001 1.89999L1.6001 4.69999L4.4001 7.49999Z"
              stroke="#F2994A"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22.6781 4.92199L19.6001 7.98699L16.0051 4.41098L19.0851 1.34499C18.3746 1.03694 17.593 0.930716 16.8261 1.03799C15.4031 1.16021 14.0802 1.82008 13.1266 2.8833C12.173 3.94651 11.6604 5.33315 11.6931 6.76099C11.6855 7.32229 11.7899 7.87946 12.0001 8.39998L2.14506 17.083C1.80331 17.3877 1.52625 17.758 1.33032 18.1718C1.13438 18.5856 1.02357 19.0346 1.00445 19.4921C0.985327 19.9496 1.05829 20.4062 1.21901 20.835C1.37973 21.2637 1.62493 21.6558 1.94006 21.988V21.988C2.26247 22.3252 2.65296 22.5899 3.08559 22.7646C3.51822 22.9392 3.98307 23.0197 4.44923 23.0008C4.91538 22.9819 5.37218 22.864 5.78923 22.6548C6.20628 22.4457 6.57405 22.1502 6.86806 21.788L15.5941 11.978C16.5267 12.2515 17.5075 12.3198 18.4691 12.178C19.4823 11.9687 20.4192 11.4869 21.1789 10.7845C21.9385 10.0821 22.4921 9.18573 22.7801 8.19199C23.1074 7.12053 23.0715 5.97096 22.6781 4.92199V4.92199Z"
              stroke="#F2994A"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22.6723 4.9334C22.9946 5.64627 23.1056 6.43052 22.9933 7.19995C22.8651 8.62761 22.1742 9.95481 21.0612 10.9114"
              stroke="#F2994A"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "database":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 4V20C3 21.7 7 23 12 23C17 23 21 21.7 21 20V4"
            stroke="#BB6BD9"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M12 7C16.9706 7 21 5.65685 21 4C21 2.34315 16.9706 1 12 1C7.02944 1 3 2.34315 3 4C3 5.65685 7.02944 7 12 7Z"
            stroke="#BB6BD9"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M21 12C21 13.7 17 15 12 15C7 15 3 13.7 3 12"
            stroke="#BB6BD9"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
        </svg>
      )
      break
    case "chart":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.33329 7.66797H5.49996C6.14163 7.66797 6.66663 8.19297 6.66663 8.83464V14.668C6.66663 15.3096 6.14163 15.8346 5.49996 15.8346H5.33329C4.69163 15.8346 4.16663 15.3096 4.16663 14.668V8.83464C4.16663 8.19297 4.69163 7.66797 5.33329 7.66797ZM9.99996 4.16797C10.6416 4.16797 11.1666 4.69297 11.1666 5.33464V14.668C11.1666 15.3096 10.6416 15.8346 9.99996 15.8346C9.35829 15.8346 8.83329 15.3096 8.83329 14.668V5.33464C8.83329 4.69297 9.35829 4.16797 9.99996 4.16797ZM14.6666 10.8346C15.3083 10.8346 15.8333 11.3596 15.8333 12.0013V14.668C15.8333 15.3096 15.3083 15.8346 14.6666 15.8346C14.025 15.8346 13.5 15.3096 13.5 14.668V12.0013C13.5 11.3596 14.025 10.8346 14.6666 10.8346Z"
            fill="#212529"
          />
        </svg>
      )
      break
    case "notes":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 4C1 3.44772 1.44772 3 2 3H4C4.55228 3 5 3.44772 5 4C5 4.55228 4.55228 5 4 5H3V22H21V5H20C19.4477 5 19 4.55228 19 4C19 3.44772 19.4477 3 20 3H22C22.5523 3 23 3.44772 23 4V23C23 23.5523 22.5523 24 22 24H2C1.44772 24 1 23.5523 1 23V4Z"
            fill="#868E96"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.1706 2C9.58229 0.834621 10.6934 0 12 0C13.3066 0 14.4177 0.834621 14.8294 2H17C17.5523 2 18 2.44772 18 3V7C18 7.55228 17.5523 8 17 8H7C6.44772 8 6 7.55228 6 7V3C6 2.44772 6.44772 2 7 2H9.1706ZM12 2C11.4473 2 11 2.44728 11 3C11 3.55228 10.5523 4 10 4H8V6H16V4H14C13.4477 4 13 3.55228 13 3C13 2.44728 12.5527 2 12 2Z"
            fill="#868E96"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 11C6 10.4477 6.44772 10 7 10H17C17.5523 10 18 10.4477 18 11C18 11.5523 17.5523 12 17 12H7C6.44772 12 6 11.5523 6 11Z"
            fill="#868E96"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 15C6 14.4477 6.44772 14 7 14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H7C6.44772 16 6 15.5523 6 15Z"
            fill="#868E96"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 19C6 18.4477 6.44772 18 7 18H11C11.5523 18 12 18.4477 12 19C12 19.5523 11.5523 20 11 20H7C6.44772 20 6 19.5523 6 19Z"
            fill="#868E96"
          />
        </svg>
      )
      break
    case "add":
      iconElement = (
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path
              d="M8 1.83398V15.1673"
              stroke={fill || "white"}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.6663 8.5H1.33301"
              stroke={fill || "white"}
              strokeWidth="1.3"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "search":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
            fill={fill || "#222D4B"}
          />
        </svg>
      )
      break
    case "arrowDown":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.5 4.5L8 12L0.5 4.5"
            stroke="#868E96"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "arrow-menu":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.3335 4.6665H4.66682C4.42482 4.6665 4.20148 4.79784 4.08348 5.00984C3.96615 5.22184 3.97282 5.48117 4.10148 5.6865L7.43482 11.0198C7.55682 11.2145 7.77015 11.3332 8.00015 11.3332C8.23015 11.3332 8.44348 11.2145 8.56548 11.0198L11.8988 5.6865C12.0275 5.48117 12.0341 5.22184 11.9168 5.00984C11.7988 4.79784 11.5755 4.6665 11.3335 4.6665Z"
            fill="rgba(0, 0, 0, 0.5)"
          />
        </svg>
      )
      break
    case "trashCan":
      iconElement = (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle opacity="0.1" cx="24" cy="24" r="24" fill="#BC2618" />
          <path
            d="M32.25 16.5V33.5455C32.25 34.4868 31.5784 35.25 30.75 35.25H17.25C16.4216 35.25 15.75 34.4868 15.75 33.5455V16.5"
            stroke="#B20D0D"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24 22.125V30.375"
            stroke="#B20D0D"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.25 22.125V30.375"
            stroke="#B20D0D"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.75 22.125V30.375"
            stroke="#B20D0D"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.25 16.5V12.75H27.75V16.5"
            stroke="#B20D0D"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.5 16.5H13.5"
            stroke="#B20D0D"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <defs>
            <clipPath id="clip0">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(12 12)"
              />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "threeDots":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
            stroke="#868E96"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M3 14C4.10457 14 5 13.1046 5 12C5 10.8954 4.10457 10 3 10C1.89543 10 1 10.8954 1 12C1 13.1046 1.89543 14 3 14Z"
            stroke="#868E96"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M21 14C22.1046 14 23 13.1046 23 12C23 10.8954 22.1046 10 21 10C19.8954 10 19 10.8954 19 12C19 13.1046 19.8954 14 21 14Z"
            stroke="#868E96"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
        </svg>
      )
      break
    case "dot":
      iconElement = (
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="4" cy="4" r="4" fill={fill || "rgba(0, 0, 0, 0.5)"} />
        </svg>
      )
      break
    case "stationery":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.1001 4.40002H20.5001"
            stroke="#27AE60"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M17.1001 10H20.5001"
            stroke="#27AE60"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M19 7.19995H20.5"
            stroke="#27AE60"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M5.8001 13.2L2.1001 7.40002L2.4001 2.40002L7.1001 4.40002L12.7001 13.3"
            stroke="#27AE60"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.2002 13V1H20.5002V13"
            stroke="#27AE60"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
          <path
            d="M20 13.5H22V23H2V13.5H20Z"
            stroke="#27AE60"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "menu":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 18H16V16H3V18ZM3 13H13V11H3V13ZM3 6V8H16V6H3ZM21 15.59L17.42 12L21 8.41L19.59 7L14.59 12L19.59 17L21 15.59Z"
            fill="#222D4B"
          />
        </svg>
      )
      break
    case "meeting":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.992 18.7373L8.2 20.4003C8.704 20.7783 9 21.3703 9 22.0003V23.0003H1V22.0003C1 21.3703 1.296 20.7783 1.8 20.4003L4.008 18.7373"
            stroke="#BB6BD9"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 19C3.895 19 3 18.105 3 17V16C3 14.895 3.895 14 5 14C6.105 14 7 14.895 7 16V17C7 18.105 6.105 19 5 19Z"
            stroke="#BB6BD9"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.992 5.7373L15.2 7.4003C15.704 7.7783 16 8.3703 16 9.0003V10.0003H8V9.0003C8 8.3703 8.296 7.7783 8.8 7.4003L11.008 5.7373"
            stroke="#BB6BD9"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 6C10.895 6 10 5.105 10 4V3C10 1.895 10.895 1 12 1C13.105 1 14 1.895 14 3V4C14 5.105 13.105 6 12 6Z"
            stroke="#BB6BD9"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.992 18.7373L22.2 20.4003C22.704 20.7783 23 21.3703 23 22.0003V23.0003H15V22.0003C15 21.3703 15.296 20.7783 15.8 20.4003L18.008 18.7373"
            stroke="#BB6BD9"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19 19C17.895 19 17 18.105 17 17V16C17 14.895 17.895 14 19 14C20.105 14 21 14.895 21 16V17C21 18.105 20.105 19 19 19Z"
            stroke="#BB6BD9"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "access-key":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path
              d="M11.2424 21.2426C13.5856 18.8995 13.5856 15.1005 11.2424 12.7574C8.89932 10.4143 5.10037 10.4143 2.75725 12.7574C0.414125 15.1005 0.414125 18.8995 2.75725 21.2426C5.10037 23.5857 8.89932 23.5857 11.2424 21.2426Z"
              stroke="#F2994A"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.2432 12.757L22.0002 2"
              stroke="#F2994A"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19 5L22 8L19 11L16 8"
              stroke="#F2994A"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "add-blue":
      iconElement = (
        <svg
          width="12px"
          height="12px"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="#01638D" />
        </svg>
      )
      break
    case "close-icon":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="12" fill="#CED4DA" />
          <path
            d="M16.6663 7.33337L7.33301 16.6667"
            stroke="#868E96"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.6663 16.6667L7.33301 7.33337"
            stroke="#868E96"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "filter-remove":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 9H23"
            stroke="#EB5757"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M1 3H23"
            stroke="#EB5757"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M1 15H11"
            stroke="#EB5757"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M1 21H11"
            stroke="#EB5757"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M16 15L22 21"
            stroke="#EB5757"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M22 15L16 21"
            stroke="#EB5757"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
        </svg>
      )
      break
    case "check":
      iconElement = (
        <svg
          width="14"
          height="10"
          viewBox="0 0 14 10"
          fill="none"
          xmlns="hjustice://www.w3.org/2000/svg"
        >
          <path
            d="M1 5L5 9L13 1"
            stroke="#1574F6"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "role-group":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 4V20C3 21.7 7 23 12 23C17 23 21 21.7 21 20V4"
            stroke="#56CCF2"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M12 7C16.9706 7 21 5.65685 21 4C21 2.34315 16.9706 1 12 1C7.02944 1 3 2.34315 3 4C3 5.65685 7.02944 7 12 7Z"
            stroke="#56CCF2"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M21 12C21 13.7 17 15 12 15C7 15 3 13.7 3 12"
            stroke="#56CCF2"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
        </svg>
      )
      break
    case "authorization":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.992 18.7371L8.2 20.4001C8.704 20.7781 9 21.3701 9 22.0001V23.0001H1V22.0001C1 21.3701 1.296 20.7781 1.8 20.4001L4.008 18.7371"
            stroke="#F2994A"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 19C3.895 19 3 18.105 3 17V16C3 14.895 3.895 14 5 14C6.105 14 7 14.895 7 16V17C7 18.105 6.105 19 5 19Z"
            stroke="#F2994A"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.992 5.73706L15.2 7.40006C15.704 7.77806 16 8.37006 16 9.00006V10.0001H8V9.00006C8 8.37006 8.296 7.77806 8.8 7.40006L11.008 5.73706"
            stroke="#F2994A"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 6C10.895 6 10 5.105 10 4V3C10 1.895 10.895 1 12 1C13.105 1 14 1.895 14 3V4C14 5.105 13.105 6 12 6Z"
            stroke="#F2994A"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.992 18.7371L22.2 20.4001C22.704 20.7781 23 21.3701 23 22.0001V23.0001H15V22.0001C15 21.3701 15.296 20.7781 15.8 20.4001L18.008 18.7371"
            stroke="#F2994A"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19 19C17.895 19 17 18.105 17 17V16C17 14.895 17.895 14 19 14C20.105 14 21 14.895 21 16V17C21 18.105 20.105 19 19 19Z"
            stroke="#F2994A"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "notice-error":
      iconElement = (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.3335 28H30.6668L16.0002 2.66666L1.3335 28ZM5.96016 25.3333L16.0002 7.98666L26.0402 25.3333H5.96016ZM14.6668 21.3333H17.3335V24H14.6668V21.3333ZM14.6668 13.3333H17.3335V18.6667H14.6668V13.3333Z"
            fill="#E13F3D"
          />
        </svg>
      )
      break
    case "notice-success":
      iconElement = (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.6861 14.1597C28.0165 15.7411 28.1152 17.4848 27.8027 19.2574C26.5524 26.348 19.8333 31.0528 12.7427 29.8025C5.65211 28.5522 0.947385 21.8332 2.19765 14.7426C3.44792 7.65195 10.167 2.94722 17.2576 4.19749C19.7196 4.63161 21.9616 5.73773 23.7055 7.36528"
            stroke="#27AE60"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M10 16L15 21L30 6"
            stroke="#27AE60"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "icon-arrow-down":
      iconElement = (
        <svg
          width="12"
          height="10"
          viewBox="0 0 12 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 0L0.999979 0C0.636979 0 0.301979 0.197 0.124979 0.515C-0.0510214 0.833 -0.0410214 1.222 0.151979 1.53L5.15198 9.53C5.33498 9.822 5.65498 10 5.99998 10C6.34498 10 6.66498 9.822 6.84798 9.53L11.848 1.53C12.041 1.222 12.051 0.833 11.875 0.515C11.698 0.197 11.363 0 11 0Z"
            fill="#868E96"
          />
        </svg>
      )
      break
    case "faq":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 16H11V14H9V16ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 4C7.79 4 6 5.79 6 8H8C8 6.9 8.9 6 10 6C11.1 6 12 6.9 12 8C12 10 9 9.75 9 13H11C11 10.75 14 10.5 14 8C14 5.79 12.21 4 10 4Z"
            fill="#1574F6"
          />
        </svg>
      )
      break
    case "warning":
      iconElement = (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.33331 28H30.6666L16 2.66663L1.33331 28ZM17.3333 24H14.6666V21.3333H17.3333V24ZM17.3333 18.6666H14.6666V13.3333H17.3333V18.6666Z"
            fill="#E65100"
          />
        </svg>
      )
      break
    case "t_warning_default":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="hjustice://www.w3.org/2000/svg"
        >
          <path
            d="M2 22L12 3L22 22H2Z"
            stroke="#F57C00"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
          <path
            d="M12 11V15"
            stroke="#F57C00"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19Z"
            fill="#F57C00"
          />
        </svg>
      )
      break
    case "arrow_down":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.3335 4.66669L4.66682 4.66669C4.42482 4.66669 4.20148 4.79802 4.08348 5.01002C3.96615 5.22202 3.97282 5.48135 4.10148 5.68669L7.43482 11.02C7.55682 11.2147 7.77015 11.3334 8.00015 11.3334C8.23015 11.3334 8.44348 11.2147 8.56548 11.02L11.8988 5.68669C12.0275 5.48135 12.0341 5.22202 11.9168 5.01002C11.7988 4.79802 11.5755 4.66669 11.3335 4.66669Z"
            fill="#868E96"
          />
        </svg>
      )
      break
    case "arrow_down_white":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.3335 4.66666L4.66682 4.66666C4.42482 4.66666 4.20148 4.79799 4.08348 5.00999C3.96615 5.22199 3.97282 5.48132 4.10148 5.68666L7.43482 11.02C7.55682 11.2147 7.77015 11.3333 8.00015 11.3333C8.23015 11.3333 8.44348 11.2147 8.56548 11.02L11.8988 5.68666C12.0275 5.48132 12.0341 5.22199 11.9168 5.00999C11.7988 4.79799 11.5755 4.66666 11.3335 4.66666Z"
            fill="white"
          />
        </svg>
      )
      break
    case "process_group":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path d="M20 6H10V8H20V6Z" fill="#F2994A" />
            <path
              d="M2.26668 21.1875V2.81249C2.26668 2.29554 2.77506 1.87499 3.39998 1.87499H19.6001C20.225 1.87499 20.7334 2.29554 20.7334 2.81249V10.0683L23 12V2.81249C23 1.26168 21.4748 0 19.6001 0H3.39998C1.52526 0 0 1.26168 0 2.81249V21.1875C0 22.7383 1.5252 24 3.39993 24H10L10.5 22.125H3.39998C2.77506 22.125 2.26668 21.7045 2.26668 21.1875Z"
              fill="#F2994A"
            />
            <path d="M20 11H10V13H18L20 11Z" fill="#F2994A" />
            <path
              d="M20.117 12L13.8232 18.4717C13.4635 18.8328 13.1888 19.2791 13.0285 19.7629L13.0143 19.8058L12 24L16.4723 23.265L16.5165 23.2503C17.0027 23.0894 17.4512 22.8131 17.8134 22.451L24.1063 15.9804L20.117 12ZM16.4851 21.1301C16.45 21.1648 16.413 21.1976 16.3745 21.2284L15.0515 19.9045C15.0832 19.8651 15.117 19.8273 15.1527 19.7916L20.137 14.6665L21.4738 16.0003L16.4851 21.1301Z"
              fill="#F2994A"
            />
            <path
              d="M8.48433 9.40326L6.19176 12.0036L5.05096 10.9323L3.76855 12.298L6.31856 14.6926L9.8896 10.6423L8.48433 9.40326Z"
              fill="#F2994A"
            />
            <path
              d="M8.48433 3.73624L6.19176 6.33654L5.05096 5.26526L3.76855 6.63097L6.31856 9.02554L9.8896 4.97519L8.48433 3.73624Z"
              fill="#F2994A"
            />
            <path
              d="M5.05096 16.5526L3.76855 17.9183L6.31856 20.3129L9.8896 16.2626L8.48433 15.0236L6.19176 17.6239L5.05096 16.5526Z"
              fill="#F2994A"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "menu-log-work":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.42857 19V20.5C7.42857 22.75 5 23 5 23C5 23 19.4053 23 19.5714 23C20.913 23 22 21.881 22 20.5V19H7.42857Z"
            stroke="#FF5722"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 1H2V20.5C2 21.881 3.119 23 4.5 23H6"
            stroke="#FF5722"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17 15C19.7614 15 22 12.7614 22 10C22 7.23858 19.7614 5 17 5C14.2386 5 12 7.23858 12 10C12 12.7614 14.2386 15 17 15Z"
            stroke="#FF5722"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17 8V10H19"
            stroke="#FF5722"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 6H9"
            stroke="#FF5722"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 10H9"
            stroke="#FF5722"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 14H9"
            stroke="#FF5722"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "menu-product":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.66732 13.3327H13.334V14.9993H6.66732V13.3327ZM6.66732 9.99935H13.334V11.666H6.66732V9.99935ZM11.6673 1.66602H5.00065C4.08398 1.66602 3.33398 2.41602 3.33398 3.33268V16.666C3.33398 17.5827 4.07565 18.3327 4.99232 18.3327H15.0007C15.9173 18.3327 16.6673 17.5827 16.6673 16.666V6.66602L11.6673 1.66602ZM15.0007 16.666H5.00065V3.33268H10.834V7.49935H15.0007V16.666Z"
            fill="#212529"
          />
        </svg>
      )
      break
    case "menu-config":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 13C9.176 13 6.671 13.638 5.025 14.193C3.81 14.604 3 15.749 3 17.032V21H12.5"
            stroke="#F57C00"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11 13C13.824 13 16.329 13.638 17.975 14.193C19.19 14.604 20 15.749 20 17.032V21H12"
            stroke="#F57C00"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 13C9.239 13 7 9.761 7 7V6C7 3.239 9.239 1 12 1C14.761 1 17 3.239 17 6V7C17 9.761 14.761 13 12 13Z"
            stroke="#F57C00"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
        </svg>
      )
      break
    case "menu-role-group":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 5V1H16V5"
            stroke="#2196F3"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 15H1V5H23V15H15"
            stroke="#2196F3"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22 18V23H2V18"
            stroke="#2196F3"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 13H9V17H15V13Z"
            stroke="#2196F3"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "menu-authori":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 13C7.176 13 4.671 13.638 3.025 14.193C1.81 14.604 1 15.749 1 17.032V21H9"
            stroke="#7B1FA2"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 13C7.239 13 5 9.761 5 7V6C5 3.239 7.239 1 10 1C12.761 1 15 3.239 15 6V7C15 9.761 12.761 13 10 13Z"
            stroke="#7B1FA2"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M17.4195 20.1937C18.4172 19.196 18.4172 17.5784 17.4195 16.5807C16.4218 15.583 14.8042 15.583 13.8065 16.5807C12.8088 17.5784 12.8088 19.196 13.8065 20.1937C14.8042 21.1914 16.4218 21.1914 17.4195 20.1937Z"
            stroke="#7B1FA2"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.4199 16.5804L22.0003 12"
            stroke="#7B1FA2"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.7227 13.2773L22.0001 14.5548L20.7227 15.8322L19.4453 14.5548"
            stroke="#7B1FA2"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "filter-black":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path
              d="M22 0H2C1.73478 0 1.48043 0.105357 1.29289 0.292893C1.10536 0.48043 1 0.734784 1 1V4C1.00006 4.26519 1.10545 4.51951 1.293 4.707L9 12.414V23C9 23.1857 9.05171 23.3678 9.14935 23.5257C9.24698 23.6837 9.38668 23.8114 9.55279 23.8944C9.71889 23.9775 9.90484 24.0126 10.0898 23.996C10.2748 23.9793 10.4514 23.9114 10.6 23.8L14.6 20.8C14.7242 20.7069 14.825 20.5861 14.8944 20.4472C14.9639 20.3084 15 20.1552 15 20V12.414L22.707 4.707C22.8946 4.51951 22.9999 4.26519 23 4V1C23 0.734784 22.8946 0.48043 22.7071 0.292893C22.5196 0.105357 22.2652 0 22 0V0Z"
              fill="#616161"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "confirm":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 12L10 16L18 8"
            stroke="#18BC78"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "history":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 7V12L16 16"
            stroke="#F57C00"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C8.1 2 4.7 4.2 3.1 7.5"
            stroke="#F57C00"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.26392 2.56982L3.09992 7.49982L8.02992 6.66382"
            stroke="#F57C00"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "edit-course":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
            fill="#00AEAC"
          />
        </svg>
      )
      break
    case "edit":
      iconElement = (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.71 5.03957L14.37 7.36957L10.62 3.61957L12.96 1.28957C13.35 0.89957 14 0.89957 14.37 1.28957L16.71 3.62957C17.1 3.99957 17.1 4.64957 16.71 5.03957ZM0 14.2496L10.06 4.17957L13.81 7.92957L3.75 17.9996H0V14.2496ZM13.62 2.03957L12.08 3.57957L14.42 5.91957L15.96 4.37957L13.62 2.03957ZM12.36 7.99957L10 5.63957L1 14.6596V16.9996H3.34L12.36 7.99957Z"
            fill="#219653"
          />
        </svg>
      )
      break
    case "arrow-right":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.66699 4.66652L4.66699 11.3332C4.66699 11.5752 4.79833 11.7985 5.01033 11.9165C5.22233 12.0339 5.48166 12.0272 5.68699 11.8985L11.0203 8.56518C11.215 8.44318 11.3337 8.22985 11.3337 7.99985C11.3337 7.76985 11.215 7.55652 11.0203 7.43452L5.68699 4.10118C5.48166 3.97252 5.22233 3.96585 5.01033 4.08318C4.79833 4.20118 4.66699 4.42452 4.66699 4.66652Z"
            fill={fill || "#616161"}
          />
        </svg>
      )
      break
    case "arrow-down":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_82_19447)">
            <path d="M12 16L6 10L18 10L12 16Z" fill="#6A7688" />
          </g>
          <defs>
            <clipPath id="clip0_82_19447">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(24) rotate(90)"
              />
            </clipPath>
          </defs>
        </svg>
      )
      break
    case "calendar":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8333 3.33268H15V2.49935C15 2.04102 14.625 1.66602 14.1667 1.66602C13.7083 1.66602 13.3333 2.04102 13.3333 2.49935V3.33268H6.66667V2.49935C6.66667 2.04102 6.29167 1.66602 5.83333 1.66602C5.375 1.66602 5 2.04102 5 2.49935V3.33268H4.16667C3.24167 3.33268 2.50833 4.08268 2.50833 4.99935L2.5 16.666C2.5 17.5827 3.24167 18.3327 4.16667 18.3327H15.8333C16.75 18.3327 17.5 17.5827 17.5 16.666V4.99935C17.5 4.08268 16.75 3.33268 15.8333 3.33268ZM15.8333 15.8327C15.8333 16.291 15.4583 16.666 15 16.666H5C4.54167 16.666 4.16667 16.291 4.16667 15.8327V7.49935H15.8333V15.8327ZM5.83333 9.16602H7.5V10.8327H5.83333V9.16602ZM9.16667 9.16602H10.8333V10.8327H9.16667V9.16602ZM12.5 9.16602H14.1667V10.8327H12.5V9.16602Z"
            fill="black"
            fillOpacity="0.54"
          />
        </svg>
      )
      break
    case "warning_default":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.33301 14.6667L7.99967 2L14.6663 14.6667H1.33301Z"
            stroke="#18BC78"
            strokeWidth="1.3"
            strokeMiterlimit="10"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
          <path
            d="M8 7.33398V10.0007"
            stroke="#18BC78"
            strokeWidth="1.3"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M7.99967 12.6673C8.36786 12.6673 8.66634 12.3688 8.66634 12.0007C8.66634 11.6325 8.36786 11.334 7.99967 11.334C7.63148 11.334 7.33301 11.6325 7.33301 12.0007C7.33301 12.3688 7.63148 12.6673 7.99967 12.6673Z"
            fill="#18BC78"
          />
        </svg>
      )
      break
    case "warning_green":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.33301 14.6667L7.99967 2L14.6663 14.6667H1.33301Z"
            stroke="#18BC78"
            strokeWidth="1.3"
            strokeMiterlimit="10"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
          <path
            d="M8 7.33398V10.0007"
            stroke="#18BC78"
            strokeWidth="1.3"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M7.99967 12.6673C8.36786 12.6673 8.66634 12.3688 8.66634 12.0007C8.66634 11.6325 8.36786 11.334 7.99967 11.334C7.63148 11.334 7.33301 11.6325 7.33301 12.0007C7.33301 12.3688 7.63148 12.6673 7.99967 12.6673Z"
            fill="#18BC78"
          />
        </svg>
      )
      break
    case "warning_yellow":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.33301 14.6667L7.99967 2L14.6663 14.6667H1.33301Z"
            stroke="#F2994A"
            strokeWidth="1.3"
            strokeMiterlimit="10"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
          <path
            d="M8 7.33398V10.0007"
            stroke="#F2994A"
            strokeWidth="1.3"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M7.99967 12.6673C8.36786 12.6673 8.66634 12.3688 8.66634 12.0007C8.66634 11.6325 8.36786 11.334 7.99967 11.334C7.63148 11.334 7.33301 11.6325 7.33301 12.0007C7.33301 12.3688 7.63148 12.6673 7.99967 12.6673Z"
            fill="#F2994A"
          />
        </svg>
      )
      break
    case "warning_red":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.3335 14.6667L8.00016 2L14.6668 14.6667H1.3335Z"
            stroke="#BC2618"
            strokeWidth="1.3"
            strokeMiterlimit="10"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
          <path
            d="M8 7.33398V10.0007"
            stroke="#BC2618"
            strokeWidth="1.3"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M8.00016 12.6673C8.36835 12.6673 8.66683 12.3688 8.66683 12.0007C8.66683 11.6325 8.36835 11.334 8.00016 11.334C7.63197 11.334 7.3335 11.6325 7.3335 12.0007C7.3335 12.3688 7.63197 12.6673 8.00016 12.6673Z"
            fill="#BC2618"
          />
        </svg>
      )
      break
    case "confirm-lw":
      iconElement = (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle opacity="0.1" cx="24" cy="24" r="24" fill="#F57C00" />
          <path
            d="M14 32L24 13L34 32H14Z"
            stroke="#F57C00"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
          <path
            d="M24 21V25"
            stroke="#F57C00"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M24 29C24.5523 29 25 28.5523 25 28C25 27.4477 24.5523 27 24 27C23.4477 27 23 27.4477 23 28C23 28.5523 23.4477 29 24 29Z"
            fill="#F57C00"
          />
        </svg>
      )
      break
    case "file-text":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM10 9H18V11H10V9ZM10 12H14V14H10V12ZM10 6H18V8H10V6Z"
            fill={fill || "rgba(0, 0, 0, 0.5)"}
          />
        </svg>
      )
      break
    case "folder":
      iconElement = (
        <svg
          width="20"
          height="16"
          viewBox="0 0 20 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 2H10L8 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V4C20 2.9 19.1 2 18 2ZM18 14H2V4H18V14Z"
            fill="#212529"
          />
        </svg>
      )
      break
    case "vbm":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.83333 12.5007H11.6667V14.1673H5.83333V12.5007ZM5.83333 9.16732H14.1667V10.834H5.83333V9.16732ZM5.83333 5.83398H14.1667V7.50065H5.83333V5.83398ZM15.8333 2.50065H12.35C12 1.53398 11.0833 0.833984 10 0.833984C8.91667 0.833984 8 1.53398 7.65 2.50065H4.16667C4.05 2.50065 3.94167 2.50898 3.83333 2.53398C3.50833 2.60065 3.21667 2.76732 2.99167 2.99232C2.84167 3.14232 2.71667 3.32565 2.63333 3.52565C2.55 3.71732 2.5 3.93398 2.5 4.16732V15.834C2.5 16.059 2.55 16.284 2.63333 16.484C2.71667 16.684 2.84167 16.859 2.99167 17.0173C3.21667 17.2423 3.50833 17.409 3.83333 17.4757C3.94167 17.4923 4.05 17.5007 4.16667 17.5007H15.8333C16.75 17.5007 17.5 16.7507 17.5 15.834V4.16732C17.5 3.25065 16.75 2.50065 15.8333 2.50065ZM10 2.29232C10.3417 2.29232 10.625 2.57565 10.625 2.91732C10.625 3.25898 10.3417 3.54232 10 3.54232C9.65833 3.54232 9.375 3.25898 9.375 2.91732C9.375 2.57565 9.65833 2.29232 10 2.29232ZM15.8333 15.834H4.16667V4.16732H15.8333V15.834Z"
            fill="#212529"
          />
        </svg>
      )
      break
    case "people":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.67 13.1299C18.04 14.0599 19 15.3199 19 16.9999V19.9999H23V16.9999C23 14.8199 19.43 13.5299 16.67 13.1299Z"
            fill="rgba(0, 0, 0, 0.5)"
          />
          <path
            d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z"
            fill="rgba(0, 0, 0, 0.5)"
          />
          <path
            d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z"
            fill="rgba(0, 0, 0, 0.5)"
          />
          <path
            d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z"
            fill="rgba(0, 0, 0, 0.5)"
          />
        </svg>
      )
      break
    case "icon-confirm":
      iconElement = (
        <svg
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M59.9994 26.6665C41.666 26.6665 26.666 41.6665 26.666 59.9998C26.666 78.3332 41.666 93.3332 59.9994 93.3332C78.3327 93.3332 93.3327 78.3332 93.3327 59.9998C93.3327 41.6665 78.3327 26.6665 59.9994 26.6665ZM59.9994 86.6665C45.2994 86.6665 33.3327 74.6998 33.3327 59.9998C33.3327 45.2998 45.2994 33.3332 59.9994 33.3332C74.6994 33.3332 86.666 45.2998 86.666 59.9998C86.666 74.6998 74.6994 86.6665 59.9994 86.6665ZM61.666 43.3332H56.666V63.3332L73.9994 73.9998L76.666 69.6665L61.666 60.6665V43.3332Z"
            fill="#E50500"
          />
          <circle
            cx="60"
            cy="60"
            r="59.5"
            stroke="#E50500"
            strokeDasharray="5 5"
          />
        </svg>
      )
      break
    case "download":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.71875 8.59473L10 11.8751L13.2812 8.59473"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 3.125V11.8727"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
            stroke="#2260BD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "icon-system":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.8833 3.76654L16.2417 6.12487L13.8833 8.4832L11.525 6.12487L13.8833 3.76654ZM7.5 4.16654V7.49987H4.16667V4.16654H7.5ZM15.8333 12.4999V15.8332H12.5V12.4999H15.8333ZM7.5 12.4999V15.8332H4.16667V12.4999H7.5ZM13.8833 1.4082L9.16667 6.11654L13.8833 10.8332L18.6 6.11654L13.8833 1.4082ZM9.16667 2.49987H2.5V9.16654H9.16667V2.49987ZM17.5 10.8332H10.8333V17.4999H17.5V10.8332ZM9.16667 10.8332H2.5V17.4999H9.16667V10.8332Z"
            fill="#212529"
          />
        </svg>
      )
      break
    case "eye":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 4.37402C3.75 4.37402 1.25 9.99963 1.25 9.99963C1.25 9.99963 3.75 15.624 10 15.624C16.25 15.624 18.75 9.99963 18.75 9.99963C18.75 9.99963 16.25 4.37402 10 4.37402Z"
            stroke="#01638D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875C8.27411 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125Z"
            stroke="#01638D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "download-grey":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0028 12.0759C11.001 12.0508 11 12.0255 11 12V4C11 3.448 11.447 3 12 3C12.553 3 13 3.448 13 4V11.9998L15.4 10.2C15.842 9.867 16.469 9.958 16.8 10.4C17.132 10.842 17.042 11.469 16.6 11.8L12.6 14.8C12.423 14.933 12.211 15 12 15C11.799 15 11.598 14.939 11.425 14.818L7.425 12.004C6.973 11.686 6.864 11.062 7.182 10.611C7.5 10.159 8.123 10.05 8.575 10.368L11.0028 12.0759ZM6 17V18H18V17C18 16.45 18.45 16 19 16C19.55 16 20 16.45 20 17V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V17C4 16.45 4.45 16 5 16C5.55 16 6 16.45 6 17Z"
            fill="#757575"
          />
          <mask
            id="mask0"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="4"
            y="3"
            width="16"
            height="17"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.0028 12.0759C11.001 12.0508 11 12.0255 11 12V4C11 3.448 11.447 3 12 3C12.553 3 13 3.448 13 4V11.9998L15.4 10.2C15.842 9.867 16.469 9.958 16.8 10.4C17.132 10.842 17.042 11.469 16.6 11.8L12.6 14.8C12.423 14.933 12.211 15 12 15C11.799 15 11.598 14.939 11.425 14.818L7.425 12.004C6.973 11.686 6.864 11.062 7.182 10.611C7.5 10.159 8.123 10.05 8.575 10.368L11.0028 12.0759ZM6 17V18H18V17C18 16.45 18.45 16 19 16C19.55 16 20 16.45 20 17V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V17C4 16.45 4.45 16 5 16C5.55 16 6 16.45 6 17Z"
              fill="white"
            />
          </mask>
        </svg>
      )
      break
    case "warning-cancel":
      iconElement = (
        <svg
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M83.3334 41.3666L78.6334 36.6666L60.0001 55.3L41.3667 36.6666L36.6667 41.3666L55.3001 60L36.6667 78.6333L41.3667 83.3333L60.0001 64.7L78.6334 83.3333L83.3334 78.6333L64.7001 60L83.3334 41.3666Z"
            fill="#E50500"
          />
          <circle
            cx="60"
            cy="60"
            r="59.5"
            stroke="#E50500"
            strokeDasharray="5 5"
          />
        </svg>
      )
      break
    case "sign_success":
      iconElement = (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="32" cy="32" r="32" fill="#373839" />
          <path
            d="M20 32L28 40L44 24"
            stroke="#18BC78"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    case "eye_orange":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 10.4996C11.173 10.4996 10.5 11.1726 10.5 11.9996C10.5 12.8266 11.173 13.4996 12 13.4996C12.827 13.4996 13.5 12.8266 13.5 11.9996C13.5 11.1726 12.827 10.4996 12 10.4996ZM12 15.4996C10.07 15.4996 8.5 13.9296 8.5 11.9996C8.5 10.0696 10.07 8.49964 12 8.49964C13.93 8.49964 15.5 10.0696 15.5 11.9996C15.5 13.9296 13.93 15.4996 12 15.4996ZM21.868 11.5016C21.229 10.3896 17.706 4.81564 11.729 5.00264C6.202 5.14364 2.986 10.0136 2.132 11.5016C1.956 11.8106 1.956 12.1886 2.132 12.4976C2.762 13.5946 6.162 18.9996 12.025 18.9996C12.106 18.9996 12.188 18.9986 12.271 18.9966C17.798 18.8556 21.014 13.9856 21.868 12.4976C22.044 12.1886 22.044 11.8106 21.868 11.5016Z"
            fill="#F7941E"
          />
          <mask
            id="mask0"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="2"
            y="4"
            width="20"
            height="15"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 10.4996C11.173 10.4996 10.5 11.1726 10.5 11.9996C10.5 12.8266 11.173 13.4996 12 13.4996C12.827 13.4996 13.5 12.8266 13.5 11.9996C13.5 11.1726 12.827 10.4996 12 10.4996ZM12 15.4996C10.07 15.4996 8.5 13.9296 8.5 11.9996C8.5 10.0696 10.07 8.49964 12 8.49964C13.93 8.49964 15.5 10.0696 15.5 11.9996C15.5 13.9296 13.93 15.4996 12 15.4996ZM21.868 11.5016C21.229 10.3896 17.706 4.81564 11.729 5.00264C6.202 5.14364 2.986 10.0136 2.132 11.5016C1.956 11.8106 1.956 12.1886 2.132 12.4976C2.762 13.5946 6.162 18.9996 12.025 18.9996C12.106 18.9996 12.188 18.9986 12.271 18.9966C17.798 18.8556 21.014 13.9856 21.868 12.4976C22.044 12.1886 22.044 11.8106 21.868 11.5016Z"
              fill="white"
            />
          </mask>
        </svg>
      )
      break
    case "download_orange":
      iconElement = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0028 12.0759C11.001 12.0508 11 12.0255 11 12V4C11 3.448 11.447 3 12 3C12.553 3 13 3.448 13 4V11.9998L15.4 10.2C15.842 9.867 16.469 9.958 16.8 10.4C17.132 10.842 17.042 11.469 16.6 11.8L12.6 14.8C12.423 14.933 12.211 15 12 15C11.799 15 11.598 14.939 11.425 14.818L7.425 12.004C6.973 11.686 6.864 11.062 7.182 10.611C7.5 10.159 8.123 10.05 8.575 10.368L11.0028 12.0759ZM6 17V18H18V17C18 16.45 18.45 16 19 16C19.55 16 20 16.45 20 17V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V17C4 16.45 4.45 16 5 16C5.55 16 6 16.45 6 17Z"
            fill="#F7941E"
          />
          <mask
            id="mask0"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="4"
            y="3"
            width="16"
            height="17"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.0028 12.0759C11.001 12.0508 11 12.0255 11 12V4C11 3.448 11.447 3 12 3C12.553 3 13 3.448 13 4V11.9998L15.4 10.2C15.842 9.867 16.469 9.958 16.8 10.4C17.132 10.842 17.042 11.469 16.6 11.8L12.6 14.8C12.423 14.933 12.211 15 12 15C11.799 15 11.598 14.939 11.425 14.818L7.425 12.004C6.973 11.686 6.864 11.062 7.182 10.611C7.5 10.159 8.123 10.05 8.575 10.368L11.0028 12.0759ZM6 17V18H18V17C18 16.45 18.45 16 19 16C19.55 16 20 16.45 20 17V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V17C4 16.45 4.45 16 5 16C5.55 16 6 16.45 6 17Z"
              fill="white"
            />
          </mask>
        </svg>
      )
      break
    case "sign_in":
      iconElement = (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 14H10.375C10.1687 14 10 13.8313 10 13.625V12.375C10 12.1687 10.1687 12 10.375 12H13C13.5531 12 14 11.5531 14 11V5C14 4.44688 13.5531 4 13 4H10.375C10.1687 4 10 3.83125 10 3.625V2.375C10 2.16875 10.1687 2 10.375 2H13C14.6562 2 16 3.34375 16 5V11C16 12.6562 14.6562 14 13 14ZM11.5312 7.71875L6.28125 2.46875C5.8125 2 5 2.32812 5 3V6H0.75C0.334375 6 0 6.33437 0 6.75V9.75C0 10.1656 0.334375 10.5 0.75 10.5H5V13.5C5 14.1719 5.8125 14.5 6.28125 14.0312L11.5312 8.78125C11.8219 8.4875 11.8219 8.0125 11.5312 7.71875Z"
            fill="white"
          />
        </svg>
      )
      break
    case "user_login":
      iconElement = (
        <svg
          width="14"
          height="16"
          viewBox="0 0 14 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 8C9.20938 8 11 6.20937 11 4C11 1.79063 9.20938 0 7 0C4.79063 0 3 1.79063 3 4C3 6.20937 4.79063 8 7 8ZM9.8 9H9.27812C8.58437 9.31875 7.8125 9.5 7 9.5C6.1875 9.5 5.41875 9.31875 4.72188 9H4.2C1.88125 9 0 10.8813 0 13.2V14.5C0 15.3281 0.671875 16 1.5 16H12.5C13.3281 16 14 15.3281 14 14.5V13.2C14 10.8813 12.1187 9 9.8 9Z"
            fill="#9A9A9A"
          />
        </svg>
      )
      break
    case "lock_login":
      iconElement = (
        <svg
          width="14"
          height="16"
          viewBox="0 0 14 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5 7H11.75V4.75C11.75 2.13125 9.61875 0 7 0C4.38125 0 2.25 2.13125 2.25 4.75V7H1.5C0.671875 7 0 7.67188 0 8.5V14.5C0 15.3281 0.671875 16 1.5 16H12.5C13.3281 16 14 15.3281 14 14.5V8.5C14 7.67188 13.3281 7 12.5 7ZM9.25 7H4.75V4.75C4.75 3.50938 5.75938 2.5 7 2.5C8.24063 2.5 9.25 3.50938 9.25 4.75V7Z"
            fill="#9E9E9E"
          />
        </svg>
      )
      break
    case "copy":
      iconElement = (
        <svg
          width="19"
          height="22"
          viewBox="0 0 19 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 0H2C0.9 0 0 0.9 0 2V16H2V2H14V0ZM13 4H6C4.9 4 4.01 4.9 4.01 6L4 20C4 21.1 4.89 22 5.99 22H17C18.1 22 19 21.1 19 20V10L13 4ZM6 20V6H12V11H17V20H6Z"
            fill="#0D99FF"
          />
        </svg>
      )
      break
    case "addRowAbove":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.33464 4.99935H1.66797V16.666C1.66797 17.5827 2.41797 18.3327 3.33464 18.3327H15.0013V16.666H3.33464V4.99935ZM16.668 1.66602H6.66797C5.7513 1.66602 5.0013 2.41602 5.0013 3.33268V13.3327C5.0013 14.2493 5.7513 14.9993 6.66797 14.9993H16.668C17.5846 14.9993 18.3346 14.2493 18.3346 13.3327V3.33268C18.3346 2.41602 17.5846 1.66602 16.668 1.66602ZM16.668 13.3327H6.66797V3.33268H16.668V13.3327ZM10.8346 12.4993H12.5013V9.16602H15.8346V7.49935H12.5013V4.16602H10.8346V7.49935H7.5013V9.16602H10.8346V12.4993Z"
            fill="#A8B1BD"
          />
        </svg>
      )
      break
    case "addRowBelow":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.6654 15.0007H18.332L18.332 3.33398C18.332 2.41732 17.582 1.66732 16.6654 1.66732H4.9987V3.33398L16.6654 3.33398V15.0007ZM3.33203 18.334L13.332 18.334C14.2487 18.334 14.9987 17.584 14.9987 16.6673L14.9987 6.66732C14.9987 5.75065 14.2487 5.00065 13.332 5.00065L3.33203 5.00065C2.41536 5.00065 1.66536 5.75065 1.66536 6.66732V16.6673C1.66536 17.584 2.41536 18.334 3.33203 18.334ZM3.33203 6.66732L13.332 6.66732L13.332 16.6673H3.33203L3.33203 6.66732ZM9.16536 7.50065H7.4987V10.834L4.16536 10.834L4.16536 12.5007L7.4987 12.5007V15.834H9.16536V12.5007H12.4987V10.834H9.16536V7.50065Z"
            fill="#A8B1BD"
          />
        </svg>
      )
      break
    case "import":
      iconElement = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.71875 6.40539L10 3.125L13.2812 6.40539"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 11.8749V3.1272"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
            stroke="#0D99FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
      break
    default:
      iconElement = null
      break
  }

  if (iconElement == null) {
    return null
  }
  return (
    <span
      className={`d-flex align-item-center justify-content-center ${className}`}
      onClick={onClick}
      style={style}
      onKeyPress={() => {}}
    >
      {iconElement}
    </span>
  )
}

SvgIcon.propTypes = {
  name: PropTypes.oneOf(ListIcon).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
}

SvgIcon.defaultProps = {
  className: "",
  onClick: null,
}
